var vehicleTable = [
    [2024, 'Acura', 'Integra', 'Hatchback 4-Door'],
    [2024, 'Acura', 'MDX', 'SUV 4-Door'],
    [2024, 'Acura', 'RDX', 'SUV 4-Door'],
    [2024, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2024, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [2024, 'Alfa Romeo', 'Stelvio', 'Sedan 4-Door'],
    [2024, 'Alfa Romeo', 'Stelvio', 'SUV 4-Door'],
    [2024, 'Alfa Romeo', 'Tonale', 'SUV 4-Door'],
    [2024, 'Aston Martin', 'DB11', 'Convertible 2-Door'],
    [2024, 'Aston Martin', 'DB11', 'Coupe 2-Door'],
    [2024, 'Aston Martin', 'DB12', 'Convertible 2-Door'],
    [2024, 'Aston Martin', 'DB12', 'Coupe 2-Door'],
    [2024, 'Aston Martin', 'DBS', 'Convertible 2-Door'],
    [2024, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2024, 'Aston Martin', 'DBX', 'SUV 4-Door'],
    [2024, 'Aston Martin', 'DBX707', 'SUV 4-Door'],
    [2024, 'Aston Martin', 'Vantage', 'Convertible 2-Door'],
    [2024, 'Aston Martin', 'Vantage', 'Hatchback 2-Door'],
    [2024, 'Audi', 'A3', 'Sedan 4-Door'],
    [2024, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2024, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2024, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2024, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2024, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2024, 'Audi', 'A5 Sportback', 'Hatchback 4-Door'],
    [2024, 'Audi', 'A6 allroad', 'Wagon 4-Door'],
    [2024, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2024, 'Audi', 'A7 Sportback', 'Hatchback 4-Door'],
    [2024, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2024, 'Audi', 'e-tron GT', 'Sedan 4-Door'],
    [2024, 'Audi', 'e-tron Quattro', 'SUV 4-Door'],
    [2024, 'Audi', 'e-tron S', 'SUV 4-Door'],
    [2024, 'Audi', 'e-tron S Sportback', 'SUV 4-Door'],
    [2024, 'Audi', 'e-tron Sportback', 'SUV 4-Door'],
    [2024, 'Audi', 'Q3', 'SUV 4-Door'],
    [2024, 'Audi', 'Q4 e-tron', 'SUV 4-Door'],
    [2024, 'Audi', 'Q4 e-tron Sportback', 'SUV 4-Door'],
    [2024, 'Audi', 'Q5', 'SUV 4-Door'],
    [2024, 'Audi', 'Q5 PHEV', 'SUV 4-Door'],
    [2024, 'Audi', 'Q5 Sportback', 'SUV 4-Door'],
    [2024, 'Audi', 'Q7', 'SUV 4-Door'],
    [2024, 'Audi', 'Q8', 'SUV 4-Door'],
    [2024, 'Audi', 'Q8 e-tron', 'SUV 4-Door'],
    [2024, 'Audi', 'Q8 e-tron Sportback', 'SUV 4-Door'],
    [2024, 'Audi', 'R8', 'Convertible 2-Door'],
    [2024, 'Audi', 'R8', 'Coupe 2-Door'],
    [2024, 'Audi', 'RS e-tron GT', 'Sedan 4-Door'],
    [2024, 'Audi', 'RS Q8', 'SUV 4-Door'],
    [2024, 'Audi', 'RS3', 'Sedan 4-Door'],
    [2024, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2024, 'Audi', 'RS5 Sportback', 'Hatchback 4-Door'],
    [2024, 'Audi', 'RS6 Avant', 'Wagon 4-Door'],
    [2024, 'Audi', 'RS7 Sportback', 'Hatchback 4-Door'],
    [2024, 'Audi', 'S3', 'Sedan 4-Door'],
    [2024, 'Audi', 'S4', 'Sedan 4-Door'],
    [2024, 'Audi', 'S5', 'Convertible 2-Door'],
    [2024, 'Audi', 'S5', 'Coupe 2-Door'],
    [2024, 'Audi', 'S5 Sportback', 'Hatchback 4-Door'],
    [2024, 'Audi', 'S6', 'Sedan 4-Door'],
    [2024, 'Audi', 'S7 Sportback', 'Hatchback 4-Door'],
    [2024, 'Audi', 'S8', 'Sedan 4-Door'],
    [2024, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2024, 'Audi', 'SQ5 Sportback', 'SUV 4-Door'],
    [2024, 'Audi', 'SQ7', 'SUV 4-Door'],
    [2024, 'Audi', 'SQ8', 'SUV 4-Door'],
    [2024, 'Audi', 'SQ8 e-tron', 'SUV 4-Door'],
    [2024, 'Audi', 'SQ8 e-tron Sportback', 'SUV 4-Door'],
    [2024, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2024, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2024, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2024, 'Bentley', 'Bentayga', 'SUV 4-Door'],
    [2024, 'Bentley', 'Bentayga EWB', 'SUV 4-Door'],
    [2024, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2024, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2024, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2024, 'BMW', '228i Gran Coupe', 'Sedan 4-Door'],
    [2024, 'BMW', '228i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2024, 'BMW', '230i', 'Coupe 2-Door'],
    [2024, 'BMW', '230i xDrive', 'Coupe 2-Door'],
    [2024, 'BMW', '330e', 'Sedan 4-Door'],
    [2024, 'BMW', '330e xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', '330i', 'Sedan 4-Door'],
    [2024, 'BMW', '330i xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', '430i', 'Convertible 2-Door'],
    [2024, 'BMW', '430i', 'Coupe 2-Door'],
    [2024, 'BMW', '430i Gran Coupe', 'Hatchback 4-Door'],
    [2024, 'BMW', '430i xDrive', 'Convertible 2-Door'],
    [2024, 'BMW', '430i xDrive', 'Coupe 2-Door'],
    [2024, 'BMW', '430i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2024, 'BMW', '530e', 'Sedan 4-Door'],
    [2024, 'BMW', '530e xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', '530i', 'Sedan 4-Door'],
    [2024, 'BMW', '530i xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', '540i', 'Sedan 4-Door'],
    [2024, 'BMW', '540i xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', '740i', 'Sedan 4-Door'],
    [2024, 'BMW', '750e xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', '760i xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', '840i', 'Convertible 2-Door'],
    [2024, 'BMW', '840i', 'Coupe 2-Door'],
    [2024, 'BMW', '840i Gran Coupe', 'Sedan 4-Door'],
    [2024, 'BMW', '840i xDrive', 'Convertible 2-Door'],
    [2024, 'BMW', '840i xDrive', 'Coupe 2-Door'],
    [2024, 'BMW', '840i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2024, 'BMW', 'Alpina B8 Gran Coupe', 'Sedan 4-Door'],
    [2024, 'BMW', 'Alpina XB7', 'SUV 4-Door'],
    [2024, 'BMW', 'i4', 'Hatchback 4-Door'],
    [2024, 'BMW', 'i7', 'Sedan 4-Door'],
    [2024, 'BMW', 'iX', 'SUV 4-Door'],
    [2024, 'BMW', 'M2', 'Coupe 2-Door'],
    [2024, 'BMW', 'M235i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2024, 'BMW', 'M240i', 'Coupe 2-Door'],
    [2024, 'BMW', 'M240i xDrive', 'Coupe 2-Door'],
    [2024, 'BMW', 'M3', 'Sedan 4-Door'],
    [2024, 'BMW', 'M340i', 'Sedan 4-Door'],
    [2024, 'BMW', 'M340i xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', 'M4', 'Convertible 2-Door'],
    [2024, 'BMW', 'M4', 'Coupe 2-Door'],
    [2024, 'BMW', 'M440i', 'Convertible 2-Door'],
    [2024, 'BMW', 'M440i', 'Coupe 2-Door'],
    [2024, 'BMW', 'M440i Gran Coupe', 'Hatchback 4-Door'],
    [2024, 'BMW', 'M440i xDrive', 'Convertible 2-Door'],
    [2024, 'BMW', 'M440i xDrive', 'Coupe 2-Door'],
    [2024, 'BMW', 'M440i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2024, 'BMW', 'M5', 'Sedan 4-Door'],
    [2024, 'BMW', 'M550i xDrive', 'Sedan 4-Door'],
    [2024, 'BMW', 'M8', 'Convertible 2-Door'],
    [2024, 'BMW', 'M8', 'Coupe 2-Door'],
    [2024, 'BMW', 'M8 Gran Coupe', 'Sedan 4-Door'],
    [2024, 'BMW', 'M850i xDrive', 'Convertible 2-Door'],
    [2024, 'BMW', 'M850i xDrive', 'Coupe 2-Door'],
    [2024, 'BMW', 'M850i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2024, 'BMW', 'X1', 'SUV 4-Door'],
    [2024, 'BMW', 'X2', 'SUV 4-Door'],
    [2024, 'BMW', 'X3', 'SUV 4-Door'],
    [2024, 'BMW', 'X4', 'SUV 4-Door'],
    [2024, 'BMW', 'X5', 'SUV 4-Door'],
    [2024, 'BMW', 'X6', 'SUV 4-Door'],
    [2024, 'BMW', 'X7', 'SUV 4-Door'],
    [2024, 'BMW', 'XM', 'SUV 4-Door'],
    [2024, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2024, 'Bugatti', 'Chiron', 'Coupe 2-Door'],
    [2024, 'Bugatti', 'Mistral', 'Convertible 2-Door'],
    [2024, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2024, 'Buick', 'Encore GX', 'SUV 4-Door'],
    [2024, 'Buick', 'Envision', 'SUV 4-Door'],
    [2024, 'Buick', 'Envista', 'SUV Coupe 4-Door'],
    [2024, 'Cadillac', 'CT4', 'Sedan 4-Door'],
    [2024, 'Cadillac', 'CT5', 'Sedan 4-Door'],
    [2024, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2024, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2024, 'Cadillac', 'LYRIQ', 'SUV 4-Door'],
    [2024, 'Cadillac', 'XT4', 'SUV 4-Door'],
    [2024, 'Cadillac', 'XT5', 'Hearse 4-Door'],
    [2024, 'Cadillac', 'XT5', 'Limousine 4-Door'],
    [2024, 'Cadillac', 'XT5', 'SUV 4-Door'],
    [2024, 'Cadillac', 'XT6', 'SUV 4-Door'],
    [2024, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2024, 'Chevrolet', 'Bolt EUV', 'SUV 4-Door'],
    [2024, 'Chevrolet', 'Bolt EV', 'Hatchback 4-Door'],
    [2024, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2024, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2024, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2024, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2024, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2024, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2024, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2024, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2024, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2024, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2024, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2024, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2024, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2024, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2024, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2024, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2024, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2024, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2024, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2024, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2024, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2024, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2024, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2024, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2024, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2024, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2024, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2024, 'Chevrolet', 'Silverado EV', 'Crew Cab Pickup 4-Door'],
    [2024, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2024, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2024, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2024, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2024, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2024, 'Chrysler', '300', 'Sedan 4-Door'],
    [2024, 'Chrysler', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2024, 'Chrysler', 'Pacifica', 'Mini Passenger Van 4-Door'],
    [2024, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2024, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2024, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2024, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2024, 'Dodge', 'Hornet', 'SUV 4-Door'],
    [2024, 'Ferrari', '296 GTB', 'Coupe 2-Door'],
    [2024, 'Ferrari', '296 GTS', 'Convertible 2-Door'],
    [2024, 'Ferrari', '812 GTS', 'Convertible 2-Door'],
    [2024, 'Ferrari', 'F8 Spider', 'Convertible 2-Door'],
    [2024, 'Ferrari', 'F8 Tributo', 'Coupe 2-Door'],
    [2024, 'Ferrari', 'Portofino M', 'Convertible 2-Door'],
    [2024, 'Ferrari', 'Purosangue', 'SUV 4-Door'],
    [2024, 'Ferrari', 'Roma', 'Convertible 2-Door'],
    [2024, 'Ferrari', 'Roma', 'Coupe 2-Door'],
    [2024, 'Ferrari', 'SF90 Spider', 'Convertible 2-Door'],
    [2024, 'Ferrari', 'SF90 Stradale', 'Coupe 2-Door'],
    [2024, 'Fiat', '500X', 'SUV 4-Door'],
    [2024, 'Fisker', 'Ocean', 'SUV 4-Door'],
    [2024, 'Ford', 'Bronco', 'SUV 2-Door'],
    [2024, 'Ford', 'Bronco', 'SUV 4-Door'],
    [2024, 'Ford', 'Bronco Sport', 'SUV 4-Door'],
    [2024, 'Ford', 'Edge', 'SUV 4-Door'],
    [2024, 'Ford', 'Escape', 'SUV 4-Door'],
    [2024, 'Ford', 'E-Transit', 'Extended Cargo Van 3-Door'],
    [2024, 'Ford', 'E-Transit', 'Standard Cargo Van 3-Door'],
    [2024, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2024, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2024, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2024, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2024, 'Ford', 'F-150 Lightning', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2024, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2024, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2024, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2024, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ford', 'F-450 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2024, 'Ford', 'Maverick', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2024, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2024, 'Ford', 'Mustang Mach-E', 'SUV 4-Door'],
    [2024, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2024, 'Ford', 'Ranger', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2024, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2024, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2024, 'Ford', 'Transit-150', 'Crew Van 3-Door'],
    [2024, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2024, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2024, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2024, 'Ford', 'Transit-250', 'Crew Van 3-Door'],
    [2024, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2024, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2024, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2024, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2024, 'Ford', 'Transit-350', 'Crew Van 3-Door'],
    [2024, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2024, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2024, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2024, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2024, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2024, 'Ford', 'Transit-350', 'Standard Passenger Van 4-Door'],
    [2024, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2024, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2024, 'Ford', 'Transit-350 HD', 'Extended Crew Van 3-Door'],
    [2024, 'Ford', 'Transit-350 HD', 'Extended Crew Van 4-Door'],
    [2024, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2024, 'Ford', 'Transit-350 HD', 'Standard Cargo Van 3-Door'],
    [2024, 'Genesis', 'Electrified G80', 'Sedan 4-Door'],
    [2024, 'Genesis', 'Electrified GV70', 'SUV 4-Door'],
    [2024, 'Genesis', 'G70', 'Sedan 4-Door'],
    [2024, 'Genesis', 'G80', 'Sedan 4-Door'],
    [2024, 'Genesis', 'G90', 'Sedan 4-Door'],
    [2024, 'Genesis', 'GV60', 'SUV 4-Door'],
    [2024, 'Genesis', 'GV70', 'SUV 4-Door'],
    [2024, 'Genesis', 'GV80', 'SUV 4-Door'],
    [2024, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2024, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2024, 'GMC', 'Hummer EV Pickup', 'Crew Cab Pickup 4-Door'],
    [2024, 'GMC', 'Hummer EV SUV', 'SUV 4-Door'],
    [2024, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2024, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2024, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2024, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2024, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2024, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2024, 'GMC', 'Savana 3500', 'Extended Cargo Van 4-Door'],
    [2024, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2024, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2024, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2024, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2024, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2024, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2024, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2024, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2024, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2024, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2024, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2024, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2024, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2024, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2024, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2024, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2024, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2024, 'Honda', 'Civic', 'Hatchback 4-Door'],
    [2024, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2024, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2024, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2024, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2024, 'Honda', 'Passport', 'SUV 4-Door'],
    [2024, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2024, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2024, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2024, 'Hyundai', 'Elantra N', 'Sedan 4-Door'],
    [2024, 'Hyundai', 'Ioniq 5', 'SUV 4-Door'],
    [2024, 'Hyundai', 'Ioniq 6', 'Sedan 4-Door'],
    [2024, 'Hyundai', 'Kona', 'SUV 4-Door'],
    [2024, 'Hyundai', 'Kona Electric', 'SUV 4-Door'],
    [2024, 'Hyundai', 'Kona N', 'SUV 4-Door'],
    [2024, 'Hyundai', 'Nexo', 'SUV 4-Door'],
    [2024, 'Hyundai', 'Palisade', 'SUV 4-Door'],
    [2024, 'Hyundai', 'Santa Cruz', 'Crew Cab Pickup 4-Door'],
    [2024, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2024, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2024, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2024, 'Hyundai', 'Venue', 'SUV 4-Door'],
    [2024, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2024, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2024, 'INFINITI', 'QX55', 'SUV 4-Door'],
    [2024, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2024, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2024, 'Jaguar', 'E-Pace', 'SUV 4-Door'],
    [2024, 'Jaguar', 'F-Pace', 'SUV 4-Door'],
    [2024, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2024, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2024, 'Jaguar', 'I-Pace', 'SUV 4-Door'],
    [2024, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2024, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2024, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2024, 'Jeep', 'Gladiator', 'Crew Cab Pickup 4-Door'],
    [2024, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2024, 'Jeep', 'Grand Cherokee L', 'SUV 4-Door'],
    [2024, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [2024, 'Jeep', 'Grand Wagoneer L', 'SUV 4-Door'],
    [2024, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2024, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [2024, 'Jeep', 'Wagoneer L', 'SUV 4-Door'],
    [2024, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2024, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2024, 'Karma', 'GS-6', 'Sedan 4-Door'],
    [2024, 'Karma', 'GSe-6', 'Sedan 4-Door'],
    [2024, 'Kia', 'Carnival', 'Mini Passenger Van 4-Door'],
    [2024, 'Kia', 'EV6', 'SUV 4-Door'],
    [2024, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2024, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2024, 'Kia', 'K5', 'Sedan 4-Door'],
    [2024, 'Kia', 'Niro', 'SUV 4-Door'],
    [2024, 'Kia', 'Niro EV', 'SUV 4-Door'],
    [2024, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2024, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2024, 'Kia', 'Seltos', 'SUV 4-Door'],
    [2024, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2024, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2024, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2024, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2024, 'Kia', 'Stinger', 'Hatchback 4-Door'],
    [2024, 'Kia', 'Telluride', 'SUV 4-Door'],
    [2024, 'Lamborghini', 'Huracan', 'Convertible 2-Door'],
    [2024, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2024, 'Lamborghini', 'Revuelto', 'Coupe 2-Door'],
    [2024, 'Lamborghini', 'Urus', 'SUV 4-Door'],
    [2024, 'Land Rover', 'Defender 110', 'SUV 4-Door'],
    [2024, 'Land Rover', 'Defender 130', 'SUV 4-Door'],
    [2024, 'Land Rover', 'Defender 90', 'SUV 2-Door'],
    [2024, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2024, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2024, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2024, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2024, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2024, 'Land Rover', 'Range Rover Velar', 'SUV 4-Door'],
    [2024, 'Lexus', 'ES250', 'Sedan 4-Door'],
    [2024, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2024, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2024, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2024, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2024, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2024, 'Lexus', 'IS500', 'Sedan 4-Door'],
    [2024, 'Lexus', 'LC500', 'Convertible 2-Door'],
    [2024, 'Lexus', 'LC500', 'Coupe 2-Door'],
    [2024, 'Lexus', 'LC500h', 'Coupe 2-Door'],
    [2024, 'Lexus', 'LS500', 'Sedan 4-Door'],
    [2024, 'Lexus', 'LS500h', 'Sedan 4-Door'],
    [2024, 'Lexus', 'LX600', 'SUV 4-Door'],
    [2024, 'Lexus', 'NX250', 'SUV 4-Door'],
    [2024, 'Lexus', 'NX350', 'SUV 4-Door'],
    [2024, 'Lexus', 'NX350h', 'SUV 4-Door'],
    [2024, 'Lexus', 'NX450h+', 'SUV 4-Door'],
    [2024, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2024, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2024, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2024, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2024, 'Lexus', 'RX350h', 'SUV 4-Door'],
    [2024, 'Lexus', 'RX450h+', 'SUV 4-Door'],
    [2024, 'Lexus', 'RX500h', 'SUV 4-Door'],
    [2024, 'Lexus', 'RZ450e', 'SUV 4-Door'],
    [2024, 'Lexus', 'UX250h', 'SUV 4-Door'],
    [2024, 'Lincoln', 'Aviator', 'SUV 4-Door'],
    [2024, 'Lincoln', 'Corsair', 'SUV 4-Door'],
    [2024, 'Lincoln', 'Nautilus', 'SUV 4-Door'],
    [2024, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2024, 'Lordstown Motors', 'Endurance', 'Crew Cab Pickup 4-Door'],
    [2024, 'Lotus', 'Emira', 'Coupe 2-Door'],
    [2024, 'Lucid', 'Air', 'Sedan 4-Door'],
    [2024, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2024, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2024, 'Maserati', 'Grecale', 'SUV 4-Door'],
    [2024, 'Maserati', 'Levante', 'SUV 4-Door'],
    [2024, 'Maserati', 'MC20', 'Convertible 2-Door'],
    [2024, 'Maserati', 'MC20', 'Coupe 2-Door'],
    [2024, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2024, 'Mazda', '3', 'Hatchback 4-Door'],
    [2024, 'Mazda', '3', 'Sedan 4-Door'],
    [2024, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2024, 'Mazda', 'CX-30', 'SUV 4-Door'],
    [2024, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2024, 'Mazda', 'CX-50', 'SUV 4-Door'],
    [2024, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2024, 'Mazda', 'CX-90', 'SUV 4-Door'],
    [2024, 'Mazda', 'MX-30 EV', 'SUV 4-Door'],
    [2024, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2024, 'McLaren', '720S', 'Convertible 2-Door'],
    [2024, 'McLaren', '720S', 'Coupe 2-Door'],
    [2024, 'McLaren', '750S', 'Convertible 2-Door'],
    [2024, 'McLaren', '750S', 'Coupe 2-Door'],
    [2024, 'McLaren', '765LT', 'Coupe 2-Door'],
    [2024, 'McLaren', 'Artura', 'Coupe 2-Door'],
    [2024, 'McLaren', 'GT', 'Coupe 2-Door'],
    [2024, 'Mercedes-Benz', 'AMG GT 43', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'AMG GT 53', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'AMG GT 63', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'AMG GT 63 S', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'AMG GT 63 S E Performance', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'C300', 'Convertible 2-Door'],
    [2024, 'Mercedes-Benz', 'C300', 'Coupe 2-Door'],
    [2024, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'C43 AMG', 'Convertible 2-Door'],
    [2024, 'Mercedes-Benz', 'C43 AMG', 'Coupe 2-Door'],
    [2024, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'C63 AMG S', 'Convertible 2-Door'],
    [2024, 'Mercedes-Benz', 'C63 AMG S', 'Coupe 2-Door'],
    [2024, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'CLA35 AMG', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'CLS450', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'CLS53 AMG', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'E450', 'Convertible 2-Door'],
    [2024, 'Mercedes-Benz', 'E450', 'Coupe 2-Door'],
    [2024, 'Mercedes-Benz', 'E450', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'E450', 'Wagon 4-Door'],
    [2024, 'Mercedes-Benz', 'E53 AMG', 'Convertible 2-Door'],
    [2024, 'Mercedes-Benz', 'E53 AMG', 'Coupe 2-Door'],
    [2024, 'Mercedes-Benz', 'E53 AMG', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'EQB 250', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQB 300', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQB 350', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQE 350', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'EQE 350 SUV', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQE 350+', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'EQE 350+ SUV', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQE 500', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'EQE 500 SUV', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQE AMG', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'EQS 450', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'EQS 450 SUV', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQS 450+', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'EQS 450+ SUV', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQS 580', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'EQS 580 SUV', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'EQS AMG', 'Hatchback 4-Door'],
    [2024, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLA35 AMG', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLB250', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLB35 AMG', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2024, 'Mercedes-Benz', 'GLC43 AMG', 'SUV Coupe 4-Door'],
    [2024, 'Mercedes-Benz', 'GLE350', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLE450', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLE53 AMG', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLE53 AMG', 'SUV Coupe 4-Door'],
    [2024, 'Mercedes-Benz', 'GLE580', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV Coupe 4-Door'],
    [2024, 'Mercedes-Benz', 'GLS450', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLS580', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'GLS63 AMG', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'Maybach GLS600', 'SUV 4-Door'],
    [2024, 'Mercedes-Benz', 'Maybach S580', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'Maybach S680', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2024, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2024, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'S580', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'S580e', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'SL43 AMG', 'Sedan 4-Door'],
    [2024, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2024, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Cargo Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Passenger Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 3500XD', 'Crew Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2024, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2024, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2024, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2024, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2024, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2024, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2024, 'Mitsubishi', 'Eclipse Cross', 'SUV 4-Door'],
    [2024, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2024, 'Mitsubishi', 'Mirage G4', 'Sedan 4-Door'],
    [2024, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2024, 'Mitsubishi', 'Outlander PHEV', 'SUV 4-Door'],
    [2024, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2024, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2024, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2024, 'Nissan', 'ARIYA', 'SUV 4-Door'],
    [2024, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2024, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2024, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2024, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2024, 'Nissan', 'Kicks', 'SUV 4-Door'],
    [2024, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2024, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2024, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2024, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2024, 'Nissan', 'Qashqai', 'SUV 4-Door'],
    [2024, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2024, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2024, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2024, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2024, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2024, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2024, 'Nissan', 'Z', 'Coupe 2-Door'],
    [2024, 'Polestar', 'Polestar 2', 'Hatchback 4-Door'],
    [2024, 'Polestar', 'Polestar 3', 'SUV 4-Door'],
    [2024, 'Porsche', '911', 'Convertible 2-Door'],
    [2024, 'Porsche', '911', 'Coupe 2-Door'],
    [2024, 'Porsche', '911', 'Targa 2-Door'],
    [2024, 'Porsche', '718 Boxster', 'Convertible 2-Door'],
    [2024, 'Porsche', '718 Cayman', 'Hatchback 2-Door'],
    [2024, 'Porsche', '718 Spyder', 'Convertible 2-Door'],
    [2024, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2024, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2024, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2024, 'Porsche', 'Panamera', 'Wagon 4-Door'],
    [2024, 'Porsche', 'Taycan', 'Sedan 4-Door'],
    [2024, 'Porsche', 'Taycan', 'Wagon 4-Door'],
    [2024, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2024, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2024, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2024, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2024, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2024, 'Ram', '1500 Classic', 'Crew Cab Pickup 4-Door'],
    [2024, 'Ram', '1500 Classic', 'Extended Cab Pickup 4-Door'],
    [2024, 'Ram', '1500 Classic', 'Standard Cab Pickup 2-Door'],
    [2024, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 3-Door'],
    [2024, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2024, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2024, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 2-Door'],
    [2024, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 3-Door'],
    [2024, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 3-Door'],
    [2024, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2024, 'Rivian', 'R1S', 'SUV 4-Door'],
    [2024, 'Rivian', 'R1T', 'Crew Cab Pickup 4-Door'],
    [2024, 'Rolls-Royce', 'Cullinan', 'SUV 4-Door'],
    [2024, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2024, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2024, 'Subaru', 'Ascent', 'SUV 4-Door'],
    [2024, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2024, 'Subaru', 'Crosstrek', 'Wagon 4-Door'],
    [2024, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2024, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2024, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2024, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2024, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2024, 'Subaru', 'Solterra', 'SUV 4-Door'],
    [2024, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2024, 'Tesla', '3', 'Sedan 4-Door'],
    [2024, 'Tesla', 'S', 'Sedan 4-Door'],
    [2024, 'Tesla', 'X', 'SUV 4-Door'],
    [2024, 'Tesla', 'Y', 'SUV 4-Door'],
    [2024, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2024, 'Toyota', 'bZ4X', 'SUV 4-Door'],
    [2024, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2024, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [2024, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2024, 'Toyota', 'Corolla Cross', 'SUV 4-Door'],
    [2024, 'Toyota', 'Crown', 'Sedan 4-Door'],
    [2024, 'Toyota', 'GR Corolla', 'Hatchback 4-Door'],
    [2024, 'Toyota', 'GR Supra', 'Hatchback 2-Door'],
    [2024, 'Toyota', 'GR86', 'Coupe 2-Door'],
    [2024, 'Toyota', 'Grand Highlander', 'SUV 4-Door'],
    [2024, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2024, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2024, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2024, 'Toyota', 'Prius AWD-e', 'Hatchback 4-Door'],
    [2024, 'Toyota', 'Prius Prime', 'Hatchback 4-Door'],
    [2024, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2024, 'Toyota', 'RAV4 Prime', 'SUV 4-Door'],
    [2024, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2024, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2024, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2024, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2024, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2024, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2024, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2024, 'VinFast', 'VF8', 'SUV 4-Door'],
    [2024, 'VinFast', 'VF9', 'SUV 4-Door'],
    [2024, 'Volkswagen', 'Arteon', 'Hatchback 4-Door'],
    [2024, 'Volkswagen', 'Atlas', 'SUV 4-Door'],
    [2024, 'Volkswagen', 'Atlas Cross Sport', 'SUV 4-Door'],
    [2024, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2024, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2024, 'Volkswagen', 'ID.4', 'SUV 4-Door'],
    [2024, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2024, 'Volkswagen', 'Taos', 'SUV 4-Door'],
    [2024, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2024, 'Volvo', 'C40 Recharge', 'SUV 4-Door'],
    [2024, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2024, 'Volvo', 'S90', 'Sedan 4-Door'],
    [2024, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2024, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2024, 'Volvo', 'V90 Cross Country', 'Wagon 4-Door'],
    [2024, 'Volvo', 'XC40', 'SUV 4-Door'],
    [2024, 'Volvo', 'XC40 Recharge', 'SUV 4-Door'],
    [2024, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2024, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2023, 'Acura', 'Integra', 'Hatchback 4-Door'],
    [2023, 'Acura', 'MDX', 'SUV 4-Door'],
    [2023, 'Acura', 'RDX', 'SUV 4-Door'],
    [2023, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2023, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [2023, 'Alfa Romeo', 'Stelvio', 'SUV 4-Door'],
    [2023, 'Aston Martin', 'DB11', 'Convertible 2-Door'],
    [2023, 'Aston Martin', 'DB11', 'Coupe 2-Door'],
    [2023, 'Aston Martin', 'DBS', 'Convertible 2-Door'],
    [2023, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2023, 'Aston Martin', 'DBX', 'SUV 4-Door'],
    [2023, 'Aston Martin', 'DBX707', 'SUV 4-Door'],
    [2023, 'Aston Martin', 'Vantage', 'Convertible 2-Door'],
    [2023, 'Aston Martin', 'Vantage', 'Hatchback 2-Door'],
    [2023, 'Audi', 'A3', 'Sedan 4-Door'],
    [2023, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2023, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2023, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2023, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2023, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2023, 'Audi', 'A5 Sportback', 'Hatchback 4-Door'],
    [2023, 'Audi', 'A6 allroad', 'Wagon 4-Door'],
    [2023, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2023, 'Audi', 'A7 Sportback', 'Hatchback 4-Door'],
    [2023, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2023, 'Audi', 'e-tron GT', 'Sedan 4-Door'],
    [2023, 'Audi', 'e-tron Quattro', 'SUV 4-Door'],
    [2023, 'Audi', 'e-tron S', 'SUV 4-Door'],
    [2023, 'Audi', 'e-tron S Sportback', 'SUV 4-Door'],
    [2023, 'Audi', 'e-tron Sportback', 'SUV 4-Door'],
    [2023, 'Audi', 'Q3', 'SUV 4-Door'],
    [2023, 'Audi', 'Q4 e-tron', 'SUV 4-Door'],
    [2023, 'Audi', 'Q4 e-tron Sportback', 'SUV 4-Door'],
    [2023, 'Audi', 'Q5', 'SUV 4-Door'],
    [2023, 'Audi', 'Q5 PHEV', 'SUV 4-Door'],
    [2023, 'Audi', 'Q5 Sportback', 'SUV 4-Door'],
    [2023, 'Audi', 'Q7', 'SUV 4-Door'],
    [2023, 'Audi', 'Q8', 'SUV 4-Door'],
    [2023, 'Audi', 'R8', 'Convertible 2-Door'],
    [2023, 'Audi', 'R8', 'Coupe 2-Door'],
    [2023, 'Audi', 'RS e-tron GT', 'Sedan 4-Door'],
    [2023, 'Audi', 'RS Q8', 'SUV 4-Door'],
    [2023, 'Audi', 'RS3', 'Sedan 4-Door'],
    [2023, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2023, 'Audi', 'RS5 Sportback', 'Hatchback 4-Door'],
    [2023, 'Audi', 'RS6 Avant', 'Wagon 4-Door'],
    [2023, 'Audi', 'RS7 Sportback', 'Hatchback 4-Door'],
    [2023, 'Audi', 'S3', 'Sedan 4-Door'],
    [2023, 'Audi', 'S4', 'Sedan 4-Door'],
    [2023, 'Audi', 'S5', 'Convertible 2-Door'],
    [2023, 'Audi', 'S5', 'Coupe 2-Door'],
    [2023, 'Audi', 'S5 Sportback', 'Hatchback 4-Door'],
    [2023, 'Audi', 'S6', 'Sedan 4-Door'],
    [2023, 'Audi', 'S7 Sportback', 'Hatchback 4-Door'],
    [2023, 'Audi', 'S8', 'Sedan 4-Door'],
    [2023, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2023, 'Audi', 'SQ5 Sportback', 'SUV 4-Door'],
    [2023, 'Audi', 'SQ7', 'SUV 4-Door'],
    [2023, 'Audi', 'SQ8', 'SUV 4-Door'],
    [2023, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2023, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2023, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2023, 'Bentley', 'Bentayga', 'SUV 4-Door'],
    [2023, 'Bentley', 'Bentayga EWB', 'SUV 4-Door'],
    [2023, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2023, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2023, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2023, 'BMW', '228i Gran Coupe', 'Sedan 4-Door'],
    [2023, 'BMW', '228i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2023, 'BMW', '230i', 'Coupe 2-Door'],
    [2023, 'BMW', '230i xDrive', 'Coupe 2-Door'],
    [2023, 'BMW', '330e', 'Sedan 4-Door'],
    [2023, 'BMW', '330e xDrive', 'Sedan 4-Door'],
    [2023, 'BMW', '330i', 'Sedan 4-Door'],
    [2023, 'BMW', '330i xDrive', 'Sedan 4-Door'],
    [2023, 'BMW', '430i', 'Convertible 2-Door'],
    [2023, 'BMW', '430i', 'Coupe 2-Door'],
    [2023, 'BMW', '430i Gran Coupe', 'Hatchback 4-Door'],
    [2023, 'BMW', '430i xDrive', 'Convertible 2-Door'],
    [2023, 'BMW', '430i xDrive', 'Coupe 2-Door'],
    [2023, 'BMW', '430i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2023, 'BMW', '530e', 'Sedan 4-Door'],
    [2023, 'BMW', '530e xDrive', 'Sedan 4-Door'],
    [2023, 'BMW', '530i', 'Sedan 4-Door'],
    [2023, 'BMW', '530i xDrive', 'Sedan 4-Door'],
    [2023, 'BMW', '540i', 'Sedan 4-Door'],
    [2023, 'BMW', '540i xDrive', 'Sedan 4-Door'],
    [2023, 'BMW', '740i', 'Sedan 4-Door'],
    [2023, 'BMW', '760i xDrive', 'Sedan 4-Door'],
    [2023, 'BMW', '840i', 'Convertible 2-Door'],
    [2023, 'BMW', '840i', 'Coupe 2-Door'],
    [2023, 'BMW', '840i Gran Coupe', 'Sedan 4-Door'],
    [2023, 'BMW', '840i xDrive', 'Convertible 2-Door'],
    [2023, 'BMW', '840i xDrive', 'Coupe 2-Door'],
    [2023, 'BMW', '840i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2023, 'BMW', 'Alpina B8 Gran Coupe', 'Sedan 4-Door'],
    [2023, 'BMW', 'Alpina XB7', 'SUV 4-Door'],
    [2023, 'BMW', 'i4', 'Hatchback 4-Door'],
    [2023, 'BMW', 'i7', 'Sedan 4-Door'],
    [2023, 'BMW', 'iX', 'SUV 4-Door'],
    [2023, 'BMW', 'M2', 'Coupe 2-Door'],
    [2023, 'BMW', 'M235i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2023, 'BMW', 'M240i', 'Coupe 2-Door'],
    [2023, 'BMW', 'M240i xDrive', 'Coupe 2-Door'],
    [2023, 'BMW', 'M3', 'Sedan 4-Door'],
    [2023, 'BMW', 'M340i', 'Sedan 4-Door'],
    [2023, 'BMW', 'M340i xDrive', 'Sedan 4-Door'],
    [2023, 'BMW', 'M4', 'Convertible 2-Door'],
    [2023, 'BMW', 'M4', 'Coupe 2-Door'],
    [2023, 'BMW', 'M440i', 'Convertible 2-Door'],
    [2023, 'BMW', 'M440i', 'Coupe 2-Door'],
    [2023, 'BMW', 'M440i Gran Coupe', 'Hatchback 4-Door'],
    [2023, 'BMW', 'M440i xDrive', 'Convertible 2-Door'],
    [2023, 'BMW', 'M440i xDrive', 'Coupe 2-Door'],
    [2023, 'BMW', 'M440i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2023, 'BMW', 'M5', 'Sedan 4-Door'],
    [2023, 'BMW', 'M550i xDrive', 'Sedan 4-Door'],
    [2023, 'BMW', 'M8', 'Convertible 2-Door'],
    [2023, 'BMW', 'M8', 'Coupe 2-Door'],
    [2023, 'BMW', 'M8 Gran Coupe', 'Sedan 4-Door'],
    [2023, 'BMW', 'M850i xDrive', 'Convertible 2-Door'],
    [2023, 'BMW', 'M850i xDrive', 'Coupe 2-Door'],
    [2023, 'BMW', 'M850i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2023, 'BMW', 'X1', 'SUV 4-Door'],
    [2023, 'BMW', 'X2', 'SUV 4-Door'],
    [2023, 'BMW', 'X3', 'SUV 4-Door'],
    [2023, 'BMW', 'X4', 'SUV 4-Door'],
    [2023, 'BMW', 'X5', 'SUV 4-Door'],
    [2023, 'BMW', 'X6', 'SUV 4-Door'],
    [2023, 'BMW', 'X7', 'SUV 4-Door'],
    [2023, 'BMW', 'XM', 'SUV 4-Door'],
    [2023, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2023, 'Bugatti', 'Chiron', 'Coupe 2-Door'],
    [2023, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2023, 'Buick', 'Encore GX', 'SUV 4-Door'],
    [2023, 'Buick', 'Envision', 'SUV 4-Door'],
    [2023, 'Cadillac', 'CT4', 'Sedan 4-Door'],
    [2023, 'Cadillac', 'CT5', 'Sedan 4-Door'],
    [2023, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2023, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2023, 'Cadillac', 'LYRIQ', 'SUV 4-Door'],
    [2023, 'Cadillac', 'XT4', 'SUV 4-Door'],
    [2023, 'Cadillac', 'XT5', 'Hearse 4-Door'],
    [2023, 'Cadillac', 'XT5', 'Limousine 4-Door'],
    [2023, 'Cadillac', 'XT5', 'SUV 4-Door'],
    [2023, 'Cadillac', 'XT6', 'SUV 4-Door'],
    [2023, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2023, 'Chevrolet', 'Bolt EUV', 'SUV 4-Door'],
    [2023, 'Chevrolet', 'Bolt EV', 'Hatchback 4-Door'],
    [2023, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2023, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2023, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2023, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2023, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2023, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2023, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2023, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2023, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2023, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2023, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2023, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2023, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2023, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2023, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2023, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2023, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2023, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2023, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2023, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2023, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2023, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2023, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2023, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2023, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2023, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2023, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2023, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2023, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2023, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2023, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2023, 'Chrysler', '300', 'Sedan 4-Door'],
    [2023, 'Chrysler', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2023, 'Chrysler', 'Pacifica', 'Mini Passenger Van 4-Door'],
    [2023, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2023, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2023, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2023, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2023, 'Dodge', 'Hornet', 'SUV 4-Door'],
    [2023, 'Ferrari', '296 GTB', 'Coupe 2-Door'],
    [2023, 'Ferrari', '296 GTS', 'Convertible 2-Door'],
    [2023, 'Ferrari', '812 GTS', 'Convertible 2-Door'],
    [2023, 'Ferrari', 'F8 Spider', 'Convertible 2-Door'],
    [2023, 'Ferrari', 'F8 Tributo', 'Coupe 2-Door'],
    [2023, 'Ferrari', 'Portofino M', 'Convertible 2-Door'],
    [2023, 'Ferrari', 'Roma', 'Coupe 2-Door'],
    [2023, 'Ferrari', 'SF90 Spider', 'Convertible 2-Door'],
    [2023, 'Ferrari', 'SF90 Stradale', 'Coupe 2-Door'],
    [2023, 'Fiat', '500X', 'SUV 4-Door'],
    [2023, 'Fisker', 'Ocean', 'SUV 4-Door'],
    [2023, 'Ford', 'Bronco', 'SUV 2-Door'],
    [2023, 'Ford', 'Bronco', 'SUV 4-Door'],
    [2023, 'Ford', 'Bronco Sport', 'SUV 4-Door'],
    [2023, 'Ford', 'Edge', 'SUV 4-Door'],
    [2023, 'Ford', 'Escape', 'SUV 4-Door'],
    [2023, 'Ford', 'E-Transit', 'Extended Cargo Van 3-Door'],
    [2023, 'Ford', 'E-Transit', 'Standard Cargo Van 3-Door'],
    [2023, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2023, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2023, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2023, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2023, 'Ford', 'F-150 Lightning', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2023, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2023, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2023, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2023, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ford', 'F-450 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2023, 'Ford', 'Maverick', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2023, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2023, 'Ford', 'Mustang Mach-E', 'SUV 4-Door'],
    [2023, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2023, 'Ford', 'Ranger', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2023, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2023, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2023, 'Ford', 'Transit-150', 'Crew Van 3-Door'],
    [2023, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2023, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2023, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2023, 'Ford', 'Transit-250', 'Crew Van 3-Door'],
    [2023, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2023, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2023, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2023, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2023, 'Ford', 'Transit-350', 'Crew Van 3-Door'],
    [2023, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2023, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2023, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2023, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2023, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2023, 'Ford', 'Transit-350', 'Standard Passenger Van 4-Door'],
    [2023, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2023, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2023, 'Ford', 'Transit-350 HD', 'Extended Crew Van 3-Door'],
    [2023, 'Ford', 'Transit-350 HD', 'Extended Crew Van 4-Door'],
    [2023, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2023, 'Ford', 'Transit-350 HD', 'Standard Cargo Van 3-Door'],
    [2023, 'Genesis', 'Electrified G80', 'Sedan 4-Door'],
    [2023, 'Genesis', 'Electrified GV70', 'SUV 4-Door'],
    [2023, 'Genesis', 'G70', 'Sedan 4-Door'],
    [2023, 'Genesis', 'G80', 'Sedan 4-Door'],
    [2023, 'Genesis', 'G90', 'Sedan 4-Door'],
    [2023, 'Genesis', 'GV60', 'SUV 4-Door'],
    [2023, 'Genesis', 'GV70', 'SUV 4-Door'],
    [2023, 'Genesis', 'GV80', 'SUV 4-Door'],
    [2023, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2023, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2023, 'GMC', 'Hummer EV Pickup', 'Crew Cab Pickup 4-Door'],
    [2023, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2023, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2023, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2023, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2023, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2023, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2023, 'GMC', 'Savana 3500', 'Extended Cargo Van 4-Door'],
    [2023, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2023, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2023, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2023, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2023, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2023, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2023, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2023, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2023, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2023, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2023, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2023, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2023, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2023, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2023, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2023, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2023, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2023, 'Honda', 'Civic', 'Hatchback 4-Door'],
    [2023, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2023, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2023, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2023, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2023, 'Honda', 'Passport', 'SUV 4-Door'],
    [2023, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2023, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2023, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2023, 'Hyundai', 'Elantra N', 'Sedan 4-Door'],
    [2023, 'Hyundai', 'Ioniq 5', 'SUV 4-Door'],
    [2023, 'Hyundai', 'Ioniq 6', 'Sedan 4-Door'],
    [2023, 'Hyundai', 'Kona', 'SUV 4-Door'],
    [2023, 'Hyundai', 'Kona Electric', 'SUV 4-Door'],
    [2023, 'Hyundai', 'Kona N', 'SUV 4-Door'],
    [2023, 'Hyundai', 'Nexo', 'SUV 4-Door'],
    [2023, 'Hyundai', 'Palisade', 'SUV 4-Door'],
    [2023, 'Hyundai', 'Santa Cruz', 'Crew Cab Pickup 4-Door'],
    [2023, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2023, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2023, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2023, 'Hyundai', 'Venue', 'SUV 4-Door'],
    [2023, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2023, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2023, 'INFINITI', 'QX55', 'SUV 4-Door'],
    [2023, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2023, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2023, 'Jaguar', 'E-Pace', 'SUV 4-Door'],
    [2023, 'Jaguar', 'F-Pace', 'SUV 4-Door'],
    [2023, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2023, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2023, 'Jaguar', 'I-Pace', 'SUV 4-Door'],
    [2023, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2023, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2023, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2023, 'Jeep', 'Gladiator', 'Crew Cab Pickup 4-Door'],
    [2023, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2023, 'Jeep', 'Grand Cherokee L', 'SUV 4-Door'],
    [2023, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [2023, 'Jeep', 'Grand Wagoneer L', 'SUV 4-Door'],
    [2023, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2023, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [2023, 'Jeep', 'Wagoneer L', 'SUV 4-Door'],
    [2023, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2023, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2023, 'Karma', 'GS-6', 'Sedan 4-Door'],
    [2023, 'Karma', 'GSe-6', 'Sedan 4-Door'],
    [2023, 'Kia', 'Carnival', 'Mini Passenger Van 4-Door'],
    [2023, 'Kia', 'EV6', 'SUV 4-Door'],
    [2023, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2023, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2023, 'Kia', 'K5', 'Sedan 4-Door'],
    [2023, 'Kia', 'Niro', 'SUV 4-Door'],
    [2023, 'Kia', 'Niro EV', 'SUV 4-Door'],
    [2023, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2023, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2023, 'Kia', 'Seltos', 'SUV 4-Door'],
    [2023, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2023, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2023, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2023, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2023, 'Kia', 'Stinger', 'Hatchback 4-Door'],
    [2023, 'Kia', 'Telluride', 'SUV 4-Door'],
    [2023, 'Lamborghini', 'Huracan', 'Convertible 2-Door'],
    [2023, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2023, 'Lamborghini', 'Urus', 'SUV 4-Door'],
    [2023, 'Land Rover', 'Defender 110', 'SUV 4-Door'],
    [2023, 'Land Rover', 'Defender 130', 'SUV 4-Door'],
    [2023, 'Land Rover', 'Defender 90', 'SUV 2-Door'],
    [2023, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2023, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2023, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2023, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2023, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2023, 'Land Rover', 'Range Rover Velar', 'SUV 4-Door'],
    [2023, 'Lexus', 'ES250', 'Sedan 4-Door'],
    [2023, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2023, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2023, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2023, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2023, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2023, 'Lexus', 'IS500', 'Sedan 4-Door'],
    [2023, 'Lexus', 'LC500', 'Convertible 2-Door'],
    [2023, 'Lexus', 'LC500', 'Coupe 2-Door'],
    [2023, 'Lexus', 'LC500h', 'Coupe 2-Door'],
    [2023, 'Lexus', 'LS500', 'Sedan 4-Door'],
    [2023, 'Lexus', 'LS500h', 'Sedan 4-Door'],
    [2023, 'Lexus', 'LX600', 'SUV 4-Door'],
    [2023, 'Lexus', 'NX250', 'SUV 4-Door'],
    [2023, 'Lexus', 'NX350', 'SUV 4-Door'],
    [2023, 'Lexus', 'NX350h', 'SUV 4-Door'],
    [2023, 'Lexus', 'NX450h+', 'SUV 4-Door'],
    [2023, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2023, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2023, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2023, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2023, 'Lexus', 'RX350h', 'SUV 4-Door'],
    [2023, 'Lexus', 'RX500h', 'SUV 4-Door'],
    [2023, 'Lexus', 'RZ450e', 'SUV 4-Door'],
    [2023, 'Lexus', 'UX250h', 'SUV 4-Door'],
    [2023, 'Lincoln', 'Aviator', 'SUV 4-Door'],
    [2023, 'Lincoln', 'Corsair', 'SUV 4-Door'],
    [2023, 'Lincoln', 'Nautilus', 'SUV 4-Door'],
    [2023, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2023, 'Lordstown Motors', 'Endurance', 'Crew Cab Pickup 4-Door'],
    [2023, 'Lotus', 'Emira', 'Coupe 2-Door'],
    [2023, 'Lucid', 'Air', 'Sedan 4-Door'],
    [2023, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2023, 'Maserati', 'Grecale', 'SUV 4-Door'],
    [2023, 'Maserati', 'Levante', 'SUV 4-Door'],
    [2023, 'Maserati', 'MC20', 'Convertible 2-Door'],
    [2023, 'Maserati', 'MC20', 'Coupe 2-Door'],
    [2023, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2023, 'Mazda', '3', 'Hatchback 4-Door'],
    [2023, 'Mazda', '3', 'Sedan 4-Door'],
    [2023, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2023, 'Mazda', 'CX-30', 'SUV 4-Door'],
    [2023, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2023, 'Mazda', 'CX-50', 'SUV 4-Door'],
    [2023, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2023, 'Mazda', 'MX-30 EV', 'SUV 4-Door'],
    [2023, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2023, 'McLaren', '720S', 'Convertible 2-Door'],
    [2023, 'McLaren', '720S', 'Coupe 2-Door'],
    [2023, 'McLaren', '765LT', 'Coupe 2-Door'],
    [2023, 'McLaren', 'Artura', 'Coupe 2-Door'],
    [2023, 'McLaren', 'GT', 'Coupe 2-Door'],
    [2023, 'Mercedes-Benz', 'AMG GT 43', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'AMG GT 53', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'AMG GT 63', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'AMG GT 63 S', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'AMG GT 63 S E Performance', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'C300', 'Convertible 2-Door'],
    [2023, 'Mercedes-Benz', 'C300', 'Coupe 2-Door'],
    [2023, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'C43 AMG', 'Convertible 2-Door'],
    [2023, 'Mercedes-Benz', 'C43 AMG', 'Coupe 2-Door'],
    [2023, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'C63 AMG S', 'Convertible 2-Door'],
    [2023, 'Mercedes-Benz', 'C63 AMG S', 'Coupe 2-Door'],
    [2023, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'CLA35 AMG', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'CLS450', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'CLS53 AMG', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'E450', 'Convertible 2-Door'],
    [2023, 'Mercedes-Benz', 'E450', 'Coupe 2-Door'],
    [2023, 'Mercedes-Benz', 'E450', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'E450', 'Wagon 4-Door'],
    [2023, 'Mercedes-Benz', 'E53 AMG', 'Convertible 2-Door'],
    [2023, 'Mercedes-Benz', 'E53 AMG', 'Coupe 2-Door'],
    [2023, 'Mercedes-Benz', 'E53 AMG', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'EQB 250', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQB 300', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQB 350', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQE 350', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'EQE 350 SUV', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQE 350+', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'EQE 350+ SUV', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQE 500', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'EQE 500 SUV', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQE AMG', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'EQS 450', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'EQS 450 SUV', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQS 450+', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'EQS 450+ SUV', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQS 580', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'EQS 580 SUV', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'EQS AMG', 'Hatchback 4-Door'],
    [2023, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLA35 AMG', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLB250', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLB35 AMG', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2023, 'Mercedes-Benz', 'GLC43 AMG', 'SUV Coupe 4-Door'],
    [2023, 'Mercedes-Benz', 'GLE350', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLE450', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLE53 AMG', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLE53 AMG', 'SUV Coupe 4-Door'],
    [2023, 'Mercedes-Benz', 'GLE580', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV Coupe 4-Door'],
    [2023, 'Mercedes-Benz', 'GLS450', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLS580', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'GLS63 AMG', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'Maybach GLS600', 'SUV 4-Door'],
    [2023, 'Mercedes-Benz', 'Maybach S580', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'Maybach S680', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2023, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2023, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'S580', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'S580e', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'SL43 AMG', 'Sedan 4-Door'],
    [2023, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2023, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Cargo Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Passenger Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 3500XD', 'Crew Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2023, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2023, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2023, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2023, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2023, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2023, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2023, 'Mitsubishi', 'Eclipse Cross', 'SUV 4-Door'],
    [2023, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2023, 'Mitsubishi', 'Mirage G4', 'Sedan 4-Door'],
    [2023, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2023, 'Mitsubishi', 'Outlander PHEV', 'SUV 4-Door'],
    [2023, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2023, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2023, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2023, 'Nissan', 'ARIYA', 'SUV 4-Door'],
    [2023, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2023, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2023, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2023, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2023, 'Nissan', 'Kicks', 'SUV 4-Door'],
    [2023, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2023, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2023, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2023, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2023, 'Nissan', 'Qashqai', 'SUV 4-Door'],
    [2023, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2023, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2023, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2023, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2023, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2023, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2023, 'Nissan', 'Z', 'Coupe 2-Door'],
    [2023, 'Polestar', 'Polestar 2', 'Hatchback 4-Door'],
    [2023, 'Porsche', '911', 'Convertible 2-Door'],
    [2023, 'Porsche', '911', 'Coupe 2-Door'],
    [2023, 'Porsche', '911', 'Targa 2-Door'],
    [2023, 'Porsche', '718 Boxster', 'Convertible 2-Door'],
    [2023, 'Porsche', '718 Cayman', 'Hatchback 2-Door'],
    [2023, 'Porsche', '718 Spyder', 'Convertible 2-Door'],
    [2023, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2023, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2023, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2023, 'Porsche', 'Panamera', 'Wagon 4-Door'],
    [2023, 'Porsche', 'Taycan', 'Sedan 4-Door'],
    [2023, 'Porsche', 'Taycan', 'Wagon 4-Door'],
    [2023, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2023, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2023, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2023, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2023, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2023, 'Ram', '1500 Classic', 'Crew Cab Pickup 4-Door'],
    [2023, 'Ram', '1500 Classic', 'Extended Cab Pickup 4-Door'],
    [2023, 'Ram', '1500 Classic', 'Standard Cab Pickup 2-Door'],
    [2023, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 3-Door'],
    [2023, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2023, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2023, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 2-Door'],
    [2023, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 3-Door'],
    [2023, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 3-Door'],
    [2023, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2023, 'Rivian', 'R1S', 'SUV 4-Door'],
    [2023, 'Rivian', 'R1T', 'Crew Cab Pickup 4-Door'],
    [2023, 'Rolls-Royce', 'Cullinan', 'SUV 4-Door'],
    [2023, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2023, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2023, 'Subaru', 'Ascent', 'SUV 4-Door'],
    [2023, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2023, 'Subaru', 'Crosstrek', 'Wagon 4-Door'],
    [2023, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2023, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2023, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2023, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2023, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2023, 'Subaru', 'Solterra', 'SUV 4-Door'],
    [2023, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2023, 'Tesla', '3', 'Sedan 4-Door'],
    [2023, 'Tesla', 'S', 'Sedan 4-Door'],
    [2023, 'Tesla', 'X', 'SUV 4-Door'],
    [2023, 'Tesla', 'Y', 'SUV 4-Door'],
    [2023, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2023, 'Toyota', 'bZ4X', 'SUV 4-Door'],
    [2023, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2023, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [2023, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2023, 'Toyota', 'Corolla Cross', 'SUV 4-Door'],
    [2023, 'Toyota', 'Crown', 'Sedan 4-Door'],
    [2023, 'Toyota', 'GR Corolla', 'Hatchback 4-Door'],
    [2023, 'Toyota', 'GR Supra', 'Hatchback 2-Door'],
    [2023, 'Toyota', 'GR86', 'Coupe 2-Door'],
    [2023, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2023, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2023, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2023, 'Toyota', 'Prius AWD-e', 'Hatchback 4-Door'],
    [2023, 'Toyota', 'Prius Prime', 'Hatchback 4-Door'],
    [2023, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2023, 'Toyota', 'RAV4 Prime', 'SUV 4-Door'],
    [2023, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2023, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2023, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2023, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2023, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2023, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2023, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2023, 'VinFast', 'VF8', 'SUV 4-Door'],
    [2023, 'VinFast', 'VF9', 'SUV 4-Door'],
    [2023, 'Volkswagen', 'Arteon', 'Hatchback 4-Door'],
    [2023, 'Volkswagen', 'Atlas', 'SUV 4-Door'],
    [2023, 'Volkswagen', 'Atlas Cross Sport', 'SUV 4-Door'],
    [2023, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2023, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2023, 'Volkswagen', 'ID.4', 'SUV 4-Door'],
    [2023, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2023, 'Volkswagen', 'Taos', 'SUV 4-Door'],
    [2023, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2023, 'Volvo', 'C40 Recharge', 'SUV 4-Door'],
    [2023, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2023, 'Volvo', 'S90', 'Sedan 4-Door'],
    [2023, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2023, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2023, 'Volvo', 'V90 Cross Country', 'Wagon 4-Door'],
    [2023, 'Volvo', 'XC40', 'SUV 4-Door'],
    [2023, 'Volvo', 'XC40 Recharge', 'SUV 4-Door'],
    [2023, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2023, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2022, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2022, 'Acura', 'MDX', 'SUV 4-Door'],
    [2022, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2022, 'Acura', 'RDX', 'SUV 4-Door'],
    [2022, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2022, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [2022, 'Alfa Romeo', 'Stelvio', 'SUV 4-Door'],
    [2022, 'Aston Martin', 'DB11', 'Convertible 2-Door'],
    [2022, 'Aston Martin', 'DB11', 'Coupe 2-Door'],
    [2022, 'Aston Martin', 'DBS', 'Convertible 2-Door'],
    [2022, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2022, 'Aston Martin', 'DBX', 'SUV 4-Door'],
    [2022, 'Aston Martin', 'Vantage', 'Convertible 2-Door'],
    [2022, 'Aston Martin', 'Vantage', 'Hatchback 2-Door'],
    [2022, 'Audi', 'A3', 'Sedan 4-Door'],
    [2022, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2022, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2022, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2022, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2022, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2022, 'Audi', 'A5 Sportback', 'Hatchback 4-Door'],
    [2022, 'Audi', 'A6 allroad', 'Wagon 4-Door'],
    [2022, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2022, 'Audi', 'A7 Sportback', 'Hatchback 4-Door'],
    [2022, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2022, 'Audi', 'e-tron GT', 'Sedan 4-Door'],
    [2022, 'Audi', 'e-tron Quattro', 'SUV 4-Door'],
    [2022, 'Audi', 'e-tron S', 'SUV 4-Door'],
    [2022, 'Audi', 'e-tron S Sportback', 'SUV 4-Door'],
    [2022, 'Audi', 'e-tron Sportback', 'SUV 4-Door'],
    [2022, 'Audi', 'Q3', 'SUV 4-Door'],
    [2022, 'Audi', 'Q4 e-tron', 'SUV 4-Door'],
    [2022, 'Audi', 'Q4 e-tron Sportback', 'SUV 4-Door'],
    [2022, 'Audi', 'Q5', 'SUV 4-Door'],
    [2022, 'Audi', 'Q5 PHEV', 'SUV 4-Door'],
    [2022, 'Audi', 'Q5 Sportback', 'SUV 4-Door'],
    [2022, 'Audi', 'Q7', 'SUV 4-Door'],
    [2022, 'Audi', 'Q8', 'SUV 4-Door'],
    [2022, 'Audi', 'R8', 'Convertible 2-Door'],
    [2022, 'Audi', 'R8', 'Coupe 2-Door'],
    [2022, 'Audi', 'RS e-tron GT', 'Sedan 4-Door'],
    [2022, 'Audi', 'RS Q8', 'SUV 4-Door'],
    [2022, 'Audi', 'RS3', 'Sedan 4-Door'],
    [2022, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2022, 'Audi', 'RS5 Sportback', 'Hatchback 4-Door'],
    [2022, 'Audi', 'RS6 Avant', 'Wagon 4-Door'],
    [2022, 'Audi', 'RS7 Sportback', 'Hatchback 4-Door'],
    [2022, 'Audi', 'S3', 'Sedan 4-Door'],
    [2022, 'Audi', 'S4', 'Sedan 4-Door'],
    [2022, 'Audi', 'S5', 'Convertible 2-Door'],
    [2022, 'Audi', 'S5', 'Coupe 2-Door'],
    [2022, 'Audi', 'S5 Sportback', 'Hatchback 4-Door'],
    [2022, 'Audi', 'S6', 'Sedan 4-Door'],
    [2022, 'Audi', 'S7 Sportback', 'Hatchback 4-Door'],
    [2022, 'Audi', 'S8', 'Sedan 4-Door'],
    [2022, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2022, 'Audi', 'SQ5 Sportback', 'SUV 4-Door'],
    [2022, 'Audi', 'SQ7', 'SUV 4-Door'],
    [2022, 'Audi', 'SQ8', 'SUV 4-Door'],
    [2022, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2022, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2022, 'Audi', 'TT RS Quattro', 'Coupe 2-Door'],
    [2022, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2022, 'Bentley', 'Bentayga', 'SUV 4-Door'],
    [2022, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2022, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2022, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2022, 'BMW', '228i Gran Coupe', 'Sedan 4-Door'],
    [2022, 'BMW', '228i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2022, 'BMW', '230i', 'Coupe 2-Door'],
    [2022, 'BMW', '330e', 'Sedan 4-Door'],
    [2022, 'BMW', '330e xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '330i', 'Sedan 4-Door'],
    [2022, 'BMW', '330i xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '430i', 'Convertible 2-Door'],
    [2022, 'BMW', '430i', 'Coupe 2-Door'],
    [2022, 'BMW', '430i Gran Coupe', 'Hatchback 4-Door'],
    [2022, 'BMW', '430i xDrive', 'Convertible 2-Door'],
    [2022, 'BMW', '430i xDrive', 'Coupe 2-Door'],
    [2022, 'BMW', '530e', 'Sedan 4-Door'],
    [2022, 'BMW', '530e xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '530i', 'Sedan 4-Door'],
    [2022, 'BMW', '530i xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '540i', 'Sedan 4-Door'],
    [2022, 'BMW', '540i xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '740i', 'Sedan 4-Door'],
    [2022, 'BMW', '740i xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '745e xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '745Le xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', '840i', 'Convertible 2-Door'],
    [2022, 'BMW', '840i', 'Coupe 2-Door'],
    [2022, 'BMW', '840i Gran Coupe', 'Sedan 4-Door'],
    [2022, 'BMW', '840i xDrive', 'Convertible 2-Door'],
    [2022, 'BMW', '840i xDrive', 'Coupe 2-Door'],
    [2022, 'BMW', '840i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2022, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2022, 'BMW', 'Alpina B8 Gran Coupe', 'Sedan 4-Door'],
    [2022, 'BMW', 'Alpina XB7', 'SUV 4-Door'],
    [2022, 'BMW', 'i4', 'Hatchback 4-Door'],
    [2022, 'BMW', 'iX', 'SUV 4-Door'],
    [2022, 'BMW', 'M235i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2022, 'BMW', 'M240i xDrive', 'Coupe 2-Door'],
    [2022, 'BMW', 'M3', 'Sedan 4-Door'],
    [2022, 'BMW', 'M340i', 'Sedan 4-Door'],
    [2022, 'BMW', 'M340i xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', 'M4', 'Convertible 2-Door'],
    [2022, 'BMW', 'M4', 'Coupe 2-Door'],
    [2022, 'BMW', 'M440i', 'Convertible 2-Door'],
    [2022, 'BMW', 'M440i', 'Coupe 2-Door'],
    [2022, 'BMW', 'M440i Gran Coupe', 'Hatchback 4-Door'],
    [2022, 'BMW', 'M440i xDrive', 'Convertible 2-Door'],
    [2022, 'BMW', 'M440i xDrive', 'Coupe 2-Door'],
    [2022, 'BMW', 'M440i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2022, 'BMW', 'M5', 'Sedan 4-Door'],
    [2022, 'BMW', 'M550i xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', 'M760i xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', 'M760Li xDrive', 'Sedan 4-Door'],
    [2022, 'BMW', 'M8', 'Convertible 2-Door'],
    [2022, 'BMW', 'M8', 'Coupe 2-Door'],
    [2022, 'BMW', 'M8 Gran Coupe', 'Sedan 4-Door'],
    [2022, 'BMW', 'M850i xDrive', 'Convertible 2-Door'],
    [2022, 'BMW', 'M850i xDrive', 'Coupe 2-Door'],
    [2022, 'BMW', 'M850i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2022, 'BMW', 'X1', 'SUV 4-Door'],
    [2022, 'BMW', 'X2', 'SUV 4-Door'],
    [2022, 'BMW', 'X3', 'SUV 4-Door'],
    [2022, 'BMW', 'X4', 'SUV 4-Door'],
    [2022, 'BMW', 'X5', 'SUV 4-Door'],
    [2022, 'BMW', 'X6', 'SUV 4-Door'],
    [2022, 'BMW', 'X7', 'SUV 4-Door'],
    [2022, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2022, 'Bugatti', 'Chiron', 'Coupe 2-Door'],
    [2022, 'Bugatti', 'Divo', 'Coupe 2-Door'],
    [2022, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2022, 'Buick', 'Encore', 'SUV 4-Door'],
    [2022, 'Buick', 'Encore GX', 'SUV 4-Door'],
    [2022, 'Buick', 'Envision', 'SUV 4-Door'],
    [2022, 'Cadillac', 'CT4', 'Sedan 4-Door'],
    [2022, 'Cadillac', 'CT5', 'Sedan 4-Door'],
    [2022, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2022, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2022, 'Cadillac', 'XT4', 'SUV 4-Door'],
    [2022, 'Cadillac', 'XT5', 'Hearse 4-Door'],
    [2022, 'Cadillac', 'XT5', 'Limousine 4-Door'],
    [2022, 'Cadillac', 'XT5', 'SUV 4-Door'],
    [2022, 'Cadillac', 'XT6', 'SUV 4-Door'],
    [2022, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2022, 'Chevrolet', 'Bolt EUV', 'SUV 4-Door'],
    [2022, 'Chevrolet', 'Bolt EV', 'Hatchback 4-Door'],
    [2022, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2022, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2022, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2022, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2022, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2022, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2022, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2022, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2022, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2022, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2022, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2022, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2022, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2022, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2022, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2022, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2022, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2022, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2022, 'Chevrolet', 'Silverado 1500 LTD', 'Crew Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Silverado 1500 LTD', 'Extended Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Silverado 1500 LTD', 'Standard Cab Pickup 2-Door'],
    [2022, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2022, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2022, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2022, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2022, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2022, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2022, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2022, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2022, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2022, 'Chrysler', '300', 'Sedan 4-Door'],
    [2022, 'Chrysler', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2022, 'Chrysler', 'Pacifica', 'Mini Passenger Van 4-Door'],
    [2022, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2022, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2022, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2022, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2022, 'Ferrari', '296 GTB', 'Coupe 2-Door'],
    [2022, 'Ferrari', '812 GTS', 'Convertible 2-Door'],
    [2022, 'Ferrari', '812 Superfast', 'Coupe 2-Door'],
    [2022, 'Ferrari', 'F8 Spider', 'Convertible 2-Door'],
    [2022, 'Ferrari', 'F8 Tributo', 'Coupe 2-Door'],
    [2022, 'Ferrari', 'Portofino M', 'Convertible 2-Door'],
    [2022, 'Ferrari', 'Roma', 'Coupe 2-Door'],
    [2022, 'Ferrari', 'SF90 Spider', 'Convertible 2-Door'],
    [2022, 'Ferrari', 'SF90 Stradale', 'Coupe 2-Door'],
    [2022, 'Fiat', '500X', 'SUV 4-Door'],
    [2022, 'Ford', 'Bronco', 'SUV 2-Door'],
    [2022, 'Ford', 'Bronco', 'SUV 4-Door'],
    [2022, 'Ford', 'Bronco Sport', 'SUV 4-Door'],
    [2022, 'Ford', 'EcoSport', 'SUV 4-Door'],
    [2022, 'Ford', 'Edge', 'SUV 4-Door'],
    [2022, 'Ford', 'Escape', 'SUV 4-Door'],
    [2022, 'Ford', 'E-Transit', 'Extended Cargo Van 3-Door'],
    [2022, 'Ford', 'E-Transit', 'Standard Cargo Van 3-Door'],
    [2022, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2022, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2022, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2022, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2022, 'Ford', 'F-150 Lightning', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2022, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2022, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2022, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2022, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ford', 'F-450 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2022, 'Ford', 'GT', 'Coupe 2-Door'],
    [2022, 'Ford', 'Maverick', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2022, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2022, 'Ford', 'Mustang Mach-E', 'SUV 4-Door'],
    [2022, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2022, 'Ford', 'Ranger', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2022, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2022, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2022, 'Ford', 'Transit-150', 'Crew Van 3-Door'],
    [2022, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2022, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2022, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2022, 'Ford', 'Transit-250', 'Crew Van 3-Door'],
    [2022, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2022, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2022, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2022, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2022, 'Ford', 'Transit-350', 'Crew Van 3-Door'],
    [2022, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2022, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2022, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2022, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2022, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2022, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2022, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2022, 'Ford', 'Transit-350 HD', 'Extended Crew Van 3-Door'],
    [2022, 'Ford', 'Transit-350 HD', 'Extended Crew Van 4-Door'],
    [2022, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2022, 'Ford', 'Transit-350 HD', 'Standard Cargo Van 3-Door'],
    [2022, 'Genesis', 'G70', 'Sedan 4-Door'],
    [2022, 'Genesis', 'G80', 'Sedan 4-Door'],
    [2022, 'Genesis', 'G90', 'Sedan 4-Door'],
    [2022, 'Genesis', 'GV70', 'SUV 4-Door'],
    [2022, 'Genesis', 'GV80', 'SUV 4-Door'],
    [2022, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2022, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2022, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2022, 'GMC', 'Hummer EV Pickup', 'Crew Cab Pickup 4-Door'],
    [2022, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2022, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2022, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2022, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2022, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2022, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2022, 'GMC', 'Savana 3500', 'Extended Cargo Van 4-Door'],
    [2022, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2022, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2022, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2022, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2022, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2022, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2022, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2022, 'GMC', 'Sierra 1500 Limited', 'Crew Cab Pickup 4-Door'],
    [2022, 'GMC', 'Sierra 1500 Limited', 'Extended Cab Pickup 4-Door'],
    [2022, 'GMC', 'Sierra 1500 Limited', 'Standard Cab Pickup 2-Door'],
    [2022, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2022, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2022, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2022, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2022, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2022, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2022, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2022, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2022, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2022, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2022, 'Honda', 'Civic', 'Hatchback 4-Door'],
    [2022, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2022, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2022, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2022, 'Honda', 'Insight', 'Sedan 4-Door'],
    [2022, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2022, 'Honda', 'Passport', 'SUV 4-Door'],
    [2022, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2022, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2022, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2022, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2022, 'Hyundai', 'Elantra N', 'Sedan 4-Door'],
    [2022, 'Hyundai', 'Ioniq', 'Hatchback 4-Door'],
    [2022, 'Hyundai', 'Ioniq 5', 'SUV 4-Door'],
    [2022, 'Hyundai', 'Kona', 'SUV 4-Door'],
    [2022, 'Hyundai', 'Kona Electric', 'SUV 4-Door'],
    [2022, 'Hyundai', 'Kona N', 'SUV 4-Door'],
    [2022, 'Hyundai', 'Nexo', 'SUV 4-Door'],
    [2022, 'Hyundai', 'Palisade', 'SUV 4-Door'],
    [2022, 'Hyundai', 'Santa Cruz', 'Crew Cab Pickup 4-Door'],
    [2022, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2022, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2022, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2022, 'Hyundai', 'Veloster N', 'Hatchback 3-Door'],
    [2022, 'Hyundai', 'Venue', 'SUV 4-Door'],
    [2022, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2022, 'INFINITI', 'Q60', 'Coupe 2-Door'],
    [2022, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2022, 'INFINITI', 'QX55', 'SUV 4-Door'],
    [2022, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2022, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2022, 'Jaguar', 'E-Pace', 'SUV 4-Door'],
    [2022, 'Jaguar', 'F-Pace', 'SUV 4-Door'],
    [2022, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2022, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2022, 'Jaguar', 'I-Pace', 'SUV 4-Door'],
    [2022, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2022, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2022, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2022, 'Jeep', 'Gladiator', 'Crew Cab Pickup 4-Door'],
    [2022, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2022, 'Jeep', 'Grand Cherokee L', 'SUV 4-Door'],
    [2022, 'Jeep', 'Grand Cherokee WK', 'SUV 4-Door'],
    [2022, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [2022, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2022, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [2022, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2022, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2022, 'Karma', 'GS-6', 'Sedan 4-Door'],
    [2022, 'Karma', 'GSe-6', 'Sedan 4-Door'],
    [2022, 'Karma', 'Revero', 'Sedan 4-Door'],
    [2022, 'Kia', 'Carnival', 'Mini Passenger Van 4-Door'],
    [2022, 'Kia', 'EV6', 'SUV 4-Door'],
    [2022, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2022, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2022, 'Kia', 'K5', 'Sedan 4-Door'],
    [2022, 'Kia', 'Niro', 'SUV 4-Door'],
    [2022, 'Kia', 'Niro EV', 'SUV 4-Door'],
    [2022, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2022, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2022, 'Kia', 'Seltos', 'SUV 4-Door'],
    [2022, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2022, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2022, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2022, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2022, 'Kia', 'Stinger', 'Hatchback 4-Door'],
    [2022, 'Kia', 'Telluride', 'SUV 4-Door'],
    [2022, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2022, 'Lamborghini', 'Huracan', 'Convertible 2-Door'],
    [2022, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2022, 'Lamborghini', 'Urus', 'SUV 4-Door'],
    [2022, 'Land Rover', 'Defender 110', 'SUV 4-Door'],
    [2022, 'Land Rover', 'Defender 90', 'SUV 2-Door'],
    [2022, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2022, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2022, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2022, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2022, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2022, 'Land Rover', 'Range Rover Velar', 'SUV 4-Door'],
    [2022, 'Lexus', 'ES250', 'Sedan 4-Door'],
    [2022, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2022, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2022, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2022, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2022, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2022, 'Lexus', 'IS500', 'Sedan 4-Door'],
    [2022, 'Lexus', 'LC500', 'Convertible 2-Door'],
    [2022, 'Lexus', 'LC500', 'Coupe 2-Door'],
    [2022, 'Lexus', 'LC500h', 'Coupe 2-Door'],
    [2022, 'Lexus', 'LS500', 'Sedan 4-Door'],
    [2022, 'Lexus', 'LS500h', 'Sedan 4-Door'],
    [2022, 'Lexus', 'LX600', 'SUV 4-Door'],
    [2022, 'Lexus', 'NX250', 'SUV 4-Door'],
    [2022, 'Lexus', 'NX350', 'SUV 4-Door'],
    [2022, 'Lexus', 'NX350h', 'SUV 4-Door'],
    [2022, 'Lexus', 'NX450h+', 'SUV 4-Door'],
    [2022, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2022, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2022, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2022, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2022, 'Lexus', 'RX350L', 'SUV 4-Door'],
    [2022, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2022, 'Lexus', 'RX450hL', 'SUV 4-Door'],
    [2022, 'Lexus', 'UX200', 'SUV 4-Door'],
    [2022, 'Lexus', 'UX250h', 'SUV 4-Door'],
    [2022, 'Lincoln', 'Aviator', 'SUV 4-Door'],
    [2022, 'Lincoln', 'Corsair', 'SUV 4-Door'],
    [2022, 'Lincoln', 'Nautilus', 'SUV 4-Door'],
    [2022, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2022, 'Lucid', 'Air', 'Sedan 4-Door'],
    [2022, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2022, 'Maserati', 'Levante', 'SUV 4-Door'],
    [2022, 'Maserati', 'MC20', 'Coupe 2-Door'],
    [2022, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2022, 'Mazda', '3', 'Hatchback 4-Door'],
    [2022, 'Mazda', '3', 'Sedan 4-Door'],
    [2022, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2022, 'Mazda', 'CX-3', 'SUV 4-Door'],
    [2022, 'Mazda', 'CX-30', 'SUV 4-Door'],
    [2022, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2022, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2022, 'Mazda', 'MX-30 EV', 'SUV 4-Door'],
    [2022, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2022, 'McLaren', '720S', 'Convertible 2-Door'],
    [2022, 'McLaren', '720S', 'Coupe 2-Door'],
    [2022, 'McLaren', '765LT', 'Coupe 2-Door'],
    [2022, 'McLaren', 'Artura', 'Coupe 2-Door'],
    [2022, 'McLaren', 'GT', 'Coupe 2-Door'],
    [2022, 'Mercedes-Benz', 'A220', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'A250', 'Hatchback 4-Door'],
    [2022, 'Mercedes-Benz', 'A35 AMG', 'Hatchback 4-Door'],
    [2022, 'Mercedes-Benz', 'A35 AMG', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'AMG GT 43', 'Hatchback 4-Door'],
    [2022, 'Mercedes-Benz', 'AMG GT 53', 'Hatchback 4-Door'],
    [2022, 'Mercedes-Benz', 'C300', 'Convertible 2-Door'],
    [2022, 'Mercedes-Benz', 'C300', 'Coupe 2-Door'],
    [2022, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'C43 AMG', 'Convertible 2-Door'],
    [2022, 'Mercedes-Benz', 'C43 AMG', 'Coupe 2-Door'],
    [2022, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'CLA35 AMG', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'CLS450', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'CLS53 AMG', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'E450', 'Convertible 2-Door'],
    [2022, 'Mercedes-Benz', 'E450', 'Coupe 2-Door'],
    [2022, 'Mercedes-Benz', 'E450', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'E450', 'Wagon 4-Door'],
    [2022, 'Mercedes-Benz', 'E53 AMG', 'Convertible 2-Door'],
    [2022, 'Mercedes-Benz', 'E53 AMG', 'Coupe 2-Door'],
    [2022, 'Mercedes-Benz', 'E53 AMG', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'EQB 300', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'EQB 350', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'EQS 450+', 'Hatchback 4-Door'],
    [2022, 'Mercedes-Benz', 'EQS 580', 'Hatchback 4-Door'],
    [2022, 'Mercedes-Benz', 'EQS AMG', 'Hatchback 4-Door'],
    [2022, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLA35 AMG', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLB250', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLB35 AMG', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2022, 'Mercedes-Benz', 'GLC43 AMG', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLC43 AMG', 'SUV Coupe 4-Door'],
    [2022, 'Mercedes-Benz', 'GLE350', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLE450', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLE53 AMG', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLE53 AMG', 'SUV Coupe 4-Door'],
    [2022, 'Mercedes-Benz', 'GLE580', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV Coupe 4-Door'],
    [2022, 'Mercedes-Benz', 'GLS450', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLS580', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'GLS63 AMG', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'Maybach GLS600', 'SUV 4-Door'],
    [2022, 'Mercedes-Benz', 'Maybach S580', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'Maybach S680', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2022, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2022, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'S580', 'Sedan 4-Door'],
    [2022, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2022, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Cargo Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Passenger Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 3500XD', 'Crew Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2022, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2022, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2022, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2022, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2022, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2022, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2022, 'Mitsubishi', 'Eclipse Cross', 'SUV 4-Door'],
    [2022, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2022, 'Mitsubishi', 'Mirage G4', 'Sedan 4-Door'],
    [2022, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2022, 'Mitsubishi', 'Outlander PHEV', 'SUV 4-Door'],
    [2022, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2022, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2022, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2022, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2022, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2022, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2022, 'Nissan', 'Kicks', 'SUV 4-Door'],
    [2022, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2022, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2022, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2022, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2022, 'Nissan', 'Qashqai', 'SUV 4-Door'],
    [2022, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2022, 'Nissan', 'Rogue Sport', 'SUV 4-Door'],
    [2022, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2022, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2022, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2022, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2022, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2022, 'Polestar', 'Polestar 2', 'Hatchback 4-Door'],
    [2022, 'Porsche', '911', 'Convertible 2-Door'],
    [2022, 'Porsche', '911', 'Coupe 2-Door'],
    [2022, 'Porsche', '911', 'Targa 2-Door'],
    [2022, 'Porsche', '718 Boxster', 'Convertible 2-Door'],
    [2022, 'Porsche', '718 Cayman', 'Hatchback 2-Door'],
    [2022, 'Porsche', '718 Spyder', 'Convertible 2-Door'],
    [2022, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2022, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2022, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2022, 'Porsche', 'Panamera', 'Wagon 4-Door'],
    [2022, 'Porsche', 'Taycan', 'Sedan 4-Door'],
    [2022, 'Porsche', 'Taycan', 'Wagon 4-Door'],
    [2022, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2022, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2022, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2022, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2022, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2022, 'Ram', '1500 Classic', 'Crew Cab Pickup 4-Door'],
    [2022, 'Ram', '1500 Classic', 'Extended Cab Pickup 4-Door'],
    [2022, 'Ram', '1500 Classic', 'Standard Cab Pickup 2-Door'],
    [2022, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 3-Door'],
    [2022, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2022, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2022, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 2-Door'],
    [2022, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 3-Door'],
    [2022, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 3-Door'],
    [2022, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2022, 'Ram', 'ProMaster City', 'Mini Cargo Van 4-Door'],
    [2022, 'Ram', 'ProMaster City', 'Mini Passenger Van 4-Door'],
    [2022, 'Rivian', 'R1S', 'SUV 4-Door'],
    [2022, 'Rivian', 'R1T', 'Crew Cab Pickup 4-Door'],
    [2022, 'Rolls-Royce', 'Cullinan', 'SUV 4-Door'],
    [2022, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2022, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2022, 'Subaru', 'Ascent', 'SUV 4-Door'],
    [2022, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2022, 'Subaru', 'Crosstrek', 'Wagon 4-Door'],
    [2022, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2022, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2022, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2022, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2022, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2022, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2022, 'Tesla', '3', 'Sedan 4-Door'],
    [2022, 'Tesla', 'S', 'Sedan 4-Door'],
    [2022, 'Tesla', 'X', 'SUV 4-Door'],
    [2022, 'Tesla', 'Y', 'SUV 4-Door'],
    [2022, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2022, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2022, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2022, 'Toyota', 'C-HR', 'SUV 4-Door'],
    [2022, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [2022, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2022, 'Toyota', 'Corolla Cross', 'SUV 4-Door'],
    [2022, 'Toyota', 'GR Supra', 'Hatchback 2-Door'],
    [2022, 'Toyota', 'GR86', 'Coupe 2-Door'],
    [2022, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2022, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2022, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2022, 'Toyota', 'Prius AWD-e', 'Hatchback 4-Door'],
    [2022, 'Toyota', 'Prius Prime', 'Hatchback 4-Door'],
    [2022, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2022, 'Toyota', 'RAV4 Prime', 'SUV 4-Door'],
    [2022, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2022, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2022, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2022, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2022, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2022, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2022, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2022, 'Volkswagen', 'Arteon', 'Hatchback 4-Door'],
    [2022, 'Volkswagen', 'Atlas', 'SUV 4-Door'],
    [2022, 'Volkswagen', 'Atlas Cross Sport', 'SUV 4-Door'],
    [2022, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2022, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2022, 'Volkswagen', 'ID.4', 'SUV 4-Door'],
    [2022, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2022, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2022, 'Volkswagen', 'Taos', 'SUV 4-Door'],
    [2022, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2022, 'Volvo', 'C40 Recharge', 'SUV 4-Door'],
    [2022, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2022, 'Volvo', 'S90', 'Sedan 4-Door'],
    [2022, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2022, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2022, 'Volvo', 'V90 Cross Country', 'Wagon 4-Door'],
    [2022, 'Volvo', 'XC40', 'SUV 4-Door'],
    [2022, 'Volvo', 'XC40 Recharge', 'SUV 4-Door'],
    [2022, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2022, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2021, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2021, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2021, 'Acura', 'RDX', 'SUV 4-Door'],
    [2021, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2021, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [2021, 'Alfa Romeo', 'Stelvio', 'SUV 4-Door'],
    [2021, 'Aston Martin', 'DB11', 'Convertible 2-Door'],
    [2021, 'Aston Martin', 'DB11', 'Coupe 2-Door'],
    [2021, 'Aston Martin', 'DBS', 'Convertible 2-Door'],
    [2021, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2021, 'Aston Martin', 'DBX', 'SUV 4-Door'],
    [2021, 'Aston Martin', 'Vantage', 'Convertible 2-Door'],
    [2021, 'Aston Martin', 'Vantage', 'Hatchback 2-Door'],
    [2021, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2021, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2021, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2021, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2021, 'Audi', 'A5 Sportback', 'Hatchback 4-Door'],
    [2021, 'Audi', 'A6 allroad', 'Wagon 4-Door'],
    [2021, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2021, 'Audi', 'A7 Sportback', 'Hatchback 4-Door'],
    [2021, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2021, 'Audi', 'e-tron Quattro', 'SUV 4-Door'],
    [2021, 'Audi', 'e-tron Sportback', 'SUV 4-Door'],
    [2021, 'Audi', 'Q3', 'SUV 4-Door'],
    [2021, 'Audi', 'Q5', 'SUV 4-Door'],
    [2021, 'Audi', 'Q5 PHEV', 'SUV 4-Door'],
    [2021, 'Audi', 'Q5 Sportback', 'SUV 4-Door'],
    [2021, 'Audi', 'Q7', 'SUV 4-Door'],
    [2021, 'Audi', 'Q8', 'SUV 4-Door'],
    [2021, 'Audi', 'R8', 'Convertible 2-Door'],
    [2021, 'Audi', 'R8', 'Coupe 2-Door'],
    [2021, 'Audi', 'RS Q8', 'SUV 4-Door'],
    [2021, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2021, 'Audi', 'RS5 Sportback', 'Hatchback 4-Door'],
    [2021, 'Audi', 'RS6 Avant', 'Wagon 4-Door'],
    [2021, 'Audi', 'RS7 Sportback', 'Hatchback 4-Door'],
    [2021, 'Audi', 'S4', 'Sedan 4-Door'],
    [2021, 'Audi', 'S5', 'Convertible 2-Door'],
    [2021, 'Audi', 'S5', 'Coupe 2-Door'],
    [2021, 'Audi', 'S5 Sportback', 'Hatchback 4-Door'],
    [2021, 'Audi', 'S6', 'Sedan 4-Door'],
    [2021, 'Audi', 'S7 Sportback', 'Hatchback 4-Door'],
    [2021, 'Audi', 'S8', 'Sedan 4-Door'],
    [2021, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2021, 'Audi', 'SQ5 Sportback', 'SUV 4-Door'],
    [2021, 'Audi', 'SQ7', 'SUV 4-Door'],
    [2021, 'Audi', 'SQ8', 'SUV 4-Door'],
    [2021, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2021, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2021, 'Audi', 'TT RS Quattro', 'Coupe 2-Door'],
    [2021, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2021, 'Bentley', 'Bentayga', 'SUV 4-Door'],
    [2021, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2021, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2021, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2021, 'BMW', '228i Gran Coupe', 'Sedan 4-Door'],
    [2021, 'BMW', '228i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2021, 'BMW', '230i', 'Convertible 2-Door'],
    [2021, 'BMW', '230i', 'Coupe 2-Door'],
    [2021, 'BMW', '230i xDrive', 'Convertible 2-Door'],
    [2021, 'BMW', '230i xDrive', 'Coupe 2-Door'],
    [2021, 'BMW', '330e', 'Sedan 4-Door'],
    [2021, 'BMW', '330e xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '330i', 'Sedan 4-Door'],
    [2021, 'BMW', '330i xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '430i', 'Convertible 2-Door'],
    [2021, 'BMW', '430i', 'Coupe 2-Door'],
    [2021, 'BMW', '430i xDrive', 'Coupe 2-Door'],
    [2021, 'BMW', '530e', 'Sedan 4-Door'],
    [2021, 'BMW', '530e xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '530i', 'Sedan 4-Door'],
    [2021, 'BMW', '530i xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '540i', 'Sedan 4-Door'],
    [2021, 'BMW', '540i xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '740i', 'Sedan 4-Door'],
    [2021, 'BMW', '740i xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '745e xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '745Le xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', '840i', 'Convertible 2-Door'],
    [2021, 'BMW', '840i', 'Coupe 2-Door'],
    [2021, 'BMW', '840i Gran Coupe', 'Sedan 4-Door'],
    [2021, 'BMW', '840i xDrive', 'Convertible 2-Door'],
    [2021, 'BMW', '840i xDrive', 'Coupe 2-Door'],
    [2021, 'BMW', '840i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2021, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2021, 'BMW', 'Alpina XB7', 'SUV 4-Door'],
    [2021, 'BMW', 'i3', 'Hatchback 4-Door'],
    [2021, 'BMW', 'i3s', 'Hatchback 4-Door'],
    [2021, 'BMW', 'M2', 'Coupe 2-Door'],
    [2021, 'BMW', 'M235i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2021, 'BMW', 'M240i', 'Convertible 2-Door'],
    [2021, 'BMW', 'M240i', 'Coupe 2-Door'],
    [2021, 'BMW', 'M240i xDrive', 'Convertible 2-Door'],
    [2021, 'BMW', 'M240i xDrive', 'Coupe 2-Door'],
    [2021, 'BMW', 'M3', 'Sedan 4-Door'],
    [2021, 'BMW', 'M340i', 'Sedan 4-Door'],
    [2021, 'BMW', 'M340i xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', 'M4', 'Coupe 2-Door'],
    [2021, 'BMW', 'M440i', 'Convertible 2-Door'],
    [2021, 'BMW', 'M440i xDrive', 'Convertible 2-Door'],
    [2021, 'BMW', 'M440i xDrive', 'Coupe 2-Door'],
    [2021, 'BMW', 'M5', 'Sedan 4-Door'],
    [2021, 'BMW', 'M550i xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', 'M760i xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', 'M760Li xDrive', 'Sedan 4-Door'],
    [2021, 'BMW', 'M8 Gran Coupe', 'Sedan 4-Door'],
    [2021, 'BMW', 'M850i xDrive', 'Convertible 2-Door'],
    [2021, 'BMW', 'M850i xDrive', 'Coupe 2-Door'],
    [2021, 'BMW', 'M850i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2021, 'BMW', 'X1', 'SUV 4-Door'],
    [2021, 'BMW', 'X2', 'SUV 4-Door'],
    [2021, 'BMW', 'X3', 'SUV 4-Door'],
    [2021, 'BMW', 'X4', 'SUV 4-Door'],
    [2021, 'BMW', 'X5', 'SUV 4-Door'],
    [2021, 'BMW', 'X6', 'SUV 4-Door'],
    [2021, 'BMW', 'X7', 'SUV 4-Door'],
    [2021, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2021, 'Bugatti', 'Chiron', 'Coupe 2-Door'],
    [2021, 'Bugatti', 'Divo', 'Coupe 2-Door'],
    [2021, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2021, 'Buick', 'Encore', 'SUV 4-Door'],
    [2021, 'Buick', 'Encore GX', 'SUV 4-Door'],
    [2021, 'Buick', 'Envision', 'SUV 4-Door'],
    [2021, 'Cadillac', 'CT4', 'Sedan 4-Door'],
    [2021, 'Cadillac', 'CT5', 'Sedan 4-Door'],
    [2021, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2021, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2021, 'Cadillac', 'XT4', 'SUV 4-Door'],
    [2021, 'Cadillac', 'XT5', 'Hearse 4-Door'],
    [2021, 'Cadillac', 'XT5', 'Limousine 4-Door'],
    [2021, 'Cadillac', 'XT5', 'SUV 4-Door'],
    [2021, 'Cadillac', 'XT6', 'SUV 4-Door'],
    [2021, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2021, 'Chevrolet', 'Bolt EV', 'Hatchback 4-Door'],
    [2021, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2021, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2021, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2021, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2021, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2021, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2021, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2021, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2021, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2021, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2021, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2021, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2021, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2021, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2021, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2021, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2021, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2021, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2021, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2021, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2021, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2021, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2021, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2021, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2021, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2021, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2021, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2021, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2021, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2021, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2021, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2021, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2021, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2021, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2021, 'Chrysler', '300', 'Sedan 4-Door'],
    [2021, 'Chrysler', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2021, 'Chrysler', 'Pacifica', 'Mini Passenger Van 4-Door'],
    [2021, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2021, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2021, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2021, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2021, 'Ferrari', '488 Pista', 'Coupe 2-Door'],
    [2021, 'Ferrari', '488 Pista Spider', 'Convertible 2-Door'],
    [2021, 'Ferrari', '812 GTS', 'Convertible 2-Door'],
    [2021, 'Ferrari', '812 Superfast', 'Coupe 2-Door'],
    [2021, 'Ferrari', 'F8 Spider', 'Convertible 2-Door'],
    [2021, 'Ferrari', 'F8 Tributo', 'Coupe 2-Door'],
    [2021, 'Ferrari', 'Portofino M', 'Convertible 2-Door'],
    [2021, 'Ferrari', 'Roma', 'Coupe 2-Door'],
    [2021, 'Ferrari', 'SF90 Spider', 'Convertible 2-Door'],
    [2021, 'Ferrari', 'SF90 Stradale', 'Coupe 2-Door'],
    [2021, 'Fiat', '500X', 'SUV 4-Door'],
    [2021, 'Ford', 'Bronco', 'SUV 2-Door'],
    [2021, 'Ford', 'Bronco', 'SUV 4-Door'],
    [2021, 'Ford', 'Bronco Sport', 'SUV 4-Door'],
    [2021, 'Ford', 'EcoSport', 'SUV 4-Door'],
    [2021, 'Ford', 'Edge', 'SUV 4-Door'],
    [2021, 'Ford', 'Escape', 'SUV 4-Door'],
    [2021, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2021, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2021, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2021, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2021, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2021, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2021, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2021, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2021, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ford', 'F-450 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2021, 'Ford', 'GT', 'Coupe 2-Door'],
    [2021, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2021, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2021, 'Ford', 'Mustang Mach-E', 'SUV 4-Door'],
    [2021, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2021, 'Ford', 'Ranger', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2021, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2021, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2021, 'Ford', 'Transit-150', 'Crew Van 3-Door'],
    [2021, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2021, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2021, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2021, 'Ford', 'Transit-250', 'Crew Van 3-Door'],
    [2021, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2021, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2021, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2021, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2021, 'Ford', 'Transit-350', 'Crew Van 3-Door'],
    [2021, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2021, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2021, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2021, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2021, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2021, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2021, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2021, 'Ford', 'Transit-350 HD', 'Extended Crew Van 3-Door'],
    [2021, 'Ford', 'Transit-350 HD', 'Extended Crew Van 4-Door'],
    [2021, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 3500XD', 'Crew Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2021, 'Freightliner', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2021, 'Freightliner', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2021, 'Freightliner', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2021, 'Freightliner', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2021, 'Genesis', 'G70', 'Sedan 4-Door'],
    [2021, 'Genesis', 'G80', 'Sedan 4-Door'],
    [2021, 'Genesis', 'G90', 'Sedan 4-Door'],
    [2021, 'Genesis', 'GV80', 'SUV 4-Door'],
    [2021, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2021, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2021, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2021, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2021, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2021, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2021, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2021, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2021, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2021, 'GMC', 'Savana 3500', 'Extended Cargo Van 4-Door'],
    [2021, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2021, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2021, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2021, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2021, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2021, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2021, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2021, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2021, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2021, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2021, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2021, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2021, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2021, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2021, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2021, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2021, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2021, 'Honda', 'Civic', 'Hatchback 4-Door'],
    [2021, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2021, 'Honda', 'Clarity', 'Sedan 4-Door'],
    [2021, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2021, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2021, 'Honda', 'Insight', 'Sedan 4-Door'],
    [2021, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2021, 'Honda', 'Passport', 'SUV 4-Door'],
    [2021, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2021, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2021, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2021, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2021, 'Hyundai', 'Ioniq', 'Hatchback 4-Door'],
    [2021, 'Hyundai', 'Kona', 'SUV 4-Door'],
    [2021, 'Hyundai', 'Kona Electric', 'SUV 4-Door'],
    [2021, 'Hyundai', 'Nexo', 'SUV 4-Door'],
    [2021, 'Hyundai', 'Palisade', 'SUV 4-Door'],
    [2021, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2021, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2021, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2021, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2021, 'Hyundai', 'Veloster N', 'Hatchback 3-Door'],
    [2021, 'Hyundai', 'Venue', 'SUV 4-Door'],
    [2021, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2021, 'INFINITI', 'Q60', 'Coupe 2-Door'],
    [2021, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2021, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2021, 'Jaguar', 'E-Pace', 'SUV 4-Door'],
    [2021, 'Jaguar', 'F-Pace', 'SUV 4-Door'],
    [2021, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2021, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2021, 'Jaguar', 'I-Pace', 'SUV 4-Door'],
    [2021, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2021, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2021, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2021, 'Jeep', 'Gladiator', 'Crew Cab Pickup 4-Door'],
    [2021, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2021, 'Jeep', 'Grand Cherokee L', 'SUV 4-Door'],
    [2021, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2021, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2021, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2021, 'Karma', 'Revero', 'Sedan 4-Door'],
    [2021, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2021, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2021, 'Kia', 'K5', 'Sedan 4-Door'],
    [2021, 'Kia', 'Niro', 'SUV 4-Door'],
    [2021, 'Kia', 'Niro EV', 'SUV 4-Door'],
    [2021, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2021, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2021, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2021, 'Kia', 'Seltos', 'SUV 4-Door'],
    [2021, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2021, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2021, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2021, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2021, 'Kia', 'Stinger', 'Hatchback 4-Door'],
    [2021, 'Kia', 'Telluride', 'SUV 4-Door'],
    [2021, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2021, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2021, 'Lamborghini', 'Huracan', 'Convertible 2-Door'],
    [2021, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2021, 'Lamborghini', 'Urus', 'SUV 4-Door'],
    [2021, 'Land Rover', 'Defender 110', 'SUV 4-Door'],
    [2021, 'Land Rover', 'Defender 90', 'SUV 2-Door'],
    [2021, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2021, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2021, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2021, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2021, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2021, 'Land Rover', 'Range Rover Velar', 'SUV 4-Door'],
    [2021, 'Lexus', 'ES250', 'Sedan 4-Door'],
    [2021, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2021, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2021, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2021, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2021, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2021, 'Lexus', 'LC500', 'Convertible 2-Door'],
    [2021, 'Lexus', 'LC500', 'Coupe 2-Door'],
    [2021, 'Lexus', 'LC500h', 'Coupe 2-Door'],
    [2021, 'Lexus', 'LS500', 'Sedan 4-Door'],
    [2021, 'Lexus', 'LS500h', 'Sedan 4-Door'],
    [2021, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2021, 'Lexus', 'NX300', 'SUV 4-Door'],
    [2021, 'Lexus', 'NX300h', 'SUV 4-Door'],
    [2021, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2021, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2021, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2021, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2021, 'Lexus', 'RX350L', 'SUV 4-Door'],
    [2021, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2021, 'Lexus', 'RX450hL', 'SUV 4-Door'],
    [2021, 'Lexus', 'UX200', 'SUV 4-Door'],
    [2021, 'Lexus', 'UX250h', 'SUV 4-Door'],
    [2021, 'Lincoln', 'Aviator', 'SUV 4-Door'],
    [2021, 'Lincoln', 'Corsair', 'SUV 4-Door'],
    [2021, 'Lincoln', 'Nautilus', 'SUV 4-Door'],
    [2021, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2021, 'Lotus', 'Evora GT', 'Coupe 2-Door'],
    [2021, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2021, 'Maserati', 'Levante', 'SUV 4-Door'],
    [2021, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2021, 'Mazda', '3', 'Hatchback 4-Door'],
    [2021, 'Mazda', '3', 'Sedan 4-Door'],
    [2021, 'Mazda', '6', 'Sedan 4-Door'],
    [2021, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2021, 'Mazda', 'CX-3', 'SUV 4-Door'],
    [2021, 'Mazda', 'CX-30', 'SUV 4-Door'],
    [2021, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2021, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2021, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2021, 'McLaren', '570S', 'Convertible 2-Door'],
    [2021, 'McLaren', '570S', 'Coupe 2-Door'],
    [2021, 'McLaren', '600LT', 'Convertible 2-Door'],
    [2021, 'McLaren', '600LT', 'Coupe 2-Door'],
    [2021, 'McLaren', '720S', 'Convertible 2-Door'],
    [2021, 'McLaren', '720S', 'Coupe 2-Door'],
    [2021, 'McLaren', '765LT', 'Coupe 2-Door'],
    [2021, 'McLaren', 'GT', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'A220', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'A250', 'Hatchback 4-Door'],
    [2021, 'Mercedes-Benz', 'A35 AMG', 'Hatchback 4-Door'],
    [2021, 'Mercedes-Benz', 'A35 AMG', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT 43', 'Hatchback 4-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT 53', 'Hatchback 4-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT 63', 'Hatchback 4-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT 63 S', 'Hatchback 4-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT Black Series', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT C', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'AMG GT C', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'C300', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'C300', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'C43 AMG', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'C43 AMG', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'C43 AMG', 'Wagon 4-Door'],
    [2021, 'Mercedes-Benz', 'C63 AMG', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'C63 AMG S', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'C63 AMG S', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'C63 AMG S', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'CLA35 AMG', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'CLS450', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'CLS53 AMG', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'E450', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'E450', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'E450', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'E450', 'Wagon 4-Door'],
    [2021, 'Mercedes-Benz', 'E53 AMG', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'E53 AMG', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'E53 AMG', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'E63 AMG S', 'Wagon 4-Door'],
    [2021, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLA35 AMG', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLB250', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLB35 AMG', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2021, 'Mercedes-Benz', 'GLC43 AMG', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLC43 AMG', 'SUV Coupe 4-Door'],
    [2021, 'Mercedes-Benz', 'GLC63 AMG', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLC63 AMG', 'SUV Coupe 4-Door'],
    [2021, 'Mercedes-Benz', 'GLC63 AMG S', 'SUV Coupe 4-Door'],
    [2021, 'Mercedes-Benz', 'GLE350', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLE450', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLE53 AMG', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLE53 AMG', 'SUV Coupe 4-Door'],
    [2021, 'Mercedes-Benz', 'GLE580', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV Coupe 4-Door'],
    [2021, 'Mercedes-Benz', 'GLS450', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLS580', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'GLS63 AMG', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'Maybach GLS600', 'SUV 4-Door'],
    [2021, 'Mercedes-Benz', 'Maybach S580', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2021, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2021, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'S560', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'S560', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'S580', 'Sedan 4-Door'],
    [2021, 'Mercedes-Benz', 'S63 AMG', 'Convertible 2-Door'],
    [2021, 'Mercedes-Benz', 'S63 AMG', 'Coupe 2-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Cargo Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Passenger Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 3500XD', 'Crew Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2021, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2021, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2021, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2021, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2021, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2021, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2021, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2021, 'Mitsubishi', 'Mirage G4', 'Sedan 4-Door'],
    [2021, 'Mitsubishi', 'Outlander PHEV', 'SUV 4-Door'],
    [2021, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2021, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2021, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2021, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2021, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2021, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2021, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2021, 'Nissan', 'Kicks', 'SUV 4-Door'],
    [2021, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2021, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2021, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2021, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2021, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2021, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2021, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2021, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2021, 'Nissan', 'Qashqai', 'SUV 4-Door'],
    [2021, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2021, 'Nissan', 'Rogue Sport', 'SUV 4-Door'],
    [2021, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2021, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2021, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2021, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2021, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2021, 'Polestar', 'Polestar 1', 'Coupe 2-Door'],
    [2021, 'Polestar', 'Polestar 2', 'Hatchback 4-Door'],
    [2021, 'Porsche', '911', 'Convertible 2-Door'],
    [2021, 'Porsche', '911', 'Coupe 2-Door'],
    [2021, 'Porsche', '911', 'Targa 2-Door'],
    [2021, 'Porsche', '718 Boxster', 'Convertible 2-Door'],
    [2021, 'Porsche', '718 Cayman', 'Hatchback 2-Door'],
    [2021, 'Porsche', '718 Spyder', 'Convertible 2-Door'],
    [2021, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2021, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2021, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2021, 'Porsche', 'Panamera', 'Wagon 4-Door'],
    [2021, 'Porsche', 'Taycan', 'Sedan 4-Door'],
    [2021, 'Porsche', 'Taycan', 'Wagon 4-Door'],
    [2021, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2021, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2021, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2021, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2021, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2021, 'Ram', '1500 Classic', 'Crew Cab Pickup 4-Door'],
    [2021, 'Ram', '1500 Classic', 'Extended Cab Pickup 4-Door'],
    [2021, 'Ram', '1500 Classic', 'Standard Cab Pickup 2-Door'],
    [2021, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 3-Door'],
    [2021, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2021, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2021, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 2-Door'],
    [2021, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 3-Door'],
    [2021, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 3-Door'],
    [2021, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2021, 'Ram', 'ProMaster City', 'Mini Cargo Van 4-Door'],
    [2021, 'Ram', 'ProMaster City', 'Mini Passenger Van 4-Door'],
    [2021, 'Rolls-Royce', 'Cullinan', 'SUV 4-Door'],
    [2021, 'Rolls-Royce', 'Dawn', 'Convertible 2-Door'],
    [2021, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2021, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2021, 'Rolls-Royce', 'Wraith', 'Coupe 2-Door'],
    [2021, 'Subaru', 'Ascent', 'SUV 4-Door'],
    [2021, 'Subaru', 'Crosstrek', 'Wagon 4-Door'],
    [2021, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2021, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2021, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2021, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2021, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2021, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2021, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2021, 'Tesla', '3', 'Sedan 4-Door'],
    [2021, 'Tesla', 'S', 'Sedan 4-Door'],
    [2021, 'Tesla', 'X', 'SUV 4-Door'],
    [2021, 'Tesla', 'Y', 'SUV 4-Door'],
    [2021, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2021, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2021, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2021, 'Toyota', 'C-HR', 'SUV 4-Door'],
    [2021, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [2021, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2021, 'Toyota', 'GR Supra', 'Hatchback 2-Door'],
    [2021, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2021, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2021, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2021, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2021, 'Toyota', 'Prius AWD-e', 'Hatchback 4-Door'],
    [2021, 'Toyota', 'Prius Prime', 'Hatchback 4-Door'],
    [2021, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2021, 'Toyota', 'RAV4 Prime', 'SUV 4-Door'],
    [2021, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2021, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2021, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2021, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2021, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2021, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2021, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2021, 'Volkswagen', 'Arteon', 'Hatchback 4-Door'],
    [2021, 'Volkswagen', 'Atlas', 'SUV 4-Door'],
    [2021, 'Volkswagen', 'Atlas Cross Sport', 'SUV 4-Door'],
    [2021, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2021, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2021, 'Volkswagen', 'ID.4', 'SUV 4-Door'],
    [2021, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2021, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2021, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2021, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2021, 'Volvo', 'S90', 'Sedan 4-Door'],
    [2021, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2021, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2021, 'Volvo', 'V90', 'Wagon 4-Door'],
    [2021, 'Volvo', 'V90 Cross Country', 'Wagon 4-Door'],
    [2021, 'Volvo', 'XC40', 'SUV 4-Door'],
    [2021, 'Volvo', 'XC40 Recharge', 'SUV 4-Door'],
    [2021, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2021, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2020, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2020, 'Acura', 'MDX', 'SUV 4-Door'],
    [2020, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2020, 'Acura', 'RDX', 'SUV 4-Door'],
    [2020, 'Acura', 'RLX', 'Sedan 4-Door'],
    [2020, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2020, 'Alfa Romeo', '4C', 'Convertible 2-Door'],
    [2020, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [2020, 'Alfa Romeo', 'Stelvio', 'SUV 4-Door'],
    [2020, 'Aston Martin', 'DB11', 'Convertible 2-Door'],
    [2020, 'Aston Martin', 'DB11', 'Coupe 2-Door'],
    [2020, 'Aston Martin', 'DBS', 'Convertible 2-Door'],
    [2020, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2020, 'Aston Martin', 'Vantage', 'Hatchback 2-Door'],
    [2020, 'Audi', 'A3', 'Sedan 4-Door'],
    [2020, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2020, 'Audi', 'A4', 'Sedan 4-Door'],
    [2020, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2020, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2020, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2020, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2020, 'Audi', 'A5 Sportback', 'Hatchback 4-Door'],
    [2020, 'Audi', 'A6 allroad', 'Wagon 4-Door'],
    [2020, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2020, 'Audi', 'A7 Quattro', 'Sedan 4-Door'],
    [2020, 'Audi', 'A7 Sportback', 'Hatchback 4-Door'],
    [2020, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2020, 'Audi', 'e-tron Quattro', 'SUV 4-Door'],
    [2020, 'Audi', 'e-tron Sportback', 'SUV 4-Door'],
    [2020, 'Audi', 'Q3', 'SUV 4-Door'],
    [2020, 'Audi', 'Q5', 'SUV 4-Door'],
    [2020, 'Audi', 'Q5 PHEV', 'SUV 4-Door'],
    [2020, 'Audi', 'Q7', 'SUV 4-Door'],
    [2020, 'Audi', 'Q8', 'SUV 4-Door'],
    [2020, 'Audi', 'R8', 'Convertible 2-Door'],
    [2020, 'Audi', 'R8', 'Coupe 2-Door'],
    [2020, 'Audi', 'RS Q8', 'SUV 4-Door'],
    [2020, 'Audi', 'RS3', 'Sedan 4-Door'],
    [2020, 'Audi', 'S3', 'Sedan 4-Door'],
    [2020, 'Audi', 'S4', 'Sedan 4-Door'],
    [2020, 'Audi', 'S5', 'Convertible 2-Door'],
    [2020, 'Audi', 'S5', 'Coupe 2-Door'],
    [2020, 'Audi', 'S5 Sportback', 'Hatchback 4-Door'],
    [2020, 'Audi', 'S6', 'Sedan 4-Door'],
    [2020, 'Audi', 'S7 Sportback', 'Hatchback 4-Door'],
    [2020, 'Audi', 'S8', 'Sedan 4-Door'],
    [2020, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2020, 'Audi', 'SQ7', 'SUV 4-Door'],
    [2020, 'Audi', 'SQ8', 'SUV 4-Door'],
    [2020, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2020, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2020, 'Audi', 'TT RS Quattro', 'Coupe 2-Door'],
    [2020, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2020, 'Bentley', 'Bentayga', 'SUV 4-Door'],
    [2020, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2020, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2020, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2020, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2020, 'BMW', '228i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2020, 'BMW', '230i', 'Convertible 2-Door'],
    [2020, 'BMW', '230i', 'Coupe 2-Door'],
    [2020, 'BMW', '230i xDrive', 'Convertible 2-Door'],
    [2020, 'BMW', '230i xDrive', 'Coupe 2-Door'],
    [2020, 'BMW', '330i', 'Sedan 4-Door'],
    [2020, 'BMW', '330i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '430i', 'Convertible 2-Door'],
    [2020, 'BMW', '430i', 'Coupe 2-Door'],
    [2020, 'BMW', '430i Gran Coupe', 'Hatchback 4-Door'],
    [2020, 'BMW', '430i xDrive', 'Convertible 2-Door'],
    [2020, 'BMW', '430i xDrive', 'Coupe 2-Door'],
    [2020, 'BMW', '430i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2020, 'BMW', '440i', 'Convertible 2-Door'],
    [2020, 'BMW', '440i', 'Coupe 2-Door'],
    [2020, 'BMW', '440i Gran Coupe', 'Hatchback 4-Door'],
    [2020, 'BMW', '440i xDrive', 'Convertible 2-Door'],
    [2020, 'BMW', '440i xDrive', 'Coupe 2-Door'],
    [2020, 'BMW', '440i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2020, 'BMW', '530e', 'Sedan 4-Door'],
    [2020, 'BMW', '530e xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '530i', 'Sedan 4-Door'],
    [2020, 'BMW', '530i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '540i', 'Sedan 4-Door'],
    [2020, 'BMW', '540i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '740i', 'Sedan 4-Door'],
    [2020, 'BMW', '740i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '745e xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '745Le xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', '840i', 'Convertible 2-Door'],
    [2020, 'BMW', '840i', 'Coupe 2-Door'],
    [2020, 'BMW', '840i Gran Coupe', 'Sedan 4-Door'],
    [2020, 'BMW', '840i xDrive', 'Convertible 2-Door'],
    [2020, 'BMW', '840i xDrive', 'Coupe 2-Door'],
    [2020, 'BMW', '840i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2020, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2020, 'BMW', 'i3', 'Hatchback 4-Door'],
    [2020, 'BMW', 'i3s', 'Hatchback 4-Door'],
    [2020, 'BMW', 'i8', 'Convertible 2-Door'],
    [2020, 'BMW', 'i8', 'Coupe 2-Door'],
    [2020, 'BMW', 'M2', 'Coupe 2-Door'],
    [2020, 'BMW', 'M235i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', 'M235i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2020, 'BMW', 'M240i', 'Convertible 2-Door'],
    [2020, 'BMW', 'M240i', 'Coupe 2-Door'],
    [2020, 'BMW', 'M240i xDrive', 'Convertible 2-Door'],
    [2020, 'BMW', 'M240i xDrive', 'Coupe 2-Door'],
    [2020, 'BMW', 'M340i', 'Sedan 4-Door'],
    [2020, 'BMW', 'M340i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', 'M4', 'Convertible 2-Door'],
    [2020, 'BMW', 'M4', 'Coupe 2-Door'],
    [2020, 'BMW', 'M5', 'Sedan 4-Door'],
    [2020, 'BMW', 'M550i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', 'M760i xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', 'M760Li xDrive', 'Sedan 4-Door'],
    [2020, 'BMW', 'M8', 'Convertible 2-Door'],
    [2020, 'BMW', 'M8', 'Coupe 2-Door'],
    [2020, 'BMW', 'M8 Gran Coupe', 'Sedan 4-Door'],
    [2020, 'BMW', 'M850i xDrive', 'Convertible 2-Door'],
    [2020, 'BMW', 'M850i xDrive', 'Coupe 2-Door'],
    [2020, 'BMW', 'M850i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2020, 'BMW', 'X1', 'SUV 4-Door'],
    [2020, 'BMW', 'X2', 'SUV 4-Door'],
    [2020, 'BMW', 'X3', 'SUV 4-Door'],
    [2020, 'BMW', 'X4', 'SUV 4-Door'],
    [2020, 'BMW', 'X5', 'SUV 4-Door'],
    [2020, 'BMW', 'X6', 'SUV 4-Door'],
    [2020, 'BMW', 'X7', 'SUV 4-Door'],
    [2020, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2020, 'Bugatti', 'Chiron', 'Coupe 2-Door'],
    [2020, 'Bugatti', 'Divo', 'Coupe 2-Door'],
    [2020, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2020, 'Buick', 'Encore', 'SUV 4-Door'],
    [2020, 'Buick', 'Encore GX', 'SUV 4-Door'],
    [2020, 'Buick', 'Envision', 'SUV 4-Door'],
    [2020, 'Buick', 'Regal Sportback', 'Hatchback 4-Door'],
    [2020, 'Buick', 'Regal TourX', 'Wagon 4-Door'],
    [2020, 'Cadillac', 'CT4', 'Sedan 4-Door'],
    [2020, 'Cadillac', 'CT5', 'Sedan 4-Door'],
    [2020, 'Cadillac', 'CT6', 'Sedan 4-Door'],
    [2020, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2020, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2020, 'Cadillac', 'XT4', 'SUV 4-Door'],
    [2020, 'Cadillac', 'XT5', 'SUV 4-Door'],
    [2020, 'Cadillac', 'XT6', 'SUV 4-Door'],
    [2020, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2020, 'Chevrolet', 'Bolt EV', 'Hatchback 4-Door'],
    [2020, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2020, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2020, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2020, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2020, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2020, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2020, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2020, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2020, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2020, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2020, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2020, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2020, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2020, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2020, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2020, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2020, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2020, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2020, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2020, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2020, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2020, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2020, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2020, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2020, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2020, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2020, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2020, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2020, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2020, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2020, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2020, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2020, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2020, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2020, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2020, 'Chrysler', '300', 'Sedan 4-Door'],
    [2020, 'Chrysler', 'Pacifica', 'Mini Passenger Van 4-Door'],
    [2020, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2020, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2020, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2020, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2020, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2020, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2020, 'Ferrari', '488 Pista', 'Coupe 2-Door'],
    [2020, 'Ferrari', '488 Pista Spider', 'Convertible 2-Door'],
    [2020, 'Ferrari', '812 GTS', 'Convertible 2-Door'],
    [2020, 'Ferrari', '812 Superfast', 'Coupe 2-Door'],
    [2020, 'Ferrari', 'F8 Tributo', 'Coupe 2-Door'],
    [2020, 'Ferrari', 'GTC4Lusso', 'Hatchback 2-Door'],
    [2020, 'Ferrari', 'GTC4Lusso T', 'Hatchback 2-Door'],
    [2020, 'Ferrari', 'Portofino', 'Convertible 2-Door'],
    [2020, 'Ferrari', 'Roma', 'Coupe 2-Door'],
    [2020, 'Ferrari', 'SF90 Stradale', 'Coupe 2-Door'],
    [2020, 'Fiat', '124 Spider', 'Convertible 2-Door'],
    [2020, 'Fiat', '500L', 'Hatchback 4-Door'],
    [2020, 'Fiat', '500X', 'SUV 4-Door'],
    [2020, 'Ford', 'EcoSport', 'SUV 4-Door'],
    [2020, 'Ford', 'Edge', 'SUV 4-Door'],
    [2020, 'Ford', 'Escape', 'SUV 4-Door'],
    [2020, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2020, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2020, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2020, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2020, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2020, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2020, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2020, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2020, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ford', 'F-450 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2020, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2020, 'Ford', 'GT', 'Coupe 2-Door'],
    [2020, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2020, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2020, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2020, 'Ford', 'Police Responder Hybrid', 'Sedan 4-Door'],
    [2020, 'Ford', 'Ranger', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2020, 'Ford', 'SSV Plug-In Hybrid', 'Sedan 4-Door'],
    [2020, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2020, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2020, 'Ford', 'Transit-150', 'Crew Van 3-Door'],
    [2020, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2020, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2020, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2020, 'Ford', 'Transit-250', 'Crew Van 3-Door'],
    [2020, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2020, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2020, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2020, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2020, 'Ford', 'Transit-350', 'Crew Van 3-Door'],
    [2020, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2020, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2020, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2020, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2020, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2020, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2020, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2020, 'Ford', 'Transit-350 HD', 'Extended Crew Van 3-Door'],
    [2020, 'Ford', 'Transit-350 HD', 'Extended Crew Van 4-Door'],
    [2020, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 1500', 'Standard Cargo Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 3500XD', 'Crew Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2020, 'Freightliner', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2020, 'Freightliner', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2020, 'Freightliner', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2020, 'Freightliner', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2020, 'Genesis', 'G70', 'Sedan 4-Door'],
    [2020, 'Genesis', 'G80', 'Sedan 4-Door'],
    [2020, 'Genesis', 'G90', 'Sedan 4-Door'],
    [2020, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2020, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2020, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2020, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2020, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2020, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2020, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2020, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2020, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2020, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2020, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2020, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2020, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2020, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2020, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2020, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2020, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2020, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2020, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2020, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2020, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2020, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2020, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2020, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2020, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2020, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2020, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2020, 'Honda', 'Civic', 'Hatchback 4-Door'],
    [2020, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2020, 'Honda', 'Clarity', 'Sedan 4-Door'],
    [2020, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2020, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2020, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2020, 'Honda', 'Insight', 'Sedan 4-Door'],
    [2020, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2020, 'Honda', 'Passport', 'SUV 4-Door'],
    [2020, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2020, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2020, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2020, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2020, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2020, 'Hyundai', 'Elantra GT', 'Hatchback 4-Door'],
    [2020, 'Hyundai', 'Ioniq', 'Hatchback 4-Door'],
    [2020, 'Hyundai', 'Kona', 'SUV 4-Door'],
    [2020, 'Hyundai', 'Kona Electric', 'SUV 4-Door'],
    [2020, 'Hyundai', 'Nexo', 'SUV 4-Door'],
    [2020, 'Hyundai', 'Palisade', 'SUV 4-Door'],
    [2020, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2020, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2020, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2020, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2020, 'Hyundai', 'Veloster N', 'Hatchback 3-Door'],
    [2020, 'Hyundai', 'Venue', 'SUV 4-Door'],
    [2020, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2020, 'INFINITI', 'Q60', 'Coupe 2-Door'],
    [2020, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2020, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2020, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2020, 'Jaguar', 'E-Pace', 'SUV 4-Door'],
    [2020, 'Jaguar', 'F-Pace', 'SUV 4-Door'],
    [2020, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2020, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2020, 'Jaguar', 'I-Pace', 'SUV 4-Door'],
    [2020, 'Jaguar', 'XE', 'Sedan 4-Door'],
    [2020, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2020, 'Jaguar', 'XF', 'Wagon 4-Door'],
    [2020, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2020, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2020, 'Jeep', 'Gladiator', 'Crew Cab Pickup 4-Door'],
    [2020, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2020, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2020, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2020, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2020, 'Karma', 'Revero', 'Sedan 4-Door'],
    [2020, 'Kia', 'Cadenza', 'Sedan 4-Door'],
    [2020, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2020, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2020, 'Kia', 'K900', 'Sedan 4-Door'],
    [2020, 'Kia', 'Niro', 'SUV 4-Door'],
    [2020, 'Kia', 'Niro EV', 'SUV 4-Door'],
    [2020, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2020, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2020, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2020, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2020, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2020, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2020, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2020, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2020, 'Kia', 'Stinger', 'Hatchback 4-Door'],
    [2020, 'Kia', 'Telluride', 'SUV 4-Door'],
    [2020, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2020, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2020, 'Lamborghini', 'Huracan', 'Convertible 2-Door'],
    [2020, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2020, 'Lamborghini', 'Urus', 'SUV 4-Door'],
    [2020, 'Land Rover', 'Defender 110', 'SUV 4-Door'],
    [2020, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2020, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2020, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2020, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2020, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2020, 'Land Rover', 'Range Rover Velar', 'SUV 4-Door'],
    [2020, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2020, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2020, 'Lexus', 'GS F', 'Sedan 4-Door'],
    [2020, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2020, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2020, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2020, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2020, 'Lexus', 'LC500', 'Coupe 2-Door'],
    [2020, 'Lexus', 'LC500h', 'Coupe 2-Door'],
    [2020, 'Lexus', 'LS500', 'Sedan 4-Door'],
    [2020, 'Lexus', 'LS500h', 'Sedan 4-Door'],
    [2020, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2020, 'Lexus', 'NX300', 'SUV 4-Door'],
    [2020, 'Lexus', 'NX300h', 'SUV 4-Door'],
    [2020, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2020, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2020, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2020, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2020, 'Lexus', 'RX350L', 'SUV 4-Door'],
    [2020, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2020, 'Lexus', 'RX450hL', 'SUV 4-Door'],
    [2020, 'Lexus', 'UX200', 'SUV 4-Door'],
    [2020, 'Lexus', 'UX250h', 'SUV 4-Door'],
    [2020, 'Lincoln', 'Aviator', 'SUV 4-Door'],
    [2020, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [2020, 'Lincoln', 'Corsair', 'SUV 4-Door'],
    [2020, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2020, 'Lincoln', 'Nautilus', 'SUV 4-Door'],
    [2020, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2020, 'Lotus', 'Evora GT', 'Coupe 2-Door'],
    [2020, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2020, 'Maserati', 'Levante', 'SUV 4-Door'],
    [2020, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2020, 'Mazda', '3', 'Hatchback 4-Door'],
    [2020, 'Mazda', '3', 'Sedan 4-Door'],
    [2020, 'Mazda', '6', 'Sedan 4-Door'],
    [2020, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2020, 'Mazda', 'CX-3', 'SUV 4-Door'],
    [2020, 'Mazda', 'CX-30', 'SUV 4-Door'],
    [2020, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2020, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2020, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2020, 'McLaren', '570S', 'Convertible 2-Door'],
    [2020, 'McLaren', '570S', 'Coupe 2-Door'],
    [2020, 'McLaren', '600LT', 'Convertible 2-Door'],
    [2020, 'McLaren', '600LT', 'Coupe 2-Door'],
    [2020, 'McLaren', '720S', 'Convertible 2-Door'],
    [2020, 'McLaren', '720S', 'Coupe 2-Door'],
    [2020, 'McLaren', 'GT', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'A220', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'A250', 'Hatchback 4-Door'],
    [2020, 'Mercedes-Benz', 'A35 AMG', 'Hatchback 4-Door'],
    [2020, 'Mercedes-Benz', 'A35 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT 53', 'Hatchback 4-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT 63', 'Hatchback 4-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT 63 S', 'Hatchback 4-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT C', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT C', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT R', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT R', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'AMG GT R Pro', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'C300', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'C300', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'C300', 'Wagon 4-Door'],
    [2020, 'Mercedes-Benz', 'C43 AMG', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'C43 AMG', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'C43 AMG', 'Wagon 4-Door'],
    [2020, 'Mercedes-Benz', 'C63 AMG', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'C63 AMG S', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'C63 AMG S', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'C63 AMG S', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'CLA35 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'CLS450', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'CLS53 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'E450', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'E450', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'E450', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'E450', 'Wagon 4-Door'],
    [2020, 'Mercedes-Benz', 'E53 AMG', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'E53 AMG', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'E53 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'E63 AMG S', 'Wagon 4-Door'],
    [2020, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLB250', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2020, 'Mercedes-Benz', 'GLC350e', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLC43 AMG', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLC43 AMG', 'SUV Coupe 4-Door'],
    [2020, 'Mercedes-Benz', 'GLC63 AMG', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLC63 AMG', 'SUV Coupe 4-Door'],
    [2020, 'Mercedes-Benz', 'GLC63 AMG S', 'SUV Coupe 4-Door'],
    [2020, 'Mercedes-Benz', 'GLE350', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLE450', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLE580', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLS450', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'GLS580', 'SUV 4-Door'],
    [2020, 'Mercedes-Benz', 'Maybach S560', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'Maybach S650', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2020, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2020, 'Mercedes-Benz', 'S450', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'S560', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'S560', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'S560', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'S560e', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'S63 AMG', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'S63 AMG', 'Coupe 2-Door'],
    [2020, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2020, 'Mercedes-Benz', 'SL450', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'SLC300', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'SLC43 AMG', 'Convertible 2-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Cargo Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Passenger Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 3500XD', 'Crew Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2020, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2020, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2020, 'Mini', 'Cooper', 'Coupe 2-Door'],
    [2020, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2020, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2020, 'Mini', 'Cooper', 'Sedan 4-Door'],
    [2020, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2020, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2020, 'Mitsubishi', 'Eclipse Cross', 'SUV 4-Door'],
    [2020, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2020, 'Mitsubishi', 'Mirage G4', 'Sedan 4-Door'],
    [2020, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2020, 'Mitsubishi', 'Outlander PHEV', 'SUV 4-Door'],
    [2020, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2020, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2020, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2020, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2020, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2020, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2020, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2020, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2020, 'Nissan', 'Kicks', 'SUV 4-Door'],
    [2020, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2020, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2020, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2020, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2020, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2020, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2020, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2020, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2020, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2020, 'Nissan', 'Qashqai', 'SUV 4-Door'],
    [2020, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2020, 'Nissan', 'Rogue Sport', 'SUV 4-Door'],
    [2020, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2020, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2020, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2020, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2020, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2020, 'Polestar', 'Polestar 1', 'Coupe 2-Door'],
    [2020, 'Porsche', '911', 'Convertible 2-Door'],
    [2020, 'Porsche', '911', 'Coupe 2-Door'],
    [2020, 'Porsche', '718 Boxster', 'Convertible 2-Door'],
    [2020, 'Porsche', '718 Cayman', 'Hatchback 2-Door'],
    [2020, 'Porsche', '718 Spyder', 'Convertible 2-Door'],
    [2020, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2020, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2020, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2020, 'Porsche', 'Panamera', 'Wagon 4-Door'],
    [2020, 'Porsche', 'Taycan', 'Sedan 4-Door'],
    [2020, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2020, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2020, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2020, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2020, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2020, 'Ram', '1500 Classic', 'Crew Cab Pickup 4-Door'],
    [2020, 'Ram', '1500 Classic', 'Extended Cab Pickup 4-Door'],
    [2020, 'Ram', '1500 Classic', 'Standard Cab Pickup 2-Door'],
    [2020, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 3-Door'],
    [2020, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2020, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2020, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 2-Door'],
    [2020, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 3-Door'],
    [2020, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 3-Door'],
    [2020, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2020, 'Ram', 'ProMaster City', 'Mini Cargo Van 4-Door'],
    [2020, 'Ram', 'ProMaster City', 'Mini Passenger Van 4-Door'],
    [2020, 'Rolls-Royce', 'Cullinan', 'SUV 4-Door'],
    [2020, 'Rolls-Royce', 'Dawn', 'Convertible 2-Door'],
    [2020, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2020, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2020, 'Rolls-Royce', 'Wraith', 'Coupe 2-Door'],
    [2020, 'Subaru', 'Ascent', 'SUV 4-Door'],
    [2020, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2020, 'Subaru', 'Crosstrek', 'SUV 4-Door'],
    [2020, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2020, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2020, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2020, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2020, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2020, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2020, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2020, 'Tesla', '3', 'Sedan 4-Door'],
    [2020, 'Tesla', 'S', 'Sedan 4-Door'],
    [2020, 'Tesla', 'X', 'SUV 4-Door'],
    [2020, 'Tesla', 'Y', 'SUV 4-Door'],
    [2020, 'Toyota', '86', 'Coupe 2-Door'],
    [2020, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2020, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2020, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2020, 'Toyota', 'C-HR', 'SUV 4-Door'],
    [2020, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [2020, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2020, 'Toyota', 'GR Supra', 'Hatchback 2-Door'],
    [2020, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2020, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2020, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2020, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2020, 'Toyota', 'Prius AWD-e', 'Hatchback 4-Door'],
    [2020, 'Toyota', 'Prius Prime', 'Hatchback 4-Door'],
    [2020, 'Toyota', 'Prius Prime', 'Sedan 4-Door'],
    [2020, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2020, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2020, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2020, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2020, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2020, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2020, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2020, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2020, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2020, 'Volkswagen', 'Arteon', 'Hatchback 4-Door'],
    [2020, 'Volkswagen', 'Atlas', 'SUV 4-Door'],
    [2020, 'Volkswagen', 'Atlas Cross Sport', 'SUV 4-Door'],
    [2020, 'Volkswagen', 'e-Golf', 'Hatchback 4-Door'],
    [2020, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2020, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2020, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2020, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2020, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2020, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2020, 'Volvo', 'S90', 'Sedan 4-Door'],
    [2020, 'Volvo', 'V60', 'Sedan 4-Door'],
    [2020, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2020, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2020, 'Volvo', 'V90', 'Wagon 4-Door'],
    [2020, 'Volvo', 'V90 Cross Country', 'Wagon 4-Door'],
    [2020, 'Volvo', 'XC40', 'SUV 4-Door'],
    [2020, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2020, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2019, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2019, 'Acura', 'MDX', 'SUV 4-Door'],
    [2019, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2019, 'Acura', 'RDX', 'SUV 4-Door'],
    [2019, 'Acura', 'RLX', 'Sedan 4-Door'],
    [2019, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2019, 'Alfa Romeo', '4C', 'Convertible 2-Door'],
    [2019, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [2019, 'Alfa Romeo', 'Stelvio', 'SUV 4-Door'],
    [2019, 'Aston Martin', 'DB11', 'Convertible 2-Door'],
    [2019, 'Aston Martin', 'DB11', 'Coupe 2-Door'],
    [2019, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2019, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2019, 'Aston Martin', 'Vantage', 'Hatchback 2-Door'],
    [2019, 'Audi', 'A3', 'Convertible 2-Door'],
    [2019, 'Audi', 'A3', 'Sedan 4-Door'],
    [2019, 'Audi', 'A3 Quattro', 'Convertible 2-Door'],
    [2019, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2019, 'Audi', 'A4', 'Sedan 4-Door'],
    [2019, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2019, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2019, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2019, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2019, 'Audi', 'A5 Sportback', 'Hatchback 4-Door'],
    [2019, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2019, 'Audi', 'A7 Sportback', 'Hatchback 4-Door'],
    [2019, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2019, 'Audi', 'e-tron Quattro', 'SUV 4-Door'],
    [2019, 'Audi', 'Q3', 'SUV 4-Door'],
    [2019, 'Audi', 'Q5', 'SUV 4-Door'],
    [2019, 'Audi', 'Q7', 'SUV 4-Door'],
    [2019, 'Audi', 'Q8', 'SUV 4-Door'],
    [2019, 'Audi', 'RS3', 'Sedan 4-Door'],
    [2019, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2019, 'Audi', 'RS5 Sportback', 'Hatchback 4-Door'],
    [2019, 'Audi', 'S3', 'Sedan 4-Door'],
    [2019, 'Audi', 'S4', 'Sedan 4-Door'],
    [2019, 'Audi', 'S5', 'Convertible 2-Door'],
    [2019, 'Audi', 'S5', 'Coupe 2-Door'],
    [2019, 'Audi', 'S5 Sportback', 'Hatchback 4-Door'],
    [2019, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2019, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2019, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2019, 'Audi', 'TT RS Quattro', 'Coupe 2-Door'],
    [2019, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2019, 'Bentley', 'Bentayga', 'SUV 4-Door'],
    [2019, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2019, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2019, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2019, 'BMW', '230i', 'Convertible 2-Door'],
    [2019, 'BMW', '230i', 'Coupe 2-Door'],
    [2019, 'BMW', '230i xDrive', 'Convertible 2-Door'],
    [2019, 'BMW', '230i xDrive', 'Coupe 2-Door'],
    [2019, 'BMW', '330i', 'Sedan 4-Door'],
    [2019, 'BMW', '330i GT xDrive', 'Hatchback 4-Door'],
    [2019, 'BMW', '330i xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', '330i xDrive', 'Wagon 4-Door'],
    [2019, 'BMW', '340i GT xDrive', 'Hatchback 4-Door'],
    [2019, 'BMW', '430i', 'Convertible 2-Door'],
    [2019, 'BMW', '430i', 'Coupe 2-Door'],
    [2019, 'BMW', '430i Gran Coupe', 'Hatchback 4-Door'],
    [2019, 'BMW', '430i xDrive', 'Convertible 2-Door'],
    [2019, 'BMW', '430i xDrive', 'Coupe 2-Door'],
    [2019, 'BMW', '430i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2019, 'BMW', '440i', 'Convertible 2-Door'],
    [2019, 'BMW', '440i', 'Coupe 2-Door'],
    [2019, 'BMW', '440i Gran Coupe', 'Hatchback 4-Door'],
    [2019, 'BMW', '440i xDrive', 'Convertible 2-Door'],
    [2019, 'BMW', '440i xDrive', 'Coupe 2-Door'],
    [2019, 'BMW', '440i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2019, 'BMW', '530e', 'Sedan 4-Door'],
    [2019, 'BMW', '530e xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', '530i', 'Sedan 4-Door'],
    [2019, 'BMW', '530i xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', '540i', 'Sedan 4-Door'],
    [2019, 'BMW', '540i xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', '640i Gran Coupe', 'Sedan 4-Door'],
    [2019, 'BMW', '640i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2019, 'BMW', '640i xDrive Gran Turismo', 'Hatchback 4-Door'],
    [2019, 'BMW', '650i Gran Coupe', 'Sedan 4-Door'],
    [2019, 'BMW', '650i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2019, 'BMW', '740e xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', '740i', 'Sedan 4-Door'],
    [2019, 'BMW', '740i xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', '750i', 'Sedan 4-Door'],
    [2019, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', 'Alpina B6 xDrive Gran Coupe', 'Sedan 4-Door'],
    [2019, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2019, 'BMW', 'i3', 'Hatchback 4-Door'],
    [2019, 'BMW', 'i3s', 'Hatchback 4-Door'],
    [2019, 'BMW', 'i8', 'Convertible 2-Door'],
    [2019, 'BMW', 'i8', 'Coupe 2-Door'],
    [2019, 'BMW', 'M2', 'Coupe 2-Door'],
    [2019, 'BMW', 'M240i', 'Convertible 2-Door'],
    [2019, 'BMW', 'M240i', 'Coupe 2-Door'],
    [2019, 'BMW', 'M240i xDrive', 'Convertible 2-Door'],
    [2019, 'BMW', 'M240i xDrive', 'Coupe 2-Door'],
    [2019, 'BMW', 'M4', 'Convertible 2-Door'],
    [2019, 'BMW', 'M4', 'Coupe 2-Door'],
    [2019, 'BMW', 'M5', 'Sedan 4-Door'],
    [2019, 'BMW', 'M550i xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', 'M6 Gran Coupe', 'Sedan 4-Door'],
    [2019, 'BMW', 'M760i xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', 'M760Li xDrive', 'Sedan 4-Door'],
    [2019, 'BMW', 'M850i xDrive', 'Convertible 2-Door'],
    [2019, 'BMW', 'M850i xDrive', 'Coupe 2-Door'],
    [2019, 'BMW', 'X1', 'SUV 4-Door'],
    [2019, 'BMW', 'X2', 'SUV 4-Door'],
    [2019, 'BMW', 'X3', 'SUV 4-Door'],
    [2019, 'BMW', 'X4', 'SUV 4-Door'],
    [2019, 'BMW', 'X5', 'SUV 4-Door'],
    [2019, 'BMW', 'X6', 'SUV 4-Door'],
    [2019, 'BMW', 'X7', 'SUV 4-Door'],
    [2019, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2019, 'Buick', 'Cascada', 'Convertible 2-Door'],
    [2019, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2019, 'Buick', 'Encore', 'SUV 4-Door'],
    [2019, 'Buick', 'Envision', 'SUV 4-Door'],
    [2019, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2019, 'Buick', 'Regal Sportback', 'Hatchback 4-Door'],
    [2019, 'Buick', 'Regal TourX', 'Wagon 4-Door'],
    [2019, 'Cadillac', 'ATS', 'Coupe 2-Door'],
    [2019, 'Cadillac', 'CT6', 'Sedan 4-Door'],
    [2019, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2019, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2019, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2019, 'Cadillac', 'XT4', 'SUV 4-Door'],
    [2019, 'Cadillac', 'XT5', 'SUV 4-Door'],
    [2019, 'Cadillac', 'XTS', 'Hearse 4-Door'],
    [2019, 'Cadillac', 'XTS', 'Limousine 4-Door'],
    [2019, 'Cadillac', 'XTS', 'Sedan 4-Door'],
    [2019, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2019, 'Chevrolet', 'Bolt EV', 'Hatchback 4-Door'],
    [2019, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2019, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2019, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2019, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2019, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2019, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2019, 'Chevrolet', 'Cruze', 'Hatchback 4-Door'],
    [2019, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2019, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2019, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2019, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2019, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2019, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2019, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2019, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2019, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2019, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2019, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2019, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2019, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2019, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2019, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2019, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2019, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2019, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2019, 'Chevrolet', 'Silverado 1500 LD', 'Extended Cab Pickup 4-Door'],
    [2019, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2019, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2019, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2019, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2019, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2019, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2019, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2019, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2019, 'Chevrolet', 'Suburban 3500 HD', 'SUV 4-Door'],
    [2019, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2019, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2019, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2019, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2019, 'Chrysler', '300', 'Sedan 4-Door'],
    [2019, 'Chrysler', 'Pacifica', 'Mini Passenger Van 4-Door'],
    [2019, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2019, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2019, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2019, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2019, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2019, 'Ferrari', '488 GTB', 'Coupe 2-Door'],
    [2019, 'Ferrari', '488 Pista', 'Coupe 2-Door'],
    [2019, 'Ferrari', '488 Pista Spider', 'Convertible 2-Door'],
    [2019, 'Ferrari', '488 Spider', 'Convertible 2-Door'],
    [2019, 'Ferrari', '812 Superfast', 'Coupe 2-Door'],
    [2019, 'Ferrari', 'GTC4Lusso', 'Hatchback 2-Door'],
    [2019, 'Ferrari', 'GTC4Lusso T', 'Hatchback 2-Door'],
    [2019, 'Ferrari', 'Portofino', 'Convertible 2-Door'],
    [2019, 'Fiat', '500', 'Convertible 2-Door'],
    [2019, 'Fiat', '500', 'Hatchback 2-Door'],
    [2019, 'Fiat', '124 Spider', 'Convertible 2-Door'],
    [2019, 'Fiat', '500L', 'Hatchback 4-Door'],
    [2019, 'Fiat', '500X', 'SUV 4-Door'],
    [2019, 'Ford', 'EcoSport', 'SUV 4-Door'],
    [2019, 'Ford', 'Edge', 'SUV 4-Door'],
    [2019, 'Ford', 'Escape', 'SUV 4-Door'],
    [2019, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2019, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2019, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2019, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2019, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2019, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2019, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2019, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2019, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ford', 'F-450 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2019, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2019, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2019, 'Ford', 'Flex', 'SUV 4-Door'],
    [2019, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2019, 'Ford', 'GT', 'Coupe 2-Door'],
    [2019, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2019, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2019, 'Ford', 'Police Interceptor Sedan', 'Sedan 4-Door'],
    [2019, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2019, 'Ford', 'Police Responder Hybrid', 'Sedan 4-Door'],
    [2019, 'Ford', 'Ranger', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2019, 'Ford', 'SSV Plug-In Hybrid', 'Sedan 4-Door'],
    [2019, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2019, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2019, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2019, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2019, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2019, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2019, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2019, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2019, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2019, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2019, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2019, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2019, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2019, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2019, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2019, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2019, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2019, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 1500', 'Standard Cargo Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 1500', 'Standard Passenger Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2019, 'Freightliner', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2019, 'Freightliner', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2019, 'Freightliner', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2019, 'Freightliner', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2019, 'Genesis', 'G70', 'Sedan 4-Door'],
    [2019, 'Genesis', 'G80', 'Sedan 4-Door'],
    [2019, 'Genesis', 'G90', 'Sedan 4-Door'],
    [2019, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2019, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2019, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2019, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2019, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2019, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2019, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2019, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2019, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2019, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2019, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2019, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2019, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2019, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2019, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2019, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2019, 'GMC', 'Sierra 1500 Limited', 'Extended Cab Pickup 4-Door'],
    [2019, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2019, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2019, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2019, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2019, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2019, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2019, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2019, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2019, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2019, 'Honda', 'Civic', 'Hatchback 4-Door'],
    [2019, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2019, 'Honda', 'Clarity', 'Sedan 4-Door'],
    [2019, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2019, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2019, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2019, 'Honda', 'Insight', 'Sedan 4-Door'],
    [2019, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2019, 'Honda', 'Passport', 'SUV 4-Door'],
    [2019, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2019, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2019, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2019, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2019, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2019, 'Hyundai', 'Elantra GT', 'Hatchback 4-Door'],
    [2019, 'Hyundai', 'Ioniq', 'Hatchback 4-Door'],
    [2019, 'Hyundai', 'Kona', 'SUV 4-Door'],
    [2019, 'Hyundai', 'Kona Electric', 'SUV 4-Door'],
    [2019, 'Hyundai', 'Nexo', 'SUV 4-Door'],
    [2019, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2019, 'Hyundai', 'Santa Fe XL', 'SUV 4-Door'],
    [2019, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2019, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2019, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2019, 'Hyundai', 'Veloster N', 'Hatchback 3-Door'],
    [2019, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2019, 'INFINITI', 'Q60', 'Coupe 2-Door'],
    [2019, 'INFINITI', 'Q70', 'Sedan 4-Door'],
    [2019, 'INFINITI', 'Q70L', 'Sedan 4-Door'],
    [2019, 'INFINITI', 'QX30', 'SUV 4-Door'],
    [2019, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2019, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2019, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2019, 'Jaguar', 'E-Pace', 'SUV 4-Door'],
    [2019, 'Jaguar', 'F-Pace', 'SUV 4-Door'],
    [2019, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2019, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2019, 'Jaguar', 'I-Pace', 'SUV 4-Door'],
    [2019, 'Jaguar', 'XE', 'Sedan 4-Door'],
    [2019, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2019, 'Jaguar', 'XF', 'Wagon 4-Door'],
    [2019, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2019, 'Jaguar', 'XJR575', 'Sedan 4-Door'],
    [2019, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2019, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2019, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2019, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2019, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2019, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2019, 'Karma', 'Revero', 'Sedan 4-Door'],
    [2019, 'Kia', 'Cadenza', 'Sedan 4-Door'],
    [2019, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2019, 'Kia', 'K900', 'Sedan 4-Door'],
    [2019, 'Kia', 'Niro', 'SUV 4-Door'],
    [2019, 'Kia', 'Niro EV', 'SUV 4-Door'],
    [2019, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2019, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2019, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2019, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2019, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2019, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2019, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2019, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2019, 'Kia', 'Stinger', 'Hatchback 4-Door'],
    [2019, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2019, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2019, 'Lamborghini', 'Huracan', 'Convertible 2-Door'],
    [2019, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2019, 'Lamborghini', 'Urus', 'SUV 4-Door'],
    [2019, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2019, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2019, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2019, 'Land Rover', 'Range Rover Evoque', 'Convertible 2-Door'],
    [2019, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2019, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2019, 'Land Rover', 'Range Rover Velar', 'SUV 4-Door'],
    [2019, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2019, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2019, 'Lexus', 'GS F', 'Sedan 4-Door'],
    [2019, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2019, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2019, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2019, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2019, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2019, 'Lexus', 'LC500', 'Coupe 2-Door'],
    [2019, 'Lexus', 'LC500h', 'Coupe 2-Door'],
    [2019, 'Lexus', 'LS500', 'Sedan 4-Door'],
    [2019, 'Lexus', 'LS500h', 'Sedan 4-Door'],
    [2019, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2019, 'Lexus', 'NX300', 'SUV 4-Door'],
    [2019, 'Lexus', 'NX300h', 'SUV 4-Door'],
    [2019, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2019, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2019, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2019, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2019, 'Lexus', 'RX350L', 'SUV 4-Door'],
    [2019, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2019, 'Lexus', 'RX450hL', 'SUV 4-Door'],
    [2019, 'Lexus', 'UX200', 'SUV 4-Door'],
    [2019, 'Lexus', 'UX250h', 'SUV 4-Door'],
    [2019, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [2019, 'Lincoln', 'MKC', 'SUV 4-Door'],
    [2019, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2019, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2019, 'Lincoln', 'Nautilus', 'SUV 4-Door'],
    [2019, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2019, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2019, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2019, 'Maserati', 'GranTurismo', 'Convertible 2-Door'],
    [2019, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2019, 'Maserati', 'Levante', 'SUV 4-Door'],
    [2019, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2019, 'Mazda', '3', 'Hatchback 4-Door'],
    [2019, 'Mazda', '3', 'Sedan 4-Door'],
    [2019, 'Mazda', '6', 'Sedan 4-Door'],
    [2019, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2019, 'Mazda', 'CX-3', 'SUV 4-Door'],
    [2019, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2019, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2019, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2019, 'McLaren', '570GT', 'Coupe 2-Door'],
    [2019, 'McLaren', '570S', 'Convertible 2-Door'],
    [2019, 'McLaren', '570S', 'Coupe 2-Door'],
    [2019, 'McLaren', '600LT', 'Convertible 2-Door'],
    [2019, 'McLaren', '600LT', 'Coupe 2-Door'],
    [2019, 'McLaren', '720S', 'Convertible 2-Door'],
    [2019, 'McLaren', '720S', 'Coupe 2-Door'],
    [2019, 'McLaren', 'GT', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'A220', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'A250', 'Hatchback 4-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT 53', 'Hatchback 4-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT 63', 'Hatchback 4-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT 63 S', 'Hatchback 4-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT C', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT C', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT R', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'AMG GT S', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'B250', 'Hatchback 4-Door'],
    [2019, 'Mercedes-Benz', 'C300', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'C300', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'C300', 'Wagon 4-Door'],
    [2019, 'Mercedes-Benz', 'C43 AMG', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'C43 AMG', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'C43 AMG', 'Wagon 4-Door'],
    [2019, 'Mercedes-Benz', 'C63 AMG', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'C63 AMG S', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'C63 AMG S', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'C63 AMG S', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'CLS450', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'CLS53 AMG', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'CLS53 AMG S', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'E450', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'E450', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'E450', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'E450', 'Wagon 4-Door'],
    [2019, 'Mercedes-Benz', 'E53 AMG', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'E53 AMG', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'E53 AMG', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'E63 AMG S', 'Wagon 4-Door'],
    [2019, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2019, 'Mercedes-Benz', 'GLC350e', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLC43 AMG', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLC43 AMG', 'SUV Coupe 4-Door'],
    [2019, 'Mercedes-Benz', 'GLC63 AMG', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLC63 AMG', 'SUV Coupe 4-Door'],
    [2019, 'Mercedes-Benz', 'GLC63 AMG S', 'SUV Coupe 4-Door'],
    [2019, 'Mercedes-Benz', 'GLE400', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLE43 AMG', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLE43 AMG', 'SUV Coupe 4-Door'],
    [2019, 'Mercedes-Benz', 'GLE63 AMG', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV Coupe 4-Door'],
    [2019, 'Mercedes-Benz', 'GLS450', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLS550', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'GLS63 AMG', 'SUV 4-Door'],
    [2019, 'Mercedes-Benz', 'Maybach S560', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'Maybach S650', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2019, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2019, 'Mercedes-Benz', 'S450', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'S560', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'S560', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'S560', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'S560e', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'S63 AMG', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'S63 AMG', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'S65 AMG', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'S65 AMG', 'Coupe 2-Door'],
    [2019, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2019, 'Mercedes-Benz', 'SL450', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'SLC300', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'SLC43 AMG', 'Convertible 2-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Cargo Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 1500', 'Standard Passenger Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 2500', 'Crew Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 3500', 'Crew Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 3500XD', 'Crew Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Cargo Van U/K-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 4500', 'Extended Passenger Van U/K-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Cargo Van U/K-Door'],
    [2019, 'Mercedes-Benz', 'Sprinter 4500', 'Standard Passenger Van U/K-Door'],
    [2019, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2019, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2019, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2019, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2019, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2019, 'Mitsubishi', 'Eclipse Cross', 'SUV 4-Door'],
    [2019, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2019, 'Mitsubishi', 'Mirage G4', 'Sedan 4-Door'],
    [2019, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2019, 'Mitsubishi', 'Outlander PHEV', 'SUV 4-Door'],
    [2019, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2019, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2019, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2019, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2019, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2019, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2019, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2019, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2019, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2019, 'Nissan', 'Kicks', 'SUV 4-Door'],
    [2019, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2019, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2019, 'Nissan', 'Micra', 'Hatchback 4-Door'],
    [2019, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2019, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2019, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2019, 'Nissan', 'NV200', 'Mini Passenger Van 4-Door'],
    [2019, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2019, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2019, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2019, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2019, 'Nissan', 'Qashqai', 'SUV 4-Door'],
    [2019, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2019, 'Nissan', 'Rogue Sport', 'SUV 4-Door'],
    [2019, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2019, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2019, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2019, 'Nissan', 'TITAN', 'Standard Cab Pickup 2-Door'],
    [2019, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2019, 'Nissan', 'TITAN XD', 'Extended Cab Pickup 4-Door'],
    [2019, 'Nissan', 'TITAN XD', 'Standard Cab Pickup 2-Door'],
    [2019, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2019, 'Nissan', 'Versa Note', 'Hatchback 4-Door'],
    [2019, 'Porsche', '911', 'Convertible 2-Door'],
    [2019, 'Porsche', '911', 'Coupe 2-Door'],
    [2019, 'Porsche', '911', 'Targa 2-Door'],
    [2019, 'Porsche', '718 Boxster', 'Convertible 2-Door'],
    [2019, 'Porsche', '718 Cayman', 'Hatchback 2-Door'],
    [2019, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2019, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2019, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2019, 'Porsche', 'Panamera', 'Wagon 4-Door'],
    [2019, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2019, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2019, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2019, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2019, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2019, 'Ram', '1500 Classic', 'Crew Cab Pickup 4-Door'],
    [2019, 'Ram', '1500 Classic', 'Extended Cab Pickup 4-Door'],
    [2019, 'Ram', '1500 Classic', 'Standard Cab Pickup 2-Door'],
    [2019, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 3-Door'],
    [2019, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2019, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2019, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 2-Door'],
    [2019, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 3-Door'],
    [2019, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 3-Door'],
    [2019, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2019, 'Ram', 'ProMaster City', 'Mini Cargo Van 4-Door'],
    [2019, 'Ram', 'ProMaster City', 'Mini Passenger Van 4-Door'],
    [2019, 'Rolls-Royce', 'Cullinan', 'SUV 4-Door'],
    [2019, 'Rolls-Royce', 'Dawn', 'Convertible 2-Door'],
    [2019, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2019, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2019, 'Rolls-Royce', 'Wraith', 'Coupe 2-Door'],
    [2019, 'Smart', 'EQ fortwo', 'Convertible 2-Door'],
    [2019, 'Smart', 'EQ fortwo', 'Coupe 2-Door'],
    [2019, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2019, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2019, 'Subaru', 'Ascent', 'SUV 4-Door'],
    [2019, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2019, 'Subaru', 'Crosstrek', 'SUV 4-Door'],
    [2019, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2019, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2019, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2019, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2019, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2019, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2019, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2019, 'Tesla', '3', 'Sedan 4-Door'],
    [2019, 'Tesla', 'S', 'Sedan 4-Door'],
    [2019, 'Tesla', 'X', 'SUV 4-Door'],
    [2019, 'Toyota', '86', 'Coupe 2-Door'],
    [2019, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2019, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2019, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2019, 'Toyota', 'C-HR', 'SUV 4-Door'],
    [2019, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [2019, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2019, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2019, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2019, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2019, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2019, 'Toyota', 'Prius AWD-e', 'Hatchback 4-Door'],
    [2019, 'Toyota', 'Prius C', 'Hatchback 4-Door'],
    [2019, 'Toyota', 'Prius Prime', 'Hatchback 4-Door'],
    [2019, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2019, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2019, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2019, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2019, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2019, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2019, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2019, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2019, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2019, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2019, 'Volkswagen', 'Arteon', 'Hatchback 4-Door'],
    [2019, 'Volkswagen', 'Atlas', 'SUV 4-Door'],
    [2019, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2019, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2019, 'Volkswagen', 'e-Golf', 'Hatchback 4-Door'],
    [2019, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2019, 'Volkswagen', 'Golf Alltrack', 'Wagon 4-Door'],
    [2019, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2019, 'Volkswagen', 'Golf SportWagen', 'Wagon 4-Door'],
    [2019, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2019, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2019, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2019, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2019, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2019, 'Volvo', 'S90', 'Sedan 4-Door'],
    [2019, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2019, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2019, 'Volvo', 'V90', 'Wagon 4-Door'],
    [2019, 'Volvo', 'V90 Cross Country', 'Wagon 4-Door'],
    [2019, 'Volvo', 'XC40', 'SUV 4-Door'],
    [2019, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2019, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2018, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2018, 'Acura', 'MDX', 'SUV 4-Door'],
    [2018, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2018, 'Acura', 'RDX', 'SUV 4-Door'],
    [2018, 'Acura', 'RLX', 'Sedan 4-Door'],
    [2018, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2018, 'Alfa Romeo', '4C', 'Coupe 2-Door'],
    [2018, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [2018, 'Alfa Romeo', 'Stelvio', 'SUV 4-Door'],
    [2018, 'Aston Martin', 'DB11', 'Coupe 2-Door'],
    [2018, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2018, 'Aston Martin', 'Vanquish', 'Convertible 2-Door'],
    [2018, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2018, 'Aston Martin', 'Vantage', 'Hatchback 2-Door'],
    [2018, 'Audi', 'A3', 'Convertible 2-Door'],
    [2018, 'Audi', 'A3', 'Sedan 4-Door'],
    [2018, 'Audi', 'A3 Quattro', 'Convertible 2-Door'],
    [2018, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2018, 'Audi', 'A3 Sportback e-tron', 'Hatchback 4-Door'],
    [2018, 'Audi', 'A4', 'Sedan 4-Door'],
    [2018, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2018, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2018, 'Audi', 'A5', 'Convertible 2-Door'],
    [2018, 'Audi', 'A5', 'Sedan 4-Door'],
    [2018, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2018, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2018, 'Audi', 'A5 Sportback', 'Hatchback 4-Door'],
    [2018, 'Audi', 'A6', 'Sedan 4-Door'],
    [2018, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2018, 'Audi', 'A7', 'Sedan 4-Door'],
    [2018, 'Audi', 'A7 Quattro', 'Hatchback 4-Door'],
    [2018, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2018, 'Audi', 'Q3', 'SUV 4-Door'],
    [2018, 'Audi', 'Q3 Quattro', 'SUV 4-Door'],
    [2018, 'Audi', 'Q5', 'SUV 4-Door'],
    [2018, 'Audi', 'Q7', 'SUV 4-Door'],
    [2018, 'Audi', 'R8', 'Convertible 2-Door'],
    [2018, 'Audi', 'R8', 'Coupe 2-Door'],
    [2018, 'Audi', 'RS3', 'Sedan 4-Door'],
    [2018, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2018, 'Audi', 'RS7', 'Hatchback 4-Door'],
    [2018, 'Audi', 'S3', 'Sedan 4-Door'],
    [2018, 'Audi', 'S4', 'Sedan 4-Door'],
    [2018, 'Audi', 'S5', 'Convertible 2-Door'],
    [2018, 'Audi', 'S5', 'Coupe 2-Door'],
    [2018, 'Audi', 'S5 Sportback', 'Hatchback 4-Door'],
    [2018, 'Audi', 'S6', 'Sedan 4-Door'],
    [2018, 'Audi', 'S7', 'Hatchback 4-Door'],
    [2018, 'Audi', 'S8', 'Sedan 4-Door'],
    [2018, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2018, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2018, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2018, 'Audi', 'TT RS Quattro', 'Coupe 2-Door'],
    [2018, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2018, 'Bentley', 'Bentayga', 'SUV 4-Door'],
    [2018, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2018, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2018, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2018, 'BMW', '230i', 'Convertible 2-Door'],
    [2018, 'BMW', '230i', 'Coupe 2-Door'],
    [2018, 'BMW', '230i xDrive', 'Convertible 2-Door'],
    [2018, 'BMW', '230i xDrive', 'Coupe 2-Door'],
    [2018, 'BMW', '320i', 'Sedan 4-Door'],
    [2018, 'BMW', '320i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '328d', 'Sedan 4-Door'],
    [2018, 'BMW', '328d xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '328d xDrive', 'Wagon 4-Door'],
    [2018, 'BMW', '330e', 'Sedan 4-Door'],
    [2018, 'BMW', '330i', 'Sedan 4-Door'],
    [2018, 'BMW', '330i GT xDrive', 'Hatchback 4-Door'],
    [2018, 'BMW', '330i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '330i xDrive', 'Wagon 4-Door'],
    [2018, 'BMW', '340i', 'Sedan 4-Door'],
    [2018, 'BMW', '340i GT xDrive', 'Hatchback 4-Door'],
    [2018, 'BMW', '340i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '430i', 'Convertible 2-Door'],
    [2018, 'BMW', '430i', 'Coupe 2-Door'],
    [2018, 'BMW', '430i Gran Coupe', 'Hatchback 4-Door'],
    [2018, 'BMW', '430i xDrive', 'Convertible 2-Door'],
    [2018, 'BMW', '430i xDrive', 'Coupe 2-Door'],
    [2018, 'BMW', '430i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2018, 'BMW', '440i', 'Convertible 2-Door'],
    [2018, 'BMW', '440i', 'Coupe 2-Door'],
    [2018, 'BMW', '440i Gran Coupe', 'Hatchback 4-Door'],
    [2018, 'BMW', '440i xDrive', 'Convertible 2-Door'],
    [2018, 'BMW', '440i xDrive', 'Coupe 2-Door'],
    [2018, 'BMW', '440i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2018, 'BMW', '530e', 'Sedan 4-Door'],
    [2018, 'BMW', '530e xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '530e xDrive iPerformance', 'Sedan 4-Door'],
    [2018, 'BMW', '530i', 'Sedan 4-Door'],
    [2018, 'BMW', '530i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '540d xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '540i', 'Sedan 4-Door'],
    [2018, 'BMW', '540i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '640i', 'Convertible 2-Door'],
    [2018, 'BMW', '640i', 'Coupe 2-Door'],
    [2018, 'BMW', '640i Gran Coupe', 'Sedan 4-Door'],
    [2018, 'BMW', '640i xDrive', 'Convertible 2-Door'],
    [2018, 'BMW', '640i xDrive', 'Coupe 2-Door'],
    [2018, 'BMW', '640i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2018, 'BMW', '640i xDrive Gran Turismo', 'Hatchback 4-Door'],
    [2018, 'BMW', '650i', 'Convertible 2-Door'],
    [2018, 'BMW', '650i', 'Coupe 2-Door'],
    [2018, 'BMW', '650i Gran Coupe', 'Sedan 4-Door'],
    [2018, 'BMW', '650i xDrive', 'Convertible 2-Door'],
    [2018, 'BMW', '650i xDrive', 'Coupe 2-Door'],
    [2018, 'BMW', '650i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2018, 'BMW', '740e xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '740i', 'Sedan 4-Door'],
    [2018, 'BMW', '740i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '750i', 'Sedan 4-Door'],
    [2018, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', 'Alpina B6 xDrive Gran Coupe', 'Sedan 4-Door'],
    [2018, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2018, 'BMW', 'i3', 'Hatchback 4-Door'],
    [2018, 'BMW', 'i3', 'Sedan 4-Door'],
    [2018, 'BMW', 'i3s', 'Hatchback 4-Door'],
    [2018, 'BMW', 'M2', 'Coupe 2-Door'],
    [2018, 'BMW', 'M240i', 'Convertible 2-Door'],
    [2018, 'BMW', 'M240i', 'Coupe 2-Door'],
    [2018, 'BMW', 'M240i xDrive', 'Convertible 2-Door'],
    [2018, 'BMW', 'M240i xDrive', 'Coupe 2-Door'],
    [2018, 'BMW', 'M3', 'Sedan 4-Door'],
    [2018, 'BMW', 'M4', 'Convertible 2-Door'],
    [2018, 'BMW', 'M4', 'Coupe 2-Door'],
    [2018, 'BMW', 'M5', 'Sedan 4-Door'],
    [2018, 'BMW', 'M550i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', 'M6', 'Convertible 2-Door'],
    [2018, 'BMW', 'M6 Gran Coupe', 'Sedan 4-Door'],
    [2018, 'BMW', 'M760i xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', 'M760Li xDrive', 'Sedan 4-Door'],
    [2018, 'BMW', 'X1', 'SUV 4-Door'],
    [2018, 'BMW', 'X2', 'SUV 4-Door'],
    [2018, 'BMW', 'X3', 'SUV 4-Door'],
    [2018, 'BMW', 'X4', 'SUV 4-Door'],
    [2018, 'BMW', 'X5', 'SUV 4-Door'],
    [2018, 'BMW', 'X6', 'SUV 4-Door'],
    [2018, 'Bugatti', 'Chiron', 'Coupe 2-Door'],
    [2018, 'Buick', 'Cascada', 'Convertible 2-Door'],
    [2018, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2018, 'Buick', 'Enclave Avenir', 'SUV 4-Door'],
    [2018, 'Buick', 'Encore', 'SUV 4-Door'],
    [2018, 'Buick', 'Envision', 'SUV 4-Door'],
    [2018, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2018, 'Buick', 'Regal Sportback', 'Hatchback 4-Door'],
    [2018, 'Buick', 'Regal TourX', 'Wagon 4-Door'],
    [2018, 'Cadillac', 'ATS', 'Coupe 2-Door'],
    [2018, 'Cadillac', 'ATS', 'Sedan 4-Door'],
    [2018, 'Cadillac', 'CT6', 'Sedan 4-Door'],
    [2018, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2018, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2018, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2018, 'Cadillac', 'XT5', 'SUV 4-Door'],
    [2018, 'Cadillac', 'XTS', 'Hearse 4-Door'],
    [2018, 'Cadillac', 'XTS', 'Limousine 4-Door'],
    [2018, 'Cadillac', 'XTS', 'Sedan 4-Door'],
    [2018, 'Chanje', 'V8100', 'Standard Passenger Van U/K-Door'],
    [2018, 'Chevrolet', 'Bolt EV', 'Hatchback 4-Door'],
    [2018, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2018, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2018, 'Chevrolet', 'City Express', 'Mini Cargo Van 4-Door'],
    [2018, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2018, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2018, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2018, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2018, 'Chevrolet', 'Cruze', 'Hatchback 4-Door'],
    [2018, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2018, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2018, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2018, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2018, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2018, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2018, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2018, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2018, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2018, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 4-Door'],
    [2018, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2018, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2018, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2018, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2018, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2018, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2018, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2018, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2018, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2018, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2018, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2018, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2018, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2018, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2018, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2018, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2018, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2018, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2018, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2018, 'Chevrolet', 'Suburban 3500 HD', 'SUV 4-Door'],
    [2018, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2018, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2018, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2018, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2018, 'Chrysler', '300', 'Sedan 4-Door'],
    [2018, 'Chrysler', 'Pacifica', 'Mini Passenger Van 4-Door'],
    [2018, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2018, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2018, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2018, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2018, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2018, 'Ferrari', '488 GTB', 'Coupe 2-Door'],
    [2018, 'Ferrari', '488 Spider', 'Convertible 2-Door'],
    [2018, 'Ferrari', '812 Superfast', 'Coupe 2-Door'],
    [2018, 'Ferrari', 'GTC4Lusso', 'Hatchback 2-Door'],
    [2018, 'Ferrari', 'GTC4Lusso T', 'Hatchback 2-Door'],
    [2018, 'Ferrari', 'Portofino', 'Convertible 2-Door'],
    [2018, 'Fiat', '500', 'Convertible 2-Door'],
    [2018, 'Fiat', '500', 'Hatchback 2-Door'],
    [2018, 'Fiat', '124 Spider', 'Convertible 2-Door'],
    [2018, 'Fiat', '500L', 'Hatchback 4-Door'],
    [2018, 'Fiat', '500X', 'SUV 4-Door'],
    [2018, 'Ford', 'C-Max', 'Hatchback 4-Door'],
    [2018, 'Ford', 'EcoSport', 'SUV 4-Door'],
    [2018, 'Ford', 'Edge', 'SUV 4-Door'],
    [2018, 'Ford', 'Escape', 'SUV 4-Door'],
    [2018, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2018, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2018, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2018, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2018, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2018, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2018, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2018, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2018, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2018, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2018, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2018, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2018, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2018, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2018, 'Ford', 'Flex', 'SUV 4-Door'],
    [2018, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2018, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2018, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2018, 'Ford', 'GT', 'Coupe 2-Door'],
    [2018, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2018, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2018, 'Ford', 'Police Interceptor Sedan', 'Sedan 4-Door'],
    [2018, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2018, 'Ford', 'Special Service Police Sedan', 'Sedan 4-Door'],
    [2018, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2018, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2018, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2018, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2018, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2018, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2018, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2018, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2018, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2018, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2018, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2018, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2018, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2018, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2018, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2018, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2018, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2018, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2018, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2018, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2018, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2018, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2018, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2018, 'Freightliner', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2018, 'Freightliner', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2018, 'Genesis', 'G80', 'Sedan 4-Door'],
    [2018, 'Genesis', 'G90', 'Sedan 4-Door'],
    [2018, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2018, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2018, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2018, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2018, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2018, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2018, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2018, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2018, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2018, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2018, 'GMC', 'Savana 3500', 'Extended Passenger Van 4-Door'],
    [2018, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2018, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2018, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2018, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2018, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2018, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2018, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2018, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2018, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2018, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2018, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2018, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2018, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2018, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2018, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2018, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2018, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2018, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2018, 'Honda', 'Civic', 'Hatchback 4-Door'],
    [2018, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2018, 'Honda', 'Clarity', 'Sedan 4-Door'],
    [2018, 'Honda', 'Clarity Plug-In Hybrid', 'Sedan 4-Door'],
    [2018, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2018, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2018, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2018, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2018, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2018, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2018, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2018, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2018, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2018, 'Hyundai', 'Elantra GT', 'Hatchback 4-Door'],
    [2018, 'Hyundai', 'Ioniq', 'Hatchback 4-Door'],
    [2018, 'Hyundai', 'Kona', 'SUV 4-Door'],
    [2018, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2018, 'Hyundai', 'Santa Fe Sport', 'SUV 4-Door'],
    [2018, 'Hyundai', 'Santa Fe XL', 'SUV 4-Door'],
    [2018, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2018, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2018, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2018, 'INFINITI', 'Q60', 'Coupe 2-Door'],
    [2018, 'INFINITI', 'Q70', 'Sedan 4-Door'],
    [2018, 'INFINITI', 'Q70L', 'Sedan 4-Door'],
    [2018, 'INFINITI', 'QX30', 'SUV 4-Door'],
    [2018, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2018, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2018, 'Jaguar', 'E-Pace', 'SUV 4-Door'],
    [2018, 'Jaguar', 'F-Pace', 'SUV 4-Door'],
    [2018, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2018, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2018, 'Jaguar', 'XE', 'Sedan 4-Door'],
    [2018, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2018, 'Jaguar', 'XF', 'Wagon 4-Door'],
    [2018, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2018, 'Jaguar', 'XJR575', 'Sedan 4-Door'],
    [2018, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2018, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2018, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2018, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2018, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2018, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2018, 'Jeep', 'Wrangler JK', 'SUV 2-Door'],
    [2018, 'Jeep', 'Wrangler JK', 'SUV 4-Door'],
    [2018, 'Karma', 'Revero', 'Sedan 4-Door'],
    [2018, 'Kia', 'Cadenza', 'Sedan 4-Door'],
    [2018, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2018, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2018, 'Kia', 'Niro', 'SUV 4-Door'],
    [2018, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2018, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2018, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2018, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2018, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2018, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2018, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2018, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2018, 'Kia', 'Stinger', 'Hatchback 4-Door'],
    [2018, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2018, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2018, 'Lamborghini', 'Huracan', 'Convertible 2-Door'],
    [2018, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2018, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2018, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2018, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2018, 'Land Rover', 'Range Rover Evoque', 'Convertible 2-Door'],
    [2018, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2018, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2018, 'Land Rover', 'Range Rover Velar', 'SUV 4-Door'],
    [2018, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2018, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2018, 'Lexus', 'GS F', 'Sedan 4-Door'],
    [2018, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2018, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2018, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2018, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2018, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2018, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2018, 'Lexus', 'LC500', 'Coupe 2-Door'],
    [2018, 'Lexus', 'LC500h', 'Coupe 2-Door'],
    [2018, 'Lexus', 'LS500', 'Sedan 4-Door'],
    [2018, 'Lexus', 'LS500h', 'Sedan 4-Door'],
    [2018, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2018, 'Lexus', 'NX300', 'SUV 4-Door'],
    [2018, 'Lexus', 'NX300h', 'SUV 4-Door'],
    [2018, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2018, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2018, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2018, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2018, 'Lexus', 'RX350L', 'SUV 4-Door'],
    [2018, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2018, 'Lexus', 'RX450hL', 'SUV 4-Door'],
    [2018, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [2018, 'Lincoln', 'MKC', 'SUV 4-Door'],
    [2018, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2018, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2018, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2018, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2018, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2018, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2018, 'Maserati', 'GranTurismo', 'Convertible 2-Door'],
    [2018, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2018, 'Maserati', 'Levante', 'SUV 4-Door'],
    [2018, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2018, 'Mazda', '3', 'Hatchback 4-Door'],
    [2018, 'Mazda', '3', 'Sedan 4-Door'],
    [2018, 'Mazda', '6', 'Sedan 4-Door'],
    [2018, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2018, 'Mazda', 'CX-3', 'SUV 4-Door'],
    [2018, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2018, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2018, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2018, 'McLaren', '570GT', 'Coupe 2-Door'],
    [2018, 'McLaren', '570S', 'Convertible 2-Door'],
    [2018, 'McLaren', '570S', 'Coupe 2-Door'],
    [2018, 'McLaren', '720S', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'AMG GT', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'AMG GT', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'AMG GT C', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'AMG GT C', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'AMG GT R', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'AMG GT S', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'B250', 'Hatchback 4-Door'],
    [2018, 'Mercedes-Benz', 'C300', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'C300', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'C350e', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'C43 AMG', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'C43 AMG', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'C63 AMG', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'C63 AMG S', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'C63 AMG S', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'C63 AMG S', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'CLS63 AMG S', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'E400', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'E400', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'E400', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'E400', 'Wagon 4-Door'],
    [2018, 'Mercedes-Benz', 'E43 AMG', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'E63 AMG S', 'Wagon 4-Door'],
    [2018, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'G550 4x4', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'G65 AMG', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2018, 'Mercedes-Benz', 'GLC350e', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLC43 AMG', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLC43 AMG', 'SUV Coupe 4-Door'],
    [2018, 'Mercedes-Benz', 'GLC63 AMG', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLC63 AMG', 'SUV Coupe 4-Door'],
    [2018, 'Mercedes-Benz', 'GLC63 AMG S', 'SUV Coupe 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE350', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE400', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE43 AMG', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE43 AMG', 'SUV Coupe 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE550', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE550e', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE63 AMG', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV Coupe 4-Door'],
    [2018, 'Mercedes-Benz', 'GLS450', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLS550', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'GLS63 AMG', 'SUV 4-Door'],
    [2018, 'Mercedes-Benz', 'Maybach S560', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'Maybach S650', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2018, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2018, 'Mercedes-Benz', 'S450', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'S560', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'S560', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'S560', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'S63 AMG', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'S63 AMG', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'S65 AMG', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'S65 AMG', 'Coupe 2-Door'],
    [2018, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2018, 'Mercedes-Benz', 'SL450', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'SLC300', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'SLC43 AMG', 'Convertible 2-Door'],
    [2018, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2018, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2018, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2018, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2018, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2018, 'Mercedes-Benz', 'Sprinter 3500XD', 'Extended Cargo Van 3-Door'],
    [2018, 'Mercedes-Benz', 'Sprinter 3500XD', 'Standard Cargo Van 3-Door'],
    [2018, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2018, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2018, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2018, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2018, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2018, 'Mitsubishi', 'Eclipse Cross', 'SUV 4-Door'],
    [2018, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2018, 'Mitsubishi', 'Mirage G4', 'Sedan 4-Door'],
    [2018, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2018, 'Mitsubishi', 'Outlander PHEV', 'SUV 4-Door'],
    [2018, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2018, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2018, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2018, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2018, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2018, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2018, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2018, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2018, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2018, 'Nissan', 'Kicks', 'SUV 4-Door'],
    [2018, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2018, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2018, 'Nissan', 'Micra', 'Hatchback 4-Door'],
    [2018, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2018, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2018, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2018, 'Nissan', 'NV200', 'Mini Passenger Van 4-Door'],
    [2018, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2018, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2018, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2018, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2018, 'Nissan', 'Qashqai', 'SUV 4-Door'],
    [2018, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2018, 'Nissan', 'Rogue Sport', 'SUV 4-Door'],
    [2018, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2018, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2018, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2018, 'Nissan', 'TITAN', 'Standard Cab Pickup 2-Door'],
    [2018, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2018, 'Nissan', 'TITAN XD', 'Extended Cab Pickup 4-Door'],
    [2018, 'Nissan', 'TITAN XD', 'Standard Cab Pickup 2-Door'],
    [2018, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2018, 'Nissan', 'Versa Note', 'Hatchback 4-Door'],
    [2018, 'Porsche', '911', 'Convertible 2-Door'],
    [2018, 'Porsche', '911', 'Coupe 2-Door'],
    [2018, 'Porsche', '911', 'Targa 2-Door'],
    [2018, 'Porsche', '718 Boxster', 'Convertible 2-Door'],
    [2018, 'Porsche', '718 Cayman', 'Hatchback 2-Door'],
    [2018, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2018, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2018, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2018, 'Porsche', 'Panamera', 'Wagon 4-Door'],
    [2018, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2018, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2018, 'Ram', '1500', 'Standard Cab Pickup 2-Door'],
    [2018, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2018, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2018, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2018, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2018, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2018, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2018, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2018, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2018, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 2-Door'],
    [2018, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2018, 'Ram', 'ProMaster City', 'Mini Cargo Van 4-Door'],
    [2018, 'Ram', 'ProMaster City', 'Mini Passenger Van 4-Door'],
    [2018, 'Rolls-Royce', 'Dawn', 'Convertible 2-Door'],
    [2018, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2018, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2018, 'Rolls-Royce', 'Wraith', 'Coupe 2-Door'],
    [2018, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2018, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2018, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2018, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2018, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2018, 'Subaru', 'Crosstrek', 'SUV 4-Door'],
    [2018, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2018, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2018, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2018, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2018, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2018, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2018, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2018, 'Tesla', '3', 'Sedan 4-Door'],
    [2018, 'Tesla', 'S', 'Sedan 4-Door'],
    [2018, 'Tesla', 'X', 'SUV 4-Door'],
    [2018, 'Toyota', '86', 'Coupe 2-Door'],
    [2018, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2018, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2018, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2018, 'Toyota', 'C-HR', 'SUV 4-Door'],
    [2018, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2018, 'Toyota', 'Corolla iM', 'Hatchback 4-Door'],
    [2018, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2018, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2018, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2018, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2018, 'Toyota', 'Prius C', 'Hatchback 4-Door'],
    [2018, 'Toyota', 'Prius Prime', 'Hatchback 4-Door'],
    [2018, 'Toyota', 'Prius V', 'Wagon 4-Door'],
    [2018, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2018, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2018, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2018, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2018, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2018, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2018, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2018, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2018, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2018, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2018, 'Toyota', 'Yaris iA', 'Sedan 4-Door'],
    [2018, 'Volkswagen', 'Atlas', 'SUV 4-Door'],
    [2018, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2018, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2018, 'Volkswagen', 'e-Golf', 'Hatchback 4-Door'],
    [2018, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2018, 'Volkswagen', 'Golf Alltrack', 'Wagon 4-Door'],
    [2018, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2018, 'Volkswagen', 'Golf SportWagen', 'Wagon 4-Door'],
    [2018, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2018, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2018, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2018, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2018, 'Volkswagen', 'Tiguan Limited', 'SUV 4-Door'],
    [2018, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2018, 'Volvo', 'S60 Cross Country', 'Sedan 4-Door'],
    [2018, 'Volvo', 'S90', 'Sedan 4-Door'],
    [2018, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2018, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2018, 'Volvo', 'V90', 'Wagon 4-Door'],
    [2018, 'Volvo', 'V90 Cross Country', 'Wagon 4-Door'],
    [2018, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2018, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2017, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2017, 'Acura', 'MDX', 'SUV 4-Door'],
    [2017, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2017, 'Acura', 'RDX', 'SUV 4-Door'],
    [2017, 'Acura', 'RLX', 'Sedan 4-Door'],
    [2017, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2017, 'Alfa Romeo', '4C', 'Convertible 2-Door'],
    [2017, 'Alfa Romeo', '4C', 'Coupe 2-Door'],
    [2017, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [2017, 'Aston Martin', 'DB11', 'Coupe 2-Door'],
    [2017, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2017, 'Aston Martin', 'V12 Vantage', 'Convertible 2-Door'],
    [2017, 'Aston Martin', 'V12 Vantage', 'Hatchback 2-Door'],
    [2017, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2017, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2017, 'Aston Martin', 'Vanquish', 'Convertible 2-Door'],
    [2017, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2017, 'Audi', 'A3', 'Convertible 2-Door'],
    [2017, 'Audi', 'A3', 'Sedan 4-Door'],
    [2017, 'Audi', 'A3 Quattro', 'Convertible 2-Door'],
    [2017, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2017, 'Audi', 'A3 Sportback e-tron', 'Hatchback 4-Door'],
    [2017, 'Audi', 'A4', 'Sedan 4-Door'],
    [2017, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2017, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2017, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2017, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2017, 'Audi', 'A6', 'Sedan 4-Door'],
    [2017, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2017, 'Audi', 'A7 Quattro', 'Hatchback 4-Door'],
    [2017, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2017, 'Audi', 'Q3', 'SUV 4-Door'],
    [2017, 'Audi', 'Q3 Quattro', 'SUV 4-Door'],
    [2017, 'Audi', 'Q5', 'SUV 4-Door'],
    [2017, 'Audi', 'Q7', 'SUV 4-Door'],
    [2017, 'Audi', 'R8', 'Convertible 2-Door'],
    [2017, 'Audi', 'R8', 'Coupe 2-Door'],
    [2017, 'Audi', 'RS3', 'Sedan 4-Door'],
    [2017, 'Audi', 'RS7', 'Hatchback 4-Door'],
    [2017, 'Audi', 'S3', 'Sedan 4-Door'],
    [2017, 'Audi', 'S5', 'Convertible 2-Door'],
    [2017, 'Audi', 'S5', 'Coupe 2-Door'],
    [2017, 'Audi', 'S6', 'Sedan 4-Door'],
    [2017, 'Audi', 'S7', 'Hatchback 4-Door'],
    [2017, 'Audi', 'S8', 'Sedan 4-Door'],
    [2017, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2017, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2017, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2017, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2017, 'Bentley', 'Bentayga', 'SUV 4-Door'],
    [2017, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2017, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2017, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2017, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2017, 'BMW', '230i', 'Convertible 2-Door'],
    [2017, 'BMW', '230i', 'Coupe 2-Door'],
    [2017, 'BMW', '230i xDrive', 'Convertible 2-Door'],
    [2017, 'BMW', '230i xDrive', 'Coupe 2-Door'],
    [2017, 'BMW', '320i', 'Sedan 4-Door'],
    [2017, 'BMW', '320i xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '328d', 'Sedan 4-Door'],
    [2017, 'BMW', '328d xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '328d xDrive', 'Wagon 4-Door'],
    [2017, 'BMW', '330e', 'Sedan 4-Door'],
    [2017, 'BMW', '330i', 'Sedan 4-Door'],
    [2017, 'BMW', '330i GT xDrive', 'Hatchback 4-Door'],
    [2017, 'BMW', '330i xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '330i xDrive', 'Wagon 4-Door'],
    [2017, 'BMW', '340i', 'Sedan 4-Door'],
    [2017, 'BMW', '340i GT xDrive', 'Hatchback 4-Door'],
    [2017, 'BMW', '340i xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '430i', 'Convertible 2-Door'],
    [2017, 'BMW', '430i', 'Coupe 2-Door'],
    [2017, 'BMW', '430i Gran Coupe', 'Hatchback 4-Door'],
    [2017, 'BMW', '430i xDrive', 'Convertible 2-Door'],
    [2017, 'BMW', '430i xDrive', 'Coupe 2-Door'],
    [2017, 'BMW', '430i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2017, 'BMW', '440i', 'Convertible 2-Door'],
    [2017, 'BMW', '440i', 'Coupe 2-Door'],
    [2017, 'BMW', '440i Gran Coupe', 'Hatchback 4-Door'],
    [2017, 'BMW', '440i xDrive', 'Convertible 2-Door'],
    [2017, 'BMW', '440i xDrive', 'Coupe 2-Door'],
    [2017, 'BMW', '440i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2017, 'BMW', '530i', 'Sedan 4-Door'],
    [2017, 'BMW', '530i xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '535i GT', 'Hatchback 4-Door'],
    [2017, 'BMW', '535i GT xDrive', 'Hatchback 4-Door'],
    [2017, 'BMW', '540i', 'Sedan 4-Door'],
    [2017, 'BMW', '540i xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '550i GT xDrive', 'Hatchback 4-Door'],
    [2017, 'BMW', '640i', 'Convertible 2-Door'],
    [2017, 'BMW', '640i', 'Coupe 2-Door'],
    [2017, 'BMW', '640i Gran Coupe', 'Sedan 4-Door'],
    [2017, 'BMW', '640i xDrive', 'Convertible 2-Door'],
    [2017, 'BMW', '640i xDrive', 'Coupe 2-Door'],
    [2017, 'BMW', '640i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2017, 'BMW', '650i', 'Convertible 2-Door'],
    [2017, 'BMW', '650i', 'Coupe 2-Door'],
    [2017, 'BMW', '650i Gran Coupe', 'Sedan 4-Door'],
    [2017, 'BMW', '650i xDrive', 'Convertible 2-Door'],
    [2017, 'BMW', '650i xDrive', 'Coupe 2-Door'],
    [2017, 'BMW', '650i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2017, 'BMW', '740e xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '740i', 'Sedan 4-Door'],
    [2017, 'BMW', '740i xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '740Le xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '750i', 'Sedan 4-Door'],
    [2017, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', 'Alpina B6 xDrive Gran Coupe', 'Sedan 4-Door'],
    [2017, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2017, 'BMW', 'i3', 'Hatchback 4-Door'],
    [2017, 'BMW', 'i8', 'Coupe 2-Door'],
    [2017, 'BMW', 'M2', 'Coupe 2-Door'],
    [2017, 'BMW', 'M240i', 'Convertible 2-Door'],
    [2017, 'BMW', 'M240i', 'Coupe 2-Door'],
    [2017, 'BMW', 'M240i xDrive', 'Convertible 2-Door'],
    [2017, 'BMW', 'M240i xDrive', 'Coupe 2-Door'],
    [2017, 'BMW', 'M3', 'Sedan 4-Door'],
    [2017, 'BMW', 'M4', 'Convertible 2-Door'],
    [2017, 'BMW', 'M4', 'Coupe 2-Door'],
    [2017, 'BMW', 'M6', 'Convertible 2-Door'],
    [2017, 'BMW', 'M6', 'Coupe 2-Door'],
    [2017, 'BMW', 'M6 Gran Coupe', 'Sedan 4-Door'],
    [2017, 'BMW', 'M760i xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', 'M760Li xDrive', 'Sedan 4-Door'],
    [2017, 'BMW', 'X1', 'SUV 4-Door'],
    [2017, 'BMW', 'X3', 'SUV 4-Door'],
    [2017, 'BMW', 'X4', 'SUV 4-Door'],
    [2017, 'BMW', 'X5', 'SUV 4-Door'],
    [2017, 'BMW', 'X6', 'SUV 4-Door'],
    [2017, 'Buick', 'Cascada', 'Convertible 2-Door'],
    [2017, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2017, 'Buick', 'Encore', 'SUV 4-Door'],
    [2017, 'Buick', 'Envision', 'SUV 4-Door'],
    [2017, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2017, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2017, 'Buick', 'Verano', 'Sedan 4-Door'],
    [2017, 'Cadillac', 'ATS', 'Coupe 2-Door'],
    [2017, 'Cadillac', 'ATS', 'Sedan 4-Door'],
    [2017, 'Cadillac', 'CT6', 'Sedan 4-Door'],
    [2017, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2017, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2017, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2017, 'Cadillac', 'XT5', 'SUV 4-Door'],
    [2017, 'Cadillac', 'XTS', 'Hearse 4-Door'],
    [2017, 'Cadillac', 'XTS', 'Limousine 4-Door'],
    [2017, 'Cadillac', 'XTS', 'Sedan 4-Door'],
    [2017, 'Chanje', 'V8100', 'Standard Cargo Van U/K-Door'],
    [2017, 'Chevrolet', 'Bolt EV', 'Hatchback 4-Door'],
    [2017, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2017, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2017, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [2017, 'Chevrolet', 'City Express', 'Mini Cargo Van 4-Door'],
    [2017, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2017, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2017, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2017, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2017, 'Chevrolet', 'Cruze', 'Hatchback 4-Door'],
    [2017, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2017, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2017, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2017, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2017, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2017, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2017, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2017, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2017, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2017, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2017, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2017, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2017, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2017, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2017, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2017, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2017, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2017, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2017, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2017, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2017, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2017, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2017, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2017, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2017, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2017, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2017, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2017, 'Chevrolet', 'SS', 'Sedan 4-Door'],
    [2017, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2017, 'Chevrolet', 'Suburban 3500 HD', 'SUV 4-Door'],
    [2017, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2017, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2017, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2017, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2017, 'Chrysler', '200', 'Sedan 4-Door'],
    [2017, 'Chrysler', '300', 'Sedan 4-Door'],
    [2017, 'Chrysler', 'Pacifica', 'Mini Passenger Van 4-Door'],
    [2017, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2017, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2017, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2017, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2017, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2017, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2017, 'Ferrari', '488 GTB', 'Coupe 2-Door'],
    [2017, 'Ferrari', '488 Spider', 'Convertible 2-Door'],
    [2017, 'Ferrari', 'California T', 'Convertible 2-Door'],
    [2017, 'Ferrari', 'F12 Berlinetta', 'Coupe 2-Door'],
    [2017, 'Ferrari', 'F12tdf', 'Coupe 2-Door'],
    [2017, 'Ferrari', 'GTC4Lusso', 'Hatchback 2-Door'],
    [2017, 'Ferrari', 'LaFerrari', 'Convertible 2-Door'],
    [2017, 'Fiat', '500', 'Convertible 2-Door'],
    [2017, 'Fiat', '500', 'Hatchback 2-Door'],
    [2017, 'Fiat', '124 Spider', 'Convertible 2-Door'],
    [2017, 'Fiat', '500L', 'Hatchback 4-Door'],
    [2017, 'Fiat', '500X', 'SUV 4-Door'],
    [2017, 'Ford', 'C-Max', 'Hatchback 4-Door'],
    [2017, 'Ford', 'Edge', 'SUV 4-Door'],
    [2017, 'Ford', 'Escape', 'SUV 4-Door'],
    [2017, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2017, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2017, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2017, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2017, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2017, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2017, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2017, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2017, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2017, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2017, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2017, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2017, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2017, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2017, 'Ford', 'Flex', 'SUV 4-Door'],
    [2017, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2017, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2017, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2017, 'Ford', 'GT', 'Coupe 2-Door'],
    [2017, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2017, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2017, 'Ford', 'Police Interceptor Sedan', 'Sedan 4-Door'],
    [2017, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2017, 'Ford', 'Special Service Police Sedan', 'Sedan 4-Door'],
    [2017, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2017, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2017, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2017, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2017, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2017, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2017, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2017, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2017, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2017, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2017, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2017, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2017, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2017, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2017, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2017, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2017, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2017, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2017, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2017, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2017, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2017, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2017, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2017, 'Genesis', 'G80', 'Sedan 4-Door'],
    [2017, 'Genesis', 'G90', 'Sedan 4-Door'],
    [2017, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2017, 'GMC', 'Acadia Limited', 'SUV 4-Door'],
    [2017, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2017, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2017, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2017, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2017, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2017, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2017, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2017, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2017, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2017, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2017, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2017, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2017, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2017, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2017, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2017, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2017, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2017, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2017, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2017, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2017, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2017, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2017, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2017, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2017, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2017, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2017, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2017, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2017, 'Honda', 'Civic', 'Hatchback 4-Door'],
    [2017, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2017, 'Honda', 'Clarity', 'Sedan 4-Door'],
    [2017, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2017, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2017, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2017, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2017, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2017, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2017, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2017, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2017, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2017, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2017, 'Hyundai', 'Elantra GT', 'Hatchback 4-Door'],
    [2017, 'Hyundai', 'Ioniq', 'Hatchback 4-Door'],
    [2017, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2017, 'Hyundai', 'Santa Fe Sport', 'SUV 4-Door'],
    [2017, 'Hyundai', 'Santa Fe XL', 'SUV 4-Door'],
    [2017, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2017, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2017, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2017, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2017, 'INFINITI', 'Q60', 'Coupe 2-Door'],
    [2017, 'INFINITI', 'Q70', 'Sedan 4-Door'],
    [2017, 'INFINITI', 'Q70L', 'Sedan 4-Door'],
    [2017, 'INFINITI', 'QX30', 'SUV 4-Door'],
    [2017, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2017, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2017, 'INFINITI', 'QX70', 'SUV 4-Door'],
    [2017, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2017, 'Jaguar', 'F-Pace', 'SUV 4-Door'],
    [2017, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2017, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2017, 'Jaguar', 'XE', 'Sedan 4-Door'],
    [2017, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2017, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2017, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2017, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2017, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2017, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2017, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2017, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2017, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2017, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2017, 'Karma', 'Revero', 'Sedan 4-Door'],
    [2017, 'Kia', 'Cadenza', 'Sedan 4-Door'],
    [2017, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2017, 'Kia', 'Forte Koup', 'Coupe 2-Door'],
    [2017, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2017, 'Kia', 'K900', 'Sedan 4-Door'],
    [2017, 'Kia', 'Niro', 'SUV 4-Door'],
    [2017, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2017, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2017, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2017, 'Kia', 'Rondo', 'Hatchback 4-Door'],
    [2017, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2017, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2017, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2017, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2017, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2017, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2017, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2017, 'Lamborghini', 'Centenario', 'Convertible 2-Door'],
    [2017, 'Lamborghini', 'Centenario', 'Coupe 2-Door'],
    [2017, 'Lamborghini', 'Huracan', 'Convertible 2-Door'],
    [2017, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2017, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2017, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2017, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2017, 'Land Rover', 'Range Rover Evoque', 'Convertible 2-Door'],
    [2017, 'Land Rover', 'Range Rover Evoque', 'SUV 2-Door'],
    [2017, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2017, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2017, 'Lexus', 'CT200h', 'Hatchback 4-Door'],
    [2017, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2017, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2017, 'Lexus', 'GS F', 'Sedan 4-Door'],
    [2017, 'Lexus', 'GS200t', 'Sedan 4-Door'],
    [2017, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2017, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2017, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2017, 'Lexus', 'IS200t', 'Sedan 4-Door'],
    [2017, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2017, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2017, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2017, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2017, 'Lexus', 'NX200t', 'SUV 4-Door'],
    [2017, 'Lexus', 'NX300h', 'SUV 4-Door'],
    [2017, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2017, 'Lexus', 'RC200t', 'Coupe 2-Door'],
    [2017, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2017, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2017, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2017, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2017, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [2017, 'Lincoln', 'MKC', 'SUV 4-Door'],
    [2017, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2017, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2017, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2017, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2017, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2017, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2017, 'Maserati', 'GranTurismo', 'Convertible 2-Door'],
    [2017, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2017, 'Maserati', 'Levante', 'SUV 4-Door'],
    [2017, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2017, 'Mazda', '3', 'Hatchback 4-Door'],
    [2017, 'Mazda', '3', 'Sedan 4-Door'],
    [2017, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2017, 'Mazda', '6', 'Sedan 4-Door'],
    [2017, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2017, 'Mazda', 'CX-3', 'SUV 4-Door'],
    [2017, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2017, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2017, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2017, 'McLaren', '540C', 'Coupe 2-Door'],
    [2017, 'McLaren', '570GT', 'Coupe 2-Door'],
    [2017, 'McLaren', '570S', 'Coupe 2-Door'],
    [2017, 'McLaren', '650S', 'Convertible 2-Door'],
    [2017, 'McLaren', '650S', 'Coupe 2-Door'],
    [2017, 'McLaren', '675LT', 'Convertible 2-Door'],
    [2017, 'McLaren', '675LT', 'Coupe 2-Door'],
    [2017, 'McLaren', '720S', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'AMG GT', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'AMG GT S', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'B250', 'Hatchback 4-Door'],
    [2017, 'Mercedes-Benz', 'B250e', 'Hatchback 4-Door'],
    [2017, 'Mercedes-Benz', 'C300', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'C300', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'C350e', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'C43 AMG', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'C43 AMG', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'C63 AMG', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'C63 AMG S', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'C63 AMG S', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'C63 AMG S', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'CLS400', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'CLS63 AMG S', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'E400', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'E400', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'E400', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'E400', 'Wagon 4-Door'],
    [2017, 'Mercedes-Benz', 'E43 AMG', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'E550', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'E550', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'G550 4x4', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'G65 AMG', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2017, 'Mercedes-Benz', 'GLC43 AMG', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLC43 AMG', 'SUV Coupe 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE300d', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE350', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE400', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE43 AMG', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE43 AMG', 'SUV Coupe 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE550', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE550e', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE63 AMG', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV Coupe 4-Door'],
    [2017, 'Mercedes-Benz', 'GLS350d', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLS450', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLS550', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'GLS63 AMG', 'SUV 4-Door'],
    [2017, 'Mercedes-Benz', 'Maybach S550', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'Maybach S600', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2017, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2017, 'Mercedes-Benz', 'S550', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'S550', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'S550e', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'S63 AMG', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'S63 AMG', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'S65 AMG', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'S65 AMG', 'Coupe 2-Door'],
    [2017, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2017, 'Mercedes-Benz', 'SL450', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'SLC300', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'SLC43 AMG', 'Convertible 2-Door'],
    [2017, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2017, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2017, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2017, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2017, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2017, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2017, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2017, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2017, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2017, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2017, 'Mitsubishi', 'i-MiEV', 'Hatchback 4-Door'],
    [2017, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2017, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2017, 'Mitsubishi', 'Mirage G4', 'Sedan 4-Door'],
    [2017, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2017, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2017, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2017, 'Mobility Ventures', 'MV-1', 'Standard Passenger Van 4-Door'],
    [2017, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2017, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2017, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2017, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2017, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2017, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2017, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2017, 'Nissan', 'Juke', 'SUV 4-Door'],
    [2017, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2017, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2017, 'Nissan', 'Micra', 'Hatchback 4-Door'],
    [2017, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2017, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2017, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2017, 'Nissan', 'NV200', 'Mini Passenger Van 4-Door'],
    [2017, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2017, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2017, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2017, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2017, 'Nissan', 'Qashqai', 'SUV 4-Door'],
    [2017, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2017, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2017, 'Nissan', 'Rogue Sport', 'SUV 4-Door'],
    [2017, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2017, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2017, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2017, 'Nissan', 'TITAN', 'Standard Cab Pickup 2-Door'],
    [2017, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2017, 'Nissan', 'TITAN XD', 'Extended Cab Pickup 4-Door'],
    [2017, 'Nissan', 'TITAN XD', 'Standard Cab Pickup 2-Door'],
    [2017, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2017, 'Nissan', 'Versa Note', 'Hatchback 4-Door'],
    [2017, 'Porsche', '911', 'Convertible 2-Door'],
    [2017, 'Porsche', '911', 'Coupe 2-Door'],
    [2017, 'Porsche', '911', 'Targa 2-Door'],
    [2017, 'Porsche', '718 Boxster', 'Convertible 2-Door'],
    [2017, 'Porsche', '718 Cayman', 'Hatchback 2-Door'],
    [2017, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2017, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2017, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2017, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2017, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2017, 'Ram', '1500', 'Standard Cab Pickup 2-Door'],
    [2017, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2017, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2017, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2017, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2017, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2017, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2017, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2017, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2017, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 4-Door'],
    [2017, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2017, 'Ram', 'ProMaster City', 'Mini Cargo Van 4-Door'],
    [2017, 'Ram', 'ProMaster City', 'Mini Passenger Van 4-Door'],
    [2017, 'Rolls-Royce', 'Dawn', 'Convertible 2-Door'],
    [2017, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2017, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2017, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2017, 'Rolls-Royce', 'Wraith', 'Coupe 2-Door'],
    [2017, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2017, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2017, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2017, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2017, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2017, 'Subaru', 'Crosstrek', 'SUV 4-Door'],
    [2017, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2017, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2017, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2017, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2017, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2017, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2017, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2017, 'Tesla', '3', 'Sedan 4-Door'],
    [2017, 'Tesla', 'S', 'Sedan 4-Door'],
    [2017, 'Tesla', 'X', 'SUV 4-Door'],
    [2017, 'Toyota', '86', 'Coupe 2-Door'],
    [2017, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2017, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2017, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2017, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2017, 'Toyota', 'Corolla iM', 'Hatchback 4-Door'],
    [2017, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2017, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2017, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2017, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2017, 'Toyota', 'Prius C', 'Hatchback 4-Door'],
    [2017, 'Toyota', 'Prius Prime', 'Hatchback 4-Door'],
    [2017, 'Toyota', 'Prius V', 'Wagon 4-Door'],
    [2017, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2017, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2017, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2017, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2017, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2017, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2017, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2017, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2017, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2017, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2017, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2017, 'Toyota', 'Yaris iA', 'Sedan 4-Door'],
    [2017, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2017, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2017, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2017, 'Volkswagen', 'e-Golf', 'Hatchback 4-Door'],
    [2017, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2017, 'Volkswagen', 'Golf Alltrack', 'Wagon 4-Door'],
    [2017, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2017, 'Volkswagen', 'Golf SportWagen', 'Wagon 4-Door'],
    [2017, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2017, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2017, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2017, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2017, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2017, 'Volkswagen', 'Tiguan Limited', 'SUV 4-Door'],
    [2017, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2017, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2017, 'Volvo', 'S60 Cross Country', 'Sedan 4-Door'],
    [2017, 'Volvo', 'S90', 'Sedan 4-Door'],
    [2017, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2017, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2017, 'Volvo', 'V90', 'Wagon 4-Door'],
    [2017, 'Volvo', 'V90 Cross Country', 'Wagon 4-Door'],
    [2017, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2017, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2016, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2016, 'Acura', 'MDX', 'SUV 4-Door'],
    [2016, 'Acura', 'RDX', 'SUV 4-Door'],
    [2016, 'Acura', 'RLX', 'Sedan 4-Door'],
    [2016, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2016, 'Alfa Romeo', '4C', 'Convertible 2-Door'],
    [2016, 'Alfa Romeo', '4C', 'Coupe 2-Door'],
    [2016, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2016, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2016, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2016, 'Aston Martin', 'V12 Vantage', 'Convertible 2-Door'],
    [2016, 'Aston Martin', 'V12 Vantage', 'Hatchback 2-Door'],
    [2016, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2016, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2016, 'Aston Martin', 'Vanquish', 'Convertible 2-Door'],
    [2016, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2016, 'Audi', 'A3', 'Convertible 2-Door'],
    [2016, 'Audi', 'A3', 'Sedan 4-Door'],
    [2016, 'Audi', 'A3 e-tron', 'Sedan 4-Door'],
    [2016, 'Audi', 'A3 Quattro', 'Convertible 2-Door'],
    [2016, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2016, 'Audi', 'A3 Sportback e-tron', 'Hatchback 4-Door'],
    [2016, 'Audi', 'A4', 'Sedan 4-Door'],
    [2016, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2016, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2016, 'Audi', 'A5', 'Convertible 2-Door'],
    [2016, 'Audi', 'A5', 'Coupe 2-Door'],
    [2016, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2016, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2016, 'Audi', 'A6', 'Sedan 4-Door'],
    [2016, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2016, 'Audi', 'A7 Quattro', 'Hatchback 4-Door'],
    [2016, 'Audi', 'A8', 'Sedan 4-Door'],
    [2016, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2016, 'Audi', 'allroad', 'Wagon 4-Door'],
    [2016, 'Audi', 'Q3', 'SUV 4-Door'],
    [2016, 'Audi', 'Q3 Quattro', 'SUV 4-Door'],
    [2016, 'Audi', 'Q5', 'SUV 4-Door'],
    [2016, 'Audi', 'RS7', 'Hatchback 4-Door'],
    [2016, 'Audi', 'S3', 'Sedan 4-Door'],
    [2016, 'Audi', 'S4', 'Sedan 4-Door'],
    [2016, 'Audi', 'S5', 'Convertible 2-Door'],
    [2016, 'Audi', 'S5', 'Coupe 2-Door'],
    [2016, 'Audi', 'S6', 'Sedan 4-Door'],
    [2016, 'Audi', 'S7', 'Hatchback 4-Door'],
    [2016, 'Audi', 'S8', 'Sedan 4-Door'],
    [2016, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2016, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2016, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2016, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2016, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2016, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2016, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2016, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2016, 'BMW', '228i', 'Convertible 2-Door'],
    [2016, 'BMW', '228i', 'Coupe 2-Door'],
    [2016, 'BMW', '228i xDrive', 'Convertible 2-Door'],
    [2016, 'BMW', '228i xDrive', 'Coupe 2-Door'],
    [2016, 'BMW', '320i', 'Sedan 4-Door'],
    [2016, 'BMW', '320i xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', '328d', 'Sedan 4-Door'],
    [2016, 'BMW', '328d xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', '328d xDrive', 'Wagon 4-Door'],
    [2016, 'BMW', '328i', 'Sedan 4-Door'],
    [2016, 'BMW', '328i GT xDrive', 'Hatchback 4-Door'],
    [2016, 'BMW', '328i xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', '328i xDrive', 'Wagon 4-Door'],
    [2016, 'BMW', '330e', 'Sedan 4-Door'],
    [2016, 'BMW', '335i GT xDrive', 'Hatchback 4-Door'],
    [2016, 'BMW', '340i', 'Sedan 4-Door'],
    [2016, 'BMW', '340i xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', '428i', 'Convertible 2-Door'],
    [2016, 'BMW', '428i', 'Coupe 2-Door'],
    [2016, 'BMW', '428i Gran Coupe', 'Hatchback 4-Door'],
    [2016, 'BMW', '428i xDrive', 'Convertible 2-Door'],
    [2016, 'BMW', '428i xDrive', 'Coupe 2-Door'],
    [2016, 'BMW', '428i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2016, 'BMW', '435i', 'Convertible 2-Door'],
    [2016, 'BMW', '435i', 'Coupe 2-Door'],
    [2016, 'BMW', '435i Gran Coupe', 'Hatchback 4-Door'],
    [2016, 'BMW', '435i xDrive', 'Convertible 2-Door'],
    [2016, 'BMW', '435i xDrive', 'Coupe 2-Door'],
    [2016, 'BMW', '435i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2016, 'BMW', '528i', 'Sedan 4-Door'],
    [2016, 'BMW', '528i xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', '535d', 'Sedan 4-Door'],
    [2016, 'BMW', '535d xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', '535i', 'Sedan 4-Door'],
    [2016, 'BMW', '535i GT', 'Hatchback 4-Door'],
    [2016, 'BMW', '535i GT xDrive', 'Hatchback 4-Door'],
    [2016, 'BMW', '535i xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', '550i', 'Sedan 4-Door'],
    [2016, 'BMW', '550i GT xDrive', 'Hatchback 4-Door'],
    [2016, 'BMW', '550i xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', '640i', 'Convertible 2-Door'],
    [2016, 'BMW', '640i', 'Coupe 2-Door'],
    [2016, 'BMW', '640i Gran Coupe', 'Sedan 4-Door'],
    [2016, 'BMW', '640i xDrive', 'Convertible 2-Door'],
    [2016, 'BMW', '640i xDrive', 'Coupe 2-Door'],
    [2016, 'BMW', '640i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2016, 'BMW', '650i', 'Convertible 2-Door'],
    [2016, 'BMW', '650i', 'Coupe 2-Door'],
    [2016, 'BMW', '650i Gran Coupe', 'Sedan 4-Door'],
    [2016, 'BMW', '650i xDrive', 'Convertible 2-Door'],
    [2016, 'BMW', '650i xDrive', 'Coupe 2-Door'],
    [2016, 'BMW', '650i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2016, 'BMW', '740i', 'Sedan 4-Door'],
    [2016, 'BMW', '750i', 'Sedan 4-Door'],
    [2016, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2016, 'BMW', 'ActiveHybrid 5', 'Sedan 4-Door'],
    [2016, 'BMW', 'Alpina B6 Gran Coupe', 'Sedan 4-Door'],
    [2016, 'BMW', 'Alpina B6 xDrive Gran Coupe', 'Sedan 4-Door'],
    [2016, 'BMW', 'i3', 'Hatchback 4-Door'],
    [2016, 'BMW', 'i8', 'Coupe 2-Door'],
    [2016, 'BMW', 'M2', 'Coupe 2-Door'],
    [2016, 'BMW', 'M235i', 'Convertible 2-Door'],
    [2016, 'BMW', 'M235i', 'Coupe 2-Door'],
    [2016, 'BMW', 'M235i xDrive', 'Convertible 2-Door'],
    [2016, 'BMW', 'M235i xDrive', 'Coupe 2-Door'],
    [2016, 'BMW', 'M3', 'Sedan 4-Door'],
    [2016, 'BMW', 'M4', 'Convertible 2-Door'],
    [2016, 'BMW', 'M4', 'Coupe 2-Door'],
    [2016, 'BMW', 'M5', 'Sedan 4-Door'],
    [2016, 'BMW', 'M6', 'Convertible 2-Door'],
    [2016, 'BMW', 'M6', 'Coupe 2-Door'],
    [2016, 'BMW', 'M6 Gran Coupe', 'Sedan 4-Door'],
    [2016, 'BMW', 'X1', 'SUV 4-Door'],
    [2016, 'BMW', 'X3', 'SUV 4-Door'],
    [2016, 'BMW', 'X4', 'SUV 4-Door'],
    [2016, 'BMW', 'X5', 'SUV 4-Door'],
    [2016, 'BMW', 'X6', 'SUV 4-Door'],
    [2016, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2016, 'Buick', 'Cascada', 'Convertible 2-Door'],
    [2016, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2016, 'Buick', 'Encore', 'SUV 4-Door'],
    [2016, 'Buick', 'Envision', 'SUV 4-Door'],
    [2016, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2016, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2016, 'Buick', 'Verano', 'Sedan 4-Door'],
    [2016, 'Cadillac', 'ATS', 'Coupe 2-Door'],
    [2016, 'Cadillac', 'ATS', 'Sedan 4-Door'],
    [2016, 'Cadillac', 'CT6', 'Sedan 4-Door'],
    [2016, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2016, 'Cadillac', 'ELR', 'Coupe 2-Door'],
    [2016, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2016, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2016, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2016, 'Cadillac', 'XTS', 'Hearse 4-Door'],
    [2016, 'Cadillac', 'XTS', 'Limousine 4-Door'],
    [2016, 'Cadillac', 'XTS', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2016, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2016, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'City Express', 'Mini Cargo Van 4-Door'],
    [2016, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2016, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2016, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2016, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2016, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Cruze Limited', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2016, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2016, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2016, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2016, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2016, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2016, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2016, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2016, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2016, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2016, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2016, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2016, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Impala Limited', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Malibu Limited', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2016, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2016, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2016, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2016, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2016, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2016, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2016, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2016, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2016, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2016, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2016, 'Chevrolet', 'Spark EV', 'Hatchback 4-Door'],
    [2016, 'Chevrolet', 'SS', 'Sedan 4-Door'],
    [2016, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2016, 'Chevrolet', 'Suburban 3500 HD', 'SUV 4-Door'],
    [2016, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2016, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2016, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2016, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2016, 'Chrysler', '200', 'Sedan 4-Door'],
    [2016, 'Chrysler', '300', 'Sedan 4-Door'],
    [2016, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2016, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2016, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2016, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [2016, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2016, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2016, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2016, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2016, 'Ferrari', '488 GTB', 'Coupe 2-Door'],
    [2016, 'Ferrari', '488 Spider', 'Convertible 2-Door'],
    [2016, 'Ferrari', 'California T', 'Convertible 2-Door'],
    [2016, 'Ferrari', 'F12 Berlinetta', 'Coupe 2-Door'],
    [2016, 'Ferrari', 'F12tdf', 'Coupe 2-Door'],
    [2016, 'Ferrari', 'FF', 'Hatchback 2-Door'],
    [2016, 'Ferrari', 'LaFerrari', 'Convertible 2-Door'],
    [2016, 'Fiat', '500', 'Convertible 2-Door'],
    [2016, 'Fiat', '500', 'Hatchback 2-Door'],
    [2016, 'Fiat', '500L', 'Hatchback 4-Door'],
    [2016, 'Fiat', '500X', 'SUV 4-Door'],
    [2016, 'Ford', 'C-Max', 'Hatchback 4-Door'],
    [2016, 'Ford', 'Edge', 'SUV 4-Door'],
    [2016, 'Ford', 'Escape', 'SUV 4-Door'],
    [2016, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2016, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2016, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2016, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2016, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2016, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2016, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2016, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2016, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2016, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2016, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2016, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2016, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2016, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2016, 'Ford', 'Flex', 'SUV 4-Door'],
    [2016, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2016, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2016, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2016, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2016, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2016, 'Ford', 'Police Interceptor Sedan', 'Sedan 4-Door'],
    [2016, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2016, 'Ford', 'Special Service Police Sedan', 'Sedan 4-Door'],
    [2016, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2016, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2016, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2016, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2016, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2016, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2016, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2016, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2016, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2016, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2016, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2016, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2016, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2016, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2016, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2016, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2016, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2016, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2016, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2016, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2016, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2016, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2016, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2016, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2016, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2016, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2016, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2016, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2016, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2016, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2016, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2016, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2016, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2016, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2016, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2016, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2016, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2016, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2016, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2016, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2016, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2016, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2016, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2016, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2016, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2016, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2016, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2016, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2016, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2016, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2016, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2016, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2016, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2016, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2016, 'Honda', 'CR-Z', 'Hatchback 2-Door'],
    [2016, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2016, 'Honda', 'HR-V', 'SUV 4-Door'],
    [2016, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2016, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2016, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2016, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2016, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2016, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2016, 'Hyundai', 'Elantra GT', 'Hatchback 4-Door'],
    [2016, 'Hyundai', 'Equus', 'Sedan 4-Door'],
    [2016, 'Hyundai', 'Genesis', 'Sedan 4-Door'],
    [2016, 'Hyundai', 'Genesis Coupe', 'Coupe 2-Door'],
    [2016, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2016, 'Hyundai', 'Santa Fe Sport', 'SUV 4-Door'],
    [2016, 'Hyundai', 'Santa Fe XL', 'SUV 4-Door'],
    [2016, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2016, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2016, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2016, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2016, 'INFINITI', 'Q70', 'Sedan 4-Door'],
    [2016, 'INFINITI', 'Q70L', 'Sedan 4-Door'],
    [2016, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2016, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2016, 'INFINITI', 'QX70', 'SUV 4-Door'],
    [2016, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2016, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2016, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2016, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2016, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2016, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2016, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2016, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2016, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2016, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2016, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2016, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2016, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2016, 'Kia', 'Cadenza', 'Sedan 4-Door'],
    [2016, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2016, 'Kia', 'Forte Koup', 'Coupe 2-Door'],
    [2016, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2016, 'Kia', 'K900', 'Sedan 4-Door'],
    [2016, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2016, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2016, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2016, 'Kia', 'Rondo', 'Hatchback 4-Door'],
    [2016, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2016, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2016, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2016, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2016, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2016, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2016, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2016, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2016, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2016, 'Land Rover', 'LR4', 'SUV 4-Door'],
    [2016, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2016, 'Land Rover', 'Range Rover Evoque', 'SUV 2-Door'],
    [2016, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2016, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2016, 'Lexus', 'CT200h', 'Hatchback 4-Door'],
    [2016, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2016, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2016, 'Lexus', 'GS F', 'Sedan 4-Door'],
    [2016, 'Lexus', 'GS200t', 'Sedan 4-Door'],
    [2016, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2016, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2016, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2016, 'Lexus', 'IS200t', 'Sedan 4-Door'],
    [2016, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2016, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2016, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2016, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2016, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2016, 'Lexus', 'NX200t', 'SUV 4-Door'],
    [2016, 'Lexus', 'NX300h', 'SUV 4-Door'],
    [2016, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2016, 'Lexus', 'RC200t', 'Coupe 2-Door'],
    [2016, 'Lexus', 'RC300', 'Coupe 2-Door'],
    [2016, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2016, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2016, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2016, 'Lincoln', 'MKC', 'SUV 4-Door'],
    [2016, 'Lincoln', 'MKS', 'Sedan 4-Door'],
    [2016, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2016, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2016, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2016, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2016, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2016, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2016, 'Maserati', 'GranTurismo', 'Convertible 2-Door'],
    [2016, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2016, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2016, 'Mazda', '3', 'Hatchback 4-Door'],
    [2016, 'Mazda', '3', 'Sedan 4-Door'],
    [2016, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2016, 'Mazda', '6', 'Sedan 4-Door'],
    [2016, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2016, 'Mazda', 'CX-3', 'SUV 4-Door'],
    [2016, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2016, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2016, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2016, 'McLaren', '570S', 'Coupe 2-Door'],
    [2016, 'McLaren', '650S', 'Convertible 2-Door'],
    [2016, 'McLaren', '650S', 'Coupe 2-Door'],
    [2016, 'McLaren', '675LT', 'Convertible 2-Door'],
    [2016, 'McLaren', '675LT', 'Coupe 2-Door'],
    [2016, 'Mercedes-Benz', 'AMG GT S', 'Coupe 2-Door'],
    [2016, 'Mercedes-Benz', 'B250', 'Hatchback 4-Door'],
    [2016, 'Mercedes-Benz', 'B250e', 'Hatchback 4-Door'],
    [2016, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'C350e', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'C450 AMG', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'C63 AMG S', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'CLS400', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'CLS63 AMG S', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'E250', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2016, 'Mercedes-Benz', 'E400', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'E400', 'Coupe 2-Door'],
    [2016, 'Mercedes-Benz', 'E400', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'E400', 'Wagon 4-Door'],
    [2016, 'Mercedes-Benz', 'E550', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'E550', 'Coupe 2-Door'],
    [2016, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'E63 AMG S', 'Wagon 4-Door'],
    [2016, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'G65 AMG', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GL350', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GL63 AMG', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLC300', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLC300', 'SUV Coupe 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE300d', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE350', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE350d', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE400', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE450 AMG', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE550', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE550e', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE63 AMG', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV 4-Door'],
    [2016, 'Mercedes-Benz', 'GLE63 AMG S', 'SUV Coupe 4-Door'],
    [2016, 'Mercedes-Benz', 'Maybach S600', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'Metris', 'Mini Cargo Van 4-Door'],
    [2016, 'Mercedes-Benz', 'Metris', 'Mini Passenger Van 4-Door'],
    [2016, 'Mercedes-Benz', 'S550', 'Coupe 2-Door'],
    [2016, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'S550e', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'S63 AMG', 'Coupe 2-Door'],
    [2016, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'S65 AMG', 'Coupe 2-Door'],
    [2016, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2016, 'Mercedes-Benz', 'SL400', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'SLK300', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2016, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2016, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2016, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2016, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2016, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2016, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2016, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2016, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2016, 'Mini', 'Cooper Clubman', 'Wagon 4-Door'],
    [2016, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2016, 'Mini', 'Cooper Paceman', 'Hatchback 2-Door'],
    [2016, 'Mitsubishi', 'i-MiEV', 'Hatchback 4-Door'],
    [2016, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2016, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2016, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2016, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2016, 'Mobility Ventures', 'MV-1', 'Standard Passenger Van 4-Door'],
    [2016, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2016, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2016, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2016, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2016, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2016, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2016, 'Nissan', 'Juke', 'SUV 4-Door'],
    [2016, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2016, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2016, 'Nissan', 'Micra', 'Hatchback 4-Door'],
    [2016, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2016, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2016, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2016, 'Nissan', 'NV200', 'Mini Passenger Van 4-Door'],
    [2016, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2016, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2016, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2016, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2016, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2016, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2016, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2016, 'Nissan', 'TITAN XD', 'Crew Cab Pickup 4-Door'],
    [2016, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2016, 'Nissan', 'Versa Note', 'Hatchback 4-Door'],
    [2016, 'Porsche', '911', 'Convertible 2-Door'],
    [2016, 'Porsche', '911', 'Coupe 2-Door'],
    [2016, 'Porsche', '911', 'Targa 2-Door'],
    [2016, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2016, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2016, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2016, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2016, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2016, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2016, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2016, 'Ram', '1500', 'Standard Cab Pickup 2-Door'],
    [2016, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2016, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2016, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2016, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2016, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2016, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2016, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2016, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2016, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 4-Door'],
    [2016, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2016, 'Ram', 'ProMaster City', 'Mini Cargo Van 4-Door'],
    [2016, 'Ram', 'ProMaster City', 'Mini Passenger Van 4-Door'],
    [2016, 'Rolls-Royce', 'Dawn', 'Convertible 2-Door'],
    [2016, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2016, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2016, 'Rolls-Royce', 'Phantom', 'Coupe 2-Door'],
    [2016, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2016, 'Rolls-Royce', 'Wraith', 'Coupe 2-Door'],
    [2016, 'Scion', 'FR-S', 'Coupe 2-Door'],
    [2016, 'Scion', 'iA', 'Sedan 4-Door'],
    [2016, 'Scion', 'iM', 'Hatchback 4-Door'],
    [2016, 'Scion', 'tC', 'Coupe 2-Door'],
    [2016, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2016, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2016, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2016, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2016, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2016, 'Subaru', 'Crosstrek', 'SUV 4-Door'],
    [2016, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2016, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2016, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2016, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2016, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2016, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2016, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2016, 'Tesla', 'S', 'Sedan 4-Door'],
    [2016, 'Tesla', 'X', 'SUV 4-Door'],
    [2016, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2016, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2016, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2016, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2016, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2016, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2016, 'Toyota', 'Mirai', 'Sedan 4-Door'],
    [2016, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2016, 'Toyota', 'Prius C', 'Hatchback 4-Door'],
    [2016, 'Toyota', 'Prius V', 'Wagon 4-Door'],
    [2016, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2016, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2016, 'Toyota', 'Sienna', 'Mini Cargo Van 4-Door'],
    [2016, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2016, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2016, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2016, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2016, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2016, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2016, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2016, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2016, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2016, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2016, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2016, 'Volkswagen', 'Beetle', 'Coupe 2-Door'],
    [2016, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2016, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2016, 'Volkswagen', 'e-Golf', 'Hatchback 4-Door'],
    [2016, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2016, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2016, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2016, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2016, 'Volkswagen', 'Golf SportWagen', 'Wagon 4-Door'],
    [2016, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2016, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2016, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2016, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2016, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2016, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2016, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2016, 'Volvo', 'S60 Cross Country', 'Sedan 4-Door'],
    [2016, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2016, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2016, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2016, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2016, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2016, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2015, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2015, 'Acura', 'MDX', 'SUV 4-Door'],
    [2015, 'Acura', 'RDX', 'SUV 4-Door'],
    [2015, 'Acura', 'RLX', 'Sedan 4-Door'],
    [2015, 'Acura', 'TLX', 'Sedan 4-Door'],
    [2015, 'Alfa Romeo', '4C', 'Convertible 2-Door'],
    [2015, 'Alfa Romeo', '4C', 'Coupe 2-Door'],
    [2015, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2015, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2015, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2015, 'Aston Martin', 'V12 Vantage', 'Convertible 2-Door'],
    [2015, 'Aston Martin', 'V12 Vantage', 'Hatchback 2-Door'],
    [2015, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2015, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2015, 'Aston Martin', 'Vanquish', 'Convertible 2-Door'],
    [2015, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2015, 'Audi', 'A3', 'Convertible 2-Door'],
    [2015, 'Audi', 'A3', 'Sedan 4-Door'],
    [2015, 'Audi', 'A3 Quattro', 'Convertible 2-Door'],
    [2015, 'Audi', 'A3 Quattro', 'Sedan 4-Door'],
    [2015, 'Audi', 'A4', 'Sedan 4-Door'],
    [2015, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2015, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2015, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2015, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2015, 'Audi', 'A6', 'Sedan 4-Door'],
    [2015, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2015, 'Audi', 'A7 Quattro', 'Hatchback 4-Door'],
    [2015, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2015, 'Audi', 'allroad', 'Wagon 4-Door'],
    [2015, 'Audi', 'Q3', 'SUV 4-Door'],
    [2015, 'Audi', 'Q3 Quattro', 'SUV 4-Door'],
    [2015, 'Audi', 'Q5', 'SUV 4-Door'],
    [2015, 'Audi', 'Q7', 'SUV 4-Door'],
    [2015, 'Audi', 'R8', 'Convertible 2-Door'],
    [2015, 'Audi', 'R8', 'Coupe 2-Door'],
    [2015, 'Audi', 'RS5', 'Convertible 2-Door'],
    [2015, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2015, 'Audi', 'RS7', 'Hatchback 4-Door'],
    [2015, 'Audi', 'S3', 'Sedan 4-Door'],
    [2015, 'Audi', 'S4', 'Sedan 4-Door'],
    [2015, 'Audi', 'S5', 'Convertible 2-Door'],
    [2015, 'Audi', 'S5', 'Coupe 2-Door'],
    [2015, 'Audi', 'S6', 'Sedan 4-Door'],
    [2015, 'Audi', 'S7', 'Hatchback 4-Door'],
    [2015, 'Audi', 'S8', 'Sedan 4-Door'],
    [2015, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2015, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2015, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2015, 'Audi', 'TTS Quattro', 'Convertible 2-Door'],
    [2015, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2015, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2015, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2015, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2015, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2015, 'BMW', '228i', 'Convertible 2-Door'],
    [2015, 'BMW', '228i', 'Coupe 2-Door'],
    [2015, 'BMW', '228i xDrive', 'Convertible 2-Door'],
    [2015, 'BMW', '228i xDrive', 'Coupe 2-Door'],
    [2015, 'BMW', '320i', 'Sedan 4-Door'],
    [2015, 'BMW', '320i xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '328d', 'Sedan 4-Door'],
    [2015, 'BMW', '328d xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '328d xDrive', 'Wagon 4-Door'],
    [2015, 'BMW', '328i', 'Sedan 4-Door'],
    [2015, 'BMW', '328i GT xDrive', 'Hatchback 4-Door'],
    [2015, 'BMW', '328i xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '328i xDrive', 'Wagon 4-Door'],
    [2015, 'BMW', '335i', 'Sedan 4-Door'],
    [2015, 'BMW', '335i GT xDrive', 'Hatchback 4-Door'],
    [2015, 'BMW', '335i xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '428i', 'Convertible 2-Door'],
    [2015, 'BMW', '428i', 'Coupe 2-Door'],
    [2015, 'BMW', '428i Gran Coupe', 'Hatchback 4-Door'],
    [2015, 'BMW', '428i xDrive', 'Convertible 2-Door'],
    [2015, 'BMW', '428i xDrive', 'Coupe 2-Door'],
    [2015, 'BMW', '428i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2015, 'BMW', '435i', 'Convertible 2-Door'],
    [2015, 'BMW', '435i', 'Coupe 2-Door'],
    [2015, 'BMW', '435i Gran Coupe', 'Hatchback 4-Door'],
    [2015, 'BMW', '435i xDrive', 'Convertible 2-Door'],
    [2015, 'BMW', '435i xDrive', 'Coupe 2-Door'],
    [2015, 'BMW', '435i xDrive Gran Coupe', 'Hatchback 4-Door'],
    [2015, 'BMW', '528i', 'Sedan 4-Door'],
    [2015, 'BMW', '528i xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '535d', 'Sedan 4-Door'],
    [2015, 'BMW', '535d xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '535i', 'Sedan 4-Door'],
    [2015, 'BMW', '535i GT', 'Hatchback 4-Door'],
    [2015, 'BMW', '535i GT xDrive', 'Hatchback 4-Door'],
    [2015, 'BMW', '535i xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '550i', 'Sedan 4-Door'],
    [2015, 'BMW', '550i GT', 'Hatchback 4-Door'],
    [2015, 'BMW', '550i GT xDrive', 'Hatchback 4-Door'],
    [2015, 'BMW', '550i xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '640i', 'Convertible 2-Door'],
    [2015, 'BMW', '640i', 'Coupe 2-Door'],
    [2015, 'BMW', '640i Gran Coupe', 'Sedan 4-Door'],
    [2015, 'BMW', '640i xDrive', 'Convertible 2-Door'],
    [2015, 'BMW', '640i xDrive', 'Coupe 2-Door'],
    [2015, 'BMW', '640i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2015, 'BMW', '650i', 'Convertible 2-Door'],
    [2015, 'BMW', '650i', 'Coupe 2-Door'],
    [2015, 'BMW', '650i Gran Coupe', 'Sedan 4-Door'],
    [2015, 'BMW', '650i xDrive', 'Convertible 2-Door'],
    [2015, 'BMW', '650i xDrive', 'Coupe 2-Door'],
    [2015, 'BMW', '650i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2015, 'BMW', '740i', 'Sedan 4-Door'],
    [2015, 'BMW', '740Ld xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '740Li', 'Sedan 4-Door'],
    [2015, 'BMW', '740Li xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '750i', 'Sedan 4-Door'],
    [2015, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '750Li', 'Sedan 4-Door'],
    [2015, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', '760Li', 'Sedan 4-Door'],
    [2015, 'BMW', 'ActiveHybrid 3', 'Sedan 4-Door'],
    [2015, 'BMW', 'ActiveHybrid 5', 'Sedan 4-Door'],
    [2015, 'BMW', 'ActiveHybrid 7', 'Sedan 4-Door'],
    [2015, 'BMW', 'Alpina B6 xDrive Gran Coupe', 'Sedan 4-Door'],
    [2015, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2015, 'BMW', 'Alpina B7 xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', 'Alpina B7L', 'Sedan 4-Door'],
    [2015, 'BMW', 'Alpina B7L xDrive', 'Sedan 4-Door'],
    [2015, 'BMW', 'i3', 'Hatchback 4-Door'],
    [2015, 'BMW', 'i8', 'Coupe 2-Door'],
    [2015, 'BMW', 'M235i', 'Convertible 2-Door'],
    [2015, 'BMW', 'M235i', 'Coupe 2-Door'],
    [2015, 'BMW', 'M235i xDrive', 'Coupe 2-Door'],
    [2015, 'BMW', 'M3', 'Sedan 4-Door'],
    [2015, 'BMW', 'M4', 'Convertible 2-Door'],
    [2015, 'BMW', 'M4', 'Coupe 2-Door'],
    [2015, 'BMW', 'M5', 'Sedan 4-Door'],
    [2015, 'BMW', 'M6', 'Convertible 2-Door'],
    [2015, 'BMW', 'M6', 'Coupe 2-Door'],
    [2015, 'BMW', 'M6 Gran Coupe', 'Sedan 4-Door'],
    [2015, 'BMW', 'X1', 'SUV 4-Door'],
    [2015, 'BMW', 'X3', 'SUV 4-Door'],
    [2015, 'BMW', 'X4', 'SUV 4-Door'],
    [2015, 'BMW', 'X5', 'SUV 4-Door'],
    [2015, 'BMW', 'X6', 'SUV 4-Door'],
    [2015, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2015, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2015, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2015, 'Buick', 'Encore', 'SUV 4-Door'],
    [2015, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2015, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2015, 'Buick', 'Verano', 'Sedan 4-Door'],
    [2015, 'Cadillac', 'ATS', 'Coupe 2-Door'],
    [2015, 'Cadillac', 'ATS', 'Sedan 4-Door'],
    [2015, 'Cadillac', 'CTS', 'Coupe 2-Door'],
    [2015, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2015, 'Cadillac', 'ELR', 'Coupe 2-Door'],
    [2015, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2015, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2015, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2015, 'Cadillac', 'XTS', 'Hearse 4-Door'],
    [2015, 'Cadillac', 'XTS', 'Limousine 4-Door'],
    [2015, 'Cadillac', 'XTS', 'Sedan 4-Door'],
    [2015, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2015, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2015, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [2015, 'Chevrolet', 'Captiva Sport', 'SUV 4-Door'],
    [2015, 'Chevrolet', 'City Express', 'Mini Cargo Van 4-Door'],
    [2015, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2015, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2015, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2015, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2015, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2015, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2015, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2015, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2015, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2015, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2015, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2015, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2015, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2015, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2015, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2015, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2015, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2015, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2015, 'Chevrolet', 'Impala Limited', 'Sedan 4-Door'],
    [2015, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2015, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2015, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2015, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2015, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2015, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2015, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2015, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2015, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2015, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2015, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2015, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2015, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2015, 'Chevrolet', 'Spark EV', 'Hatchback 4-Door'],
    [2015, 'Chevrolet', 'SS', 'Sedan 4-Door'],
    [2015, 'Chevrolet', 'Suburban', 'SUV 4-Door'],
    [2015, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2015, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2015, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2015, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2015, 'Chrysler', '200', 'Sedan 4-Door'],
    [2015, 'Chrysler', '300', 'Sedan 4-Door'],
    [2015, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2015, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2015, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2015, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [2015, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2015, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2015, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2015, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2015, 'Ferrari', '458 Italia', 'Coupe 2-Door'],
    [2015, 'Ferrari', '458 Speciale', 'Coupe 2-Door'],
    [2015, 'Ferrari', '458 Spider', 'Convertible 2-Door'],
    [2015, 'Ferrari', 'California T', 'Convertible 2-Door'],
    [2015, 'Ferrari', 'F12 Berlinetta', 'Coupe 2-Door'],
    [2015, 'Ferrari', 'FF', 'Hatchback 2-Door'],
    [2015, 'Ferrari', 'LaFerrari', 'Coupe 2-Door'],
    [2015, 'Fiat', '500', 'Convertible 2-Door'],
    [2015, 'Fiat', '500', 'Hatchback 2-Door'],
    [2015, 'Fiat', '500L', 'Hatchback 4-Door'],
    [2015, 'Ford', 'C-Max', 'Hatchback 4-Door'],
    [2015, 'Ford', 'Edge', 'SUV 4-Door'],
    [2015, 'Ford', 'Escape', 'SUV 4-Door'],
    [2015, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2015, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2015, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2015, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2015, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2015, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2015, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2015, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2015, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2015, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2015, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2015, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2015, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2015, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2015, 'Ford', 'Flex', 'SUV 4-Door'],
    [2015, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2015, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2015, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2015, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2015, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2015, 'Ford', 'Police Interceptor Sedan', 'Sedan 4-Door'],
    [2015, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2015, 'Ford', 'Special Service Police Sedan', 'Sedan 4-Door'],
    [2015, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2015, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2015, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2015, 'Ford', 'Transit-150', 'Standard Cargo Van 3-Door'],
    [2015, 'Ford', 'Transit-150', 'Standard Cargo Van 4-Door'],
    [2015, 'Ford', 'Transit-150', 'Standard Passenger Van 3-Door'],
    [2015, 'Ford', 'Transit-250', 'Extended Cargo Van 3-Door'],
    [2015, 'Ford', 'Transit-250', 'Extended Cargo Van 4-Door'],
    [2015, 'Ford', 'Transit-250', 'Standard Cargo Van 3-Door'],
    [2015, 'Ford', 'Transit-250', 'Standard Cargo Van 4-Door'],
    [2015, 'Ford', 'Transit-350', 'Extended Cargo Van 3-Door'],
    [2015, 'Ford', 'Transit-350', 'Extended Cargo Van 4-Door'],
    [2015, 'Ford', 'Transit-350', 'Standard Cargo Van 3-Door'],
    [2015, 'Ford', 'Transit-350', 'Standard Cargo Van 4-Door'],
    [2015, 'Ford', 'Transit-350', 'Standard Passenger Van 3-Door'],
    [2015, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 3-Door'],
    [2015, 'Ford', 'Transit-350 HD', 'Extended Cargo Van 4-Door'],
    [2015, 'Ford', 'Transit-350 HD', 'Extended Passenger Van 3-Door'],
    [2015, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2015, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2015, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2015, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2015, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2015, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2015, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2015, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2015, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2015, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2015, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2015, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2015, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2015, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2015, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2015, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2015, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2015, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2015, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2015, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2015, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2015, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2015, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2015, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2015, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2015, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2015, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2015, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2015, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2015, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2015, 'GMC', 'Yukon XL', 'SUV 4-Door'],
    [2015, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2015, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2015, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2015, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2015, 'Honda', 'Crosstour', 'Hatchback 4-Door'],
    [2015, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2015, 'Honda', 'CR-Z', 'Hatchback 2-Door'],
    [2015, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2015, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2015, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2015, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2015, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2015, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2015, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2015, 'Hyundai', 'Elantra GT', 'Hatchback 4-Door'],
    [2015, 'Hyundai', 'Equus', 'Sedan 4-Door'],
    [2015, 'Hyundai', 'Genesis', 'Sedan 4-Door'],
    [2015, 'Hyundai', 'Genesis Coupe', 'Coupe 2-Door'],
    [2015, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2015, 'Hyundai', 'Santa Fe Sport', 'SUV 4-Door'],
    [2015, 'Hyundai', 'Santa Fe XL', 'SUV 4-Door'],
    [2015, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2015, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2015, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2015, 'INFINITI', 'Q40', 'Sedan 4-Door'],
    [2015, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2015, 'INFINITI', 'Q60', 'Convertible 2-Door'],
    [2015, 'INFINITI', 'Q60', 'Coupe 2-Door'],
    [2015, 'INFINITI', 'Q70', 'Sedan 4-Door'],
    [2015, 'INFINITI', 'Q70L', 'Sedan 4-Door'],
    [2015, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2015, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2015, 'INFINITI', 'QX70', 'SUV 4-Door'],
    [2015, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2015, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2015, 'Jaguar', 'F-Type', 'Coupe 2-Door'],
    [2015, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2015, 'Jaguar', 'XFR', 'Sedan 4-Door'],
    [2015, 'Jaguar', 'XFR-S', 'Sedan 4-Door'],
    [2015, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2015, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2015, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2015, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2015, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2015, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2015, 'Jaguar', 'XKR-S', 'Convertible 2-Door'],
    [2015, 'Jaguar', 'XKR-S', 'Coupe 2-Door'],
    [2015, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2015, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2015, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2015, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2015, 'Jeep', 'Renegade', 'SUV 4-Door'],
    [2015, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2015, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2015, 'Kia', 'Cadenza', 'Sedan 4-Door'],
    [2015, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2015, 'Kia', 'Forte Koup', 'Coupe 2-Door'],
    [2015, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2015, 'Kia', 'K900', 'Sedan 4-Door'],
    [2015, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2015, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2015, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2015, 'Kia', 'Rondo', 'Hatchback 4-Door'],
    [2015, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2015, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2015, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2015, 'Kia', 'Soul EV', 'Hatchback 4-Door'],
    [2015, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2015, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2015, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2015, 'Lamborghini', 'Huracan', 'Coupe 2-Door'],
    [2015, 'Land Rover', 'Discovery Sport', 'SUV 4-Door'],
    [2015, 'Land Rover', 'LR2', 'SUV 4-Door'],
    [2015, 'Land Rover', 'LR4', 'SUV 4-Door'],
    [2015, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2015, 'Land Rover', 'Range Rover Evoque', 'SUV 2-Door'],
    [2015, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2015, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2015, 'Lexus', 'CT200h', 'Hatchback 4-Door'],
    [2015, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2015, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2015, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2015, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2015, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2015, 'Lexus', 'IS250', 'Convertible 2-Door'],
    [2015, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2015, 'Lexus', 'IS350', 'Convertible 2-Door'],
    [2015, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2015, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2015, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2015, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2015, 'Lexus', 'NX200t', 'SUV 4-Door'],
    [2015, 'Lexus', 'NX300h', 'SUV 4-Door'],
    [2015, 'Lexus', 'RC F', 'Coupe 2-Door'],
    [2015, 'Lexus', 'RC350', 'Coupe 2-Door'],
    [2015, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2015, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2015, 'Lincoln', 'MKC', 'SUV 4-Door'],
    [2015, 'Lincoln', 'MKS', 'Sedan 4-Door'],
    [2015, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2015, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2015, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2015, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2015, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2015, 'Maserati', 'GranTurismo', 'Convertible 2-Door'],
    [2015, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2015, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2015, 'Mazda', '3', 'Hatchback 4-Door'],
    [2015, 'Mazda', '3', 'Sedan 4-Door'],
    [2015, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2015, 'Mazda', '6', 'Sedan 4-Door'],
    [2015, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2015, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2015, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2015, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2015, 'McLaren', '650S', 'Convertible 2-Door'],
    [2015, 'McLaren', '650S', 'Coupe 2-Door'],
    [2015, 'McLaren', 'P1', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'B Electric Drive', 'Hatchback 4-Door'],
    [2015, 'Mercedes-Benz', 'B250', 'Hatchback 4-Door'],
    [2015, 'Mercedes-Benz', 'C250', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'C350', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'C400', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'C63 AMG S', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'CLS400', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'CLS63 AMG S', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'E250', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2015, 'Mercedes-Benz', 'E400', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'E400', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'E400', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'E400', 'Wagon 4-Door'],
    [2015, 'Mercedes-Benz', 'E550', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'E550', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'E63 AMG S', 'Wagon 4-Door'],
    [2015, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'GL350', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'GL63 AMG', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'GLA250', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'GLA45 AMG', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'GLK250', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'GLK350', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'ML250', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'ML400', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'ML550', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2015, 'Mercedes-Benz', 'S550', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'S550e', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'S63 AMG', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'S65 AMG', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2015, 'Mercedes-Benz', 'SL400', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'SLK250', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'SLS AMG', 'Convertible 2-Door'],
    [2015, 'Mercedes-Benz', 'SLS AMG', 'Coupe 2-Door'],
    [2015, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2015, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2015, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2015, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2015, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2015, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2015, 'Mini', 'Cooper', 'Coupe 2-Door'],
    [2015, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2015, 'Mini', 'Cooper', 'Hatchback 4-Door'],
    [2015, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2015, 'Mini', 'Cooper Paceman', 'Hatchback 2-Door'],
    [2015, 'Mitsubishi', 'Lancer', 'Hatchback 4-Door'],
    [2015, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2015, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2015, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2015, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2015, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2015, 'Mobility Ventures', 'MV-1', 'Standard Passenger Van 4-Door'],
    [2015, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2015, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2015, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2015, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2015, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2015, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2015, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2015, 'Nissan', 'Juke', 'SUV 4-Door'],
    [2015, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2015, 'Nissan', 'Micra', 'Hatchback 4-Door'],
    [2015, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2015, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2015, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2015, 'Nissan', 'NV200', 'Mini Passenger Van 4-Door'],
    [2015, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2015, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2015, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2015, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2015, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2015, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2015, 'Nissan', 'Rogue Select', 'SUV 4-Door'],
    [2015, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2015, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2015, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2015, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2015, 'Nissan', 'Versa Note', 'Hatchback 4-Door'],
    [2015, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2015, 'Porsche', '911', 'Convertible 2-Door'],
    [2015, 'Porsche', '911', 'Coupe 2-Door'],
    [2015, 'Porsche', '911', 'Targa 2-Door'],
    [2015, 'Porsche', '918 Spyder', 'Convertible 2-Door'],
    [2015, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2015, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2015, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2015, 'Porsche', 'Macan', 'SUV 4-Door'],
    [2015, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2015, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2015, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2015, 'Ram', '1500', 'Standard Cab Pickup 2-Door'],
    [2015, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2015, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2015, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2015, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2015, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2015, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2015, 'Ram', 'C/V', 'Mini Cargo Van 4-Door'],
    [2015, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2015, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2015, 'Ram', 'ProMaster 3500', 'Extended Cargo Van 4-Door'],
    [2015, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2015, 'Ram', 'ProMaster City', 'Mini Cargo Van 4-Door'],
    [2015, 'Ram', 'ProMaster City', 'Mini Passenger Van 4-Door'],
    [2015, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2015, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2015, 'Rolls-Royce', 'Phantom', 'Coupe 2-Door'],
    [2015, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2015, 'Rolls-Royce', 'Wraith', 'Coupe 2-Door'],
    [2015, 'Scion', 'FR-S', 'Coupe 2-Door'],
    [2015, 'Scion', 'iQ', 'Hatchback 2-Door'],
    [2015, 'Scion', 'tC', 'Coupe 2-Door'],
    [2015, 'Scion', 'xB', 'Wagon 4-Door'],
    [2015, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2015, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2015, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2015, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2015, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2015, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2015, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2015, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2015, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2015, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2015, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2015, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2015, 'Subaru', 'XV Crosstrek', 'SUV 4-Door'],
    [2015, 'Tesla', 'S', 'Sedan 4-Door'],
    [2015, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2015, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2015, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2015, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2015, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2015, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2015, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2015, 'Toyota', 'Prius C', 'Hatchback 4-Door'],
    [2015, 'Toyota', 'Prius Plug-In', 'Hatchback 4-Door'],
    [2015, 'Toyota', 'Prius V', 'Wagon 4-Door'],
    [2015, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2015, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2015, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2015, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2015, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2015, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2015, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2015, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2015, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2015, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2015, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2015, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2015, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2015, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2015, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2015, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2015, 'Volkswagen', 'e-Golf', 'Hatchback 4-Door'],
    [2015, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2015, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2015, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2015, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2015, 'Volkswagen', 'Golf SportWagen', 'Wagon 4-Door'],
    [2015, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2015, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2015, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2015, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2015, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2015, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2015, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2015, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2015, 'Volvo', 'V60', 'Wagon 4-Door'],
    [2015, 'Volvo', 'V60 Cross Country', 'Wagon 4-Door'],
    [2015, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2015, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2014, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2014, 'Acura', 'MDX', 'SUV 4-Door'],
    [2014, 'Acura', 'RDX', 'SUV 4-Door'],
    [2014, 'Acura', 'RLX', 'Sedan 4-Door'],
    [2014, 'Acura', 'TL', 'Sedan 4-Door'],
    [2014, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2014, 'Acura', 'TSX', 'Wagon 4-Door'],
    [2014, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2014, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2014, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2014, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2014, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2014, 'Aston Martin', 'Vanquish', 'Convertible 2-Door'],
    [2014, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2014, 'Audi', 'A4', 'Sedan 4-Door'],
    [2014, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2014, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2014, 'Audi', 'A5', 'Convertible 2-Door'],
    [2014, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2014, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2014, 'Audi', 'A6', 'Sedan 4-Door'],
    [2014, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2014, 'Audi', 'A7 Quattro', 'Hatchback 4-Door'],
    [2014, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2014, 'Audi', 'allroad', 'Wagon 4-Door'],
    [2014, 'Audi', 'Q5', 'SUV 4-Door'],
    [2014, 'Audi', 'Q7', 'SUV 4-Door'],
    [2014, 'Audi', 'R8', 'Convertible 2-Door'],
    [2014, 'Audi', 'R8', 'Coupe 2-Door'],
    [2014, 'Audi', 'RS5', 'Convertible 2-Door'],
    [2014, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2014, 'Audi', 'RS7', 'Hatchback 4-Door'],
    [2014, 'Audi', 'S4', 'Sedan 4-Door'],
    [2014, 'Audi', 'S5', 'Convertible 2-Door'],
    [2014, 'Audi', 'S5', 'Coupe 2-Door'],
    [2014, 'Audi', 'S6', 'Sedan 4-Door'],
    [2014, 'Audi', 'S7', 'Hatchback 4-Door'],
    [2014, 'Audi', 'S8', 'Sedan 4-Door'],
    [2014, 'Audi', 'SQ5', 'SUV 4-Door'],
    [2014, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2014, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2014, 'Audi', 'TTS Quattro', 'Convertible 2-Door'],
    [2014, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2014, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2014, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2014, 'Bentley', 'Flying Spur', 'Sedan 4-Door'],
    [2014, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2014, 'BMW', '228i', 'Coupe 2-Door'],
    [2014, 'BMW', '320i', 'Sedan 4-Door'],
    [2014, 'BMW', '320i xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '328d', 'Sedan 4-Door'],
    [2014, 'BMW', '328d xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '328d xDrive', 'Wagon 4-Door'],
    [2014, 'BMW', '328i', 'Sedan 4-Door'],
    [2014, 'BMW', '328i GT xDrive', 'Hatchback 4-Door'],
    [2014, 'BMW', '328i xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '328i xDrive', 'Wagon 4-Door'],
    [2014, 'BMW', '335i', 'Sedan 4-Door'],
    [2014, 'BMW', '335i GT xDrive', 'Hatchback 4-Door'],
    [2014, 'BMW', '335i xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '428i', 'Convertible 2-Door'],
    [2014, 'BMW', '428i', 'Coupe 2-Door'],
    [2014, 'BMW', '428i xDrive', 'Convertible 2-Door'],
    [2014, 'BMW', '428i xDrive', 'Coupe 2-Door'],
    [2014, 'BMW', '435i', 'Convertible 2-Door'],
    [2014, 'BMW', '435i', 'Coupe 2-Door'],
    [2014, 'BMW', '435i xDrive', 'Coupe 2-Door'],
    [2014, 'BMW', '528i', 'Sedan 4-Door'],
    [2014, 'BMW', '528i xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '535d', 'Sedan 4-Door'],
    [2014, 'BMW', '535d xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '535i', 'Sedan 4-Door'],
    [2014, 'BMW', '535i GT', 'Hatchback 4-Door'],
    [2014, 'BMW', '535i GT xDrive', 'Hatchback 4-Door'],
    [2014, 'BMW', '535i xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '550i', 'Sedan 4-Door'],
    [2014, 'BMW', '550i GT', 'Hatchback 4-Door'],
    [2014, 'BMW', '550i GT xDrive', 'Hatchback 4-Door'],
    [2014, 'BMW', '550i xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '640i', 'Convertible 2-Door'],
    [2014, 'BMW', '640i', 'Coupe 2-Door'],
    [2014, 'BMW', '640i Gran Coupe', 'Sedan 4-Door'],
    [2014, 'BMW', '640i xDrive', 'Convertible 2-Door'],
    [2014, 'BMW', '640i xDrive', 'Coupe 2-Door'],
    [2014, 'BMW', '640i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2014, 'BMW', '650i', 'Convertible 2-Door'],
    [2014, 'BMW', '650i', 'Coupe 2-Door'],
    [2014, 'BMW', '650i Gran Coupe', 'Sedan 4-Door'],
    [2014, 'BMW', '650i xDrive', 'Convertible 2-Door'],
    [2014, 'BMW', '650i xDrive', 'Coupe 2-Door'],
    [2014, 'BMW', '650i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2014, 'BMW', '740i', 'Sedan 4-Door'],
    [2014, 'BMW', '740Li', 'Sedan 4-Door'],
    [2014, 'BMW', '740Li xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '750i', 'Sedan 4-Door'],
    [2014, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '750Li', 'Sedan 4-Door'],
    [2014, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', '760Li', 'Sedan 4-Door'],
    [2014, 'BMW', 'ActiveHybrid 3', 'Sedan 4-Door'],
    [2014, 'BMW', 'ActiveHybrid 5', 'Sedan 4-Door'],
    [2014, 'BMW', 'ActiveHybrid 7', 'Sedan 4-Door'],
    [2014, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2014, 'BMW', 'Alpina B7 xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', 'Alpina B7L', 'Sedan 4-Door'],
    [2014, 'BMW', 'Alpina B7L xDrive', 'Sedan 4-Door'],
    [2014, 'BMW', 'i3', 'Hatchback 4-Door'],
    [2014, 'BMW', 'i8', 'Coupe 2-Door'],
    [2014, 'BMW', 'M235i', 'Coupe 2-Door'],
    [2014, 'BMW', 'M5', 'Sedan 4-Door'],
    [2014, 'BMW', 'M6', 'Convertible 2-Door'],
    [2014, 'BMW', 'M6', 'Coupe 2-Door'],
    [2014, 'BMW', 'M6 Gran Coupe', 'Sedan 4-Door'],
    [2014, 'BMW', 'X1', 'SUV 4-Door'],
    [2014, 'BMW', 'X3', 'SUV 4-Door'],
    [2014, 'BMW', 'X5', 'SUV 4-Door'],
    [2014, 'BMW', 'X6', 'SUV 4-Door'],
    [2014, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2014, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2014, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2014, 'Buick', 'Encore', 'SUV 4-Door'],
    [2014, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2014, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2014, 'Buick', 'Verano', 'Sedan 4-Door'],
    [2014, 'Cadillac', 'ATS', 'Sedan 4-Door'],
    [2014, 'Cadillac', 'CTS', 'Coupe 2-Door'],
    [2014, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2014, 'Cadillac', 'CTS', 'Wagon 4-Door'],
    [2014, 'Cadillac', 'ELR', 'Coupe 2-Door'],
    [2014, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2014, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2014, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2014, 'Cadillac', 'XTS', 'Hearse 4-Door'],
    [2014, 'Cadillac', 'XTS', 'Limousine 4-Door'],
    [2014, 'Cadillac', 'XTS', 'Sedan 4-Door'],
    [2014, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2014, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2014, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [2014, 'Chevrolet', 'Captiva Sport', 'SUV 4-Door'],
    [2014, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2014, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2014, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2014, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2014, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2014, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2014, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2014, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2014, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2014, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2014, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2014, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2014, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2014, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2014, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2014, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2014, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2014, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2014, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2014, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2014, 'Chevrolet', 'Impala Limited', 'Sedan 4-Door'],
    [2014, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2014, 'Chevrolet', 'Orlando', 'SUV 4-Door'],
    [2014, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2014, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2014, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2014, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2014, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2014, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2014, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2014, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2014, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2014, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2014, 'Chevrolet', 'Spark EV', 'Hatchback 4-Door'],
    [2014, 'Chevrolet', 'SS', 'Sedan 4-Door'],
    [2014, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2014, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2014, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2014, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2014, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2014, 'Chrysler', '200', 'Convertible 2-Door'],
    [2014, 'Chrysler', '200', 'Sedan 4-Door'],
    [2014, 'Chrysler', '300', 'Sedan 4-Door'],
    [2014, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2014, 'Dodge', 'Avenger', 'Sedan 4-Door'],
    [2014, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2014, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2014, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [2014, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2014, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2014, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2014, 'Ferrari', '458 Italia', 'Coupe 2-Door'],
    [2014, 'Ferrari', '458 Spider', 'Convertible 2-Door'],
    [2014, 'Ferrari', 'California', 'Convertible 2-Door'],
    [2014, 'Ferrari', 'F12 Berlinetta', 'Coupe 2-Door'],
    [2014, 'Ferrari', 'FF', 'Hatchback 2-Door'],
    [2014, 'Ferrari', 'LaFerrari', 'Coupe 2-Door'],
    [2014, 'Fiat', '500', 'Convertible 2-Door'],
    [2014, 'Fiat', '500', 'Hatchback 2-Door'],
    [2014, 'Fiat', '500L', 'Hatchback 4-Door'],
    [2014, 'Ford', 'C-Max', 'Hatchback 4-Door'],
    [2014, 'Ford', 'E-150', 'Extended Cargo Van 3-Door'],
    [2014, 'Ford', 'E-150', 'Standard Cargo Van 3-Door'],
    [2014, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2014, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2014, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2014, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 3-Door'],
    [2014, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2014, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 3-Door'],
    [2014, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2014, 'Ford', 'Edge', 'SUV 4-Door'],
    [2014, 'Ford', 'Escape', 'SUV 4-Door'],
    [2014, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2014, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2014, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2014, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2014, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2014, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2014, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2014, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2014, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2014, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2014, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2014, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2014, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2014, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2014, 'Ford', 'Flex', 'SUV 4-Door'],
    [2014, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2014, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2014, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2014, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2014, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2014, 'Ford', 'Police Interceptor Sedan', 'Sedan 4-Door'],
    [2014, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2014, 'Ford', 'Special Service Police Sedan', 'Sedan 4-Door'],
    [2014, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2014, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2014, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2014, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2014, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2014, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2014, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2014, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2014, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2014, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2014, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2014, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2014, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2014, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2014, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2014, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2014, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2014, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2014, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2014, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2014, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2014, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2014, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2014, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2014, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2014, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2014, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2014, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2014, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2014, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2014, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2014, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2014, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2014, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2014, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2014, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2014, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2014, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2014, 'Honda', 'Crosstour', 'Hatchback 4-Door'],
    [2014, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2014, 'Honda', 'CR-Z', 'Hatchback 2-Door'],
    [2014, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2014, 'Honda', 'Insight', 'Hatchback 4-Door'],
    [2014, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2014, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2014, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2014, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2014, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2014, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2014, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2014, 'Hyundai', 'Elantra Coupe', 'Coupe 2-Door'],
    [2014, 'Hyundai', 'Elantra GT', 'Hatchback 4-Door'],
    [2014, 'Hyundai', 'Equus', 'Sedan 4-Door'],
    [2014, 'Hyundai', 'Genesis', 'Sedan 4-Door'],
    [2014, 'Hyundai', 'Genesis Coupe', 'Coupe 2-Door'],
    [2014, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2014, 'Hyundai', 'Santa Fe Sport', 'SUV 4-Door'],
    [2014, 'Hyundai', 'Santa Fe XL', 'SUV 4-Door'],
    [2014, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2014, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2014, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2014, 'INFINITI', 'Q50', 'Sedan 4-Door'],
    [2014, 'INFINITI', 'Q60', 'Convertible 2-Door'],
    [2014, 'INFINITI', 'Q60', 'Coupe 2-Door'],
    [2014, 'INFINITI', 'Q70', 'Sedan 4-Door'],
    [2014, 'INFINITI', 'QX50', 'SUV 4-Door'],
    [2014, 'INFINITI', 'QX60', 'SUV 4-Door'],
    [2014, 'INFINITI', 'QX70', 'SUV 4-Door'],
    [2014, 'INFINITI', 'QX80', 'SUV 4-Door'],
    [2014, 'Jaguar', 'F-Type', 'Convertible 2-Door'],
    [2014, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2014, 'Jaguar', 'XFR', 'Sedan 4-Door'],
    [2014, 'Jaguar', 'XFR-S', 'Sedan 4-Door'],
    [2014, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2014, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2014, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2014, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2014, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2014, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2014, 'Jaguar', 'XKR-S', 'Convertible 2-Door'],
    [2014, 'Jaguar', 'XKR-S', 'Coupe 2-Door'],
    [2014, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2014, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2014, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2014, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2014, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2014, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2014, 'Kia', 'Cadenza', 'Sedan 4-Door'],
    [2014, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2014, 'Kia', 'Forte Koup', 'Coupe 2-Door'],
    [2014, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2014, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2014, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2014, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2014, 'Kia', 'Rondo', 'Hatchback 4-Door'],
    [2014, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2014, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2014, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2014, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2014, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2014, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2014, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2014, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2014, 'Land Rover', 'LR2', 'SUV 4-Door'],
    [2014, 'Land Rover', 'LR4', 'SUV 4-Door'],
    [2014, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2014, 'Land Rover', 'Range Rover Evoque', 'SUV 2-Door'],
    [2014, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2014, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2014, 'Lexus', 'CT200h', 'Hatchback 4-Door'],
    [2014, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2014, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2014, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2014, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2014, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2014, 'Lexus', 'IS F', 'Sedan 4-Door'],
    [2014, 'Lexus', 'IS250', 'Convertible 2-Door'],
    [2014, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2014, 'Lexus', 'IS350', 'Convertible 2-Door'],
    [2014, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2014, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2014, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2014, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2014, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2014, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2014, 'Lincoln', 'MKS', 'Sedan 4-Door'],
    [2014, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2014, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2014, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2014, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2014, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2014, 'Maserati', 'Ghibli', 'Sedan 4-Door'],
    [2014, 'Maserati', 'GranTurismo', 'Convertible 2-Door'],
    [2014, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2014, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2014, 'Mazda', '2', 'Hatchback 4-Door'],
    [2014, 'Mazda', '3', 'Hatchback 4-Door'],
    [2014, 'Mazda', '3', 'Sedan 4-Door'],
    [2014, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2014, 'Mazda', '6', 'Sedan 4-Door'],
    [2014, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2014, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2014, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2014, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2014, 'McLaren', 'MP4-12C', 'Convertible 2-Door'],
    [2014, 'McLaren', 'MP4-12C', 'Coupe 2-Door'],
    [2014, 'McLaren', 'P1', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'B Electric Drive', 'Hatchback 4-Door'],
    [2014, 'Mercedes-Benz', 'B250', 'Hatchback 4-Door'],
    [2014, 'Mercedes-Benz', 'C250', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'C250', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'C350', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'CL550', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'CL63 AMG', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'CLA250', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'CLA45 AMG', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'CLS63 AMG', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'CLS63 AMG S', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'E250', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'E350', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'E350', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2014, 'Mercedes-Benz', 'E400', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'E550', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'E550', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'E63 AMG', 'Wagon 4-Door'],
    [2014, 'Mercedes-Benz', 'E63 AMG S', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'E63 AMG S', 'Wagon 4-Door'],
    [2014, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'GL350', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'GL63 AMG', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'GLK250', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'GLK350', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'ML550', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2014, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2014, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'SLK250', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'SLS AMG', 'Convertible 2-Door'],
    [2014, 'Mercedes-Benz', 'SLS AMG', 'Coupe 2-Door'],
    [2014, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2014, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2014, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2014, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2014, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2014, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2014, 'Mini', 'Cooper', 'Coupe 2-Door'],
    [2014, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2014, 'Mini', 'Cooper', 'Wagon 3-Door'],
    [2014, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2014, 'Mini', 'Cooper Paceman', 'Hatchback 2-Door'],
    [2014, 'Mitsubishi', 'i-MiEV', 'Hatchback 4-Door'],
    [2014, 'Mitsubishi', 'Lancer', 'Hatchback 4-Door'],
    [2014, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2014, 'Mitsubishi', 'Mirage', 'Hatchback 4-Door'],
    [2014, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2014, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2014, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2014, 'Mobility Ventures', 'MV-1', 'Standard Passenger Van 4-Door'],
    [2014, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2014, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2014, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2014, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2014, 'Nissan', 'Cube', 'Wagon 4-Door'],
    [2014, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2014, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2014, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2014, 'Nissan', 'Juke', 'SUV 4-Door'],
    [2014, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2014, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2014, 'Nissan', 'Murano', 'Convertible 2-Door'],
    [2014, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2014, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2014, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2014, 'Nissan', 'NV200', 'Mini Passenger Van 4-Door'],
    [2014, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2014, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2014, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2014, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2014, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2014, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2014, 'Nissan', 'Rogue Select', 'SUV 4-Door'],
    [2014, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2014, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2014, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2014, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2014, 'Nissan', 'Versa Note', 'Hatchback 4-Door'],
    [2014, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2014, 'Porsche', '911', 'Convertible 2-Door'],
    [2014, 'Porsche', '911', 'Coupe 2-Door'],
    [2014, 'Porsche', '911', 'Targa 2-Door'],
    [2014, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2014, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2014, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2014, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2014, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2014, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2014, 'Ram', '1500', 'Standard Cab Pickup 2-Door'],
    [2014, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2014, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2014, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2014, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2014, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2014, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2014, 'Ram', 'C/V', 'Mini Cargo Van 4-Door'],
    [2014, 'Ram', 'ProMaster 1500', 'Standard Cargo Van 4-Door'],
    [2014, 'Ram', 'ProMaster 2500', 'Standard Cargo Van 4-Door'],
    [2014, 'Ram', 'ProMaster 3500', 'Standard Cargo Van 4-Door'],
    [2014, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2014, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2014, 'Rolls-Royce', 'Phantom', 'Coupe 2-Door'],
    [2014, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2014, 'Rolls-Royce', 'Wraith', 'Coupe 2-Door'],
    [2014, 'Scion', 'FR-S', 'Coupe 2-Door'],
    [2014, 'Scion', 'iQ', 'Hatchback 2-Door'],
    [2014, 'Scion', 'tC', 'Coupe 2-Door'],
    [2014, 'Scion', 'xB', 'Wagon 4-Door'],
    [2014, 'Scion', 'xD', 'Hatchback 4-Door'],
    [2014, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2014, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2014, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2014, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2014, 'SRT', 'Viper', 'Coupe 2-Door'],
    [2014, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2014, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2014, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2014, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2014, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2014, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2014, 'Subaru', 'Tribeca', 'SUV 4-Door'],
    [2014, 'Subaru', 'WRX', 'Hatchback 4-Door'],
    [2014, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2014, 'Subaru', 'WRX STI', 'Hatchback 4-Door'],
    [2014, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2014, 'Subaru', 'XV Crosstrek', 'SUV 4-Door'],
    [2014, 'Tesla', 'S', 'Sedan 4-Door'],
    [2014, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2014, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2014, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2014, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2014, 'Toyota', 'FJ Cruiser', 'SUV 4-Door'],
    [2014, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2014, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2014, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2014, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2014, 'Toyota', 'Prius C', 'Hatchback 4-Door'],
    [2014, 'Toyota', 'Prius Plug-In', 'Hatchback 4-Door'],
    [2014, 'Toyota', 'Prius V', 'Wagon 4-Door'],
    [2014, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2014, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2014, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2014, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2014, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2014, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2014, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2014, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2014, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2014, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2014, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2014, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2014, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2014, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2014, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2014, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2014, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2014, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2014, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2014, 'Volkswagen', 'Golf', 'Wagon 4-Door'],
    [2014, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2014, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2014, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2014, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2014, 'Volkswagen', 'Routan', 'Mini Passenger Van 4-Door'],
    [2014, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2014, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2014, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2014, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2014, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2014, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2014, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2013, 'Acura', 'ILX', 'Sedan 4-Door'],
    [2013, 'Acura', 'MDX', 'SUV 4-Door'],
    [2013, 'Acura', 'RDX', 'SUV 4-Door'],
    [2013, 'Acura', 'TL', 'Sedan 4-Door'],
    [2013, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2013, 'Acura', 'TSX', 'Wagon 4-Door'],
    [2013, 'Acura', 'ZDX', 'SUV 4-Door'],
    [2013, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2013, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2013, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2013, 'Aston Martin', 'V12 Vantage', 'Convertible 2-Door'],
    [2013, 'Aston Martin', 'V12 Vantage', 'Hatchback 2-Door'],
    [2013, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2013, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2013, 'Audi', 'A3', 'Hatchback 4-Door'],
    [2013, 'Audi', 'A3 Quattro', 'Hatchback 4-Door'],
    [2013, 'Audi', 'A4', 'Sedan 4-Door'],
    [2013, 'Audi', 'A4 allroad', 'Wagon 4-Door'],
    [2013, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2013, 'Audi', 'A5', 'Convertible 2-Door'],
    [2013, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2013, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2013, 'Audi', 'A6', 'Sedan 4-Door'],
    [2013, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2013, 'Audi', 'A7 Quattro', 'Hatchback 4-Door'],
    [2013, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2013, 'Audi', 'allroad', 'Wagon 4-Door'],
    [2013, 'Audi', 'Q5', 'SUV 4-Door'],
    [2013, 'Audi', 'Q7', 'SUV 4-Door'],
    [2013, 'Audi', 'RS5', 'Convertible 2-Door'],
    [2013, 'Audi', 'RS5', 'Coupe 2-Door'],
    [2013, 'Audi', 'S4', 'Sedan 4-Door'],
    [2013, 'Audi', 'S5', 'Convertible 2-Door'],
    [2013, 'Audi', 'S5', 'Coupe 2-Door'],
    [2013, 'Audi', 'S6', 'Sedan 4-Door'],
    [2013, 'Audi', 'S7', 'Hatchback 4-Door'],
    [2013, 'Audi', 'S8', 'Sedan 4-Door'],
    [2013, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2013, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2013, 'Audi', 'TT RS Quattro', 'Coupe 2-Door'],
    [2013, 'Audi', 'TTS Quattro', 'Convertible 2-Door'],
    [2013, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2013, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2013, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2013, 'Bentley', 'Continental', 'Sedan 4-Door'],
    [2013, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2013, 'BMW', '128i', 'Convertible 2-Door'],
    [2013, 'BMW', '128i', 'Coupe 2-Door'],
    [2013, 'BMW', '135i', 'Convertible 2-Door'],
    [2013, 'BMW', '135i', 'Coupe 2-Door'],
    [2013, 'BMW', '135is', 'Convertible 2-Door'],
    [2013, 'BMW', '135is', 'Coupe 2-Door'],
    [2013, 'BMW', '320i', 'Sedan 4-Door'],
    [2013, 'BMW', '320i xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '328i', 'Convertible 2-Door'],
    [2013, 'BMW', '328i', 'Coupe 2-Door'],
    [2013, 'BMW', '328i', 'Sedan 4-Door'],
    [2013, 'BMW', '328i xDrive', 'Coupe 2-Door'],
    [2013, 'BMW', '328i xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '335i', 'Convertible 2-Door'],
    [2013, 'BMW', '335i', 'Coupe 2-Door'],
    [2013, 'BMW', '335i', 'Sedan 4-Door'],
    [2013, 'BMW', '335i xDrive', 'Coupe 2-Door'],
    [2013, 'BMW', '335i xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '335is', 'Convertible 2-Door'],
    [2013, 'BMW', '335is', 'Coupe 2-Door'],
    [2013, 'BMW', '528i', 'Sedan 4-Door'],
    [2013, 'BMW', '528i xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '535i', 'Sedan 4-Door'],
    [2013, 'BMW', '535i GT', 'Hatchback 4-Door'],
    [2013, 'BMW', '535i GT xDrive', 'Hatchback 4-Door'],
    [2013, 'BMW', '535i xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '550i', 'Sedan 4-Door'],
    [2013, 'BMW', '550i GT', 'Hatchback 4-Door'],
    [2013, 'BMW', '550i GT xDrive', 'Hatchback 4-Door'],
    [2013, 'BMW', '550i xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '640i', 'Convertible 2-Door'],
    [2013, 'BMW', '640i', 'Coupe 2-Door'],
    [2013, 'BMW', '640i Gran Coupe', 'Sedan 4-Door'],
    [2013, 'BMW', '650i', 'Convertible 2-Door'],
    [2013, 'BMW', '650i', 'Coupe 2-Door'],
    [2013, 'BMW', '650i Gran Coupe', 'Sedan 4-Door'],
    [2013, 'BMW', '650i xDrive', 'Convertible 2-Door'],
    [2013, 'BMW', '650i xDrive', 'Coupe 2-Door'],
    [2013, 'BMW', '650i xDrive Gran Coupe', 'Sedan 4-Door'],
    [2013, 'BMW', '740i', 'Sedan 4-Door'],
    [2013, 'BMW', '740Li', 'Sedan 4-Door'],
    [2013, 'BMW', '740Li xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '750i', 'Sedan 4-Door'],
    [2013, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '750Li', 'Sedan 4-Door'],
    [2013, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', '760Li', 'Sedan 4-Door'],
    [2013, 'BMW', 'ActiveHybrid 3', 'Sedan 4-Door'],
    [2013, 'BMW', 'ActiveHybrid 5', 'Sedan 4-Door'],
    [2013, 'BMW', 'ActiveHybrid 7', 'Sedan 4-Door'],
    [2013, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2013, 'BMW', 'Alpina B7 xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', 'Alpina B7L', 'Sedan 4-Door'],
    [2013, 'BMW', 'Alpina B7L xDrive', 'Sedan 4-Door'],
    [2013, 'BMW', 'M3', 'Convertible 2-Door'],
    [2013, 'BMW', 'M3', 'Coupe 2-Door'],
    [2013, 'BMW', 'M5', 'Sedan 4-Door'],
    [2013, 'BMW', 'M6', 'Convertible 2-Door'],
    [2013, 'BMW', 'M6', 'Coupe 2-Door'],
    [2013, 'BMW', 'X1', 'SUV 4-Door'],
    [2013, 'BMW', 'X3', 'SUV 4-Door'],
    [2013, 'BMW', 'X5', 'SUV 4-Door'],
    [2013, 'BMW', 'X6', 'SUV 4-Door'],
    [2013, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2013, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2013, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2013, 'Buick', 'Encore', 'SUV 4-Door'],
    [2013, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2013, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2013, 'Buick', 'Verano', 'Sedan 4-Door'],
    [2013, 'Cadillac', 'ATS', 'Sedan 4-Door'],
    [2013, 'Cadillac', 'CTS', 'Coupe 2-Door'],
    [2013, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2013, 'Cadillac', 'CTS', 'Wagon 4-Door'],
    [2013, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2013, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2013, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2013, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2013, 'Cadillac', 'XTS', 'Hearse 4-Door'],
    [2013, 'Cadillac', 'XTS', 'Limousine 4-Door'],
    [2013, 'Cadillac', 'XTS', 'Sedan 4-Door'],
    [2013, 'Chevrolet', 'Avalanche', 'Crew Cab Pickup 4-Door'],
    [2013, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2013, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2013, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [2013, 'Chevrolet', 'Captiva Sport', 'SUV 4-Door'],
    [2013, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2013, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2013, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2013, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2013, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2013, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2013, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2013, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2013, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2013, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2013, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2013, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2013, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2013, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2013, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2013, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2013, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2013, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2013, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2013, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2013, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2013, 'Chevrolet', 'Orlando', 'SUV 4-Door'],
    [2013, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2013, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2013, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2013, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2013, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2013, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2013, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2013, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2013, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2013, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2013, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2013, 'Chevrolet', 'Spark', 'Hatchback 4-Door'],
    [2013, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2013, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2013, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2013, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2013, 'Chevrolet', 'Trax', 'SUV 4-Door'],
    [2013, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2013, 'Chrysler', '200', 'Convertible 2-Door'],
    [2013, 'Chrysler', '200', 'Sedan 4-Door'],
    [2013, 'Chrysler', '300', 'Sedan 4-Door'],
    [2013, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2013, 'Coda', 'Sedan', 'Sedan 4-Door'],
    [2013, 'Dodge', 'Avenger', 'Sedan 4-Door'],
    [2013, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2013, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2013, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [2013, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2013, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2013, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2013, 'Ferrari', '458 Italia', 'Coupe 2-Door'],
    [2013, 'Ferrari', '458 Spider', 'Convertible 2-Door'],
    [2013, 'Ferrari', 'California', 'Convertible 2-Door'],
    [2013, 'Ferrari', 'F12 Berlinetta', 'Coupe 2-Door'],
    [2013, 'Ferrari', 'FF', 'Hatchback 2-Door'],
    [2013, 'Fiat', '500', 'Convertible 2-Door'],
    [2013, 'Fiat', '500', 'Hatchback 2-Door'],
    [2013, 'Ford', 'C-Max', 'Hatchback 4-Door'],
    [2013, 'Ford', 'E-150', 'Extended Cargo Van 3-Door'],
    [2013, 'Ford', 'E-150', 'Standard Cargo Van 3-Door'],
    [2013, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2013, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2013, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2013, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 3-Door'],
    [2013, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2013, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 3-Door'],
    [2013, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2013, 'Ford', 'Edge', 'SUV 4-Door'],
    [2013, 'Ford', 'Escape', 'SUV 4-Door'],
    [2013, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2013, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2013, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2013, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2013, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2013, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2013, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2013, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2013, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2013, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2013, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2013, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2013, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2013, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2013, 'Ford', 'Flex', 'SUV 4-Door'],
    [2013, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2013, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2013, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2013, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2013, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2013, 'Ford', 'Police Interceptor Sedan', 'Sedan 4-Door'],
    [2013, 'Ford', 'Police Interceptor Utility', 'SUV 4-Door'],
    [2013, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2013, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2013, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2013, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2013, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2013, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2013, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2013, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2013, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2013, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2013, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2013, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2013, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2013, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2013, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2013, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2013, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2013, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2013, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2013, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2013, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2013, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2013, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2013, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2013, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2013, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2013, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2013, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2013, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2013, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2013, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2013, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2013, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2013, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2013, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2013, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2013, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2013, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2013, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2013, 'Honda', 'Crosstour', 'Hatchback 4-Door'],
    [2013, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2013, 'Honda', 'CR-Z', 'Hatchback 2-Door'],
    [2013, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2013, 'Honda', 'Insight', 'Hatchback 4-Door'],
    [2013, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2013, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2013, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2013, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2013, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2013, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2013, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2013, 'Hyundai', 'Elantra Coupe', 'Coupe 2-Door'],
    [2013, 'Hyundai', 'Elantra GT', 'Hatchback 4-Door'],
    [2013, 'Hyundai', 'Equus', 'Sedan 4-Door'],
    [2013, 'Hyundai', 'Genesis', 'Sedan 4-Door'],
    [2013, 'Hyundai', 'Genesis Coupe', 'Coupe 2-Door'],
    [2013, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2013, 'Hyundai', 'Santa Fe Sport', 'SUV 4-Door'],
    [2013, 'Hyundai', 'Santa Fe XL', 'SUV 4-Door'],
    [2013, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2013, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2013, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2013, 'INFINITI', 'EX37', 'SUV 4-Door'],
    [2013, 'INFINITI', 'FX37', 'SUV 4-Door'],
    [2013, 'INFINITI', 'FX50', 'SUV 4-Door'],
    [2013, 'INFINITI', 'G37', 'Convertible 2-Door'],
    [2013, 'INFINITI', 'G37', 'Coupe 2-Door'],
    [2013, 'INFINITI', 'G37', 'Sedan 4-Door'],
    [2013, 'INFINITI', 'JX35', 'SUV 4-Door'],
    [2013, 'INFINITI', 'M35h', 'Sedan 4-Door'],
    [2013, 'INFINITI', 'M37', 'Sedan 4-Door'],
    [2013, 'INFINITI', 'M56', 'Sedan 4-Door'],
    [2013, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2013, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2013, 'Jaguar', 'XFR', 'Sedan 4-Door'],
    [2013, 'Jaguar', 'XFR-S', 'Sedan 4-Door'],
    [2013, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2013, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2013, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2013, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2013, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2013, 'Jaguar', 'XKR-S', 'Convertible 2-Door'],
    [2013, 'Jaguar', 'XKR-S', 'Coupe 2-Door'],
    [2013, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2013, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2013, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2013, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2013, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2013, 'Kia', 'Forte', 'Hatchback 4-Door'],
    [2013, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2013, 'Kia', 'Forte Koup', 'Coupe 2-Door'],
    [2013, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2013, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2013, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2013, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2013, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2013, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2013, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2013, 'Lamborghini', 'Aventador', 'Convertible 2-Door'],
    [2013, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2013, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2013, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2013, 'Land Rover', 'LR2', 'SUV 4-Door'],
    [2013, 'Land Rover', 'LR4', 'SUV 4-Door'],
    [2013, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2013, 'Land Rover', 'Range Rover Evoque', 'SUV 2-Door'],
    [2013, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2013, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2013, 'Lexus', 'CT200h', 'Hatchback 4-Door'],
    [2013, 'Lexus', 'ES300h', 'Sedan 4-Door'],
    [2013, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2013, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2013, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2013, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2013, 'Lexus', 'IS F', 'Sedan 4-Door'],
    [2013, 'Lexus', 'IS250', 'Convertible 2-Door'],
    [2013, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2013, 'Lexus', 'IS350', 'Convertible 2-Door'],
    [2013, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2013, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2013, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2013, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2013, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2013, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2013, 'Lincoln', 'MKS', 'Sedan 4-Door'],
    [2013, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2013, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2013, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2013, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2013, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2013, 'Maserati', 'GranTurismo', 'Convertible 2-Door'],
    [2013, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2013, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2013, 'Mazda', '2', 'Hatchback 4-Door'],
    [2013, 'Mazda', '3', 'Hatchback 4-Door'],
    [2013, 'Mazda', '3', 'Sedan 4-Door'],
    [2013, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2013, 'Mazda', '6', 'Sedan 4-Door'],
    [2013, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2013, 'Mazda', 'CX-5', 'SUV 4-Door'],
    [2013, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2013, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2013, 'McLaren', 'MP4-12C', 'Convertible 2-Door'],
    [2013, 'McLaren', 'MP4-12C', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'B250', 'Hatchback 4-Door'],
    [2013, 'Mercedes-Benz', 'C250', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'C250', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'C350', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'CL550', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'CL63 AMG', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'CLS63 AMG', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'E350', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'E350', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2013, 'Mercedes-Benz', 'E400', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'E550', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'E550', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'E63 AMG', 'Wagon 4-Door'],
    [2013, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'G63 AMG', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'GL350', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'GL63 AMG', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'GLK250', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'GLK350', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'ML550', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2013, 'Mercedes-Benz', 'R350', 'Wagon 4-Door'],
    [2013, 'Mercedes-Benz', 'S350', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'S400', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2013, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'SLK250', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'SLS AMG', 'Convertible 2-Door'],
    [2013, 'Mercedes-Benz', 'SLS AMG', 'Coupe 2-Door'],
    [2013, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2013, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2013, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2013, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2013, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2013, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2013, 'Mini', 'Cooper', 'Coupe 2-Door'],
    [2013, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2013, 'Mini', 'Cooper', 'Wagon 3-Door'],
    [2013, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2013, 'Mini', 'Cooper Paceman', 'Hatchback 2-Door'],
    [2013, 'Mitsubishi', 'Lancer', 'Hatchback 4-Door'],
    [2013, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2013, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2013, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2013, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2013, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2013, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2013, 'Nissan', 'Altima', 'Coupe 2-Door'],
    [2013, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2013, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2013, 'Nissan', 'Cube', 'Wagon 4-Door'],
    [2013, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2013, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2013, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2013, 'Nissan', 'Juke', 'SUV 4-Door'],
    [2013, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2013, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2013, 'Nissan', 'Murano', 'Convertible 2-Door'],
    [2013, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2013, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2013, 'Nissan', 'NV200', 'Mini Cargo Van 4-Door'],
    [2013, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2013, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2013, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2013, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2013, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2013, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2013, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2013, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2013, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2013, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2013, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2013, 'Porsche', '911', 'Convertible 2-Door'],
    [2013, 'Porsche', '911', 'Coupe 2-Door'],
    [2013, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2013, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2013, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2013, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2013, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2013, 'Ram', '1500', 'Standard Cab Pickup 2-Door'],
    [2013, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2013, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2013, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2013, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2013, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2013, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2013, 'Ram', 'C/V', 'Mini Cargo Van 4-Door'],
    [2013, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2013, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2013, 'Rolls-Royce', 'Phantom', 'Coupe 2-Door'],
    [2013, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2013, 'Scion', 'FR-S', 'Coupe 2-Door'],
    [2013, 'Scion', 'iQ', 'Hatchback 2-Door'],
    [2013, 'Scion', 'tC', 'Coupe 2-Door'],
    [2013, 'Scion', 'xB', 'Wagon 4-Door'],
    [2013, 'Scion', 'xD', 'Hatchback 4-Door'],
    [2013, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2013, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2013, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2013, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2013, 'SRT', 'Viper', 'Coupe 2-Door'],
    [2013, 'Subaru', 'BRZ', 'Coupe 2-Door'],
    [2013, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2013, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2013, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2013, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2013, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2013, 'Subaru', 'Tribeca', 'SUV 4-Door'],
    [2013, 'Subaru', 'WRX', 'Hatchback 4-Door'],
    [2013, 'Subaru', 'WRX', 'Sedan 4-Door'],
    [2013, 'Subaru', 'WRX STI', 'Hatchback 4-Door'],
    [2013, 'Subaru', 'WRX STI', 'Sedan 4-Door'],
    [2013, 'Subaru', 'XV Crosstrek', 'SUV 4-Door'],
    [2013, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2013, 'Suzuki', 'Kizashi', 'Sedan 4-Door'],
    [2013, 'Suzuki', 'SX4', 'Hatchback 4-Door'],
    [2013, 'Suzuki', 'SX4', 'Sedan 4-Door'],
    [2013, 'Tesla', 'S', 'Sedan 4-Door'],
    [2013, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2013, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2013, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2013, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2013, 'Toyota', 'FJ Cruiser', 'SUV 4-Door'],
    [2013, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2013, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2013, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2013, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2013, 'Toyota', 'Prius C', 'Hatchback 4-Door'],
    [2013, 'Toyota', 'Prius Plug-In', 'Hatchback 4-Door'],
    [2013, 'Toyota', 'Prius V', 'Wagon 4-Door'],
    [2013, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2013, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2013, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2013, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2013, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2013, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2013, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2013, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2013, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2013, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2013, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2013, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2013, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2013, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2013, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2013, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2013, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2013, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2013, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2013, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2013, 'Volkswagen', 'Golf', 'Wagon 4-Door'],
    [2013, 'Volkswagen', 'Golf R', 'Hatchback 2-Door'],
    [2013, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2013, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2013, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2013, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2013, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2013, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2013, 'Volkswagen', 'Routan', 'Mini Passenger Van 4-Door'],
    [2013, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2013, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2013, 'Volvo', 'C30', 'Hatchback 2-Door'],
    [2013, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2013, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2013, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2013, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2013, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2013, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2012, 'Acura', 'MDX', 'SUV 4-Door'],
    [2012, 'Acura', 'RDX', 'SUV 4-Door'],
    [2012, 'Acura', 'RL', 'Sedan 4-Door'],
    [2012, 'Acura', 'TL', 'Sedan 4-Door'],
    [2012, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2012, 'Acura', 'TSX', 'Wagon 4-Door'],
    [2012, 'Acura', 'ZDX', 'SUV 4-Door'],
    [2012, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2012, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2012, 'Aston Martin', 'DBS', 'Convertible 2-Door'],
    [2012, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2012, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2012, 'Aston Martin', 'V12 Vantage', 'Convertible 2-Door'],
    [2012, 'Aston Martin', 'V12 Vantage', 'Hatchback 2-Door'],
    [2012, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2012, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2012, 'Aston Martin', 'Virage', 'Convertible 2-Door'],
    [2012, 'Aston Martin', 'Virage', 'Coupe 2-Door'],
    [2012, 'Audi', 'A3', 'Hatchback 4-Door'],
    [2012, 'Audi', 'A3 Quattro', 'Hatchback 4-Door'],
    [2012, 'Audi', 'A4', 'Sedan 4-Door'],
    [2012, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2012, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2012, 'Audi', 'A5', 'Convertible 2-Door'],
    [2012, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2012, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2012, 'Audi', 'A6', 'Sedan 4-Door'],
    [2012, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2012, 'Audi', 'A7 Quattro', 'Hatchback 4-Door'],
    [2012, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2012, 'Audi', 'Q5', 'SUV 4-Door'],
    [2012, 'Audi', 'Q7', 'SUV 4-Door'],
    [2012, 'Audi', 'R8', 'Convertible 2-Door'],
    [2012, 'Audi', 'R8', 'Coupe 2-Door'],
    [2012, 'Audi', 'S4', 'Sedan 4-Door'],
    [2012, 'Audi', 'S5', 'Convertible 2-Door'],
    [2012, 'Audi', 'S5', 'Coupe 2-Door'],
    [2012, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2012, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2012, 'Audi', 'TT RS Quattro', 'Coupe 2-Door'],
    [2012, 'Audi', 'TTS Quattro', 'Convertible 2-Door'],
    [2012, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2012, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2012, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2012, 'Bentley', 'Continental', 'Sedan 4-Door'],
    [2012, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2012, 'BMW', '128i', 'Convertible 2-Door'],
    [2012, 'BMW', '128i', 'Coupe 2-Door'],
    [2012, 'BMW', '135i', 'Convertible 2-Door'],
    [2012, 'BMW', '135i', 'Coupe 2-Door'],
    [2012, 'BMW', '320i', 'Sedan 4-Door'],
    [2012, 'BMW', '328i', 'Convertible 2-Door'],
    [2012, 'BMW', '328i', 'Coupe 2-Door'],
    [2012, 'BMW', '328i', 'Sedan 4-Door'],
    [2012, 'BMW', '328i', 'Wagon 4-Door'],
    [2012, 'BMW', '328i xDrive', 'Coupe 2-Door'],
    [2012, 'BMW', '328i xDrive', 'Wagon 4-Door'],
    [2012, 'BMW', '335i', 'Convertible 2-Door'],
    [2012, 'BMW', '335i', 'Coupe 2-Door'],
    [2012, 'BMW', '335i', 'Sedan 4-Door'],
    [2012, 'BMW', '335i xDrive', 'Coupe 2-Door'],
    [2012, 'BMW', '335is', 'Convertible 2-Door'],
    [2012, 'BMW', '335is', 'Coupe 2-Door'],
    [2012, 'BMW', '528i', 'Sedan 4-Door'],
    [2012, 'BMW', '528i xDrive', 'Sedan 4-Door'],
    [2012, 'BMW', '535i', 'Sedan 4-Door'],
    [2012, 'BMW', '535i GT', 'Hatchback 4-Door'],
    [2012, 'BMW', '535i GT xDrive', 'Hatchback 4-Door'],
    [2012, 'BMW', '535i xDrive', 'Sedan 4-Door'],
    [2012, 'BMW', '550i', 'Sedan 4-Door'],
    [2012, 'BMW', '550i GT', 'Hatchback 4-Door'],
    [2012, 'BMW', '550i GT xDrive', 'Hatchback 4-Door'],
    [2012, 'BMW', '550i xDrive', 'Sedan 4-Door'],
    [2012, 'BMW', '640i', 'Convertible 2-Door'],
    [2012, 'BMW', '640i', 'Coupe 2-Door'],
    [2012, 'BMW', '650i', 'Convertible 2-Door'],
    [2012, 'BMW', '650i', 'Coupe 2-Door'],
    [2012, 'BMW', '650i xDrive', 'Convertible 2-Door'],
    [2012, 'BMW', '650i xDrive', 'Coupe 2-Door'],
    [2012, 'BMW', '740i', 'Sedan 4-Door'],
    [2012, 'BMW', '740Li', 'Sedan 4-Door'],
    [2012, 'BMW', '750i', 'Sedan 4-Door'],
    [2012, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2012, 'BMW', '750Li', 'Sedan 4-Door'],
    [2012, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2012, 'BMW', '760Li', 'Sedan 4-Door'],
    [2012, 'BMW', 'ActiveHybrid 5', 'Sedan 4-Door'],
    [2012, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2012, 'BMW', 'Alpina B7 xDrive', 'Sedan 4-Door'],
    [2012, 'BMW', 'Alpina B7L', 'Sedan 4-Door'],
    [2012, 'BMW', 'Alpina B7L xDrive', 'Sedan 4-Door'],
    [2012, 'BMW', 'M3', 'Convertible 2-Door'],
    [2012, 'BMW', 'M3', 'Coupe 2-Door'],
    [2012, 'BMW', 'M5', 'Sedan 4-Door'],
    [2012, 'BMW', 'M6', 'Convertible 2-Door'],
    [2012, 'BMW', 'X1', 'SUV 4-Door'],
    [2012, 'BMW', 'X3', 'SUV 4-Door'],
    [2012, 'BMW', 'X5', 'SUV 4-Door'],
    [2012, 'BMW', 'X6', 'SUV 4-Door'],
    [2012, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2012, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2012, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2012, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2012, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2012, 'Buick', 'Verano', 'Sedan 4-Door'],
    [2012, 'Cadillac', 'CTS', 'Coupe 2-Door'],
    [2012, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2012, 'Cadillac', 'CTS', 'Wagon 4-Door'],
    [2012, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2012, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2012, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2012, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2012, 'Chevrolet', 'Avalanche', 'Crew Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2012, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2012, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [2012, 'Chevrolet', 'Captiva Sport', 'SUV 4-Door'],
    [2012, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2012, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2012, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2012, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2012, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2012, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2012, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2012, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2012, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2012, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2012, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2012, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2012, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2012, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2012, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2012, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2012, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2012, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2012, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2012, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2012, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2012, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2012, 'Chevrolet', 'Orlando', 'SUV 4-Door'],
    [2012, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2012, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2012, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2012, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2012, 'Chevrolet', 'Sonic', 'Hatchback 4-Door'],
    [2012, 'Chevrolet', 'Sonic', 'Sedan 4-Door'],
    [2012, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2012, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2012, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2012, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2012, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2012, 'Chrysler', '200', 'Convertible 2-Door'],
    [2012, 'Chrysler', '200', 'Sedan 4-Door'],
    [2012, 'Chrysler', '300', 'Sedan 4-Door'],
    [2012, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2012, 'Coda', 'Sedan', 'Sedan 4-Door'],
    [2012, 'Dodge', 'Avenger', 'Sedan 4-Door'],
    [2012, 'Dodge', 'Caliber', 'Hatchback 4-Door'],
    [2012, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2012, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2012, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2012, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2012, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2012, 'Ferrari', '458 Italia', 'Coupe 2-Door'],
    [2012, 'Ferrari', '458 Spider', 'Convertible 2-Door'],
    [2012, 'Ferrari', 'California', 'Convertible 2-Door'],
    [2012, 'Ferrari', 'FF', 'Hatchback 2-Door'],
    [2012, 'Fiat', '500', 'Convertible 2-Door'],
    [2012, 'Fiat', '500', 'Hatchback 2-Door'],
    [2012, 'Fisker', 'Karma', 'Sedan 4-Door'],
    [2012, 'Ford', 'E-150', 'Extended Cargo Van 3-Door'],
    [2012, 'Ford', 'E-150', 'Standard Cargo Van 3-Door'],
    [2012, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2012, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2012, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2012, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 3-Door'],
    [2012, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2012, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 3-Door'],
    [2012, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2012, 'Ford', 'Edge', 'SUV 4-Door'],
    [2012, 'Ford', 'Escape', 'SUV 4-Door'],
    [2012, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2012, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2012, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2012, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2012, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2012, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2012, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2012, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2012, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2012, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2012, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2012, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2012, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2012, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2012, 'Ford', 'Flex', 'SUV 4-Door'],
    [2012, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2012, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2012, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2012, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2012, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2012, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2012, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2012, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2012, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2012, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2012, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2012, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2012, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2012, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2012, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2012, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2012, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2012, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2012, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2012, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2012, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2012, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2012, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2012, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2012, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2012, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2012, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2012, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2012, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2012, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2012, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2012, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2012, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2012, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2012, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2012, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2012, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2012, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2012, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2012, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2012, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2012, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2012, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2012, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2012, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2012, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2012, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2012, 'Honda', 'Crosstour', 'Hatchback 4-Door'],
    [2012, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2012, 'Honda', 'CR-Z', 'Hatchback 2-Door'],
    [2012, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2012, 'Honda', 'Insight', 'Hatchback 4-Door'],
    [2012, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2012, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2012, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2012, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2012, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2012, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2012, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2012, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2012, 'Hyundai', 'Equus', 'Sedan 4-Door'],
    [2012, 'Hyundai', 'Genesis', 'Sedan 4-Door'],
    [2012, 'Hyundai', 'Genesis Coupe', 'Coupe 2-Door'],
    [2012, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2012, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2012, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2012, 'Hyundai', 'Veloster', 'Hatchback 3-Door'],
    [2012, 'Hyundai', 'Veracruz', 'SUV 4-Door'],
    [2012, 'INFINITI', 'EX35', 'SUV 4-Door'],
    [2012, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2012, 'INFINITI', 'FX50', 'SUV 4-Door'],
    [2012, 'INFINITI', 'G25', 'Sedan 4-Door'],
    [2012, 'INFINITI', 'G37', 'Convertible 2-Door'],
    [2012, 'INFINITI', 'G37', 'Coupe 2-Door'],
    [2012, 'INFINITI', 'G37', 'Sedan 4-Door'],
    [2012, 'INFINITI', 'M35h', 'Sedan 4-Door'],
    [2012, 'INFINITI', 'M37', 'Sedan 4-Door'],
    [2012, 'INFINITI', 'M56', 'Sedan 4-Door'],
    [2012, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2012, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2012, 'Jaguar', 'XFR', 'Sedan 4-Door'],
    [2012, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2012, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2012, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2012, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2012, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2012, 'Jaguar', 'XKR-S', 'Convertible 2-Door'],
    [2012, 'Jaguar', 'XKR-S', 'Coupe 2-Door'],
    [2012, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2012, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2012, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2012, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2012, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2012, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2012, 'Kia', 'Forte', 'Hatchback 4-Door'],
    [2012, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2012, 'Kia', 'Forte Koup', 'Coupe 2-Door'],
    [2012, 'Kia', 'Forte5', 'Hatchback 4-Door'],
    [2012, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2012, 'Kia', 'Rio', 'Hatchback 4-Door'],
    [2012, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2012, 'Kia', 'Rondo', 'Wagon 4-Door'],
    [2012, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2012, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2012, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2012, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2012, 'Lamborghini', 'Aventador', 'Coupe 2-Door'],
    [2012, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2012, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2012, 'Land Rover', 'LR2', 'SUV 4-Door'],
    [2012, 'Land Rover', 'LR4', 'SUV 4-Door'],
    [2012, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2012, 'Land Rover', 'Range Rover Evoque', 'SUV 2-Door'],
    [2012, 'Land Rover', 'Range Rover Evoque', 'SUV 4-Door'],
    [2012, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2012, 'Lexus', 'CT200h', 'Hatchback 4-Door'],
    [2012, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2012, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2012, 'Lexus', 'HS250h', 'Sedan 4-Door'],
    [2012, 'Lexus', 'IS F', 'Sedan 4-Door'],
    [2012, 'Lexus', 'IS250', 'Convertible 2-Door'],
    [2012, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2012, 'Lexus', 'IS350', 'Convertible 2-Door'],
    [2012, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2012, 'Lexus', 'LFA', 'Coupe 2-Door'],
    [2012, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2012, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2012, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2012, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2012, 'Lincoln', 'MKS', 'Sedan 4-Door'],
    [2012, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2012, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2012, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2012, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2012, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2012, 'Maserati', 'GranTurismo', 'Convertible 2-Door'],
    [2012, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2012, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2012, 'Maybach', '57', 'Sedan 4-Door'],
    [2012, 'Maybach', '62', 'Sedan 4-Door'],
    [2012, 'Mazda', '2', 'Hatchback 4-Door'],
    [2012, 'Mazda', '3', 'Hatchback 4-Door'],
    [2012, 'Mazda', '3', 'Sedan 4-Door'],
    [2012, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2012, 'Mazda', '6', 'Sedan 4-Door'],
    [2012, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2012, 'Mazda', 'CX-7', 'SUV 4-Door'],
    [2012, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2012, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2012, 'McLaren', 'MP4-12C', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'C250', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'C250', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'C350', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'C63 AMG', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'CL550', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'CL63 AMG', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'CLS63 AMG', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'E350', 'Convertible 2-Door'],
    [2012, 'Mercedes-Benz', 'E350', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2012, 'Mercedes-Benz', 'E550', 'Convertible 2-Door'],
    [2012, 'Mercedes-Benz', 'E550', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'E63 AMG', 'Wagon 4-Door'],
    [2012, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2012, 'Mercedes-Benz', 'GL350', 'SUV 4-Door'],
    [2012, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2012, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2012, 'Mercedes-Benz', 'GLK350', 'SUV 4-Door'],
    [2012, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2012, 'Mercedes-Benz', 'ML550', 'SUV 4-Door'],
    [2012, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2012, 'Mercedes-Benz', 'R350', 'Wagon 4-Door'],
    [2012, 'Mercedes-Benz', 'S350', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'S400', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2012, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2012, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2012, 'Mercedes-Benz', 'SLK250', 'Convertible 2-Door'],
    [2012, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2012, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2012, 'Mercedes-Benz', 'SLS AMG', 'Convertible 2-Door'],
    [2012, 'Mercedes-Benz', 'SLS AMG', 'Coupe 2-Door'],
    [2012, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 2-Door'],
    [2012, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2012, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2012, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2012, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2012, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2012, 'Mini', 'Cooper', 'Coupe 2-Door'],
    [2012, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2012, 'Mini', 'Cooper', 'Wagon 3-Door'],
    [2012, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2012, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2012, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2012, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2012, 'Mitsubishi', 'i-MiEV', 'Hatchback 4-Door'],
    [2012, 'Mitsubishi', 'Lancer', 'Hatchback 4-Door'],
    [2012, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2012, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2012, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2012, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2012, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2012, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2012, 'Nissan', 'Altima', 'Coupe 2-Door'],
    [2012, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2012, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2012, 'Nissan', 'Cube', 'Wagon 4-Door'],
    [2012, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2012, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2012, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2012, 'Nissan', 'Juke', 'SUV 4-Door'],
    [2012, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2012, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2012, 'Nissan', 'Murano', 'Convertible 2-Door'],
    [2012, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2012, 'Nissan', 'NV1500', 'Standard Cargo Van 3-Door'],
    [2012, 'Nissan', 'NV2500', 'Standard Cargo Van 3-Door'],
    [2012, 'Nissan', 'NV3500', 'Standard Cargo Van 3-Door'],
    [2012, 'Nissan', 'NV3500', 'Standard Passenger Van 3-Door'],
    [2012, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2012, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2012, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2012, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2012, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2012, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2012, 'Nissan', 'Versa', 'Hatchback 4-Door'],
    [2012, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2012, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2012, 'Porsche', '911', 'Convertible 2-Door'],
    [2012, 'Porsche', '911', 'Coupe 2-Door'],
    [2012, 'Porsche', '911', 'Targa 2-Door'],
    [2012, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2012, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2012, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2012, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2012, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2012, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2012, 'Ram', '1500', 'Standard Cab Pickup 2-Door'],
    [2012, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2012, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2012, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2012, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2012, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2012, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2012, 'Ram', 'C/V', 'Mini Cargo Van 4-Door'],
    [2012, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2012, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2012, 'Rolls-Royce', 'Phantom', 'Coupe 2-Door'],
    [2012, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2012, 'Scion', 'iQ', 'Hatchback 2-Door'],
    [2012, 'Scion', 'tC', 'Coupe 2-Door'],
    [2012, 'Scion', 'xB', 'Wagon 4-Door'],
    [2012, 'Scion', 'xD', 'Hatchback 4-Door'],
    [2012, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2012, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2012, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2012, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2012, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2012, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2012, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2012, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2012, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2012, 'Subaru', 'Tribeca', 'SUV 4-Door'],
    [2012, 'Suzuki', 'Equator', 'Crew Cab Pickup 4-Door'],
    [2012, 'Suzuki', 'Equator', 'Extended Cab Pickup 4-Door'],
    [2012, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2012, 'Suzuki', 'Kizashi', 'Sedan 4-Door'],
    [2012, 'Suzuki', 'SX4', 'Hatchback 4-Door'],
    [2012, 'Suzuki', 'SX4', 'Sedan 4-Door'],
    [2012, 'Suzuki', 'SX4 Crossover', 'Hatchback 4-Door'],
    [2012, 'Tesla', 'S', 'Sedan 4-Door'],
    [2012, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2012, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2012, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2012, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2012, 'Toyota', 'FJ Cruiser', 'SUV 4-Door'],
    [2012, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2012, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2012, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2012, 'Toyota', 'Prius C', 'Hatchback 4-Door'],
    [2012, 'Toyota', 'Prius Plug-In', 'Hatchback 4-Door'],
    [2012, 'Toyota', 'Prius V', 'Wagon 4-Door'],
    [2012, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2012, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2012, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2012, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2012, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2012, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2012, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2012, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2012, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2012, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2012, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2012, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2012, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2012, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2012, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2012, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2012, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2012, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2012, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2012, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2012, 'Volkswagen', 'Golf', 'Wagon 4-Door'],
    [2012, 'Volkswagen', 'Golf R', 'Hatchback 2-Door'],
    [2012, 'Volkswagen', 'Golf R', 'Hatchback 4-Door'],
    [2012, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2012, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2012, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2012, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2012, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2012, 'Volkswagen', 'Routan', 'Mini Passenger Van 4-Door'],
    [2012, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2012, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2012, 'Volvo', 'C30', 'Hatchback 2-Door'],
    [2012, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2012, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2012, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2012, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2012, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2012, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2012, 'VPG', 'MV-1', 'Standard Passenger Van 4-Door'],
    [2011, 'Acura', 'CSX', 'Sedan 4-Door'],
    [2011, 'Acura', 'MDX', 'SUV 4-Door'],
    [2011, 'Acura', 'RDX', 'SUV 4-Door'],
    [2011, 'Acura', 'RL', 'Sedan 4-Door'],
    [2011, 'Acura', 'TL', 'Sedan 4-Door'],
    [2011, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2011, 'Acura', 'TSX', 'Wagon 4-Door'],
    [2011, 'Acura', 'ZDX', 'SUV 4-Door'],
    [2011, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2011, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2011, 'Aston Martin', 'DBS', 'Convertible 2-Door'],
    [2011, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2011, 'Aston Martin', 'One-77', 'Coupe 2-Door'],
    [2011, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2011, 'Aston Martin', 'V12 Vantage', 'Convertible 2-Door'],
    [2011, 'Aston Martin', 'V12 Vantage', 'Hatchback 2-Door'],
    [2011, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2011, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2011, 'Audi', 'A3', 'Hatchback 4-Door'],
    [2011, 'Audi', 'A3 Quattro', 'Hatchback 4-Door'],
    [2011, 'Audi', 'A4', 'Sedan 4-Door'],
    [2011, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2011, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2011, 'Audi', 'A5', 'Convertible 2-Door'],
    [2011, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2011, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2011, 'Audi', 'A6', 'Sedan 4-Door'],
    [2011, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2011, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2011, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2011, 'Audi', 'Q5', 'SUV 4-Door'],
    [2011, 'Audi', 'Q7', 'SUV 4-Door'],
    [2011, 'Audi', 'R8', 'Convertible 2-Door'],
    [2011, 'Audi', 'R8', 'Coupe 2-Door'],
    [2011, 'Audi', 'S4', 'Sedan 4-Door'],
    [2011, 'Audi', 'S5', 'Convertible 2-Door'],
    [2011, 'Audi', 'S5', 'Coupe 2-Door'],
    [2011, 'Audi', 'S6', 'Sedan 4-Door'],
    [2011, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2011, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2011, 'Audi', 'TTS Quattro', 'Convertible 2-Door'],
    [2011, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2011, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2011, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2011, 'Bentley', 'Continental', 'Sedan 4-Door'],
    [2011, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [2011, 'BMW', '1 Series M', 'Coupe 2-Door'],
    [2011, 'BMW', '128i', 'Convertible 2-Door'],
    [2011, 'BMW', '128i', 'Coupe 2-Door'],
    [2011, 'BMW', '135i', 'Convertible 2-Door'],
    [2011, 'BMW', '135i', 'Coupe 2-Door'],
    [2011, 'BMW', '323i', 'Sedan 4-Door'],
    [2011, 'BMW', '328i', 'Convertible 2-Door'],
    [2011, 'BMW', '328i', 'Coupe 2-Door'],
    [2011, 'BMW', '328i', 'Sedan 4-Door'],
    [2011, 'BMW', '328i', 'Wagon 4-Door'],
    [2011, 'BMW', '328i xDrive', 'Coupe 2-Door'],
    [2011, 'BMW', '328i xDrive', 'Sedan 4-Door'],
    [2011, 'BMW', '328i xDrive', 'Wagon 4-Door'],
    [2011, 'BMW', '335d', 'Sedan 4-Door'],
    [2011, 'BMW', '335i', 'Convertible 2-Door'],
    [2011, 'BMW', '335i', 'Coupe 2-Door'],
    [2011, 'BMW', '335i', 'Sedan 4-Door'],
    [2011, 'BMW', '335i xDrive', 'Coupe 2-Door'],
    [2011, 'BMW', '335i xDrive', 'Sedan 4-Door'],
    [2011, 'BMW', '335is', 'Convertible 2-Door'],
    [2011, 'BMW', '335is', 'Coupe 2-Door'],
    [2011, 'BMW', '528i', 'Sedan 4-Door'],
    [2011, 'BMW', '535i', 'Sedan 4-Door'],
    [2011, 'BMW', '535i GT', 'Hatchback 4-Door'],
    [2011, 'BMW', '535i GT xDrive', 'Hatchback 4-Door'],
    [2011, 'BMW', '535i xDrive', 'Sedan 4-Door'],
    [2011, 'BMW', '550i', 'Sedan 4-Door'],
    [2011, 'BMW', '550i GT', 'Hatchback 4-Door'],
    [2011, 'BMW', '550i GT xDrive', 'Hatchback 4-Door'],
    [2011, 'BMW', '550i xDrive', 'Sedan 4-Door'],
    [2011, 'BMW', '740i', 'Sedan 4-Door'],
    [2011, 'BMW', '740Li', 'Sedan 4-Door'],
    [2011, 'BMW', '750i', 'Sedan 4-Door'],
    [2011, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2011, 'BMW', '750Li', 'Sedan 4-Door'],
    [2011, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2011, 'BMW', '760Li', 'Sedan 4-Door'],
    [2011, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2011, 'BMW', 'Alpina B7 xDrive', 'Sedan 4-Door'],
    [2011, 'BMW', 'Alpina B7L', 'Sedan 4-Door'],
    [2011, 'BMW', 'Alpina B7L xDrive', 'Sedan 4-Door'],
    [2011, 'BMW', 'M3', 'Convertible 2-Door'],
    [2011, 'BMW', 'M3', 'Coupe 2-Door'],
    [2011, 'BMW', 'M3', 'Sedan 4-Door'],
    [2011, 'BMW', 'X3', 'SUV 4-Door'],
    [2011, 'BMW', 'X5', 'SUV 4-Door'],
    [2011, 'BMW', 'X6', 'SUV 4-Door'],
    [2011, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2011, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2011, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2011, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2011, 'Buick', 'Lucerne', 'Sedan 4-Door'],
    [2011, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2011, 'Cadillac', 'CTS', 'Coupe 2-Door'],
    [2011, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2011, 'Cadillac', 'CTS', 'Wagon 4-Door'],
    [2011, 'Cadillac', 'DTS', 'Hearse 4-Door'],
    [2011, 'Cadillac', 'DTS', 'Limousine 4-Door'],
    [2011, 'Cadillac', 'DTS', 'Sedan 4-Door'],
    [2011, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2011, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2011, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2011, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2011, 'Cadillac', 'STS', 'Sedan 4-Door'],
    [2011, 'Chevrolet', 'Avalanche', 'Crew Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Aveo', 'Sedan 4-Door'],
    [2011, 'Chevrolet', 'Aveo5', 'Hatchback 4-Door'],
    [2011, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2011, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2011, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [2011, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2011, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2011, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2011, 'Chevrolet', 'Cruze', 'Sedan 4-Door'],
    [2011, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2011, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2011, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2011, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2011, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2011, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2011, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2011, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2011, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2011, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2011, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2011, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2011, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2011, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2011, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2011, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2011, 'Chevrolet', 'HHR', 'Wagon 2-Door'],
    [2011, 'Chevrolet', 'HHR', 'Wagon 4-Door'],
    [2011, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2011, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2011, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2011, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2011, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2011, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2011, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2011, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2011, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2011, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2011, 'Chevrolet', 'Volt', 'Hatchback 4-Door'],
    [2011, 'Chrysler', '200', 'Convertible 2-Door'],
    [2011, 'Chrysler', '200', 'Sedan 4-Door'],
    [2011, 'Chrysler', '300', 'Sedan 4-Door'],
    [2011, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2011, 'Dodge', 'Avenger', 'Sedan 4-Door'],
    [2011, 'Dodge', 'Caliber', 'Hatchback 4-Door'],
    [2011, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2011, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2011, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2011, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 4-Door'],
    [2011, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2011, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2011, 'Dodge', 'Nitro', 'SUV 4-Door'],
    [2011, 'Ferrari', '458 Italia', 'Coupe 2-Door'],
    [2011, 'Ferrari', '599 GTO', 'Coupe 2-Door'],
    [2011, 'Ferrari', 'California', 'Convertible 2-Door'],
    [2011, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2011, 'Ford', 'E-150', 'Extended Cargo Van 3-Door'],
    [2011, 'Ford', 'E-150', 'Standard Cargo Van 3-Door'],
    [2011, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2011, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2011, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2011, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 3-Door'],
    [2011, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2011, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 3-Door'],
    [2011, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2011, 'Ford', 'Edge', 'SUV 4-Door'],
    [2011, 'Ford', 'Escape', 'SUV 4-Door'],
    [2011, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2011, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2011, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2011, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2011, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2011, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2011, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2011, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2011, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2011, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2011, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2011, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2011, 'Ford', 'Fiesta', 'Hatchback 4-Door'],
    [2011, 'Ford', 'Fiesta', 'Sedan 4-Door'],
    [2011, 'Ford', 'Flex', 'SUV 4-Door'],
    [2011, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2011, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2011, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2011, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2011, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2011, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2011, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2011, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2011, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2011, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2011, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2011, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2011, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2011, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2011, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2011, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2011, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2011, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2011, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2011, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2011, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2011, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2011, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2011, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2011, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2011, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2011, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2011, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2011, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2011, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2011, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2011, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2011, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2011, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2011, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2011, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2011, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2011, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2011, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2011, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2011, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2011, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2011, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2011, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2011, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2011, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2011, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2011, 'Honda', 'Accord Crosstour', 'Hatchback 4-Door'],
    [2011, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2011, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2011, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2011, 'Honda', 'CR-Z', 'Hatchback 2-Door'],
    [2011, 'Honda', 'Element', 'SUV 4-Door'],
    [2011, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2011, 'Honda', 'Insight', 'Hatchback 4-Door'],
    [2011, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2011, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2011, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2011, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2011, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2011, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2011, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2011, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2011, 'Hyundai', 'Equus', 'Sedan 4-Door'],
    [2011, 'Hyundai', 'Genesis', 'Sedan 4-Door'],
    [2011, 'Hyundai', 'Genesis Coupe', 'Coupe 2-Door'],
    [2011, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2011, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2011, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2011, 'Hyundai', 'Veracruz', 'SUV 4-Door'],
    [2011, 'INFINITI', 'EX35', 'SUV 4-Door'],
    [2011, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2011, 'INFINITI', 'FX50', 'SUV 4-Door'],
    [2011, 'INFINITI', 'G25', 'Sedan 4-Door'],
    [2011, 'INFINITI', 'G37', 'Convertible 2-Door'],
    [2011, 'INFINITI', 'G37', 'Coupe 2-Door'],
    [2011, 'INFINITI', 'G37', 'Sedan 4-Door'],
    [2011, 'INFINITI', 'M37', 'Sedan 4-Door'],
    [2011, 'INFINITI', 'M56', 'Sedan 4-Door'],
    [2011, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2011, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2011, 'Jaguar', 'XFR', 'Sedan 4-Door'],
    [2011, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2011, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2011, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2011, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2011, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2011, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2011, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2011, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2011, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2011, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2011, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2011, 'Kia', 'Borrego', 'SUV 4-Door'],
    [2011, 'Kia', 'Forte', 'Hatchback 4-Door'],
    [2011, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2011, 'Kia', 'Forte Koup', 'Coupe 2-Door'],
    [2011, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2011, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2011, 'Kia', 'Rio5', 'Hatchback 4-Door'],
    [2011, 'Kia', 'Rondo', 'Wagon 4-Door'],
    [2011, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2011, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2011, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2011, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2011, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2011, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2011, 'Land Rover', 'LR2', 'SUV 4-Door'],
    [2011, 'Land Rover', 'LR4', 'SUV 4-Door'],
    [2011, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2011, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2011, 'Lexus', 'CT200h', 'Hatchback 4-Door'],
    [2011, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2011, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2011, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2011, 'Lexus', 'GS460', 'Sedan 4-Door'],
    [2011, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2011, 'Lexus', 'HS250h', 'Sedan 4-Door'],
    [2011, 'Lexus', 'IS F', 'Sedan 4-Door'],
    [2011, 'Lexus', 'IS250', 'Convertible 2-Door'],
    [2011, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2011, 'Lexus', 'IS350', 'Convertible 2-Door'],
    [2011, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2011, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2011, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2011, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2011, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2011, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2011, 'Lincoln', 'MKS', 'Sedan 4-Door'],
    [2011, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2011, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2011, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2011, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2011, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2011, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2011, 'Lotus', 'Elise', 'Convertible 2-Door'],
    [2011, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2011, 'Lotus', 'Exige', 'Coupe 2-Door'],
    [2011, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2011, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2011, 'Maybach', '57', 'Sedan 4-Door'],
    [2011, 'Maybach', '62', 'Sedan 4-Door'],
    [2011, 'Mazda', '2', 'Hatchback 4-Door'],
    [2011, 'Mazda', '3', 'Hatchback 4-Door'],
    [2011, 'Mazda', '3', 'Sedan 4-Door'],
    [2011, 'Mazda', '6', 'Sedan 4-Door'],
    [2011, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2011, 'Mazda', 'CX-7', 'SUV 4-Door'],
    [2011, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2011, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2011, 'Mazda', 'RX-8', 'Coupe 4-Door'],
    [2011, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'B200', 'Hatchback 4-Door'],
    [2011, 'Mercedes-Benz', 'C250', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'CL550', 'Coupe 2-Door'],
    [2011, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2011, 'Mercedes-Benz', 'CL63 AMG', 'Coupe 2-Door'],
    [2011, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2011, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'CLS63 AMG', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'E350', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'E350', 'Coupe 2-Door'],
    [2011, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2011, 'Mercedes-Benz', 'E550', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'E550', 'Coupe 2-Door'],
    [2011, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'GL350', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'GLK350', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'ML450', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'ML550', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2011, 'Mercedes-Benz', 'R350', 'Wagon 4-Door'],
    [2011, 'Mercedes-Benz', 'S400', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'S450', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2011, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'SLK300', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2011, 'Mercedes-Benz', 'SLS AMG', 'Coupe 2-Door'],
    [2011, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2011, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2011, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2011, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2011, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2011, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2011, 'Mercury', 'Mariner', 'SUV 4-Door'],
    [2011, 'Mercury', 'Milan', 'Sedan 4-Door'],
    [2011, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2011, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2011, 'Mini', 'Cooper', 'Wagon 3-Door'],
    [2011, 'Mini', 'Cooper Countryman', 'Hatchback 4-Door'],
    [2011, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2011, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2011, 'Mitsubishi', 'Endeavor', 'SUV 4-Door'],
    [2011, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2011, 'Mitsubishi', 'Lancer', 'Hatchback 4-Door'],
    [2011, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2011, 'Mitsubishi', 'Lancer', 'Wagon 4-Door'],
    [2011, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2011, 'Mitsubishi', 'Outlander Sport', 'SUV 4-Door'],
    [2011, 'Mitsubishi', 'RVR', 'SUV 4-Door'],
    [2011, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2011, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2011, 'Nissan', 'Altima', 'Coupe 2-Door'],
    [2011, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2011, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2011, 'Nissan', 'Cube', 'Wagon 4-Door'],
    [2011, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2011, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2011, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2011, 'Nissan', 'Juke', 'SUV 4-Door'],
    [2011, 'Nissan', 'LEAF', 'Hatchback 4-Door'],
    [2011, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2011, 'Nissan', 'Murano', 'Convertible 2-Door'],
    [2011, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2011, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2011, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2011, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2011, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2011, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2011, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2011, 'Nissan', 'Versa', 'Hatchback 4-Door'],
    [2011, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2011, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2011, 'Porsche', '911', 'Convertible 2-Door'],
    [2011, 'Porsche', '911', 'Coupe 2-Door'],
    [2011, 'Porsche', '911', 'Targa 2-Door'],
    [2011, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2011, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2011, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2011, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2011, 'Ram', '1500', 'Crew Cab Pickup 4-Door'],
    [2011, 'Ram', '1500', 'Extended Cab Pickup 4-Door'],
    [2011, 'Ram', '1500', 'Standard Cab Pickup 2-Door'],
    [2011, 'Ram', '2500', 'Crew Cab Pickup 4-Door'],
    [2011, 'Ram', '2500', 'Extended Crew Cab Pickup 4-Door'],
    [2011, 'Ram', '2500', 'Standard Cab Pickup 2-Door'],
    [2011, 'Ram', '3500', 'Crew Cab Pickup 4-Door'],
    [2011, 'Ram', '3500', 'Extended Crew Cab Pickup 4-Door'],
    [2011, 'Ram', '3500', 'Standard Cab Pickup 2-Door'],
    [2011, 'Ram', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2011, 'Ram', 'Dakota', 'Extended Cab Pickup 4-Door'],
    [2011, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2011, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2011, 'Rolls-Royce', 'Phantom', 'Coupe 2-Door'],
    [2011, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2011, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2011, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2011, 'Saab', '3-Sep', 'Wagon 4-Door'],
    [2011, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2011, 'Saab', '9-3X', 'Wagon 4-Door'],
    [2011, 'Saab', '9-4X', 'SUV 4-Door'],
    [2011, 'Scion', 'tC', 'Coupe 2-Door'],
    [2011, 'Scion', 'xB', 'Wagon 4-Door'],
    [2011, 'Scion', 'xD', 'Hatchback 4-Door'],
    [2011, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2011, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2011, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2011, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2011, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2011, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2011, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2011, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2011, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2011, 'Subaru', 'Tribeca', 'SUV 4-Door'],
    [2011, 'Suzuki', 'Equator', 'Crew Cab Pickup 4-Door'],
    [2011, 'Suzuki', 'Equator', 'Extended Cab Pickup 4-Door'],
    [2011, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2011, 'Suzuki', 'Kizashi', 'Sedan 4-Door'],
    [2011, 'Suzuki', 'SX4', 'Hatchback 4-Door'],
    [2011, 'Suzuki', 'SX4', 'Sedan 4-Door'],
    [2011, 'Tesla', 'Roadster', 'Convertible 2-Door'],
    [2011, 'Think', 'City', 'Coupe 2-Door'],
    [2011, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2011, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2011, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2011, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2011, 'Toyota', 'FJ Cruiser', 'SUV 4-Door'],
    [2011, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2011, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2011, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2011, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2011, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2011, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2011, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2011, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2011, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2011, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2011, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2011, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2011, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2011, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2011, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2011, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2011, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2011, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2011, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2011, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2011, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2011, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2011, 'Volkswagen', 'Golf', 'Wagon 4-Door'],
    [2011, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2011, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2011, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2011, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2011, 'Volkswagen', 'Routan', 'Mini Passenger Van 4-Door'],
    [2011, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2011, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2011, 'Volvo', 'C30', 'Hatchback 2-Door'],
    [2011, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2011, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2011, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2011, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2011, 'Volvo', 'V50', 'Wagon 4-Door'],
    [2011, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2011, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2011, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2011, 'VPG', 'MV-1', 'Standard Passenger Van 4-Door'],
    [2010, 'Acura', 'CSX', 'Sedan 4-Door'],
    [2010, 'Acura', 'MDX', 'SUV 4-Door'],
    [2010, 'Acura', 'RDX', 'SUV 4-Door'],
    [2010, 'Acura', 'RL', 'Sedan 4-Door'],
    [2010, 'Acura', 'TL', 'Sedan 4-Door'],
    [2010, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2010, 'Acura', 'ZDX', 'SUV 4-Door'],
    [2010, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2010, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2010, 'Aston Martin', 'DBS', 'Convertible 2-Door'],
    [2010, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2010, 'Aston Martin', 'Rapide', 'Sedan 4-Door'],
    [2010, 'Aston Martin', 'V12 Vantage', 'Convertible 2-Door'],
    [2010, 'Aston Martin', 'V12 Vantage', 'Hatchback 2-Door'],
    [2010, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2010, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2010, 'Audi', 'A3', 'Hatchback 4-Door'],
    [2010, 'Audi', 'A3 Quattro', 'Hatchback 4-Door'],
    [2010, 'Audi', 'A4', 'Sedan 4-Door'],
    [2010, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2010, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2010, 'Audi', 'A5', 'Convertible 2-Door'],
    [2010, 'Audi', 'A5 Quattro', 'Convertible 2-Door'],
    [2010, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2010, 'Audi', 'A6', 'Sedan 4-Door'],
    [2010, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2010, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2010, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2010, 'Audi', 'Q5', 'SUV 4-Door'],
    [2010, 'Audi', 'Q7', 'SUV 4-Door'],
    [2010, 'Audi', 'R8', 'Coupe 2-Door'],
    [2010, 'Audi', 'S4', 'Sedan 4-Door'],
    [2010, 'Audi', 'S5', 'Convertible 2-Door'],
    [2010, 'Audi', 'S5', 'Coupe 2-Door'],
    [2010, 'Audi', 'S6', 'Sedan 4-Door'],
    [2010, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2010, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2010, 'Audi', 'TTS Quattro', 'Convertible 2-Door'],
    [2010, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2010, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2010, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2010, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2010, 'Bentley', 'Continental', 'Sedan 4-Door'],
    [2010, 'BMW', '128i', 'Convertible 2-Door'],
    [2010, 'BMW', '128i', 'Coupe 2-Door'],
    [2010, 'BMW', '135i', 'Convertible 2-Door'],
    [2010, 'BMW', '135i', 'Coupe 2-Door'],
    [2010, 'BMW', '323i', 'Sedan 4-Door'],
    [2010, 'BMW', '328i', 'Convertible 2-Door'],
    [2010, 'BMW', '328i', 'Coupe 2-Door'],
    [2010, 'BMW', '328i', 'Sedan 4-Door'],
    [2010, 'BMW', '328i', 'Wagon 4-Door'],
    [2010, 'BMW', '328i xDrive', 'Coupe 2-Door'],
    [2010, 'BMW', '328i xDrive', 'Sedan 4-Door'],
    [2010, 'BMW', '328i xDrive', 'Wagon 4-Door'],
    [2010, 'BMW', '335d', 'Sedan 4-Door'],
    [2010, 'BMW', '335i', 'Convertible 2-Door'],
    [2010, 'BMW', '335i', 'Coupe 2-Door'],
    [2010, 'BMW', '335i', 'Sedan 4-Door'],
    [2010, 'BMW', '335i xDrive', 'Coupe 2-Door'],
    [2010, 'BMW', '335i xDrive', 'Sedan 4-Door'],
    [2010, 'BMW', '528i', 'Sedan 4-Door'],
    [2010, 'BMW', '528i xDrive', 'Sedan 4-Door'],
    [2010, 'BMW', '535i', 'Sedan 4-Door'],
    [2010, 'BMW', '535i', 'Wagon 4-Door'],
    [2010, 'BMW', '535i GT', 'Hatchback 4-Door'],
    [2010, 'BMW', '535i xDrive', 'Sedan 4-Door'],
    [2010, 'BMW', '535i xDrive', 'Wagon 4-Door'],
    [2010, 'BMW', '550i', 'Sedan 4-Door'],
    [2010, 'BMW', '550i GT', 'Hatchback 4-Door'],
    [2010, 'BMW', '550i GT xDrive', 'Hatchback 4-Door'],
    [2010, 'BMW', '650i', 'Convertible 2-Door'],
    [2010, 'BMW', '650i', 'Coupe 2-Door'],
    [2010, 'BMW', '750i', 'Sedan 4-Door'],
    [2010, 'BMW', '750i xDrive', 'Sedan 4-Door'],
    [2010, 'BMW', '750Li', 'Sedan 4-Door'],
    [2010, 'BMW', '750Li xDrive', 'Sedan 4-Door'],
    [2010, 'BMW', '760Li', 'Sedan 4-Door'],
    [2010, 'BMW', 'M3', 'Convertible 2-Door'],
    [2010, 'BMW', 'M3', 'Coupe 2-Door'],
    [2010, 'BMW', 'M3', 'Sedan 4-Door'],
    [2010, 'BMW', 'M5', 'Sedan 4-Door'],
    [2010, 'BMW', 'M6', 'Convertible 2-Door'],
    [2010, 'BMW', 'M6', 'Coupe 2-Door'],
    [2010, 'BMW', 'X3', 'SUV 4-Door'],
    [2010, 'BMW', 'X5', 'SUV 4-Door'],
    [2010, 'BMW', 'X6', 'SUV 4-Door'],
    [2010, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2010, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2010, 'Buick', 'Allure', 'Sedan 4-Door'],
    [2010, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2010, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2010, 'Buick', 'Lucerne', 'Sedan 4-Door'],
    [2010, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2010, 'Cadillac', 'CTS', 'Wagon 4-Door'],
    [2010, 'Cadillac', 'DTS', 'Hearse 4-Door'],
    [2010, 'Cadillac', 'DTS', 'Limousine 4-Door'],
    [2010, 'Cadillac', 'DTS', 'Sedan 4-Door'],
    [2010, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2010, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2010, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2010, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2010, 'Cadillac', 'STS', 'Sedan 4-Door'],
    [2010, 'Chevrolet', 'Avalanche', 'Crew Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Aveo', 'Sedan 4-Door'],
    [2010, 'Chevrolet', 'Aveo5', 'Hatchback 4-Door'],
    [2010, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2010, 'Chevrolet', 'Cobalt', 'Coupe 2-Door'],
    [2010, 'Chevrolet', 'Cobalt', 'Sedan 4-Door'],
    [2010, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2010, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2010, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2010, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2010, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2010, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2010, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2010, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2010, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2010, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2010, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2010, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2010, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2010, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2010, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2010, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2010, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2010, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2010, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2010, 'Chevrolet', 'HHR', 'Wagon 2-Door'],
    [2010, 'Chevrolet', 'HHR', 'Wagon 4-Door'],
    [2010, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2010, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2010, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2010, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2010, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2010, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2010, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2010, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2010, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2010, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2010, 'Chrysler', '300', 'Sedan 4-Door'],
    [2010, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2010, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2010, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2010, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2010, 'Dodge', 'Avenger', 'Sedan 4-Door'],
    [2010, 'Dodge', 'Caliber', 'Hatchback 4-Door'],
    [2010, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2010, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2010, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2010, 'Dodge', 'Dakota', 'Extended Cab Pickup 4-Door'],
    [2010, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 4-Door'],
    [2010, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2010, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2010, 'Dodge', 'Nitro', 'SUV 4-Door'],
    [2010, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2010, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 4-Door'],
    [2010, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2010, 'Dodge', 'Ram 2500', 'Crew Cab Pickup 4-Door'],
    [2010, 'Dodge', 'Ram 2500', 'Extended Crew Cab Pickup 4-Door'],
    [2010, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2010, 'Dodge', 'Ram 3500', 'Crew Cab Pickup 4-Door'],
    [2010, 'Dodge', 'Ram 3500', 'Extended Crew Cab Pickup 4-Door'],
    [2010, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2010, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2010, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2010, 'Ferrari', '458 Italia', 'Coupe 2-Door'],
    [2010, 'Ferrari', '599 GTB', 'Coupe 2-Door'],
    [2010, 'Ferrari', '612 Scaglietti', 'Coupe 2-Door'],
    [2010, 'Ferrari', 'California', 'Convertible 2-Door'],
    [2010, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2010, 'Ford', 'E-150', 'Extended Cargo Van 3-Door'],
    [2010, 'Ford', 'E-150', 'Standard Cargo Van 3-Door'],
    [2010, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2010, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2010, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2010, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 3-Door'],
    [2010, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2010, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 3-Door'],
    [2010, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2010, 'Ford', 'Edge', 'SUV 4-Door'],
    [2010, 'Ford', 'Escape', 'SUV 4-Door'],
    [2010, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2010, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2010, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2010, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2010, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2010, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2010, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2010, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2010, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2010, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2010, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2010, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2010, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2010, 'Ford', 'Flex', 'SUV 4-Door'],
    [2010, 'Ford', 'Focus', 'Coupe 2-Door'],
    [2010, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2010, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2010, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2010, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2010, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2010, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2010, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2010, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2010, 'Ford', 'Transit Connect', 'Mini Cargo Van 4-Door'],
    [2010, 'Ford', 'Transit Connect', 'Mini Passenger Van 4-Door'],
    [2010, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2010, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2010, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2010, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2010, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2010, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2010, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2010, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2010, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2010, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2010, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2010, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2010, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2010, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2010, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2010, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2010, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2010, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2010, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2010, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2010, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2010, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2010, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2010, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2010, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2010, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2010, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2010, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2010, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2010, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2010, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2010, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2010, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2010, 'GMC', 'Terrain', 'SUV 4-Door'],
    [2010, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2010, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2010, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2010, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2010, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2010, 'Honda', 'Accord Crosstour', 'Hatchback 4-Door'],
    [2010, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2010, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2010, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2010, 'Honda', 'Element', 'SUV 4-Door'],
    [2010, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2010, 'Honda', 'Insight', 'Hatchback 4-Door'],
    [2010, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2010, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2010, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2010, 'Hummer', 'H3', 'SUV 4-Door'],
    [2010, 'Hummer', 'H3T', 'Crew Cab Pickup 4-Door'],
    [2010, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2010, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2010, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2010, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2010, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2010, 'Hyundai', 'Entourage', 'Mini Passenger Van 4-Door'],
    [2010, 'Hyundai', 'Genesis', 'Sedan 4-Door'],
    [2010, 'Hyundai', 'Genesis Coupe', 'Coupe 2-Door'],
    [2010, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2010, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2010, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2010, 'Hyundai', 'Veracruz', 'SUV 4-Door'],
    [2010, 'INFINITI', 'EX35', 'SUV 4-Door'],
    [2010, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2010, 'INFINITI', 'FX50', 'SUV 4-Door'],
    [2010, 'INFINITI', 'G37', 'Convertible 2-Door'],
    [2010, 'INFINITI', 'G37', 'Coupe 2-Door'],
    [2010, 'INFINITI', 'G37', 'Sedan 4-Door'],
    [2010, 'INFINITI', 'M35', 'Sedan 4-Door'],
    [2010, 'INFINITI', 'M45', 'Sedan 4-Door'],
    [2010, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2010, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2010, 'Jaguar', 'XFR', 'Sedan 4-Door'],
    [2010, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [2010, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2010, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2010, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2010, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2010, 'Jeep', 'Commander', 'SUV 4-Door'],
    [2010, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2010, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2010, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2010, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2010, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2010, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2010, 'Kia', 'Borrego', 'SUV 4-Door'],
    [2010, 'Kia', 'Forte', 'Sedan 4-Door'],
    [2010, 'Kia', 'Forte Koup', 'Coupe 2-Door'],
    [2010, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2010, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2010, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2010, 'Kia', 'Rio5', 'Hatchback 4-Door'],
    [2010, 'Kia', 'Rondo', 'Wagon 4-Door'],
    [2010, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2010, 'Kia', 'Soul', 'Hatchback 4-Door'],
    [2010, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2010, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2010, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2010, 'Lamborghini', 'Murcielago', 'Convertible 2-Door'],
    [2010, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2010, 'Land Rover', 'LR2', 'SUV 4-Door'],
    [2010, 'Land Rover', 'LR4', 'SUV 4-Door'],
    [2010, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2010, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2010, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2010, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2010, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2010, 'Lexus', 'GS460', 'Sedan 4-Door'],
    [2010, 'Lexus', 'GX460', 'SUV 4-Door'],
    [2010, 'Lexus', 'HS250h', 'Sedan 4-Door'],
    [2010, 'Lexus', 'IS F', 'Sedan 4-Door'],
    [2010, 'Lexus', 'IS250', 'Convertible 2-Door'],
    [2010, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2010, 'Lexus', 'IS350', 'Convertible 2-Door'],
    [2010, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2010, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2010, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2010, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2010, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2010, 'Lexus', 'RX450h', 'SUV 4-Door'],
    [2010, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2010, 'Lincoln', 'MKS', 'Sedan 4-Door'],
    [2010, 'Lincoln', 'MKT', 'SUV 4-Door'],
    [2010, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2010, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2010, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2010, 'Lincoln', 'Town Car', 'Hearse 4-Door'],
    [2010, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2010, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2010, 'Lotus', 'Elise', 'Convertible 2-Door'],
    [2010, 'Lotus', 'Evora', 'Coupe 2-Door'],
    [2010, 'Lotus', 'Exige', 'Coupe 2-Door'],
    [2010, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2010, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2010, 'Maybach', '57', 'Sedan 4-Door'],
    [2010, 'Maybach', '62', 'Sedan 4-Door'],
    [2010, 'Mazda', '3', 'Hatchback 4-Door'],
    [2010, 'Mazda', '3', 'Sedan 4-Door'],
    [2010, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2010, 'Mazda', '6', 'Sedan 4-Door'],
    [2010, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2010, 'Mazda', 'B2300', 'Extended Cab Pickup 2-Door'],
    [2010, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2010, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2010, 'Mazda', 'CX-7', 'SUV 4-Door'],
    [2010, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2010, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2010, 'Mazda', 'RX-8', 'Coupe 4-Door'],
    [2010, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'B200', 'Hatchback 4-Door'],
    [2010, 'Mercedes-Benz', 'C250', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'CL550', 'Coupe 2-Door'],
    [2010, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2010, 'Mercedes-Benz', 'CL63 AMG', 'Coupe 2-Door'],
    [2010, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2010, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'CLS63 AMG', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'E350', 'Coupe 2-Door'],
    [2010, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'E550', 'Coupe 2-Door'],
    [2010, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'GL350', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'GLK350', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'ML450', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'ML550', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2010, 'Mercedes-Benz', 'R350', 'Wagon 4-Door'],
    [2010, 'Mercedes-Benz', 'S400', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'S450', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2010, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2010, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2010, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2010, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2010, 'Mercedes-Benz', 'SLK300', 'Convertible 2-Door'],
    [2010, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2010, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2010, 'Mercedes-Benz', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2010, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2010, 'Mercedes-Benz', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2010, 'Mercedes-Benz', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2010, 'Mercedes-Benz', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2010, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2010, 'Mercury', 'Mariner', 'SUV 4-Door'],
    [2010, 'Mercury', 'Milan', 'Sedan 4-Door'],
    [2010, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2010, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2010, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2010, 'Mini', 'Cooper', 'Wagon 3-Door'],
    [2010, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2010, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2010, 'Mitsubishi', 'Endeavor', 'SUV 4-Door'],
    [2010, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2010, 'Mitsubishi', 'Lancer', 'Hatchback 4-Door'],
    [2010, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2010, 'Mitsubishi', 'Lancer', 'Wagon 4-Door'],
    [2010, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2010, 'Nissan', '370Z', 'Convertible 2-Door'],
    [2010, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2010, 'Nissan', 'Altima', 'Coupe 2-Door'],
    [2010, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2010, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2010, 'Nissan', 'Cube', 'Wagon 4-Door'],
    [2010, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2010, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2010, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2010, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2010, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2010, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2010, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2010, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2010, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2010, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2010, 'Nissan', 'Versa', 'Hatchback 4-Door'],
    [2010, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2010, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2010, 'Pontiac', 'G3', 'Hatchback 4-Door'],
    [2010, 'Pontiac', 'G3', 'Sedan 4-Door'],
    [2010, 'Pontiac', 'G5', 'Coupe 2-Door'],
    [2010, 'Pontiac', 'G5', 'Sedan 4-Door'],
    [2010, 'Pontiac', 'G6', 'Sedan 4-Door'],
    [2010, 'Pontiac', 'Vibe', 'Wagon 4-Door'],
    [2010, 'Porsche', '911', 'Convertible 2-Door'],
    [2010, 'Porsche', '911', 'Coupe 2-Door'],
    [2010, 'Porsche', '911', 'Targa 2-Door'],
    [2010, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2010, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2010, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2010, 'Porsche', 'Panamera', 'Hatchback 4-Door'],
    [2010, 'Rolls-Royce', 'Ghost', 'Sedan 4-Door'],
    [2010, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2010, 'Rolls-Royce', 'Phantom', 'Coupe 2-Door'],
    [2010, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2010, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2010, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2010, 'Saab', '3-Sep', 'Wagon 4-Door'],
    [2010, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2010, 'Saab', '9-3X', 'Wagon 4-Door'],
    [2010, 'Saturn', 'Outlook', 'SUV 4-Door'],
    [2010, 'Saturn', 'Sky', 'Convertible 2-Door'],
    [2010, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2010, 'Scion', 'tC', 'Coupe 2-Door'],
    [2010, 'Scion', 'xB', 'Wagon 4-Door'],
    [2010, 'Scion', 'xD', 'Hatchback 4-Door'],
    [2010, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2010, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2010, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2010, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2010, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2010, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2010, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2010, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2010, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2010, 'Subaru', 'Tribeca', 'SUV 4-Door'],
    [2010, 'Suzuki', 'Equator', 'Crew Cab Pickup 4-Door'],
    [2010, 'Suzuki', 'Equator', 'Extended Cab Pickup 4-Door'],
    [2010, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2010, 'Suzuki', 'Kizashi', 'Sedan 4-Door'],
    [2010, 'Suzuki', 'Swift+', 'Hatchback 4-Door'],
    [2010, 'Suzuki', 'SX4', 'Hatchback 4-Door'],
    [2010, 'Suzuki', 'SX4', 'Sedan 4-Door'],
    [2010, 'Tesla', 'Roadster', 'Convertible 2-Door'],
    [2010, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2010, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2010, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2010, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2010, 'Toyota', 'FJ Cruiser', 'SUV 4-Door'],
    [2010, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2010, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2010, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2010, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2010, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2010, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2010, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2010, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2010, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2010, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2010, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2010, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2010, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2010, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2010, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2010, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2010, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2010, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2010, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2010, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2010, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2010, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2010, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2010, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2010, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2010, 'Volkswagen', 'Golf', 'Wagon 4-Door'],
    [2010, 'Volkswagen', 'Golf City', 'Hatchback 4-Door'],
    [2010, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2010, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2010, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2010, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2010, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2010, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2010, 'Volkswagen', 'Passat CC', 'Sedan 4-Door'],
    [2010, 'Volkswagen', 'Routan', 'Mini Passenger Van 4-Door'],
    [2010, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2010, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2010, 'Volvo', 'C30', 'Hatchback 2-Door'],
    [2010, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2010, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2010, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2010, 'Volvo', 'V50', 'Wagon 4-Door'],
    [2010, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2010, 'Volvo', 'XC60', 'SUV 4-Door'],
    [2010, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2010, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2009, 'Acura', 'CSX', 'Sedan 4-Door'],
    [2009, 'Acura', 'MDX', 'SUV 4-Door'],
    [2009, 'Acura', 'RDX', 'SUV 4-Door'],
    [2009, 'Acura', 'RL', 'Sedan 4-Door'],
    [2009, 'Acura', 'TL', 'Sedan 4-Door'],
    [2009, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2009, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2009, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2009, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2009, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2009, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2009, 'Audi', 'A3', 'Hatchback 4-Door'],
    [2009, 'Audi', 'A3 Quattro', 'Hatchback 4-Door'],
    [2009, 'Audi', 'A4', 'Convertible 2-Door'],
    [2009, 'Audi', 'A4', 'Sedan 4-Door'],
    [2009, 'Audi', 'A4 Quattro', 'Convertible 2-Door'],
    [2009, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2009, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2009, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2009, 'Audi', 'A6', 'Sedan 4-Door'],
    [2009, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2009, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2009, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2009, 'Audi', 'Q5', 'SUV 4-Door'],
    [2009, 'Audi', 'Q7', 'SUV 4-Door'],
    [2009, 'Audi', 'R8', 'Coupe 2-Door'],
    [2009, 'Audi', 'S4', 'Convertible 2-Door'],
    [2009, 'Audi', 'S5', 'Coupe 2-Door'],
    [2009, 'Audi', 'S6', 'Sedan 4-Door'],
    [2009, 'Audi', 'S8', 'Sedan 4-Door'],
    [2009, 'Audi', 'TT', 'Convertible 2-Door'],
    [2009, 'Audi', 'TT', 'Coupe 2-Door'],
    [2009, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2009, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2009, 'Audi', 'TTS Quattro', 'Convertible 2-Door'],
    [2009, 'Audi', 'TTS Quattro', 'Coupe 2-Door'],
    [2009, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2009, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2009, 'Bentley', 'Brooklands', 'Coupe 2-Door'],
    [2009, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2009, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2009, 'Bentley', 'Continental', 'Sedan 4-Door'],
    [2009, 'BMW', '128i', 'Convertible 2-Door'],
    [2009, 'BMW', '128i', 'Coupe 2-Door'],
    [2009, 'BMW', '135i', 'Convertible 2-Door'],
    [2009, 'BMW', '135i', 'Coupe 2-Door'],
    [2009, 'BMW', '323i', 'Sedan 4-Door'],
    [2009, 'BMW', '328i', 'Convertible 2-Door'],
    [2009, 'BMW', '328i', 'Coupe 2-Door'],
    [2009, 'BMW', '328i', 'Sedan 4-Door'],
    [2009, 'BMW', '328i', 'Wagon 4-Door'],
    [2009, 'BMW', '328i xDrive', 'Coupe 2-Door'],
    [2009, 'BMW', '328i xDrive', 'Sedan 4-Door'],
    [2009, 'BMW', '328i xDrive', 'Wagon 4-Door'],
    [2009, 'BMW', '335d', 'Sedan 4-Door'],
    [2009, 'BMW', '335i', 'Convertible 2-Door'],
    [2009, 'BMW', '335i', 'Coupe 2-Door'],
    [2009, 'BMW', '335i', 'Sedan 4-Door'],
    [2009, 'BMW', '335i xDrive', 'Coupe 2-Door'],
    [2009, 'BMW', '335i xDrive', 'Sedan 4-Door'],
    [2009, 'BMW', '528i', 'Sedan 4-Door'],
    [2009, 'BMW', '528i xDrive', 'Sedan 4-Door'],
    [2009, 'BMW', '535i', 'Sedan 4-Door'],
    [2009, 'BMW', '535i xDrive', 'Sedan 4-Door'],
    [2009, 'BMW', '535i xDrive', 'Wagon 4-Door'],
    [2009, 'BMW', '550i', 'Sedan 4-Door'],
    [2009, 'BMW', '650i', 'Convertible 2-Door'],
    [2009, 'BMW', '650i', 'Coupe 2-Door'],
    [2009, 'BMW', '750i', 'Sedan 4-Door'],
    [2009, 'BMW', '750Li', 'Sedan 4-Door'],
    [2009, 'BMW', 'M3', 'Convertible 2-Door'],
    [2009, 'BMW', 'M3', 'Coupe 2-Door'],
    [2009, 'BMW', 'M3', 'Sedan 4-Door'],
    [2009, 'BMW', 'M5', 'Sedan 4-Door'],
    [2009, 'BMW', 'M6', 'Convertible 2-Door'],
    [2009, 'BMW', 'M6', 'Coupe 2-Door'],
    [2009, 'BMW', 'X3', 'SUV 4-Door'],
    [2009, 'BMW', 'X5', 'SUV 4-Door'],
    [2009, 'BMW', 'X6', 'SUV 4-Door'],
    [2009, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2009, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2009, 'Buick', 'Allure', 'Sedan 4-Door'],
    [2009, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2009, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2009, 'Buick', 'Lucerne', 'Sedan 4-Door'],
    [2009, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2009, 'Cadillac', 'DTS', 'Hearse 4-Door'],
    [2009, 'Cadillac', 'DTS', 'Limousine 4-Door'],
    [2009, 'Cadillac', 'DTS', 'Sedan 4-Door'],
    [2009, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2009, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2009, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2009, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2009, 'Cadillac', 'STS', 'Sedan 4-Door'],
    [2009, 'Cadillac', 'XLR', 'Convertible 2-Door'],
    [2009, 'Chevrolet', 'Avalanche', 'Crew Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Aveo', 'Sedan 4-Door'],
    [2009, 'Chevrolet', 'Aveo5', 'Hatchback 4-Door'],
    [2009, 'Chevrolet', 'Cobalt', 'Coupe 2-Door'],
    [2009, 'Chevrolet', 'Cobalt', 'Sedan 4-Door'],
    [2009, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2009, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2009, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2009, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2009, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2009, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2009, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2009, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2009, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2009, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2009, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2009, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2009, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2009, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2009, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2009, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2009, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2009, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2009, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2009, 'Chevrolet', 'HHR', 'Wagon 2-Door'],
    [2009, 'Chevrolet', 'HHR', 'Wagon 4-Door'],
    [2009, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2009, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2009, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2009, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2009, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2009, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2009, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2009, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2009, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2009, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2009, 'Chevrolet', 'Traverse', 'SUV 4-Door'],
    [2009, 'Chevrolet', 'Uplander', 'Mini Cargo Van 4-Door'],
    [2009, 'Chevrolet', 'Uplander', 'Mini Passenger Van 4-Door'],
    [2009, 'Chrysler', '300', 'Sedan 4-Door'],
    [2009, 'Chrysler', 'Aspen', 'SUV 4-Door'],
    [2009, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2009, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2009, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2009, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2009, 'Dodge', 'Avenger', 'Sedan 4-Door'],
    [2009, 'Dodge', 'Caliber', 'Hatchback 4-Door'],
    [2009, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2009, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2009, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2009, 'Dodge', 'Dakota', 'Extended Cab Pickup 4-Door'],
    [2009, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2009, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 4-Door'],
    [2009, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2009, 'Dodge', 'Journey', 'SUV 4-Door'],
    [2009, 'Dodge', 'Nitro', 'SUV 4-Door'],
    [2009, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2009, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 4-Door'],
    [2009, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2009, 'Dodge', 'Ram 2500', 'Crew Cab Pickup 4-Door'],
    [2009, 'Dodge', 'Ram 2500', 'Extended Crew Cab Pickup 4-Door'],
    [2009, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2009, 'Dodge', 'Ram 3500', 'Crew Cab Pickup 4-Door'],
    [2009, 'Dodge', 'Ram 3500', 'Extended Crew Cab Pickup 4-Door'],
    [2009, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2009, 'Dodge', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2009, 'Dodge', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2009, 'Dodge', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2009, 'Dodge', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2009, 'Dodge', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2009, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2009, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2009, 'Ferrari', '599 GTB', 'Coupe 2-Door'],
    [2009, 'Ferrari', '612 Scaglietti', 'Coupe 2-Door'],
    [2009, 'Ferrari', 'California', 'Convertible 2-Door'],
    [2009, 'Ferrari', 'F430', 'Convertible 2-Door'],
    [2009, 'Ferrari', 'F430', 'Coupe 2-Door'],
    [2009, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2009, 'Ford', 'E-150', 'Extended Cargo Van 3-Door'],
    [2009, 'Ford', 'E-150', 'Standard Cargo Van 3-Door'],
    [2009, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2009, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2009, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2009, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 3-Door'],
    [2009, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2009, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 3-Door'],
    [2009, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2009, 'Ford', 'Edge', 'SUV 4-Door'],
    [2009, 'Ford', 'Escape', 'SUV 4-Door'],
    [2009, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2009, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2009, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2009, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2009, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2009, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2009, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2009, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2009, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2009, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2009, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2009, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2009, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2009, 'Ford', 'Flex', 'SUV 4-Door'],
    [2009, 'Ford', 'Focus', 'Coupe 2-Door'],
    [2009, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2009, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2009, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2009, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2009, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2009, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2009, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2009, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2009, 'Ford', 'Taurus X', 'Wagon 4-Door'],
    [2009, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2009, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2009, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2009, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2009, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2009, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2009, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2009, 'GMC', 'Envoy', 'SUV 4-Door'],
    [2009, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2009, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2009, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2009, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2009, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2009, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2009, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2009, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2009, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2009, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2009, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2009, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2009, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2009, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2009, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2009, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2009, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2009, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2009, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2009, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2009, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2009, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2009, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2009, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2009, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2009, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2009, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2009, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2009, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2009, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2009, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2009, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2009, 'Honda', 'Element', 'SUV 4-Door'],
    [2009, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2009, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2009, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2009, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2009, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2009, 'Hummer', 'H2', 'Crew Cab Pickup 4-Door'],
    [2009, 'Hummer', 'H2', 'SUV 4-Door'],
    [2009, 'Hummer', 'H3', 'SUV 4-Door'],
    [2009, 'Hummer', 'H3T', 'Crew Cab Pickup 4-Door'],
    [2009, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2009, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2009, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2009, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2009, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2009, 'Hyundai', 'Entourage', 'Mini Passenger Van 4-Door'],
    [2009, 'Hyundai', 'Genesis', 'Sedan 4-Door'],
    [2009, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2009, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2009, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2009, 'Hyundai', 'Veracruz', 'SUV 4-Door'],
    [2009, 'INFINITI', 'EX35', 'SUV 4-Door'],
    [2009, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2009, 'INFINITI', 'FX50', 'SUV 4-Door'],
    [2009, 'INFINITI', 'G37', 'Convertible 2-Door'],
    [2009, 'INFINITI', 'G37', 'Coupe 2-Door'],
    [2009, 'INFINITI', 'G37', 'Sedan 4-Door'],
    [2009, 'INFINITI', 'M35', 'Sedan 4-Door'],
    [2009, 'INFINITI', 'M45', 'Sedan 4-Door'],
    [2009, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2009, 'Jaguar', 'Super V8', 'Sedan 4-Door'],
    [2009, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2009, 'Jaguar', 'XF', 'Sedan 4-Door'],
    [2009, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2009, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2009, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2009, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2009, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2009, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2009, 'Jeep', 'Commander', 'SUV 4-Door'],
    [2009, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2009, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2009, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2009, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2009, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2009, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2009, 'Kia', 'Amanti', 'Sedan 4-Door'],
    [2009, 'Kia', 'Borrego', 'SUV 4-Door'],
    [2009, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2009, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2009, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2009, 'Kia', 'Rio5', 'Hatchback 4-Door'],
    [2009, 'Kia', 'Rondo', 'Wagon 4-Door'],
    [2009, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2009, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2009, 'Kia', 'Spectra', 'Sedan 4-Door'],
    [2009, 'Kia', 'Spectra5', 'Hatchback 4-Door'],
    [2009, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2009, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2009, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2009, 'Lamborghini', 'Murcielago', 'Convertible 2-Door'],
    [2009, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2009, 'Land Rover', 'LR2', 'SUV 4-Door'],
    [2009, 'Land Rover', 'LR3', 'SUV 4-Door'],
    [2009, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2009, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2009, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2009, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2009, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2009, 'Lexus', 'GS460', 'Sedan 4-Door'],
    [2009, 'Lexus', 'GX470', 'SUV 4-Door'],
    [2009, 'Lexus', 'IS F', 'Sedan 4-Door'],
    [2009, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2009, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2009, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2009, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2009, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2009, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2009, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2009, 'Lincoln', 'MKS', 'Sedan 4-Door'],
    [2009, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2009, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2009, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2009, 'Lincoln', 'Town Car', 'Hearse 4-Door'],
    [2009, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2009, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2009, 'Lotus', 'Elise', 'Convertible 2-Door'],
    [2009, 'Lotus', 'Exige', 'Coupe 2-Door'],
    [2009, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2009, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2009, 'Maybach', '57', 'Sedan 4-Door'],
    [2009, 'Maybach', '62', 'Sedan 4-Door'],
    [2009, 'Mazda', '3', 'Hatchback 4-Door'],
    [2009, 'Mazda', '3', 'Sedan 4-Door'],
    [2009, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2009, 'Mazda', '6', 'Sedan 4-Door'],
    [2009, 'Mazda', '3 Sport', 'Hatchback 4-Door'],
    [2009, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2009, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2009, 'Mazda', 'CX-7', 'SUV 4-Door'],
    [2009, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2009, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2009, 'Mazda', 'RX-8', 'Coupe 4-Door'],
    [2009, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'B200', 'Hatchback 4-Door'],
    [2009, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'CL550', 'Coupe 2-Door'],
    [2009, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2009, 'Mercedes-Benz', 'CL63 AMG', 'Coupe 2-Door'],
    [2009, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2009, 'Mercedes-Benz', 'CLK350', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'CLK350', 'Coupe 2-Door'],
    [2009, 'Mercedes-Benz', 'CLK550', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'CLK550', 'Coupe 2-Door'],
    [2009, 'Mercedes-Benz', 'CLK63 AMG', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'CLS63 AMG', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2009, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'E63 AMG', 'Wagon 4-Door'],
    [2009, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'G550', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'GL320', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'ML550', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2009, 'Mercedes-Benz', 'R320', 'Wagon 4-Door'],
    [2009, 'Mercedes-Benz', 'R350', 'Wagon 4-Door'],
    [2009, 'Mercedes-Benz', 'S450', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2009, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'SL63 AMG', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'SL65 AMG', 'Coupe 2-Door'],
    [2009, 'Mercedes-Benz', 'SLK300', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2009, 'Mercedes-Benz', 'SLR McLaren', 'Convertible 2-Door'],
    [2009, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2009, 'Mercury', 'Mariner', 'SUV 4-Door'],
    [2009, 'Mercury', 'Milan', 'Sedan 4-Door'],
    [2009, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2009, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [2009, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2009, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2009, 'Mini', 'Cooper', 'Wagon 3-Door'],
    [2009, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2009, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2009, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2009, 'Mitsubishi', 'Lancer', 'Hatchback 4-Door'],
    [2009, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2009, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2009, 'Mitsubishi', 'Raider', 'Crew Cab Pickup 4-Door'],
    [2009, 'Mitsubishi', 'Raider', 'Extended Cab Pickup 4-Door'],
    [2009, 'Nissan', '350Z', 'Convertible 2-Door'],
    [2009, 'Nissan', '370Z', 'Coupe 2-Door'],
    [2009, 'Nissan', 'Altima', 'Coupe 2-Door'],
    [2009, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2009, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2009, 'Nissan', 'Cube', 'Wagon 4-Door'],
    [2009, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2009, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2009, 'Nissan', 'GT-R', 'Coupe 2-Door'],
    [2009, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2009, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2009, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2009, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2009, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2009, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2009, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2009, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2009, 'Nissan', 'Versa', 'Hatchback 4-Door'],
    [2009, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2009, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2009, 'Pontiac', 'G3', 'Hatchback 4-Door'],
    [2009, 'Pontiac', 'G3 Wave', 'Hatchback 4-Door'],
    [2009, 'Pontiac', 'G3 Wave', 'Sedan 4-Door'],
    [2009, 'Pontiac', 'G5', 'Coupe 2-Door'],
    [2009, 'Pontiac', 'G5', 'Sedan 4-Door'],
    [2009, 'Pontiac', 'G6', 'Convertible 2-Door'],
    [2009, 'Pontiac', 'G6', 'Coupe 2-Door'],
    [2009, 'Pontiac', 'G6', 'Sedan 4-Door'],
    [2009, 'Pontiac', 'G8', 'Sedan 4-Door'],
    [2009, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2009, 'Pontiac', 'Solstice', 'Convertible 2-Door'],
    [2009, 'Pontiac', 'Solstice', 'Coupe 2-Door'],
    [2009, 'Pontiac', 'Torrent', 'SUV 4-Door'],
    [2009, 'Pontiac', 'Vibe', 'Wagon 4-Door'],
    [2009, 'Porsche', '911', 'Convertible 2-Door'],
    [2009, 'Porsche', '911', 'Coupe 2-Door'],
    [2009, 'Porsche', '911', 'Targa 2-Door'],
    [2009, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2009, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2009, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2009, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2009, 'Rolls-Royce', 'Phantom', 'Coupe 2-Door'],
    [2009, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2009, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2009, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2009, 'Saab', '3-Sep', 'Wagon 4-Door'],
    [2009, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2009, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2009, 'Saab', '9-7x', 'SUV 4-Door'],
    [2009, 'Saturn', 'Astra', 'Hatchback 2-Door'],
    [2009, 'Saturn', 'Astra', 'Hatchback 4-Door'],
    [2009, 'Saturn', 'Aura', 'Sedan 4-Door'],
    [2009, 'Saturn', 'Outlook', 'SUV 4-Door'],
    [2009, 'Saturn', 'Sky', 'Convertible 2-Door'],
    [2009, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2009, 'Scion', 'tC', 'Coupe 2-Door'],
    [2009, 'Scion', 'xB', 'Wagon 4-Door'],
    [2009, 'Scion', 'xD', 'Hatchback 4-Door'],
    [2009, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2009, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2009, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2009, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2009, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2009, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2009, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2009, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2009, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2009, 'Subaru', 'Tribeca', 'SUV 4-Door'],
    [2009, 'Suzuki', 'Equator', 'Crew Cab Pickup 4-Door'],
    [2009, 'Suzuki', 'Equator', 'Extended Cab Pickup 4-Door'],
    [2009, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2009, 'Suzuki', 'Swift+', 'Hatchback 4-Door'],
    [2009, 'Suzuki', 'SX4', 'Hatchback 4-Door'],
    [2009, 'Suzuki', 'SX4', 'Sedan 4-Door'],
    [2009, 'Suzuki', 'XL-7', 'SUV 4-Door'],
    [2009, 'Tesla', 'Roadster', 'Convertible 2-Door'],
    [2009, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2009, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2009, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2009, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2009, 'Toyota', 'FJ Cruiser', 'SUV 4-Door'],
    [2009, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2009, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2009, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2009, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2009, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2009, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2009, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2009, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2009, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2009, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2009, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2009, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2009, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2009, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2009, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2009, 'Toyota', 'Venza', 'SUV 4-Door'],
    [2009, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2009, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2009, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2009, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2009, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2009, 'Volkswagen', 'CC', 'Sedan 4-Door'],
    [2009, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2009, 'Volkswagen', 'Golf City', 'Hatchback 4-Door'],
    [2009, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2009, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2009, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2009, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2009, 'Volkswagen', 'Jetta City', 'Sedan 4-Door'],
    [2009, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2009, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2009, 'Volkswagen', 'Passat CC', 'Sedan 4-Door'],
    [2009, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [2009, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [2009, 'Volkswagen', 'Routan', 'Mini Passenger Van 4-Door'],
    [2009, 'Volkswagen', 'Tiguan', 'SUV 4-Door'],
    [2009, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2009, 'Volvo', 'C30', 'Hatchback 2-Door'],
    [2009, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2009, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2009, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2009, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2009, 'Volvo', 'V50', 'Wagon 4-Door'],
    [2009, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2009, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2009, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2008, 'Acura', 'CSX', 'Sedan 4-Door'],
    [2008, 'Acura', 'MDX', 'SUV 4-Door'],
    [2008, 'Acura', 'RDX', 'SUV 4-Door'],
    [2008, 'Acura', 'RL', 'Sedan 4-Door'],
    [2008, 'Acura', 'TL', 'Sedan 4-Door'],
    [2008, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2008, 'Alfa Romeo', '8C', 'Coupe 2-Door'],
    [2008, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2008, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2008, 'Aston Martin', 'DBS', 'Coupe 2-Door'],
    [2008, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2008, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2008, 'Audi', 'A3', 'Hatchback 4-Door'],
    [2008, 'Audi', 'A3 Quattro', 'Hatchback 4-Door'],
    [2008, 'Audi', 'A4', 'Convertible 2-Door'],
    [2008, 'Audi', 'A4', 'Sedan 4-Door'],
    [2008, 'Audi', 'A4 Quattro', 'Convertible 2-Door'],
    [2008, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2008, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2008, 'Audi', 'A5 Quattro', 'Coupe 2-Door'],
    [2008, 'Audi', 'A6', 'Sedan 4-Door'],
    [2008, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2008, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2008, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2008, 'Audi', 'Q7', 'SUV 4-Door'],
    [2008, 'Audi', 'R8', 'Coupe 2-Door'],
    [2008, 'Audi', 'RS4', 'Convertible 2-Door'],
    [2008, 'Audi', 'RS4', 'Sedan 4-Door'],
    [2008, 'Audi', 'S4', 'Convertible 2-Door'],
    [2008, 'Audi', 'S4', 'Sedan 4-Door'],
    [2008, 'Audi', 'S4', 'Wagon 4-Door'],
    [2008, 'Audi', 'S5', 'Coupe 2-Door'],
    [2008, 'Audi', 'S6', 'Sedan 4-Door'],
    [2008, 'Audi', 'S8', 'Sedan 4-Door'],
    [2008, 'Audi', 'TT', 'Convertible 2-Door'],
    [2008, 'Audi', 'TT', 'Coupe 2-Door'],
    [2008, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2008, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2008, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2008, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2008, 'Bentley', 'Brooklands', 'Coupe 2-Door'],
    [2008, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2008, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2008, 'Bentley', 'Continental', 'Sedan 4-Door'],
    [2008, 'BMW', '128i', 'Convertible 2-Door'],
    [2008, 'BMW', '128i', 'Coupe 2-Door'],
    [2008, 'BMW', '135i', 'Convertible 2-Door'],
    [2008, 'BMW', '135i', 'Coupe 2-Door'],
    [2008, 'BMW', '323i', 'Sedan 4-Door'],
    [2008, 'BMW', '328i', 'Convertible 2-Door'],
    [2008, 'BMW', '328i', 'Coupe 2-Door'],
    [2008, 'BMW', '328i', 'Sedan 4-Door'],
    [2008, 'BMW', '328i', 'Wagon 4-Door'],
    [2008, 'BMW', '328xi', 'Coupe 2-Door'],
    [2008, 'BMW', '328xi', 'Sedan 4-Door'],
    [2008, 'BMW', '328xi', 'Wagon 4-Door'],
    [2008, 'BMW', '335i', 'Convertible 2-Door'],
    [2008, 'BMW', '335i', 'Coupe 2-Door'],
    [2008, 'BMW', '335i', 'Sedan 4-Door'],
    [2008, 'BMW', '335xi', 'Coupe 2-Door'],
    [2008, 'BMW', '335xi', 'Sedan 4-Door'],
    [2008, 'BMW', '528i', 'Sedan 4-Door'],
    [2008, 'BMW', '528xi', 'Sedan 4-Door'],
    [2008, 'BMW', '535i', 'Sedan 4-Door'],
    [2008, 'BMW', '535xi', 'Sedan 4-Door'],
    [2008, 'BMW', '535xi', 'Wagon 4-Door'],
    [2008, 'BMW', '550i', 'Sedan 4-Door'],
    [2008, 'BMW', '650i', 'Convertible 2-Door'],
    [2008, 'BMW', '650i', 'Coupe 2-Door'],
    [2008, 'BMW', '750i', 'Sedan 4-Door'],
    [2008, 'BMW', '750Li', 'Sedan 4-Door'],
    [2008, 'BMW', '760Li', 'Sedan 4-Door'],
    [2008, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2008, 'BMW', 'M3', 'Convertible 2-Door'],
    [2008, 'BMW', 'M3', 'Coupe 2-Door'],
    [2008, 'BMW', 'M3', 'Sedan 4-Door'],
    [2008, 'BMW', 'M5', 'Sedan 4-Door'],
    [2008, 'BMW', 'M6', 'Convertible 2-Door'],
    [2008, 'BMW', 'M6', 'Coupe 2-Door'],
    [2008, 'BMW', 'X3', 'SUV 4-Door'],
    [2008, 'BMW', 'X5', 'SUV 4-Door'],
    [2008, 'BMW', 'X6', 'SUV 4-Door'],
    [2008, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2008, 'BMW', 'Z4', 'Coupe 2-Door'],
    [2008, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2008, 'Buick', 'Allure', 'Sedan 4-Door'],
    [2008, 'Buick', 'Enclave', 'SUV 4-Door'],
    [2008, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2008, 'Buick', 'Lucerne', 'Sedan 4-Door'],
    [2008, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2008, 'Cadillac', 'DTS', 'Hearse 4-Door'],
    [2008, 'Cadillac', 'DTS', 'Limousine 4-Door'],
    [2008, 'Cadillac', 'DTS', 'Sedan 4-Door'],
    [2008, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2008, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2008, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2008, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2008, 'Cadillac', 'STS', 'Sedan 4-Door'],
    [2008, 'Cadillac', 'XLR', 'Convertible 2-Door'],
    [2008, 'Chevrolet', 'Avalanche', 'Crew Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Aveo', 'Sedan 4-Door'],
    [2008, 'Chevrolet', 'Aveo5', 'Hatchback 4-Door'],
    [2008, 'Chevrolet', 'Cobalt', 'Coupe 2-Door'],
    [2008, 'Chevrolet', 'Cobalt', 'Sedan 4-Door'],
    [2008, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2008, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2008, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2008, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2008, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2008, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2008, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2008, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2008, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2008, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2008, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2008, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2008, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2008, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2008, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2008, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2008, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2008, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2008, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2008, 'Chevrolet', 'HHR', 'Wagon 2-Door'],
    [2008, 'Chevrolet', 'HHR', 'Wagon 4-Door'],
    [2008, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2008, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2008, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2008, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2008, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2008, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2008, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2008, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2008, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2008, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2008, 'Chevrolet', 'Uplander', 'Mini Cargo Van 4-Door'],
    [2008, 'Chevrolet', 'Uplander', 'Mini Passenger Van 4-Door'],
    [2008, 'Chrysler', '300', 'Sedan 4-Door'],
    [2008, 'Chrysler', 'Aspen', 'SUV 4-Door'],
    [2008, 'Chrysler', 'Crossfire', 'Convertible 2-Door'],
    [2008, 'Chrysler', 'Crossfire', 'Coupe 2-Door'],
    [2008, 'Chrysler', 'Pacifica', 'SUV 4-Door'],
    [2008, 'Chrysler', 'PT Cruiser', 'Convertible 2-Door'],
    [2008, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2008, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2008, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2008, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2008, 'Dodge', 'Avenger', 'Sedan 4-Door'],
    [2008, 'Dodge', 'Caliber', 'Hatchback 4-Door'],
    [2008, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [2008, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2008, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2008, 'Dodge', 'Dakota', 'Extended Cab Pickup 4-Door'],
    [2008, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2008, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 4-Door'],
    [2008, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2008, 'Dodge', 'Magnum', 'Wagon 4-Door'],
    [2008, 'Dodge', 'Nitro', 'SUV 4-Door'],
    [2008, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2008, 'Dodge', 'Ram 1500', 'Extended Crew Cab Pickup 4-Door'],
    [2008, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2008, 'Dodge', 'Ram 2500', 'Crew Cab Pickup 4-Door'],
    [2008, 'Dodge', 'Ram 2500', 'Extended Crew Cab Pickup 4-Door'],
    [2008, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2008, 'Dodge', 'Ram 3500', 'Crew Cab Pickup 4-Door'],
    [2008, 'Dodge', 'Ram 3500', 'Extended Crew Cab Pickup 4-Door'],
    [2008, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2008, 'Dodge', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2008, 'Dodge', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2008, 'Dodge', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2008, 'Dodge', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2008, 'Dodge', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2008, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2008, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2008, 'Ferrari', '599 GTB', 'Coupe 2-Door'],
    [2008, 'Ferrari', '612 Scaglietti', 'Coupe 2-Door'],
    [2008, 'Ferrari', 'F430', 'Convertible 2-Door'],
    [2008, 'Ferrari', 'F430', 'Coupe 2-Door'],
    [2008, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2008, 'Ford', 'E-150', 'Extended Cargo Van 3-Door'],
    [2008, 'Ford', 'E-150', 'Standard Cargo Van 3-Door'],
    [2008, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2008, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2008, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2008, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 3-Door'],
    [2008, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2008, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 3-Door'],
    [2008, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2008, 'Ford', 'Edge', 'SUV 4-Door'],
    [2008, 'Ford', 'Escape', 'SUV 4-Door'],
    [2008, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2008, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2008, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2008, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2008, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2008, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2008, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2008, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2008, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2008, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2008, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2008, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2008, 'Ford', 'F-450 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2008, 'Ford', 'Focus', 'Coupe 2-Door'],
    [2008, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2008, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2008, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2008, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2008, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2008, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2008, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2008, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2008, 'Ford', 'Taurus X', 'Wagon 4-Door'],
    [2008, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2008, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2008, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2008, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2008, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2008, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2008, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2008, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2008, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2008, 'GMC', 'Envoy', 'SUV 4-Door'],
    [2008, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2008, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2008, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2008, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2008, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2008, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2008, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2008, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2008, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2008, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2008, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2008, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2008, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2008, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2008, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2008, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2008, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2008, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2008, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2008, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2008, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2008, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2008, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2008, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2008, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2008, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2008, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2008, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2008, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2008, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2008, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2008, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2008, 'Honda', 'Element', 'SUV 4-Door'],
    [2008, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2008, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2008, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2008, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2008, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2008, 'Hummer', 'H2', 'Crew Cab Pickup 4-Door'],
    [2008, 'Hummer', 'H2', 'SUV 4-Door'],
    [2008, 'Hummer', 'H3', 'SUV 4-Door'],
    [2008, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2008, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2008, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2008, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2008, 'Hyundai', 'Entourage', 'Mini Passenger Van 4-Door'],
    [2008, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2008, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2008, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [2008, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2008, 'Hyundai', 'Veracruz', 'SUV 4-Door'],
    [2008, 'INFINITI', 'EX35', 'SUV 4-Door'],
    [2008, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2008, 'INFINITI', 'FX45', 'SUV 4-Door'],
    [2008, 'INFINITI', 'G35', 'Sedan 4-Door'],
    [2008, 'INFINITI', 'G37', 'Coupe 2-Door'],
    [2008, 'INFINITI', 'M35', 'Sedan 4-Door'],
    [2008, 'INFINITI', 'M45', 'Sedan 4-Door'],
    [2008, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2008, 'Isuzu', 'Ascender', 'SUV 4-Door'],
    [2008, 'Isuzu', 'i-290', 'Extended Cab Pickup 4-Door'],
    [2008, 'Isuzu', 'i-370', 'Crew Cab Pickup 4-Door'],
    [2008, 'Isuzu', 'i-370', 'Extended Cab Pickup 4-Door'],
    [2008, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2008, 'Jaguar', 'Super V8', 'Sedan 4-Door'],
    [2008, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2008, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2008, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2008, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2008, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2008, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2008, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2008, 'Jaguar', 'X-Type', 'Sedan 4-Door'],
    [2008, 'Jaguar', 'X-Type', 'Wagon 4-Door'],
    [2008, 'Jeep', 'Commander', 'SUV 4-Door'],
    [2008, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2008, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2008, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2008, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2008, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2008, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2008, 'Kia', 'Amanti', 'Sedan 4-Door'],
    [2008, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2008, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2008, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2008, 'Kia', 'Rio5', 'Hatchback 4-Door'],
    [2008, 'Kia', 'Rondo', 'Wagon 4-Door'],
    [2008, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2008, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2008, 'Kia', 'Spectra', 'Sedan 4-Door'],
    [2008, 'Kia', 'Spectra5', 'Hatchback 4-Door'],
    [2008, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2008, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2008, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2008, 'Lamborghini', 'Murcielago', 'Convertible 2-Door'],
    [2008, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2008, 'Land Rover', 'LR2', 'SUV 4-Door'],
    [2008, 'Land Rover', 'LR3', 'SUV 4-Door'],
    [2008, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2008, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2008, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2008, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2008, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2008, 'Lexus', 'GS460', 'Sedan 4-Door'],
    [2008, 'Lexus', 'GX470', 'SUV 4-Door'],
    [2008, 'Lexus', 'IS F', 'Sedan 4-Door'],
    [2008, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2008, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2008, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2008, 'Lexus', 'LS600h', 'Sedan 4-Door'],
    [2008, 'Lexus', 'LX570', 'SUV 4-Door'],
    [2008, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2008, 'Lexus', 'RX400h', 'SUV 4-Door'],
    [2008, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2008, 'Lincoln', 'Mark LT', 'Crew Cab Pickup 4-Door'],
    [2008, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2008, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2008, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2008, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2008, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2008, 'Lotus', 'Elise', 'Convertible 2-Door'],
    [2008, 'Lotus', 'Exige', 'Coupe 2-Door'],
    [2008, 'Maserati', 'GranTurismo', 'Coupe 2-Door'],
    [2008, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2008, 'Maybach', '57', 'Sedan 4-Door'],
    [2008, 'Maybach', '62', 'Sedan 4-Door'],
    [2008, 'Mazda', '3', 'Hatchback 4-Door'],
    [2008, 'Mazda', '3', 'Sedan 4-Door'],
    [2008, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2008, 'Mazda', '6', 'Hatchback 4-Door'],
    [2008, 'Mazda', '6', 'Sedan 4-Door'],
    [2008, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2008, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [2008, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2008, 'Mazda', 'CX-7', 'SUV 4-Door'],
    [2008, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2008, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2008, 'Mazda', 'RX-8', 'Coupe 4-Door'],
    [2008, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'B200', 'Hatchback 4-Door'],
    [2008, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'C300', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'C63 AMG', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'CL550', 'Coupe 2-Door'],
    [2008, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2008, 'Mercedes-Benz', 'CL63 AMG', 'Coupe 2-Door'],
    [2008, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2008, 'Mercedes-Benz', 'CLK350', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'CLK350', 'Coupe 2-Door'],
    [2008, 'Mercedes-Benz', 'CLK550', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'CLK550', 'Coupe 2-Door'],
    [2008, 'Mercedes-Benz', 'CLK63 AMG', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'CLK63 AMG', 'Coupe 2-Door'],
    [2008, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'CLS63 AMG', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2008, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'E63 AMG', 'Wagon 4-Door'],
    [2008, 'Mercedes-Benz', 'G500', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'GL320', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'GL550', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'ML550', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2008, 'Mercedes-Benz', 'R320', 'Wagon 4-Door'],
    [2008, 'Mercedes-Benz', 'R350', 'Wagon 4-Door'],
    [2008, 'Mercedes-Benz', 'R550', 'Wagon 4-Door'],
    [2008, 'Mercedes-Benz', 'S450', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'S63 AMG', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2008, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'SLK280', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'SLR McLaren', 'Convertible 2-Door'],
    [2008, 'Mercedes-Benz', 'SLR McLaren', 'Coupe 2-Door'],
    [2008, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2008, 'Mercury', 'Mariner', 'SUV 4-Door'],
    [2008, 'Mercury', 'Milan', 'Sedan 4-Door'],
    [2008, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2008, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [2008, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2008, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2008, 'Mini', 'Cooper', 'Wagon 3-Door'],
    [2008, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2008, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2008, 'Mitsubishi', 'Endeavor', 'SUV 4-Door'],
    [2008, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2008, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2008, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2008, 'Mitsubishi', 'Raider', 'Crew Cab Pickup 4-Door'],
    [2008, 'Mitsubishi', 'Raider', 'Extended Cab Pickup 4-Door'],
    [2008, 'Nissan', '350Z', 'Convertible 2-Door'],
    [2008, 'Nissan', '350Z', 'Coupe 2-Door'],
    [2008, 'Nissan', 'Altima', 'Coupe 2-Door'],
    [2008, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2008, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2008, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2008, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2008, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2008, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2008, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2008, 'Nissan', 'Rogue', 'SUV 4-Door'],
    [2008, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2008, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2008, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2008, 'Nissan', 'Versa', 'Hatchback 4-Door'],
    [2008, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2008, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2008, 'Pontiac', 'G5', 'Coupe 2-Door'],
    [2008, 'Pontiac', 'G5', 'Sedan 4-Door'],
    [2008, 'Pontiac', 'G6', 'Convertible 2-Door'],
    [2008, 'Pontiac', 'G6', 'Coupe 2-Door'],
    [2008, 'Pontiac', 'G6', 'Sedan 4-Door'],
    [2008, 'Pontiac', 'G8', 'Sedan 4-Door'],
    [2008, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2008, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2008, 'Pontiac', 'Solstice', 'Convertible 2-Door'],
    [2008, 'Pontiac', 'Torrent', 'SUV 4-Door'],
    [2008, 'Pontiac', 'Vibe', 'Wagon 4-Door'],
    [2008, 'Pontiac', 'Wave', 'Hatchback 4-Door'],
    [2008, 'Pontiac', 'Wave', 'Sedan 4-Door'],
    [2008, 'Porsche', '911', 'Convertible 2-Door'],
    [2008, 'Porsche', '911', 'Coupe 2-Door'],
    [2008, 'Porsche', '911', 'Targa 2-Door'],
    [2008, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2008, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2008, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2008, 'Rolls-Royce', 'Phantom', 'Convertible 2-Door'],
    [2008, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2008, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2008, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2008, 'Saab', '3-Sep', 'Wagon 4-Door'],
    [2008, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2008, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2008, 'Saab', '9-7x', 'SUV 4-Door'],
    [2008, 'Saturn', 'Astra', 'Hatchback 2-Door'],
    [2008, 'Saturn', 'Astra', 'Hatchback 4-Door'],
    [2008, 'Saturn', 'Aura', 'Sedan 4-Door'],
    [2008, 'Saturn', 'Outlook', 'SUV 4-Door'],
    [2008, 'Saturn', 'Sky', 'Convertible 2-Door'],
    [2008, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2008, 'Scion', 'tC', 'Coupe 2-Door'],
    [2008, 'Scion', 'xB', 'Wagon 4-Door'],
    [2008, 'Scion', 'xD', 'Hatchback 4-Door'],
    [2008, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2008, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2008, 'Spyker', 'C12', 'Coupe 2-Door'],
    [2008, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2008, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2008, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2008, 'Subaru', 'Impreza', 'Hatchback 4-Door'],
    [2008, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2008, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2008, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2008, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2008, 'Subaru', 'Tribeca', 'SUV 4-Door'],
    [2008, 'Suzuki', 'Forenza', 'Sedan 4-Door'],
    [2008, 'Suzuki', 'Forenza', 'Wagon 4-Door'],
    [2008, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2008, 'Suzuki', 'Reno', 'Hatchback 4-Door'],
    [2008, 'Suzuki', 'Swift+', 'Hatchback 4-Door'],
    [2008, 'Suzuki', 'SX4', 'Hatchback 4-Door'],
    [2008, 'Suzuki', 'SX4', 'Sedan 4-Door'],
    [2008, 'Suzuki', 'XL-7', 'SUV 4-Door'],
    [2008, 'Tesla', 'Roadster', 'Convertible 2-Door'],
    [2008, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2008, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2008, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2008, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2008, 'Toyota', 'FJ Cruiser', 'SUV 4-Door'],
    [2008, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2008, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2008, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2008, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2008, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2008, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2008, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2008, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2008, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2008, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2008, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2008, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2008, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2008, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2008, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2008, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2008, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2008, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2008, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2008, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2008, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2008, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2008, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2008, 'Volkswagen', 'Golf City', 'Hatchback 4-Door'],
    [2008, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2008, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2008, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2008, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2008, 'Volkswagen', 'Jetta City', 'Sedan 4-Door'],
    [2008, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2008, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2008, 'Volkswagen', 'R32', 'Hatchback 2-Door'],
    [2008, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [2008, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [2008, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2008, 'Volvo', 'C30', 'Hatchback 2-Door'],
    [2008, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2008, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2008, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2008, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2008, 'Volvo', 'V50', 'Wagon 4-Door'],
    [2008, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2008, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2008, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2007, 'Acura', 'CSX', 'Sedan 4-Door'],
    [2007, 'Acura', 'MDX', 'SUV 4-Door'],
    [2007, 'Acura', 'RDX', 'SUV 4-Door'],
    [2007, 'Acura', 'RL', 'Sedan 4-Door'],
    [2007, 'Acura', 'TL', 'Sedan 4-Door'],
    [2007, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2007, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2007, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2007, 'Aston Martin', 'V8 Vantage', 'Convertible 2-Door'],
    [2007, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2007, 'Audi', 'A3', 'Hatchback 4-Door'],
    [2007, 'Audi', 'A3 Quattro', 'Hatchback 4-Door'],
    [2007, 'Audi', 'A4', 'Convertible 2-Door'],
    [2007, 'Audi', 'A4', 'Sedan 4-Door'],
    [2007, 'Audi', 'A4 Quattro', 'Convertible 2-Door'],
    [2007, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2007, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2007, 'Audi', 'A6', 'Sedan 4-Door'],
    [2007, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2007, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2007, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2007, 'Audi', 'Q7', 'SUV 4-Door'],
    [2007, 'Audi', 'RS4', 'Sedan 4-Door'],
    [2007, 'Audi', 'S4', 'Convertible 2-Door'],
    [2007, 'Audi', 'S4', 'Sedan 4-Door'],
    [2007, 'Audi', 'S4', 'Wagon 4-Door'],
    [2007, 'Audi', 'S6', 'Sedan 4-Door'],
    [2007, 'Audi', 'S8', 'Sedan 4-Door'],
    [2007, 'Avanti', 'Avanti', 'Convertible 2-Door'],
    [2007, 'Avanti', 'Avanti', 'Coupe 2-Door'],
    [2007, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2007, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2007, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [2007, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2007, 'Bentley', 'Continental', 'Sedan 4-Door'],
    [2007, 'BMW', '323i', 'Sedan 4-Door'],
    [2007, 'BMW', '328i', 'Convertible 2-Door'],
    [2007, 'BMW', '328i', 'Coupe 2-Door'],
    [2007, 'BMW', '328i', 'Sedan 4-Door'],
    [2007, 'BMW', '328i', 'Wagon 4-Door'],
    [2007, 'BMW', '328xi', 'Coupe 2-Door'],
    [2007, 'BMW', '328xi', 'Sedan 4-Door'],
    [2007, 'BMW', '328xi', 'Wagon 4-Door'],
    [2007, 'BMW', '335i', 'Convertible 2-Door'],
    [2007, 'BMW', '335i', 'Coupe 2-Door'],
    [2007, 'BMW', '335i', 'Sedan 4-Door'],
    [2007, 'BMW', '335xi', 'Sedan 4-Door'],
    [2007, 'BMW', '525i', 'Sedan 4-Door'],
    [2007, 'BMW', '525xi', 'Sedan 4-Door'],
    [2007, 'BMW', '530i', 'Sedan 4-Door'],
    [2007, 'BMW', '530xi', 'Sedan 4-Door'],
    [2007, 'BMW', '530xi', 'Wagon 4-Door'],
    [2007, 'BMW', '550i', 'Sedan 4-Door'],
    [2007, 'BMW', '650i', 'Convertible 2-Door'],
    [2007, 'BMW', '650i', 'Coupe 2-Door'],
    [2007, 'BMW', '750i', 'Sedan 4-Door'],
    [2007, 'BMW', '750Li', 'Sedan 4-Door'],
    [2007, 'BMW', '760Li', 'Sedan 4-Door'],
    [2007, 'BMW', 'Alpina B7', 'Sedan 4-Door'],
    [2007, 'BMW', 'M5', 'Sedan 4-Door'],
    [2007, 'BMW', 'M6', 'Convertible 2-Door'],
    [2007, 'BMW', 'M6', 'Coupe 2-Door'],
    [2007, 'BMW', 'X3', 'SUV 4-Door'],
    [2007, 'BMW', 'X5', 'SUV 4-Door'],
    [2007, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2007, 'BMW', 'Z4', 'Coupe 2-Door'],
    [2007, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2007, 'Buick', 'Allure', 'Sedan 4-Door'],
    [2007, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2007, 'Buick', 'Lucerne', 'Sedan 4-Door'],
    [2007, 'Buick', 'Rainier', 'SUV 4-Door'],
    [2007, 'Buick', 'Rendezvous', 'SUV 4-Door'],
    [2007, 'Buick', 'Terraza', 'Mini Passenger Van 4-Door'],
    [2007, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2007, 'Cadillac', 'DTS', 'Hearse 4-Door'],
    [2007, 'Cadillac', 'DTS', 'Limousine 4-Door'],
    [2007, 'Cadillac', 'DTS', 'Sedan 4-Door'],
    [2007, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2007, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2007, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2007, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2007, 'Cadillac', 'STS', 'Sedan 4-Door'],
    [2007, 'Cadillac', 'XLR', 'Convertible 2-Door'],
    [2007, 'Chevrolet', 'Avalanche', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Aveo', 'Sedan 4-Door'],
    [2007, 'Chevrolet', 'Aveo5', 'Hatchback 4-Door'],
    [2007, 'Chevrolet', 'Cobalt', 'Coupe 2-Door'],
    [2007, 'Chevrolet', 'Cobalt', 'Sedan 4-Door'],
    [2007, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2007, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2007, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2007, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2007, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2007, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2007, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2007, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2007, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2007, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2007, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2007, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2007, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 4-Door'],
    [2007, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2007, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2007, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2007, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2007, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2007, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2007, 'Chevrolet', 'HHR', 'Wagon 2-Door'],
    [2007, 'Chevrolet', 'HHR', 'Wagon 4-Door'],
    [2007, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2007, 'Chevrolet', 'Malibu', 'Hatchback 4-Door'],
    [2007, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2007, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [2007, 'Chevrolet', 'Optra', 'Hatchback 4-Door'],
    [2007, 'Chevrolet', 'Optra', 'Wagon 4-Door'],
    [2007, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2007, 'Chevrolet', 'Silverado 1500 Classic', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 1500 Classic', 'Extended Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 1500 Classic', 'Standard Cab Pickup 2-Door'],
    [2007, 'Chevrolet', 'Silverado 1500 HD Classic', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2007, 'Chevrolet', 'Silverado 2500 HD Classic', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 2500 HD Classic', 'Extended Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 2500 HD Classic', 'Standard Cab Pickup 2-Door'],
    [2007, 'Chevrolet', 'Silverado 3500 Classic', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 3500 Classic', 'Extended Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 3500 Classic', 'Standard Cab Pickup 2-Door'],
    [2007, 'Chevrolet', 'Silverado 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2007, 'Chevrolet', 'Silverado 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2007, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2007, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2007, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2007, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2007, 'Chevrolet', 'Uplander', 'Mini Cargo Van 4-Door'],
    [2007, 'Chevrolet', 'Uplander', 'Mini Passenger Van 4-Door'],
    [2007, 'Chrysler', '300', 'Sedan 4-Door'],
    [2007, 'Chrysler', 'Aspen', 'SUV 4-Door'],
    [2007, 'Chrysler', 'Crossfire', 'Convertible 2-Door'],
    [2007, 'Chrysler', 'Crossfire', 'Coupe 2-Door'],
    [2007, 'Chrysler', 'Pacifica', 'SUV 4-Door'],
    [2007, 'Chrysler', 'PT Cruiser', 'Convertible 2-Door'],
    [2007, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2007, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2007, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2007, 'Dodge', 'Caliber', 'Hatchback 4-Door'],
    [2007, 'Dodge', 'Caravan', 'Mini Cargo Van 4-Door'],
    [2007, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [2007, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2007, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2007, 'Dodge', 'Dakota', 'Extended Cab Pickup 4-Door'],
    [2007, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2007, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 4-Door'],
    [2007, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2007, 'Dodge', 'Magnum', 'Wagon 4-Door'],
    [2007, 'Dodge', 'Nitro', 'SUV 4-Door'],
    [2007, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2007, 'Dodge', 'Ram 1500', 'Extended Crew Cab Pickup 4-Door'],
    [2007, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2007, 'Dodge', 'Ram 2500', 'Crew Cab Pickup 4-Door'],
    [2007, 'Dodge', 'Ram 2500', 'Extended Crew Cab Pickup 4-Door'],
    [2007, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2007, 'Dodge', 'Ram 3500', 'Crew Cab Pickup 4-Door'],
    [2007, 'Dodge', 'Ram 3500', 'Extended Crew Cab Pickup 4-Door'],
    [2007, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2007, 'Dodge', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2007, 'Dodge', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2007, 'Dodge', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2007, 'Dodge', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2007, 'Dodge', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2007, 'Dodge', 'Sprinter 3500', 'Standard Passenger Van 3-Door'],
    [2007, 'Ferrari', '599 GTB', 'Coupe 2-Door'],
    [2007, 'Ferrari', '612 Scaglietti', 'Coupe 2-Door'],
    [2007, 'Ferrari', 'F430', 'Convertible 2-Door'],
    [2007, 'Ferrari', 'F430', 'Coupe 2-Door'],
    [2007, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2007, 'Ford', 'E-150', 'Standard Cargo Van 2-Door'],
    [2007, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2007, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2007, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2007, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [2007, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2007, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [2007, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2007, 'Ford', 'Edge', 'SUV 4-Door'],
    [2007, 'Ford', 'Escape', 'SUV 4-Door'],
    [2007, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2007, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2007, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2007, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2007, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2007, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2007, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2007, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2007, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2007, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2007, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2007, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2007, 'Ford', 'Five Hundred', 'Sedan 4-Door'],
    [2007, 'Ford', 'Focus', 'Hatchback 2-Door'],
    [2007, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2007, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2007, 'Ford', 'Focus', 'Wagon 5-Door'],
    [2007, 'Ford', 'Freestar', 'Mini Cargo Van 3-Door'],
    [2007, 'Ford', 'Freestar', 'Mini Passenger Van 4-Door'],
    [2007, 'Ford', 'Freestyle', 'Wagon 4-Door'],
    [2007, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2007, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2007, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2007, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2007, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2007, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2007, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2007, 'Freightliner', 'Sprinter 2500', 'Extended Cargo Van 3-Door'],
    [2007, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2007, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2007, 'Freightliner', 'Sprinter 3500', 'Extended Cargo Van 3-Door'],
    [2007, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2007, 'GMC', 'Acadia', 'SUV 4-Door'],
    [2007, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2007, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2007, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2007, 'GMC', 'Envoy', 'SUV 4-Door'],
    [2007, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2007, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2007, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2007, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2007, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2007, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2007, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2007, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2007, 'GMC', 'Savana 2500', 'Standard Passenger Van 4-Door'],
    [2007, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2007, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2007, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2007, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2007, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2007, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2007, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2007, 'GMC', 'Sierra 1500 Classic', 'Crew Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 1500 Classic', 'Extended Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 1500 Classic', 'Standard Cab Pickup 2-Door'],
    [2007, 'GMC', 'Sierra 1500 HD Classic', 'Crew Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2007, 'GMC', 'Sierra 2500 HD Classic', 'Crew Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 2500 HD Classic', 'Extended Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 2500 HD Classic', 'Standard Cab Pickup 2-Door'],
    [2007, 'GMC', 'Sierra 3500 Classic', 'Crew Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 3500 Classic', 'Extended Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 3500 Classic', 'Standard Cab Pickup 2-Door'],
    [2007, 'GMC', 'Sierra 3500 HD', 'Crew Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 3500 HD', 'Extended Cab Pickup 4-Door'],
    [2007, 'GMC', 'Sierra 3500 HD', 'Standard Cab Pickup 2-Door'],
    [2007, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2007, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2007, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2007, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2007, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2007, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2007, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2007, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2007, 'Honda', 'Element', 'SUV 4-Door'],
    [2007, 'Honda', 'Fit', 'Hatchback 4-Door'],
    [2007, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2007, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2007, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2007, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2007, 'Hummer', 'H2', 'Crew Cab Pickup 4-Door'],
    [2007, 'Hummer', 'H2', 'SUV 4-Door'],
    [2007, 'Hummer', 'H3', 'SUV 4-Door'],
    [2007, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2007, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2007, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2007, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2007, 'Hyundai', 'Entourage', 'Mini Passenger Van 4-Door'],
    [2007, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2007, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2007, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [2007, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2007, 'Hyundai', 'Veracruz', 'SUV 4-Door'],
    [2007, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2007, 'INFINITI', 'FX45', 'SUV 4-Door'],
    [2007, 'INFINITI', 'G35', 'Coupe 2-Door'],
    [2007, 'INFINITI', 'G35', 'Sedan 4-Door'],
    [2007, 'INFINITI', 'M35', 'Sedan 4-Door'],
    [2007, 'INFINITI', 'M45', 'Sedan 4-Door'],
    [2007, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2007, 'Isuzu', 'Ascender', 'SUV 4-Door'],
    [2007, 'Isuzu', 'i-290', 'Extended Cab Pickup 4-Door'],
    [2007, 'Isuzu', 'i-370', 'Crew Cab Pickup 4-Door'],
    [2007, 'Isuzu', 'i-370', 'Extended Cab Pickup 2-Door'],
    [2007, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2007, 'Jaguar', 'Super V8', 'Sedan 4-Door'],
    [2007, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2007, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2007, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2007, 'Jaguar', 'XK', 'Convertible 2-Door'],
    [2007, 'Jaguar', 'XK', 'Coupe 2-Door'],
    [2007, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2007, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2007, 'Jaguar', 'X-Type', 'Sedan 4-Door'],
    [2007, 'Jaguar', 'X-Type', 'Wagon 4-Door'],
    [2007, 'Jeep', 'Commander', 'SUV 4-Door'],
    [2007, 'Jeep', 'Compass', 'SUV 4-Door'],
    [2007, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2007, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2007, 'Jeep', 'Patriot', 'SUV 4-Door'],
    [2007, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2007, 'Jeep', 'Wrangler', 'SUV 4-Door'],
    [2007, 'Kia', 'Amanti', 'Sedan 4-Door'],
    [2007, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2007, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2007, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2007, 'Kia', 'Rio5', 'Hatchback 4-Door'],
    [2007, 'Kia', 'Rondo', 'Wagon 4-Door'],
    [2007, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2007, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2007, 'Kia', 'Spectra', 'Sedan 4-Door'],
    [2007, 'Kia', 'Spectra5', 'Hatchback 4-Door'],
    [2007, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2007, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2007, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2007, 'Lamborghini', 'Murcielago', 'Convertible 2-Door'],
    [2007, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2007, 'Land Rover', 'LR3', 'SUV 4-Door'],
    [2007, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2007, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2007, 'Lexus', 'ES350', 'Sedan 4-Door'],
    [2007, 'Lexus', 'GS350', 'Sedan 4-Door'],
    [2007, 'Lexus', 'GS430', 'Sedan 4-Door'],
    [2007, 'Lexus', 'GS450h', 'Sedan 4-Door'],
    [2007, 'Lexus', 'GX470', 'SUV 4-Door'],
    [2007, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2007, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2007, 'Lexus', 'LS460', 'Sedan 4-Door'],
    [2007, 'Lexus', 'LX470', 'SUV 4-Door'],
    [2007, 'Lexus', 'RX350', 'SUV 4-Door'],
    [2007, 'Lexus', 'RX400h', 'SUV 4-Door'],
    [2007, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2007, 'Lincoln', 'Mark LT', 'Crew Cab Pickup 4-Door'],
    [2007, 'Lincoln', 'MKX', 'SUV 4-Door'],
    [2007, 'Lincoln', 'MKZ', 'Sedan 4-Door'],
    [2007, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2007, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2007, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2007, 'Lotus', 'Elise', 'Convertible 2-Door'],
    [2007, 'Lotus', 'Exige', 'Coupe 2-Door'],
    [2007, 'Maserati', 'Coupe', 'Coupe 2-Door'],
    [2007, 'Maserati', 'GranSport', 'Convertible 2-Door'],
    [2007, 'Maserati', 'GranSport', 'Coupe 2-Door'],
    [2007, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2007, 'Maybach', '57', 'Sedan 4-Door'],
    [2007, 'Maybach', '62', 'Sedan 4-Door'],
    [2007, 'Mazda', '3', 'Hatchback 4-Door'],
    [2007, 'Mazda', '3', 'Sedan 4-Door'],
    [2007, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2007, 'Mazda', '6', 'Hatchback 4-Door'],
    [2007, 'Mazda', '6', 'Sedan 4-Door'],
    [2007, 'Mazda', '6', 'Wagon 5-Door'],
    [2007, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2007, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [2007, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [2007, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2007, 'Mazda', 'CX-7', 'SUV 4-Door'],
    [2007, 'Mazda', 'CX-9', 'SUV 4-Door'],
    [2007, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2007, 'Mazda', 'RX-8', 'Coupe 4-Door'],
    [2007, 'Mercedes-Benz', 'B200', 'Hatchback 4-Door'],
    [2007, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'CL550', 'Coupe 2-Door'],
    [2007, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2007, 'Mercedes-Benz', 'CLK350', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'CLK350', 'Coupe 2-Door'],
    [2007, 'Mercedes-Benz', 'CLK550', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'CLK550', 'Coupe 2-Door'],
    [2007, 'Mercedes-Benz', 'CLK63 AMG', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'CLS550', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'CLS63 AMG', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'E280', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2007, 'Mercedes-Benz', 'E550', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'E63 AMG', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'E63 AMG', 'Wagon 4-Door'],
    [2007, 'Mercedes-Benz', 'G500', 'SUV 4-Door'],
    [2007, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2007, 'Mercedes-Benz', 'GL320', 'SUV 4-Door'],
    [2007, 'Mercedes-Benz', 'GL450', 'SUV 4-Door'],
    [2007, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [2007, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2007, 'Mercedes-Benz', 'ML500', 'SUV 4-Door'],
    [2007, 'Mercedes-Benz', 'ML63 AMG', 'SUV 4-Door'],
    [2007, 'Mercedes-Benz', 'R320', 'Wagon 4-Door'],
    [2007, 'Mercedes-Benz', 'R350', 'Wagon 4-Door'],
    [2007, 'Mercedes-Benz', 'R500', 'Wagon 4-Door'],
    [2007, 'Mercedes-Benz', 'R63 AMG', 'Wagon 4-Door'],
    [2007, 'Mercedes-Benz', 'S550', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2007, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'SL550', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'SLK280', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2007, 'Mercedes-Benz', 'SLR McLaren', 'Coupe 2-Door'],
    [2007, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2007, 'Mercury', 'Mariner', 'SUV 4-Door'],
    [2007, 'Mercury', 'Milan', 'Sedan 4-Door'],
    [2007, 'Mercury', 'Montego', 'Sedan 4-Door'],
    [2007, 'Mercury', 'Monterey', 'Mini Passenger Van 4-Door'],
    [2007, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2007, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2007, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2007, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2007, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2007, 'Mitsubishi', 'Endeavor', 'SUV 4-Door'],
    [2007, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2007, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2007, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2007, 'Mitsubishi', 'Raider', 'Crew Cab Pickup 4-Door'],
    [2007, 'Mitsubishi', 'Raider', 'Extended Cab Pickup 4-Door'],
    [2007, 'Morgan', 'Aero 8', 'Convertible 2-Door'],
    [2007, 'Nissan', '350Z', 'Convertible 2-Door'],
    [2007, 'Nissan', '350Z', 'Coupe 2-Door'],
    [2007, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2007, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2007, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2007, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2007, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2007, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2007, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2007, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2007, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2007, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2007, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2007, 'Nissan', 'Versa', 'Hatchback 4-Door'],
    [2007, 'Nissan', 'Versa', 'Sedan 4-Door'],
    [2007, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2007, 'Panoz', 'Esperante', 'Convertible 2-Door'],
    [2007, 'Panoz', 'Esperante', 'Coupe 2-Door'],
    [2007, 'Pontiac', 'G5', 'Coupe 2-Door'],
    [2007, 'Pontiac', 'G5', 'Sedan 4-Door'],
    [2007, 'Pontiac', 'G6', 'Convertible 2-Door'],
    [2007, 'Pontiac', 'G6', 'Coupe 2-Door'],
    [2007, 'Pontiac', 'G6', 'Sedan 4-Door'],
    [2007, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2007, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2007, 'Pontiac', 'Solstice', 'Convertible 2-Door'],
    [2007, 'Pontiac', 'Torrent', 'SUV 4-Door'],
    [2007, 'Pontiac', 'Vibe', 'Wagon 4-Door'],
    [2007, 'Pontiac', 'Wave', 'Sedan 4-Door'],
    [2007, 'Pontiac', 'Wave5', 'Hatchback 4-Door'],
    [2007, 'Porsche', '911', 'Convertible 2-Door'],
    [2007, 'Porsche', '911', 'Coupe 2-Door'],
    [2007, 'Porsche', '911', 'Targa 2-Door'],
    [2007, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2007, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2007, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2007, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2007, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2007, 'Saab', '3-Sep', 'Wagon 4-Door'],
    [2007, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2007, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2007, 'Saab', '9-7x', 'SUV 4-Door'],
    [2007, 'Saturn', 'Aura', 'Sedan 4-Door'],
    [2007, 'Saturn', 'Ion', 'Coupe 4-Door'],
    [2007, 'Saturn', 'Ion', 'Sedan 4-Door'],
    [2007, 'Saturn', 'Outlook', 'SUV 4-Door'],
    [2007, 'Saturn', 'Relay', 'Mini Passenger Van 4-Door'],
    [2007, 'Saturn', 'Sky', 'Convertible 2-Door'],
    [2007, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2007, 'Scion', 'tC', 'Coupe 2-Door'],
    [2007, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2007, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2007, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2007, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2007, 'Subaru', 'B9 Tribeca', 'SUV 4-Door'],
    [2007, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2007, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2007, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [2007, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2007, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2007, 'Subaru', 'Outback', 'Sedan 4-Door'],
    [2007, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2007, 'Suzuki', 'Aerio', 'Sedan 4-Door'],
    [2007, 'Suzuki', 'Forenza', 'Sedan 4-Door'],
    [2007, 'Suzuki', 'Forenza', 'Wagon 4-Door'],
    [2007, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2007, 'Suzuki', 'Reno', 'Hatchback 4-Door'],
    [2007, 'Suzuki', 'Swift+', 'Hatchback 4-Door'],
    [2007, 'Suzuki', 'SX4', 'Hatchback 4-Door'],
    [2007, 'Suzuki', 'XL-7', 'SUV 4-Door'],
    [2007, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2007, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2007, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2007, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2007, 'Toyota', 'FJ Cruiser', 'SUV 4-Door'],
    [2007, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2007, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2007, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2007, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2007, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2007, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2007, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2007, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2007, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2007, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2007, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2007, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2007, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2007, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2007, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2007, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2007, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2007, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2007, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2007, 'Toyota', 'Yaris', 'Sedan 4-Door'],
    [2007, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2007, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2007, 'Volkswagen', 'Eos', 'Convertible 2-Door'],
    [2007, 'Volkswagen', 'Golf City', 'Hatchback 4-Door'],
    [2007, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2007, 'Volkswagen', 'GTI', 'Hatchback 4-Door'],
    [2007, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2007, 'Volkswagen', 'Jetta City', 'Sedan 4-Door'],
    [2007, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2007, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2007, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [2007, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [2007, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2007, 'Volvo', 'C30', 'Hatchback 2-Door'],
    [2007, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2007, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2007, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2007, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2007, 'Volvo', 'V50', 'Wagon 4-Door'],
    [2007, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2007, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2007, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2006, 'Acura', 'CSX', 'Sedan 4-Door'],
    [2006, 'Acura', 'MDX', 'SUV 4-Door'],
    [2006, 'Acura', 'RL', 'Sedan 4-Door'],
    [2006, 'Acura', 'RSX', 'Coupe 2-Door'],
    [2006, 'Acura', 'TL', 'Sedan 4-Door'],
    [2006, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2006, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2006, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2006, 'Aston Martin', 'V8 Vantage', 'Hatchback 2-Door'],
    [2006, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2006, 'Audi', 'A3', 'Hatchback 4-Door'],
    [2006, 'Audi', 'A3 Quattro', 'Hatchback 4-Door'],
    [2006, 'Audi', 'A4', 'Convertible 2-Door'],
    [2006, 'Audi', 'A4', 'Sedan 4-Door'],
    [2006, 'Audi', 'A4 Quattro', 'Convertible 2-Door'],
    [2006, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2006, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2006, 'Audi', 'A6', 'Sedan 4-Door'],
    [2006, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2006, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2006, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2006, 'Audi', 'S4', 'Convertible 2-Door'],
    [2006, 'Audi', 'S4', 'Sedan 4-Door'],
    [2006, 'Audi', 'S4', 'Wagon 4-Door'],
    [2006, 'Audi', 'TT', 'Convertible 2-Door'],
    [2006, 'Audi', 'TT', 'Coupe 2-Door'],
    [2006, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2006, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2006, 'Avanti', 'Avanti', 'Convertible 2-Door'],
    [2006, 'Avanti', 'Avanti', 'Coupe 2-Door'],
    [2006, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2006, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2006, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2006, 'Bentley', 'Continental', 'Sedan 4-Door'],
    [2006, 'BMW', '323i', 'Sedan 4-Door'],
    [2006, 'BMW', '325Ci', 'Convertible 2-Door'],
    [2006, 'BMW', '325Ci', 'Coupe 2-Door'],
    [2006, 'BMW', '325i', 'Sedan 4-Door'],
    [2006, 'BMW', '325xi', 'Sedan 4-Door'],
    [2006, 'BMW', '325xi', 'Wagon 4-Door'],
    [2006, 'BMW', '330Ci', 'Convertible 2-Door'],
    [2006, 'BMW', '330Ci', 'Coupe 2-Door'],
    [2006, 'BMW', '330i', 'Sedan 4-Door'],
    [2006, 'BMW', '330xi', 'Sedan 4-Door'],
    [2006, 'BMW', '525i', 'Sedan 4-Door'],
    [2006, 'BMW', '525xi', 'Sedan 4-Door'],
    [2006, 'BMW', '530i', 'Sedan 4-Door'],
    [2006, 'BMW', '530xi', 'Sedan 4-Door'],
    [2006, 'BMW', '530xi', 'Wagon 4-Door'],
    [2006, 'BMW', '550i', 'Sedan 4-Door'],
    [2006, 'BMW', '650i', 'Convertible 2-Door'],
    [2006, 'BMW', '650i', 'Coupe 2-Door'],
    [2006, 'BMW', '750i', 'Sedan 4-Door'],
    [2006, 'BMW', '750Li', 'Sedan 4-Door'],
    [2006, 'BMW', '760i', 'Sedan 4-Door'],
    [2006, 'BMW', '760Li', 'Sedan 4-Door'],
    [2006, 'BMW', 'M3', 'Convertible 2-Door'],
    [2006, 'BMW', 'M3', 'Coupe 2-Door'],
    [2006, 'BMW', 'M5', 'Sedan 4-Door'],
    [2006, 'BMW', 'M6', 'Coupe 2-Door'],
    [2006, 'BMW', 'X3', 'SUV 4-Door'],
    [2006, 'BMW', 'X5', 'SUV 4-Door'],
    [2006, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2006, 'BMW', 'Z4', 'Coupe 2-Door'],
    [2006, 'Bugatti', 'Veyron 16.4', 'Coupe 2-Door'],
    [2006, 'Buick', 'Allure', 'Sedan 4-Door'],
    [2006, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2006, 'Buick', 'Lucerne', 'Sedan 4-Door'],
    [2006, 'Buick', 'Rainier', 'SUV 4-Door'],
    [2006, 'Buick', 'Rendezvous', 'SUV 4-Door'],
    [2006, 'Buick', 'Terraza', 'Mini Passenger Van 4-Door'],
    [2006, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2006, 'Cadillac', 'DTS', 'Hearse 4-Door'],
    [2006, 'Cadillac', 'DTS', 'Limousine 4-Door'],
    [2006, 'Cadillac', 'DTS', 'Sedan 4-Door'],
    [2006, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2006, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2006, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2006, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2006, 'Cadillac', 'STS', 'Sedan 4-Door'],
    [2006, 'Cadillac', 'XLR', 'Convertible 2-Door'],
    [2006, 'Chevrolet', 'Avalanche 1500', 'Crew Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Avalanche 2500', 'Crew Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Aveo', 'Hatchback 4-Door'],
    [2006, 'Chevrolet', 'Aveo', 'Sedan 4-Door'],
    [2006, 'Chevrolet', 'Aveo5', 'Hatchback 4-Door'],
    [2006, 'Chevrolet', 'Cobalt', 'Coupe 2-Door'],
    [2006, 'Chevrolet', 'Cobalt', 'Sedan 4-Door'],
    [2006, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2006, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2006, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2006, 'Chevrolet', 'Epica', 'Sedan 4-Door'],
    [2006, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2006, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2006, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 4-Door'],
    [2006, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2006, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 4-Door'],
    [2006, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2006, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [2006, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2006, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 4-Door'],
    [2006, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2006, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2006, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2006, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2006, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 4-Door'],
    [2006, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2006, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 4-Door'],
    [2006, 'Chevrolet', 'HHR', 'Wagon 4-Door'],
    [2006, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2006, 'Chevrolet', 'Malibu', 'Hatchback 4-Door'],
    [2006, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2006, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [2006, 'Chevrolet', 'Optra', 'Hatchback 4-Door'],
    [2006, 'Chevrolet', 'Optra', 'Wagon 4-Door'],
    [2006, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2006, 'Chevrolet', 'Silverado 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2006, 'Chevrolet', 'Silverado 3500', 'Crew Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Silverado 3500', 'Extended Cab Pickup 4-Door'],
    [2006, 'Chevrolet', 'Silverado 3500', 'Standard Cab Pickup 2-Door'],
    [2006, 'Chevrolet', 'SSR', 'Convertible 2-Door'],
    [2006, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2006, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2006, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2006, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2006, 'Chevrolet', 'Trailblazer EXT', 'SUV 4-Door'],
    [2006, 'Chevrolet', 'Uplander', 'Mini Cargo Van 4-Door'],
    [2006, 'Chevrolet', 'Uplander', 'Mini Passenger Van 4-Door'],
    [2006, 'Chrysler', '300', 'Sedan 4-Door'],
    [2006, 'Chrysler', 'Crossfire', 'Convertible 2-Door'],
    [2006, 'Chrysler', 'Crossfire', 'Coupe 2-Door'],
    [2006, 'Chrysler', 'Pacifica', 'SUV 4-Door'],
    [2006, 'Chrysler', 'PT Cruiser', 'Convertible 2-Door'],
    [2006, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2006, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2006, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2006, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2006, 'Dodge', 'Caravan', 'Mini Cargo Van 4-Door'],
    [2006, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [2006, 'Dodge', 'Charger', 'Sedan 4-Door'],
    [2006, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2006, 'Dodge', 'Dakota', 'Extended Cab Pickup 4-Door'],
    [2006, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2006, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 4-Door'],
    [2006, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2006, 'Dodge', 'Magnum', 'Wagon 4-Door'],
    [2006, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2006, 'Dodge', 'Ram 1500', 'Extended Crew Cab Pickup 4-Door'],
    [2006, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2006, 'Dodge', 'Ram 2500', 'Crew Cab Pickup 4-Door'],
    [2006, 'Dodge', 'Ram 2500', 'Extended Crew Cab Pickup 4-Door'],
    [2006, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2006, 'Dodge', 'Ram 3500', 'Crew Cab Pickup 4-Door'],
    [2006, 'Dodge', 'Ram 3500', 'Extended Crew Cab Pickup 4-Door'],
    [2006, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2006, 'Dodge', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2006, 'Dodge', 'Sprinter 2500', 'Standard Cargo Van 4-Door'],
    [2006, 'Dodge', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2006, 'Dodge', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2006, 'Dodge', 'Sprinter 3500', 'Standard Cargo Van 4-Door'],
    [2006, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [2006, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2006, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2006, 'Ferrari', '612 Scaglietti', 'Coupe 2-Door'],
    [2006, 'Ferrari', 'F430', 'Convertible 2-Door'],
    [2006, 'Ferrari', 'F430', 'Coupe 2-Door'],
    [2006, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2006, 'Ford', 'E-150', 'Standard Cargo Van 2-Door'],
    [2006, 'Ford', 'E-150', 'Standard Passenger Van 3-Door'],
    [2006, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2006, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2006, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [2006, 'Ford', 'E-350 Super Duty', 'Extended Passenger Van 3-Door'],
    [2006, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [2006, 'Ford', 'E-350 Super Duty', 'Standard Passenger Van 3-Door'],
    [2006, 'Ford', 'Escape', 'SUV 4-Door'],
    [2006, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2006, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2006, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2006, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2006, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2006, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2006, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2006, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2006, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2006, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2006, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2006, 'Ford', 'Five Hundred', 'Sedan 4-Door'],
    [2006, 'Ford', 'Focus', 'Hatchback 2-Door'],
    [2006, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2006, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2006, 'Ford', 'Focus', 'Wagon 5-Door'],
    [2006, 'Ford', 'Freestar', 'Mini Cargo Van 4-Door'],
    [2006, 'Ford', 'Freestar', 'Mini Passenger Van 4-Door'],
    [2006, 'Ford', 'Freestyle', 'Wagon 4-Door'],
    [2006, 'Ford', 'Fusion', 'Sedan 4-Door'],
    [2006, 'Ford', 'GT', 'Coupe 2-Door'],
    [2006, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2006, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2006, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2006, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2006, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2006, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2006, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 2-Door'],
    [2006, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2006, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 4-Door'],
    [2006, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2006, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 2-Door'],
    [2006, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2006, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 4-Door'],
    [2006, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2006, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2006, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2006, 'GMC', 'Envoy', 'SUV 4-Door'],
    [2006, 'GMC', 'Envoy XL', 'SUV 4-Door'],
    [2006, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2006, 'GMC', 'Savana 1500', 'Standard Cargo Van 4-Door'],
    [2006, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2006, 'GMC', 'Savana 1500', 'Standard Passenger Van 4-Door'],
    [2006, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2006, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2006, 'GMC', 'Savana 2500', 'Standard Cargo Van 4-Door'],
    [2006, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2006, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2006, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2006, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2006, 'GMC', 'Savana 3500', 'Standard Cargo Van 4-Door'],
    [2006, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2006, 'GMC', 'Savana 3500', 'Standard Passenger Van 4-Door'],
    [2006, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2006, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2006, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2006, 'GMC', 'Sierra 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2006, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2006, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2006, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2006, 'GMC', 'Sierra 3500', 'Crew Cab Pickup 4-Door'],
    [2006, 'GMC', 'Sierra 3500', 'Extended Cab Pickup 4-Door'],
    [2006, 'GMC', 'Sierra 3500', 'Standard Cab Pickup 2-Door'],
    [2006, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2006, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2006, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2006, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2006, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2006, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2006, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2006, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2006, 'Honda', 'Element', 'SUV 4-Door'],
    [2006, 'Honda', 'Insight', 'Hatchback 2-Door'],
    [2006, 'Honda', 'Odyssey', 'Mini Passenger Van 4-Door'],
    [2006, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2006, 'Honda', 'Ridgeline', 'Crew Cab Pickup 4-Door'],
    [2006, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2006, 'Hummer', 'H1', 'SUV 4-Door'],
    [2006, 'Hummer', 'H2', 'Crew Cab Pickup 4-Door'],
    [2006, 'Hummer', 'H2', 'SUV 4-Door'],
    [2006, 'Hummer', 'H3', 'SUV 4-Door'],
    [2006, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2006, 'Hyundai', 'Accent', 'Hatchback 4-Door'],
    [2006, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2006, 'Hyundai', 'Azera', 'Sedan 4-Door'],
    [2006, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2006, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2006, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2006, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2006, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [2006, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2006, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2006, 'INFINITI', 'FX45', 'SUV 4-Door'],
    [2006, 'INFINITI', 'G35', 'Coupe 2-Door'],
    [2006, 'INFINITI', 'G35', 'Sedan 4-Door'],
    [2006, 'INFINITI', 'M35', 'Sedan 4-Door'],
    [2006, 'INFINITI', 'M45', 'Sedan 4-Door'],
    [2006, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [2006, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2006, 'Isuzu', 'Ascender', 'SUV 4-Door'],
    [2006, 'Isuzu', 'i-280', 'Extended Cab Pickup 2-Door'],
    [2006, 'Isuzu', 'i-350', 'Crew Cab Pickup 4-Door'],
    [2006, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2006, 'Jaguar', 'Super V8', 'Sedan 4-Door'],
    [2006, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2006, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2006, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2006, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [2006, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [2006, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2006, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2006, 'Jaguar', 'X-Type', 'Sedan 4-Door'],
    [2006, 'Jaguar', 'X-Type', 'Wagon 4-Door'],
    [2006, 'Jeep', 'Commander', 'SUV 4-Door'],
    [2006, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2006, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2006, 'Jeep', 'TJ', 'SUV 2-Door'],
    [2006, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2006, 'Kia', 'Amanti', 'Sedan 4-Door'],
    [2006, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2006, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2006, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2006, 'Kia', 'Rio5', 'Hatchback 4-Door'],
    [2006, 'Kia', 'Sedona', 'Mini Passenger Van 4-Door'],
    [2006, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2006, 'Kia', 'Spectra', 'Sedan 4-Door'],
    [2006, 'Kia', 'Spectra5', 'Hatchback 4-Door'],
    [2006, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2006, 'Lamborghini', 'Gallardo', 'Convertible 2-Door'],
    [2006, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2006, 'Lamborghini', 'Murcielago', 'Convertible 2-Door'],
    [2006, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2006, 'Land Rover', 'LR3', 'SUV 4-Door'],
    [2006, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2006, 'Land Rover', 'Range Rover Sport', 'SUV 4-Door'],
    [2006, 'Lexus', 'ES330', 'Sedan 4-Door'],
    [2006, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2006, 'Lexus', 'GS430', 'Sedan 4-Door'],
    [2006, 'Lexus', 'GX470', 'SUV 4-Door'],
    [2006, 'Lexus', 'IS250', 'Sedan 4-Door'],
    [2006, 'Lexus', 'IS350', 'Sedan 4-Door'],
    [2006, 'Lexus', 'LS430', 'Sedan 4-Door'],
    [2006, 'Lexus', 'LX470', 'SUV 4-Door'],
    [2006, 'Lexus', 'RX330', 'SUV 4-Door'],
    [2006, 'Lexus', 'RX400h', 'SUV 4-Door'],
    [2006, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2006, 'Lincoln', 'LS', 'Sedan 4-Door'],
    [2006, 'Lincoln', 'Mark LT', 'Crew Cab Pickup 4-Door'],
    [2006, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2006, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2006, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2006, 'Lincoln', 'Zephyr', 'Sedan 4-Door'],
    [2006, 'Lotus', 'Elise', 'Convertible 2-Door'],
    [2006, 'Lotus', 'Exige', 'Coupe 2-Door'],
    [2006, 'Maserati', 'Coupe', 'Coupe 2-Door'],
    [2006, 'Maserati', 'GranSport', 'Coupe 2-Door'],
    [2006, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2006, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [2006, 'Maybach', '57', 'Sedan 4-Door'],
    [2006, 'Maybach', '62', 'Sedan 4-Door'],
    [2006, 'Mazda', '3', 'Hatchback 4-Door'],
    [2006, 'Mazda', '3', 'Sedan 4-Door'],
    [2006, 'Mazda', '5', 'Mini Passenger Van 4-Door'],
    [2006, 'Mazda', '6', 'Hatchback 4-Door'],
    [2006, 'Mazda', '6', 'Sedan 4-Door'],
    [2006, 'Mazda', '6', 'Wagon 5-Door'],
    [2006, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2006, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [2006, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [2006, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2006, 'Mazda', 'MPV', 'Mini Passenger Van 4-Door'],
    [2006, 'Mazda', 'MX-5 Miata', 'Convertible 2-Door'],
    [2006, 'Mazda', 'RX-8', 'Coupe 4-Door'],
    [2006, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2006, 'Mercedes-Benz', 'B200', 'Hatchback 4-Door'],
    [2006, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'C350', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'C55 AMG', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [2006, 'Mercedes-Benz', 'CL55 AMG', 'Coupe 2-Door'],
    [2006, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2006, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2006, 'Mercedes-Benz', 'CLK350', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'CLK350', 'Coupe 2-Door'],
    [2006, 'Mercedes-Benz', 'CLK500', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'CLK500', 'Coupe 2-Door'],
    [2006, 'Mercedes-Benz', 'CLK55 AMG', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'CLS500', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'CLS55 AMG', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'E350', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'E350', 'Wagon 4-Door'],
    [2006, 'Mercedes-Benz', 'E500', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'E500', 'Wagon 4-Door'],
    [2006, 'Mercedes-Benz', 'E55 AMG', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'E55 AMG', 'Wagon 4-Door'],
    [2006, 'Mercedes-Benz', 'G500', 'SUV 4-Door'],
    [2006, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2006, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2006, 'Mercedes-Benz', 'ML500', 'SUV 4-Door'],
    [2006, 'Mercedes-Benz', 'R350', 'Wagon 4-Door'],
    [2006, 'Mercedes-Benz', 'R500', 'Wagon 4-Door'],
    [2006, 'Mercedes-Benz', 'S350', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'S430', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'S55 AMG', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'S65 AMG', 'Sedan 4-Door'],
    [2006, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'SLK280', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2006, 'Mercedes-Benz', 'SLR McLaren', 'Coupe 2-Door'],
    [2006, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2006, 'Mercury', 'Mariner', 'SUV 4-Door'],
    [2006, 'Mercury', 'Milan', 'Sedan 4-Door'],
    [2006, 'Mercury', 'Montego', 'Sedan 4-Door'],
    [2006, 'Mercury', 'Monterey', 'Mini Passenger Van 4-Door'],
    [2006, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2006, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2006, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2006, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2006, 'Mitsubishi', 'Endeavor', 'SUV 4-Door'],
    [2006, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2006, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2006, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [2006, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2006, 'Mitsubishi', 'Raider', 'Crew Cab Pickup 4-Door'],
    [2006, 'Mitsubishi', 'Raider', 'Extended Cab Pickup 4-Door'],
    [2006, 'Morgan', 'Aero 8', 'Convertible 2-Door'],
    [2006, 'Morgan', 'Roadster', 'Convertible 2-Door'],
    [2006, 'Nissan', '350Z', 'Convertible 2-Door'],
    [2006, 'Nissan', '350Z', 'Coupe 2-Door'],
    [2006, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2006, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2006, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2006, 'Nissan', 'Frontier', 'Extended Cab Pickup 4-Door'],
    [2006, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2006, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2006, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2006, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2006, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2006, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2006, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2006, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2006, 'Nissan', 'X-Trail', 'SUV 4-Door'],
    [2006, 'Panoz', 'Esperante', 'Convertible 2-Door'],
    [2006, 'Panoz', 'Esperante', 'Coupe 2-Door'],
    [2006, 'Pontiac', 'G6', 'Convertible 2-Door'],
    [2006, 'Pontiac', 'G6', 'Coupe 2-Door'],
    [2006, 'Pontiac', 'G6', 'Sedan 4-Door'],
    [2006, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2006, 'Pontiac', 'GTO', 'Coupe 2-Door'],
    [2006, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2006, 'Pontiac', 'Pursuit', 'Coupe 2-Door'],
    [2006, 'Pontiac', 'Pursuit', 'Sedan 4-Door'],
    [2006, 'Pontiac', 'Solstice', 'Convertible 2-Door'],
    [2006, 'Pontiac', 'Torrent', 'SUV 4-Door'],
    [2006, 'Pontiac', 'Vibe', 'Wagon 4-Door'],
    [2006, 'Pontiac', 'Wave', 'Sedan 4-Door'],
    [2006, 'Pontiac', 'Wave5', 'Hatchback 4-Door'],
    [2006, 'Porsche', '911', 'Convertible 2-Door'],
    [2006, 'Porsche', '911', 'Coupe 2-Door'],
    [2006, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2006, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2006, 'Porsche', 'Cayman', 'Hatchback 2-Door'],
    [2006, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2006, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2006, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2006, 'Saab', '3-Sep', 'Wagon 4-Door'],
    [2006, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2006, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2006, 'Saab', '9-2X', 'Wagon 4-Door'],
    [2006, 'Saab', '9-7x', 'SUV 4-Door'],
    [2006, 'Saleen', 'S7', 'Coupe 2-Door'],
    [2006, 'Saturn', 'Ion', 'Coupe 4-Door'],
    [2006, 'Saturn', 'Ion', 'Sedan 4-Door'],
    [2006, 'Saturn', 'Relay', 'Mini Passenger Van 4-Door'],
    [2006, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2006, 'Scion', 'tC', 'Coupe 2-Door'],
    [2006, 'Scion', 'xA', 'Hatchback 4-Door'],
    [2006, 'Scion', 'xB', 'Wagon 4-Door'],
    [2006, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2006, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2006, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2006, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2006, 'Subaru', 'B9 Tribeca', 'SUV 4-Door'],
    [2006, 'Subaru', 'Baja', 'Crew Cab Pickup 4-Door'],
    [2006, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2006, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2006, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [2006, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2006, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2006, 'Subaru', 'Outback', 'Sedan 4-Door'],
    [2006, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2006, 'Suzuki', 'Aerio', 'Sedan 4-Door'],
    [2006, 'Suzuki', 'Aerio', 'Wagon 5-Door'],
    [2006, 'Suzuki', 'Forenza', 'Sedan 4-Door'],
    [2006, 'Suzuki', 'Forenza', 'Wagon 4-Door'],
    [2006, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2006, 'Suzuki', 'Reno', 'Hatchback 4-Door'],
    [2006, 'Suzuki', 'Swift+', 'Hatchback 4-Door'],
    [2006, 'Suzuki', 'Verona', 'Sedan 4-Door'],
    [2006, 'Suzuki', 'XL-7', 'SUV 4-Door'],
    [2006, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2006, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2006, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2006, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2006, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2006, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2006, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2006, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2006, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2006, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2006, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2006, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2006, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2006, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2006, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2006, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2006, 'Toyota', 'Tacoma', 'Extended Cab Pickup 4-Door'],
    [2006, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2006, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2006, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2006, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2006, 'Toyota', 'Yaris', 'Hatchback 2-Door'],
    [2006, 'Toyota', 'Yaris', 'Hatchback 4-Door'],
    [2006, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2006, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2006, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2006, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2006, 'Volkswagen', 'GTI', 'Hatchback 2-Door'],
    [2006, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2006, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2006, 'Volkswagen', 'Phaeton', 'Sedan 4-Door'],
    [2006, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [2006, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [2006, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2006, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2006, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2006, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2006, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2006, 'Volvo', 'V50', 'Wagon 4-Door'],
    [2006, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2006, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2006, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2005, 'Acura', 'EL', 'Sedan 4-Door'],
    [2005, 'Acura', 'MDX', 'SUV 4-Door'],
    [2005, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2005, 'Acura', 'RL', 'Sedan 4-Door'],
    [2005, 'Acura', 'RSX', 'Coupe 2-Door'],
    [2005, 'Acura', 'TL', 'Sedan 4-Door'],
    [2005, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2005, 'Aston Martin', 'DB9', 'Convertible 2-Door'],
    [2005, 'Aston Martin', 'DB9', 'Coupe 2-Door'],
    [2005, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2005, 'Audi', 'A4', 'Convertible 2-Door'],
    [2005, 'Audi', 'A4', 'Sedan 4-Door'],
    [2005, 'Audi', 'A4', 'Wagon 4-Door'],
    [2005, 'Audi', 'A4 Quattro', 'Convertible 2-Door'],
    [2005, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2005, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2005, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2005, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2005, 'Audi', 'Allroad Quattro', 'Wagon 4-Door'],
    [2005, 'Audi', 'S4', 'Convertible 2-Door'],
    [2005, 'Audi', 'S4', 'Sedan 4-Door'],
    [2005, 'Audi', 'S4', 'Wagon 4-Door'],
    [2005, 'Audi', 'TT', 'Convertible 2-Door'],
    [2005, 'Audi', 'TT', 'Coupe 2-Door'],
    [2005, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2005, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2005, 'Avanti', 'Avanti', 'Coupe 2-Door'],
    [2005, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2005, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2005, 'BMW', '320i', 'Sedan 4-Door'],
    [2005, 'BMW', '325Ci', 'Convertible 2-Door'],
    [2005, 'BMW', '325Ci', 'Coupe 2-Door'],
    [2005, 'BMW', '325i', 'Sedan 4-Door'],
    [2005, 'BMW', '325i', 'Wagon 4-Door'],
    [2005, 'BMW', '325xi', 'Sedan 4-Door'],
    [2005, 'BMW', '325xi', 'Wagon 4-Door'],
    [2005, 'BMW', '330Ci', 'Convertible 2-Door'],
    [2005, 'BMW', '330Ci', 'Coupe 2-Door'],
    [2005, 'BMW', '330i', 'Sedan 4-Door'],
    [2005, 'BMW', '330xi', 'Sedan 4-Door'],
    [2005, 'BMW', '525i', 'Sedan 4-Door'],
    [2005, 'BMW', '530i', 'Sedan 4-Door'],
    [2005, 'BMW', '545i', 'Sedan 4-Door'],
    [2005, 'BMW', '645Ci', 'Convertible 2-Door'],
    [2005, 'BMW', '645Ci', 'Coupe 2-Door'],
    [2005, 'BMW', '745i', 'Sedan 4-Door'],
    [2005, 'BMW', '745Li', 'Sedan 4-Door'],
    [2005, 'BMW', '760i', 'Sedan 4-Door'],
    [2005, 'BMW', '760Li', 'Sedan 4-Door'],
    [2005, 'BMW', 'M3', 'Convertible 2-Door'],
    [2005, 'BMW', 'M3', 'Coupe 2-Door'],
    [2005, 'BMW', 'X3', 'SUV 4-Door'],
    [2005, 'BMW', 'X5', 'SUV 4-Door'],
    [2005, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2005, 'Buick', 'Allure', 'Sedan 4-Door'],
    [2005, 'Buick', 'Century', 'Sedan 4-Door'],
    [2005, 'Buick', 'LaCrosse', 'Sedan 4-Door'],
    [2005, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [2005, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [2005, 'Buick', 'Rainier', 'SUV 4-Door'],
    [2005, 'Buick', 'Rendezvous', 'SUV 4-Door'],
    [2005, 'Buick', 'Terraza', 'Mini Passenger Van 4-Door'],
    [2005, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2005, 'Cadillac', 'DeVille', 'Hearse 4-Door'],
    [2005, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [2005, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [2005, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2005, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2005, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2005, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2005, 'Cadillac', 'STS', 'Sedan 4-Door'],
    [2005, 'Cadillac', 'XLR', 'Convertible 2-Door'],
    [2005, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [2005, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [2005, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [2005, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [2005, 'Chevrolet', 'Avalanche 1500', 'Crew Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Avalanche 2500', 'Crew Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Aveo', 'Hatchback 4-Door'],
    [2005, 'Chevrolet', 'Aveo', 'Sedan 4-Door'],
    [2005, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [2005, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2005, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [2005, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [2005, 'Chevrolet', 'Classic', 'Sedan 4-Door'],
    [2005, 'Chevrolet', 'Cobalt', 'Coupe 2-Door'],
    [2005, 'Chevrolet', 'Cobalt', 'Sedan 4-Door'],
    [2005, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 3-Door'],
    [2005, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2005, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2005, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2005, 'Chevrolet', 'Epica', 'Sedan 4-Door'],
    [2005, 'Chevrolet', 'Equinox', 'SUV 4-Door'],
    [2005, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2005, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2005, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2005, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [2005, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2005, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2005, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2005, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2005, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2005, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2005, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2005, 'Chevrolet', 'Malibu', 'Hatchback 4-Door'],
    [2005, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2005, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [2005, 'Chevrolet', 'Optra', 'Hatchback 4-Door'],
    [2005, 'Chevrolet', 'Optra', 'Sedan 4-Door'],
    [2005, 'Chevrolet', 'Optra', 'Wagon 4-Door'],
    [2005, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2005, 'Chevrolet', 'Silverado 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2005, 'Chevrolet', 'Silverado 3500', 'Crew Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Silverado 3500', 'Extended Cab Pickup 4-Door'],
    [2005, 'Chevrolet', 'Silverado 3500', 'Standard Cab Pickup 2-Door'],
    [2005, 'Chevrolet', 'SSR', 'Convertible 2-Door'],
    [2005, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2005, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2005, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2005, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2005, 'Chevrolet', 'Trailblazer EXT', 'SUV 4-Door'],
    [2005, 'Chevrolet', 'Uplander', 'Mini Passenger Van 4-Door'],
    [2005, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [2005, 'Chrysler', '300', 'Sedan 4-Door'],
    [2005, 'Chrysler', 'Crossfire', 'Convertible 2-Door'],
    [2005, 'Chrysler', 'Crossfire', 'Coupe 2-Door'],
    [2005, 'Chrysler', 'Pacifica', 'SUV 4-Door'],
    [2005, 'Chrysler', 'PT Cruiser', 'Convertible 2-Door'],
    [2005, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2005, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2005, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [2005, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2005, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2005, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [2005, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [2005, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2005, 'Dodge', 'Dakota', 'Extended Cab Pickup 4-Door'],
    [2005, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2005, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 3-Door'],
    [2005, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2005, 'Dodge', 'Magnum', 'Wagon 4-Door'],
    [2005, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [2005, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2005, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2005, 'Dodge', 'Ram 2500', 'Crew Cab Pickup 4-Door'],
    [2005, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2005, 'Dodge', 'Ram 3500', 'Crew Cab Pickup 4-Door'],
    [2005, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2005, 'Dodge', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2005, 'Dodge', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2005, 'Dodge', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2005, 'Dodge', 'Sprinter 3500', 'Standard Passenger Van 3-Door'],
    [2005, 'Dodge', 'Stratus', 'Coupe 2-Door'],
    [2005, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [2005, 'Dodge', 'SX 2.0', 'Sedan 4-Door'],
    [2005, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2005, 'Ferrari', '360', 'Convertible 2-Door'],
    [2005, 'Ferrari', '360', 'Coupe 2-Door'],
    [2005, 'Ferrari', '575 M Maranello', 'Coupe 2-Door'],
    [2005, 'Ferrari', '612 Scaglietti', 'Coupe 2-Door'],
    [2005, 'Ferrari', 'F430', 'Convertible 2-Door'],
    [2005, 'Ferrari', 'F430', 'Coupe 2-Door'],
    [2005, 'Ferrari', 'Superamerica', 'Convertible 2-Door'],
    [2005, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2005, 'Ford', 'E-150', 'Standard Cargo Van 2-Door'],
    [2005, 'Ford', 'E-150 Club Wagon', 'Standard Passenger Van 2-Door'],
    [2005, 'Ford', 'E-250', 'Extended Cargo Van 3-Door'],
    [2005, 'Ford', 'E-250', 'Standard Cargo Van 3-Door'],
    [2005, 'Ford', 'E-350 Club Wagon', 'Extended Passenger Van 2-Door'],
    [2005, 'Ford', 'E-350 Club Wagon', 'Standard Passenger Van 2-Door'],
    [2005, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [2005, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [2005, 'Ford', 'Escape', 'SUV 4-Door'],
    [2005, 'Ford', 'Excursion', 'SUV 4-Door'],
    [2005, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2005, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2005, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2005, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2005, 'Ford', 'F-150', 'Extended Cab Pickup 3-Door'],
    [2005, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2005, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2005, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2005, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2005, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2005, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2005, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2005, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2005, 'Ford', 'Five Hundred', 'Sedan 4-Door'],
    [2005, 'Ford', 'Focus', 'Hatchback 2-Door'],
    [2005, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2005, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2005, 'Ford', 'Focus', 'Wagon 5-Door'],
    [2005, 'Ford', 'Freestar', 'Mini Cargo Van 4-Door'],
    [2005, 'Ford', 'Freestar', 'Mini Passenger Van 4-Door'],
    [2005, 'Ford', 'Freestyle', 'Wagon 4-Door'],
    [2005, 'Ford', 'GT', 'Coupe 2-Door'],
    [2005, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2005, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2005, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2005, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2005, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2005, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2005, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [2005, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [2005, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2005, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2005, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2005, 'Freightliner', 'Sprinter 3500', 'Standard Passenger Van 3-Door'],
    [2005, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2005, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2005, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2005, 'GMC', 'Envoy', 'SUV 4-Door'],
    [2005, 'GMC', 'Envoy XL', 'SUV 4-Door'],
    [2005, 'GMC', 'Envoy XUV', 'SUV 4-Door'],
    [2005, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [2005, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [2005, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [2005, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [2005, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [2005, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2005, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2005, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2005, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [2005, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2005, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2005, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2005, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2005, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2005, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2005, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2005, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2005, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2005, 'GMC', 'Sierra 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2005, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2005, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2005, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2005, 'GMC', 'Sierra 3500', 'Crew Cab Pickup 4-Door'],
    [2005, 'GMC', 'Sierra 3500', 'Extended Cab Pickup 4-Door'],
    [2005, 'GMC', 'Sierra 3500', 'Standard Cab Pickup 2-Door'],
    [2005, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2005, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2005, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2005, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2005, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2005, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2005, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [2005, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2005, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2005, 'Honda', 'Element', 'SUV 4-Door'],
    [2005, 'Honda', 'Insight', 'Hatchback 2-Door'],
    [2005, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [2005, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2005, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2005, 'Hummer', 'H2', 'Crew Cab Pickup 4-Door'],
    [2005, 'Hummer', 'H2', 'SUV 4-Door'],
    [2005, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2005, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2005, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2005, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2005, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2005, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2005, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [2005, 'Hyundai', 'Tucson', 'SUV 4-Door'],
    [2005, 'Hyundai', 'XG350', 'Sedan 4-Door'],
    [2005, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2005, 'INFINITI', 'FX45', 'SUV 4-Door'],
    [2005, 'INFINITI', 'G35', 'Coupe 2-Door'],
    [2005, 'INFINITI', 'G35', 'Sedan 4-Door'],
    [2005, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [2005, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2005, 'Isuzu', 'Ascender', 'SUV 4-Door'],
    [2005, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2005, 'Jaguar', 'Super V8', 'Sedan 4-Door'],
    [2005, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2005, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2005, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2005, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [2005, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [2005, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2005, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2005, 'Jaguar', 'X-Type', 'Sedan 4-Door'],
    [2005, 'Jaguar', 'X-Type', 'Wagon 4-Door'],
    [2005, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2005, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2005, 'Jeep', 'TJ', 'SUV 2-Door'],
    [2005, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2005, 'Kia', 'Amanti', 'Sedan 4-Door'],
    [2005, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2005, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2005, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2005, 'Kia', 'Rio', 'Wagon 4-Door'],
    [2005, 'Kia', 'Sedona', 'Mini Passenger Van 5-Door'],
    [2005, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2005, 'Kia', 'Spectra', 'Sedan 4-Door'],
    [2005, 'Kia', 'Spectra5', 'Hatchback 4-Door'],
    [2005, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2005, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2005, 'Lamborghini', 'Murcielago', 'Convertible 2-Door'],
    [2005, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2005, 'Land Rover', 'Freelander', 'SUV 2-Door'],
    [2005, 'Land Rover', 'Freelander', 'SUV 4-Door'],
    [2005, 'Land Rover', 'LR3', 'SUV 4-Door'],
    [2005, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2005, 'Lexus', 'ES330', 'Sedan 4-Door'],
    [2005, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2005, 'Lexus', 'GS430', 'Sedan 4-Door'],
    [2005, 'Lexus', 'GX470', 'SUV 4-Door'],
    [2005, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2005, 'Lexus', 'IS300', 'Wagon 4-Door'],
    [2005, 'Lexus', 'LS430', 'Sedan 4-Door'],
    [2005, 'Lexus', 'LX470', 'SUV 4-Door'],
    [2005, 'Lexus', 'RX330', 'SUV 4-Door'],
    [2005, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2005, 'Lincoln', 'Aviator', 'SUV 4-Door'],
    [2005, 'Lincoln', 'LS', 'Sedan 4-Door'],
    [2005, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2005, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2005, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2005, 'Lotus', 'Elise', 'Convertible 2-Door'],
    [2005, 'Maserati', 'Coupe', 'Coupe 2-Door'],
    [2005, 'Maserati', 'GranSport', 'Coupe 2-Door'],
    [2005, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2005, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [2005, 'Maybach', '57', 'Sedan 4-Door'],
    [2005, 'Maybach', '62', 'Sedan 4-Door'],
    [2005, 'Mazda', '3', 'Hatchback 4-Door'],
    [2005, 'Mazda', '3', 'Sedan 4-Door'],
    [2005, 'Mazda', '6', 'Hatchback 4-Door'],
    [2005, 'Mazda', '6', 'Sedan 4-Door'],
    [2005, 'Mazda', '6', 'Wagon 5-Door'],
    [2005, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2005, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [2005, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [2005, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2005, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [2005, 'Mazda', 'MPV', 'Mini Passenger Van 4-Door'],
    [2005, 'Mazda', 'RX-8', 'Coupe 4-Door'],
    [2005, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2005, 'Mercedes-Benz', 'C230', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'C240', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'C240', 'Wagon 4-Door'],
    [2005, 'Mercedes-Benz', 'C320', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'C320', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'C55 AMG', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'CL55 AMG', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'CL65 AMG', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'CLK320', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'CLK320', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'CLK500', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'CLK500', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'CLK55 AMG', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'CLK55 AMG', 'Coupe 2-Door'],
    [2005, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [2005, 'Mercedes-Benz', 'E500', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'E500', 'Wagon 4-Door'],
    [2005, 'Mercedes-Benz', 'E55 AMG', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'G500', 'SUV 4-Door'],
    [2005, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2005, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2005, 'Mercedes-Benz', 'ML500', 'SUV 4-Door'],
    [2005, 'Mercedes-Benz', 'S430', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'S55 AMG', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2005, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'SL65 AMG', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'SLK350', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'SLK55 AMG', 'Convertible 2-Door'],
    [2005, 'Mercedes-Benz', 'SLR McLaren', 'Coupe 2-Door'],
    [2005, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2005, 'Mercury', 'Mariner', 'SUV 4-Door'],
    [2005, 'Mercury', 'Montego', 'Sedan 4-Door'],
    [2005, 'Mercury', 'Monterey', 'Mini Passenger Van 4-Door'],
    [2005, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2005, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [2005, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [2005, 'Mini', 'Cooper', 'Convertible 2-Door'],
    [2005, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2005, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2005, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2005, 'Mitsubishi', 'Endeavor', 'SUV 4-Door'],
    [2005, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2005, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2005, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [2005, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2005, 'Morgan', 'Aero 8', 'Convertible 2-Door'],
    [2005, 'Nissan', '350Z', 'Convertible 2-Door'],
    [2005, 'Nissan', '350Z', 'Coupe 2-Door'],
    [2005, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2005, 'Nissan', 'Armada', 'SUV 4-Door'],
    [2005, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2005, 'Nissan', 'Frontier', 'Extended Cab Pickup 2-Door'],
    [2005, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2005, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2005, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2005, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2005, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2005, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2005, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2005, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2005, 'Nissan', 'X-Trail', 'SUV 4-Door'],
    [2005, 'Panoz', 'Esperante', 'Convertible 2-Door'],
    [2005, 'Panoz', 'Esperante', 'Coupe 2-Door'],
    [2005, 'Pontiac', 'Aztek', 'SUV 4-Door'],
    [2005, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [2005, 'Pontiac', 'G6', 'Sedan 4-Door'],
    [2005, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [2005, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [2005, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2005, 'Pontiac', 'GTO', 'Coupe 2-Door'],
    [2005, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2005, 'Pontiac', 'Pursuit', 'Coupe 2-Door'],
    [2005, 'Pontiac', 'Pursuit', 'Sedan 4-Door'],
    [2005, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [2005, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [2005, 'Pontiac', 'Vibe', 'Wagon 4-Door'],
    [2005, 'Pontiac', 'Wave', 'Sedan 4-Door'],
    [2005, 'Pontiac', 'Wave5', 'Hatchback 4-Door'],
    [2005, 'Porsche', '911', 'Convertible 2-Door'],
    [2005, 'Porsche', '911', 'Coupe 2-Door'],
    [2005, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2005, 'Porsche', 'Carrera GT', 'Convertible 2-Door'],
    [2005, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2005, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2005, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2005, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2005, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2005, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2005, 'Saab', '9-2X', 'Wagon 4-Door'],
    [2005, 'Saab', '9-7x', 'SUV 4-Door'],
    [2005, 'Saleen', 'S7', 'Coupe 2-Door'],
    [2005, 'Saturn', 'Ion', 'Coupe 4-Door'],
    [2005, 'Saturn', 'Ion', 'Sedan 4-Door'],
    [2005, 'Saturn', 'L300', 'Sedan 4-Door'],
    [2005, 'Saturn', 'Relay', 'Mini Passenger Van 4-Door'],
    [2005, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2005, 'Scion', 'tC', 'Coupe 2-Door'],
    [2005, 'Scion', 'xA', 'Hatchback 4-Door'],
    [2005, 'Scion', 'xB', 'Wagon 4-Door'],
    [2005, 'Smart', 'Fortwo', 'Convertible 2-Door'],
    [2005, 'Smart', 'Fortwo', 'Coupe 2-Door'],
    [2005, 'Spyker', 'C8', 'Convertible 2-Door'],
    [2005, 'Spyker', 'C8', 'Coupe 2-Door'],
    [2005, 'Subaru', 'Baja', 'Crew Cab Pickup 4-Door'],
    [2005, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2005, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2005, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [2005, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2005, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2005, 'Subaru', 'Outback', 'Sedan 4-Door'],
    [2005, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2005, 'Suzuki', 'Aerio', 'Sedan 4-Door'],
    [2005, 'Suzuki', 'Aerio', 'Wagon 5-Door'],
    [2005, 'Suzuki', 'Forenza', 'Sedan 4-Door'],
    [2005, 'Suzuki', 'Forenza', 'Wagon 4-Door'],
    [2005, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2005, 'Suzuki', 'Reno', 'Hatchback 4-Door'],
    [2005, 'Suzuki', 'Swift+', 'Hatchback 4-Door'],
    [2005, 'Suzuki', 'Verona', 'Sedan 4-Door'],
    [2005, 'Suzuki', 'XL-7', 'SUV 4-Door'],
    [2005, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2005, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2005, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2005, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [2005, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2005, 'Toyota', 'Echo', 'Hatchback 2-Door'],
    [2005, 'Toyota', 'Echo', 'Hatchback 4-Door'],
    [2005, 'Toyota', 'Echo', 'Sedan 2-Door'],
    [2005, 'Toyota', 'Echo', 'Sedan 4-Door'],
    [2005, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2005, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2005, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2005, 'Toyota', 'MR2 Spyder', 'Convertible 2-Door'],
    [2005, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2005, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2005, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2005, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2005, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2005, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2005, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2005, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2005, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2005, 'Toyota', 'Tacoma', 'Extended Cab Pickup 3-Door'],
    [2005, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2005, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2005, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2005, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2005, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2005, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2005, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2005, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2005, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2005, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2005, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2005, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2005, 'Volkswagen', 'Phaeton', 'Sedan 4-Door'],
    [2005, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2005, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2005, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2005, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2005, 'Volvo', 'V50', 'Wagon 4-Door'],
    [2005, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2005, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2005, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2005, 'Workhorse', 'FasTrack FT1061', 'Standard Cargo Van 2-Door'],
    [2005, 'Workhorse', 'FasTrack FT1261', 'Standard Cargo Van 2-Door'],
    [2005, 'Workhorse', 'FasTrack FT1461', 'Standard Cargo Van 2-Door'],
    [2005, 'Workhorse', 'FasTrack FT1601', 'Standard Cargo Van 2-Door'],
    [2005, 'Workhorse', 'FasTrack FT1801', 'Standard Cargo Van 2-Door'],
    [2004, 'Acura', 'EL', 'Sedan 4-Door'],
    [2004, 'Acura', 'MDX', 'SUV 4-Door'],
    [2004, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2004, 'Acura', 'RL', 'Sedan 4-Door'],
    [2004, 'Acura', 'RSX', 'Coupe 2-Door'],
    [2004, 'Acura', 'TL', 'Sedan 4-Door'],
    [2004, 'Acura', 'TSX', 'Sedan 4-Door'],
    [2004, 'Aston Martin', 'DB7', 'Convertible 2-Door'],
    [2004, 'Aston Martin', 'DB7', 'Coupe 2-Door'],
    [2004, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2004, 'Audi', 'A4', 'Convertible 2-Door'],
    [2004, 'Audi', 'A4', 'Sedan 4-Door'],
    [2004, 'Audi', 'A4', 'Wagon 4-Door'],
    [2004, 'Audi', 'A4 Quattro', 'Convertible 2-Door'],
    [2004, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2004, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2004, 'Audi', 'A6', 'Sedan 4-Door'],
    [2004, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2004, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2004, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2004, 'Audi', 'Allroad Quattro', 'Wagon 4-Door'],
    [2004, 'Audi', 'RS6', 'Sedan 4-Door'],
    [2004, 'Audi', 'S4', 'Convertible 2-Door'],
    [2004, 'Audi', 'S4', 'Sedan 4-Door'],
    [2004, 'Audi', 'S4', 'Wagon 4-Door'],
    [2004, 'Audi', 'TT', 'Convertible 2-Door'],
    [2004, 'Audi', 'TT', 'Coupe 2-Door'],
    [2004, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2004, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2004, 'Avanti', 'II', 'Convertible 2-Door'],
    [2004, 'Avanti', 'II', 'Coupe 2-Door'],
    [2004, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2004, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2004, 'BMW', '320i', 'Sedan 4-Door'],
    [2004, 'BMW', '325Ci', 'Convertible 2-Door'],
    [2004, 'BMW', '325Ci', 'Coupe 2-Door'],
    [2004, 'BMW', '325i', 'Sedan 4-Door'],
    [2004, 'BMW', '325i', 'Wagon 4-Door'],
    [2004, 'BMW', '325xi', 'Sedan 4-Door'],
    [2004, 'BMW', '325xi', 'Wagon 4-Door'],
    [2004, 'BMW', '330Ci', 'Convertible 2-Door'],
    [2004, 'BMW', '330Ci', 'Coupe 2-Door'],
    [2004, 'BMW', '330i', 'Sedan 4-Door'],
    [2004, 'BMW', '330xi', 'Sedan 4-Door'],
    [2004, 'BMW', '525i', 'Sedan 4-Door'],
    [2004, 'BMW', '530i', 'Sedan 4-Door'],
    [2004, 'BMW', '545i', 'Sedan 4-Door'],
    [2004, 'BMW', '645Ci', 'Convertible 2-Door'],
    [2004, 'BMW', '645Ci', 'Coupe 2-Door'],
    [2004, 'BMW', '745i', 'Sedan 4-Door'],
    [2004, 'BMW', '745Li', 'Sedan 4-Door'],
    [2004, 'BMW', '760i', 'Sedan 4-Door'],
    [2004, 'BMW', '760Li', 'Sedan 4-Door'],
    [2004, 'BMW', 'M3', 'Convertible 2-Door'],
    [2004, 'BMW', 'M3', 'Coupe 2-Door'],
    [2004, 'BMW', 'X3', 'SUV 4-Door'],
    [2004, 'BMW', 'X5', 'SUV 4-Door'],
    [2004, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2004, 'Buick', 'Century', 'Sedan 4-Door'],
    [2004, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [2004, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [2004, 'Buick', 'Rainier', 'SUV 4-Door'],
    [2004, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2004, 'Buick', 'Rendezvous', 'SUV 4-Door'],
    [2004, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2004, 'Cadillac', 'DeVille', 'Hearse 4-Door'],
    [2004, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [2004, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [2004, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2004, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2004, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2004, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [2004, 'Cadillac', 'SRX', 'SUV 4-Door'],
    [2004, 'Cadillac', 'XLR', 'Convertible 2-Door'],
    [2004, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [2004, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [2004, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [2004, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [2004, 'Chevrolet', 'Avalanche 1500', 'Crew Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Avalanche 2500', 'Crew Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Aveo', 'Hatchback 4-Door'],
    [2004, 'Chevrolet', 'Aveo', 'Sedan 4-Door'],
    [2004, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [2004, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2004, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [2004, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [2004, 'Chevrolet', 'Classic', 'Sedan 4-Door'],
    [2004, 'Chevrolet', 'Colorado', 'Crew Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Colorado', 'Extended Cab Pickup 3-Door'],
    [2004, 'Chevrolet', 'Colorado', 'Standard Cab Pickup 2-Door'],
    [2004, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2004, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2004, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2004, 'Chevrolet', 'Epica', 'Sedan 4-Door'],
    [2004, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2004, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2004, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2004, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [2004, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2004, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2004, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2004, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2004, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2004, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2004, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2004, 'Chevrolet', 'Malibu', 'Hatchback 4-Door'],
    [2004, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2004, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [2004, 'Chevrolet', 'Optra', 'Hatchback 4-Door'],
    [2004, 'Chevrolet', 'Optra', 'Sedan 4-Door'],
    [2004, 'Chevrolet', 'S10', 'Crew Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 1500', 'Crew Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2004, 'Chevrolet', 'Silverado 2500', 'Crew Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 2500', 'Extended Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 2500', 'Standard Cab Pickup 2-Door'],
    [2004, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2004, 'Chevrolet', 'Silverado 3500', 'Crew Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 3500', 'Extended Cab Pickup 4-Door'],
    [2004, 'Chevrolet', 'Silverado 3500', 'Standard Cab Pickup 2-Door'],
    [2004, 'Chevrolet', 'SSR', 'Convertible 2-Door'],
    [2004, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2004, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2004, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2004, 'Chevrolet', 'Tracker', 'SUV 4-Door'],
    [2004, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2004, 'Chevrolet', 'Trailblazer EXT', 'SUV 4-Door'],
    [2004, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [2004, 'Chrysler', '300M', 'Sedan 4-Door'],
    [2004, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [2004, 'Chrysler', 'Crossfire', 'Coupe 2-Door'],
    [2004, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [2004, 'Chrysler', 'Pacifica', 'SUV 4-Door'],
    [2004, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2004, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2004, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [2004, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2004, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2004, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [2004, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [2004, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2004, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [2004, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [2004, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2004, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 3-Door'],
    [2004, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2004, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [2004, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [2004, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2004, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2004, 'Dodge', 'Ram 2500', 'Crew Cab Pickup 4-Door'],
    [2004, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2004, 'Dodge', 'Ram 3500', 'Crew Cab Pickup 4-Door'],
    [2004, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2004, 'Dodge', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2004, 'Dodge', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2004, 'Dodge', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2004, 'Dodge', 'Stratus', 'Coupe 2-Door'],
    [2004, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [2004, 'Dodge', 'SX 2.0', 'Sedan 4-Door'],
    [2004, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2004, 'Ferrari', '360', 'Convertible 2-Door'],
    [2004, 'Ferrari', '360', 'Coupe 2-Door'],
    [2004, 'Ferrari', '456 M GT', 'Coupe 2-Door'],
    [2004, 'Ferrari', '456 M GTA', 'Coupe 2-Door'],
    [2004, 'Ferrari', '575 M Maranello', 'Coupe 2-Door'],
    [2004, 'Ferrari', 'Enzo', 'Coupe 2-Door'],
    [2004, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2004, 'Ford', 'E-150', 'Standard Cargo Van 2-Door'],
    [2004, 'Ford', 'E-150 Club Wagon', 'Standard Passenger Van 2-Door'],
    [2004, 'Ford', 'E-250', 'Extended Cargo Van 2-Door'],
    [2004, 'Ford', 'E-250', 'Standard Cargo Van 2-Door'],
    [2004, 'Ford', 'E-350 Club Wagon', 'Extended Passenger Van 2-Door'],
    [2004, 'Ford', 'E-350 Club Wagon', 'Standard Passenger Van 2-Door'],
    [2004, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [2004, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [2004, 'Ford', 'Escape', 'SUV 4-Door'],
    [2004, 'Ford', 'Excursion', 'SUV 4-Door'],
    [2004, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2004, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2004, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2004, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2004, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2004, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2004, 'Ford', 'F-150 Heritage', 'Extended Cab Pickup 4-Door'],
    [2004, 'Ford', 'F-150 Heritage', 'Standard Cab Pickup 2-Door'],
    [2004, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2004, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2004, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2004, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2004, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2004, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2004, 'Ford', 'Focus', 'Hatchback 2-Door'],
    [2004, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2004, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2004, 'Ford', 'Focus', 'Wagon 4-Door'],
    [2004, 'Ford', 'Freestar', 'Mini Cargo Van 4-Door'],
    [2004, 'Ford', 'Freestar', 'Mini Passenger Van 4-Door'],
    [2004, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2004, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2004, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2004, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2004, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2004, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2004, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [2004, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [2004, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2004, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2004, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2004, 'GMC', 'Canyon', 'Crew Cab Pickup 4-Door'],
    [2004, 'GMC', 'Canyon', 'Extended Cab Pickup 4-Door'],
    [2004, 'GMC', 'Canyon', 'Standard Cab Pickup 2-Door'],
    [2004, 'GMC', 'Envoy', 'SUV 4-Door'],
    [2004, 'GMC', 'Envoy XL', 'SUV 4-Door'],
    [2004, 'GMC', 'Envoy XUV', 'SUV 4-Door'],
    [2004, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [2004, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [2004, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [2004, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [2004, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [2004, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [2004, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2004, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2004, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2004, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [2004, 'GMC', 'Savana 2500', 'Extended Passenger Van 4-Door'],
    [2004, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2004, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2004, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2004, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2004, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2004, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2004, 'GMC', 'Sierra 1500', 'Crew Cab Pickup 4-Door'],
    [2004, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2004, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2004, 'GMC', 'Sierra 2500', 'Crew Cab Pickup 4-Door'],
    [2004, 'GMC', 'Sierra 2500', 'Extended Cab Pickup 4-Door'],
    [2004, 'GMC', 'Sierra 2500', 'Standard Cab Pickup 2-Door'],
    [2004, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2004, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2004, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2004, 'GMC', 'Sierra 3500', 'Crew Cab Pickup 4-Door'],
    [2004, 'GMC', 'Sierra 3500', 'Extended Cab Pickup 4-Door'],
    [2004, 'GMC', 'Sierra 3500', 'Standard Cab Pickup 2-Door'],
    [2004, 'GMC', 'Sonoma', 'Crew Cab Pickup 4-Door'],
    [2004, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2004, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2004, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2004, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2004, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2004, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2004, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [2004, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2004, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2004, 'Honda', 'Element', 'SUV 4-Door'],
    [2004, 'Honda', 'Insight', 'Hatchback 2-Door'],
    [2004, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [2004, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2004, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2004, 'Hummer', 'H1', 'SUV 4-Door'],
    [2004, 'Hummer', 'H2', 'SUV 4-Door'],
    [2004, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2004, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2004, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2004, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2004, 'Hyundai', 'Santa Fe', 'SUV 4-Door'],
    [2004, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2004, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [2004, 'Hyundai', 'XG350', 'Sedan 4-Door'],
    [2004, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2004, 'INFINITI', 'FX45', 'SUV 4-Door'],
    [2004, 'INFINITI', 'G35', 'Coupe 2-Door'],
    [2004, 'INFINITI', 'G35', 'Sedan 4-Door'],
    [2004, 'INFINITI', 'I35', 'Sedan 4-Door'],
    [2004, 'INFINITI', 'M45', 'Sedan 4-Door'],
    [2004, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [2004, 'INFINITI', 'QX56', 'SUV 4-Door'],
    [2004, 'Isuzu', 'Ascender', 'SUV 4-Door'],
    [2004, 'Isuzu', 'Axiom', 'SUV 4-Door'],
    [2004, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [2004, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2004, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2004, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2004, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2004, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [2004, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [2004, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2004, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2004, 'Jaguar', 'X-Type', 'Sedan 4-Door'],
    [2004, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2004, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2004, 'Jeep', 'TJ', 'SUV 2-Door'],
    [2004, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2004, 'Kia', 'Amanti', 'Sedan 4-Door'],
    [2004, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2004, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2004, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2004, 'Kia', 'Rio', 'Wagon 4-Door'],
    [2004, 'Kia', 'Rio', 'Wagon 5-Door'],
    [2004, 'Kia', 'Sedona', 'Mini Passenger Van 5-Door'],
    [2004, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2004, 'Kia', 'Spectra', 'Hatchback 4-Door'],
    [2004, 'Kia', 'Spectra', 'Sedan 4-Door'],
    [2004, 'Lamborghini', 'Gallardo', 'Coupe 2-Door'],
    [2004, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2004, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2004, 'Land Rover', 'Freelander', 'SUV 2-Door'],
    [2004, 'Land Rover', 'Freelander', 'SUV 4-Door'],
    [2004, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2004, 'Lexus', 'ES330', 'Sedan 4-Door'],
    [2004, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2004, 'Lexus', 'GS430', 'Sedan 4-Door'],
    [2004, 'Lexus', 'GX470', 'SUV 4-Door'],
    [2004, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2004, 'Lexus', 'IS300', 'Wagon 4-Door'],
    [2004, 'Lexus', 'LS430', 'Sedan 4-Door'],
    [2004, 'Lexus', 'LX470', 'SUV 4-Door'],
    [2004, 'Lexus', 'RX330', 'SUV 4-Door'],
    [2004, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2004, 'Lincoln', 'Aviator', 'SUV 4-Door'],
    [2004, 'Lincoln', 'LS', 'Sedan 4-Door'],
    [2004, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2004, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2004, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2004, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [2004, 'Maserati', 'Coupe', 'Coupe 2-Door'],
    [2004, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [2004, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [2004, 'Maybach', '57', 'Sedan 4-Door'],
    [2004, 'Maybach', '62', 'Sedan 4-Door'],
    [2004, 'Mazda', '3', 'Hatchback 4-Door'],
    [2004, 'Mazda', '3', 'Sedan 4-Door'],
    [2004, 'Mazda', '6', 'Hatchback 4-Door'],
    [2004, 'Mazda', '6', 'Sedan 4-Door'],
    [2004, 'Mazda', '6', 'Wagon 5-Door'],
    [2004, 'Mazda', 'B2300', 'Extended Cab Pickup 2-Door'],
    [2004, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2004, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [2004, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [2004, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [2004, 'Mazda', 'B4000', 'Extended Cab Pickup 2-Door'],
    [2004, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2004, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [2004, 'Mazda', 'MPV', 'Mini Passenger Van 4-Door'],
    [2004, 'Mazda', 'RX-8', 'Coupe 4-Door'],
    [2004, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2004, 'Mercedes-Benz', 'C230', 'Coupe 2-Door'],
    [2004, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'C240', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'C240', 'Wagon 4-Door'],
    [2004, 'Mercedes-Benz', 'C32 AMG', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'C320', 'Coupe 2-Door'],
    [2004, 'Mercedes-Benz', 'C320', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'C320', 'Wagon 4-Door'],
    [2004, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [2004, 'Mercedes-Benz', 'CL55 AMG', 'Coupe 2-Door'],
    [2004, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2004, 'Mercedes-Benz', 'CLK320', 'Convertible 2-Door'],
    [2004, 'Mercedes-Benz', 'CLK320', 'Coupe 2-Door'],
    [2004, 'Mercedes-Benz', 'CLK500', 'Convertible 2-Door'],
    [2004, 'Mercedes-Benz', 'CLK500', 'Coupe 2-Door'],
    [2004, 'Mercedes-Benz', 'CLK55 AMG', 'Convertible 2-Door'],
    [2004, 'Mercedes-Benz', 'CLK55 AMG', 'Coupe 2-Door'],
    [2004, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [2004, 'Mercedes-Benz', 'E500', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'E500', 'Wagon 4-Door'],
    [2004, 'Mercedes-Benz', 'E55 AMG', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'G500', 'SUV 4-Door'],
    [2004, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2004, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2004, 'Mercedes-Benz', 'ML500', 'SUV 4-Door'],
    [2004, 'Mercedes-Benz', 'S430', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'S55 AMG', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2004, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [2004, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2004, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2004, 'Mercedes-Benz', 'SLK230', 'Convertible 2-Door'],
    [2004, 'Mercedes-Benz', 'SLK32 AMG', 'Convertible 2-Door'],
    [2004, 'Mercedes-Benz', 'SLK320', 'Convertible 2-Door'],
    [2004, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2004, 'Mercury', 'Marauder', 'Sedan 4-Door'],
    [2004, 'Mercury', 'Monterey', 'Mini Passenger Van 4-Door'],
    [2004, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2004, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [2004, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [2004, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2004, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [2004, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2004, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2004, 'Mitsubishi', 'Endeavor', 'SUV 4-Door'],
    [2004, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2004, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2004, 'Mitsubishi', 'Lancer', 'Wagon 4-Door'],
    [2004, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [2004, 'Mitsubishi', 'Montero Sport', 'SUV 4-Door'],
    [2004, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2004, 'Morgan', 'Aero 8', 'Convertible 2-Door'],
    [2004, 'Nissan', '350Z', 'Convertible 2-Door'],
    [2004, 'Nissan', '350Z', 'Coupe 2-Door'],
    [2004, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2004, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2004, 'Nissan', 'Frontier', 'Extended Cab Pickup 2-Door'],
    [2004, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2004, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2004, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2004, 'Nissan', 'Pathfinder Armada', 'SUV 4-Door'],
    [2004, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2004, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2004, 'Nissan', 'TITAN', 'Crew Cab Pickup 4-Door'],
    [2004, 'Nissan', 'TITAN', 'Extended Cab Pickup 4-Door'],
    [2004, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2004, 'Oldsmobile', 'Alero', 'Coupe 2-Door'],
    [2004, 'Oldsmobile', 'Alero', 'Sedan 4-Door'],
    [2004, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [2004, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 4-Door'],
    [2004, 'Panoz', 'Esperante', 'Convertible 2-Door'],
    [2004, 'Pontiac', 'Aztek', 'SUV 4-Door'],
    [2004, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [2004, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [2004, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [2004, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2004, 'Pontiac', 'GTO', 'Coupe 2-Door'],
    [2004, 'Pontiac', 'Montana', 'Mini Cargo Van 4-Door'],
    [2004, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2004, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [2004, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [2004, 'Pontiac', 'Vibe', 'Wagon 4-Door'],
    [2004, 'Porsche', '911', 'Convertible 2-Door'],
    [2004, 'Porsche', '911', 'Coupe 2-Door'],
    [2004, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2004, 'Porsche', 'Carrera GT', 'Convertible 2-Door'],
    [2004, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2004, 'Rolls-Royce', 'Phantom', 'Sedan 4-Door'],
    [2004, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2004, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2004, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2004, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2004, 'Saleen', 'S7', 'Coupe 2-Door'],
    [2004, 'Saturn', 'Ion', 'Coupe 4-Door'],
    [2004, 'Saturn', 'Ion', 'Sedan 4-Door'],
    [2004, 'Saturn', 'L300', 'Sedan 4-Door'],
    [2004, 'Saturn', 'L300', 'Wagon 4-Door'],
    [2004, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2004, 'Scion', 'xA', 'Hatchback 4-Door'],
    [2004, 'Scion', 'xB', 'Wagon 4-Door'],
    [2004, 'Subaru', 'Baja', 'Crew Cab Pickup 4-Door'],
    [2004, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2004, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2004, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [2004, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2004, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2004, 'Subaru', 'Outback', 'Sedan 4-Door'],
    [2004, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2004, 'Suzuki', 'Aerio', 'Sedan 4-Door'],
    [2004, 'Suzuki', 'Aerio', 'Wagon 5-Door'],
    [2004, 'Suzuki', 'Forenza', 'Sedan 4-Door'],
    [2004, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2004, 'Suzuki', 'Swift+', 'Hatchback 4-Door'],
    [2004, 'Suzuki', 'Verona', 'Sedan 4-Door'],
    [2004, 'Suzuki', 'Vitara', 'SUV 4-Door'],
    [2004, 'Suzuki', 'XL-7', 'SUV 4-Door'],
    [2004, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2004, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2004, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2004, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [2004, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2004, 'Toyota', 'Echo', 'Hatchback 2-Door'],
    [2004, 'Toyota', 'Echo', 'Hatchback 4-Door'],
    [2004, 'Toyota', 'Echo', 'Sedan 2-Door'],
    [2004, 'Toyota', 'Echo', 'Sedan 4-Door'],
    [2004, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2004, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2004, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2004, 'Toyota', 'MR2 Spyder', 'Convertible 2-Door'],
    [2004, 'Toyota', 'Prius', 'Hatchback 4-Door'],
    [2004, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2004, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2004, 'Toyota', 'Sienna', 'Mini Cargo Van 5-Door'],
    [2004, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2004, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2004, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2004, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2004, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2004, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [2004, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2004, 'Toyota', 'Tundra', 'Crew Cab Pickup 4-Door'],
    [2004, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2004, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2004, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2004, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2004, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2004, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2004, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2004, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2004, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2004, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2004, 'Volkswagen', 'Phaeton', 'Sedan 4-Door'],
    [2004, 'Volkswagen', 'R32', 'Hatchback 2-Door'],
    [2004, 'Volkswagen', 'Touareg', 'SUV 4-Door'],
    [2004, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2004, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2004, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2004, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2004, 'Volvo', 'V40', 'Wagon 4-Door'],
    [2004, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2004, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2004, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2004, 'Workhorse', 'FasTrack FT1061', 'Standard Cargo Van 2-Door'],
    [2004, 'Workhorse', 'FasTrack FT1261', 'Standard Cargo Van 2-Door'],
    [2004, 'Workhorse', 'FasTrack FT1461', 'Standard Cargo Van 2-Door'],
    [2004, 'Workhorse', 'FasTrack FT1601', 'Standard Cargo Van 2-Door'],
    [2004, 'Workhorse', 'FasTrack FT1801', 'Standard Cargo Van 2-Door'],
    [2003, 'Acura', 'CL', 'Coupe 2-Door'],
    [2003, 'Acura', 'EL', 'Sedan 4-Door'],
    [2003, 'Acura', 'MDX', 'SUV 4-Door'],
    [2003, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2003, 'Acura', 'RL', 'Sedan 4-Door'],
    [2003, 'Acura', 'RSX', 'Coupe 2-Door'],
    [2003, 'Acura', 'TL', 'Sedan 4-Door'],
    [2003, 'Aston Martin', 'DB7', 'Convertible 2-Door'],
    [2003, 'Aston Martin', 'DB7', 'Coupe 2-Door'],
    [2003, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2003, 'Audi', 'A4', 'Convertible 2-Door'],
    [2003, 'Audi', 'A4', 'Sedan 4-Door'],
    [2003, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2003, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2003, 'Audi', 'A6', 'Sedan 4-Door'],
    [2003, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2003, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2003, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2003, 'Audi', 'Allroad Quattro', 'Wagon 4-Door'],
    [2003, 'Audi', 'RS6', 'Sedan 4-Door'],
    [2003, 'Audi', 'S6', 'Wagon 4-Door'],
    [2003, 'Audi', 'S8', 'Sedan 4-Door'],
    [2003, 'Audi', 'TT', 'Convertible 2-Door'],
    [2003, 'Audi', 'TT', 'Coupe 2-Door'],
    [2003, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2003, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2003, 'Avanti', 'II', 'Convertible 2-Door'],
    [2003, 'Avanti', 'II', 'Coupe 2-Door'],
    [2003, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2003, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2003, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2003, 'BMW', '320i', 'Sedan 4-Door'],
    [2003, 'BMW', '325Ci', 'Convertible 2-Door'],
    [2003, 'BMW', '325Ci', 'Coupe 2-Door'],
    [2003, 'BMW', '325i', 'Sedan 4-Door'],
    [2003, 'BMW', '325i', 'Wagon 4-Door'],
    [2003, 'BMW', '325xi', 'Sedan 4-Door'],
    [2003, 'BMW', '325xi', 'Wagon 4-Door'],
    [2003, 'BMW', '330Ci', 'Convertible 2-Door'],
    [2003, 'BMW', '330Ci', 'Coupe 2-Door'],
    [2003, 'BMW', '330i', 'Sedan 4-Door'],
    [2003, 'BMW', '330xi', 'Sedan 4-Door'],
    [2003, 'BMW', '525i', 'Sedan 4-Door'],
    [2003, 'BMW', '525i', 'Wagon 4-Door'],
    [2003, 'BMW', '530i', 'Sedan 4-Door'],
    [2003, 'BMW', '540i', 'Sedan 4-Door'],
    [2003, 'BMW', '540i', 'Wagon 4-Door'],
    [2003, 'BMW', '745i', 'Sedan 4-Door'],
    [2003, 'BMW', '745Li', 'Sedan 4-Door'],
    [2003, 'BMW', '760Li', 'Sedan 4-Door'],
    [2003, 'BMW', 'M3', 'Convertible 2-Door'],
    [2003, 'BMW', 'M3', 'Coupe 2-Door'],
    [2003, 'BMW', 'M5', 'Sedan 4-Door'],
    [2003, 'BMW', 'X5', 'SUV 4-Door'],
    [2003, 'BMW', 'Z4', 'Convertible 2-Door'],
    [2003, 'BMW', 'Z8', 'Convertible 2-Door'],
    [2003, 'Buick', 'Century', 'Sedan 4-Door'],
    [2003, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [2003, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [2003, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2003, 'Buick', 'Rendezvous', 'SUV 4-Door'],
    [2003, 'Cadillac', 'CTS', 'Sedan 4-Door'],
    [2003, 'Cadillac', 'DeVille', 'Hearse 4-Door'],
    [2003, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [2003, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [2003, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2003, 'Cadillac', 'Escalade ESV', 'SUV 4-Door'],
    [2003, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2003, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [2003, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [2003, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [2003, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [2003, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [2003, 'Chevrolet', 'Avalanche 1500', 'Crew Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Avalanche 2500', 'Crew Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [2003, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2003, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [2003, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [2003, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2003, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2003, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2003, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2003, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2003, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2003, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [2003, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2003, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2003, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2003, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2003, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2003, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2003, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2003, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2003, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [2003, 'Chevrolet', 'S10', 'Crew Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [2003, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [2003, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2003, 'Chevrolet', 'Silverado 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Silverado 2500', 'Extended Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Silverado 2500', 'Standard Cab Pickup 2-Door'],
    [2003, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2003, 'Chevrolet', 'Silverado 3500', 'Crew Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Silverado 3500', 'Extended Cab Pickup 4-Door'],
    [2003, 'Chevrolet', 'Silverado 3500', 'Standard Cab Pickup 2-Door'],
    [2003, 'Chevrolet', 'SSR', 'Convertible 2-Door'],
    [2003, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2003, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2003, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2003, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [2003, 'Chevrolet', 'Tracker', 'SUV 4-Door'],
    [2003, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2003, 'Chevrolet', 'Trailblazer EXT', 'SUV 4-Door'],
    [2003, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [2003, 'Chrysler', '300M', 'Sedan 4-Door'],
    [2003, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [2003, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [2003, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2003, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2003, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [2003, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2003, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2003, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2003, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [2003, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [2003, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2003, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [2003, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [2003, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2003, 'Dodge', 'Grand Caravan', 'Mini Cargo Van 4-Door'],
    [2003, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2003, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [2003, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [2003, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2003, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2003, 'Dodge', 'Ram 1500 Van', 'Extended Cargo Van 3-Door'],
    [2003, 'Dodge', 'Ram 1500 Van', 'Standard Cargo Van 3-Door'],
    [2003, 'Dodge', 'Ram 1500 Van', 'Standard Passenger Van 3-Door'],
    [2003, 'Dodge', 'Ram 2500', 'Crew Cab Pickup 4-Door'],
    [2003, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2003, 'Dodge', 'Ram 2500 Van', 'Extended Cargo Van 3-Door'],
    [2003, 'Dodge', 'Ram 2500 Van', 'Standard Cargo Van 3-Door'],
    [2003, 'Dodge', 'Ram 2500 Van', 'Standard Passenger Van 3-Door'],
    [2003, 'Dodge', 'Ram 3500', 'Crew Cab Pickup 4-Door'],
    [2003, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2003, 'Dodge', 'Ram 3500 Van', 'Extended Cargo Van 3-Door'],
    [2003, 'Dodge', 'Ram 3500 Van', 'Extended Passenger Van 3-Door'],
    [2003, 'Dodge', 'Ram 3500 Van', 'Standard Cargo Van 3-Door'],
    [2003, 'Dodge', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2003, 'Dodge', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2003, 'Dodge', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2003, 'Dodge', 'Stratus', 'Coupe 2-Door'],
    [2003, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [2003, 'Dodge', 'SX 2.0', 'Sedan 4-Door'],
    [2003, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2003, 'Ferrari', '360', 'Convertible 2-Door'],
    [2003, 'Ferrari', '360', 'Coupe 2-Door'],
    [2003, 'Ferrari', '456 M GT', 'Coupe 2-Door'],
    [2003, 'Ferrari', '456 M GTA', 'Coupe 2-Door'],
    [2003, 'Ferrari', '575 M Maranello', 'Coupe 2-Door'],
    [2003, 'Ferrari', 'Enzo', 'Coupe 2-Door'],
    [2003, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2003, 'Ford', 'E-150', 'Standard Cargo Van 2-Door'],
    [2003, 'Ford', 'E-150 Club Wagon', 'Standard Passenger Van 2-Door'],
    [2003, 'Ford', 'E-250', 'Extended Cargo Van 2-Door'],
    [2003, 'Ford', 'E-250', 'Standard Cargo Van 2-Door'],
    [2003, 'Ford', 'E-350 Club Wagon', 'Extended Passenger Van 2-Door'],
    [2003, 'Ford', 'E-350 Club Wagon', 'Standard Passenger Van 2-Door'],
    [2003, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [2003, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [2003, 'Ford', 'Escape', 'SUV 4-Door'],
    [2003, 'Ford', 'Escort', 'Coupe 2-Door'],
    [2003, 'Ford', 'Excursion', 'SUV 4-Door'],
    [2003, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2003, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2003, 'Ford', 'Explorer Sport', 'SUV 2-Door'],
    [2003, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2003, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2003, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [2003, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2003, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2003, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2003, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2003, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2003, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2003, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2003, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2003, 'Ford', 'Focus', 'Hatchback 2-Door'],
    [2003, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2003, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2003, 'Ford', 'Focus', 'Wagon 4-Door'],
    [2003, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2003, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2003, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2003, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2003, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2003, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2003, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [2003, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [2003, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [2003, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [2003, 'Ford', 'Windstar', 'Mini Passenger Van 4-Door'],
    [2003, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2003, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2003, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2003, 'GMC', 'Envoy', 'SUV 4-Door'],
    [2003, 'GMC', 'Envoy XL', 'SUV 4-Door'],
    [2003, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [2003, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [2003, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [2003, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [2003, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2003, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2003, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2003, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [2003, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2003, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2003, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2003, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2003, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2003, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2003, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2003, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2003, 'GMC', 'Sierra 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2003, 'GMC', 'Sierra 2500', 'Extended Cab Pickup 4-Door'],
    [2003, 'GMC', 'Sierra 2500', 'Standard Cab Pickup 2-Door'],
    [2003, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2003, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2003, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2003, 'GMC', 'Sierra 3500', 'Crew Cab Pickup 4-Door'],
    [2003, 'GMC', 'Sierra 3500', 'Extended Cab Pickup 4-Door'],
    [2003, 'GMC', 'Sierra 3500', 'Standard Cab Pickup 2-Door'],
    [2003, 'GMC', 'Sonoma', 'Crew Cab Pickup 4-Door'],
    [2003, 'GMC', 'Sonoma', 'Extended Cab Pickup 3-Door'],
    [2003, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [2003, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2003, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2003, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2003, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2003, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2003, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2003, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [2003, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2003, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2003, 'Honda', 'Element', 'SUV 4-Door'],
    [2003, 'Honda', 'Insight', 'Hatchback 2-Door'],
    [2003, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [2003, 'Honda', 'Pilot', 'SUV 4-Door'],
    [2003, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2003, 'Hummer', 'H1', 'SUV 2-Door'],
    [2003, 'Hummer', 'H1', 'SUV 4-Door'],
    [2003, 'Hummer', 'H2', 'SUV 4-Door'],
    [2003, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2003, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2003, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2003, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2003, 'Hyundai', 'Santa Fe', 'SUV 5-Door'],
    [2003, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2003, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [2003, 'Hyundai', 'XG350', 'Sedan 4-Door'],
    [2003, 'INFINITI', 'FX35', 'SUV 4-Door'],
    [2003, 'INFINITI', 'FX45', 'SUV 4-Door'],
    [2003, 'INFINITI', 'G35', 'Coupe 2-Door'],
    [2003, 'INFINITI', 'G35', 'Sedan 4-Door'],
    [2003, 'INFINITI', 'I35', 'Sedan 4-Door'],
    [2003, 'INFINITI', 'M45', 'Sedan 4-Door'],
    [2003, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [2003, 'INFINITI', 'QX4', 'SUV 4-Door'],
    [2003, 'Isuzu', 'Ascender', 'SUV 4-Door'],
    [2003, 'Isuzu', 'Axiom', 'SUV 4-Door'],
    [2003, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [2003, 'Isuzu', 'Rodeo Sport', 'SUV 2-Door'],
    [2003, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2003, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2003, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2003, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2003, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [2003, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [2003, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2003, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2003, 'Jaguar', 'X-Type', 'Sedan 4-Door'],
    [2003, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2003, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2003, 'Jeep', 'TJ', 'SUV 2-Door'],
    [2003, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2003, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2003, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2003, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2003, 'Kia', 'Rio', 'Wagon 5-Door'],
    [2003, 'Kia', 'Sedona', 'Mini Passenger Van 5-Door'],
    [2003, 'Kia', 'Sorento', 'SUV 4-Door'],
    [2003, 'Kia', 'Spectra', 'Hatchback 4-Door'],
    [2003, 'Kia', 'Spectra', 'Sedan 4-Door'],
    [2003, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2003, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2003, 'Land Rover', 'Freelander', 'SUV 2-Door'],
    [2003, 'Land Rover', 'Freelander', 'SUV 4-Door'],
    [2003, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2003, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [2003, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2003, 'Lexus', 'GS430', 'Sedan 4-Door'],
    [2003, 'Lexus', 'GX470', 'SUV 4-Door'],
    [2003, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2003, 'Lexus', 'IS300', 'Wagon 4-Door'],
    [2003, 'Lexus', 'LS430', 'Sedan 4-Door'],
    [2003, 'Lexus', 'LX470', 'SUV 4-Door'],
    [2003, 'Lexus', 'RX300', 'SUV 4-Door'],
    [2003, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2003, 'Lincoln', 'Aviator', 'SUV 4-Door'],
    [2003, 'Lincoln', 'LS', 'Sedan 4-Door'],
    [2003, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2003, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2003, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2003, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [2003, 'Maserati', 'Coupe', 'Coupe 2-Door'],
    [2003, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [2003, 'Maybach', '57', 'Sedan 4-Door'],
    [2003, 'Maybach', '62', 'Sedan 4-Door'],
    [2003, 'Mazda', '6', 'Sedan 4-Door'],
    [2003, 'Mazda', 'B2300', 'Extended Cab Pickup 2-Door'],
    [2003, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2003, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [2003, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [2003, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [2003, 'Mazda', 'B4000', 'Extended Cab Pickup 2-Door'],
    [2003, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2003, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [2003, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [2003, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [2003, 'Mazda', 'Protege5', 'Hatchback 4-Door'],
    [2003, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2003, 'Mercedes-Benz', 'C230', 'Coupe 2-Door'],
    [2003, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'C240', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'C240', 'Wagon 4-Door'],
    [2003, 'Mercedes-Benz', 'C32 AMG', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'C320', 'Coupe 2-Door'],
    [2003, 'Mercedes-Benz', 'C320', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'C320', 'Wagon 4-Door'],
    [2003, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [2003, 'Mercedes-Benz', 'CL55 AMG', 'Coupe 2-Door'],
    [2003, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2003, 'Mercedes-Benz', 'CLK320', 'Convertible 2-Door'],
    [2003, 'Mercedes-Benz', 'CLK320', 'Coupe 2-Door'],
    [2003, 'Mercedes-Benz', 'CLK430', 'Convertible 2-Door'],
    [2003, 'Mercedes-Benz', 'CLK500', 'Coupe 2-Door'],
    [2003, 'Mercedes-Benz', 'CLK55 AMG', 'Coupe 2-Door'],
    [2003, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [2003, 'Mercedes-Benz', 'E500', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'E55 AMG', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'G500', 'SUV 4-Door'],
    [2003, 'Mercedes-Benz', 'G55 AMG', 'SUV 4-Door'],
    [2003, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [2003, 'Mercedes-Benz', 'ML350', 'SUV 4-Door'],
    [2003, 'Mercedes-Benz', 'ML500', 'SUV 4-Door'],
    [2003, 'Mercedes-Benz', 'ML55 AMG', 'SUV 4-Door'],
    [2003, 'Mercedes-Benz', 'S430', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'S55 AMG', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2003, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [2003, 'Mercedes-Benz', 'SL55 AMG', 'Convertible 2-Door'],
    [2003, 'Mercedes-Benz', 'SLK230', 'Convertible 2-Door'],
    [2003, 'Mercedes-Benz', 'SLK32 AMG', 'Convertible 2-Door'],
    [2003, 'Mercedes-Benz', 'SLK320', 'Convertible 2-Door'],
    [2003, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2003, 'Mercury', 'Marauder', 'Sedan 4-Door'],
    [2003, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2003, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [2003, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [2003, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2003, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [2003, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2003, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2003, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2003, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2003, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [2003, 'Mitsubishi', 'Montero Sport', 'SUV 4-Door'],
    [2003, 'Mitsubishi', 'Outlander', 'SUV 4-Door'],
    [2003, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [2003, 'Nissan', '350Z', 'Coupe 2-Door'],
    [2003, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2003, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2003, 'Nissan', 'Frontier', 'Extended Cab Pickup 2-Door'],
    [2003, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2003, 'Nissan', 'Murano', 'SUV 4-Door'],
    [2003, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2003, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2003, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2003, 'Oldsmobile', 'Alero', 'Coupe 2-Door'],
    [2003, 'Oldsmobile', 'Alero', 'Sedan 4-Door'],
    [2003, 'Oldsmobile', 'Aurora', 'Sedan 4-Door'],
    [2003, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [2003, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 4-Door'],
    [2003, 'Panoz', 'Esperante', 'Convertible 2-Door'],
    [2003, 'Pontiac', 'Aztek', 'SUV 4-Door'],
    [2003, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [2003, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [2003, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [2003, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [2003, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2003, 'Pontiac', 'Montana', 'Mini Cargo Van 4-Door'],
    [2003, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2003, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [2003, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [2003, 'Pontiac', 'Vibe', 'Wagon 4-Door'],
    [2003, 'Porsche', '911', 'Convertible 2-Door'],
    [2003, 'Porsche', '911', 'Coupe 2-Door'],
    [2003, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2003, 'Porsche', 'Cayenne', 'SUV 4-Door'],
    [2003, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2003, 'Saab', '3-Sep', 'Sedan 4-Door'],
    [2003, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2003, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2003, 'Saleen', 'S7', 'Coupe 2-Door'],
    [2003, 'Saturn', 'Ion', 'Coupe 4-Door'],
    [2003, 'Saturn', 'Ion', 'Sedan 4-Door'],
    [2003, 'Saturn', 'L200', 'Sedan 4-Door'],
    [2003, 'Saturn', 'L300', 'Sedan 4-Door'],
    [2003, 'Saturn', 'LW200', 'Wagon 4-Door'],
    [2003, 'Saturn', 'LW300', 'Wagon 4-Door'],
    [2003, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2003, 'Subaru', 'Baja', 'Crew Cab Pickup 4-Door'],
    [2003, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2003, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2003, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [2003, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2003, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2003, 'Subaru', 'Outback', 'Sedan 4-Door'],
    [2003, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2003, 'Suzuki', 'Aerio', 'Sedan 4-Door'],
    [2003, 'Suzuki', 'Aerio', 'Wagon 5-Door'],
    [2003, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2003, 'Suzuki', 'Vitara', 'SUV 2-Door'],
    [2003, 'Suzuki', 'Vitara', 'SUV 4-Door'],
    [2003, 'Suzuki', 'XL-7', 'SUV 4-Door'],
    [2003, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2003, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2003, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2003, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [2003, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2003, 'Toyota', 'Echo', 'Sedan 2-Door'],
    [2003, 'Toyota', 'Echo', 'Sedan 4-Door'],
    [2003, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2003, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2003, 'Toyota', 'Matrix', 'Wagon 4-Door'],
    [2003, 'Toyota', 'MR2 Spyder', 'Convertible 2-Door'],
    [2003, 'Toyota', 'Prius', 'Sedan 4-Door'],
    [2003, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2003, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2003, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2003, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2003, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2003, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2003, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2003, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [2003, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2003, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2003, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2003, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [2003, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2003, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [2003, 'Volkswagen', 'EuroVan', 'Van Camper 3-Door'],
    [2003, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2003, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2003, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2003, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2003, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2003, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2003, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2003, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2003, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2003, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2003, 'Volvo', 'V40', 'Wagon 4-Door'],
    [2003, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2003, 'Volvo', 'XC70', 'Wagon 4-Door'],
    [2003, 'Volvo', 'XC90', 'SUV 4-Door'],
    [2003, 'Workhorse', 'FasTrack FT1061', 'Standard Cargo Van 2-Door'],
    [2003, 'Workhorse', 'FasTrack FT1261', 'Standard Cargo Van 2-Door'],
    [2003, 'Workhorse', 'FasTrack FT1461', 'Standard Cargo Van 2-Door'],
    [2003, 'Workhorse', 'FasTrack FT1601', 'Standard Cargo Van 2-Door'],
    [2003, 'Workhorse', 'FasTrack FT1801', 'Standard Cargo Van 2-Door'],
    [2003, 'Workhorse', 'FasTrack FT1802', 'Standard Cargo Van 2-Door'],
    [2003, 'Workhorse', 'FasTrack FT931', 'Standard Cargo Van 2-Door'],
    [2002, 'Acura', 'CL', 'Coupe 2-Door'],
    [2002, 'Acura', 'EL', 'Sedan 4-Door'],
    [2002, 'Acura', 'MDX', 'SUV 4-Door'],
    [2002, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2002, 'Acura', 'RL', 'Sedan 4-Door'],
    [2002, 'Acura', 'RSX', 'Coupe 2-Door'],
    [2002, 'Acura', 'TL', 'Sedan 4-Door'],
    [2002, 'Aston Martin', 'DB7', 'Convertible 2-Door'],
    [2002, 'Aston Martin', 'DB7', 'Coupe 2-Door'],
    [2002, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2002, 'Audi', 'A4', 'Sedan 4-Door'],
    [2002, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2002, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2002, 'Audi', 'A6', 'Sedan 4-Door'],
    [2002, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2002, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2002, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2002, 'Audi', 'Allroad Quattro', 'Wagon 4-Door'],
    [2002, 'Audi', 'S4', 'Sedan 4-Door'],
    [2002, 'Audi', 'S4', 'Wagon 4-Door'],
    [2002, 'Audi', 'S6', 'Wagon 4-Door'],
    [2002, 'Audi', 'S8', 'Sedan 4-Door'],
    [2002, 'Audi', 'TT', 'Convertible 2-Door'],
    [2002, 'Audi', 'TT', 'Coupe 2-Door'],
    [2002, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2002, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2002, 'Avanti', 'II', 'Convertible 2-Door'],
    [2002, 'Avanti', 'II', 'Coupe 2-Door'],
    [2002, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2002, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2002, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2002, 'BMW', '320i', 'Sedan 4-Door'],
    [2002, 'BMW', '325Ci', 'Convertible 2-Door'],
    [2002, 'BMW', '325Ci', 'Coupe 2-Door'],
    [2002, 'BMW', '325i', 'Sedan 4-Door'],
    [2002, 'BMW', '325i', 'Wagon 4-Door'],
    [2002, 'BMW', '325xi', 'Sedan 4-Door'],
    [2002, 'BMW', '325xi', 'Wagon 4-Door'],
    [2002, 'BMW', '330Ci', 'Convertible 2-Door'],
    [2002, 'BMW', '330Ci', 'Coupe 2-Door'],
    [2002, 'BMW', '330i', 'Sedan 4-Door'],
    [2002, 'BMW', '330xi', 'Sedan 4-Door'],
    [2002, 'BMW', '525i', 'Sedan 4-Door'],
    [2002, 'BMW', '525i', 'Wagon 4-Door'],
    [2002, 'BMW', '530i', 'Sedan 4-Door'],
    [2002, 'BMW', '540i', 'Sedan 4-Door'],
    [2002, 'BMW', '540i', 'Wagon 4-Door'],
    [2002, 'BMW', '745i', 'Sedan 4-Door'],
    [2002, 'BMW', '745Li', 'Sedan 4-Door'],
    [2002, 'BMW', 'M3', 'Convertible 2-Door'],
    [2002, 'BMW', 'M3', 'Coupe 2-Door'],
    [2002, 'BMW', 'M5', 'Sedan 4-Door'],
    [2002, 'BMW', 'X5', 'SUV 4-Door'],
    [2002, 'BMW', 'Z3', 'Convertible 2-Door'],
    [2002, 'BMW', 'Z3', 'Coupe 2-Door'],
    [2002, 'BMW', 'Z8', 'Convertible 2-Door'],
    [2002, 'Buick', 'Century', 'Sedan 4-Door'],
    [2002, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [2002, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [2002, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2002, 'Buick', 'Rendezvous', 'SUV 4-Door'],
    [2002, 'Cadillac', 'DeVille', 'Hearse 4-Door'],
    [2002, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [2002, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [2002, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [2002, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2002, 'Cadillac', 'Escalade EXT', 'Crew Cab Pickup 4-Door'],
    [2002, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [2002, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [2002, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [2002, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [2002, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [2002, 'Chevrolet', 'Avalanche 1500', 'Crew Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Avalanche 2500', 'Crew Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [2002, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2002, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2002, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2002, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [2002, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [2002, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2002, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2002, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2002, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2002, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2002, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2002, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [2002, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2002, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2002, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2002, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2002, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2002, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2002, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2002, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2002, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [2002, 'Chevrolet', 'Prizm', 'Sedan 4-Door'],
    [2002, 'Chevrolet', 'S10', 'Crew Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [2002, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [2002, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2002, 'Chevrolet', 'Silverado 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Silverado 2500', 'Extended Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Silverado 2500', 'Standard Cab Pickup 2-Door'],
    [2002, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2002, 'Chevrolet', 'Silverado 3500', 'Crew Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Silverado 3500', 'Extended Cab Pickup 4-Door'],
    [2002, 'Chevrolet', 'Silverado 3500', 'Standard Cab Pickup 2-Door'],
    [2002, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2002, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2002, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2002, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [2002, 'Chevrolet', 'Tracker', 'SUV 4-Door'],
    [2002, 'Chevrolet', 'Trailblazer', 'SUV 4-Door'],
    [2002, 'Chevrolet', 'Trailblazer EXT', 'SUV 4-Door'],
    [2002, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [2002, 'Chrysler', '300M', 'Sedan 4-Door'],
    [2002, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [2002, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [2002, 'Chrysler', 'Neon', 'Sedan 4-Door'],
    [2002, 'Chrysler', 'Prowler', 'Convertible 2-Door'],
    [2002, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2002, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2002, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [2002, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2002, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2002, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2002, 'Daewoo', 'Lanos', 'Hatchback 2-Door'],
    [2002, 'Daewoo', 'Lanos', 'Sedan 4-Door'],
    [2002, 'Daewoo', 'Leganza', 'Sedan 4-Door'],
    [2002, 'Daewoo', 'Nubira', 'Sedan 4-Door'],
    [2002, 'Daewoo', 'Nubira', 'Wagon 5-Door'],
    [2002, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [2002, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2002, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [2002, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [2002, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2002, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2002, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [2002, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [2002, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2002, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2002, 'Dodge', 'Ram 1500 Van', 'Extended Cargo Van 3-Door'],
    [2002, 'Dodge', 'Ram 1500 Van', 'Standard Cargo Van 3-Door'],
    [2002, 'Dodge', 'Ram 1500 Van', 'Standard Passenger Van 3-Door'],
    [2002, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 2-Door'],
    [2002, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 4-Door'],
    [2002, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2002, 'Dodge', 'Ram 2500 Van', 'Extended Cargo Van 3-Door'],
    [2002, 'Dodge', 'Ram 2500 Van', 'Standard Cargo Van 3-Door'],
    [2002, 'Dodge', 'Ram 2500 Van', 'Standard Passenger Van 3-Door'],
    [2002, 'Dodge', 'Ram 3500', 'Extended Cab Pickup 4-Door'],
    [2002, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2002, 'Dodge', 'Ram 3500 Van', 'Extended Cargo Van 3-Door'],
    [2002, 'Dodge', 'Ram 3500 Van', 'Extended Passenger Van 3-Door'],
    [2002, 'Dodge', 'Ram 3500 Van', 'Standard Cargo Van 3-Door'],
    [2002, 'Dodge', 'Stratus', 'Coupe 2-Door'],
    [2002, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [2002, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2002, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2002, 'Ferrari', '360', 'Convertible 2-Door'],
    [2002, 'Ferrari', '360', 'Coupe 2-Door'],
    [2002, 'Ferrari', '456 M GT', 'Coupe 2-Door'],
    [2002, 'Ferrari', '456 M GTA', 'Coupe 2-Door'],
    [2002, 'Ferrari', '550 Maranello', 'Convertible 2-Door'],
    [2002, 'Ferrari', '550 Maranello', 'Coupe 2-Door'],
    [2002, 'Ferrari', '575 M Maranello', 'Coupe 2-Door'],
    [2002, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2002, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [2002, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [2002, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [2002, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [2002, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [2002, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [2002, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [2002, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [2002, 'Ford', 'Escape', 'SUV 4-Door'],
    [2002, 'Ford', 'Escort', 'Coupe 2-Door'],
    [2002, 'Ford', 'Escort', 'Sedan 4-Door'],
    [2002, 'Ford', 'Excursion', 'SUV 4-Door'],
    [2002, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2002, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2002, 'Ford', 'Explorer Sport', 'SUV 2-Door'],
    [2002, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2002, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2002, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [2002, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2002, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2002, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2002, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2002, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2002, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2002, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2002, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2002, 'Ford', 'Focus', 'Hatchback 2-Door'],
    [2002, 'Ford', 'Focus', 'Hatchback 4-Door'],
    [2002, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2002, 'Ford', 'Focus', 'Wagon 4-Door'],
    [2002, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2002, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2002, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2002, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2002, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2002, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2002, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [2002, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [2002, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [2002, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [2002, 'Ford', 'Windstar', 'Mini Passenger Van 4-Door'],
    [2002, 'Freightliner', 'Sprinter 2500', 'Standard Cargo Van 3-Door'],
    [2002, 'Freightliner', 'Sprinter 2500', 'Standard Passenger Van 3-Door'],
    [2002, 'Freightliner', 'Sprinter 3500', 'Standard Cargo Van 3-Door'],
    [2002, 'GMC', 'Envoy', 'SUV 4-Door'],
    [2002, 'GMC', 'Envoy XL', 'SUV 4-Door'],
    [2002, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [2002, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [2002, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [2002, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [2002, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2002, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2002, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2002, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [2002, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2002, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2002, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2002, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2002, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2002, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2002, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2002, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2002, 'GMC', 'Sierra 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2002, 'GMC', 'Sierra 2500', 'Extended Cab Pickup 4-Door'],
    [2002, 'GMC', 'Sierra 2500', 'Standard Cab Pickup 2-Door'],
    [2002, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2002, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2002, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2002, 'GMC', 'Sierra 3500', 'Crew Cab Pickup 4-Door'],
    [2002, 'GMC', 'Sierra 3500', 'Extended Cab Pickup 4-Door'],
    [2002, 'GMC', 'Sierra 3500', 'Standard Cab Pickup 2-Door'],
    [2002, 'GMC', 'Sonoma', 'Crew Cab Pickup 4-Door'],
    [2002, 'GMC', 'Sonoma', 'Extended Cab Pickup 3-Door'],
    [2002, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [2002, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2002, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2002, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2002, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2002, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2002, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2002, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [2002, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2002, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2002, 'Honda', 'Insight', 'Hatchback 2-Door'],
    [2002, 'Honda', 'Odyssey', 'Mini Cargo Van 5-Door'],
    [2002, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [2002, 'Honda', 'Passport', 'SUV 4-Door'],
    [2002, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2002, 'Hummer', 'H1', 'SUV 2-Door'],
    [2002, 'Hummer', 'H1', 'SUV 4-Door'],
    [2002, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2002, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2002, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2002, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2002, 'Hyundai', 'Santa Fe', 'SUV 5-Door'],
    [2002, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2002, 'Hyundai', 'XG350', 'Sedan 4-Door'],
    [2002, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [2002, 'INFINITI', 'I35', 'Sedan 4-Door'],
    [2002, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [2002, 'INFINITI', 'QX4', 'SUV 4-Door'],
    [2002, 'Isuzu', 'Axiom', 'SUV 4-Door'],
    [2002, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [2002, 'Isuzu', 'Rodeo Sport', 'SUV 2-Door'],
    [2002, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [2002, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2002, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2002, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2002, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2002, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [2002, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [2002, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2002, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2002, 'Jaguar', 'X-Type', 'Sedan 4-Door'],
    [2002, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2002, 'Jeep', 'Liberty', 'SUV 4-Door'],
    [2002, 'Jeep', 'TJ', 'SUV 2-Door'],
    [2002, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2002, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2002, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2002, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2002, 'Kia', 'Rio', 'Wagon 5-Door'],
    [2002, 'Kia', 'Sedona', 'Mini Passenger Van 5-Door'],
    [2002, 'Kia', 'Spectra', 'Hatchback 4-Door'],
    [2002, 'Kia', 'Spectra', 'Sedan 4-Door'],
    [2002, 'Kia', 'Sportage', 'Convertible 2-Door'],
    [2002, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2002, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2002, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2002, 'Land Rover', 'Freelander', 'SUV 4-Door'],
    [2002, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2002, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [2002, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2002, 'Lexus', 'GS430', 'Sedan 4-Door'],
    [2002, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2002, 'Lexus', 'IS300', 'Wagon 4-Door'],
    [2002, 'Lexus', 'LS430', 'Sedan 4-Door'],
    [2002, 'Lexus', 'LX470', 'SUV 4-Door'],
    [2002, 'Lexus', 'RX300', 'SUV 4-Door'],
    [2002, 'Lexus', 'SC430', 'Convertible 2-Door'],
    [2002, 'Lincoln', 'Blackwood', 'Crew Cab Pickup 4-Door'],
    [2002, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [2002, 'Lincoln', 'LS', 'Sedan 4-Door'],
    [2002, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2002, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2002, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2002, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [2002, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [2002, 'Mazda', '626', 'Sedan 4-Door'],
    [2002, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2002, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [2002, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [2002, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2002, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [2002, 'Mazda', 'Millenia', 'Sedan 4-Door'],
    [2002, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [2002, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [2002, 'Mazda', 'Protege5', 'Hatchback 4-Door'],
    [2002, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2002, 'Mercedes-Benz', 'C230', 'Coupe 2-Door'],
    [2002, 'Mercedes-Benz', 'C240', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'C32 AMG', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'C320', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'C320', 'Wagon 4-Door'],
    [2002, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [2002, 'Mercedes-Benz', 'CL55 AMG', 'Coupe 2-Door'],
    [2002, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2002, 'Mercedes-Benz', 'CLK320', 'Convertible 2-Door'],
    [2002, 'Mercedes-Benz', 'CLK320', 'Coupe 2-Door'],
    [2002, 'Mercedes-Benz', 'CLK430', 'Convertible 2-Door'],
    [2002, 'Mercedes-Benz', 'CLK430', 'Coupe 2-Door'],
    [2002, 'Mercedes-Benz', 'CLK55 AMG', 'Convertible 2-Door'],
    [2002, 'Mercedes-Benz', 'CLK55 AMG', 'Coupe 2-Door'],
    [2002, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [2002, 'Mercedes-Benz', 'E430', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'E55 AMG', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'G500', 'SUV 4-Door'],
    [2002, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [2002, 'Mercedes-Benz', 'ML500', 'SUV 4-Door'],
    [2002, 'Mercedes-Benz', 'ML55 AMG', 'SUV 4-Door'],
    [2002, 'Mercedes-Benz', 'S430', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'S55 AMG', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2002, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [2002, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2002, 'Mercedes-Benz', 'SLK230', 'Convertible 2-Door'],
    [2002, 'Mercedes-Benz', 'SLK32 AMG', 'Convertible 2-Door'],
    [2002, 'Mercedes-Benz', 'SLK320', 'Convertible 2-Door'],
    [2002, 'Mercury', 'Cougar', 'Coupe 2-Door'],
    [2002, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2002, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2002, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [2002, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [2002, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [2002, 'Mini', 'Cooper', 'Hatchback 2-Door'],
    [2002, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [2002, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2002, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2002, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2002, 'Mitsubishi', 'Lancer', 'Sedan 4-Door'],
    [2002, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [2002, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [2002, 'Mitsubishi', 'Montero Sport', 'SUV 4-Door'],
    [2002, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [2002, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2002, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2002, 'Nissan', 'Frontier', 'Extended Cab Pickup 2-Door'],
    [2002, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2002, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2002, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2002, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2002, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2002, 'Oldsmobile', 'Alero', 'Coupe 2-Door'],
    [2002, 'Oldsmobile', 'Alero', 'Sedan 4-Door'],
    [2002, 'Oldsmobile', 'Aurora', 'Sedan 4-Door'],
    [2002, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [2002, 'Oldsmobile', 'Intrigue', 'Sedan 4-Door'],
    [2002, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 4-Door'],
    [2002, 'Panoz', 'Esperante', 'Convertible 2-Door'],
    [2002, 'Pontiac', 'Aztek', 'SUV 4-Door'],
    [2002, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [2002, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [2002, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [2002, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [2002, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [2002, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [2002, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2002, 'Pontiac', 'Montana', 'Mini Cargo Van 4-Door'],
    [2002, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2002, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [2002, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [2002, 'Porsche', '911', 'Convertible 2-Door'],
    [2002, 'Porsche', '911', 'Coupe 2-Door'],
    [2002, 'Porsche', '911', 'Targa 2-Door'],
    [2002, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2002, 'Qvale', 'Mangusta', 'Convertible 2-Door'],
    [2002, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [2002, 'Rolls-Royce', 'Park Ward', 'Sedan 4-Door'],
    [2002, 'Rolls-Royce', 'Silver Seraph', 'Sedan 4-Door'],
    [2002, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2002, 'Saab', '3-Sep', 'Hatchback 2-Door'],
    [2002, 'Saab', '3-Sep', 'Hatchback 4-Door'],
    [2002, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2002, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2002, 'Saleen', 'S7', 'Coupe 2-Door'],
    [2002, 'Saturn', 'L100', 'Sedan 4-Door'],
    [2002, 'Saturn', 'L200', 'Sedan 4-Door'],
    [2002, 'Saturn', 'L300', 'Sedan 4-Door'],
    [2002, 'Saturn', 'LW200', 'Wagon 4-Door'],
    [2002, 'Saturn', 'LW300', 'Wagon 4-Door'],
    [2002, 'Saturn', 'SC1', 'Coupe 3-Door'],
    [2002, 'Saturn', 'SC2', 'Coupe 3-Door'],
    [2002, 'Saturn', 'SL', 'Sedan 4-Door'],
    [2002, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [2002, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [2002, 'Saturn', 'Vue', 'SUV 4-Door'],
    [2002, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2002, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2002, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [2002, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2002, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2002, 'Subaru', 'Outback', 'Sedan 4-Door'],
    [2002, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2002, 'Suzuki', 'Aerio', 'Sedan 4-Door'],
    [2002, 'Suzuki', 'Aerio', 'Wagon 5-Door'],
    [2002, 'Suzuki', 'Esteem', 'Sedan 4-Door'],
    [2002, 'Suzuki', 'Esteem', 'Wagon 5-Door'],
    [2002, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2002, 'Suzuki', 'Vitara', 'SUV 2-Door'],
    [2002, 'Suzuki', 'Vitara', 'SUV 4-Door'],
    [2002, 'Suzuki', 'XL-7', 'SUV 4-Door'],
    [2002, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2002, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2002, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2002, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [2002, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2002, 'Toyota', 'Echo', 'Sedan 2-Door'],
    [2002, 'Toyota', 'Echo', 'Sedan 4-Door'],
    [2002, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2002, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2002, 'Toyota', 'MR2 Spyder', 'Convertible 2-Door'],
    [2002, 'Toyota', 'Prius', 'Sedan 4-Door'],
    [2002, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2002, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2002, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2002, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2002, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2002, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2002, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2002, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [2002, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2002, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2002, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2002, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2002, 'Volkswagen', 'Cabrio', 'Convertible 2-Door'],
    [2002, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [2002, 'Volkswagen', 'EuroVan', 'Van Camper 3-Door'],
    [2002, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2002, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2002, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2002, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2002, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2002, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2002, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2002, 'Volvo', 'C70', 'Coupe 2-Door'],
    [2002, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2002, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2002, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2002, 'Volvo', 'V40', 'Wagon 4-Door'],
    [2002, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2002, 'Workhorse', 'FasTrack FT1061', 'Standard Cargo Van 2-Door'],
    [2002, 'Workhorse', 'FasTrack FT1261', 'Standard Cargo Van 2-Door'],
    [2002, 'Workhorse', 'FasTrack FT1460', 'Standard Cargo Van 2-Door'],
    [2002, 'Workhorse', 'FasTrack FT1461', 'Standard Cargo Van 2-Door'],
    [2002, 'Workhorse', 'FasTrack FT1601', 'Standard Cargo Van 2-Door'],
    [2002, 'Workhorse', 'FasTrack FT1801', 'Standard Cargo Van 2-Door'],
    [2002, 'Workhorse', 'FasTrack FT1802', 'Standard Cargo Van 2-Door'],
    [2002, 'Workhorse', 'FasTrack FT931', 'Standard Cargo Van 2-Door'],
    [2001, 'Acura', 'CL', 'Coupe 2-Door'],
    [2001, 'Acura', 'EL', 'Sedan 4-Door'],
    [2001, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [2001, 'Acura', 'Integra', 'Sedan 4-Door'],
    [2001, 'Acura', 'MDX', 'SUV 4-Door'],
    [2001, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2001, 'Acura', 'RL', 'Sedan 4-Door'],
    [2001, 'Acura', 'TL', 'Sedan 4-Door'],
    [2001, 'AM General', 'Hummer', 'SUV 2-Door'],
    [2001, 'AM General', 'Hummer', 'SUV 4-Door'],
    [2001, 'Aston Martin', 'DB7', 'Convertible 2-Door'],
    [2001, 'Aston Martin', 'DB7', 'Coupe 2-Door'],
    [2001, 'Aston Martin', 'Vanquish', 'Coupe 2-Door'],
    [2001, 'Audi', 'A4', 'Sedan 4-Door'],
    [2001, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2001, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2001, 'Audi', 'A6', 'Sedan 4-Door'],
    [2001, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2001, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2001, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2001, 'Audi', 'Allroad Quattro', 'Wagon 4-Door'],
    [2001, 'Audi', 'S4', 'Sedan 4-Door'],
    [2001, 'Audi', 'S4', 'Wagon 4-Door'],
    [2001, 'Audi', 'S8', 'Sedan 4-Door'],
    [2001, 'Audi', 'TT', 'Convertible 2-Door'],
    [2001, 'Audi', 'TT', 'Coupe 2-Door'],
    [2001, 'Audi', 'TT Quattro', 'Convertible 2-Door'],
    [2001, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2001, 'Avanti', 'II', 'Convertible 2-Door'],
    [2001, 'Avanti', 'II', 'Coupe 2-Door'],
    [2001, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2001, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2001, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2001, 'BMW', '320i', 'Sedan 4-Door'],
    [2001, 'BMW', '325Ci', 'Convertible 2-Door'],
    [2001, 'BMW', '325Ci', 'Coupe 2-Door'],
    [2001, 'BMW', '325i', 'Sedan 4-Door'],
    [2001, 'BMW', '325i', 'Wagon 4-Door'],
    [2001, 'BMW', '325xi', 'Sedan 4-Door'],
    [2001, 'BMW', '325xi', 'Wagon 4-Door'],
    [2001, 'BMW', '330Ci', 'Convertible 2-Door'],
    [2001, 'BMW', '330Ci', 'Coupe 2-Door'],
    [2001, 'BMW', '330i', 'Sedan 4-Door'],
    [2001, 'BMW', '330xi', 'Sedan 4-Door'],
    [2001, 'BMW', '525i', 'Sedan 4-Door'],
    [2001, 'BMW', '525i', 'Wagon 4-Door'],
    [2001, 'BMW', '530i', 'Sedan 4-Door'],
    [2001, 'BMW', '540i', 'Sedan 4-Door'],
    [2001, 'BMW', '540i', 'Wagon 4-Door'],
    [2001, 'BMW', '740i', 'Sedan 4-Door'],
    [2001, 'BMW', '740iL', 'Sedan 4-Door'],
    [2001, 'BMW', '750iL', 'Sedan 4-Door'],
    [2001, 'BMW', 'M3', 'Convertible 2-Door'],
    [2001, 'BMW', 'M3', 'Coupe 2-Door'],
    [2001, 'BMW', 'M5', 'Sedan 4-Door'],
    [2001, 'BMW', 'X5', 'SUV 4-Door'],
    [2001, 'BMW', 'Z3', 'Convertible 2-Door'],
    [2001, 'BMW', 'Z3', 'Coupe 2-Door'],
    [2001, 'BMW', 'Z8', 'Convertible 2-Door'],
    [2001, 'Buick', 'Century', 'Sedan 4-Door'],
    [2001, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [2001, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [2001, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2001, 'Cadillac', 'Catera', 'Sedan 4-Door'],
    [2001, 'Cadillac', 'DeVille', 'Hearse 4-Door'],
    [2001, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [2001, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [2001, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [2001, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [2001, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [2001, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [2001, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [2001, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [2001, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [2001, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2001, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2001, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2001, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [2001, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [2001, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2001, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2001, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2001, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2001, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2001, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2001, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [2001, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2001, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2001, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2001, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2001, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2001, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2001, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2001, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [2001, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2001, 'Chevrolet', 'Metro', 'Sedan 4-Door'],
    [2001, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [2001, 'Chevrolet', 'Prizm', 'Sedan 4-Door'],
    [2001, 'Chevrolet', 'S10', 'Crew Cab Pickup 4-Door'],
    [2001, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [2001, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [2001, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [2001, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2001, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2001, 'Chevrolet', 'Silverado 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2001, 'Chevrolet', 'Silverado 2500', 'Extended Cab Pickup 4-Door'],
    [2001, 'Chevrolet', 'Silverado 2500', 'Standard Cab Pickup 2-Door'],
    [2001, 'Chevrolet', 'Silverado 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2001, 'Chevrolet', 'Silverado 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2001, 'Chevrolet', 'Silverado 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2001, 'Chevrolet', 'Silverado 3500', 'Crew Cab Pickup 4-Door'],
    [2001, 'Chevrolet', 'Silverado 3500', 'Extended Cab Pickup 4-Door'],
    [2001, 'Chevrolet', 'Silverado 3500', 'Standard Cab Pickup 2-Door'],
    [2001, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2001, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2001, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2001, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [2001, 'Chevrolet', 'Tracker', 'SUV 4-Door'],
    [2001, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [2001, 'Chrysler', '300M', 'Sedan 4-Door'],
    [2001, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [2001, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [2001, 'Chrysler', 'LHS', 'Sedan 4-Door'],
    [2001, 'Chrysler', 'Neon', 'Sedan 4-Door'],
    [2001, 'Chrysler', 'Prowler', 'Convertible 2-Door'],
    [2001, 'Chrysler', 'PT Cruiser', 'Wagon 4-Door'],
    [2001, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2001, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [2001, 'Chrysler', 'Sebring', 'Sedan 4-Door'],
    [2001, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2001, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2001, 'Daewoo', 'Lanos', 'Hatchback 2-Door'],
    [2001, 'Daewoo', 'Lanos', 'Sedan 4-Door'],
    [2001, 'Daewoo', 'Leganza', 'Sedan 4-Door'],
    [2001, 'Daewoo', 'Nubira', 'Sedan 4-Door'],
    [2001, 'Daewoo', 'Nubira', 'Wagon 5-Door'],
    [2001, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [2001, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2001, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [2001, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [2001, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2001, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2001, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [2001, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [2001, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 2-Door'],
    [2001, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 4-Door'],
    [2001, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2001, 'Dodge', 'Ram 1500 Van', 'Extended Cargo Van 3-Door'],
    [2001, 'Dodge', 'Ram 1500 Van', 'Standard Cargo Van 3-Door'],
    [2001, 'Dodge', 'Ram 1500 Van', 'Standard Passenger Van 3-Door'],
    [2001, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 2-Door'],
    [2001, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 4-Door'],
    [2001, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2001, 'Dodge', 'Ram 2500 Van', 'Extended Cargo Van 3-Door'],
    [2001, 'Dodge', 'Ram 2500 Van', 'Standard Cargo Van 3-Door'],
    [2001, 'Dodge', 'Ram 2500 Van', 'Standard Passenger Van 3-Door'],
    [2001, 'Dodge', 'Ram 3500', 'Extended Cab Pickup 4-Door'],
    [2001, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2001, 'Dodge', 'Ram 3500 Van', 'Extended Cargo Van 3-Door'],
    [2001, 'Dodge', 'Ram 3500 Van', 'Extended Passenger Van 3-Door'],
    [2001, 'Dodge', 'Ram 3500 Van', 'Standard Cargo Van 3-Door'],
    [2001, 'Dodge', 'Stratus', 'Coupe 2-Door'],
    [2001, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [2001, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2001, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2001, 'Ferrari', '360', 'Convertible 2-Door'],
    [2001, 'Ferrari', '360', 'Coupe 2-Door'],
    [2001, 'Ferrari', '456 M', 'Coupe 2-Door'],
    [2001, 'Ferrari', '550 Maranello', 'Coupe 2-Door'],
    [2001, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2001, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [2001, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [2001, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [2001, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [2001, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [2001, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [2001, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [2001, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [2001, 'Ford', 'Escape', 'SUV 4-Door'],
    [2001, 'Ford', 'Escort', 'Coupe 2-Door'],
    [2001, 'Ford', 'Escort', 'Sedan 4-Door'],
    [2001, 'Ford', 'Excursion', 'SUV 4-Door'],
    [2001, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2001, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2001, 'Ford', 'Explorer Sport', 'SUV 2-Door'],
    [2001, 'Ford', 'Explorer Sport Trac', 'Crew Cab Pickup 4-Door'],
    [2001, 'Ford', 'F-150', 'Crew Cab Pickup 4-Door'],
    [2001, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2001, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2001, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2001, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2001, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2001, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2001, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2001, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2001, 'Ford', 'Focus', 'Hatchback 2-Door'],
    [2001, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2001, 'Ford', 'Focus', 'Wagon 4-Door'],
    [2001, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2001, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2001, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2001, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2001, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2001, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2001, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [2001, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [2001, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [2001, 'Ford', 'Windstar', 'Mini Passenger Van 4-Door'],
    [2001, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [2001, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [2001, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [2001, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [2001, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2001, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2001, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2001, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [2001, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2001, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2001, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2001, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2001, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2001, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2001, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2001, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2001, 'GMC', 'Sierra 1500 HD', 'Crew Cab Pickup 4-Door'],
    [2001, 'GMC', 'Sierra 2500', 'Extended Cab Pickup 4-Door'],
    [2001, 'GMC', 'Sierra 2500', 'Standard Cab Pickup 2-Door'],
    [2001, 'GMC', 'Sierra 2500 HD', 'Crew Cab Pickup 4-Door'],
    [2001, 'GMC', 'Sierra 2500 HD', 'Extended Cab Pickup 4-Door'],
    [2001, 'GMC', 'Sierra 2500 HD', 'Standard Cab Pickup 2-Door'],
    [2001, 'GMC', 'Sierra 3500', 'Crew Cab Pickup 4-Door'],
    [2001, 'GMC', 'Sierra 3500', 'Extended Cab Pickup 4-Door'],
    [2001, 'GMC', 'Sierra 3500', 'Standard Cab Pickup 2-Door'],
    [2001, 'GMC', 'Sonoma', 'Crew Cab Pickup 4-Door'],
    [2001, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [2001, 'GMC', 'Sonoma', 'Extended Cab Pickup 3-Door'],
    [2001, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [2001, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2001, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2001, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2001, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2001, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2001, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2001, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2001, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2001, 'Honda', 'Insight', 'Hatchback 2-Door'],
    [2001, 'Honda', 'Odyssey', 'Mini Cargo Van 5-Door'],
    [2001, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [2001, 'Honda', 'Passport', 'SUV 4-Door'],
    [2001, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [2001, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2001, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2001, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2001, 'Hyundai', 'Elantra', 'Hatchback 4-Door'],
    [2001, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2001, 'Hyundai', 'Santa Fe', 'SUV 5-Door'],
    [2001, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2001, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [2001, 'Hyundai', 'XG300', 'Sedan 4-Door'],
    [2001, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [2001, 'INFINITI', 'I30', 'Sedan 4-Door'],
    [2001, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [2001, 'INFINITI', 'QX4', 'SUV 4-Door'],
    [2001, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [2001, 'Isuzu', 'Rodeo Sport', 'SUV 2-Door'],
    [2001, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [2001, 'Isuzu', 'VehiCROSS', 'SUV 2-Door'],
    [2001, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2001, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2001, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2001, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2001, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [2001, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [2001, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2001, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2001, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [2001, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2001, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2001, 'Jeep', 'TJ', 'SUV 2-Door'],
    [2001, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2001, 'Kia', 'Magentis', 'Sedan 4-Door'],
    [2001, 'Kia', 'Optima', 'Sedan 4-Door'],
    [2001, 'Kia', 'Rio', 'Sedan 4-Door'],
    [2001, 'Kia', 'Sephia', 'Sedan 4-Door'],
    [2001, 'Kia', 'Spectra', 'Hatchback 4-Door'],
    [2001, 'Kia', 'Sportage', 'Convertible 2-Door'],
    [2001, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2001, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [2001, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [2001, 'Lamborghini', 'Murcielago', 'Coupe 2-Door'],
    [2001, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2001, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2001, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [2001, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2001, 'Lexus', 'GS430', 'Sedan 4-Door'],
    [2001, 'Lexus', 'IS300', 'Sedan 4-Door'],
    [2001, 'Lexus', 'LS430', 'Sedan 4-Door'],
    [2001, 'Lexus', 'LX470', 'SUV 4-Door'],
    [2001, 'Lexus', 'RX300', 'SUV 4-Door'],
    [2001, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [2001, 'Lincoln', 'LS', 'Sedan 4-Door'],
    [2001, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2001, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2001, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2001, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [2001, 'Mazda', '626', 'Sedan 4-Door'],
    [2001, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [2001, 'Mazda', 'B2500', 'Standard Cab Pickup 2-Door'],
    [2001, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [2001, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [2001, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [2001, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2001, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [2001, 'Mazda', 'Millenia', 'Sedan 4-Door'],
    [2001, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [2001, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [2001, 'Mazda', 'Tribute', 'SUV 4-Door'],
    [2001, 'Mercedes-Benz', 'C240', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'C320', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [2001, 'Mercedes-Benz', 'CL55 AMG', 'Coupe 2-Door'],
    [2001, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [2001, 'Mercedes-Benz', 'CLK320', 'Convertible 2-Door'],
    [2001, 'Mercedes-Benz', 'CLK320', 'Coupe 2-Door'],
    [2001, 'Mercedes-Benz', 'CLK430', 'Convertible 2-Door'],
    [2001, 'Mercedes-Benz', 'CLK430', 'Coupe 2-Door'],
    [2001, 'Mercedes-Benz', 'CLK55 AMG', 'Coupe 2-Door'],
    [2001, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [2001, 'Mercedes-Benz', 'E430', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'E55 AMG', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [2001, 'Mercedes-Benz', 'ML430', 'SUV 4-Door'],
    [2001, 'Mercedes-Benz', 'ML55 AMG', 'SUV 4-Door'],
    [2001, 'Mercedes-Benz', 'S430', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'S55 AMG', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [2001, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [2001, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2001, 'Mercedes-Benz', 'SLK230', 'Convertible 2-Door'],
    [2001, 'Mercedes-Benz', 'SLK320', 'Convertible 2-Door'],
    [2001, 'Mercury', 'Cougar', 'Coupe 2-Door'],
    [2001, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2001, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2001, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [2001, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [2001, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [2001, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [2001, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [2001, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2001, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2001, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [2001, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [2001, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [2001, 'Mitsubishi', 'Montero Sport', 'SUV 4-Door'],
    [2001, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2001, 'Nissan', 'Altra EV', 'Wagon 4-Door'],
    [2001, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2001, 'Nissan', 'Frontier', 'Extended Cab Pickup 2-Door'],
    [2001, 'Nissan', 'Frontier', 'Standard Cab Pickup 2-Door'],
    [2001, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2001, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2001, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2001, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2001, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2001, 'Oldsmobile', 'Alero', 'Coupe 2-Door'],
    [2001, 'Oldsmobile', 'Alero', 'Sedan 4-Door'],
    [2001, 'Oldsmobile', 'Aurora', 'Sedan 4-Door'],
    [2001, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [2001, 'Oldsmobile', 'Intrigue', 'Sedan 4-Door'],
    [2001, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 4-Door'],
    [2001, 'Panoz', 'Esperante', 'Convertible 2-Door'],
    [2001, 'Plymouth', 'Neon', 'Sedan 4-Door'],
    [2001, 'Plymouth', 'Prowler', 'Convertible 2-Door'],
    [2001, 'Pontiac', 'Aztek', 'SUV 4-Door'],
    [2001, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [2001, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [2001, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [2001, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [2001, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [2001, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [2001, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2001, 'Pontiac', 'Montana', 'Mini Cargo Van 4-Door'],
    [2001, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2001, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [2001, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [2001, 'Porsche', '911', 'Convertible 2-Door'],
    [2001, 'Porsche', '911', 'Coupe 2-Door'],
    [2001, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2001, 'Qvale', 'Mangusta', 'Convertible 2-Door'],
    [2001, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [2001, 'Rolls-Royce', 'Silver Seraph', 'Sedan 4-Door'],
    [2001, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2001, 'Saab', '3-Sep', 'Hatchback 2-Door'],
    [2001, 'Saab', '3-Sep', 'Hatchback 4-Door'],
    [2001, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2001, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2001, 'Saturn', 'L100', 'Sedan 4-Door'],
    [2001, 'Saturn', 'L200', 'Sedan 4-Door'],
    [2001, 'Saturn', 'L300', 'Sedan 4-Door'],
    [2001, 'Saturn', 'LW200', 'Wagon 4-Door'],
    [2001, 'Saturn', 'LW300', 'Wagon 4-Door'],
    [2001, 'Saturn', 'SC1', 'Coupe 3-Door'],
    [2001, 'Saturn', 'SC2', 'Coupe 3-Door'],
    [2001, 'Saturn', 'SL', 'Sedan 4-Door'],
    [2001, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [2001, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [2001, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [2001, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2001, 'Subaru', 'Impreza', 'Coupe 2-Door'],
    [2001, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2001, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [2001, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2001, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2001, 'Subaru', 'Outback', 'Sedan 4-Door'],
    [2001, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2001, 'Suzuki', 'Esteem', 'Sedan 4-Door'],
    [2001, 'Suzuki', 'Esteem', 'Wagon 5-Door'],
    [2001, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2001, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [2001, 'Suzuki', 'Vitara', 'SUV 2-Door'],
    [2001, 'Suzuki', 'Vitara', 'SUV 4-Door'],
    [2001, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2001, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2001, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2001, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [2001, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2001, 'Toyota', 'Echo', 'Sedan 2-Door'],
    [2001, 'Toyota', 'Echo', 'Sedan 4-Door'],
    [2001, 'Toyota', 'Highlander', 'SUV 4-Door'],
    [2001, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2001, 'Toyota', 'MR2 Spyder', 'Convertible 2-Door'],
    [2001, 'Toyota', 'Prius', 'Sedan 4-Door'],
    [2001, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2001, 'Toyota', 'Sequoia', 'SUV 4-Door'],
    [2001, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2001, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2001, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2001, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2001, 'Toyota', 'Tacoma', 'Crew Cab Pickup 4-Door'],
    [2001, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [2001, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2001, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2001, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2001, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2001, 'Volkswagen', 'Cabrio', 'Convertible 2-Door'],
    [2001, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [2001, 'Volkswagen', 'EuroVan', 'Van Camper 3-Door'],
    [2001, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2001, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2001, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2001, 'Volkswagen', 'Jetta', 'Wagon 4-Door'],
    [2001, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2001, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2001, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2001, 'Volvo', 'C70', 'Coupe 2-Door'],
    [2001, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2001, 'Volvo', 'S60', 'Sedan 4-Door'],
    [2001, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2001, 'Volvo', 'V40', 'Wagon 4-Door'],
    [2001, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2001, 'Workhorse', 'FasTrack FT1260', 'Standard Cargo Van 2-Door'],
    [2001, 'Workhorse', 'FasTrack FT1460', 'Standard Cargo Van 2-Door'],
    [2001, 'Workhorse', 'FasTrack FT1600', 'Standard Cargo Van 2-Door'],
    [2001, 'Workhorse', 'FasTrack FT1800', 'Standard Cargo Van 2-Door'],
    [2000, 'Acura', 'EL', 'Sedan 4-Door'],
    [2000, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [2000, 'Acura', 'Integra', 'Sedan 4-Door'],
    [2000, 'Acura', 'NSX', 'Coupe 2-Door'],
    [2000, 'Acura', 'RL', 'Sedan 4-Door'],
    [2000, 'Acura', 'TL', 'Sedan 4-Door'],
    [2000, 'AM General', 'Hummer', 'SUV 2-Door'],
    [2000, 'AM General', 'Hummer', 'SUV 4-Door'],
    [2000, 'Aston Martin', 'DB7', 'Convertible 2-Door'],
    [2000, 'Aston Martin', 'DB7', 'Coupe 2-Door'],
    [2000, 'Audi', 'A4', 'Sedan 4-Door'],
    [2000, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [2000, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [2000, 'Audi', 'A6', 'Sedan 4-Door'],
    [2000, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [2000, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [2000, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [2000, 'Audi', 'S4', 'Sedan 4-Door'],
    [2000, 'Audi', 'TT', 'Coupe 2-Door'],
    [2000, 'Audi', 'TT Quattro', 'Coupe 2-Door'],
    [2000, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [2000, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [2000, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [2000, 'BMW', '323Ci', 'Convertible 2-Door'],
    [2000, 'BMW', '323Ci', 'Coupe 2-Door'],
    [2000, 'BMW', '323i', 'Sedan 4-Door'],
    [2000, 'BMW', '323i', 'Wagon 4-Door'],
    [2000, 'BMW', '328Ci', 'Coupe 2-Door'],
    [2000, 'BMW', '328i', 'Sedan 4-Door'],
    [2000, 'BMW', '528i', 'Sedan 4-Door'],
    [2000, 'BMW', '528i', 'Wagon 4-Door'],
    [2000, 'BMW', '540i', 'Sedan 4-Door'],
    [2000, 'BMW', '540i', 'Wagon 4-Door'],
    [2000, 'BMW', '740i', 'Sedan 4-Door'],
    [2000, 'BMW', '740iL', 'Sedan 4-Door'],
    [2000, 'BMW', '750iL', 'Sedan 4-Door'],
    [2000, 'BMW', 'M5', 'Sedan 4-Door'],
    [2000, 'BMW', 'X5', 'SUV 4-Door'],
    [2000, 'BMW', 'Z3', 'Convertible 2-Door'],
    [2000, 'BMW', 'Z3', 'Coupe 2-Door'],
    [2000, 'BMW', 'Z8', 'Convertible 2-Door'],
    [2000, 'Buick', 'Century', 'Sedan 4-Door'],
    [2000, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [2000, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [2000, 'Buick', 'Regal', 'Sedan 4-Door'],
    [2000, 'Cadillac', 'Catera', 'Sedan 4-Door'],
    [2000, 'Cadillac', 'DeVille', 'Hearse 4-Door'],
    [2000, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [2000, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [2000, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [2000, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [2000, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [2000, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [2000, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [2000, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [2000, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [2000, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [2000, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [2000, 'Chevrolet', 'C2500', 'Crew Cab Pickup 4-Door'],
    [2000, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [2000, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [2000, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [2000, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [2000, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [2000, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [2000, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [2000, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [2000, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [2000, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [2000, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [2000, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [2000, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [2000, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [2000, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [2000, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [2000, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [2000, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [2000, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [2000, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [2000, 'Chevrolet', 'K2500', 'Crew Cab Pickup 4-Door'],
    [2000, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [2000, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [2000, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [2000, 'Chevrolet', 'Metro', 'Hatchback 2-Door'],
    [2000, 'Chevrolet', 'Metro', 'Sedan 4-Door'],
    [2000, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [2000, 'Chevrolet', 'Prizm', 'Sedan 4-Door'],
    [2000, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [2000, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 3-Door'],
    [2000, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 4-Door'],
    [2000, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'Silverado 2500', 'Extended Cab Pickup 3-Door'],
    [2000, 'Chevrolet', 'Silverado 2500', 'Extended Cab Pickup 4-Door'],
    [2000, 'Chevrolet', 'Silverado 2500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Chevrolet', 'Suburban 1500', 'SUV 4-Door'],
    [2000, 'Chevrolet', 'Suburban 2500', 'SUV 4-Door'],
    [2000, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [2000, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [2000, 'Chevrolet', 'Tracker', 'SUV 4-Door'],
    [2000, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [2000, 'Chrysler', '300M', 'Sedan 4-Door'],
    [2000, 'Chrysler', 'Cirrus', 'Sedan 4-Door'],
    [2000, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [2000, 'Chrysler', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [2000, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [2000, 'Chrysler', 'LHS', 'Sedan 4-Door'],
    [2000, 'Chrysler', 'Neon', 'Sedan 4-Door'],
    [2000, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [2000, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [2000, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [2000, 'Chrysler', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2000, 'Daewoo', 'Lanos', 'Hatchback 2-Door'],
    [2000, 'Daewoo', 'Lanos', 'Sedan 4-Door'],
    [2000, 'Daewoo', 'Leganza', 'Sedan 4-Door'],
    [2000, 'Daewoo', 'Nubira', 'Sedan 4-Door'],
    [2000, 'Daewoo', 'Nubira', 'Wagon 5-Door'],
    [2000, 'Dodge', 'Avenger', 'Coupe 2-Door'],
    [2000, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [2000, 'Dodge', 'Dakota', 'Crew Cab Pickup 4-Door'],
    [2000, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [2000, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [2000, 'Dodge', 'Durango', 'SUV 4-Door'],
    [2000, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [2000, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [2000, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [2000, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [2000, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 2-Door'],
    [2000, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 4-Door'],
    [2000, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Dodge', 'Ram 1500 Van', 'Extended Cargo Van 3-Door'],
    [2000, 'Dodge', 'Ram 1500 Van', 'Standard Cargo Van 3-Door'],
    [2000, 'Dodge', 'Ram 1500 Van', 'Standard Passenger Van 3-Door'],
    [2000, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 2-Door'],
    [2000, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 4-Door'],
    [2000, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Dodge', 'Ram 2500 Van', 'Extended Cargo Van 3-Door'],
    [2000, 'Dodge', 'Ram 2500 Van', 'Standard Cargo Van 3-Door'],
    [2000, 'Dodge', 'Ram 2500 Van', 'Standard Passenger Van 3-Door'],
    [2000, 'Dodge', 'Ram 3500', 'Extended Cab Pickup 4-Door'],
    [2000, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Dodge', 'Ram 3500 Van', 'Extended Cargo Van 3-Door'],
    [2000, 'Dodge', 'Ram 3500 Van', 'Extended Passenger Van 3-Door'],
    [2000, 'Dodge', 'Ram 3500 Van', 'Standard Cargo Van 3-Door'],
    [2000, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [2000, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [2000, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [2000, 'Ferrari', '360', 'Coupe 2-Door'],
    [2000, 'Ferrari', '456 M', 'Coupe 2-Door'],
    [2000, 'Ferrari', '550 Maranello', 'Coupe 2-Door'],
    [2000, 'Ford', 'Contour', 'Sedan 4-Door'],
    [2000, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [2000, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [2000, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [2000, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [2000, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [2000, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [2000, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [2000, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [2000, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [2000, 'Ford', 'Escort', 'Coupe 2-Door'],
    [2000, 'Ford', 'Escort', 'Sedan 4-Door'],
    [2000, 'Ford', 'Excursion', 'SUV 4-Door'],
    [2000, 'Ford', 'Expedition', 'SUV 4-Door'],
    [2000, 'Ford', 'Explorer', 'SUV 2-Door'],
    [2000, 'Ford', 'Explorer', 'SUV 4-Door'],
    [2000, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [2000, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [2000, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2000, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2000, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2000, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [2000, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [2000, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [2000, 'Ford', 'Focus', 'Hatchback 2-Door'],
    [2000, 'Ford', 'Focus', 'Sedan 4-Door'],
    [2000, 'Ford', 'Focus', 'Wagon 4-Door'],
    [2000, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [2000, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [2000, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [2000, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [2000, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [2000, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [2000, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [2000, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [2000, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [2000, 'Ford', 'Windstar', 'Mini Passenger Van 4-Door'],
    [2000, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [2000, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [2000, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [2000, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [2000, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [2000, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [2000, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [2000, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [2000, 'GMC', 'K2500', 'Crew Cab Pickup 4-Door'],
    [2000, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [2000, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [2000, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [2000, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [2000, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [2000, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [2000, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [2000, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [2000, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [2000, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [2000, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [2000, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [2000, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [2000, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [2000, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [2000, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [2000, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [2000, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [2000, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 3-Door'],
    [2000, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 4-Door'],
    [2000, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [2000, 'GMC', 'Sierra 2500', 'Extended Cab Pickup 3-Door'],
    [2000, 'GMC', 'Sierra 2500', 'Extended Cab Pickup 4-Door'],
    [2000, 'GMC', 'Sierra 2500', 'Standard Cab Pickup 2-Door'],
    [2000, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [2000, 'GMC', 'Sonoma', 'Extended Cab Pickup 3-Door'],
    [2000, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [2000, 'GMC', 'Yukon', 'SUV 4-Door'],
    [2000, 'GMC', 'Yukon XL 1500', 'SUV 4-Door'],
    [2000, 'GMC', 'Yukon XL 2500', 'SUV 4-Door'],
    [2000, 'Honda', 'Accord', 'Coupe 2-Door'],
    [2000, 'Honda', 'Accord', 'Sedan 4-Door'],
    [2000, 'Honda', 'Civic', 'Coupe 2-Door'],
    [2000, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [2000, 'Honda', 'Civic', 'Sedan 4-Door'],
    [2000, 'Honda', 'CR-V', 'SUV 4-Door'],
    [2000, 'Honda', 'Insight', 'Hatchback 2-Door'],
    [2000, 'Honda', 'Odyssey', 'Mini Cargo Van 5-Door'],
    [2000, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [2000, 'Honda', 'Passport', 'SUV 4-Door'],
    [2000, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [2000, 'Honda', 'S2000', 'Convertible 2-Door'],
    [2000, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [2000, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [2000, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [2000, 'Hyundai', 'Elantra', 'Wagon 5-Door'],
    [2000, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [2000, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [2000, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [2000, 'INFINITI', 'I30', 'Sedan 4-Door'],
    [2000, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [2000, 'INFINITI', 'QX4', 'SUV 4-Door'],
    [2000, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [2000, 'Isuzu', 'Hombre', 'Extended Cab Pickup 2-Door'],
    [2000, 'Isuzu', 'Hombre', 'Standard Cab Pickup 2-Door'],
    [2000, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [2000, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [2000, 'Isuzu', 'VehiCROSS', 'SUV 2-Door'],
    [2000, 'Jaguar', 'S-Type', 'Sedan 4-Door'],
    [2000, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [2000, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [2000, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [2000, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [2000, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [2000, 'Jaguar', 'XKR', 'Convertible 2-Door'],
    [2000, 'Jaguar', 'XKR', 'Coupe 2-Door'],
    [2000, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [2000, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [2000, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [2000, 'Jeep', 'TJ', 'SUV 2-Door'],
    [2000, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [2000, 'Kia', 'Sephia', 'Sedan 4-Door'],
    [2000, 'Kia', 'Spectra', 'Hatchback 4-Door'],
    [2000, 'Kia', 'Sportage', 'Convertible 2-Door'],
    [2000, 'Kia', 'Sportage', 'SUV 4-Door'],
    [2000, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [2000, 'Lamborghini', 'Diablo', 'Convertible 2-Door'],
    [2000, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [2000, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [2000, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [2000, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [2000, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [2000, 'Lexus', 'GS400', 'Sedan 4-Door'],
    [2000, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [2000, 'Lexus', 'LX470', 'SUV 4-Door'],
    [2000, 'Lexus', 'RX300', 'SUV 4-Door'],
    [2000, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [2000, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [2000, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [2000, 'Lincoln', 'LS', 'Sedan 4-Door'],
    [2000, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [2000, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [2000, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [2000, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [2000, 'Mazda', '626', 'Sedan 4-Door'],
    [2000, 'Mazda', 'B2500', 'Extended Cab Pickup 2-Door'],
    [2000, 'Mazda', 'B2500', 'Standard Cab Pickup 2-Door'],
    [2000, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [2000, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [2000, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [2000, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [2000, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [2000, 'Mazda', 'Millenia', 'Sedan 4-Door'],
    [2000, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [2000, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [2000, 'Mercedes-Benz', 'CLK320', 'Convertible 2-Door'],
    [2000, 'Mercedes-Benz', 'CLK320', 'Coupe 2-Door'],
    [2000, 'Mercedes-Benz', 'CLK430', 'Convertible 2-Door'],
    [2000, 'Mercedes-Benz', 'CLK430', 'Coupe 2-Door'],
    [2000, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [2000, 'Mercedes-Benz', 'E430', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'E55 AMG', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [2000, 'Mercedes-Benz', 'ML430', 'SUV 4-Door'],
    [2000, 'Mercedes-Benz', 'ML55 AMG', 'SUV 4-Door'],
    [2000, 'Mercedes-Benz', 'S430', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [2000, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [2000, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [2000, 'Mercedes-Benz', 'SLK230', 'Convertible 2-Door'],
    [2000, 'Mercury', 'Cougar', 'Coupe 2-Door'],
    [2000, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [2000, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [2000, 'Mercury', 'Mystique', 'Sedan 4-Door'],
    [2000, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [2000, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [2000, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [2000, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [2000, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [2000, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [2000, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [2000, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [2000, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [2000, 'Mitsubishi', 'Montero Sport', 'SUV 4-Door'],
    [2000, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [2000, 'Nissan', 'Altra EV', 'Wagon 4-Door'],
    [2000, 'Nissan', 'Frontier', 'Crew Cab Pickup 4-Door'],
    [2000, 'Nissan', 'Frontier', 'Extended Cab Pickup 2-Door'],
    [2000, 'Nissan', 'Frontier', 'Standard Cab Pickup 2-Door'],
    [2000, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [2000, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [2000, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [2000, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [2000, 'Nissan', 'Xterra', 'SUV 4-Door'],
    [2000, 'Oldsmobile', 'Alero', 'Coupe 2-Door'],
    [2000, 'Oldsmobile', 'Alero', 'Sedan 4-Door'],
    [2000, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [2000, 'Oldsmobile', 'Intrigue', 'Sedan 4-Door'],
    [2000, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 4-Door'],
    [2000, 'Panoz', 'AIV Roadster', 'Convertible 2-Door'],
    [2000, 'Plymouth', 'Breeze', 'Sedan 4-Door'],
    [2000, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [2000, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 4-Door'],
    [2000, 'Plymouth', 'Neon', 'Sedan 4-Door'],
    [2000, 'Plymouth', 'Prowler', 'Convertible 2-Door'],
    [2000, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [2000, 'Plymouth', 'Voyager', 'Mini Passenger Van 4-Door'],
    [2000, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [2000, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [2000, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [2000, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [2000, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [2000, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [2000, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [2000, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [2000, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [2000, 'Pontiac', 'Montana', 'Mini Cargo Van 4-Door'],
    [2000, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [2000, 'Pontiac', 'Sunfire', 'Convertible 2-Door'],
    [2000, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [2000, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [2000, 'Porsche', '911', 'Convertible 2-Door'],
    [2000, 'Porsche', '911', 'Coupe 2-Door'],
    [2000, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [2000, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [2000, 'Rolls-Royce', 'Silver Seraph', 'Sedan 4-Door'],
    [2000, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [2000, 'Saab', '3-Sep', 'Hatchback 2-Door'],
    [2000, 'Saab', '3-Sep', 'Hatchback 4-Door'],
    [2000, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [2000, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [2000, 'Saturn', 'LS', 'Sedan 4-Door'],
    [2000, 'Saturn', 'LS1', 'Sedan 4-Door'],
    [2000, 'Saturn', 'LS2', 'Sedan 4-Door'],
    [2000, 'Saturn', 'LW1', 'Wagon 4-Door'],
    [2000, 'Saturn', 'LW2', 'Wagon 4-Door'],
    [2000, 'Saturn', 'SC1', 'Coupe 3-Door'],
    [2000, 'Saturn', 'SC2', 'Coupe 3-Door'],
    [2000, 'Saturn', 'SL', 'Sedan 4-Door'],
    [2000, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [2000, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [2000, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [2000, 'Shelby', 'Series 1', 'Coupe 2-Door'],
    [2000, 'Subaru', 'Forester', 'SUV 4-Door'],
    [2000, 'Subaru', 'Impreza', 'Coupe 2-Door'],
    [2000, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [2000, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [2000, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [2000, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [2000, 'Subaru', 'Outback', 'Sedan 4-Door'],
    [2000, 'Subaru', 'Outback', 'Wagon 4-Door'],
    [2000, 'Suzuki', 'Esteem', 'Sedan 4-Door'],
    [2000, 'Suzuki', 'Esteem', 'Wagon 5-Door'],
    [2000, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [2000, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [2000, 'Suzuki', 'Vitara', 'SUV 2-Door'],
    [2000, 'Suzuki', 'Vitara', 'SUV 4-Door'],
    [2000, 'Toyota', '4Runner', 'SUV 4-Door'],
    [2000, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [2000, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [2000, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [2000, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [2000, 'Toyota', 'Echo', 'Sedan 2-Door'],
    [2000, 'Toyota', 'Echo', 'Sedan 4-Door'],
    [2000, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [2000, 'Toyota', 'MR2 Spyder', 'Convertible 2-Door'],
    [2000, 'Toyota', 'RAV4', 'SUV 2-Door'],
    [2000, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [2000, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [2000, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [2000, 'Toyota', 'Solara', 'Convertible 2-Door'],
    [2000, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [2000, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [2000, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [2000, 'Toyota', 'Tundra', 'Extended Cab Pickup 4-Door'],
    [2000, 'Toyota', 'Tundra', 'Standard Cab Pickup 2-Door'],
    [2000, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [2000, 'Volkswagen', 'Cabrio', 'Convertible 2-Door'],
    [2000, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [2000, 'Volkswagen', 'EuroVan', 'Van Camper 3-Door'],
    [2000, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [2000, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [2000, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [2000, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [2000, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [2000, 'Volvo', 'C70', 'Convertible 2-Door'],
    [2000, 'Volvo', 'C70', 'Coupe 2-Door'],
    [2000, 'Volvo', 'S40', 'Sedan 4-Door'],
    [2000, 'Volvo', 'S70', 'Sedan 4-Door'],
    [2000, 'Volvo', 'S80', 'Sedan 4-Door'],
    [2000, 'Volvo', 'V40', 'Wagon 4-Door'],
    [2000, 'Volvo', 'V70', 'Wagon 4-Door'],
    [2000, 'Workhorse', 'FasTrack FT1260', 'Standard Cargo Van 2-Door'],
    [2000, 'Workhorse', 'FasTrack FT1460', 'Standard Cargo Van 2-Door'],
    [2000, 'Workhorse', 'FasTrack FT1600', 'Standard Cargo Van 2-Door'],
    [2000, 'Workhorse', 'FasTrack FT1800', 'Standard Cargo Van 2-Door'],
    [1999, 'Acura', 'CL', 'Coupe 2-Door'],
    [1999, 'Acura', 'EL', 'Sedan 4-Door'],
    [1999, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1999, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1999, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1999, 'Acura', 'RL', 'Sedan 4-Door'],
    [1999, 'Acura', 'SLX', 'SUV 4-Door'],
    [1999, 'Acura', 'TL', 'Sedan 4-Door'],
    [1999, 'AM General', 'Hummer', 'SUV 2-Door'],
    [1999, 'AM General', 'Hummer', 'SUV 4-Door'],
    [1999, 'Audi', 'A4', 'Sedan 4-Door'],
    [1999, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [1999, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [1999, 'Audi', 'A6', 'Sedan 4-Door'],
    [1999, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [1999, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [1999, 'Audi', 'A8', 'Sedan 4-Door'],
    [1999, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [1999, 'Bentley', 'Arnage', 'Sedan 4-Door'],
    [1999, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [1999, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [1999, 'BMW', '318i', 'Convertible 2-Door'],
    [1999, 'BMW', '318is', 'Coupe 2-Door'],
    [1999, 'BMW', '318ti', 'Hatchback 2-Door'],
    [1999, 'BMW', '323i', 'Convertible 2-Door'],
    [1999, 'BMW', '323i', 'Sedan 4-Door'],
    [1999, 'BMW', '323is', 'Coupe 2-Door'],
    [1999, 'BMW', '328i', 'Convertible 2-Door'],
    [1999, 'BMW', '328i', 'Sedan 4-Door'],
    [1999, 'BMW', '328is', 'Coupe 2-Door'],
    [1999, 'BMW', '528i', 'Sedan 4-Door'],
    [1999, 'BMW', '528i', 'Wagon 4-Door'],
    [1999, 'BMW', '540i', 'Sedan 4-Door'],
    [1999, 'BMW', '540i', 'Wagon 4-Door'],
    [1999, 'BMW', '740i', 'Sedan 4-Door'],
    [1999, 'BMW', '740iL', 'Sedan 4-Door'],
    [1999, 'BMW', '750iL', 'Sedan 4-Door'],
    [1999, 'BMW', 'M3', 'Convertible 2-Door'],
    [1999, 'BMW', 'M3', 'Coupe 2-Door'],
    [1999, 'BMW', 'Z3', 'Convertible 2-Door'],
    [1999, 'BMW', 'Z3', 'Coupe 2-Door'],
    [1999, 'Buick', 'Century', 'Sedan 4-Door'],
    [1999, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1999, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1999, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1999, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1999, 'Cadillac', 'Catera', 'Sedan 4-Door'],
    [1999, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1999, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1999, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1999, 'Cadillac', 'Escalade', 'SUV 4-Door'],
    [1999, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1999, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1999, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1999, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1999, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1999, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1999, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [1999, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1999, 'Chevrolet', 'C1500 Suburban', 'SUV 4-Door'],
    [1999, 'Chevrolet', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1999, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'C2500 Suburban', 'SUV 4-Door'],
    [1999, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1999, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1999, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1999, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1999, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1999, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1999, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1999, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1999, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1999, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [1999, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [1999, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [1999, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [1999, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [1999, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [1999, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [1999, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [1999, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [1999, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [1999, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1999, 'Chevrolet', 'K1500 Suburban', 'SUV 4-Door'],
    [1999, 'Chevrolet', 'K2500', 'Crew Cab Pickup 4-Door'],
    [1999, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'K2500 Suburban', 'SUV 4-Door'],
    [1999, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1999, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1999, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1999, 'Chevrolet', 'Metro', 'Hatchback 2-Door'],
    [1999, 'Chevrolet', 'Metro', 'Sedan 4-Door'],
    [1999, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1999, 'Chevrolet', 'Prizm', 'Sedan 4-Door'],
    [1999, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [1999, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'Silverado 1500', 'Extended Cab Pickup 3-Door'],
    [1999, 'Chevrolet', 'Silverado 1500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'Silverado 2500', 'Extended Cab Pickup 3-Door'],
    [1999, 'Chevrolet', 'Silverado 2500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Chevrolet', 'Tahoe', 'SUV 2-Door'],
    [1999, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [1999, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [1999, 'Chevrolet', 'Tracker', 'SUV 4-Door'],
    [1999, 'Chevrolet', 'Venture', 'Mini Passenger Van 3-Door'],
    [1999, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [1999, 'Chrysler', '300M', 'Sedan 4-Door'],
    [1999, 'Chrysler', 'Cirrus', 'Sedan 4-Door'],
    [1999, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [1999, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [1999, 'Chrysler', 'LHS', 'Sedan 4-Door'],
    [1999, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [1999, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [1999, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [1999, 'Daewoo', 'Lanos', 'Hatchback 2-Door'],
    [1999, 'Daewoo', 'Lanos', 'Sedan 4-Door'],
    [1999, 'Daewoo', 'Leganza', 'Sedan 4-Door'],
    [1999, 'Daewoo', 'Nubira', 'Hatchback 4-Door'],
    [1999, 'Daewoo', 'Nubira', 'Sedan 4-Door'],
    [1999, 'Daewoo', 'Nubira', 'Wagon 5-Door'],
    [1999, 'Dodge', 'Avenger', 'Coupe 2-Door'],
    [1999, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [1999, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1999, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1999, 'Dodge', 'Durango', 'SUV 4-Door'],
    [1999, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [1999, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [1999, 'Dodge', 'Neon', 'Coupe 2-Door'],
    [1999, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [1999, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [1999, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 4-Door'],
    [1999, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Dodge', 'Ram 1500 Van', 'Extended Cargo Van 3-Door'],
    [1999, 'Dodge', 'Ram 1500 Van', 'Standard Cargo Van 3-Door'],
    [1999, 'Dodge', 'Ram 1500 Van', 'Standard Passenger Van 3-Door'],
    [1999, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 4-Door'],
    [1999, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Dodge', 'Ram 2500 Van', 'Extended Cargo Van 3-Door'],
    [1999, 'Dodge', 'Ram 2500 Van', 'Standard Cargo Van 3-Door'],
    [1999, 'Dodge', 'Ram 2500 Van', 'Standard Passenger Van 3-Door'],
    [1999, 'Dodge', 'Ram 3500', 'Extended Cab Pickup 4-Door'],
    [1999, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Dodge', 'Ram 3500 Van', 'Extended Cargo Van 3-Door'],
    [1999, 'Dodge', 'Ram 3500 Van', 'Extended Passenger Van 3-Door'],
    [1999, 'Dodge', 'Ram 3500 Van', 'Standard Cargo Van 3-Door'],
    [1999, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [1999, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [1999, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [1999, 'Ferrari', '456 M', 'Coupe 2-Door'],
    [1999, 'Ferrari', '550 Maranello', 'Coupe 2-Door'],
    [1999, 'Ferrari', 'F355', 'Coupe 2-Door'],
    [1999, 'Ferrari', 'F355 Spider', 'Convertible 2-Door'],
    [1999, 'Ford', 'Contour', 'Sedan 4-Door'],
    [1999, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [1999, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1999, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1999, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1999, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1999, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1999, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1999, 'Ford', 'E-350 Super Duty', 'Extended Cargo Van 2-Door'],
    [1999, 'Ford', 'E-350 Super Duty', 'Standard Cargo Van 2-Door'],
    [1999, 'Ford', 'Escort', 'Coupe 2-Door'],
    [1999, 'Ford', 'Escort', 'Sedan 4-Door'],
    [1999, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1999, 'Ford', 'Expedition', 'SUV 4-Door'],
    [1999, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1999, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1999, 'Ford', 'F-150', 'Extended Cab Pickup 4-Door'],
    [1999, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1999, 'Ford', 'F-250', 'Extended Cab Pickup 3-Door'],
    [1999, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1999, 'Ford', 'F-250 Super Duty', 'Crew Cab Pickup 4-Door'],
    [1999, 'Ford', 'F-250 Super Duty', 'Extended Cab Pickup 4-Door'],
    [1999, 'Ford', 'F-250 Super Duty', 'Standard Cab Pickup 2-Door'],
    [1999, 'Ford', 'F-350 Super Duty', 'Crew Cab Pickup 4-Door'],
    [1999, 'Ford', 'F-350 Super Duty', 'Extended Cab Pickup 4-Door'],
    [1999, 'Ford', 'F-350 Super Duty', 'Standard Cab Pickup 2-Door'],
    [1999, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1999, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [1999, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1999, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [1999, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1999, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1999, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1999, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [1999, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [1999, 'Ford', 'Windstar', 'Mini Passenger Van 4-Door'],
    [1999, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1999, 'GMC', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1999, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1999, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1999, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1999, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1999, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1999, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1999, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1999, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1999, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1999, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1999, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [1999, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1999, 'GMC', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1999, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1999, 'GMC', 'K2500', 'Crew Cab Pickup 4-Door'],
    [1999, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1999, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1999, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1999, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1999, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1999, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1999, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1999, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1999, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [1999, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [1999, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [1999, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [1999, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [1999, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [1999, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [1999, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [1999, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [1999, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [1999, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 2-Door'],
    [1999, 'GMC', 'Sierra 1500', 'Extended Cab Pickup 3-Door'],
    [1999, 'GMC', 'Sierra 1500', 'Standard Cab Pickup 2-Door'],
    [1999, 'GMC', 'Sierra 2500', 'Extended Cab Pickup 3-Door'],
    [1999, 'GMC', 'Sierra 2500', 'Standard Cab Pickup 2-Door'],
    [1999, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1999, 'GMC', 'Sonoma', 'Extended Cab Pickup 3-Door'],
    [1999, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1999, 'GMC', 'Yukon', 'SUV 4-Door'],
    [1999, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1999, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1999, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1999, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1999, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1999, 'Honda', 'CR-V', 'SUV 4-Door'],
    [1999, 'Honda', 'EV Plus', 'Hatchback 2-Door'],
    [1999, 'Honda', 'Odyssey', 'Mini Cargo Van 5-Door'],
    [1999, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [1999, 'Honda', 'Passport', 'SUV 4-Door'],
    [1999, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1999, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [1999, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [1999, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [1999, 'Hyundai', 'Elantra', 'Wagon 5-Door'],
    [1999, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1999, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [1999, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [1999, 'INFINITI', 'I30', 'Sedan 4-Door'],
    [1999, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1999, 'INFINITI', 'QX4', 'SUV 4-Door'],
    [1999, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [1999, 'Isuzu', 'Hombre', 'Extended Cab Pickup 2-Door'],
    [1999, 'Isuzu', 'Hombre', 'Standard Cab Pickup 2-Door'],
    [1999, 'Isuzu', 'Oasis', 'Mini Passenger Van 5-Door'],
    [1999, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1999, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1999, 'Isuzu', 'VehiCROSS', 'SUV 2-Door'],
    [1999, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1999, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [1999, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [1999, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [1999, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [1999, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1999, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1999, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [1999, 'Jeep', 'TJ', 'SUV 2-Door'],
    [1999, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1999, 'Kia', 'Sephia', 'Sedan 4-Door'],
    [1999, 'Kia', 'Sportage', 'Convertible 2-Door'],
    [1999, 'Kia', 'Sportage', 'SUV 4-Door'],
    [1999, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1999, 'Lamborghini', 'Diablo', 'Convertible 2-Door'],
    [1999, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1999, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [1999, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1999, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [1999, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [1999, 'Lexus', 'GS400', 'Sedan 4-Door'],
    [1999, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1999, 'Lexus', 'LX470', 'SUV 4-Door'],
    [1999, 'Lexus', 'RX300', 'SUV 4-Door'],
    [1999, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [1999, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [1999, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1999, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [1999, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1999, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1999, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1999, 'Mazda', '626', 'Sedan 4-Door'],
    [1999, 'Mazda', 'B2500', 'Extended Cab Pickup 2-Door'],
    [1999, 'Mazda', 'B2500', 'Extended Cab Pickup 4-Door'],
    [1999, 'Mazda', 'B2500', 'Standard Cab Pickup 2-Door'],
    [1999, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [1999, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [1999, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [1999, 'Mazda', 'B4000', 'Extended Cab Pickup 2-Door'],
    [1999, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [1999, 'Mazda', 'B4000', 'Standard Cab Pickup 2-Door'],
    [1999, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1999, 'Mazda', 'Millenia', 'Sedan 4-Door'],
    [1999, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [1999, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [1999, 'Mercedes-Benz', 'CLK320', 'Convertible 2-Door'],
    [1999, 'Mercedes-Benz', 'CLK320', 'Coupe 2-Door'],
    [1999, 'Mercedes-Benz', 'CLK430', 'Coupe 2-Door'],
    [1999, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [1999, 'Mercedes-Benz', 'E430', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'E55 AMG', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [1999, 'Mercedes-Benz', 'ML430', 'SUV 4-Door'],
    [1999, 'Mercedes-Benz', 'S320', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'S420', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [1999, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [1999, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [1999, 'Mercedes-Benz', 'SLK230', 'Convertible 2-Door'],
    [1999, 'Mercury', 'Cougar', 'Coupe 2-Door'],
    [1999, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1999, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [1999, 'Mercury', 'Mystique', 'Sedan 4-Door'],
    [1999, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1999, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1999, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1999, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1999, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [1999, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1999, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [1999, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [1999, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1999, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1999, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [1999, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1999, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1999, 'Mitsubishi', 'Montero Sport', 'SUV 4-Door'],
    [1999, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [1999, 'Nissan', 'Altra EV', 'Wagon 4-Door'],
    [1999, 'Nissan', 'Frontier', 'Extended Cab Pickup 2-Door'],
    [1999, 'Nissan', 'Frontier', 'Standard Cab Pickup 2-Door'],
    [1999, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1999, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1999, 'Nissan', 'Quest', 'Mini Passenger Van 4-Door'],
    [1999, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1999, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1999, 'Oldsmobile', 'Alero', 'Coupe 2-Door'],
    [1999, 'Oldsmobile', 'Alero', 'Sedan 4-Door'],
    [1999, 'Oldsmobile', 'Aurora', 'Sedan 4-Door'],
    [1999, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [1999, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1999, 'Oldsmobile', 'Intrigue', 'Sedan 4-Door'],
    [1999, 'Oldsmobile', 'LSS', 'Sedan 4-Door'],
    [1999, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 4-Door'],
    [1999, 'Panoz', 'AIV Roadster', 'Convertible 2-Door'],
    [1999, 'Plymouth', 'Breeze', 'Sedan 4-Door'],
    [1999, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1999, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 4-Door'],
    [1999, 'Plymouth', 'Neon', 'Coupe 2-Door'],
    [1999, 'Plymouth', 'Neon', 'Sedan 4-Door'],
    [1999, 'Plymouth', 'Prowler', 'Convertible 2-Door'],
    [1999, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1999, 'Plymouth', 'Voyager', 'Mini Passenger Van 4-Door'],
    [1999, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1999, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1999, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1999, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1999, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1999, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1999, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1999, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1999, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1999, 'Pontiac', 'Montana', 'Mini Passenger Van 3-Door'],
    [1999, 'Pontiac', 'Montana', 'Mini Passenger Van 4-Door'],
    [1999, 'Pontiac', 'Sunfire', 'Convertible 2-Door'],
    [1999, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [1999, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [1999, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1999, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 4-Door'],
    [1999, 'Porsche', '911', 'Convertible 2-Door'],
    [1999, 'Porsche', '911', 'Coupe 2-Door'],
    [1999, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [1999, 'Rolls-Royce', 'Silver Seraph', 'Sedan 4-Door'],
    [1999, 'Saab', '3-Sep', 'Convertible 2-Door'],
    [1999, 'Saab', '3-Sep', 'Hatchback 2-Door'],
    [1999, 'Saab', '3-Sep', 'Hatchback 4-Door'],
    [1999, 'Saab', '5-Sep', 'Sedan 4-Door'],
    [1999, 'Saab', '5-Sep', 'Wagon 4-Door'],
    [1999, 'Saturn', 'SC1', 'Coupe 3-Door'],
    [1999, 'Saturn', 'SC2', 'Coupe 3-Door'],
    [1999, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1999, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1999, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1999, 'Saturn', 'SW1', 'Wagon 4-Door'],
    [1999, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [1999, 'Shelby', 'Series 1', 'Coupe 2-Door'],
    [1999, 'Subaru', 'Forester', 'SUV 4-Door'],
    [1999, 'Subaru', 'Impreza', 'Coupe 2-Door'],
    [1999, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [1999, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [1999, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1999, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1999, 'Suzuki', 'Esteem', 'Sedan 4-Door'],
    [1999, 'Suzuki', 'Esteem', 'Wagon 5-Door'],
    [1999, 'Suzuki', 'Grand Vitara', 'SUV 4-Door'],
    [1999, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1999, 'Suzuki', 'Vitara', 'SUV 2-Door'],
    [1999, 'Suzuki', 'Vitara', 'SUV 4-Door'],
    [1999, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1999, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [1999, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1999, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1999, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1999, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1999, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1999, 'Toyota', 'Paseo', 'Coupe 2-Door'],
    [1999, 'Toyota', 'RAV4', 'SUV 2-Door'],
    [1999, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [1999, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [1999, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [1999, 'Toyota', 'Solara', 'Coupe 2-Door'],
    [1999, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [1999, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [1999, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1999, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [1999, 'Volkswagen', 'Cabrio', 'Convertible 2-Door'],
    [1999, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [1999, 'Volkswagen', 'EuroVan', 'Van Camper 3-Door'],
    [1999, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1999, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1999, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1999, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1999, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1999, 'Volvo', 'C70', 'Convertible 2-Door'],
    [1999, 'Volvo', 'C70', 'Coupe 2-Door'],
    [1999, 'Volvo', 'S70', 'Sedan 4-Door'],
    [1999, 'Volvo', 'S80', 'Sedan 4-Door'],
    [1999, 'Volvo', 'V70', 'Wagon 4-Door'],
    [1998, 'Acura', 'CL', 'Coupe 2-Door'],
    [1998, 'Acura', 'EL', 'Sedan 4-Door'],
    [1998, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1998, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1998, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1998, 'Acura', 'RL', 'Sedan 4-Door'],
    [1998, 'Acura', 'SLX', 'SUV 4-Door'],
    [1998, 'Acura', 'TL', 'Sedan 4-Door'],
    [1998, 'AM General', 'Hummer', 'SUV 2-Door'],
    [1998, 'AM General', 'Hummer', 'SUV 4-Door'],
    [1998, 'Aston Martin', 'DB7', 'Convertible 2-Door'],
    [1998, 'Aston Martin', 'DB7', 'Coupe 2-Door'],
    [1998, 'Audi', 'A4', 'Sedan 4-Door'],
    [1998, 'Audi', 'A4', 'Wagon 4-Door'],
    [1998, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [1998, 'Audi', 'A4 Quattro', 'Wagon 4-Door'],
    [1998, 'Audi', 'A6', 'Sedan 4-Door'],
    [1998, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [1998, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [1998, 'Audi', 'A8', 'Sedan 4-Door'],
    [1998, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [1998, 'Audi', 'Cabriolet', 'Convertible 2-Door'],
    [1998, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [1998, 'Bentley', 'Brooklands', 'Sedan 4-Door'],
    [1998, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [1998, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1998, 'BMW', '318i', 'Convertible 2-Door'],
    [1998, 'BMW', '318i', 'Sedan 4-Door'],
    [1998, 'BMW', '318is', 'Coupe 2-Door'],
    [1998, 'BMW', '318ti', 'Hatchback 2-Door'],
    [1998, 'BMW', '323i', 'Convertible 2-Door'],
    [1998, 'BMW', '323is', 'Coupe 2-Door'],
    [1998, 'BMW', '328i', 'Convertible 2-Door'],
    [1998, 'BMW', '328i', 'Sedan 4-Door'],
    [1998, 'BMW', '328is', 'Coupe 2-Door'],
    [1998, 'BMW', '528i', 'Sedan 4-Door'],
    [1998, 'BMW', '540i', 'Sedan 4-Door'],
    [1998, 'BMW', '740i', 'Sedan 4-Door'],
    [1998, 'BMW', '740iL', 'Sedan 4-Door'],
    [1998, 'BMW', '750iL', 'Sedan 4-Door'],
    [1998, 'BMW', 'M3', 'Convertible 2-Door'],
    [1998, 'BMW', 'M3', 'Coupe 2-Door'],
    [1998, 'BMW', 'M3', 'Sedan 4-Door'],
    [1998, 'BMW', 'Z3', 'Convertible 2-Door'],
    [1998, 'Buick', 'Century', 'Sedan 4-Door'],
    [1998, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1998, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1998, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1998, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1998, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1998, 'Cadillac', 'Catera', 'Sedan 4-Door'],
    [1998, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1998, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1998, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1998, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1998, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1998, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1998, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1998, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1998, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1998, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [1998, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1998, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'C1500 Suburban', 'SUV 4-Door'],
    [1998, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'C2500 Suburban', 'SUV 4-Door'],
    [1998, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1998, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1998, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1998, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1998, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1998, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1998, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1998, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1998, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [1998, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [1998, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [1998, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [1998, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [1998, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [1998, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [1998, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [1998, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [1998, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [1998, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1998, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'K1500 Suburban', 'SUV 4-Door'],
    [1998, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'K2500 Suburban', 'SUV 4-Door'],
    [1998, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1998, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1998, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1998, 'Chevrolet', 'Metro', 'Hatchback 2-Door'],
    [1998, 'Chevrolet', 'Metro', 'Sedan 4-Door'],
    [1998, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1998, 'Chevrolet', 'Prizm', 'Sedan 4-Door'],
    [1998, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [1998, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1998, 'Chevrolet', 'Tahoe', 'SUV 2-Door'],
    [1998, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [1998, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [1998, 'Chevrolet', 'Tracker', 'SUV 4-Door'],
    [1998, 'Chevrolet', 'Venture', 'Mini Passenger Van 3-Door'],
    [1998, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [1998, 'Chrysler', 'Cirrus', 'Sedan 4-Door'],
    [1998, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [1998, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [1998, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [1998, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [1998, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [1998, 'Dodge', 'Avenger', 'Coupe 2-Door'],
    [1998, 'Dodge', 'B1500', 'Extended Cargo Van 3-Door'],
    [1998, 'Dodge', 'B1500', 'Standard Cargo Van 3-Door'],
    [1998, 'Dodge', 'B1500', 'Standard Passenger Van 3-Door'],
    [1998, 'Dodge', 'B2500', 'Extended Cargo Van 3-Door'],
    [1998, 'Dodge', 'B2500', 'Extended Passenger Van 3-Door'],
    [1998, 'Dodge', 'B2500', 'Standard Cargo Van 3-Door'],
    [1998, 'Dodge', 'B3500', 'Extended Cargo Van 3-Door'],
    [1998, 'Dodge', 'B3500', 'Extended Passenger Van 3-Door'],
    [1998, 'Dodge', 'B3500', 'Standard Cargo Van 3-Door'],
    [1998, 'Dodge', 'B3500', 'Standard Passenger Van 3-Door'],
    [1998, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [1998, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1998, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1998, 'Dodge', 'Durango', 'SUV 4-Door'],
    [1998, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [1998, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [1998, 'Dodge', 'Neon', 'Coupe 2-Door'],
    [1998, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [1998, 'Dodge', 'Ram 1500', 'Crew Cab Pickup 4-Door'],
    [1998, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 4-Door'],
    [1998, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 4-Door'],
    [1998, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Dodge', 'Ram 3500', 'Extended Cab Pickup 4-Door'],
    [1998, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [1998, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [1998, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [1998, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1998, 'Ferrari', '456 GT', 'Coupe 2-Door'],
    [1998, 'Ferrari', '456 GTA', 'Coupe 2-Door'],
    [1998, 'Ferrari', '550 Maranello', 'Coupe 2-Door'],
    [1998, 'Ferrari', 'F355 F1', 'Coupe 2-Door'],
    [1998, 'Ferrari', 'F355 GTS', 'Coupe 2-Door'],
    [1998, 'Ferrari', 'F355 Spider', 'Convertible 2-Door'],
    [1998, 'Ford', 'Contour', 'Sedan 4-Door'],
    [1998, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [1998, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1998, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1998, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1998, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1998, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1998, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1998, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1998, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1998, 'Ford', 'Escort', 'Coupe 2-Door'],
    [1998, 'Ford', 'Escort', 'Sedan 4-Door'],
    [1998, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1998, 'Ford', 'Expedition', 'SUV 4-Door'],
    [1998, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1998, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1998, 'Ford', 'F-150', 'Extended Cab Pickup 3-Door'],
    [1998, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1998, 'Ford', 'F-250', 'Extended Cab Pickup 3-Door'],
    [1998, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1998, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1998, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [1998, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1998, 'Ford', 'Ranger', 'Extended Cab Pickup 4-Door'],
    [1998, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1998, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1998, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1998, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [1998, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [1998, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1998, 'GMC', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1998, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1998, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1998, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1998, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1998, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1998, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1998, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1998, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1998, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1998, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [1998, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1998, 'GMC', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1998, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1998, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1998, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1998, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1998, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1998, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1998, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1998, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1998, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1998, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1998, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [1998, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [1998, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [1998, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [1998, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [1998, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [1998, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [1998, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [1998, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [1998, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [1998, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1998, 'GMC', 'Sonoma', 'Extended Cab Pickup 3-Door'],
    [1998, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1998, 'GMC', 'Yukon', 'SUV 4-Door'],
    [1998, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1998, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1998, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1998, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1998, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1998, 'Honda', 'CR-V', 'SUV 4-Door'],
    [1998, 'Honda', 'EV Plus', 'Hatchback 2-Door'],
    [1998, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [1998, 'Honda', 'Passport', 'SUV 4-Door'],
    [1998, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1998, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [1998, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [1998, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [1998, 'Hyundai', 'Elantra', 'Wagon 5-Door'],
    [1998, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1998, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [1998, 'INFINITI', 'I30', 'Sedan 4-Door'],
    [1998, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1998, 'INFINITI', 'QX4', 'SUV 4-Door'],
    [1998, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [1998, 'Isuzu', 'Hombre', 'Extended Cab Pickup 2-Door'],
    [1998, 'Isuzu', 'Hombre', 'Extended Cab Pickup 3-Door'],
    [1998, 'Isuzu', 'Hombre', 'Standard Cab Pickup 2-Door'],
    [1998, 'Isuzu', 'Oasis', 'Mini Passenger Van 5-Door'],
    [1998, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1998, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1998, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1998, 'Jaguar', 'XJ8', 'Sedan 4-Door'],
    [1998, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [1998, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [1998, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [1998, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1998, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1998, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [1998, 'Jeep', 'TJ', 'SUV 2-Door'],
    [1998, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1998, 'Kia', 'Sephia', 'Sedan 4-Door'],
    [1998, 'Kia', 'Sportage', 'SUV 4-Door'],
    [1998, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1998, 'Lamborghini', 'Diablo', 'Convertible 2-Door'],
    [1998, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1998, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [1998, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1998, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [1998, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [1998, 'Lexus', 'GS400', 'Sedan 4-Door'],
    [1998, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1998, 'Lexus', 'LX470', 'SUV 4-Door'],
    [1998, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [1998, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [1998, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1998, 'Lincoln', 'Mark VIII', 'Sedan 2-Door'],
    [1998, 'Lincoln', 'Navigator', 'SUV 4-Door'],
    [1998, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1998, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1998, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1998, 'Mazda', '626', 'Sedan 4-Door'],
    [1998, 'Mazda', 'B2500', 'Extended Cab Pickup 2-Door'],
    [1998, 'Mazda', 'B2500', 'Extended Cab Pickup 4-Door'],
    [1998, 'Mazda', 'B2500', 'Standard Cab Pickup 2-Door'],
    [1998, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [1998, 'Mazda', 'B3000', 'Extended Cab Pickup 4-Door'],
    [1998, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [1998, 'Mazda', 'B4000', 'Extended Cab Pickup 2-Door'],
    [1998, 'Mazda', 'B4000', 'Extended Cab Pickup 4-Door'],
    [1998, 'Mazda', 'Millenia', 'Sedan 4-Door'],
    [1998, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1998, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'C43 AMG', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'CL500', 'Coupe 2-Door'],
    [1998, 'Mercedes-Benz', 'CL600', 'Coupe 2-Door'],
    [1998, 'Mercedes-Benz', 'CLK320', 'Coupe 2-Door'],
    [1998, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [1998, 'Mercedes-Benz', 'E430', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'ML320', 'SUV 4-Door'],
    [1998, 'Mercedes-Benz', 'S320', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'S420', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [1998, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [1998, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [1998, 'Mercedes-Benz', 'SLK230', 'Convertible 2-Door'],
    [1998, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1998, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [1998, 'Mercury', 'Mystique', 'Sedan 4-Door'],
    [1998, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1998, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1998, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1998, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1998, 'Mercury', 'Villager', 'Mini Cargo Van 3-Door'],
    [1998, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [1998, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1998, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [1998, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [1998, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1998, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1998, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [1998, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1998, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1998, 'Mitsubishi', 'Montero Sport', 'SUV 4-Door'],
    [1998, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1998, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1998, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [1998, 'Nissan', 'Frontier', 'Extended Cab Pickup 2-Door'],
    [1998, 'Nissan', 'Frontier', 'Standard Cab Pickup 2-Door'],
    [1998, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1998, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1998, 'Nissan', 'Quest', 'Mini Passenger Van 3-Door'],
    [1998, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1998, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1998, 'Oldsmobile', 'Achieva', 'Sedan 4-Door'],
    [1998, 'Oldsmobile', 'Aurora', 'Sedan 4-Door'],
    [1998, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [1998, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1998, 'Oldsmobile', 'Intrigue', 'Sedan 4-Door'],
    [1998, 'Oldsmobile', 'LSS', 'Sedan 4-Door'],
    [1998, 'Oldsmobile', 'Regency', 'Sedan 4-Door'],
    [1998, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 4-Door'],
    [1998, 'Plymouth', 'Breeze', 'Sedan 4-Door'],
    [1998, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1998, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 4-Door'],
    [1998, 'Plymouth', 'Neon', 'Coupe 2-Door'],
    [1998, 'Plymouth', 'Neon', 'Sedan 4-Door'],
    [1998, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1998, 'Plymouth', 'Voyager', 'Mini Passenger Van 4-Door'],
    [1998, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1998, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1998, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1998, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1998, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1998, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1998, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1998, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1998, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1998, 'Pontiac', 'Sunfire', 'Convertible 2-Door'],
    [1998, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [1998, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [1998, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1998, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 4-Door'],
    [1998, 'Porsche', '911', 'Convertible 2-Door'],
    [1998, 'Porsche', '911', 'Coupe 2-Door'],
    [1998, 'Porsche', '911', 'Targa 2-Door'],
    [1998, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [1998, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1998, 'Saab', '900', 'Convertible 2-Door'],
    [1998, 'Saab', '900', 'Hatchback 2-Door'],
    [1998, 'Saab', '900', 'Hatchback 4-Door'],
    [1998, 'Saab', '9000', 'Hatchback 4-Door'],
    [1998, 'Saturn', 'SC1', 'Coupe 3-Door'],
    [1998, 'Saturn', 'SC2', 'Coupe 3-Door'],
    [1998, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1998, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1998, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1998, 'Saturn', 'SW1', 'Wagon 4-Door'],
    [1998, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [1998, 'Subaru', 'Forester', 'SUV 4-Door'],
    [1998, 'Subaru', 'Impreza', 'Coupe 2-Door'],
    [1998, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [1998, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [1998, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1998, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1998, 'Suzuki', 'Esteem', 'Sedan 4-Door'],
    [1998, 'Suzuki', 'Esteem', 'Wagon 5-Door'],
    [1998, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1998, 'Suzuki', 'Sidekick', 'SUV 4-Door'],
    [1998, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1998, 'Suzuki', 'X-90', 'SUV 2-Door'],
    [1998, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1998, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [1998, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1998, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1998, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1998, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1998, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1998, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1998, 'Toyota', 'Paseo', 'Convertible 2-Door'],
    [1998, 'Toyota', 'Paseo', 'Coupe 2-Door'],
    [1998, 'Toyota', 'RAV4', 'SUV 2-Door'],
    [1998, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [1998, 'Toyota', 'Sienna', 'Mini Passenger Van 4-Door'],
    [1998, 'Toyota', 'Sienna', 'Mini Passenger Van 5-Door'],
    [1998, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1998, 'Toyota', 'T100', 'Extended Cab Pickup 2-Door'],
    [1998, 'Toyota', 'T100', 'Standard Cab Pickup 2-Door'],
    [1998, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [1998, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [1998, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1998, 'Volkswagen', 'Beetle', 'Hatchback 2-Door'],
    [1998, 'Volkswagen', 'Cabrio', 'Convertible 2-Door'],
    [1998, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1998, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1998, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1998, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1998, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1998, 'Volvo', 'C70', 'Convertible 2-Door'],
    [1998, 'Volvo', 'C70', 'Coupe 2-Door'],
    [1998, 'Volvo', 'S70', 'Sedan 4-Door'],
    [1998, 'Volvo', 'S90', 'Sedan 4-Door'],
    [1998, 'Volvo', 'V70', 'Wagon 4-Door'],
    [1998, 'Volvo', 'V90', 'Wagon 4-Door'],
    [1997, 'Acura', 'CL', 'Coupe 2-Door'],
    [1997, 'Acura', 'EL', 'Sedan 4-Door'],
    [1997, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1997, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1997, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1997, 'Acura', 'RL', 'Sedan 4-Door'],
    [1997, 'Acura', 'SLX', 'SUV 4-Door'],
    [1997, 'Acura', 'TL', 'Sedan 4-Door'],
    [1997, 'AM General', 'Hummer', 'SUV 2-Door'],
    [1997, 'AM General', 'Hummer', 'SUV 4-Door'],
    [1997, 'Aston Martin', 'DB7', 'Convertible 2-Door'],
    [1997, 'Aston Martin', 'DB7', 'Coupe 2-Door'],
    [1997, 'Audi', 'A4', 'Sedan 4-Door'],
    [1997, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [1997, 'Audi', 'A6', 'Sedan 4-Door'],
    [1997, 'Audi', 'A6', 'Wagon 4-Door'],
    [1997, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [1997, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [1997, 'Audi', 'A8', 'Sedan 4-Door'],
    [1997, 'Audi', 'A8 Quattro', 'Sedan 4-Door'],
    [1997, 'Audi', 'Cabriolet', 'Convertible 2-Door'],
    [1997, 'Audi', 'S6', 'Sedan 4-Door'],
    [1997, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [1997, 'Bentley', 'Brooklands', 'Sedan 4-Door'],
    [1997, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [1997, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1997, 'BMW', '318i', 'Convertible 2-Door'],
    [1997, 'BMW', '318i', 'Sedan 4-Door'],
    [1997, 'BMW', '318is', 'Coupe 2-Door'],
    [1997, 'BMW', '318ti', 'Hatchback 2-Door'],
    [1997, 'BMW', '328i', 'Convertible 2-Door'],
    [1997, 'BMW', '328i', 'Sedan 4-Door'],
    [1997, 'BMW', '328is', 'Coupe 2-Door'],
    [1997, 'BMW', '528i', 'Sedan 4-Door'],
    [1997, 'BMW', '540i', 'Sedan 4-Door'],
    [1997, 'BMW', '740i', 'Sedan 4-Door'],
    [1997, 'BMW', '740iL', 'Sedan 4-Door'],
    [1997, 'BMW', '750iL', 'Sedan 4-Door'],
    [1997, 'BMW', '840Ci', 'Coupe 2-Door'],
    [1997, 'BMW', '850Ci', 'Coupe 2-Door'],
    [1997, 'BMW', 'M3', 'Coupe 2-Door'],
    [1997, 'BMW', 'M3', 'Sedan 4-Door'],
    [1997, 'BMW', 'Z3', 'Convertible 2-Door'],
    [1997, 'Buick', 'Century', 'Sedan 4-Door'],
    [1997, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1997, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1997, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1997, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1997, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1997, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1997, 'Cadillac', 'Catera', 'Sedan 4-Door'],
    [1997, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1997, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1997, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1997, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1997, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1997, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1997, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1997, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1997, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1997, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [1997, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1997, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'C1500 Suburban', 'SUV 4-Door'],
    [1997, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'C2500 Suburban', 'SUV 4-Door'],
    [1997, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1997, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1997, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1997, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1997, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1997, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1997, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1997, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [1997, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [1997, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [1997, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [1997, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [1997, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [1997, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [1997, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [1997, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [1997, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [1997, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1997, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'K1500 Suburban', 'SUV 4-Door'],
    [1997, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'K2500 Suburban', 'SUV 4-Door'],
    [1997, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1997, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1997, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1997, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1997, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [1997, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1997, 'Chevrolet', 'Tahoe', 'SUV 2-Door'],
    [1997, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [1997, 'Chevrolet', 'Venture', 'Mini Passenger Van 3-Door'],
    [1997, 'Chevrolet', 'Venture', 'Mini Passenger Van 4-Door'],
    [1997, 'Chrysler', 'Cirrus', 'Sedan 4-Door'],
    [1997, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [1997, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [1997, 'Chrysler', 'LHS', 'Sedan 4-Door'],
    [1997, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [1997, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [1997, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [1997, 'Dodge', 'Avenger', 'Coupe 2-Door'],
    [1997, 'Dodge', 'B1500', 'Standard Cargo Van 3-Door'],
    [1997, 'Dodge', 'B1500', 'Standard Passenger Van 3-Door'],
    [1997, 'Dodge', 'B2500', 'Extended Cargo Van 3-Door'],
    [1997, 'Dodge', 'B2500', 'Extended Passenger Van 3-Door'],
    [1997, 'Dodge', 'B2500', 'Standard Cargo Van 3-Door'],
    [1997, 'Dodge', 'B3500', 'Extended Cargo Van 3-Door'],
    [1997, 'Dodge', 'B3500', 'Extended Passenger Van 3-Door'],
    [1997, 'Dodge', 'B3500', 'Standard Cargo Van 3-Door'],
    [1997, 'Dodge', 'B3500', 'Standard Passenger Van 3-Door'],
    [1997, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [1997, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1997, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1997, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1997, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [1997, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [1997, 'Dodge', 'Neon', 'Coupe 2-Door'],
    [1997, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [1997, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Dodge', 'Ram 3500', 'Extended Cab Pickup 2-Door'],
    [1997, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [1997, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [1997, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [1997, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [1997, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1997, 'Eagle', 'Vision', 'Sedan 4-Door'],
    [1997, 'Ferrari', '456 GT', 'Coupe 2-Door'],
    [1997, 'Ferrari', '456 GTA', 'Coupe 2-Door'],
    [1997, 'Ferrari', '550 Maranello', 'Coupe 2-Door'],
    [1997, 'Ferrari', 'F355 GTS', 'Coupe 2-Door'],
    [1997, 'Ferrari', 'F355 Spider', 'Convertible 2-Door'],
    [1997, 'Ferrari', 'F50', 'Coupe 2-Door'],
    [1997, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1997, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1997, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1997, 'Ford', 'Aspire', 'Hatchback 2-Door'],
    [1997, 'Ford', 'Aspire', 'Hatchback 4-Door'],
    [1997, 'Ford', 'Contour', 'Sedan 4-Door'],
    [1997, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [1997, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1997, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1997, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1997, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1997, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1997, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1997, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1997, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1997, 'Ford', 'Escort', 'Sedan 4-Door'],
    [1997, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1997, 'Ford', 'Expedition', 'SUV 4-Door'],
    [1997, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1997, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1997, 'Ford', 'F-150', 'Extended Cab Pickup 3-Door'],
    [1997, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1997, 'Ford', 'F-250', 'Extended Cab Pickup 3-Door'],
    [1997, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1997, 'Ford', 'F-250 HD', 'Crew Cab Pickup 4-Door'],
    [1997, 'Ford', 'F-250 HD', 'Extended Cab Pickup 2-Door'],
    [1997, 'Ford', 'F-250 HD', 'Standard Cab Pickup 2-Door'],
    [1997, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1997, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1997, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1997, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1997, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [1997, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1997, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1997, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1997, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1997, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1997, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1997, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1997, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [1997, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [1997, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1997, 'Geo', 'Metro', 'Sedan 4-Door'],
    [1997, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1997, 'Geo', 'Tracker', 'SUV 2-Door'],
    [1997, 'Geo', 'Tracker', 'SUV 4-Door'],
    [1997, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1997, 'GMC', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1997, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1997, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1997, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1997, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1997, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1997, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1997, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1997, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1997, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1997, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [1997, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1997, 'GMC', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1997, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1997, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1997, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1997, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1997, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1997, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1997, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1997, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1997, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1997, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1997, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1997, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1997, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [1997, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [1997, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [1997, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [1997, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [1997, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [1997, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [1997, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [1997, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [1997, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [1997, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1997, 'GMC', 'Sonoma', 'Extended Cab Pickup 3-Door'],
    [1997, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1997, 'GMC', 'Yukon', 'SUV 2-Door'],
    [1997, 'GMC', 'Yukon', 'SUV 4-Door'],
    [1997, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1997, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1997, 'Honda', 'Accord', 'Wagon 5-Door'],
    [1997, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1997, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1997, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1997, 'Honda', 'Civic del Sol', 'Coupe 2-Door'],
    [1997, 'Honda', 'CR-V', 'SUV 4-Door'],
    [1997, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [1997, 'Honda', 'Passport', 'SUV 4-Door'],
    [1997, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1997, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [1997, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [1997, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [1997, 'Hyundai', 'Elantra', 'Wagon 5-Door'],
    [1997, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1997, 'Hyundai', 'Tiburon', 'Coupe 2-Door'],
    [1997, 'INFINITI', 'I30', 'Sedan 4-Door'],
    [1997, 'INFINITI', 'J30', 'Sedan 4-Door'],
    [1997, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1997, 'INFINITI', 'QX4', 'SUV 4-Door'],
    [1997, 'Isuzu', 'Hombre', 'Extended Cab Pickup 2-Door'],
    [1997, 'Isuzu', 'Hombre', 'Standard Cab Pickup 2-Door'],
    [1997, 'Isuzu', 'Oasis', 'Mini Passenger Van 5-Door'],
    [1997, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1997, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1997, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1997, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1997, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [1997, 'Jaguar', 'XK8', 'Convertible 2-Door'],
    [1997, 'Jaguar', 'XK8', 'Coupe 2-Door'],
    [1997, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1997, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1997, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [1997, 'Jeep', 'TJ', 'SUV 2-Door'],
    [1997, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1997, 'Kia', 'Sephia', 'Sedan 4-Door'],
    [1997, 'Kia', 'Sportage', 'SUV 4-Door'],
    [1997, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1997, 'Lamborghini', 'Diablo', 'Convertible 2-Door'],
    [1997, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1997, 'Land Rover', 'Defender 90', 'SUV 2-Door'],
    [1997, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [1997, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1997, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [1997, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [1997, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1997, 'Lexus', 'LX450', 'SUV 4-Door'],
    [1997, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [1997, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [1997, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1997, 'Lincoln', 'Mark VIII', 'Sedan 2-Door'],
    [1997, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1997, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1997, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1997, 'Mazda', '626', 'Sedan 4-Door'],
    [1997, 'Mazda', 'B2300', 'Extended Cab Pickup 2-Door'],
    [1997, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [1997, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [1997, 'Mazda', 'B4000', 'Extended Cab Pickup 2-Door'],
    [1997, 'Mazda', 'B4000', 'Standard Cab Pickup 2-Door'],
    [1997, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1997, 'Mazda', 'Millenia', 'Sedan 4-Door'],
    [1997, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1997, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1997, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'C230', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'C36 AMG', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'E420', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'S320', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'S420', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'S500', 'Coupe 2-Door'],
    [1997, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'S600', 'Coupe 2-Door'],
    [1997, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [1997, 'Mercedes-Benz', 'SL320', 'Convertible 2-Door'],
    [1997, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [1997, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [1997, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1997, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1997, 'Mercury', 'Mountaineer', 'SUV 4-Door'],
    [1997, 'Mercury', 'Mystique', 'Sedan 4-Door'],
    [1997, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1997, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1997, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1997, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1997, 'Mercury', 'Villager', 'Mini Cargo Van 3-Door'],
    [1997, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [1997, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1997, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [1997, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [1997, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1997, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1997, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [1997, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1997, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1997, 'Mitsubishi', 'Montero Sport', 'SUV 4-Door'],
    [1997, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1997, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1997, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [1997, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1997, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1997, 'Nissan', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1997, 'Nissan', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1997, 'Nissan', 'Quest', 'Mini Passenger Van 3-Door'],
    [1997, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1997, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1997, 'Oldsmobile', 'Achieva', 'Coupe 2-Door'],
    [1997, 'Oldsmobile', 'Achieva', 'Sedan 4-Door'],
    [1997, 'Oldsmobile', 'Aurora', 'Sedan 4-Door'],
    [1997, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [1997, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1997, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1997, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1997, 'Oldsmobile', 'LSS', 'Sedan 4-Door'],
    [1997, 'Oldsmobile', 'Regency', 'Sedan 4-Door'],
    [1997, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 3-Door'],
    [1997, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 4-Door'],
    [1997, 'Plymouth', 'Breeze', 'Sedan 4-Door'],
    [1997, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1997, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 4-Door'],
    [1997, 'Plymouth', 'Neon', 'Coupe 2-Door'],
    [1997, 'Plymouth', 'Neon', 'Sedan 4-Door'],
    [1997, 'Plymouth', 'Prowler', 'Convertible 2-Door'],
    [1997, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1997, 'Plymouth', 'Voyager', 'Mini Passenger Van 4-Door'],
    [1997, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1997, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1997, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1997, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1997, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1997, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1997, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1997, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1997, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1997, 'Pontiac', 'Sunfire', 'Convertible 2-Door'],
    [1997, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [1997, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [1997, 'Pontiac', 'Sunrunner', 'SUV 2-Door'],
    [1997, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1997, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 4-Door'],
    [1997, 'Porsche', '911', 'Convertible 2-Door'],
    [1997, 'Porsche', '911', 'Coupe 2-Door'],
    [1997, 'Porsche', '911', 'Targa 2-Door'],
    [1997, 'Porsche', 'Boxster', 'Convertible 2-Door'],
    [1997, 'Rolls-Royce', 'Silver Dawn', 'Sedan 4-Door'],
    [1997, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1997, 'Saab', '900', 'Convertible 2-Door'],
    [1997, 'Saab', '900', 'Hatchback 2-Door'],
    [1997, 'Saab', '900', 'Hatchback 4-Door'],
    [1997, 'Saab', '9000', 'Hatchback 4-Door'],
    [1997, 'Saturn', 'SC1', 'Coupe 2-Door'],
    [1997, 'Saturn', 'SC2', 'Coupe 2-Door'],
    [1997, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1997, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1997, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1997, 'Saturn', 'SW1', 'Wagon 4-Door'],
    [1997, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [1997, 'Subaru', 'Impreza', 'Coupe 2-Door'],
    [1997, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [1997, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [1997, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1997, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1997, 'Subaru', 'SVX', 'Coupe 2-Door'],
    [1997, 'Suzuki', 'Esteem', 'Sedan 4-Door'],
    [1997, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1997, 'Suzuki', 'Sidekick', 'SUV 4-Door'],
    [1997, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1997, 'Suzuki', 'X-90', 'SUV 2-Door'],
    [1997, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1997, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [1997, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1997, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1997, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1997, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1997, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1997, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1997, 'Toyota', 'Paseo', 'Convertible 2-Door'],
    [1997, 'Toyota', 'Paseo', 'Coupe 2-Door'],
    [1997, 'Toyota', 'Previa', 'Mini Passenger Van 3-Door'],
    [1997, 'Toyota', 'RAV4', 'SUV 2-Door'],
    [1997, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [1997, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1997, 'Toyota', 'T100', 'Extended Cab Pickup 2-Door'],
    [1997, 'Toyota', 'T100', 'Standard Cab Pickup 2-Door'],
    [1997, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [1997, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [1997, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1997, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1997, 'Volkswagen', 'Cabrio', 'Convertible 2-Door'],
    [1997, 'Volkswagen', 'EuroVan', 'Van Camper 3-Door'],
    [1997, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1997, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1997, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1997, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1997, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1997, 'Volvo', '850', 'Sedan 4-Door'],
    [1997, 'Volvo', '850', 'Wagon 4-Door'],
    [1997, 'Volvo', '960', 'Sedan 4-Door'],
    [1997, 'Volvo', '960', 'Wagon 4-Door'],
    [1997, 'Volvo', 'S90', 'Sedan 4-Door'],
    [1997, 'Volvo', 'V90', 'Wagon 4-Door'],
    [1996, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1996, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1996, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1996, 'Acura', 'RL', 'Sedan 4-Door'],
    [1996, 'Acura', 'SLX', 'SUV 4-Door'],
    [1996, 'Acura', 'TL', 'Sedan 4-Door'],
    [1996, 'AM General', 'Hummer', 'SUV 2-Door'],
    [1996, 'AM General', 'Hummer', 'SUV 4-Door'],
    [1996, 'Audi', 'A4', 'Sedan 4-Door'],
    [1996, 'Audi', 'A4 Quattro', 'Sedan 4-Door'],
    [1996, 'Audi', 'A6', 'Sedan 4-Door'],
    [1996, 'Audi', 'A6', 'Wagon 4-Door'],
    [1996, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [1996, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [1996, 'Audi', 'Cabriolet', 'Convertible 2-Door'],
    [1996, 'Audi', 'S6', 'Sedan 4-Door'],
    [1996, 'Bentley', 'Azure', 'Convertible 2-Door'],
    [1996, 'Bentley', 'Brooklands', 'Sedan 4-Door'],
    [1996, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [1996, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1996, 'BMW', '318i', 'Convertible 2-Door'],
    [1996, 'BMW', '318i', 'Sedan 4-Door'],
    [1996, 'BMW', '318is', 'Coupe 2-Door'],
    [1996, 'BMW', '318ti', 'Hatchback 2-Door'],
    [1996, 'BMW', '328i', 'Convertible 2-Door'],
    [1996, 'BMW', '328i', 'Sedan 4-Door'],
    [1996, 'BMW', '328is', 'Coupe 2-Door'],
    [1996, 'BMW', '740iL', 'Sedan 4-Door'],
    [1996, 'BMW', '750iL', 'Sedan 4-Door'],
    [1996, 'BMW', '840Ci', 'Coupe 2-Door'],
    [1996, 'BMW', '850Ci', 'Coupe 2-Door'],
    [1996, 'BMW', 'M3', 'Coupe 2-Door'],
    [1996, 'BMW', 'Z3', 'Convertible 2-Door'],
    [1996, 'Buick', 'Century', 'Sedan 4-Door'],
    [1996, 'Buick', 'Century', 'Wagon 4-Door'],
    [1996, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1996, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1996, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1996, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1996, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1996, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1996, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1996, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1996, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1996, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1996, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1996, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1996, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1996, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1996, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1996, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1996, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [1996, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1996, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'C1500 Suburban', 'SUV 4-Door'],
    [1996, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'C2500 Suburban', 'SUV 4-Door'],
    [1996, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1996, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1996, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1996, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1996, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1996, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1996, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1996, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1996, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1996, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1996, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1996, 'Chevrolet', 'Express 1500', 'Standard Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'Express 1500', 'Standard Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'Express 2500', 'Extended Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'Express 2500', 'Extended Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'Express 2500', 'Standard Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'Express 2500', 'Standard Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'Express 3500', 'Extended Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'Express 3500', 'Extended Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'Express 3500', 'Standard Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'Express 3500', 'Standard Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1996, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1996, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'K1500 Suburban', 'SUV 4-Door'],
    [1996, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'K2500 Suburban', 'SUV 4-Door'],
    [1996, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1996, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1996, 'Chevrolet', 'Lumina APV', 'Mini Cargo Van 3-Door'],
    [1996, 'Chevrolet', 'Lumina APV', 'Mini Passenger Van 3-Door'],
    [1996, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1996, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [1996, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1996, 'Chevrolet', 'Tahoe', 'SUV 2-Door'],
    [1996, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [1996, 'Chrysler', 'Cirrus', 'Sedan 4-Door'],
    [1996, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [1996, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [1996, 'Chrysler', 'LHS', 'Sedan 4-Door'],
    [1996, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1996, 'Chrysler', 'Sebring', 'Convertible 2-Door'],
    [1996, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [1996, 'Chrysler', 'Town & Country', 'Mini Passenger Van 3-Door'],
    [1996, 'Chrysler', 'Town & Country', 'Mini Passenger Van 4-Door'],
    [1996, 'Dodge', 'Avenger', 'Coupe 2-Door'],
    [1996, 'Dodge', 'B1500', 'Standard Cargo Van 3-Door'],
    [1996, 'Dodge', 'B1500', 'Standard Passenger Van 3-Door'],
    [1996, 'Dodge', 'B2500', 'Extended Cargo Van 3-Door'],
    [1996, 'Dodge', 'B2500', 'Extended Passenger Van 3-Door'],
    [1996, 'Dodge', 'B2500', 'Standard Cargo Van 3-Door'],
    [1996, 'Dodge', 'B3500', 'Extended Cargo Van 3-Door'],
    [1996, 'Dodge', 'B3500', 'Extended Passenger Van 3-Door'],
    [1996, 'Dodge', 'B3500', 'Standard Cargo Van 3-Door'],
    [1996, 'Dodge', 'B3500', 'Standard Passenger Van 3-Door'],
    [1996, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1996, 'Dodge', 'Caravan', 'Mini Passenger Van 4-Door'],
    [1996, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1996, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1996, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1996, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 4-Door'],
    [1996, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [1996, 'Dodge', 'Neon', 'Coupe 2-Door'],
    [1996, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [1996, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Dodge', 'Ram 3500', 'Extended Cab Pickup 2-Door'],
    [1996, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [1996, 'Dodge', 'Stealth', 'Hatchback 2-Door'],
    [1996, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [1996, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [1996, 'Dodge', 'Viper', 'Coupe 2-Door'],
    [1996, 'Eagle', 'Summit', 'Coupe 2-Door'],
    [1996, 'Eagle', 'Summit', 'Sedan 4-Door'],
    [1996, 'Eagle', 'Summit', 'Wagon 3-Door'],
    [1996, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1996, 'Eagle', 'Vision', 'Sedan 4-Door'],
    [1996, 'Ferrari', '456 GT', 'Coupe 2-Door'],
    [1996, 'Ferrari', 'F355 Berlinetta', 'Coupe 2-Door'],
    [1996, 'Ferrari', 'F355 GTS', 'Coupe 2-Door'],
    [1996, 'Ferrari', 'F355 Spider', 'Convertible 2-Door'],
    [1996, 'Ferrari', 'F50', 'Coupe 2-Door'],
    [1996, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1996, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1996, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1996, 'Ford', 'Aspire', 'Hatchback 2-Door'],
    [1996, 'Ford', 'Aspire', 'Hatchback 4-Door'],
    [1996, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1996, 'Ford', 'Contour', 'Sedan 4-Door'],
    [1996, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [1996, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1996, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1996, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1996, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1996, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1996, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1996, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1996, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1996, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1996, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1996, 'Ford', 'Escort', 'Sedan 4-Door'],
    [1996, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1996, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1996, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1996, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1996, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1996, 'Ford', 'F-250', 'Crew Cab Pickup 4-Door'],
    [1996, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1996, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1996, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1996, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1996, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1996, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1996, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [1996, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1996, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1996, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1996, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1996, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1996, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1996, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1996, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [1996, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [1996, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1996, 'Geo', 'Metro', 'Sedan 4-Door'],
    [1996, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1996, 'Geo', 'Tracker', 'SUV 2-Door'],
    [1996, 'Geo', 'Tracker', 'SUV 4-Door'],
    [1996, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1996, 'GMC', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1996, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1996, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1996, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1996, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1996, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1996, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1996, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1996, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1996, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1996, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1996, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1996, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1996, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1996, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [1996, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1996, 'GMC', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1996, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1996, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1996, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1996, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1996, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1996, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1996, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1996, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1996, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1996, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1996, 'GMC', 'Savana 1500', 'Standard Cargo Van 3-Door'],
    [1996, 'GMC', 'Savana 1500', 'Standard Passenger Van 3-Door'],
    [1996, 'GMC', 'Savana 2500', 'Extended Cargo Van 3-Door'],
    [1996, 'GMC', 'Savana 2500', 'Extended Passenger Van 3-Door'],
    [1996, 'GMC', 'Savana 2500', 'Standard Cargo Van 3-Door'],
    [1996, 'GMC', 'Savana 2500', 'Standard Passenger Van 3-Door'],
    [1996, 'GMC', 'Savana 3500', 'Extended Cargo Van 3-Door'],
    [1996, 'GMC', 'Savana 3500', 'Extended Passenger Van 3-Door'],
    [1996, 'GMC', 'Savana 3500', 'Standard Cargo Van 3-Door'],
    [1996, 'GMC', 'Savana 3500', 'Standard Passenger Van 3-Door'],
    [1996, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1996, 'GMC', 'Sonoma', 'Extended Cab Pickup 3-Door'],
    [1996, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1996, 'GMC', 'Yukon', 'SUV 2-Door'],
    [1996, 'GMC', 'Yukon', 'SUV 4-Door'],
    [1996, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1996, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1996, 'Honda', 'Accord', 'Wagon 5-Door'],
    [1996, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1996, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1996, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1996, 'Honda', 'Civic del Sol', 'Coupe 2-Door'],
    [1996, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [1996, 'Honda', 'Passport', 'SUV 4-Door'],
    [1996, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1996, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [1996, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [1996, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [1996, 'Hyundai', 'Elantra', 'Wagon 5-Door'],
    [1996, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1996, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [1996, 'INFINITI', 'I30', 'Sedan 4-Door'],
    [1996, 'INFINITI', 'J30', 'Sedan 4-Door'],
    [1996, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1996, 'Isuzu', 'Hombre', 'Standard Cab Pickup 2-Door'],
    [1996, 'Isuzu', 'Oasis', 'Mini Passenger Van 5-Door'],
    [1996, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1996, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1996, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1996, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1996, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1996, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [1996, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1996, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1996, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1996, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [1996, 'Kia', 'Sephia', 'Sedan 4-Door'],
    [1996, 'Kia', 'Sportage', 'SUV 4-Door'],
    [1996, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1996, 'Lamborghini', 'Diablo', 'Convertible 2-Door'],
    [1996, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1996, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [1996, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1996, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [1996, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [1996, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1996, 'Lexus', 'LX450', 'SUV 4-Door'],
    [1996, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [1996, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [1996, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1996, 'Lincoln', 'Mark VIII', 'Sedan 2-Door'],
    [1996, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1996, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1996, 'Mazda', '626', 'Sedan 4-Door'],
    [1996, 'Mazda', 'B2300', 'Extended Cab Pickup 2-Door'],
    [1996, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [1996, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [1996, 'Mazda', 'B4000', 'Extended Cab Pickup 2-Door'],
    [1996, 'Mazda', 'B4000', 'Standard Cab Pickup 2-Door'],
    [1996, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1996, 'Mazda', 'Millenia', 'Sedan 4-Door'],
    [1996, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1996, 'Mazda', 'MX-3', 'Coupe 2-Door'],
    [1996, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1996, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'C220', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'C36 AMG', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'S320', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'S420', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'S500', 'Coupe 2-Door'],
    [1996, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'S600', 'Coupe 2-Door'],
    [1996, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [1996, 'Mercedes-Benz', 'SL320', 'Convertible 2-Door'],
    [1996, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [1996, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [1996, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1996, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1996, 'Mercury', 'Mystique', 'Sedan 4-Door'],
    [1996, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1996, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1996, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1996, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1996, 'Mercury', 'Villager', 'Mini Cargo Van 3-Door'],
    [1996, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [1996, 'Mitsubishi', '3000GT', 'Convertible 2-Door'],
    [1996, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1996, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [1996, 'Mitsubishi', 'Eclipse', 'Convertible 2-Door'],
    [1996, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1996, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1996, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1996, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [1996, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1996, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1996, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1996, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1996, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1996, 'Nissan', '300ZX', 'Convertible 2-Door'],
    [1996, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1996, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [1996, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1996, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1996, 'Nissan', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1996, 'Nissan', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1996, 'Nissan', 'Quest', 'Mini Passenger Van 3-Door'],
    [1996, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1996, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1996, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1996, 'Oldsmobile', 'Achieva', 'Coupe 2-Door'],
    [1996, 'Oldsmobile', 'Achieva', 'Sedan 4-Door'],
    [1996, 'Oldsmobile', 'Aurora', 'Sedan 4-Door'],
    [1996, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [1996, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1996, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1996, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1996, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1996, 'Oldsmobile', 'LSS', 'Sedan 4-Door'],
    [1996, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 3-Door'],
    [1996, 'Plymouth', 'Breeze', 'Sedan 4-Door'],
    [1996, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1996, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 4-Door'],
    [1996, 'Plymouth', 'Neon', 'Coupe 2-Door'],
    [1996, 'Plymouth', 'Neon', 'Sedan 4-Door'],
    [1996, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1996, 'Plymouth', 'Voyager', 'Mini Passenger Van 4-Door'],
    [1996, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1996, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1996, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1996, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1996, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1996, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1996, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1996, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1996, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1996, 'Pontiac', 'Sunfire', 'Convertible 2-Door'],
    [1996, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [1996, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [1996, 'Pontiac', 'Sunrunner', 'SUV 2-Door'],
    [1996, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1996, 'Porsche', '911', 'Convertible 2-Door'],
    [1996, 'Porsche', '911', 'Coupe 2-Door'],
    [1996, 'Porsche', '911', 'Targa 2-Door'],
    [1996, 'Rolls-Royce', 'Silver Dawn', 'Sedan 4-Door'],
    [1996, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1996, 'Saab', '900', 'Convertible 2-Door'],
    [1996, 'Saab', '900', 'Hatchback 2-Door'],
    [1996, 'Saab', '900', 'Hatchback 4-Door'],
    [1996, 'Saab', '9000', 'Hatchback 4-Door'],
    [1996, 'Saturn', 'SC1', 'Coupe 2-Door'],
    [1996, 'Saturn', 'SC2', 'Coupe 2-Door'],
    [1996, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1996, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1996, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1996, 'Saturn', 'SW1', 'Wagon 4-Door'],
    [1996, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [1996, 'Subaru', 'Impreza', 'Coupe 2-Door'],
    [1996, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [1996, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [1996, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1996, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1996, 'Subaru', 'SVX', 'Coupe 2-Door'],
    [1996, 'Suzuki', 'Esteem', 'Sedan 4-Door'],
    [1996, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1996, 'Suzuki', 'Sidekick', 'SUV 4-Door'],
    [1996, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1996, 'Suzuki', 'X-90', 'SUV 2-Door'],
    [1996, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1996, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [1996, 'Toyota', 'Camry', 'Coupe 2-Door'],
    [1996, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1996, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1996, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1996, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1996, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1996, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1996, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1996, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1996, 'Toyota', 'Paseo', 'Coupe 2-Door'],
    [1996, 'Toyota', 'Previa', 'Mini Passenger Van 3-Door'],
    [1996, 'Toyota', 'RAV4', 'SUV 2-Door'],
    [1996, 'Toyota', 'RAV4', 'SUV 4-Door'],
    [1996, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1996, 'Toyota', 'T100', 'Extended Cab Pickup 2-Door'],
    [1996, 'Toyota', 'T100', 'Standard Cab Pickup 2-Door'],
    [1996, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [1996, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [1996, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1996, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1996, 'Volkswagen', 'Cabrio', 'Convertible 2-Door'],
    [1996, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [1996, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1996, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1996, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1996, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1996, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1996, 'Volvo', '850', 'Sedan 4-Door'],
    [1996, 'Volvo', '850', 'Wagon 4-Door'],
    [1996, 'Volvo', '960', 'Sedan 4-Door'],
    [1996, 'Volvo', '960', 'Wagon 4-Door'],
    [1995, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1995, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1995, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1995, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1995, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1995, 'Acura', 'TL', 'Sedan 4-Door'],
    [1995, 'Alfa Romeo', '164', 'Sedan 4-Door'],
    [1995, 'AM General', 'Hummer', 'SUV 2-Door'],
    [1995, 'AM General', 'Hummer', 'SUV 4-Door'],
    [1995, 'Audi', '90', 'Sedan 4-Door'],
    [1995, 'Audi', '90 Quattro', 'Sedan 4-Door'],
    [1995, 'Audi', 'A6', 'Sedan 4-Door'],
    [1995, 'Audi', 'A6', 'Wagon 4-Door'],
    [1995, 'Audi', 'A6 Quattro', 'Sedan 4-Door'],
    [1995, 'Audi', 'A6 Quattro', 'Wagon 4-Door'],
    [1995, 'Audi', 'Cabriolet', 'Convertible 2-Door'],
    [1995, 'Audi', 'S6', 'Sedan 4-Door'],
    [1995, 'Audi', 'S6', 'Wagon 4-Door'],
    [1995, 'Bentley', 'Brooklands', 'Sedan 4-Door'],
    [1995, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1995, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [1995, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1995, 'BMW', '318i', 'Convertible 2-Door'],
    [1995, 'BMW', '318i', 'Sedan 4-Door'],
    [1995, 'BMW', '318is', 'Coupe 2-Door'],
    [1995, 'BMW', '318ti', 'Hatchback 2-Door'],
    [1995, 'BMW', '320i', 'Sedan 4-Door'],
    [1995, 'BMW', '325i', 'Convertible 2-Door'],
    [1995, 'BMW', '325i', 'Sedan 4-Door'],
    [1995, 'BMW', '325is', 'Coupe 2-Door'],
    [1995, 'BMW', '525i', 'Sedan 4-Door'],
    [1995, 'BMW', '525i', 'Wagon 4-Door'],
    [1995, 'BMW', '530i', 'Sedan 4-Door'],
    [1995, 'BMW', '530i', 'Wagon 4-Door'],
    [1995, 'BMW', '540i', 'Sedan 4-Door'],
    [1995, 'BMW', '740i', 'Sedan 4-Door'],
    [1995, 'BMW', '740iL', 'Sedan 4-Door'],
    [1995, 'BMW', '750iL', 'Sedan 4-Door'],
    [1995, 'BMW', '840Ci', 'Coupe 2-Door'],
    [1995, 'BMW', '850Ci', 'Coupe 2-Door'],
    [1995, 'BMW', '850CSi', 'Coupe 2-Door'],
    [1995, 'BMW', 'M3', 'Coupe 2-Door'],
    [1995, 'Buick', 'Century', 'Sedan 4-Door'],
    [1995, 'Buick', 'Century', 'Wagon 4-Door'],
    [1995, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1995, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1995, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1995, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1995, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1995, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1995, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1995, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1995, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1995, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1995, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1995, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1995, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1995, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1995, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1995, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1995, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1995, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1995, 'Chevrolet', 'Blazer', 'SUV 4-Door'],
    [1995, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'C1500 Suburban', 'SUV 4-Door'],
    [1995, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'C2500 Suburban', 'SUV 4-Door'],
    [1995, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1995, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1995, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1995, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1995, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1995, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1995, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1995, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1995, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1995, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1995, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1995, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1995, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1995, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1995, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1995, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1995, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1995, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1995, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'K1500 Suburban', 'SUV 4-Door'],
    [1995, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'K2500 Suburban', 'SUV 4-Door'],
    [1995, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1995, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1995, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1995, 'Chevrolet', 'Lumina APV', 'Mini Cargo Van 3-Door'],
    [1995, 'Chevrolet', 'Lumina APV', 'Mini Passenger Van 3-Door'],
    [1995, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1995, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'S10', 'Extended Cab Pickup 3-Door'],
    [1995, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1995, 'Chevrolet', 'Tahoe', 'SUV 2-Door'],
    [1995, 'Chevrolet', 'Tahoe', 'SUV 4-Door'],
    [1995, 'Chrysler', 'Cirrus', 'Sedan 4-Door'],
    [1995, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [1995, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [1995, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1995, 'Chrysler', 'LHS', 'Sedan 4-Door'],
    [1995, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1995, 'Chrysler', 'Sebring', 'Coupe 2-Door'],
    [1995, 'Chrysler', 'Town & Country', 'Mini Passenger Van 3-Door'],
    [1995, 'Dodge', 'Avenger', 'Coupe 2-Door'],
    [1995, 'Dodge', 'B1500', 'Standard Cargo Van 3-Door'],
    [1995, 'Dodge', 'B1500', 'Standard Passenger Van 3-Door'],
    [1995, 'Dodge', 'B2500', 'Extended Cargo Van 3-Door'],
    [1995, 'Dodge', 'B2500', 'Extended Passenger Van 3-Door'],
    [1995, 'Dodge', 'B2500', 'Standard Cargo Van 3-Door'],
    [1995, 'Dodge', 'B2500', 'Standard Passenger Van 3-Door'],
    [1995, 'Dodge', 'B3500', 'Extended Cargo Van 3-Door'],
    [1995, 'Dodge', 'B3500', 'Extended Passenger Van 3-Door'],
    [1995, 'Dodge', 'B3500', 'Standard Cargo Van 3-Door'],
    [1995, 'Dodge', 'B3500', 'Standard Passenger Van 3-Door'],
    [1995, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [1995, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1995, 'Dodge', 'Colt', 'Sedan 2-Door'],
    [1995, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1995, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1995, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1995, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [1995, 'Dodge', 'Neon', 'Coupe 2-Door'],
    [1995, 'Dodge', 'Neon', 'Sedan 4-Door'],
    [1995, 'Dodge', 'Ram 1500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Dodge', 'Ram 2500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Dodge', 'Ram 3500', 'Extended Cab Pickup 2-Door'],
    [1995, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [1995, 'Dodge', 'Spirit', 'Sedan 4-Door'],
    [1995, 'Dodge', 'Stealth', 'Hatchback 2-Door'],
    [1995, 'Dodge', 'Stratus', 'Sedan 4-Door'],
    [1995, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [1995, 'Eagle', 'Summit', 'Coupe 2-Door'],
    [1995, 'Eagle', 'Summit', 'Sedan 4-Door'],
    [1995, 'Eagle', 'Summit', 'Wagon 3-Door'],
    [1995, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1995, 'Eagle', 'Vision', 'Sedan 4-Door'],
    [1995, 'Ferrari', '348 Spider', 'Convertible 2-Door'],
    [1995, 'Ferrari', '456 GT', 'Coupe 2-Door'],
    [1995, 'Ferrari', '512 M', 'Coupe 2-Door'],
    [1995, 'Ferrari', 'F355 Berlinetta', 'Coupe 2-Door'],
    [1995, 'Ferrari', 'F355 GTS', 'Coupe 2-Door'],
    [1995, 'Ferrari', 'F50', 'Coupe 2-Door'],
    [1995, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1995, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1995, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1995, 'Ford', 'Aspire', 'Hatchback 2-Door'],
    [1995, 'Ford', 'Aspire', 'Hatchback 4-Door'],
    [1995, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1995, 'Ford', 'Contour', 'Sedan 4-Door'],
    [1995, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [1995, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1995, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1995, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1995, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1995, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1995, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1995, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1995, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1995, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1995, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1995, 'Ford', 'Escort', 'Sedan 4-Door'],
    [1995, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1995, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1995, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1995, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1995, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1995, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1995, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1995, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1995, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1995, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1995, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1995, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [1995, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1995, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1995, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1995, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1995, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1995, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1995, 'Ford', 'Windstar', 'Mini Cargo Van 3-Door'],
    [1995, 'Ford', 'Windstar', 'Mini Passenger Van 3-Door'],
    [1995, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1995, 'Geo', 'Metro', 'Sedan 4-Door'],
    [1995, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1995, 'Geo', 'Tracker', 'Convertible 2-Door'],
    [1995, 'Geo', 'Tracker', 'Hardtop 2-Door'],
    [1995, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1995, 'GMC', 'C1500', 'Extended Cab Pickup 3-Door'],
    [1995, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1995, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1995, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1995, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1995, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1995, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1995, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1995, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1995, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1995, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1995, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1995, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1995, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1995, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1995, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1995, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1995, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1995, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1995, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1995, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1995, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [1995, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1995, 'GMC', 'K1500', 'Extended Cab Pickup 3-Door'],
    [1995, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1995, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1995, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1995, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1995, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1995, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1995, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1995, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1995, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1995, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1995, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1995, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1995, 'GMC', 'Yukon', 'SUV 2-Door'],
    [1995, 'GMC', 'Yukon', 'SUV 4-Door'],
    [1995, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1995, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1995, 'Honda', 'Accord', 'Wagon 5-Door'],
    [1995, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1995, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1995, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1995, 'Honda', 'Civic del Sol', 'Coupe 2-Door'],
    [1995, 'Honda', 'Odyssey', 'Mini Passenger Van 5-Door'],
    [1995, 'Honda', 'Passport', 'SUV 4-Door'],
    [1995, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1995, 'Hyundai', 'Accent', 'Hatchback 2-Door'],
    [1995, 'Hyundai', 'Accent', 'Sedan 4-Door'],
    [1995, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [1995, 'Hyundai', 'Scoupe', 'Coupe 2-Door'],
    [1995, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1995, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [1995, 'INFINITI', 'J30', 'Sedan 4-Door'],
    [1995, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1995, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1995, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1995, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1995, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1995, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1995, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1995, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1995, 'Jaguar', 'XJR', 'Sedan 4-Door'],
    [1995, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1995, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1995, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1995, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1995, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [1995, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1995, 'Kia', 'Sephia', 'Sedan 4-Door'],
    [1995, 'Kia', 'Sportage', 'SUV 4-Door'],
    [1995, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1995, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1995, 'Land Rover', 'Defender 90', 'SUV 2-Door'],
    [1995, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [1995, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1995, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [1995, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [1995, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1995, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [1995, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [1995, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1995, 'Lincoln', 'Mark VIII', 'Sedan 2-Door'],
    [1995, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1995, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1995, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1995, 'Mazda', '323', 'Hatchback 2-Door'],
    [1995, 'Mazda', '626', 'Sedan 4-Door'],
    [1995, 'Mazda', '929', 'Sedan 4-Door'],
    [1995, 'Mazda', 'B2300', 'Extended Cab Pickup 2-Door'],
    [1995, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [1995, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [1995, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [1995, 'Mazda', 'B4000', 'Extended Cab Pickup 2-Door'],
    [1995, 'Mazda', 'B4000', 'Standard Cab Pickup 2-Door'],
    [1995, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1995, 'Mazda', 'Millenia', 'Sedan 4-Door'],
    [1995, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1995, 'Mazda', 'MX-3', 'Coupe 2-Door'],
    [1995, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1995, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1995, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1995, 'Mercedes-Benz', 'C220', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'C36 AMG', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'E300', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'E320', 'Convertible 2-Door'],
    [1995, 'Mercedes-Benz', 'E320', 'Coupe 2-Door'],
    [1995, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [1995, 'Mercedes-Benz', 'E420', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'S320', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'S350', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'S420', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'S500', 'Coupe 2-Door'],
    [1995, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'S600', 'Coupe 2-Door'],
    [1995, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [1995, 'Mercedes-Benz', 'SL320', 'Convertible 2-Door'],
    [1995, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [1995, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [1995, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1995, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1995, 'Mercury', 'Mystique', 'Sedan 4-Door'],
    [1995, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1995, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1995, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1995, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1995, 'Mercury', 'Villager', 'Mini Cargo Van 3-Door'],
    [1995, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [1995, 'Mitsubishi', '3000GT', 'Convertible 2-Door'],
    [1995, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1995, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [1995, 'Mitsubishi', 'Diamante', 'Wagon 4-Door'],
    [1995, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1995, 'Mitsubishi', 'Expo', 'Wagon 4-Door'],
    [1995, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1995, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1995, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [1995, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1995, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1995, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1995, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1995, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1995, 'Nissan', '300ZX', 'Convertible 2-Door'],
    [1995, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1995, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [1995, 'Nissan', 'Axxess', 'Wagon 4-Door'],
    [1995, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1995, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1995, 'Nissan', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1995, 'Nissan', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1995, 'Nissan', 'Quest', 'Mini Passenger Van 3-Door'],
    [1995, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1995, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1995, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1995, 'Oldsmobile', 'Achieva', 'Coupe 2-Door'],
    [1995, 'Oldsmobile', 'Achieva', 'Sedan 4-Door'],
    [1995, 'Oldsmobile', 'Aurora', 'Sedan 4-Door'],
    [1995, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1995, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1995, 'Oldsmobile', 'Cutlass Supreme', 'Convertible 2-Door'],
    [1995, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1995, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1995, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 3-Door'],
    [1995, 'Plymouth', 'Acclaim', 'Sedan 4-Door'],
    [1995, 'Plymouth', 'Colt', 'Coupe 2-Door'],
    [1995, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1995, 'Plymouth', 'Neon', 'Coupe 2-Door'],
    [1995, 'Plymouth', 'Neon', 'Sedan 4-Door'],
    [1995, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1995, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1995, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1995, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1995, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1995, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1995, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1995, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1995, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1995, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1995, 'Pontiac', 'Sunfire', 'Convertible 2-Door'],
    [1995, 'Pontiac', 'Sunfire', 'Coupe 2-Door'],
    [1995, 'Pontiac', 'Sunfire', 'Sedan 4-Door'],
    [1995, 'Pontiac', 'Sunrunner', 'SUV 2-Door'],
    [1995, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1995, 'Porsche', '911', 'Convertible 2-Door'],
    [1995, 'Porsche', '911', 'Coupe 2-Door'],
    [1995, 'Porsche', '928', 'Coupe 2-Door'],
    [1995, 'Porsche', '968', 'Convertible 2-Door'],
    [1995, 'Porsche', '968', 'Coupe 2-Door'],
    [1995, 'Rolls-Royce', 'Corniche IV', 'Convertible 2-Door'],
    [1995, 'Rolls-Royce', 'Corniche S', 'Convertible 2-Door'],
    [1995, 'Rolls-Royce', 'Flying Spur', 'Sedan 4-Door'],
    [1995, 'Rolls-Royce', 'Silver Dawn', 'Sedan 4-Door'],
    [1995, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1995, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1995, 'Saab', '900', 'Convertible 2-Door'],
    [1995, 'Saab', '900', 'Hatchback 2-Door'],
    [1995, 'Saab', '900', 'Hatchback 4-Door'],
    [1995, 'Saab', '9000', 'Hatchback 4-Door'],
    [1995, 'Saab', '9000', 'Sedan 4-Door'],
    [1995, 'Saturn', 'SC1', 'Coupe 2-Door'],
    [1995, 'Saturn', 'SC2', 'Coupe 2-Door'],
    [1995, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1995, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1995, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1995, 'Saturn', 'SW1', 'Wagon 4-Door'],
    [1995, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [1995, 'Subaru', 'Impreza', 'Coupe 2-Door'],
    [1995, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [1995, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [1995, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1995, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1995, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1995, 'Subaru', 'SVX', 'Coupe 2-Door'],
    [1995, 'Suzuki', 'Esteem', 'Sedan 4-Door'],
    [1995, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1995, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1995, 'Suzuki', 'Sidekick', 'SUV 4-Door'],
    [1995, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1995, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1995, 'Toyota', 'Avalon', 'Sedan 4-Door'],
    [1995, 'Toyota', 'Camry', 'Coupe 2-Door'],
    [1995, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1995, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1995, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1995, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1995, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1995, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1995, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1995, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1995, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1995, 'Toyota', 'Paseo', 'Coupe 2-Door'],
    [1995, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1995, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1995, 'Toyota', 'Previa', 'Mini Passenger Van 3-Door'],
    [1995, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1995, 'Toyota', 'T100', 'Extended Cab Pickup 2-Door'],
    [1995, 'Toyota', 'T100', 'Standard Cab Pickup 2-Door'],
    [1995, 'Toyota', 'Tacoma', 'Extended Cab Pickup 2-Door'],
    [1995, 'Toyota', 'Tacoma', 'Standard Cab Pickup 2-Door'],
    [1995, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1995, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1995, 'Volkswagen', 'Cabrio', 'Convertible 2-Door'],
    [1995, 'Volkswagen', 'Corrado', 'Coupe 2-Door'],
    [1995, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [1995, 'Volkswagen', 'EuroVan', 'Van Camper 3-Door'],
    [1995, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1995, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1995, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1995, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1995, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1995, 'Volvo', '850', 'Sedan 4-Door'],
    [1995, 'Volvo', '850', 'Wagon 4-Door'],
    [1995, 'Volvo', '940', 'Sedan 4-Door'],
    [1995, 'Volvo', '940', 'Wagon 4-Door'],
    [1995, 'Volvo', '960', 'Sedan 4-Door'],
    [1995, 'Volvo', '960', 'Wagon 4-Door'],
    [1994, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1994, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1994, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1994, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1994, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1994, 'Acura', 'Vigor', 'Sedan 4-Door'],
    [1994, 'Alfa Romeo', '164', 'Sedan 4-Door'],
    [1994, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1994, 'AM General', 'Hummer', 'SUV 0-Door'],
    [1994, 'AM General', 'Hummer', 'SUV 2-Door'],
    [1994, 'AM General', 'Hummer', 'SUV 4-Door'],
    [1994, 'Aston Martin', 'Virage', 'Convertible 2-Door'],
    [1994, 'Aston Martin', 'Virage', 'Coupe 2-Door'],
    [1994, 'Audi', '90', 'Sedan 4-Door'],
    [1994, 'Audi', '100', 'Sedan 4-Door'],
    [1994, 'Audi', '100', 'Wagon 4-Door'],
    [1994, 'Audi', '100 Quattro', 'Sedan 4-Door'],
    [1994, 'Audi', '100 Quattro', 'Wagon 4-Door'],
    [1994, 'Audi', '90 Quattro', 'Sedan 4-Door'],
    [1994, 'Audi', 'Cabriolet', 'Convertible 2-Door'],
    [1994, 'Audi', 'S4', 'Sedan 4-Door'],
    [1994, 'Audi', 'V8 Quattro', 'Sedan 4-Door'],
    [1994, 'Bentley', 'Brooklands', 'Sedan 4-Door'],
    [1994, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1994, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [1994, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1994, 'BMW', '318i', 'Convertible 2-Door'],
    [1994, 'BMW', '318i', 'Sedan 4-Door'],
    [1994, 'BMW', '318is', 'Coupe 2-Door'],
    [1994, 'BMW', '320i', 'Sedan 4-Door'],
    [1994, 'BMW', '325i', 'Convertible 2-Door'],
    [1994, 'BMW', '325i', 'Sedan 4-Door'],
    [1994, 'BMW', '325is', 'Coupe 2-Door'],
    [1994, 'BMW', '525i', 'Sedan 4-Door'],
    [1994, 'BMW', '525i', 'Wagon 4-Door'],
    [1994, 'BMW', '530i', 'Sedan 4-Door'],
    [1994, 'BMW', '530i', 'Wagon 4-Door'],
    [1994, 'BMW', '540i', 'Sedan 4-Door'],
    [1994, 'BMW', '740i', 'Sedan 4-Door'],
    [1994, 'BMW', '740iL', 'Sedan 4-Door'],
    [1994, 'BMW', '750iL', 'Sedan 4-Door'],
    [1994, 'BMW', '840Ci', 'Coupe 2-Door'],
    [1994, 'BMW', '850Ci', 'Coupe 2-Door'],
    [1994, 'BMW', '850CSi', 'Coupe 2-Door'],
    [1994, 'BMW', 'M3', 'Coupe 2-Door'],
    [1994, 'Buick', 'Century', 'Sedan 4-Door'],
    [1994, 'Buick', 'Century', 'Wagon 4-Door'],
    [1994, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1994, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1994, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1994, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1994, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1994, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1994, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1994, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1994, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1994, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1994, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1994, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1994, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1994, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1994, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1994, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1994, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1994, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'C1500 Suburban', 'SUV 4-Door'],
    [1994, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'C2500 Suburban', 'SUV 4-Door'],
    [1994, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1994, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1994, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1994, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1994, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1994, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1994, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1994, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1994, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1994, 'Chevrolet', 'Commercial Chassis', 'Hearse 2-Door'],
    [1994, 'Chevrolet', 'Commercial Chassis', 'Limousine 4-Door'],
    [1994, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1994, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1994, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1994, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1994, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1994, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1994, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1994, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1994, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1994, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'K1500 Suburban', 'SUV 4-Door'],
    [1994, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'K2500 Suburban', 'SUV 4-Door'],
    [1994, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1994, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1994, 'Chevrolet', 'Lumina', 'Coupe 2-Door'],
    [1994, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1994, 'Chevrolet', 'Lumina APV', 'Mini Cargo Van 3-Door'],
    [1994, 'Chevrolet', 'Lumina APV', 'Mini Passenger Van 3-Door'],
    [1994, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1994, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1994, 'Chevrolet', 'S10 Blazer', 'SUV 4-Door'],
    [1994, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [1994, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [1994, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1994, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1994, 'Chrysler', 'LHS', 'Sedan 4-Door'],
    [1994, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1994, 'Chrysler', 'Town & Country', 'Mini Passenger Van 3-Door'],
    [1994, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1994, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1994, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1994, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1994, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1994, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1994, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1994, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1994, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1994, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1994, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [1994, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1994, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1994, 'Dodge', 'Colt', 'Sedan 2-Door'],
    [1994, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1994, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1994, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1994, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1994, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1994, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [1994, 'Dodge', 'Ram 1500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Dodge', 'Ram 2500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Dodge', 'Ram 3500', 'Standard Cab Pickup 2-Door'],
    [1994, 'Dodge', 'Shadow', 'Hatchback 2-Door'],
    [1994, 'Dodge', 'Shadow', 'Hatchback 4-Door'],
    [1994, 'Dodge', 'Spirit', 'Sedan 4-Door'],
    [1994, 'Dodge', 'Stealth', 'Hatchback 2-Door'],
    [1994, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [1994, 'Eagle', 'Summit', 'Coupe 2-Door'],
    [1994, 'Eagle', 'Summit', 'Sedan 4-Door'],
    [1994, 'Eagle', 'Summit', 'Wagon 3-Door'],
    [1994, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1994, 'Eagle', 'Vision', 'Sedan 4-Door'],
    [1994, 'Ferrari', '348 GTB', 'Coupe 2-Door'],
    [1994, 'Ferrari', '348 GTS', 'Coupe 2-Door'],
    [1994, 'Ferrari', '348 Spider', 'Convertible 2-Door'],
    [1994, 'Ferrari', '512 TR', 'Coupe 2-Door'],
    [1994, 'Ferrari', 'F355 Berlinetta', 'Coupe 2-Door'],
    [1994, 'Ferrari', 'F355 GTS', 'Coupe 2-Door'],
    [1994, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1994, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1994, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1994, 'Ford', 'Aspire', 'Hatchback 2-Door'],
    [1994, 'Ford', 'Aspire', 'Hatchback 4-Door'],
    [1994, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1994, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [1994, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1994, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1994, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1994, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1994, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1994, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1994, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1994, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1994, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1994, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1994, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1994, 'Ford', 'Escort', 'Sedan 4-Door'],
    [1994, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1994, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1994, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1994, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1994, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1994, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1994, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1994, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1994, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1994, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1994, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1994, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [1994, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1994, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1994, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1994, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1994, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1994, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1994, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1994, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1994, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1994, 'Geo', 'Metro', 'Hatchback 4-Door'],
    [1994, 'Geo', 'Metro', 'Sedan 4-Door'],
    [1994, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1994, 'Geo', 'Tracker', 'Convertible 2-Door'],
    [1994, 'Geo', 'Tracker', 'Hardtop 2-Door'],
    [1994, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1994, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1994, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1994, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1994, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1994, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1994, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1994, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1994, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1994, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1994, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1994, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1994, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1994, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1994, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1994, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1994, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1994, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1994, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1994, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1994, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1994, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [1994, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1994, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1994, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1994, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1994, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1994, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1994, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1994, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1994, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1994, 'GMC', 'P3500', 'Standard Cargo Van 2-Door'],
    [1994, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1994, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1994, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1994, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1994, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1994, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1994, 'GMC', 'Yukon', 'SUV 2-Door'],
    [1994, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1994, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1994, 'Honda', 'Accord', 'Wagon 5-Door'],
    [1994, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1994, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1994, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1994, 'Honda', 'Civic del Sol', 'Coupe 2-Door'],
    [1994, 'Honda', 'Passport', 'SUV 4-Door'],
    [1994, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1994, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [1994, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1994, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1994, 'Hyundai', 'Scoupe', 'Coupe 2-Door'],
    [1994, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1994, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [1994, 'INFINITI', 'J30', 'Sedan 4-Door'],
    [1994, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1994, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [1994, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1994, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1994, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1994, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1994, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1994, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1994, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1994, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1994, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1994, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1994, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1994, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1994, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [1994, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1994, 'Kia', 'Sephia', 'Sedan 4-Door'],
    [1994, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1994, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1994, 'Land Rover', 'Defender 90', 'SUV 2-Door'],
    [1994, 'Land Rover', 'Discovery', 'SUV 4-Door'],
    [1994, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1994, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [1994, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [1994, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1994, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [1994, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [1994, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1994, 'Lincoln', 'Mark VIII', 'Sedan 2-Door'],
    [1994, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1994, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1994, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1994, 'Mazda', '323', 'Hatchback 2-Door'],
    [1994, 'Mazda', '626', 'Sedan 4-Door'],
    [1994, 'Mazda', '929', 'Sedan 4-Door'],
    [1994, 'Mazda', 'B2300', 'Extended Cab Pickup 2-Door'],
    [1994, 'Mazda', 'B2300', 'Standard Cab Pickup 2-Door'],
    [1994, 'Mazda', 'B3000', 'Extended Cab Pickup 2-Door'],
    [1994, 'Mazda', 'B3000', 'Standard Cab Pickup 2-Door'],
    [1994, 'Mazda', 'B4000', 'Extended Cab Pickup 2-Door'],
    [1994, 'Mazda', 'B4000', 'Standard Cab Pickup 2-Door'],
    [1994, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1994, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1994, 'Mazda', 'MX-3', 'Coupe 2-Door'],
    [1994, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1994, 'Mazda', 'Navajo', 'SUV 2-Door'],
    [1994, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1994, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1994, 'Mercedes-Benz', 'C220', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'C280', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'E320', 'Convertible 2-Door'],
    [1994, 'Mercedes-Benz', 'E320', 'Coupe 2-Door'],
    [1994, 'Mercedes-Benz', 'E320', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'E320', 'Wagon 4-Door'],
    [1994, 'Mercedes-Benz', 'E420', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'E500', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'S320', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'S350', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'S420', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'S500', 'Coupe 2-Door'],
    [1994, 'Mercedes-Benz', 'S500', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'S600', 'Coupe 2-Door'],
    [1994, 'Mercedes-Benz', 'S600', 'Sedan 4-Door'],
    [1994, 'Mercedes-Benz', 'SL320', 'Convertible 2-Door'],
    [1994, 'Mercedes-Benz', 'SL500', 'Convertible 2-Door'],
    [1994, 'Mercedes-Benz', 'SL600', 'Convertible 2-Door'],
    [1994, 'Mercury', 'Capri', 'Convertible 2-Door'],
    [1994, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1994, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1994, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1994, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1994, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1994, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1994, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1994, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1994, 'Mercury', 'Villager', 'Mini Cargo Van 3-Door'],
    [1994, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [1994, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1994, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [1994, 'Mitsubishi', 'Diamante', 'Wagon 4-Door'],
    [1994, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1994, 'Mitsubishi', 'Expo', 'Wagon 4-Door'],
    [1994, 'Mitsubishi', 'Expo LRV', 'Wagon 2-Door'],
    [1994, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1994, 'Mitsubishi', 'Mighty Max', 'Extended Cab Pickup 2-Door'],
    [1994, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1994, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [1994, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1994, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1994, 'Mitsubishi', 'Precis', 'Hatchback 2-Door'],
    [1994, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1994, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1994, 'Nissan', '240SX', 'Convertible 2-Door'],
    [1994, 'Nissan', '300ZX', 'Convertible 2-Door'],
    [1994, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1994, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [1994, 'Nissan', 'Axxess', 'Wagon 4-Door'],
    [1994, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1994, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1994, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1994, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1994, 'Nissan', 'Quest', 'Mini Passenger Van 3-Door'],
    [1994, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1994, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1994, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1994, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1994, 'Oldsmobile', 'Achieva', 'Coupe 2-Door'],
    [1994, 'Oldsmobile', 'Achieva', 'Sedan 4-Door'],
    [1994, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [1994, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1994, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1994, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1994, 'Oldsmobile', 'Cutlass Supreme', 'Convertible 2-Door'],
    [1994, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1994, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1994, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 3-Door'],
    [1994, 'Plymouth', 'Acclaim', 'Sedan 4-Door'],
    [1994, 'Plymouth', 'Colt', 'Sedan 2-Door'],
    [1994, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1994, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1994, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1994, 'Plymouth', 'Laser', 'Hatchback 2-Door'],
    [1994, 'Plymouth', 'Sundance', 'Hatchback 2-Door'],
    [1994, 'Plymouth', 'Sundance', 'Hatchback 4-Door'],
    [1994, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1994, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1994, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1994, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1994, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1994, 'Pontiac', 'Firefly', 'Hatchback 4-Door'],
    [1994, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1994, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1994, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1994, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1994, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1994, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1994, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1994, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1994, 'Pontiac', 'Sunrunner', 'SUV 2-Door'],
    [1994, 'Pontiac', 'Trans Sport', 'Mini Cargo Van 3-Door'],
    [1994, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1994, 'Porsche', '911', 'Convertible 2-Door'],
    [1994, 'Porsche', '911', 'Coupe 2-Door'],
    [1994, 'Porsche', '911', 'Targa 2-Door'],
    [1994, 'Porsche', '928', 'Coupe 2-Door'],
    [1994, 'Porsche', '968', 'Convertible 2-Door'],
    [1994, 'Porsche', '968', 'Coupe 2-Door'],
    [1994, 'Rolls-Royce', 'Corniche IV', 'Convertible 2-Door'],
    [1994, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1994, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1994, 'Rolls-Royce', 'Touring Limousine', 'Sedan 4-Door'],
    [1994, 'Saab', '900', 'Convertible 2-Door'],
    [1994, 'Saab', '900', 'Hatchback 2-Door'],
    [1994, 'Saab', '900', 'Hatchback 4-Door'],
    [1994, 'Saab', '9000', 'Hatchback 4-Door'],
    [1994, 'Saab', '9000', 'Sedan 4-Door'],
    [1994, 'Saturn', 'SC1', 'Coupe 2-Door'],
    [1994, 'Saturn', 'SC2', 'Coupe 2-Door'],
    [1994, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1994, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1994, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1994, 'Saturn', 'SW1', 'Wagon 4-Door'],
    [1994, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [1994, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [1994, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [1994, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1994, 'Subaru', 'Justy', 'Hatchback 4-Door'],
    [1994, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1994, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1994, 'Subaru', 'Loyale', 'Wagon 4-Door'],
    [1994, 'Subaru', 'SVX', 'Coupe 2-Door'],
    [1994, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1994, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1994, 'Suzuki', 'Sidekick', 'SUV 4-Door'],
    [1994, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1994, 'Suzuki', 'Swift', 'Sedan 4-Door'],
    [1994, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1994, 'Toyota', 'Camry', 'Coupe 2-Door'],
    [1994, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1994, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1994, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1994, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1994, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1994, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1994, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1994, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1994, 'Toyota', 'Paseo', 'Coupe 2-Door'],
    [1994, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1994, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1994, 'Toyota', 'Previa', 'Mini Passenger Van 3-Door'],
    [1994, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1994, 'Toyota', 'T100', 'Standard Cab Pickup 2-Door'],
    [1994, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1994, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1994, 'Volkswagen', 'Corrado', 'Coupe 2-Door'],
    [1994, 'Volkswagen', 'EuroVan', 'Standard Cargo Van 3-Door'],
    [1994, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [1994, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1994, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1994, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1994, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1994, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1994, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1994, 'Volvo', '850', 'Sedan 4-Door'],
    [1994, 'Volvo', '850', 'Wagon 4-Door'],
    [1994, 'Volvo', '940', 'Sedan 4-Door'],
    [1994, 'Volvo', '940', 'Wagon 4-Door'],
    [1994, 'Volvo', '960', 'Sedan 4-Door'],
    [1994, 'Volvo', '960', 'Wagon 4-Door'],
    [1993, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1993, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1993, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1993, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1993, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1993, 'Acura', 'Vigor', 'Sedan 4-Door'],
    [1993, 'Alfa Romeo', '164', 'Sedan 4-Door'],
    [1993, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1993, 'AM General', 'Hummer', 'SUV 0-Door'],
    [1993, 'AM General', 'Hummer', 'SUV 2-Door'],
    [1993, 'AM General', 'Hummer', 'SUV 4-Door'],
    [1993, 'Aston Martin', 'Virage', 'Convertible 2-Door'],
    [1993, 'Aston Martin', 'Virage', 'Coupe 2-Door'],
    [1993, 'Asuna', 'GT', 'Hatchback 2-Door'],
    [1993, 'Asuna', 'SE', 'Sedan 4-Door'],
    [1993, 'Asuna', 'Sunfire', 'Hatchback 2-Door'],
    [1993, 'Asuna', 'Sunrunner', 'SUV 2-Door'],
    [1993, 'Audi', '90', 'Sedan 4-Door'],
    [1993, 'Audi', '100', 'Sedan 4-Door'],
    [1993, 'Audi', '100 Quattro', 'Sedan 4-Door'],
    [1993, 'Audi', '100 Quattro', 'Wagon 4-Door'],
    [1993, 'Audi', '90 Quattro', 'Sedan 4-Door'],
    [1993, 'Audi', 'S4', 'Sedan 4-Door'],
    [1993, 'Audi', 'V8 Quattro', 'Sedan 4-Door'],
    [1993, 'Bentley', 'Brooklands', 'Sedan 4-Door'],
    [1993, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1993, 'Bentley', 'Continental', 'Coupe 2-Door'],
    [1993, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1993, 'BMW', '318i', 'Convertible 2-Door'],
    [1993, 'BMW', '318i', 'Sedan 4-Door'],
    [1993, 'BMW', '318is', 'Coupe 2-Door'],
    [1993, 'BMW', '320i', 'Sedan 4-Door'],
    [1993, 'BMW', '325i', 'Convertible 2-Door'],
    [1993, 'BMW', '325i', 'Sedan 4-Door'],
    [1993, 'BMW', '325is', 'Coupe 2-Door'],
    [1993, 'BMW', '525i', 'Sedan 4-Door'],
    [1993, 'BMW', '525i', 'Wagon 4-Door'],
    [1993, 'BMW', '525iT', 'Wagon 4-Door'],
    [1993, 'BMW', '535i', 'Sedan 4-Door'],
    [1993, 'BMW', '740i', 'Sedan 4-Door'],
    [1993, 'BMW', '740iL', 'Sedan 4-Door'],
    [1993, 'BMW', '750iL', 'Sedan 4-Door'],
    [1993, 'BMW', '850Ci', 'Coupe 2-Door'],
    [1993, 'BMW', 'M5', 'Sedan 4-Door'],
    [1993, 'Buick', 'Century', 'Coupe 2-Door'],
    [1993, 'Buick', 'Century', 'Sedan 4-Door'],
    [1993, 'Buick', 'Century', 'Wagon 4-Door'],
    [1993, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1993, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1993, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1993, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1993, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1993, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1993, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1993, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1993, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1993, 'Cadillac', '60 Special', 'Sedan 4-Door'],
    [1993, 'Cadillac', 'Allante', 'Convertible 2-Door'],
    [1993, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1993, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1993, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1993, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1993, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1993, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1993, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1993, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1993, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1993, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1993, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'C1500 Suburban', 'SUV 4-Door'],
    [1993, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'C2500 Suburban', 'SUV 4-Door'],
    [1993, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1993, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1993, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1993, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1993, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1993, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1993, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1993, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1993, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1993, 'Chevrolet', 'Commercial Chassis', 'Hearse 2-Door'],
    [1993, 'Chevrolet', 'Commercial Chassis', 'Limousine 4-Door'],
    [1993, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1993, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1993, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1993, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1993, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1993, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1993, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1993, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1993, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'K1500 Suburban', 'SUV 4-Door'],
    [1993, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'K2500 Suburban', 'SUV 4-Door'],
    [1993, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1993, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1993, 'Chevrolet', 'Lumina', 'Coupe 2-Door'],
    [1993, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1993, 'Chevrolet', 'Lumina APV', 'Mini Cargo Van 3-Door'],
    [1993, 'Chevrolet', 'Lumina APV', 'Mini Passenger Van 3-Door'],
    [1993, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1993, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1993, 'Chevrolet', 'S10 Blazer', 'SUV 4-Door'],
    [1993, 'Chrysler', 'Concorde', 'Sedan 4-Door'],
    [1993, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1993, 'Chrysler', 'Dynasty', 'Sedan 4-Door'],
    [1993, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1993, 'Chrysler', 'Intrepid', 'Sedan 4-Door'],
    [1993, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1993, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1993, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1993, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1993, 'Chrysler', 'Town & Country', 'Mini Passenger Van 3-Door'],
    [1993, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1993, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1993, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1993, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1993, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1993, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1993, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1993, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1993, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1993, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1993, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [1993, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1993, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1993, 'Dodge', 'Colt', 'Sedan 2-Door'],
    [1993, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1993, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1993, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1993, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1993, 'Dodge', 'D250', 'Extended Cab Pickup 2-Door'],
    [1993, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1993, 'Dodge', 'D350', 'Extended Cab Pickup 2-Door'],
    [1993, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1993, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1993, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1993, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1993, 'Dodge', 'Dynasty', 'Sedan 4-Door'],
    [1993, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1993, 'Dodge', 'Intrepid', 'Sedan 4-Door'],
    [1993, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1993, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1993, 'Dodge', 'Shadow', 'Convertible 2-Door'],
    [1993, 'Dodge', 'Shadow', 'Hatchback 2-Door'],
    [1993, 'Dodge', 'Shadow', 'Hatchback 4-Door'],
    [1993, 'Dodge', 'Spirit', 'Sedan 4-Door'],
    [1993, 'Dodge', 'Stealth', 'Hatchback 2-Door'],
    [1993, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [1993, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1993, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1993, 'Dodge', 'W250', 'Extended Cab Pickup 2-Door'],
    [1993, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1993, 'Dodge', 'W350', 'Extended Cab Pickup 2-Door'],
    [1993, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1993, 'Eagle', '2000 GTX', 'Sedan 4-Door'],
    [1993, 'Eagle', 'Summit', 'Coupe 2-Door'],
    [1993, 'Eagle', 'Summit', 'Sedan 4-Door'],
    [1993, 'Eagle', 'Summit', 'Wagon 3-Door'],
    [1993, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1993, 'Eagle', 'Vision', 'Sedan 4-Door'],
    [1993, 'Excalibur', 'Limited', 'Convertible 2-Door'],
    [1993, 'Ferrari', '348 GTB', 'Coupe 2-Door'],
    [1993, 'Ferrari', '348 GTS', 'Coupe 2-Door'],
    [1993, 'Ferrari', '348 Spider', 'Convertible 2-Door'],
    [1993, 'Ferrari', '512 TR', 'Coupe 2-Door'],
    [1993, 'Ferrari', 'Mondial t', 'Convertible 2-Door'],
    [1993, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1993, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1993, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1993, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1993, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [1993, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1993, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1993, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1993, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1993, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1993, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1993, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1993, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1993, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1993, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1993, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1993, 'Ford', 'Escort', 'Sedan 4-Door'],
    [1993, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1993, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1993, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1993, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1993, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1993, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1993, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1993, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1993, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1993, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1993, 'Ford', 'Festiva', 'Hatchback 2-Door'],
    [1993, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1993, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1993, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1993, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1993, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1993, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1993, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1993, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1993, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1993, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1993, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1993, 'Geo', 'Metro', 'Convertible 2-Door'],
    [1993, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1993, 'Geo', 'Metro', 'Hatchback 4-Door'],
    [1993, 'Geo', 'Metro', 'Sedan 4-Door'],
    [1993, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1993, 'Geo', 'Storm', 'Hatchback 2-Door'],
    [1993, 'Geo', 'Storm', 'Wagon 2-Door'],
    [1993, 'Geo', 'Tracker', 'Convertible 2-Door'],
    [1993, 'Geo', 'Tracker', 'Hardtop 2-Door'],
    [1993, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1993, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1993, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1993, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1993, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1993, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1993, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1993, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1993, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1993, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1993, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1993, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1993, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1993, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1993, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1993, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1993, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1993, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1993, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1993, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1993, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1993, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [1993, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1993, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1993, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1993, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1993, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1993, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1993, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1993, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1993, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1993, 'GMC', 'P3500', 'Standard Cargo Van 2-Door'],
    [1993, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1993, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1993, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1993, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1993, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1993, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1993, 'GMC', 'Typhoon', 'SUV 2-Door'],
    [1993, 'GMC', 'Yukon', 'SUV 2-Door'],
    [1993, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1993, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1993, 'Honda', 'Accord', 'Wagon 5-Door'],
    [1993, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1993, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1993, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1993, 'Honda', 'Civic del Sol', 'Coupe 2-Door'],
    [1993, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1993, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [1993, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1993, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1993, 'Hyundai', 'Scoupe', 'Coupe 2-Door'],
    [1993, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1993, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [1993, 'INFINITI', 'J30', 'Sedan 4-Door'],
    [1993, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1993, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [1993, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1993, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1993, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1993, 'Isuzu', 'Stylus', 'Sedan 4-Door'],
    [1993, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1993, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1993, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1993, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1993, 'Jaguar', 'XJRS', 'Convertible 2-Door'],
    [1993, 'Jaguar', 'XJRS', 'Coupe 2-Door'],
    [1993, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1993, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1993, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1993, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1993, 'Jeep', 'Grand Cherokee', 'SUV 4-Door'],
    [1993, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1993, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1993, 'Lada', 'Niva', 'SUV 2-Door'],
    [1993, 'Lada', 'Samara', 'Hatchback 2-Door'],
    [1993, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1993, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1993, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1993, 'Lamborghini', 'LM American', 'SUV 4-Door'],
    [1993, 'Land Rover', 'Defender 110', 'SUV 4-Door'],
    [1993, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1993, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [1993, 'Lexus', 'GS300', 'Sedan 4-Door'],
    [1993, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1993, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [1993, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [1993, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1993, 'Lincoln', 'Mark VIII', 'Sedan 2-Door'],
    [1993, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1993, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1993, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1993, 'Mazda', '323', 'Hatchback 2-Door'],
    [1993, 'Mazda', '626', 'Sedan 4-Door'],
    [1993, 'Mazda', '929', 'Sedan 4-Door'],
    [1993, 'Mazda', 'B2200', 'Extended Cab Pickup 2-Door'],
    [1993, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1993, 'Mazda', 'B2600', 'Extended Cab Pickup 2-Door'],
    [1993, 'Mazda', 'B2600', 'Standard Cab Pickup 2-Door'],
    [1993, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1993, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1993, 'Mazda', 'MX-3', 'Coupe 2-Door'],
    [1993, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1993, 'Mazda', 'Navajo', 'SUV 2-Door'],
    [1993, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1993, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1993, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '300CE', 'Convertible 2-Door'],
    [1993, 'Mercedes-Benz', '300CE', 'Coupe 2-Door'],
    [1993, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '300E', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '300SE', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '300SL', 'Convertible 2-Door'],
    [1993, 'Mercedes-Benz', '300TE', 'Wagon 4-Door'],
    [1993, 'Mercedes-Benz', '400E', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '400SEL', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '500E', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '500SEC', 'Coupe 2-Door'],
    [1993, 'Mercedes-Benz', '500SEL', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '500SL', 'Convertible 2-Door'],
    [1993, 'Mercedes-Benz', '600SEC', 'Coupe 2-Door'],
    [1993, 'Mercedes-Benz', '600SEL', 'Sedan 4-Door'],
    [1993, 'Mercedes-Benz', '600SL', 'Convertible 2-Door'],
    [1993, 'Mercury', 'Capri', 'Convertible 2-Door'],
    [1993, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1993, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1993, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1993, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1993, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1993, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1993, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1993, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1993, 'Mercury', 'Villager', 'Mini Cargo Van 3-Door'],
    [1993, 'Mercury', 'Villager', 'Mini Passenger Van 3-Door'],
    [1993, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1993, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [1993, 'Mitsubishi', 'Diamante', 'Wagon 4-Door'],
    [1993, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1993, 'Mitsubishi', 'Expo', 'Wagon 4-Door'],
    [1993, 'Mitsubishi', 'Expo LRV', 'Wagon 2-Door'],
    [1993, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1993, 'Mitsubishi', 'Mighty Max', 'Extended Cab Pickup 2-Door'],
    [1993, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1993, 'Mitsubishi', 'Mirage', 'Coupe 2-Door'],
    [1993, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1993, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1993, 'Mitsubishi', 'Precis', 'Hatchback 2-Door'],
    [1993, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1993, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1993, 'Nissan', '240SX', 'Convertible 2-Door'],
    [1993, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1993, 'Nissan', '240SX', 'Hatchback 2-Door'],
    [1993, 'Nissan', '300ZX', 'Convertible 2-Door'],
    [1993, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1993, 'Nissan', 'Altima', 'Sedan 4-Door'],
    [1993, 'Nissan', 'Axxess', 'Wagon 4-Door'],
    [1993, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1993, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1993, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1993, 'Nissan', 'NX', 'Coupe 2-Door'],
    [1993, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1993, 'Nissan', 'Quest', 'Mini Passenger Van 3-Door'],
    [1993, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1993, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1993, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1993, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1993, 'Oldsmobile', 'Achieva', 'Coupe 2-Door'],
    [1993, 'Oldsmobile', 'Achieva', 'Sedan 4-Door'],
    [1993, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [1993, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1993, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1993, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1993, 'Oldsmobile', 'Cutlass Supreme', 'Convertible 2-Door'],
    [1993, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1993, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1993, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 3-Door'],
    [1993, 'Plymouth', 'Acclaim', 'Sedan 4-Door'],
    [1993, 'Plymouth', 'Colt', 'Sedan 2-Door'],
    [1993, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1993, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1993, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1993, 'Plymouth', 'Laser', 'Hatchback 2-Door'],
    [1993, 'Plymouth', 'Sundance', 'Hatchback 2-Door'],
    [1993, 'Plymouth', 'Sundance', 'Hatchback 4-Door'],
    [1993, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1993, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1993, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1993, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1993, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1993, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1993, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1993, 'Pontiac', 'LeMans', 'Hatchback 2-Door'],
    [1993, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1993, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1993, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1993, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1993, 'Pontiac', 'Trans Sport', 'Mini Cargo Van 3-Door'],
    [1993, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1993, 'Porsche', '911', 'Convertible 2-Door'],
    [1993, 'Porsche', '911', 'Coupe 2-Door'],
    [1993, 'Porsche', '911', 'Targa 2-Door'],
    [1993, 'Porsche', '928', 'Coupe 2-Door'],
    [1993, 'Porsche', '968', 'Convertible 2-Door'],
    [1993, 'Porsche', '968', 'Coupe 2-Door'],
    [1993, 'Rolls-Royce', 'Corniche IV', 'Convertible 2-Door'],
    [1993, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1993, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1993, 'Saab', '900', 'Convertible 2-Door'],
    [1993, 'Saab', '900', 'Hatchback 2-Door'],
    [1993, 'Saab', '900', 'Sedan 4-Door'],
    [1993, 'Saab', '9000', 'Hatchback 4-Door'],
    [1993, 'Saab', '9000', 'Sedan 4-Door'],
    [1993, 'Saturn', 'SC1', 'Coupe 2-Door'],
    [1993, 'Saturn', 'SC2', 'Coupe 2-Door'],
    [1993, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1993, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1993, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1993, 'Saturn', 'SW1', 'Wagon 4-Door'],
    [1993, 'Saturn', 'SW2', 'Wagon 4-Door'],
    [1993, 'Subaru', 'Impreza', 'Sedan 4-Door'],
    [1993, 'Subaru', 'Impreza', 'Wagon 4-Door'],
    [1993, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1993, 'Subaru', 'Justy', 'Hatchback 4-Door'],
    [1993, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1993, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1993, 'Subaru', 'Loyale', 'Sedan 4-Door'],
    [1993, 'Subaru', 'Loyale', 'Wagon 4-Door'],
    [1993, 'Subaru', 'SVX', 'Coupe 2-Door'],
    [1993, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1993, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1993, 'Suzuki', 'Sidekick', 'SUV 4-Door'],
    [1993, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1993, 'Suzuki', 'Swift', 'Sedan 4-Door'],
    [1993, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1993, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1993, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1993, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1993, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1993, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1993, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1993, 'Toyota', 'Corolla', 'Wagon 4-Door'],
    [1993, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1993, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1993, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1993, 'Toyota', 'Paseo', 'Coupe 2-Door'],
    [1993, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1993, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1993, 'Toyota', 'Previa', 'Mini Passenger Van 3-Door'],
    [1993, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1993, 'Toyota', 'T100', 'Standard Cab Pickup 2-Door'],
    [1993, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1993, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1993, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1993, 'Volkswagen', 'Corrado', 'Coupe 2-Door'],
    [1993, 'Volkswagen', 'EuroVan', 'Standard Cargo Van 3-Door'],
    [1993, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [1993, 'Volkswagen', 'Fox', 'Sedan 2-Door'],
    [1993, 'Volkswagen', 'Fox', 'Sedan 4-Door'],
    [1993, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1993, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1993, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1993, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1993, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1993, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1993, 'Volvo', '240', 'Sedan 4-Door'],
    [1993, 'Volvo', '240', 'Wagon 4-Door'],
    [1993, 'Volvo', '850', 'Sedan 4-Door'],
    [1993, 'Volvo', '940', 'Sedan 4-Door'],
    [1993, 'Volvo', '940', 'Wagon 4-Door'],
    [1993, 'Volvo', '960', 'Sedan 4-Door'],
    [1993, 'Volvo', '960', 'Wagon 4-Door'],
    [1992, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1992, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1992, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1992, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1992, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1992, 'Acura', 'Vigor', 'Sedan 4-Door'],
    [1992, 'Alfa Romeo', '164', 'Sedan 4-Door'],
    [1992, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1992, 'AM General', 'Hummer', 'SUV 0-Door'],
    [1992, 'AM General', 'Hummer', 'SUV 2-Door'],
    [1992, 'AM General', 'Hummer', 'SUV 4-Door'],
    [1992, 'Aston Martin', 'Virage', 'Coupe 2-Door'],
    [1992, 'Asuna', 'Sunrunner', 'SUV 2-Door'],
    [1992, 'Audi', '80', 'Sedan 4-Door'],
    [1992, 'Audi', '100', 'Sedan 4-Door'],
    [1992, 'Audi', '100 Quattro', 'Sedan 4-Door'],
    [1992, 'Audi', '100 Quattro', 'Wagon 4-Door'],
    [1992, 'Audi', '80 Quattro', 'Sedan 4-Door'],
    [1992, 'Audi', '90 Quattro', 'Sedan 4-Door'],
    [1992, 'Audi', 'S4', 'Sedan 4-Door'],
    [1992, 'Audi', 'V8 Quattro', 'Sedan 4-Door'],
    [1992, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1992, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1992, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1992, 'BMW', '318i', 'Convertible 2-Door'],
    [1992, 'BMW', '318i', 'Sedan 4-Door'],
    [1992, 'BMW', '318is', 'Coupe 2-Door'],
    [1992, 'BMW', '320i', 'Sedan 4-Door'],
    [1992, 'BMW', '325i', 'Convertible 2-Door'],
    [1992, 'BMW', '325i', 'Sedan 4-Door'],
    [1992, 'BMW', '325is', 'Coupe 2-Door'],
    [1992, 'BMW', '525i', 'Sedan 4-Door'],
    [1992, 'BMW', '525i', 'Wagon 4-Door'],
    [1992, 'BMW', '535i', 'Sedan 4-Door'],
    [1992, 'BMW', '735i', 'Sedan 4-Door'],
    [1992, 'BMW', '735iL', 'Sedan 4-Door'],
    [1992, 'BMW', '750iL', 'Sedan 4-Door'],
    [1992, 'BMW', '850i', 'Coupe 2-Door'],
    [1992, 'BMW', 'M5', 'Sedan 4-Door'],
    [1992, 'Buick', 'Century', 'Coupe 2-Door'],
    [1992, 'Buick', 'Century', 'Sedan 4-Door'],
    [1992, 'Buick', 'Century', 'Wagon 4-Door'],
    [1992, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1992, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1992, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1992, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1992, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1992, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1992, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1992, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1992, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1992, 'Cadillac', 'Allante', 'Convertible 2-Door'],
    [1992, 'Cadillac', 'Brougham', 'Sedan 4-Door'],
    [1992, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1992, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1992, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1992, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1992, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1992, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1992, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1992, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1992, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1992, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1992, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1992, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'C1500 Suburban', 'SUV 4-Door'],
    [1992, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'C2500 Suburban', 'SUV 4-Door'],
    [1992, 'Chevrolet', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1992, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1992, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1992, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1992, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1992, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1992, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1992, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1992, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1992, 'Chevrolet', 'Commercial Chassis', 'Hearse 2-Door'],
    [1992, 'Chevrolet', 'Commercial Chassis', 'Limousine 4-Door'],
    [1992, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1992, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1992, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1992, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1992, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1992, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1992, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1992, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1992, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'K1500 Suburban', 'SUV 4-Door'],
    [1992, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'K2500 Suburban', 'SUV 4-Door'],
    [1992, 'Chevrolet', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1992, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1992, 'Chevrolet', 'Lumina', 'Coupe 2-Door'],
    [1992, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1992, 'Chevrolet', 'Lumina APV', 'Mini Cargo Van 3-Door'],
    [1992, 'Chevrolet', 'Lumina APV', 'Mini Passenger Van 3-Door'],
    [1992, 'Chevrolet', 'Metro', 'Hatchback 2-Door'],
    [1992, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1992, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1992, 'Chevrolet', 'S10 Blazer', 'SUV 4-Door'],
    [1992, 'Chevrolet', 'Sprint', 'Convertible 2-Door'],
    [1992, 'Chevrolet', 'Sprint', 'Hatchback 2-Door'],
    [1992, 'Chevrolet', 'Sprint', 'Hatchback 4-Door'],
    [1992, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1992, 'Chrysler', 'Dynasty', 'Sedan 4-Door'],
    [1992, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1992, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1992, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1992, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1992, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1992, 'Chrysler', 'Town & Country', 'Mini Passenger Van 3-Door'],
    [1992, 'Daihatsu', 'Charade', 'Hatchback 2-Door'],
    [1992, 'Daihatsu', 'Charade', 'Sedan 4-Door'],
    [1992, 'Daihatsu', 'Rocky', 'SUV 2-Door'],
    [1992, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1992, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1992, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1992, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1992, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1992, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1992, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1992, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1992, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1992, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1992, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [1992, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1992, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1992, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1992, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1992, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1992, 'Dodge', 'D250', 'Extended Cab Pickup 2-Door'],
    [1992, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1992, 'Dodge', 'D350', 'Extended Cab Pickup 2-Door'],
    [1992, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1992, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1992, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1992, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1992, 'Dodge', 'Dynasty', 'Sedan 4-Door'],
    [1992, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1992, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1992, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1992, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1992, 'Dodge', 'Shadow', 'Convertible 2-Door'],
    [1992, 'Dodge', 'Shadow', 'Hatchback 2-Door'],
    [1992, 'Dodge', 'Shadow', 'Hatchback 4-Door'],
    [1992, 'Dodge', 'Spirit', 'Sedan 4-Door'],
    [1992, 'Dodge', 'Stealth', 'Hatchback 2-Door'],
    [1992, 'Dodge', 'Viper', 'Convertible 2-Door'],
    [1992, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1992, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1992, 'Dodge', 'W250', 'Extended Cab Pickup 2-Door'],
    [1992, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1992, 'Dodge', 'W350', 'Extended Cab Pickup 2-Door'],
    [1992, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1992, 'Eagle', '2000 GTX', 'Sedan 4-Door'],
    [1992, 'Eagle', '2000 GTX', 'Wagon 4-Door'],
    [1992, 'Eagle', 'Premier', 'Sedan 4-Door'],
    [1992, 'Eagle', 'Summit', 'Hatchback 2-Door'],
    [1992, 'Eagle', 'Summit', 'Sedan 4-Door'],
    [1992, 'Eagle', 'Summit', 'Wagon 3-Door'],
    [1992, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1992, 'Eagle', 'Vista', 'Hatchback 2-Door'],
    [1992, 'Eagle', 'Vista', 'Sedan 4-Door'],
    [1992, 'Ferrari', '348 TB', 'Coupe 2-Door'],
    [1992, 'Ferrari', '348 TS', 'Coupe 2-Door'],
    [1992, 'Ferrari', '512 TR', 'Coupe 2-Door'],
    [1992, 'Ferrari', 'F40', 'Coupe 2-Door'],
    [1992, 'Ferrari', 'Mondial t', 'Convertible 2-Door'],
    [1992, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1992, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1992, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1992, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1992, 'Ford', 'Crown Victoria', 'Sedan 4-Door'],
    [1992, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1992, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1992, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1992, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1992, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1992, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1992, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1992, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1992, 'Ford', 'E-350 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1992, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1992, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1992, 'Ford', 'Escort', 'Sedan 4-Door'],
    [1992, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1992, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1992, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1992, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1992, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1992, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1992, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1992, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1992, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1992, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1992, 'Ford', 'Festiva', 'Hatchback 2-Door'],
    [1992, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1992, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1992, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1992, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1992, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1992, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1992, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1992, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1992, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1992, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1992, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1992, 'Geo', 'Metro', 'Convertible 2-Door'],
    [1992, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1992, 'Geo', 'Metro', 'Hatchback 4-Door'],
    [1992, 'Geo', 'Metro', 'Sedan 4-Door'],
    [1992, 'Geo', 'Prizm', 'Hatchback 4-Door'],
    [1992, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1992, 'Geo', 'Storm', 'Hatchback 2-Door'],
    [1992, 'Geo', 'Storm', 'Wagon 2-Door'],
    [1992, 'Geo', 'Tracker', 'Convertible 2-Door'],
    [1992, 'Geo', 'Tracker', 'Hardtop 2-Door'],
    [1992, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1992, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1992, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1992, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1992, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1992, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1992, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1992, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1992, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1992, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1992, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1992, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1992, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1992, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1992, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1992, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1992, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1992, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1992, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1992, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1992, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1992, 'GMC', 'Jimmy', 'SUV 4-Door'],
    [1992, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1992, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1992, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1992, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1992, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1992, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1992, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1992, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1992, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1992, 'GMC', 'P3500', 'Standard Cargo Van 2-Door'],
    [1992, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1992, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1992, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1992, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1992, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1992, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1992, 'GMC', 'Typhoon', 'SUV 2-Door'],
    [1992, 'GMC', 'Yukon', 'SUV 2-Door'],
    [1992, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1992, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1992, 'Honda', 'Accord', 'Wagon 5-Door'],
    [1992, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1992, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1992, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1992, 'Hyundai', 'Elantra', 'Sedan 4-Door'],
    [1992, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1992, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1992, 'Hyundai', 'Scoupe', 'Coupe 2-Door'],
    [1992, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1992, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [1992, 'INFINITI', 'M30', 'Convertible 2-Door'],
    [1992, 'INFINITI', 'M30', 'Coupe 2-Door'],
    [1992, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1992, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [1992, 'Isuzu', 'Impulse', 'Coupe 2-Door'],
    [1992, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1992, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1992, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1992, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1992, 'Isuzu', 'Stylus', 'Sedan 4-Door'],
    [1992, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1992, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1992, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1992, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1992, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1992, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1992, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1992, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1992, 'Jeep', 'Comanche', 'Standard Cab Pickup 2-Door'],
    [1992, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1992, 'Lada', 'Niva', 'SUV 2-Door'],
    [1992, 'Lada', 'Samara', 'Hatchback 2-Door'],
    [1992, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1992, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1992, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1992, 'Lamborghini', 'LM American', 'SUV 4-Door'],
    [1992, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1992, 'Lexus', 'ES300', 'Sedan 4-Door'],
    [1992, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1992, 'Lexus', 'SC300', 'Coupe 2-Door'],
    [1992, 'Lexus', 'SC400', 'Coupe 2-Door'],
    [1992, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1992, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1992, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1992, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1992, 'Lotus', 'Elan', 'Convertible 2-Door'],
    [1992, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1992, 'Mazda', '323', 'Hatchback 2-Door'],
    [1992, 'Mazda', '626', 'Sedan 4-Door'],
    [1992, 'Mazda', '929', 'Sedan 4-Door'],
    [1992, 'Mazda', 'B2200', 'Extended Cab Pickup 2-Door'],
    [1992, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1992, 'Mazda', 'B2600', 'Extended Cab Pickup 2-Door'],
    [1992, 'Mazda', 'B2600', 'Standard Cab Pickup 2-Door'],
    [1992, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1992, 'Mazda', 'MPV', 'Standard Cargo Van 3-Door'],
    [1992, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1992, 'Mazda', 'MX-3', 'Coupe 2-Door'],
    [1992, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1992, 'Mazda', 'Navajo', 'SUV 2-Door'],
    [1992, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '300CE', 'Coupe 2-Door'],
    [1992, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '300E', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '300SE', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '300SL', 'Convertible 2-Door'],
    [1992, 'Mercedes-Benz', '300TE', 'Wagon 4-Door'],
    [1992, 'Mercedes-Benz', '400E', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '400SE', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '500E', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '500SEL', 'Sedan 4-Door'],
    [1992, 'Mercedes-Benz', '500SL', 'Convertible 2-Door'],
    [1992, 'Mercedes-Benz', '600SEL', 'Sedan 4-Door'],
    [1992, 'Mercury', 'Capri', 'Convertible 2-Door'],
    [1992, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1992, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1992, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1992, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1992, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1992, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1992, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1992, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1992, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1992, 'Mitsubishi', 'Diamante', 'Sedan 4-Door'],
    [1992, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1992, 'Mitsubishi', 'Expo', 'Wagon 4-Door'],
    [1992, 'Mitsubishi', 'Expo LRV', 'Wagon 2-Door'],
    [1992, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1992, 'Mitsubishi', 'Mighty Max', 'Extended Cab Pickup 2-Door'],
    [1992, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1992, 'Mitsubishi', 'Mirage', 'Hatchback 2-Door'],
    [1992, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1992, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1992, 'Mitsubishi', 'Precis', 'Hatchback 2-Door'],
    [1992, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1992, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1992, 'Nissan', '240SX', 'Convertible 2-Door'],
    [1992, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1992, 'Nissan', '240SX', 'Hatchback 2-Door'],
    [1992, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1992, 'Nissan', 'Axxess', 'Wagon 4-Door'],
    [1992, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1992, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1992, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1992, 'Nissan', 'NX', 'Coupe 2-Door'],
    [1992, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1992, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1992, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1992, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1992, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1992, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1992, 'Oldsmobile', 'Achieva', 'Coupe 2-Door'],
    [1992, 'Oldsmobile', 'Achieva', 'Sedan 4-Door'],
    [1992, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [1992, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1992, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1992, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1992, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1992, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1992, 'Oldsmobile', 'Cutlass Supreme', 'Convertible 2-Door'],
    [1992, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1992, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1992, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 3-Door'],
    [1992, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1992, 'Plymouth', 'Acclaim', 'Sedan 4-Door'],
    [1992, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1992, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1992, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1992, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1992, 'Plymouth', 'Laser', 'Hatchback 2-Door'],
    [1992, 'Plymouth', 'Sundance', 'Hatchback 2-Door'],
    [1992, 'Plymouth', 'Sundance', 'Hatchback 4-Door'],
    [1992, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1992, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1992, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1992, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1992, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1992, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1992, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1992, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1992, 'Pontiac', 'LeMans', 'Hatchback 2-Door'],
    [1992, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1992, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1992, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1992, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1992, 'Pontiac', 'Trans Sport', 'Mini Cargo Van 3-Door'],
    [1992, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1992, 'Porsche', '911', 'Convertible 2-Door'],
    [1992, 'Porsche', '911', 'Coupe 2-Door'],
    [1992, 'Porsche', '911', 'Targa 2-Door'],
    [1992, 'Porsche', '968', 'Convertible 2-Door'],
    [1992, 'Porsche', '968', 'Coupe 2-Door'],
    [1992, 'Rolls-Royce', 'Corniche II', 'Convertible 2-Door'],
    [1992, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1992, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1992, 'Saab', '900', 'Convertible 2-Door'],
    [1992, 'Saab', '900', 'Hatchback 2-Door'],
    [1992, 'Saab', '900', 'Sedan 4-Door'],
    [1992, 'Saab', '9000', 'Hatchback 4-Door'],
    [1992, 'Saab', '9000', 'Sedan 4-Door'],
    [1992, 'Saturn', 'SC', 'Coupe 2-Door'],
    [1992, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1992, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1992, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1992, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1992, 'Subaru', 'Justy', 'Hatchback 4-Door'],
    [1992, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1992, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1992, 'Subaru', 'Loyale', 'Sedan 4-Door'],
    [1992, 'Subaru', 'Loyale', 'Wagon 4-Door'],
    [1992, 'Subaru', 'SVX', 'Coupe 2-Door'],
    [1992, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1992, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1992, 'Suzuki', 'Sidekick', 'SUV 4-Door'],
    [1992, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1992, 'Suzuki', 'Swift', 'Sedan 4-Door'],
    [1992, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1992, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1992, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1992, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1992, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1992, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1992, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1992, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1992, 'Toyota', 'Corolla', 'Wagon 4-Door'],
    [1992, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1992, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1992, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1992, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1992, 'Toyota', 'Paseo', 'Coupe 2-Door'],
    [1992, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1992, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1992, 'Toyota', 'Previa', 'Mini Passenger Van 3-Door'],
    [1992, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1992, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1992, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1992, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1992, 'Volkswagen', 'Corrado', 'Coupe 2-Door'],
    [1992, 'Volkswagen', 'EuroVan', 'Standard Cargo Van 3-Door'],
    [1992, 'Volkswagen', 'EuroVan', 'Standard Passenger Van 3-Door'],
    [1992, 'Volkswagen', 'Fox', 'Sedan 2-Door'],
    [1992, 'Volkswagen', 'Fox', 'Sedan 4-Door'],
    [1992, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1992, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1992, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1992, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1992, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1992, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1992, 'Volvo', '240', 'Sedan 4-Door'],
    [1992, 'Volvo', '240', 'Wagon 4-Door'],
    [1992, 'Volvo', '740', 'Sedan 4-Door'],
    [1992, 'Volvo', '740', 'Wagon 4-Door'],
    [1992, 'Volvo', '940', 'Sedan 4-Door'],
    [1992, 'Volvo', '940', 'Wagon 4-Door'],
    [1992, 'Volvo', '960', 'Sedan 4-Door'],
    [1992, 'Volvo', '960', 'Wagon 4-Door'],
    [1992, 'Yugo', 'Cabrio', 'Convertible 2-Door'],
    [1992, 'Yugo', 'GV', 'Hatchback 2-Door'],
    [1991, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1991, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1991, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1991, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1991, 'Acura', 'NSX', 'Coupe 2-Door'],
    [1991, 'Alfa Romeo', '164', 'Sedan 4-Door'],
    [1991, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1991, 'Aston Martin', 'Virage', 'Coupe 2-Door'],
    [1991, 'Audi', '80', 'Sedan 4-Door'],
    [1991, 'Audi', '90', 'Sedan 4-Door'],
    [1991, 'Audi', '100', 'Sedan 4-Door'],
    [1991, 'Audi', '200', 'Sedan 4-Door'],
    [1991, 'Audi', '100 Quattro', 'Sedan 4-Door'],
    [1991, 'Audi', '200 Quattro', 'Sedan 4-Door'],
    [1991, 'Audi', '200 Quattro', 'Wagon 4-Door'],
    [1991, 'Audi', '80 Quattro', 'Sedan 4-Door'],
    [1991, 'Audi', '90 Quattro', 'Sedan 4-Door'],
    [1991, 'Audi', 'Coupe Quattro', 'Coupe 2-Door'],
    [1991, 'Audi', 'V8 Quattro', 'Sedan 4-Door'],
    [1991, 'Avanti', 'II', 'Convertible 2-Door'],
    [1991, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1991, 'Bentley', 'Eight', 'Sedan 4-Door'],
    [1991, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1991, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1991, 'BMW', '318i', 'Convertible 2-Door'],
    [1991, 'BMW', '318i', 'Sedan 4-Door'],
    [1991, 'BMW', '318is', 'Coupe 2-Door'],
    [1991, 'BMW', '325i', 'Convertible 2-Door'],
    [1991, 'BMW', '325i', 'Coupe 2-Door'],
    [1991, 'BMW', '325i', 'Sedan 4-Door'],
    [1991, 'BMW', '325is', 'Coupe 2-Door'],
    [1991, 'BMW', '325iX', 'Coupe 2-Door'],
    [1991, 'BMW', '325iX', 'Sedan 4-Door'],
    [1991, 'BMW', '525i', 'Sedan 4-Door'],
    [1991, 'BMW', '535i', 'Sedan 4-Door'],
    [1991, 'BMW', '735i', 'Sedan 4-Door'],
    [1991, 'BMW', '735iL', 'Sedan 4-Door'],
    [1991, 'BMW', '750iL', 'Sedan 4-Door'],
    [1991, 'BMW', '850i', 'Coupe 2-Door'],
    [1991, 'BMW', 'M3', 'Coupe 2-Door'],
    [1991, 'BMW', 'M5', 'Sedan 4-Door'],
    [1991, 'Buick', 'Century', 'Coupe 2-Door'],
    [1991, 'Buick', 'Century', 'Sedan 4-Door'],
    [1991, 'Buick', 'Century', 'Wagon 4-Door'],
    [1991, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1991, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1991, 'Buick', 'Park Avenue', 'Sedan 4-Door'],
    [1991, 'Buick', 'Reatta', 'Convertible 2-Door'],
    [1991, 'Buick', 'Reatta', 'Coupe 2-Door'],
    [1991, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1991, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1991, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1991, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1991, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1991, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1991, 'Cadillac', 'Allante', 'Convertible 2-Door'],
    [1991, 'Cadillac', 'Brougham', 'Sedan 4-Door'],
    [1991, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1991, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1991, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1991, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1991, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1991, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1991, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1991, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1991, 'Chevrolet', 'Beretta', 'Convertible 2-Door'],
    [1991, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1991, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1991, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1991, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1991, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1991, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1991, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1991, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1991, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1991, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1991, 'Chevrolet', 'Commercial Chassis', 'Hearse 2-Door'],
    [1991, 'Chevrolet', 'Commercial Chassis', 'Limousine 4-Door'],
    [1991, 'Chevrolet', 'Corsica', 'Hatchback 4-Door'],
    [1991, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1991, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1991, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1991, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1991, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1991, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1991, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1991, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1991, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1991, 'Chevrolet', 'Lumina', 'Coupe 2-Door'],
    [1991, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1991, 'Chevrolet', 'Lumina APV', 'Mini Cargo Van 3-Door'],
    [1991, 'Chevrolet', 'Lumina APV', 'Mini Passenger Van 3-Door'],
    [1991, 'Chevrolet', 'R1500 Suburban', 'SUV 4-Door'],
    [1991, 'Chevrolet', 'R2500 Suburban', 'SUV 4-Door'],
    [1991, 'Chevrolet', 'R3500', 'Crew Cab Pickup 4-Door'],
    [1991, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1991, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1991, 'Chevrolet', 'S10 Blazer', 'SUV 4-Door'],
    [1991, 'Chevrolet', 'Sprint', 'Convertible 2-Door'],
    [1991, 'Chevrolet', 'Sprint', 'Hatchback 2-Door'],
    [1991, 'Chevrolet', 'Sprint', 'Hatchback 4-Door'],
    [1991, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [1991, 'Chevrolet', 'V1500 Suburban', 'SUV 4-Door'],
    [1991, 'Chevrolet', 'V2500 Suburban', 'SUV 4-Door'],
    [1991, 'Chevrolet', 'V3500', 'Crew Cab Pickup 4-Door'],
    [1991, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1991, 'Chrysler', 'Dynasty', 'Sedan 4-Door'],
    [1991, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1991, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1991, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1991, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1991, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1991, 'Chrysler', 'TC Maserati', 'Convertible 2-Door'],
    [1991, 'Chrysler', 'Town & Country', 'Mini Passenger Van 3-Door'],
    [1991, 'Daihatsu', 'Charade', 'Hatchback 2-Door'],
    [1991, 'Daihatsu', 'Charade', 'Sedan 4-Door'],
    [1991, 'Daihatsu', 'Rocky', 'SUV 2-Door'],
    [1991, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1991, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1991, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1991, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1991, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1991, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1991, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1991, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1991, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1991, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1991, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [1991, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1991, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1991, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1991, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1991, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1991, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1991, 'Dodge', 'D250', 'Extended Cab Pickup 2-Door'],
    [1991, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1991, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1991, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1991, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1991, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1991, 'Dodge', 'Dynasty', 'Sedan 4-Door'],
    [1991, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1991, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1991, 'Dodge', 'Ram 50', 'Extended Cab Pickup 2-Door'],
    [1991, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1991, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1991, 'Dodge', 'Shadow', 'Convertible 2-Door'],
    [1991, 'Dodge', 'Shadow', 'Hatchback 2-Door'],
    [1991, 'Dodge', 'Shadow', 'Hatchback 4-Door'],
    [1991, 'Dodge', 'Spirit', 'Sedan 4-Door'],
    [1991, 'Dodge', 'Stealth', 'Hatchback 2-Door'],
    [1991, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1991, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1991, 'Dodge', 'W250', 'Extended Cab Pickup 2-Door'],
    [1991, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1991, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1991, 'Eagle', '2000 GTX', 'Sedan 4-Door'],
    [1991, 'Eagle', 'Premier', 'Sedan 4-Door'],
    [1991, 'Eagle', 'Summit', 'Hatchback 2-Door'],
    [1991, 'Eagle', 'Summit', 'Sedan 4-Door'],
    [1991, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1991, 'Eagle', 'Vista', 'Hatchback 2-Door'],
    [1991, 'Eagle', 'Vista', 'Sedan 4-Door'],
    [1991, 'Eagle', 'Vista', 'Wagon 4-Door'],
    [1991, 'Ferrari', '348 TB', 'Coupe 2-Door'],
    [1991, 'Ferrari', '348 TS', 'Coupe 2-Door'],
    [1991, 'Ferrari', 'F40', 'Coupe 2-Door'],
    [1991, 'Ferrari', 'Mondial t', 'Convertible 2-Door'],
    [1991, 'Ferrari', 'Testarossa', 'Coupe 2-Door'],
    [1991, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1991, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1991, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1991, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1991, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1991, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1991, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1991, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1991, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1991, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1991, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1991, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1991, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1991, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1991, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1991, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1991, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1991, 'Ford', 'Explorer', 'SUV 2-Door'],
    [1991, 'Ford', 'Explorer', 'SUV 4-Door'],
    [1991, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1991, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1991, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1991, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1991, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1991, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1991, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1991, 'Ford', 'Festiva', 'Hatchback 2-Door'],
    [1991, 'Ford', 'LTD Crown Victoria', 'Sedan 4-Door'],
    [1991, 'Ford', 'LTD Crown Victoria', 'Wagon 4-Door'],
    [1991, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1991, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1991, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1991, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1991, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1991, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1991, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1991, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1991, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1991, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1991, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1991, 'Geo', 'Metro', 'Convertible 2-Door'],
    [1991, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1991, 'Geo', 'Metro', 'Hatchback 4-Door'],
    [1991, 'Geo', 'Prizm', 'Hatchback 4-Door'],
    [1991, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1991, 'Geo', 'Storm', 'Hatchback 2-Door'],
    [1991, 'Geo', 'Storm', 'Wagon 2-Door'],
    [1991, 'Geo', 'Tracker', 'Convertible 2-Door'],
    [1991, 'Geo', 'Tracker', 'Hardtop 2-Door'],
    [1991, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1991, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1991, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1991, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1991, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1991, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1991, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1991, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1991, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1991, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1991, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1991, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1991, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1991, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1991, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1991, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1991, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1991, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1991, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1991, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1991, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1991, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1991, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1991, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1991, 'GMC', 'P3500', 'Standard Cargo Van 2-Door'],
    [1991, 'GMC', 'R1500 Suburban', 'SUV 4-Door'],
    [1991, 'GMC', 'R2500 Suburban', 'SUV 4-Door'],
    [1991, 'GMC', 'R3500', 'Crew Cab Pickup 4-Door'],
    [1991, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1991, 'GMC', 'S15 Jimmy', 'SUV 4-Door'],
    [1991, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1991, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1991, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1991, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1991, 'GMC', 'Sonoma', 'Extended Cab Pickup 2-Door'],
    [1991, 'GMC', 'Sonoma', 'Standard Cab Pickup 2-Door'],
    [1991, 'GMC', 'Syclone', 'Standard Cab Pickup 2-Door'],
    [1991, 'GMC', 'Tracker', 'SUV 2-Door'],
    [1991, 'GMC', 'V1500 Suburban', 'SUV 4-Door'],
    [1991, 'GMC', 'V2500 Suburban', 'SUV 4-Door'],
    [1991, 'GMC', 'V3500', 'Crew Cab Pickup 4-Door'],
    [1991, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1991, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1991, 'Honda', 'Accord', 'Wagon 5-Door'],
    [1991, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1991, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1991, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1991, 'Honda', 'CRX', 'Coupe 2-Door'],
    [1991, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1991, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1991, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1991, 'Hyundai', 'Scoupe', 'Coupe 2-Door'],
    [1991, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1991, 'INFINITI', 'G20', 'Sedan 4-Door'],
    [1991, 'INFINITI', 'M30', 'Convertible 2-Door'],
    [1991, 'INFINITI', 'M30', 'Coupe 2-Door'],
    [1991, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1991, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [1991, 'Isuzu', 'Impulse', 'Coupe 2-Door'],
    [1991, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1991, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1991, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1991, 'Isuzu', 'Rodeo', 'SUV 4-Door'],
    [1991, 'Isuzu', 'Stylus', 'Sedan 4-Door'],
    [1991, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1991, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1991, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1991, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1991, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1991, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1991, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1991, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1991, 'Jeep', 'Comanche', 'Standard Cab Pickup 2-Door'],
    [1991, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1991, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1991, 'Lada', 'Niva', 'SUV 2-Door'],
    [1991, 'Lada', 'Samara', 'Hatchback 2-Door'],
    [1991, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1991, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1991, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1991, 'Lamborghini', 'LM American', 'SUV 4-Door'],
    [1991, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1991, 'Lexus', 'ES250', 'Sedan 4-Door'],
    [1991, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1991, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1991, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1991, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1991, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1991, 'Lotus', 'Elan', 'Convertible 2-Door'],
    [1991, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1991, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [1991, 'Mazda', '323', 'Hatchback 2-Door'],
    [1991, 'Mazda', '626', 'Hatchback 4-Door'],
    [1991, 'Mazda', '626', 'Sedan 4-Door'],
    [1991, 'Mazda', '929', 'Sedan 4-Door'],
    [1991, 'Mazda', 'B2200', 'Extended Cab Pickup 2-Door'],
    [1991, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1991, 'Mazda', 'B2600', 'Extended Cab Pickup 2-Door'],
    [1991, 'Mazda', 'B2600', 'Standard Cab Pickup 2-Door'],
    [1991, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1991, 'Mazda', 'MPV', 'Standard Cargo Van 3-Door'],
    [1991, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1991, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1991, 'Mazda', 'Navajo', 'SUV 2-Door'],
    [1991, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1991, 'Mazda', 'RX-7', 'Convertible 2-Door'],
    [1991, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1991, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1991, 'Mercedes-Benz', '300CE', 'Coupe 2-Door'],
    [1991, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1991, 'Mercedes-Benz', '300E', 'Sedan 4-Door'],
    [1991, 'Mercedes-Benz', '300SE', 'Sedan 4-Door'],
    [1991, 'Mercedes-Benz', '300SEL', 'Sedan 4-Door'],
    [1991, 'Mercedes-Benz', '300SL', 'Convertible 2-Door'],
    [1991, 'Mercedes-Benz', '300TE', 'Wagon 4-Door'],
    [1991, 'Mercedes-Benz', '350SD', 'Sedan 4-Door'],
    [1991, 'Mercedes-Benz', '350SDL', 'Sedan 4-Door'],
    [1991, 'Mercedes-Benz', '420SEL', 'Sedan 4-Door'],
    [1991, 'Mercedes-Benz', '500SL', 'Convertible 2-Door'],
    [1991, 'Mercedes-Benz', '560SEC', 'Coupe 2-Door'],
    [1991, 'Mercedes-Benz', '560SEL', 'Sedan 4-Door'],
    [1991, 'Mercury', 'Capri', 'Convertible 2-Door'],
    [1991, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1991, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1991, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1991, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1991, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1991, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1991, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1991, 'Mercury', 'Tracer', 'Sedan 4-Door'],
    [1991, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1991, 'Mitsubishi', '3000GT', 'Coupe 2-Door'],
    [1991, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1991, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1991, 'Mitsubishi', 'Mighty Max', 'Extended Cab Pickup 2-Door'],
    [1991, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1991, 'Mitsubishi', 'Mirage', 'Hatchback 2-Door'],
    [1991, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1991, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1991, 'Mitsubishi', 'Precis', 'Hatchback 2-Door'],
    [1991, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1991, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1991, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1991, 'Nissan', '240SX', 'Hatchback 2-Door'],
    [1991, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1991, 'Nissan', 'Axxess', 'Wagon 4-Door'],
    [1991, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1991, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1991, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1991, 'Nissan', 'Micra', 'Hatchback 2-Door'],
    [1991, 'Nissan', 'NX', 'Coupe 2-Door'],
    [1991, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1991, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1991, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1991, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1991, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1991, 'Oldsmobile', 'Bravada', 'SUV 4-Door'],
    [1991, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1991, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1991, 'Oldsmobile', 'Cutlass Calais', 'Sedan 4-Door'],
    [1991, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1991, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1991, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1991, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1991, 'Oldsmobile', 'Cutlass Supreme', 'Convertible 2-Door'],
    [1991, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1991, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1991, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1991, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1991, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 3-Door'],
    [1991, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1991, 'Peugeot', '405', 'Sedan 4-Door'],
    [1991, 'Peugeot', '405', 'Wagon 4-Door'],
    [1991, 'Peugeot', '505', 'Wagon 4-Door'],
    [1991, 'Plymouth', 'Acclaim', 'Sedan 4-Door'],
    [1991, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1991, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1991, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1991, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1991, 'Plymouth', 'Laser', 'Hatchback 2-Door'],
    [1991, 'Plymouth', 'Sundance', 'Hatchback 2-Door'],
    [1991, 'Plymouth', 'Sundance', 'Hatchback 4-Door'],
    [1991, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1991, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1991, 'Pontiac', '6000', 'Wagon 4-Door'],
    [1991, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1991, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1991, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1991, 'Pontiac', 'Firefly', 'Convertible 2-Door'],
    [1991, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1991, 'Pontiac', 'Firefly', 'Hatchback 4-Door'],
    [1991, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1991, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1991, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1991, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1991, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1991, 'Pontiac', 'LeMans', 'Hatchback 2-Door'],
    [1991, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1991, 'Pontiac', 'Optima', 'Sedan 4-Door'],
    [1991, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1991, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1991, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1991, 'Pontiac', 'Tempest', 'Sedan 4-Door'],
    [1991, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1991, 'Porsche', '911', 'Convertible 2-Door'],
    [1991, 'Porsche', '911', 'Coupe 2-Door'],
    [1991, 'Porsche', '911', 'Targa 2-Door'],
    [1991, 'Porsche', '928', 'Coupe 2-Door'],
    [1991, 'Porsche', '944', 'Convertible 2-Door'],
    [1991, 'Porsche', '944', 'Coupe 2-Door'],
    [1991, 'Rolls-Royce', 'Corniche II', 'Convertible 2-Door'],
    [1991, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1991, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1991, 'Saab', '900', 'Convertible 2-Door'],
    [1991, 'Saab', '900', 'Hatchback 2-Door'],
    [1991, 'Saab', '900', 'Sedan 4-Door'],
    [1991, 'Saab', '9000', 'Hatchback 4-Door'],
    [1991, 'Saab', '9000', 'Sedan 4-Door'],
    [1991, 'Saturn', 'SC', 'Coupe 2-Door'],
    [1991, 'Saturn', 'SL', 'Sedan 4-Door'],
    [1991, 'Saturn', 'SL1', 'Sedan 4-Door'],
    [1991, 'Saturn', 'SL2', 'Sedan 4-Door'],
    [1991, 'Sterling', '827', 'Hatchback 4-Door'],
    [1991, 'Sterling', '827', 'Sedan 4-Door'],
    [1991, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1991, 'Subaru', 'Justy', 'Hatchback 4-Door'],
    [1991, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1991, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1991, 'Subaru', 'Loyale', 'Sedan 4-Door'],
    [1991, 'Subaru', 'Loyale', 'Wagon 4-Door'],
    [1991, 'Subaru', 'XT', 'Coupe 2-Door'],
    [1991, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1991, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1991, 'Suzuki', 'Sidekick', 'SUV 4-Door'],
    [1991, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1991, 'Suzuki', 'Swift', 'Sedan 4-Door'],
    [1991, 'Toyota', '4Runner', 'SUV 2-Door'],
    [1991, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1991, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1991, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1991, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1991, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1991, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1991, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1991, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1991, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1991, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1991, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1991, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1991, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1991, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1991, 'Toyota', 'Previa', 'Mini Passenger Van 3-Door'],
    [1991, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1991, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1991, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1991, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1991, 'Volkswagen', 'Corrado', 'Coupe 2-Door'],
    [1991, 'Volkswagen', 'Fox', 'Sedan 2-Door'],
    [1991, 'Volkswagen', 'Fox', 'Sedan 4-Door'],
    [1991, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1991, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1991, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1991, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1991, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1991, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1991, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1991, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1991, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1991, 'Volvo', '240', 'Sedan 4-Door'],
    [1991, 'Volvo', '240', 'Wagon 4-Door'],
    [1991, 'Volvo', '740', 'Sedan 4-Door'],
    [1991, 'Volvo', '740', 'Wagon 4-Door'],
    [1991, 'Volvo', '780', 'Coupe 2-Door'],
    [1991, 'Volvo', '940', 'Sedan 4-Door'],
    [1991, 'Volvo', '940', 'Wagon 4-Door'],
    [1991, 'Yugo', 'Cabrio', 'Convertible 2-Door'],
    [1991, 'Yugo', 'GV', 'Hatchback 2-Door'],
    [1990, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1990, 'Acura', 'Integra', 'Sedan 4-Door'],
    [1990, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1990, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1990, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1990, 'Aston Martin', 'Virage', 'Coupe 2-Door'],
    [1990, 'Audi', '80', 'Sedan 4-Door'],
    [1990, 'Audi', '90', 'Sedan 4-Door'],
    [1990, 'Audi', '100', 'Sedan 4-Door'],
    [1990, 'Audi', '200', 'Sedan 4-Door'],
    [1990, 'Audi', '100 Quattro', 'Sedan 4-Door'],
    [1990, 'Audi', '200 Quattro', 'Sedan 4-Door'],
    [1990, 'Audi', '200 Quattro', 'Wagon 4-Door'],
    [1990, 'Audi', '80 Quattro', 'Sedan 4-Door'],
    [1990, 'Audi', '90 Quattro', 'Sedan 4-Door'],
    [1990, 'Audi', 'Coupe Quattro', 'Coupe 2-Door'],
    [1990, 'Audi', 'V8 Quattro', 'Sedan 4-Door'],
    [1990, 'Avanti', 'II', 'Sedan 4-Door'],
    [1990, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1990, 'Bentley', 'Eight', 'Sedan 4-Door'],
    [1990, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1990, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1990, 'BMW', '325i', 'Convertible 2-Door'],
    [1990, 'BMW', '325i', 'Coupe 2-Door'],
    [1990, 'BMW', '325i', 'Sedan 4-Door'],
    [1990, 'BMW', '325is', 'Coupe 2-Door'],
    [1990, 'BMW', '325iX', 'Coupe 2-Door'],
    [1990, 'BMW', '325iX', 'Sedan 4-Door'],
    [1990, 'BMW', '525i', 'Sedan 4-Door'],
    [1990, 'BMW', '535i', 'Sedan 4-Door'],
    [1990, 'BMW', '735i', 'Sedan 4-Door'],
    [1990, 'BMW', '735iL', 'Sedan 4-Door'],
    [1990, 'BMW', '750iL', 'Sedan 4-Door'],
    [1990, 'BMW', 'M3', 'Coupe 2-Door'],
    [1990, 'Buick', 'Century', 'Coupe 2-Door'],
    [1990, 'Buick', 'Century', 'Sedan 4-Door'],
    [1990, 'Buick', 'Century', 'Wagon 4-Door'],
    [1990, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1990, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1990, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1990, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1990, 'Buick', 'Reatta', 'Convertible 2-Door'],
    [1990, 'Buick', 'Reatta', 'Coupe 2-Door'],
    [1990, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1990, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1990, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1990, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1990, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1990, 'Cadillac', 'Allante', 'Convertible 2-Door'],
    [1990, 'Cadillac', 'Brougham', 'Sedan 4-Door'],
    [1990, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1990, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1990, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1990, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1990, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1990, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1990, 'Chevrolet', 'Astro', 'Extended Cargo Van 3-Door'],
    [1990, 'Chevrolet', 'Astro', 'Extended Passenger Van 3-Door'],
    [1990, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1990, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1990, 'Chevrolet', 'Beretta', 'Convertible 2-Door'],
    [1990, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1990, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1990, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1990, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1990, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1990, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1990, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1990, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1990, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1990, 'Chevrolet', 'Celebrity', 'Wagon 4-Door'],
    [1990, 'Chevrolet', 'Corsica', 'Hatchback 4-Door'],
    [1990, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1990, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1990, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1990, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1990, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1990, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1990, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1990, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1990, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1990, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1990, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1990, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1990, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1990, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1990, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1990, 'Chevrolet', 'Lumina', 'Coupe 2-Door'],
    [1990, 'Chevrolet', 'Lumina', 'Sedan 4-Door'],
    [1990, 'Chevrolet', 'Lumina APV', 'Mini Passenger Van 3-Door'],
    [1990, 'Chevrolet', 'R1500 Suburban', 'SUV 4-Door'],
    [1990, 'Chevrolet', 'R2500 Suburban', 'SUV 4-Door'],
    [1990, 'Chevrolet', 'R3500', 'Crew Cab Pickup 4-Door'],
    [1990, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1990, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1990, 'Chevrolet', 'Sprint', 'Convertible 2-Door'],
    [1990, 'Chevrolet', 'Sprint', 'Hatchback 2-Door'],
    [1990, 'Chevrolet', 'Sprint', 'Hatchback 4-Door'],
    [1990, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [1990, 'Chevrolet', 'V1500 Suburban', 'SUV 4-Door'],
    [1990, 'Chevrolet', 'V2500 Suburban', 'SUV 4-Door'],
    [1990, 'Chevrolet', 'V3500', 'Crew Cab Pickup 4-Door'],
    [1990, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1990, 'Chrysler', 'Dynasty', 'Sedan 4-Door'],
    [1990, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1990, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1990, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1990, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1990, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1990, 'Chrysler', 'TC Maserati', 'Convertible 2-Door'],
    [1990, 'Chrysler', 'Town & Country', 'Mini Passenger Van 3-Door'],
    [1990, 'Daihatsu', 'Charade', 'Hatchback 2-Door'],
    [1990, 'Daihatsu', 'Charade', 'Sedan 4-Door'],
    [1990, 'Daihatsu', 'Rocky', 'SUV 2-Door'],
    [1990, 'Dodge', '2000 GTX', 'Sedan 4-Door'],
    [1990, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1990, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1990, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1990, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1990, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1990, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1990, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1990, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1990, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1990, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1990, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [1990, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1990, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1990, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1990, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1990, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1990, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1990, 'Dodge', 'D250', 'Extended Cab Pickup 2-Door'],
    [1990, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1990, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1990, 'Dodge', 'Dakota', 'Convertible 2-Door'],
    [1990, 'Dodge', 'Dakota', 'Extended Cab Pickup 2-Door'],
    [1990, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1990, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1990, 'Dodge', 'Dynasty', 'Sedan 4-Door'],
    [1990, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1990, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1990, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1990, 'Dodge', 'Ram 50', 'Extended Cab Pickup 2-Door'],
    [1990, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1990, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1990, 'Dodge', 'Shadow', 'Hatchback 2-Door'],
    [1990, 'Dodge', 'Shadow', 'Hatchback 4-Door'],
    [1990, 'Dodge', 'Spirit', 'Sedan 4-Door'],
    [1990, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1990, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1990, 'Dodge', 'W250', 'Extended Cab Pickup 2-Door'],
    [1990, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1990, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1990, 'Eagle', 'Premier', 'Sedan 4-Door'],
    [1990, 'Eagle', 'Summit', 'Sedan 4-Door'],
    [1990, 'Eagle', 'Talon', 'Hatchback 2-Door'],
    [1990, 'Eagle', 'Vista', 'Hatchback 2-Door'],
    [1990, 'Eagle', 'Vista', 'Sedan 4-Door'],
    [1990, 'Eagle', 'Vista', 'Wagon 4-Door'],
    [1990, 'Ferrari', '348 TB', 'Coupe 2-Door'],
    [1990, 'Ferrari', '348 TS', 'Coupe 2-Door'],
    [1990, 'Ferrari', 'F40', 'Coupe 2-Door'],
    [1990, 'Ferrari', 'Mondial t', 'Convertible 2-Door'],
    [1990, 'Ferrari', 'Testarossa', 'Coupe 2-Door'],
    [1990, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1990, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1990, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1990, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1990, 'Ford', 'Bronco II', 'SUV 2-Door'],
    [1990, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1990, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1990, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1990, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1990, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1990, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1990, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1990, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1990, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1990, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1990, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1990, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1990, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1990, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1990, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1990, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1990, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1990, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1990, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1990, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1990, 'Ford', 'Festiva', 'Hatchback 2-Door'],
    [1990, 'Ford', 'LTD Crown Victoria', 'Sedan 4-Door'],
    [1990, 'Ford', 'LTD Crown Victoria', 'Wagon 4-Door'],
    [1990, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1990, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1990, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1990, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1990, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1990, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1990, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1990, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1990, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1990, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1990, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1990, 'Geo', 'Metro', 'Convertible 2-Door'],
    [1990, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1990, 'Geo', 'Metro', 'Hatchback 4-Door'],
    [1990, 'Geo', 'Prizm', 'Hatchback 4-Door'],
    [1990, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1990, 'Geo', 'Storm', 'Hatchback 2-Door'],
    [1990, 'Geo', 'Storm', 'Wagon 2-Door'],
    [1990, 'Geo', 'Tracker', 'Convertible 2-Door'],
    [1990, 'Geo', 'Tracker', 'Hardtop 2-Door'],
    [1990, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1990, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1990, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1990, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1990, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1990, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1990, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1990, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1990, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1990, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1990, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1990, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1990, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1990, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1990, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1990, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1990, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1990, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1990, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1990, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1990, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1990, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1990, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1990, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1990, 'GMC', 'R1500 Suburban', 'SUV 4-Door'],
    [1990, 'GMC', 'R2500 Suburban', 'SUV 4-Door'],
    [1990, 'GMC', 'R3500', 'Crew Cab Pickup 4-Door'],
    [1990, 'GMC', 'S15', 'Extended Cab Pickup 2-Door'],
    [1990, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1990, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1990, 'GMC', 'Safari', 'Extended Cargo Van 3-Door'],
    [1990, 'GMC', 'Safari', 'Extended Passenger Van 3-Door'],
    [1990, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1990, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1990, 'GMC', 'Tracker', 'SUV 2-Door'],
    [1990, 'GMC', 'V1500 Suburban', 'SUV 4-Door'],
    [1990, 'GMC', 'V2500 Suburban', 'SUV 4-Door'],
    [1990, 'GMC', 'V3500', 'Crew Cab Pickup 4-Door'],
    [1990, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1990, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1990, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1990, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1990, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1990, 'Honda', 'CRX', 'Coupe 2-Door'],
    [1990, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1990, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1990, 'Hyundai', 'Excel', 'Hatchback 4-Door'],
    [1990, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1990, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1990, 'INFINITI', 'M30', 'Coupe 2-Door'],
    [1990, 'INFINITI', 'Q45', 'Sedan 4-Door'],
    [1990, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [1990, 'Isuzu', 'Impulse', 'Coupe 2-Door'],
    [1990, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1990, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1990, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1990, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1990, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1990, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1990, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1990, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1990, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1990, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1990, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1990, 'Jeep', 'Comanche', 'Standard Cab Pickup 2-Door'],
    [1990, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1990, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1990, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1990, 'Lada', 'Niva', 'SUV 2-Door'],
    [1990, 'Lada', 'Samara', 'Hatchback 2-Door'],
    [1990, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1990, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1990, 'Lamborghini', 'Diablo', 'Coupe 2-Door'],
    [1990, 'Lamborghini', 'LM002', 'SUV 4-Door'],
    [1990, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1990, 'Lexus', 'ES250', 'Sedan 4-Door'],
    [1990, 'Lexus', 'LS400', 'Sedan 4-Door'],
    [1990, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1990, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1990, 'Lincoln', 'Town Car', 'Limousine 4-Door'],
    [1990, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1990, 'Lotus', 'Elan', 'Convertible 2-Door'],
    [1990, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1990, 'Maserati', '228i', 'Coupe 2-Door'],
    [1990, 'Maserati', '430i', 'Coupe 2-Door'],
    [1990, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [1990, 'Mazda', '323', 'Hatchback 2-Door'],
    [1990, 'Mazda', '626', 'Hatchback 4-Door'],
    [1990, 'Mazda', '626', 'Sedan 4-Door'],
    [1990, 'Mazda', '929', 'Sedan 4-Door'],
    [1990, 'Mazda', 'B2200', 'Extended Cab Pickup 2-Door'],
    [1990, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1990, 'Mazda', 'B2600', 'Extended Cab Pickup 2-Door'],
    [1990, 'Mazda', 'B2600', 'Standard Cab Pickup 2-Door'],
    [1990, 'Mazda', 'Miata', 'Convertible 2-Door'],
    [1990, 'Mazda', 'MPV', 'Standard Cargo Van 3-Door'],
    [1990, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1990, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1990, 'Mazda', 'Protege', 'Sedan 4-Door'],
    [1990, 'Mazda', 'RX-7', 'Convertible 2-Door'],
    [1990, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1990, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1990, 'Mercedes-Benz', '300CE', 'Coupe 2-Door'],
    [1990, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1990, 'Mercedes-Benz', '300E', 'Sedan 4-Door'],
    [1990, 'Mercedes-Benz', '300SE', 'Sedan 4-Door'],
    [1990, 'Mercedes-Benz', '300SEL', 'Sedan 4-Door'],
    [1990, 'Mercedes-Benz', '300SL', 'Convertible 2-Door'],
    [1990, 'Mercedes-Benz', '300TE', 'Wagon 4-Door'],
    [1990, 'Mercedes-Benz', '350SDL', 'Sedan 4-Door'],
    [1990, 'Mercedes-Benz', '420SEL', 'Sedan 4-Door'],
    [1990, 'Mercedes-Benz', '500SL', 'Convertible 2-Door'],
    [1990, 'Mercedes-Benz', '560SEC', 'Coupe 2-Door'],
    [1990, 'Mercedes-Benz', '560SEL', 'Sedan 4-Door'],
    [1990, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1990, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1990, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1990, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1990, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1990, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1990, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1990, 'Mercury', 'Tracer', 'Hatchback 2-Door'],
    [1990, 'Mercury', 'Tracer', 'Hatchback 4-Door'],
    [1990, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1990, 'Mitsubishi', 'Eclipse', 'Hatchback 2-Door'],
    [1990, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1990, 'Mitsubishi', 'Mighty Max', 'Extended Cab Pickup 2-Door'],
    [1990, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1990, 'Mitsubishi', 'Mirage', 'Hatchback 2-Door'],
    [1990, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1990, 'Mitsubishi', 'Montero', 'SUV 2-Door'],
    [1990, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1990, 'Mitsubishi', 'Precis', 'Hatchback 2-Door'],
    [1990, 'Mitsubishi', 'Sigma', 'Sedan 4-Door'],
    [1990, 'Mitsubishi', 'Van', 'Standard Cargo Van 3-Door'],
    [1990, 'Mitsubishi', 'Van', 'Standard Passenger Van 3-Door'],
    [1990, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1990, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1990, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1990, 'Nissan', '240SX', 'Hatchback 2-Door'],
    [1990, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1990, 'Nissan', 'Axxess', 'Wagon 4-Door'],
    [1990, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1990, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1990, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1990, 'Nissan', 'Micra', 'Hatchback 2-Door'],
    [1990, 'Nissan', 'Pathfinder', 'SUV 2-Door'],
    [1990, 'Nissan', 'Pathfinder', 'SUV 4-Door'],
    [1990, 'Nissan', 'Pulsar NX', 'Coupe 2-Door'],
    [1990, 'Nissan', 'Sentra', 'Coupe 2-Door'],
    [1990, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1990, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1990, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1990, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1990, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1990, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1990, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1990, 'Oldsmobile', 'Cutlass Calais', 'Sedan 4-Door'],
    [1990, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1990, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1990, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1990, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1990, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1990, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1990, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1990, 'Oldsmobile', 'Silhouette', 'Mini Passenger Van 3-Door'],
    [1990, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1990, 'Peugeot', '405', 'Sedan 4-Door'],
    [1990, 'Peugeot', '405', 'Wagon 4-Door'],
    [1990, 'Peugeot', '505', 'Sedan 4-Door'],
    [1990, 'Peugeot', '505', 'Wagon 4-Door'],
    [1990, 'Plymouth', 'Acclaim', 'Sedan 4-Door'],
    [1990, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1990, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1990, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1990, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1990, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1990, 'Plymouth', 'Laser', 'Hatchback 2-Door'],
    [1990, 'Plymouth', 'Sundance', 'Hatchback 2-Door'],
    [1990, 'Plymouth', 'Sundance', 'Hatchback 4-Door'],
    [1990, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1990, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1990, 'Pontiac', '6000', 'Wagon 4-Door'],
    [1990, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1990, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1990, 'Pontiac', 'Firefly', 'Convertible 2-Door'],
    [1990, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1990, 'Pontiac', 'Firefly', 'Hatchback 4-Door'],
    [1990, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1990, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1990, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1990, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1990, 'Pontiac', 'Grand Prix', 'Sedan 4-Door'],
    [1990, 'Pontiac', 'LeMans', 'Hatchback 2-Door'],
    [1990, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1990, 'Pontiac', 'Optima', 'Sedan 4-Door'],
    [1990, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1990, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1990, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1990, 'Pontiac', 'Tempest', 'Sedan 4-Door'],
    [1990, 'Pontiac', 'Trans Sport', 'Mini Passenger Van 3-Door'],
    [1990, 'Porsche', '911', 'Convertible 2-Door'],
    [1990, 'Porsche', '911', 'Coupe 2-Door'],
    [1990, 'Porsche', '911', 'Targa 2-Door'],
    [1990, 'Porsche', '928', 'Coupe 2-Door'],
    [1990, 'Porsche', '944', 'Convertible 2-Door'],
    [1990, 'Porsche', '944', 'Coupe 2-Door'],
    [1990, 'Rolls-Royce', 'Corniche II', 'Convertible 2-Door'],
    [1990, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1990, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1990, 'Saab', '900', 'Convertible 2-Door'],
    [1990, 'Saab', '900', 'Hatchback 2-Door'],
    [1990, 'Saab', '900', 'Sedan 4-Door'],
    [1990, 'Saab', '9000', 'Hatchback 4-Door'],
    [1990, 'Saab', '9000', 'Sedan 4-Door'],
    [1990, 'Sterling', '827', 'Hatchback 4-Door'],
    [1990, 'Sterling', '827', 'Sedan 4-Door'],
    [1990, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1990, 'Subaru', 'Justy', 'Hatchback 4-Door'],
    [1990, 'Subaru', 'Legacy', 'Sedan 4-Door'],
    [1990, 'Subaru', 'Legacy', 'Wagon 4-Door'],
    [1990, 'Subaru', 'Loyale', 'Coupe 3-Door'],
    [1990, 'Subaru', 'Loyale', 'Sedan 4-Door'],
    [1990, 'Subaru', 'Loyale', 'Wagon 4-Door'],
    [1990, 'Subaru', 'XT', 'Coupe 2-Door'],
    [1990, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1990, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1990, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1990, 'Suzuki', 'Swift', 'Hatchback 4-Door'],
    [1990, 'Suzuki', 'Swift', 'Sedan 4-Door'],
    [1990, 'Suzuki', 'Swift', 'Sedan 5-Door'],
    [1990, 'Toyota', '4Runner', 'SUV 2-Door'],
    [1990, 'Toyota', '4Runner', 'SUV 4-Door'],
    [1990, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1990, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1990, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1990, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1990, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1990, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1990, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1990, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1990, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1990, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1990, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1990, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1990, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1990, 'Toyota', 'Tercel', 'Hatchback 4-Door'],
    [1990, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1990, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1990, 'Volkswagen', 'Corrado', 'Coupe 2-Door'],
    [1990, 'Volkswagen', 'Fox', 'Sedan 2-Door'],
    [1990, 'Volkswagen', 'Fox', 'Sedan 4-Door'],
    [1990, 'Volkswagen', 'Fox', 'Wagon 2-Door'],
    [1990, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1990, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1990, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1990, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1990, 'Volkswagen', 'Passat', 'Sedan 4-Door'],
    [1990, 'Volkswagen', 'Passat', 'Wagon 4-Door'],
    [1990, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1990, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1990, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1990, 'Volvo', '240', 'Sedan 4-Door'],
    [1990, 'Volvo', '240', 'Wagon 4-Door'],
    [1990, 'Volvo', '740', 'Sedan 4-Door'],
    [1990, 'Volvo', '740', 'Wagon 4-Door'],
    [1990, 'Volvo', '760', 'Sedan 4-Door'],
    [1990, 'Volvo', '760', 'Wagon 4-Door'],
    [1990, 'Volvo', '780', 'Coupe 2-Door'],
    [1990, 'Yugo', 'Cabrio', 'Convertible 2-Door'],
    [1990, 'Yugo', 'GV', 'Hatchback 2-Door'],
    [1989, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1989, 'Acura', 'Integra', 'Hatchback 4-Door'],
    [1989, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1989, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1989, 'Alfa Romeo', 'Milano', 'Sedan 4-Door'],
    [1989, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1989, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1989, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1989, 'Aston Martin', 'Virage', 'Coupe 2-Door'],
    [1989, 'Audi', '80', 'Sedan 4-Door'],
    [1989, 'Audi', '90', 'Sedan 4-Door'],
    [1989, 'Audi', '100', 'Sedan 4-Door'],
    [1989, 'Audi', '100', 'Wagon 4-Door'],
    [1989, 'Audi', '200', 'Sedan 4-Door'],
    [1989, 'Audi', '100 Quattro', 'Sedan 4-Door'],
    [1989, 'Audi', '200 Quattro', 'Sedan 4-Door'],
    [1989, 'Audi', '200 Quattro', 'Wagon 4-Door'],
    [1989, 'Audi', '80 Quattro', 'Sedan 4-Door'],
    [1989, 'Audi', '90 Quattro', 'Sedan 4-Door'],
    [1989, 'Avanti', 'II', 'Convertible 2-Door'],
    [1989, 'Avanti', 'II', 'Coupe 2-Door'],
    [1989, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1989, 'Bentley', 'Eight', 'Sedan 4-Door'],
    [1989, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1989, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1989, 'Bertone', 'X-1/9', 'Coupe 2-Door'],
    [1989, 'BMW', '325i', 'Convertible 2-Door'],
    [1989, 'BMW', '325i', 'Coupe 2-Door'],
    [1989, 'BMW', '325i', 'Sedan 4-Door'],
    [1989, 'BMW', '325is', 'Coupe 2-Door'],
    [1989, 'BMW', '325iX', 'Coupe 2-Door'],
    [1989, 'BMW', '325iX', 'Sedan 4-Door'],
    [1989, 'BMW', '525i', 'Sedan 4-Door'],
    [1989, 'BMW', '535i', 'Sedan 4-Door'],
    [1989, 'BMW', '635CSi', 'Coupe 2-Door'],
    [1989, 'BMW', '735i', 'Sedan 4-Door'],
    [1989, 'BMW', '735iL', 'Sedan 4-Door'],
    [1989, 'BMW', '750iL', 'Sedan 4-Door'],
    [1989, 'BMW', 'M3', 'Coupe 2-Door'],
    [1989, 'Buick', 'Century', 'Coupe 2-Door'],
    [1989, 'Buick', 'Century', 'Sedan 4-Door'],
    [1989, 'Buick', 'Century', 'Wagon 4-Door'],
    [1989, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1989, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1989, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1989, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1989, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1989, 'Buick', 'Reatta', 'Coupe 2-Door'],
    [1989, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1989, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1989, 'Buick', 'Skyhawk', 'Coupe 2-Door'],
    [1989, 'Buick', 'Skyhawk', 'Sedan 4-Door'],
    [1989, 'Buick', 'Skyhawk', 'Wagon 4-Door'],
    [1989, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1989, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1989, 'Cadillac', 'Allante', 'Convertible 2-Door'],
    [1989, 'Cadillac', 'Brougham', 'Sedan 4-Door'],
    [1989, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1989, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1989, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1989, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1989, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1989, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1989, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1989, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1989, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1989, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1989, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1989, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1989, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1989, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1989, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1989, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1989, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1989, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1989, 'Chevrolet', 'Celebrity', 'Sedan 4-Door'],
    [1989, 'Chevrolet', 'Celebrity', 'Wagon 4-Door'],
    [1989, 'Chevrolet', 'Corsica', 'Hatchback 4-Door'],
    [1989, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1989, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1989, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1989, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1989, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1989, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1989, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1989, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1989, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1989, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1989, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1989, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1989, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1989, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1989, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1989, 'Chevrolet', 'R1500 Suburban', 'SUV 4-Door'],
    [1989, 'Chevrolet', 'R2500', 'Crew Cab Pickup 4-Door'],
    [1989, 'Chevrolet', 'R2500 Suburban', 'SUV 4-Door'],
    [1989, 'Chevrolet', 'R3500', 'Crew Cab Pickup 4-Door'],
    [1989, 'Chevrolet', 'R3500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1989, 'Chevrolet', 'Sprint', 'Hatchback 2-Door'],
    [1989, 'Chevrolet', 'Sprint', 'Hatchback 4-Door'],
    [1989, 'Chevrolet', 'Tracker', 'SUV 2-Door'],
    [1989, 'Chevrolet', 'V1500 Suburban', 'SUV 4-Door'],
    [1989, 'Chevrolet', 'V2500 Suburban', 'SUV 4-Door'],
    [1989, 'Chevrolet', 'V3500', 'Crew Cab Pickup 4-Door'],
    [1989, 'Chevrolet', 'V3500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Chrysler', 'Conquest', 'Hatchback 2-Door'],
    [1989, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1989, 'Chrysler', 'Dynasty', 'Sedan 4-Door'],
    [1989, 'Chrysler', 'Fifth Avenue', 'Sedan 4-Door'],
    [1989, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1989, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1989, 'Chrysler', 'LeBaron', 'Hatchback 4-Door'],
    [1989, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1989, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1989, 'Chrysler', 'TC Maserati', 'Convertible 2-Door'],
    [1989, 'Daihatsu', 'Charade', 'Hatchback 2-Door'],
    [1989, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1989, 'Dodge', '2000 GTX', 'Sedan 4-Door'],
    [1989, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1989, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1989, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1989, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1989, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1989, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1989, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1989, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1989, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1989, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1989, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1989, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1989, 'Dodge', 'Caravan', 'Mini Cargo Van 3-Door'],
    [1989, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1989, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1989, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1989, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1989, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1989, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1989, 'Dodge', 'Dynasty', 'Sedan 4-Door'],
    [1989, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1989, 'Dodge', 'Lancer', 'Hatchback 4-Door'],
    [1989, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1989, 'Dodge', 'Raider', 'SUV 2-Door'],
    [1989, 'Dodge', 'Ram 50', 'Extended Cab Pickup 2-Door'],
    [1989, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1989, 'Dodge', 'Shadow', 'Hatchback 2-Door'],
    [1989, 'Dodge', 'Shadow', 'Hatchback 4-Door'],
    [1989, 'Dodge', 'Spirit', 'Sedan 4-Door'],
    [1989, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1989, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1989, 'Eagle', 'Medallion', 'Sedan 4-Door'],
    [1989, 'Eagle', 'Medallion', 'Wagon 4-Door'],
    [1989, 'Eagle', 'Premier', 'Sedan 4-Door'],
    [1989, 'Eagle', 'Summit', 'Sedan 4-Door'],
    [1989, 'Eagle', 'Vista', 'Hatchback 2-Door'],
    [1989, 'Eagle', 'Vista', 'Sedan 4-Door'],
    [1989, 'Eagle', 'Vista', 'Wagon 4-Door'],
    [1989, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1989, 'Ferrari', '412', 'Coupe 2-Door'],
    [1989, 'Ferrari', '328 GTB', 'Coupe 2-Door'],
    [1989, 'Ferrari', '328 GTS', 'Coupe 2-Door'],
    [1989, 'Ferrari', '348 TS', 'Coupe 2-Door'],
    [1989, 'Ferrari', 'Mondial t', 'Convertible 2-Door'],
    [1989, 'Ferrari', 'Mondial t', 'Coupe 2-Door'],
    [1989, 'Ferrari', 'Testarossa', 'Coupe 2-Door'],
    [1989, 'Ford', 'Aerostar', 'Extended Passenger Van 2-Door'],
    [1989, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1989, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1989, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1989, 'Ford', 'Bronco II', 'SUV 2-Door'],
    [1989, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1989, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1989, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1989, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1989, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1989, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1989, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1989, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1989, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1989, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1989, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1989, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1989, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1989, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1989, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1989, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1989, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1989, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1989, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1989, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1989, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1989, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1989, 'Ford', 'Festiva', 'Hatchback 2-Door'],
    [1989, 'Ford', 'LTD Crown Victoria', 'Sedan 4-Door'],
    [1989, 'Ford', 'LTD Crown Victoria', 'Wagon 4-Door'],
    [1989, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1989, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1989, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1989, 'Ford', 'Probe', 'Hatchback 2-Door'],
    [1989, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1989, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1989, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1989, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1989, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1989, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1989, 'Ford', 'Thunderbird', 'Coupe 2-Door'],
    [1989, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1989, 'Geo', 'Metro', 'Hatchback 2-Door'],
    [1989, 'Geo', 'Metro', 'Hatchback 4-Door'],
    [1989, 'Geo', 'Prizm', 'Hatchback 4-Door'],
    [1989, 'Geo', 'Prizm', 'Sedan 4-Door'],
    [1989, 'Geo', 'Spectrum', 'Hatchback 2-Door'],
    [1989, 'Geo', 'Spectrum', 'Sedan 4-Door'],
    [1989, 'Geo', 'Tracker', 'SUV 2-Door'],
    [1989, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1989, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1989, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1989, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1989, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1989, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1989, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1989, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1989, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1989, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1989, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1989, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1989, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1989, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1989, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1989, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1989, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1989, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1989, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1989, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1989, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1989, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1989, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1989, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1989, 'GMC', 'R1500 Suburban', 'SUV 4-Door'],
    [1989, 'GMC', 'R2500', 'Crew Cab Pickup 4-Door'],
    [1989, 'GMC', 'R2500 Suburban', 'SUV 4-Door'],
    [1989, 'GMC', 'R3500', 'Crew Cab Pickup 4-Door'],
    [1989, 'GMC', 'R3500', 'Standard Cab Pickup 2-Door'],
    [1989, 'GMC', 'S15', 'Extended Cab Pickup 2-Door'],
    [1989, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1989, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1989, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1989, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1989, 'GMC', 'Tracker', 'SUV 2-Door'],
    [1989, 'GMC', 'V1500 Suburban', 'SUV 4-Door'],
    [1989, 'GMC', 'V2500 Suburban', 'SUV 4-Door'],
    [1989, 'GMC', 'V3500', 'Crew Cab Pickup 4-Door'],
    [1989, 'GMC', 'V3500', 'Standard Cab Pickup 2-Door'],
    [1989, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1989, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1989, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1989, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1989, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1989, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1989, 'Honda', 'CRX', 'Coupe 2-Door'],
    [1989, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1989, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1989, 'Hyundai', 'Excel', 'Hatchback 4-Door'],
    [1989, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1989, 'Hyundai', 'Sonata', 'Sedan 4-Door'],
    [1989, 'Isuzu', 'Amigo', 'SUV 2-Door'],
    [1989, 'Isuzu', 'I-Mark', 'Hatchback 2-Door'],
    [1989, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1989, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1989, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1989, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1989, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1989, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1989, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1989, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1989, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1989, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1989, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1989, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1989, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1989, 'Jeep', 'Comanche', 'Standard Cab Pickup 2-Door'],
    [1989, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1989, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1989, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1989, 'Lada', 'Niva', 'SUV 2-Door'],
    [1989, 'Lada', 'Samara', 'Hatchback 2-Door'],
    [1989, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1989, 'Laforza', 'Laforza', 'SUV 4-Door'],
    [1989, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1989, 'Lamborghini', 'LM002', 'SUV 4-Door'],
    [1989, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1989, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1989, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1989, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1989, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1989, 'Maserati', '228i', 'Coupe 2-Door'],
    [1989, 'Maserati', '430i', 'Coupe 2-Door'],
    [1989, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [1989, 'Mazda', '323', 'Hatchback 2-Door'],
    [1989, 'Mazda', '323', 'Sedan 4-Door'],
    [1989, 'Mazda', '323', 'Wagon 4-Door'],
    [1989, 'Mazda', '626', 'Hatchback 4-Door'],
    [1989, 'Mazda', '626', 'Sedan 4-Door'],
    [1989, 'Mazda', '929', 'Sedan 4-Door'],
    [1989, 'Mazda', 'B2200', 'Extended Cab Pickup 2-Door'],
    [1989, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1989, 'Mazda', 'B2600', 'Extended Cab Pickup 2-Door'],
    [1989, 'Mazda', 'B2600', 'Standard Cab Pickup 2-Door'],
    [1989, 'Mazda', 'MPV', 'Standard Cargo Van 3-Door'],
    [1989, 'Mazda', 'MPV', 'Standard Passenger Van 3-Door'],
    [1989, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1989, 'Mazda', 'RX-7', 'Convertible 2-Door'],
    [1989, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1989, 'Mercedes-Benz', '190D', 'Sedan 4-Door'],
    [1989, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1989, 'Mercedes-Benz', '260E', 'Sedan 4-Door'],
    [1989, 'Mercedes-Benz', '300CE', 'Coupe 2-Door'],
    [1989, 'Mercedes-Benz', '300E', 'Sedan 4-Door'],
    [1989, 'Mercedes-Benz', '300SE', 'Sedan 4-Door'],
    [1989, 'Mercedes-Benz', '300SEL', 'Sedan 4-Door'],
    [1989, 'Mercedes-Benz', '300TE', 'Wagon 4-Door'],
    [1989, 'Mercedes-Benz', '420SEL', 'Sedan 4-Door'],
    [1989, 'Mercedes-Benz', '560SEC', 'Coupe 2-Door'],
    [1989, 'Mercedes-Benz', '560SEL', 'Sedan 4-Door'],
    [1989, 'Mercedes-Benz', '560SL', 'Convertible 2-Door'],
    [1989, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1989, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1989, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1989, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1989, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1989, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1989, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1989, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1989, 'Mercury', 'Tracer', 'Hatchback 2-Door'],
    [1989, 'Mercury', 'Tracer', 'Hatchback 4-Door'],
    [1989, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1989, 'Merkur', 'Scorpio', 'Hatchback 4-Door'],
    [1989, 'Merkur', 'XR4Ti', 'Hatchback 2-Door'],
    [1989, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1989, 'Mitsubishi', 'Mighty Max', 'Extended Cab Pickup 2-Door'],
    [1989, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1989, 'Mitsubishi', 'Mirage', 'Hatchback 2-Door'],
    [1989, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1989, 'Mitsubishi', 'Montero', 'SUV 2-Door'],
    [1989, 'Mitsubishi', 'Montero', 'SUV 4-Door'],
    [1989, 'Mitsubishi', 'Precis', 'Hatchback 2-Door'],
    [1989, 'Mitsubishi', 'Precis', 'Hatchback 4-Door'],
    [1989, 'Mitsubishi', 'Sigma', 'Sedan 4-Door'],
    [1989, 'Mitsubishi', 'Starion', 'Coupe 2-Door'],
    [1989, 'Mitsubishi', 'Van', 'Standard Cargo Van 3-Door'],
    [1989, 'Mitsubishi', 'Van', 'Standard Passenger Van 3-Door'],
    [1989, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1989, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1989, 'Nissan', '240SX', 'Coupe 2-Door'],
    [1989, 'Nissan', '240SX', 'Hatchback 2-Door'],
    [1989, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1989, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1989, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1989, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1989, 'Nissan', 'Micra', 'Hatchback 2-Door'],
    [1989, 'Nissan', 'Pathfinder', 'SUV 2-Door'],
    [1989, 'Nissan', 'Pulsar NX', 'Coupe 2-Door'],
    [1989, 'Nissan', 'Sentra', 'Coupe 2-Door'],
    [1989, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1989, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1989, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1989, 'Nissan', 'Stanza', 'Hatchback 4-Door'],
    [1989, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1989, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1989, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1989, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1989, 'Oldsmobile', 'Cutlass Calais', 'Sedan 4-Door'],
    [1989, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1989, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1989, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1989, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1989, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1989, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1989, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1989, 'Peugeot', '405', 'Sedan 4-Door'],
    [1989, 'Peugeot', '505', 'Sedan 4-Door'],
    [1989, 'Peugeot', '505', 'Wagon 4-Door'],
    [1989, 'Plymouth', 'Acclaim', 'Sedan 4-Door'],
    [1989, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1989, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1989, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1989, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1989, 'Plymouth', 'Expo', 'Wagon 4-Door'],
    [1989, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1989, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1989, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1989, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1989, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1989, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1989, 'Plymouth', 'Sundance', 'Hatchback 2-Door'],
    [1989, 'Plymouth', 'Sundance', 'Hatchback 4-Door'],
    [1989, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1989, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1989, 'Pontiac', '6000', 'Wagon 4-Door'],
    [1989, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1989, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1989, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1989, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1989, 'Pontiac', 'Firefly', 'Hatchback 4-Door'],
    [1989, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1989, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1989, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1989, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1989, 'Pontiac', 'LeMans', 'Hatchback 2-Door'],
    [1989, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1989, 'Pontiac', 'Optima', 'Sedan 4-Door'],
    [1989, 'Pontiac', 'Safari', 'Wagon 4-Door'],
    [1989, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1989, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1989, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1989, 'Pontiac', 'Tempest', 'Sedan 4-Door'],
    [1989, 'Porsche', '911', 'Convertible 2-Door'],
    [1989, 'Porsche', '911', 'Coupe 2-Door'],
    [1989, 'Porsche', '911', 'Targa 2-Door'],
    [1989, 'Porsche', '928', 'Coupe 2-Door'],
    [1989, 'Porsche', '944', 'Convertible 2-Door'],
    [1989, 'Porsche', '944', 'Coupe 2-Door'],
    [1989, 'Rolls-Royce', 'Corniche II', 'Convertible 2-Door'],
    [1989, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1989, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1989, 'Saab', '900', 'Convertible 2-Door'],
    [1989, 'Saab', '900', 'Hatchback 2-Door'],
    [1989, 'Saab', '900', 'Sedan 4-Door'],
    [1989, 'Saab', '9000', 'Hatchback 4-Door'],
    [1989, 'Saab', '9000', 'Sedan 4-Door'],
    [1989, 'Sterling', '827', 'Hatchback 4-Door'],
    [1989, 'Sterling', '827', 'Sedan 4-Door'],
    [1989, 'Subaru', 'DL', 'Coupe 3-Door'],
    [1989, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1989, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1989, 'Subaru', 'GL', 'Coupe 3-Door'],
    [1989, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1989, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1989, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1989, 'Subaru', 'GL-10', 'Sedan 4-Door'],
    [1989, 'Subaru', 'GL-10', 'Wagon 4-Door'],
    [1989, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1989, 'Subaru', 'RX', 'Coupe 3-Door'],
    [1989, 'Subaru', 'RX', 'Sedan 4-Door'],
    [1989, 'Subaru', 'XT', 'Coupe 2-Door'],
    [1989, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1989, 'Suzuki', 'Sidekick', 'SUV 2-Door'],
    [1989, 'Suzuki', 'Swift', 'Hatchback 2-Door'],
    [1989, 'Suzuki', 'Swift', 'Hatchback 4-Door'],
    [1989, 'Toyota', '4Runner', 'SUV 2-Door'],
    [1989, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1989, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1989, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1989, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1989, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1989, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1989, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1989, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1989, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1989, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1989, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1989, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1989, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1989, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1989, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1989, 'Toyota', 'Tercel', 'Hatchback 4-Door'],
    [1989, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1989, 'Toyota', 'Van', 'Mini Cargo Van 3-Door'],
    [1989, 'Toyota', 'Van', 'Mini Passenger Van 3-Door'],
    [1989, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1989, 'Volkswagen', 'Fox', 'Sedan 2-Door'],
    [1989, 'Volkswagen', 'Fox', 'Sedan 4-Door'],
    [1989, 'Volkswagen', 'Fox', 'Wagon 2-Door'],
    [1989, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1989, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1989, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1989, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1989, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1989, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1989, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1989, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1989, 'Volvo', '244', 'Sedan 4-Door'],
    [1989, 'Volvo', '245', 'Wagon 4-Door'],
    [1989, 'Volvo', '740', 'Sedan 4-Door'],
    [1989, 'Volvo', '740', 'Wagon 4-Door'],
    [1989, 'Volvo', '760', 'Sedan 4-Door'],
    [1989, 'Volvo', '760', 'Wagon 4-Door'],
    [1989, 'Volvo', '780', 'Coupe 2-Door'],
    [1989, 'Yugo', 'GV', 'Hatchback 2-Door'],
    [1989, 'Yugo', 'GVL', 'Hatchback 2-Door'],
    [1989, 'Yugo', 'GVX', 'Hatchback 2-Door'],
    [1988, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1988, 'Acura', 'Integra', 'Hatchback 4-Door'],
    [1988, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1988, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1988, 'Alfa Romeo', 'Milano', 'Sedan 4-Door'],
    [1988, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1988, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1988, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1988, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1988, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1988, 'Aston Martin', 'Zagato', 'Coupe 2-Door'],
    [1988, 'Audi', '80', 'Sedan 4-Door'],
    [1988, 'Audi', '90', 'Sedan 4-Door'],
    [1988, 'Audi', '5000', 'Sedan 4-Door'],
    [1988, 'Audi', '5000', 'Wagon 4-Door'],
    [1988, 'Audi', '5000 Quattro', 'Sedan 4-Door'],
    [1988, 'Audi', '5000 Quattro', 'Wagon 4-Door'],
    [1988, 'Audi', '80 Quattro', 'Sedan 4-Door'],
    [1988, 'Audi', '90 Quattro', 'Sedan 4-Door'],
    [1988, 'Avanti', 'II', 'Convertible 2-Door'],
    [1988, 'Avanti', 'II', 'Coupe 2-Door'],
    [1988, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1988, 'Bentley', 'Eight', 'Sedan 4-Door'],
    [1988, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1988, 'Bentley', 'Turbo R', 'Sedan 4-Door'],
    [1988, 'Bertone', 'X-1/9', 'Coupe 2-Door'],
    [1988, 'BMW', '325', 'Coupe 2-Door'],
    [1988, 'BMW', '325', 'Sedan 4-Door'],
    [1988, 'BMW', '325i', 'Convertible 2-Door'],
    [1988, 'BMW', '325i', 'Sedan 4-Door'],
    [1988, 'BMW', '325is', 'Coupe 2-Door'],
    [1988, 'BMW', '325iX', 'Coupe 2-Door'],
    [1988, 'BMW', '528e', 'Sedan 4-Door'],
    [1988, 'BMW', '535i', 'Sedan 4-Door'],
    [1988, 'BMW', '535is', 'Sedan 4-Door'],
    [1988, 'BMW', '635CSi', 'Coupe 2-Door'],
    [1988, 'BMW', '735i', 'Sedan 4-Door'],
    [1988, 'BMW', '735iL', 'Sedan 4-Door'],
    [1988, 'BMW', '750iL', 'Sedan 4-Door'],
    [1988, 'BMW', 'M3', 'Coupe 2-Door'],
    [1988, 'BMW', 'M5', 'Sedan 4-Door'],
    [1988, 'BMW', 'M6', 'Coupe 2-Door'],
    [1988, 'Buick', 'Century', 'Coupe 2-Door'],
    [1988, 'Buick', 'Century', 'Sedan 4-Door'],
    [1988, 'Buick', 'Century', 'Wagon 4-Door'],
    [1988, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1988, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1988, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1988, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1988, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1988, 'Buick', 'Reatta', 'Coupe 2-Door'],
    [1988, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1988, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1988, 'Buick', 'Skyhawk', 'Coupe 2-Door'],
    [1988, 'Buick', 'Skyhawk', 'Sedan 4-Door'],
    [1988, 'Buick', 'Skyhawk', 'Wagon 4-Door'],
    [1988, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1988, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1988, 'Cadillac', 'Allante', 'Convertible 2-Door'],
    [1988, 'Cadillac', 'Brougham', 'Sedan 4-Door'],
    [1988, 'Cadillac', 'Cimarron', 'Sedan 4-Door'],
    [1988, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1988, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1988, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1988, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1988, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1988, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1988, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1988, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1988, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1988, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1988, 'Chevrolet', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1988, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1988, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1988, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1988, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1988, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1988, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1988, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1988, 'Chevrolet', 'Celebrity', 'Coupe 2-Door'],
    [1988, 'Chevrolet', 'Celebrity', 'Sedan 4-Door'],
    [1988, 'Chevrolet', 'Celebrity', 'Wagon 4-Door'],
    [1988, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1988, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1988, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1988, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1988, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1988, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1988, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1988, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1988, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1988, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1988, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1988, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1988, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1988, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1988, 'Chevrolet', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1988, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1988, 'Chevrolet', 'Nova', 'Hatchback 4-Door'],
    [1988, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1988, 'Chevrolet', 'R10 Suburban', 'SUV 4-Door'],
    [1988, 'Chevrolet', 'R20', 'Crew Cab Pickup 4-Door'],
    [1988, 'Chevrolet', 'R20', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'R20 Suburban', 'SUV 4-Door'],
    [1988, 'Chevrolet', 'R30', 'Crew Cab Pickup 4-Door'],
    [1988, 'Chevrolet', 'R30', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1988, 'Chevrolet', 'Spectrum', 'Hatchback 2-Door'],
    [1988, 'Chevrolet', 'Spectrum', 'Sedan 4-Door'],
    [1988, 'Chevrolet', 'Sprint', 'Hatchback 2-Door'],
    [1988, 'Chevrolet', 'Sprint', 'Hatchback 4-Door'],
    [1988, 'Chevrolet', 'V10 Suburban', 'SUV 4-Door'],
    [1988, 'Chevrolet', 'V20 Suburban', 'SUV 4-Door'],
    [1988, 'Chevrolet', 'V30', 'Crew Cab Pickup 4-Door'],
    [1988, 'Chevrolet', 'V30', 'Standard Cab Pickup 2-Door'],
    [1988, 'Chrysler', 'Conquest', 'Hatchback 2-Door'],
    [1988, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1988, 'Chrysler', 'Dynasty', 'Sedan 4-Door'],
    [1988, 'Chrysler', 'Fifth Avenue', 'Sedan 4-Door'],
    [1988, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1988, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1988, 'Chrysler', 'LeBaron', 'Hatchback 4-Door'],
    [1988, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1988, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1988, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1988, 'Daihatsu', 'Charade', 'Hatchback 2-Door'],
    [1988, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1988, 'Dodge', '600', 'Sedan 4-Door'],
    [1988, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1988, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1988, 'Dodge', 'Aries', 'Wagon 4-Door'],
    [1988, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1988, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1988, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1988, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1988, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1988, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1988, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1988, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1988, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1988, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1988, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1988, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1988, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1988, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1988, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1988, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1988, 'Dodge', 'Dynasty', 'Sedan 4-Door'],
    [1988, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1988, 'Dodge', 'Lancer', 'Hatchback 4-Door'],
    [1988, 'Dodge', 'Mini Ram', 'Mini Cargo Van 3-Door'],
    [1988, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1988, 'Dodge', 'Raider', 'SUV 2-Door'],
    [1988, 'Dodge', 'Ram 50', 'Extended Cab Pickup 2-Door'],
    [1988, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1988, 'Dodge', 'Shadow', 'Hatchback 2-Door'],
    [1988, 'Dodge', 'Shadow', 'Hatchback 4-Door'],
    [1988, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1988, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1988, 'Eagle', 'Medallion', 'Sedan 4-Door'],
    [1988, 'Eagle', 'Medallion', 'Wagon 4-Door'],
    [1988, 'Eagle', 'Premier', 'Sedan 4-Door'],
    [1988, 'Eagle', 'Vista', 'Sedan 4-Door'],
    [1988, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1988, 'Ferrari', '412', 'Coupe 2-Door'],
    [1988, 'Ferrari', '328 GTB', 'Coupe 2-Door'],
    [1988, 'Ferrari', '328 GTS', 'Coupe 2-Door'],
    [1988, 'Ferrari', 'Mondial 3.2', 'Convertible 2-Door'],
    [1988, 'Ferrari', 'Mondial 3.2', 'Coupe 2-Door'],
    [1988, 'Ferrari', 'Testarossa', 'Coupe 2-Door'],
    [1988, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1988, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1988, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1988, 'Ford', 'Bronco II', 'SUV 2-Door'],
    [1988, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1988, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1988, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1988, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1988, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1988, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1988, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1988, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1988, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1988, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1988, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1988, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1988, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1988, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1988, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1988, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1988, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1988, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1988, 'Ford', 'EXP', 'Coupe 2-Door'],
    [1988, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1988, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1988, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1988, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1988, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1988, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1988, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1988, 'Ford', 'Festiva', 'Hatchback 2-Door'],
    [1988, 'Ford', 'LTD Crown Victoria', 'Sedan 4-Door'],
    [1988, 'Ford', 'LTD Crown Victoria', 'Wagon 4-Door'],
    [1988, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1988, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1988, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1988, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1988, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1988, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1988, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1988, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1988, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1988, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1988, 'GMC', 'C1500', 'Extended Cab Pickup 2-Door'],
    [1988, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1988, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1988, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1988, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1988, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1988, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1988, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1988, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1988, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1988, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1988, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1988, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1988, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1988, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1988, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1988, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1988, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1988, 'GMC', 'K1500', 'Extended Cab Pickup 2-Door'],
    [1988, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1988, 'GMC', 'K2500', 'Extended Cab Pickup 2-Door'],
    [1988, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1988, 'GMC', 'K3500', 'Extended Cab Pickup 2-Door'],
    [1988, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1988, 'GMC', 'R1500 Suburban', 'SUV 4-Door'],
    [1988, 'GMC', 'R2500', 'Crew Cab Pickup 4-Door'],
    [1988, 'GMC', 'R2500 Suburban', 'SUV 4-Door'],
    [1988, 'GMC', 'R3500', 'Crew Cab Pickup 4-Door'],
    [1988, 'GMC', 'R3500', 'Standard Cab Pickup 2-Door'],
    [1988, 'GMC', 'S15', 'Extended Cab Pickup 2-Door'],
    [1988, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1988, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1988, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1988, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1988, 'GMC', 'V1500 Suburban', 'SUV 4-Door'],
    [1988, 'GMC', 'V2500 Suburban', 'SUV 4-Door'],
    [1988, 'GMC', 'V3500', 'Crew Cab Pickup 4-Door'],
    [1988, 'GMC', 'V3500', 'Standard Cab Pickup 2-Door'],
    [1988, 'Honda', 'Accord', 'Coupe 2-Door'],
    [1988, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1988, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1988, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1988, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1988, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1988, 'Honda', 'CRX', 'Coupe 2-Door'],
    [1988, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1988, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1988, 'Hyundai', 'Excel', 'Hatchback 4-Door'],
    [1988, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1988, 'Isuzu', 'I-Mark', 'Hatchback 2-Door'],
    [1988, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1988, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1988, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1988, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1988, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1988, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1988, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1988, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1988, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1988, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1988, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1988, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1988, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1988, 'Jeep', 'Comanche', 'Standard Cab Pickup 2-Door'],
    [1988, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1988, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1988, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1988, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1988, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1988, 'Lada', 'Niva', 'SUV 2-Door'],
    [1988, 'Lada', 'Samara', 'Hatchback 2-Door'],
    [1988, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1988, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1988, 'Lamborghini', 'Jalpa', 'Coupe 2-Door'],
    [1988, 'Lamborghini', 'LM002', 'SUV 4-Door'],
    [1988, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1988, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1988, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1988, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1988, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1988, 'Mazda', '323', 'Hatchback 2-Door'],
    [1988, 'Mazda', '323', 'Sedan 4-Door'],
    [1988, 'Mazda', '323', 'Wagon 4-Door'],
    [1988, 'Mazda', '626', 'Hatchback 4-Door'],
    [1988, 'Mazda', '626', 'Sedan 4-Door'],
    [1988, 'Mazda', '929', 'Sedan 4-Door'],
    [1988, 'Mazda', 'B2200', 'Extended Cab Pickup 2-Door'],
    [1988, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1988, 'Mazda', 'B2600', 'Extended Cab Pickup 2-Door'],
    [1988, 'Mazda', 'B2600', 'Standard Cab Pickup 2-Door'],
    [1988, 'Mazda', 'MX-6', 'Coupe 2-Door'],
    [1988, 'Mazda', 'RX-7', 'Convertible 2-Door'],
    [1988, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1988, 'Mercedes-Benz', '190D', 'Sedan 4-Door'],
    [1988, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1988, 'Mercedes-Benz', '260E', 'Sedan 4-Door'],
    [1988, 'Mercedes-Benz', '300CE', 'Coupe 2-Door'],
    [1988, 'Mercedes-Benz', '300E', 'Sedan 4-Door'],
    [1988, 'Mercedes-Benz', '300SE', 'Sedan 4-Door'],
    [1988, 'Mercedes-Benz', '300SEL', 'Sedan 4-Door'],
    [1988, 'Mercedes-Benz', '300TE', 'Wagon 4-Door'],
    [1988, 'Mercedes-Benz', '420SEL', 'Sedan 4-Door'],
    [1988, 'Mercedes-Benz', '560SEC', 'Coupe 2-Door'],
    [1988, 'Mercedes-Benz', '560SEL', 'Sedan 4-Door'],
    [1988, 'Mercedes-Benz', '560SL', 'Convertible 2-Door'],
    [1988, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1988, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1988, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1988, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1988, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1988, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1988, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1988, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1988, 'Mercury', 'Tracer', 'Hatchback 2-Door'],
    [1988, 'Mercury', 'Tracer', 'Hatchback 4-Door'],
    [1988, 'Mercury', 'Tracer', 'Wagon 4-Door'],
    [1988, 'Merkur', 'Scorpio', 'Hatchback 4-Door'],
    [1988, 'Merkur', 'XR4Ti', 'Hatchback 2-Door'],
    [1988, 'Mitsubishi', 'Cordia', 'Hatchback 2-Door'],
    [1988, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1988, 'Mitsubishi', 'Mighty Max', 'Extended Cab Pickup 2-Door'],
    [1988, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1988, 'Mitsubishi', 'Mirage', 'Hatchback 2-Door'],
    [1988, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1988, 'Mitsubishi', 'Montero', 'SUV 2-Door'],
    [1988, 'Mitsubishi', 'Precis', 'Hatchback 2-Door'],
    [1988, 'Mitsubishi', 'Precis', 'Hatchback 4-Door'],
    [1988, 'Mitsubishi', 'Starion', 'Coupe 2-Door'],
    [1988, 'Mitsubishi', 'Tredia', 'Sedan 4-Door'],
    [1988, 'Mitsubishi', 'Van', 'Standard Cargo Van 3-Door'],
    [1988, 'Mitsubishi', 'Van', 'Standard Passenger Van 3-Door'],
    [1988, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1988, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1988, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1988, 'Nissan', '200SX', 'Hatchback 2-Door'],
    [1988, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1988, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1988, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1988, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1988, 'Nissan', 'Maxima', 'Wagon 4-Door'],
    [1988, 'Nissan', 'Micra', 'Hatchback 2-Door'],
    [1988, 'Nissan', 'Multi', 'Wagon 4-Door'],
    [1988, 'Nissan', 'Pathfinder', 'SUV 2-Door'],
    [1988, 'Nissan', 'Pulsar NX', 'Coupe 2-Door'],
    [1988, 'Nissan', 'Sentra', 'Coupe 2-Door'],
    [1988, 'Nissan', 'Sentra', 'Hatchback 2-Door'],
    [1988, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1988, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1988, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1988, 'Nissan', 'Stanza', 'Hatchback 4-Door'],
    [1988, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1988, 'Nissan', 'Stanza', 'Wagon 4-Door'],
    [1988, 'Nissan', 'Van', 'Standard Cargo Van 3-Door'],
    [1988, 'Nissan', 'Van', 'Standard Passenger Van 3-Door'],
    [1988, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1988, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1988, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1988, 'Oldsmobile', 'Cutlass Calais', 'Sedan 4-Door'],
    [1988, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1988, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1988, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1988, 'Oldsmobile', 'Cutlass Supreme', 'Convertible 2-Door'],
    [1988, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1988, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1988, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1988, 'Oldsmobile', 'Firenza', 'Coupe 2-Door'],
    [1988, 'Oldsmobile', 'Firenza', 'Sedan 4-Door'],
    [1988, 'Oldsmobile', 'Firenza', 'Wagon 4-Door'],
    [1988, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1988, 'Peugeot', '505', 'Sedan 4-Door'],
    [1988, 'Peugeot', '505', 'Wagon 4-Door'],
    [1988, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1988, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1988, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1988, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1988, 'Plymouth', 'Expo', 'Wagon 4-Door'],
    [1988, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1988, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1988, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1988, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1988, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1988, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1988, 'Plymouth', 'Sundance', 'Hatchback 2-Door'],
    [1988, 'Plymouth', 'Sundance', 'Hatchback 4-Door'],
    [1988, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1988, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1988, 'Pontiac', '6000', 'Wagon 4-Door'],
    [1988, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1988, 'Pontiac', 'Fiero', 'Coupe 2-Door'],
    [1988, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1988, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1988, 'Pontiac', 'Firefly', 'Hatchback 4-Door'],
    [1988, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1988, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1988, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1988, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1988, 'Pontiac', 'LeMans', 'Hatchback 2-Door'],
    [1988, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1988, 'Pontiac', 'Optima', 'Sedan 4-Door'],
    [1988, 'Pontiac', 'Safari', 'Wagon 4-Door'],
    [1988, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1988, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1988, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1988, 'Pontiac', 'Sunbird', 'Wagon 4-Door'],
    [1988, 'Pontiac', 'Sunburst', 'Sedan 4-Door'],
    [1988, 'Pontiac', 'Tempest', 'Sedan 4-Door'],
    [1988, 'Porsche', '911', 'Convertible 2-Door'],
    [1988, 'Porsche', '911', 'Coupe 2-Door'],
    [1988, 'Porsche', '911', 'Targa 2-Door'],
    [1988, 'Porsche', '924', 'Coupe 2-Door'],
    [1988, 'Porsche', '928', 'Coupe 2-Door'],
    [1988, 'Porsche', '944', 'Coupe 2-Door'],
    [1988, 'Rolls-Royce', 'Corniche II', 'Convertible 2-Door'],
    [1988, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1988, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1988, 'Saab', '900', 'Convertible 2-Door'],
    [1988, 'Saab', '900', 'Hatchback 2-Door'],
    [1988, 'Saab', '900', 'Sedan 4-Door'],
    [1988, 'Saab', '9000', 'Hatchback 4-Door'],
    [1988, 'Sterling', '825', 'Sedan 4-Door'],
    [1988, 'Subaru', 'DL', 'Coupe 3-Door'],
    [1988, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1988, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1988, 'Subaru', 'GL', 'Coupe 3-Door'],
    [1988, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1988, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1988, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1988, 'Subaru', 'GL-10', 'Sedan 4-Door'],
    [1988, 'Subaru', 'GL-10', 'Wagon 4-Door'],
    [1988, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1988, 'Subaru', 'RX', 'Coupe 3-Door'],
    [1988, 'Subaru', 'RX', 'Sedan 4-Door'],
    [1988, 'Subaru', 'XT', 'Coupe 2-Door'],
    [1988, 'Suzuki', 'Forsa', 'Hatchback 2-Door'],
    [1988, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1988, 'Toyota', '4Runner', 'SUV 2-Door'],
    [1988, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1988, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1988, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1988, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1988, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1988, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1988, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1988, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1988, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1988, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1988, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1988, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1988, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1988, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1988, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1988, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1988, 'Toyota', 'Tercel', 'Hatchback 4-Door'],
    [1988, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1988, 'Toyota', 'Tercel', 'Wagon 4-Door'],
    [1988, 'Toyota', 'Van', 'Mini Cargo Van 3-Door'],
    [1988, 'Toyota', 'Van', 'Mini Passenger Van 3-Door'],
    [1988, 'Toyota', 'Van Wagon', 'Mini Cargo Van 3-Door'],
    [1988, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1988, 'Volkswagen', 'Fox', 'Sedan 2-Door'],
    [1988, 'Volkswagen', 'Fox', 'Sedan 4-Door'],
    [1988, 'Volkswagen', 'Fox', 'Wagon 2-Door'],
    [1988, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1988, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1988, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1988, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1988, 'Volkswagen', 'Quantum', 'Sedan 4-Door'],
    [1988, 'Volkswagen', 'Quantum', 'Wagon 4-Door'],
    [1988, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1988, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1988, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1988, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1988, 'Volvo', '244', 'Sedan 4-Door'],
    [1988, 'Volvo', '245', 'Wagon 4-Door'],
    [1988, 'Volvo', '740', 'Sedan 4-Door'],
    [1988, 'Volvo', '740', 'Wagon 4-Door'],
    [1988, 'Volvo', '760', 'Sedan 4-Door'],
    [1988, 'Volvo', '760', 'Wagon 4-Door'],
    [1988, 'Volvo', '780', 'Coupe 2-Door'],
    [1988, 'Yugo', 'GV', 'Hatchback 2-Door'],
    [1988, 'Yugo', 'GVL', 'Hatchback 2-Door'],
    [1988, 'Yugo', 'GVS', 'Hatchback 2-Door'],
    [1988, 'Yugo', 'GVX', 'Hatchback 2-Door'],
    [1987, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1987, 'Acura', 'Integra', 'Hatchback 4-Door'],
    [1987, 'Acura', 'Legend', 'Coupe 2-Door'],
    [1987, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1987, 'Alfa Romeo', 'Milano', 'Sedan 4-Door'],
    [1987, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1987, 'AMC', 'Eagle', 'Sedan 4-Door'],
    [1987, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1987, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1987, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1987, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1987, 'Aston Martin', 'Zagato', 'Coupe 2-Door'],
    [1987, 'Audi', '4000', 'Sedan 2-Door'],
    [1987, 'Audi', '4000', 'Sedan 4-Door'],
    [1987, 'Audi', '5000', 'Sedan 4-Door'],
    [1987, 'Audi', '5000', 'Wagon 4-Door'],
    [1987, 'Audi', '4000 Quattro', 'Sedan 4-Door'],
    [1987, 'Audi', '5000 Quattro', 'Sedan 4-Door'],
    [1987, 'Audi', '5000 Quattro', 'Wagon 4-Door'],
    [1987, 'Audi', 'Coupe', 'Coupe 2-Door'],
    [1987, 'Avanti', 'II', 'Convertible 2-Door'],
    [1987, 'Avanti', 'II', 'Coupe 2-Door'],
    [1987, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1987, 'Bentley', 'Eight', 'Sedan 4-Door'],
    [1987, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1987, 'Bertone', 'X-1/9', 'Coupe 2-Door'],
    [1987, 'BMW', '325', 'Coupe 2-Door'],
    [1987, 'BMW', '325', 'Sedan 4-Door'],
    [1987, 'BMW', '325e', 'Coupe 2-Door'],
    [1987, 'BMW', '325e', 'Sedan 4-Door'],
    [1987, 'BMW', '325es', 'Coupe 2-Door'],
    [1987, 'BMW', '325i', 'Convertible 2-Door'],
    [1987, 'BMW', '325i', 'Sedan 4-Door'],
    [1987, 'BMW', '325is', 'Coupe 2-Door'],
    [1987, 'BMW', '528e', 'Sedan 4-Door'],
    [1987, 'BMW', '535i', 'Sedan 4-Door'],
    [1987, 'BMW', '635CSi', 'Coupe 2-Door'],
    [1987, 'BMW', '735i', 'Sedan 4-Door'],
    [1987, 'BMW', 'L6', 'Coupe 2-Door'],
    [1987, 'BMW', 'L7', 'Sedan 4-Door'],
    [1987, 'BMW', 'M6', 'Coupe 2-Door'],
    [1987, 'Buick', 'Century', 'Coupe 2-Door'],
    [1987, 'Buick', 'Century', 'Sedan 4-Door'],
    [1987, 'Buick', 'Century', 'Wagon 4-Door'],
    [1987, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1987, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1987, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1987, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1987, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1987, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1987, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1987, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1987, 'Buick', 'Skyhawk', 'Coupe 2-Door'],
    [1987, 'Buick', 'Skyhawk', 'Hatchback 2-Door'],
    [1987, 'Buick', 'Skyhawk', 'Sedan 4-Door'],
    [1987, 'Buick', 'Skyhawk', 'Wagon 4-Door'],
    [1987, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1987, 'Buick', 'Somerset', 'Coupe 2-Door'],
    [1987, 'Cadillac', 'Allante', 'Convertible 2-Door'],
    [1987, 'Cadillac', 'Brougham', 'Sedan 4-Door'],
    [1987, 'Cadillac', 'Cimarron', 'Sedan 4-Door'],
    [1987, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1987, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1987, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1987, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1987, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1987, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1987, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1987, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1987, 'Chevrolet', 'Beretta', 'Coupe 2-Door'],
    [1987, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1987, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1987, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1987, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1987, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1987, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1987, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1987, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1987, 'Chevrolet', 'Cavalier', 'Hatchback 2-Door'],
    [1987, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1987, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1987, 'Chevrolet', 'Celebrity', 'Coupe 2-Door'],
    [1987, 'Chevrolet', 'Celebrity', 'Sedan 4-Door'],
    [1987, 'Chevrolet', 'Celebrity', 'Wagon 4-Door'],
    [1987, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1987, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1987, 'Chevrolet', 'Corsica', 'Sedan 4-Door'],
    [1987, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1987, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1987, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1987, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1987, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1987, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1987, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1987, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1987, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1987, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1987, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1987, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1987, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1987, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1987, 'Chevrolet', 'LLV', 'Mini Cargo Van 2-Door'],
    [1987, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1987, 'Chevrolet', 'Nova', 'Hatchback 4-Door'],
    [1987, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1987, 'Chevrolet', 'R10', 'Standard Cab Pickup 2-Door'],
    [1987, 'Chevrolet', 'R10 Suburban', 'SUV 4-Door'],
    [1987, 'Chevrolet', 'R20', 'Crew Cab Pickup 4-Door'],
    [1987, 'Chevrolet', 'R20', 'Standard Cab Pickup 2-Door'],
    [1987, 'Chevrolet', 'R20 Suburban', 'SUV 4-Door'],
    [1987, 'Chevrolet', 'R30', 'Crew Cab Pickup 4-Door'],
    [1987, 'Chevrolet', 'R30', 'Standard Cab Pickup 2-Door'],
    [1987, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1987, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1987, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1987, 'Chevrolet', 'Spectrum', 'Hatchback 2-Door'],
    [1987, 'Chevrolet', 'Spectrum', 'Sedan 4-Door'],
    [1987, 'Chevrolet', 'Sprint', 'Hatchback 2-Door'],
    [1987, 'Chevrolet', 'Sprint', 'Hatchback 4-Door'],
    [1987, 'Chevrolet', 'V10', 'Standard Cab Pickup 2-Door'],
    [1987, 'Chevrolet', 'V10 Suburban', 'SUV 4-Door'],
    [1987, 'Chevrolet', 'V20', 'Standard Cab Pickup 2-Door'],
    [1987, 'Chevrolet', 'V20 Suburban', 'SUV 4-Door'],
    [1987, 'Chevrolet', 'V30', 'Crew Cab Pickup 4-Door'],
    [1987, 'Chevrolet', 'V30', 'Standard Cab Pickup 2-Door'],
    [1987, 'Chrysler', 'Conquest', 'Hatchback 2-Door'],
    [1987, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1987, 'Chrysler', 'Fifth Avenue', 'Sedan 4-Door'],
    [1987, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1987, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1987, 'Chrysler', 'LeBaron', 'Hatchback 4-Door'],
    [1987, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1987, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1987, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1987, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1987, 'Dodge', '600', 'Sedan 4-Door'],
    [1987, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1987, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1987, 'Dodge', 'Aries', 'Wagon 4-Door'],
    [1987, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1987, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1987, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1987, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1987, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1987, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1987, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1987, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1987, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1987, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1987, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1987, 'Dodge', 'Charger', 'Hatchback 2-Door'],
    [1987, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1987, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1987, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1987, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'Dakota', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1987, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1987, 'Dodge', 'Grand Caravan', 'Mini Passenger Van 3-Door'],
    [1987, 'Dodge', 'Lancer', 'Hatchback 4-Door'],
    [1987, 'Dodge', 'Mini Ram', 'Mini Cargo Van 3-Door'],
    [1987, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1987, 'Dodge', 'Raider', 'SUV 2-Door'],
    [1987, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1987, 'Dodge', 'Shadow', 'Hatchback 2-Door'],
    [1987, 'Dodge', 'Shadow', 'Hatchback 4-Door'],
    [1987, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1987, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1987, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1987, 'Ferrari', '412', 'Coupe 2-Door'],
    [1987, 'Ferrari', '328 GTB', 'Coupe 2-Door'],
    [1987, 'Ferrari', '328 GTS', 'Coupe 2-Door'],
    [1987, 'Ferrari', 'GTO', 'Coupe 2-Door'],
    [1987, 'Ferrari', 'Mondial 3.2', 'Convertible 2-Door'],
    [1987, 'Ferrari', 'Mondial 3.2', 'Coupe 2-Door'],
    [1987, 'Ferrari', 'Testarossa', 'Coupe 2-Door'],
    [1987, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1987, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1987, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1987, 'Ford', 'Bronco II', 'SUV 2-Door'],
    [1987, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1987, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1987, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1987, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1987, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1987, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1987, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1987, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1987, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1987, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1987, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1987, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1987, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1987, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1987, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1987, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1987, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1987, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1987, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1987, 'Ford', 'EXP', 'Coupe 2-Door'],
    [1987, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1987, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1987, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1987, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1987, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1987, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1987, 'Ford', 'LTD Crown Victoria', 'Sedan 2-Door'],
    [1987, 'Ford', 'LTD Crown Victoria', 'Sedan 4-Door'],
    [1987, 'Ford', 'LTD Crown Victoria', 'Wagon 4-Door'],
    [1987, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1987, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1987, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1987, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1987, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1987, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1987, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1987, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1987, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1987, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1987, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1987, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1987, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1987, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1987, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1987, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1987, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1987, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1987, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1987, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1987, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1987, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1987, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1987, 'GMC', 'R1500', 'Standard Cab Pickup 2-Door'],
    [1987, 'GMC', 'R1500 Suburban', 'SUV 4-Door'],
    [1987, 'GMC', 'R2500', 'Crew Cab Pickup 4-Door'],
    [1987, 'GMC', 'R2500', 'Standard Cab Pickup 2-Door'],
    [1987, 'GMC', 'R2500 Suburban', 'SUV 4-Door'],
    [1987, 'GMC', 'R3500', 'Crew Cab Pickup 4-Door'],
    [1987, 'GMC', 'R3500', 'Standard Cab Pickup 2-Door'],
    [1987, 'GMC', 'S15', 'Extended Cab Pickup 2-Door'],
    [1987, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1987, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1987, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1987, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1987, 'GMC', 'V1500', 'Standard Cab Pickup 2-Door'],
    [1987, 'GMC', 'V1500 Suburban', 'SUV 4-Door'],
    [1987, 'GMC', 'V2500', 'Standard Cab Pickup 2-Door'],
    [1987, 'GMC', 'V2500 Suburban', 'SUV 4-Door'],
    [1987, 'GMC', 'V3500', 'Crew Cab Pickup 4-Door'],
    [1987, 'GMC', 'V3500', 'Standard Cab Pickup 2-Door'],
    [1987, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1987, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1987, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1987, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1987, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1987, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1987, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1987, 'Honda', 'Wagovan', 'Wagon 4-Door'],
    [1987, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1987, 'Hyundai', 'Excel', 'Hatchback 4-Door'],
    [1987, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1987, 'Hyundai', 'Pony', 'Hatchback 2-Door'],
    [1987, 'Hyundai', 'Stellar', 'Sedan 4-Door'],
    [1987, 'Isuzu', 'I-Mark', 'Hatchback 2-Door'],
    [1987, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1987, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1987, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1987, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1987, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1987, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1987, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1987, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1987, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1987, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1987, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1987, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1987, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1987, 'Jeep', 'Comanche', 'Standard Cab Pickup 2-Door'],
    [1987, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1987, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1987, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1987, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1987, 'Jeep', 'Wrangler', 'SUV 2-Door'],
    [1987, 'Lada', 'Niva', 'SUV 2-Door'],
    [1987, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1987, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1987, 'Lamborghini', 'Jalpa', 'Coupe 2-Door'],
    [1987, 'Lamborghini', 'LM002', 'SUV 4-Door'],
    [1987, 'Land Rover', 'Range Rover', 'SUV 4-Door'],
    [1987, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1987, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1987, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1987, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1987, 'Maserati', '425', 'Coupe 2-Door'],
    [1987, 'Maserati', '425', 'Sedan 4-Door'],
    [1987, 'Maserati', 'Biturbo', 'Coupe 2-Door'],
    [1987, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [1987, 'Mazda', '323', 'Hatchback 2-Door'],
    [1987, 'Mazda', '323', 'Sedan 4-Door'],
    [1987, 'Mazda', '323', 'Wagon 4-Door'],
    [1987, 'Mazda', '626', 'Coupe 2-Door'],
    [1987, 'Mazda', '626', 'Hatchback 4-Door'],
    [1987, 'Mazda', '626', 'Sedan 4-Door'],
    [1987, 'Mazda', 'B2000', 'Extended Cab Pickup 2-Door'],
    [1987, 'Mazda', 'B2000', 'Standard Cab Pickup 2-Door'],
    [1987, 'Mazda', 'B2200', 'Extended Cab Pickup 2-Door'],
    [1987, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1987, 'Mazda', 'B2600', 'Extended Cab Pickup 2-Door'],
    [1987, 'Mazda', 'B2600', 'Standard Cab Pickup 2-Door'],
    [1987, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1987, 'Mercedes-Benz', '190D', 'Sedan 4-Door'],
    [1987, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1987, 'Mercedes-Benz', '260E', 'Sedan 4-Door'],
    [1987, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1987, 'Mercedes-Benz', '300E', 'Sedan 4-Door'],
    [1987, 'Mercedes-Benz', '300SDL', 'Sedan 4-Door'],
    [1987, 'Mercedes-Benz', '300TD', 'Wagon 4-Door'],
    [1987, 'Mercedes-Benz', '420SEL', 'Sedan 4-Door'],
    [1987, 'Mercedes-Benz', '560SEC', 'Coupe 2-Door'],
    [1987, 'Mercedes-Benz', '560SEL', 'Sedan 4-Door'],
    [1987, 'Mercedes-Benz', '560SL', 'Convertible 2-Door'],
    [1987, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1987, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1987, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1987, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1987, 'Mercury', 'Lynx', 'Hatchback 2-Door'],
    [1987, 'Mercury', 'Lynx', 'Hatchback 4-Door'],
    [1987, 'Mercury', 'Lynx', 'Wagon 4-Door'],
    [1987, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1987, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1987, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1987, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1987, 'Mercury', 'Tracer', 'Hatchback 2-Door'],
    [1987, 'Mercury', 'Tracer', 'Hatchback 4-Door'],
    [1987, 'Merkur', 'XR4Ti', 'Hatchback 2-Door'],
    [1987, 'Mitsubishi', 'Cordia', 'Hatchback 2-Door'],
    [1987, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1987, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1987, 'Mitsubishi', 'Mirage', 'Hatchback 2-Door'],
    [1987, 'Mitsubishi', 'Mirage', 'Sedan 4-Door'],
    [1987, 'Mitsubishi', 'Montero', 'SUV 2-Door'],
    [1987, 'Mitsubishi', 'Precis', 'Hatchback 2-Door'],
    [1987, 'Mitsubishi', 'Precis', 'Hatchback 4-Door'],
    [1987, 'Mitsubishi', 'Starion', 'Coupe 2-Door'],
    [1987, 'Mitsubishi', 'Tredia', 'Sedan 4-Door'],
    [1987, 'Mitsubishi', 'Van', 'Standard Cargo Van 3-Door'],
    [1987, 'Mitsubishi', 'Van', 'Standard Passenger Van 3-Door'],
    [1987, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1987, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1987, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1987, 'Nissan', '200SX', 'Hatchback 2-Door'],
    [1987, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1987, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1987, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1987, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1987, 'Nissan', 'Maxima', 'Wagon 4-Door'],
    [1987, 'Nissan', 'Micra', 'Hatchback 2-Door'],
    [1987, 'Nissan', 'Multi', 'Wagon 4-Door'],
    [1987, 'Nissan', 'Pathfinder', 'SUV 2-Door'],
    [1987, 'Nissan', 'Pulsar NX', 'Coupe 2-Door'],
    [1987, 'Nissan', 'Sentra', 'Coupe 2-Door'],
    [1987, 'Nissan', 'Sentra', 'Hatchback 2-Door'],
    [1987, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1987, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1987, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1987, 'Nissan', 'Stanza', 'Hatchback 4-Door'],
    [1987, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1987, 'Nissan', 'Stanza', 'Wagon 4-Door'],
    [1987, 'Nissan', 'Van', 'Standard Cargo Van 3-Door'],
    [1987, 'Nissan', 'Van', 'Standard Passenger Van 3-Door'],
    [1987, 'Oldsmobile', '98', 'Sedan 2-Door'],
    [1987, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1987, 'Oldsmobile', 'Calais', 'Coupe 2-Door'],
    [1987, 'Oldsmobile', 'Calais', 'Sedan 4-Door'],
    [1987, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1987, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1987, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1987, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1987, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1987, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1987, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1987, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1987, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1987, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1987, 'Oldsmobile', 'Firenza', 'Coupe 2-Door'],
    [1987, 'Oldsmobile', 'Firenza', 'Hatchback 2-Door'],
    [1987, 'Oldsmobile', 'Firenza', 'Sedan 4-Door'],
    [1987, 'Oldsmobile', 'Firenza', 'Wagon 4-Door'],
    [1987, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1987, 'Peugeot', '505', 'Sedan 4-Door'],
    [1987, 'Peugeot', '505', 'Wagon 4-Door'],
    [1987, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1987, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1987, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1987, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1987, 'Plymouth', 'Expo', 'Wagon 4-Door'],
    [1987, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1987, 'Plymouth', 'Grand Voyager', 'Mini Passenger Van 3-Door'],
    [1987, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1987, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1987, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1987, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1987, 'Plymouth', 'Sundance', 'Hatchback 2-Door'],
    [1987, 'Plymouth', 'Sundance', 'Hatchback 4-Door'],
    [1987, 'Plymouth', 'Turismo', 'Hatchback 2-Door'],
    [1987, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1987, 'Pontiac', '6000', 'Coupe 2-Door'],
    [1987, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1987, 'Pontiac', '6000', 'Wagon 4-Door'],
    [1987, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1987, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1987, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1987, 'Pontiac', 'Fiero', 'Coupe 2-Door'],
    [1987, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1987, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1987, 'Pontiac', 'Firefly', 'Hatchback 4-Door'],
    [1987, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1987, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1987, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1987, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1987, 'Pontiac', 'Safari', 'Wagon 4-Door'],
    [1987, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1987, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1987, 'Pontiac', 'Sunbird', 'Hatchback 2-Door'],
    [1987, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1987, 'Pontiac', 'Sunbird', 'Wagon 4-Door'],
    [1987, 'Pontiac', 'Sunburst', 'Sedan 4-Door'],
    [1987, 'Pontiac', 'T1000', 'Hatchback 2-Door'],
    [1987, 'Pontiac', 'T1000', 'Hatchback 4-Door'],
    [1987, 'Pontiac', 'Tempest', 'Sedan 4-Door'],
    [1987, 'Porsche', '911', 'Convertible 2-Door'],
    [1987, 'Porsche', '911', 'Coupe 2-Door'],
    [1987, 'Porsche', '911', 'Targa 2-Door'],
    [1987, 'Porsche', '924', 'Coupe 2-Door'],
    [1987, 'Porsche', '928', 'Coupe 2-Door'],
    [1987, 'Porsche', '944', 'Coupe 2-Door'],
    [1987, 'Renault', 'Alliance', 'Convertible 2-Door'],
    [1987, 'Renault', 'Alliance', 'Hatchback 2-Door'],
    [1987, 'Renault', 'Alliance', 'Hatchback 4-Door'],
    [1987, 'Renault', 'Alliance', 'Sedan 2-Door'],
    [1987, 'Renault', 'Alliance', 'Sedan 4-Door'],
    [1987, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1987, 'Rolls-Royce', 'Corniche II', 'Convertible 2-Door'],
    [1987, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1987, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1987, 'Saab', '900', 'Convertible 2-Door'],
    [1987, 'Saab', '900', 'Hatchback 2-Door'],
    [1987, 'Saab', '900', 'Sedan 4-Door'],
    [1987, 'Saab', '9000', 'Hatchback 4-Door'],
    [1987, 'Sterling', '825', 'Sedan 4-Door'],
    [1987, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1987, 'Subaru', 'DL', 'Coupe 3-Door'],
    [1987, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1987, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1987, 'Subaru', 'GL', 'Coupe 3-Door'],
    [1987, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1987, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1987, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1987, 'Subaru', 'GL-10', 'Sedan 4-Door'],
    [1987, 'Subaru', 'GL-10', 'Wagon 4-Door'],
    [1987, 'Subaru', 'Justy', 'Hatchback 2-Door'],
    [1987, 'Subaru', 'RX', 'Sedan 4-Door'],
    [1987, 'Subaru', 'Standard', 'Hatchback 2-Door'],
    [1987, 'Subaru', 'XT', 'Coupe 2-Door'],
    [1987, 'Suzuki', 'Forsa', 'Hatchback 2-Door'],
    [1987, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1987, 'Toyota', '4Runner', 'SUV 2-Door'],
    [1987, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1987, 'Toyota', 'Camry', 'Wagon 4-Door'],
    [1987, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1987, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1987, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1987, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1987, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1987, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [1987, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1987, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1987, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1987, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1987, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1987, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1987, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1987, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1987, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1987, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1987, 'Toyota', 'Tercel', 'Hatchback 4-Door'],
    [1987, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1987, 'Toyota', 'Tercel', 'Sedan 3-Door'],
    [1987, 'Toyota', 'Tercel', 'Sedan 5-Door'],
    [1987, 'Toyota', 'Tercel', 'Wagon 4-Door'],
    [1987, 'Toyota', 'Van', 'Mini Cargo Van 3-Door'],
    [1987, 'Toyota', 'Van', 'Mini Passenger Van 3-Door'],
    [1987, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1987, 'Volkswagen', 'Fox', 'Sedan 2-Door'],
    [1987, 'Volkswagen', 'Fox', 'Sedan 4-Door'],
    [1987, 'Volkswagen', 'Fox', 'Wagon 2-Door'],
    [1987, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1987, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1987, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1987, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1987, 'Volkswagen', 'Quantum', 'Sedan 4-Door'],
    [1987, 'Volkswagen', 'Quantum', 'Wagon 4-Door'],
    [1987, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1987, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1987, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1987, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1987, 'Volvo', '244', 'Sedan 4-Door'],
    [1987, 'Volvo', '245', 'Wagon 4-Door'],
    [1987, 'Volvo', '740', 'Sedan 4-Door'],
    [1987, 'Volvo', '740', 'Wagon 4-Door'],
    [1987, 'Volvo', '760', 'Sedan 4-Door'],
    [1987, 'Volvo', '760', 'Wagon 4-Door'],
    [1987, 'Volvo', '780', 'Coupe 2-Door'],
    [1987, 'Yugo', 'GV', 'Hatchback 2-Door'],
    [1987, 'Yugo', 'GVX', 'Hatchback 2-Door'],
    [1986, 'Acura', 'Integra', 'Hatchback 2-Door'],
    [1986, 'Acura', 'Integra', 'Hatchback 4-Door'],
    [1986, 'Acura', 'Legend', 'Sedan 4-Door'],
    [1986, 'Alfa Romeo', 'GTV-6', 'Coupe 2-Door'],
    [1986, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1986, 'AMC', 'Eagle', 'Sedan 4-Door'],
    [1986, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1986, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1986, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1986, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1986, 'Audi', '4000', 'Sedan 2-Door'],
    [1986, 'Audi', '4000', 'Sedan 4-Door'],
    [1986, 'Audi', '5000', 'Sedan 4-Door'],
    [1986, 'Audi', '5000', 'Wagon 4-Door'],
    [1986, 'Audi', '4000 Quattro', 'Sedan 4-Door'],
    [1986, 'Audi', '5000 Quattro', 'Sedan 4-Door'],
    [1986, 'Audi', '5000 Quattro', 'Wagon 4-Door'],
    [1986, 'Audi', 'Coupe', 'Coupe 2-Door'],
    [1986, 'Audi', 'Quattro', 'Hatchback 2-Door'],
    [1986, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1986, 'Bentley', 'Eight', 'Sedan 4-Door'],
    [1986, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1986, 'Bertone', 'X-1/9', 'Coupe 2-Door'],
    [1986, 'BMW', '325', 'Coupe 2-Door'],
    [1986, 'BMW', '325', 'Sedan 4-Door'],
    [1986, 'BMW', '325e', 'Coupe 2-Door'],
    [1986, 'BMW', '325e', 'Sedan 4-Door'],
    [1986, 'BMW', '325es', 'Coupe 2-Door'],
    [1986, 'BMW', '524td', 'Sedan 4-Door'],
    [1986, 'BMW', '528e', 'Sedan 4-Door'],
    [1986, 'BMW', '535i', 'Sedan 4-Door'],
    [1986, 'BMW', '635CSi', 'Coupe 2-Door'],
    [1986, 'BMW', '735i', 'Sedan 4-Door'],
    [1986, 'BMW', 'L7', 'Sedan 4-Door'],
    [1986, 'Buick', 'Century', 'Coupe 2-Door'],
    [1986, 'Buick', 'Century', 'Sedan 4-Door'],
    [1986, 'Buick', 'Century', 'Wagon 4-Door'],
    [1986, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1986, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1986, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1986, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1986, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1986, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1986, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1986, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1986, 'Buick', 'Skyhawk', 'Coupe 2-Door'],
    [1986, 'Buick', 'Skyhawk', 'Hatchback 2-Door'],
    [1986, 'Buick', 'Skyhawk', 'Sedan 4-Door'],
    [1986, 'Buick', 'Skyhawk', 'Wagon 4-Door'],
    [1986, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1986, 'Buick', 'Somerset', 'Coupe 2-Door'],
    [1986, 'Cadillac', 'Cimarron', 'Sedan 4-Door'],
    [1986, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1986, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1986, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1986, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1986, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1986, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1986, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1986, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1986, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1986, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1986, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1986, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1986, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1986, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1986, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1986, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1986, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1986, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1986, 'Chevrolet', 'Cavalier', 'Hatchback 2-Door'],
    [1986, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1986, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1986, 'Chevrolet', 'Celebrity', 'Coupe 2-Door'],
    [1986, 'Chevrolet', 'Celebrity', 'Sedan 4-Door'],
    [1986, 'Chevrolet', 'Celebrity', 'Wagon 4-Door'],
    [1986, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1986, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1986, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1986, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1986, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1986, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1986, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1986, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1986, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1986, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1986, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1986, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1986, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1986, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1986, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1986, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1986, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1986, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1986, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1986, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1986, 'Chevrolet', 'Nova', 'Hatchback 4-Door'],
    [1986, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1986, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1986, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1986, 'Chevrolet', 'Spectrum', 'Hatchback 2-Door'],
    [1986, 'Chevrolet', 'Spectrum', 'Sedan 4-Door'],
    [1986, 'Chevrolet', 'Sprint', 'Hatchback 2-Door'],
    [1986, 'Chevrolet', 'Sprint', 'Hatchback 4-Door'],
    [1986, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1986, 'Chrysler', 'Executive Limousine', 'Sedan 4-Door'],
    [1986, 'Chrysler', 'Fifth Avenue', 'Sedan 4-Door'],
    [1986, 'Chrysler', 'Laser', 'Hatchback 2-Door'],
    [1986, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1986, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1986, 'Chrysler', 'LeBaron', 'Hatchback 4-Door'],
    [1986, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1986, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1986, 'Chrysler', 'Town & Country', 'Convertible 2-Door'],
    [1986, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1986, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1986, 'Dodge', '600', 'Convertible 2-Door'],
    [1986, 'Dodge', '600', 'Coupe 2-Door'],
    [1986, 'Dodge', '600', 'Sedan 4-Door'],
    [1986, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1986, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1986, 'Dodge', 'Aries', 'Wagon 4-Door'],
    [1986, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1986, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1986, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1986, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1986, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1986, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1986, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1986, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1986, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1986, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1986, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1986, 'Dodge', 'Charger', 'Hatchback 2-Door'],
    [1986, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1986, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1986, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1986, 'Dodge', 'Conquest', 'Hatchback 2-Door'],
    [1986, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1986, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1986, 'Dodge', 'Lancer', 'Hatchback 4-Door'],
    [1986, 'Dodge', 'Mini Ram', 'Mini Cargo Van 3-Door'],
    [1986, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1986, 'Dodge', 'Power Ram 50', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1986, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1986, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1986, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1986, 'Ferrari', '412', 'Coupe 2-Door'],
    [1986, 'Ferrari', '328 GTB', 'Coupe 2-Door'],
    [1986, 'Ferrari', '328 GTS', 'Coupe 2-Door'],
    [1986, 'Ferrari', 'GTO', 'Coupe 2-Door'],
    [1986, 'Ferrari', 'Mondial 3.2', 'Convertible 2-Door'],
    [1986, 'Ferrari', 'Mondial 3.2', 'Coupe 2-Door'],
    [1986, 'Ferrari', 'Testarossa', 'Coupe 2-Door'],
    [1986, 'Ford', 'Aerostar', 'Mini Cargo Van 2-Door'],
    [1986, 'Ford', 'Aerostar', 'Mini Passenger Van 2-Door'],
    [1986, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1986, 'Ford', 'Bronco II', 'SUV 2-Door'],
    [1986, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1986, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1986, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1986, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1986, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1986, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1986, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1986, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1986, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1986, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1986, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1986, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1986, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1986, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1986, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1986, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1986, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1986, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1986, 'Ford', 'EXP', 'Hatchback 2-Door'],
    [1986, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1986, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1986, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1986, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1986, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1986, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1986, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1986, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1986, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1986, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1986, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1986, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1986, 'Ford', 'Ranger', 'Extended Cab Pickup 2-Door'],
    [1986, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1986, 'Ford', 'Taurus', 'Sedan 4-Door'],
    [1986, 'Ford', 'Taurus', 'Wagon 4-Door'],
    [1986, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1986, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1986, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1986, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1986, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1986, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1986, 'GMC', 'C2500', 'Extended Cab Pickup 2-Door'],
    [1986, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1986, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1986, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1986, 'GMC', 'C3500', 'Extended Cab Pickup 2-Door'],
    [1986, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1986, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1986, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1986, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1986, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1986, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1986, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1986, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1986, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1986, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1986, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1986, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1986, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1986, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1986, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1986, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1986, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1986, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1986, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1986, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1986, 'GMC', 'S15', 'Extended Cab Pickup 2-Door'],
    [1986, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1986, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1986, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1986, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1986, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1986, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1986, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1986, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1986, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1986, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1986, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1986, 'Honda', 'Prelude', 'Coupe 3-Door'],
    [1986, 'Honda', 'Wagovan', 'Wagon 4-Door'],
    [1986, 'Hyundai', 'Excel', 'Hatchback 2-Door'],
    [1986, 'Hyundai', 'Excel', 'Hatchback 4-Door'],
    [1986, 'Hyundai', 'Excel', 'Sedan 4-Door'],
    [1986, 'Hyundai', 'Pony', 'Hatchback 2-Door'],
    [1986, 'Hyundai', 'Stellar', 'Sedan 4-Door'],
    [1986, 'Isuzu', 'I-Mark', 'Hatchback 2-Door'],
    [1986, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1986, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1986, 'Isuzu', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1986, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1986, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1986, 'Isuzu', 'Trooper', 'SUV 4-Door'],
    [1986, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1986, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1986, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1986, 'Jaguar', 'XJS', 'Convertible 2-Door'],
    [1986, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1986, 'Jaguar', 'XJS', 'Sedan 4-Door'],
    [1986, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1986, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1986, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1986, 'Jeep', 'Comanche', 'Standard Cab Pickup 2-Door'],
    [1986, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1986, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1986, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1986, 'Jeep', 'Scrambler', 'SUV 2-Door'],
    [1986, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1986, 'Lada', 'Niva', 'SUV 2-Door'],
    [1986, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1986, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1986, 'Lamborghini', 'Jalpa', 'Coupe 2-Door'],
    [1986, 'Lamborghini', 'LM002', 'SUV 4-Door'],
    [1986, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1986, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1986, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1986, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1986, 'Maserati', '425', 'Coupe 2-Door'],
    [1986, 'Maserati', '425', 'Sedan 4-Door'],
    [1986, 'Maserati', 'Biturbo', 'Coupe 2-Door'],
    [1986, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [1986, 'Maserati', 'Spyder', 'Convertible 2-Door'],
    [1986, 'Mazda', '323', 'Hatchback 2-Door'],
    [1986, 'Mazda', '323', 'Sedan 4-Door'],
    [1986, 'Mazda', '626', 'Coupe 2-Door'],
    [1986, 'Mazda', '626', 'Hatchback 4-Door'],
    [1986, 'Mazda', '626', 'Sedan 4-Door'],
    [1986, 'Mazda', 'B2000', 'Extended Cab Pickup 2-Door'],
    [1986, 'Mazda', 'B2000', 'Standard Cab Pickup 2-Door'],
    [1986, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1986, 'Mercedes-Benz', '190D', 'Sedan 4-Door'],
    [1986, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1986, 'Mercedes-Benz', '300E', 'Sedan 4-Door'],
    [1986, 'Mercedes-Benz', '300SDL', 'Sedan 4-Door'],
    [1986, 'Mercedes-Benz', '420SEL', 'Sedan 4-Door'],
    [1986, 'Mercedes-Benz', '560SEC', 'Coupe 2-Door'],
    [1986, 'Mercedes-Benz', '560SEL', 'Sedan 4-Door'],
    [1986, 'Mercedes-Benz', '560SL', 'Convertible 2-Door'],
    [1986, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1986, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1986, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1986, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1986, 'Mercury', 'Grand Marquis', 'Wagon 4-Door'],
    [1986, 'Mercury', 'Lynx', 'Hatchback 2-Door'],
    [1986, 'Mercury', 'Lynx', 'Hatchback 4-Door'],
    [1986, 'Mercury', 'Lynx', 'Wagon 4-Door'],
    [1986, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1986, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1986, 'Mercury', 'Sable', 'Sedan 4-Door'],
    [1986, 'Mercury', 'Sable', 'Wagon 4-Door'],
    [1986, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1986, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1986, 'Merkur', 'XR4Ti', 'Sedan 3-Door'],
    [1986, 'Mitsubishi', 'Cordia', 'Hatchback 2-Door'],
    [1986, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1986, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1986, 'Mitsubishi', 'Mirage', 'Hatchback 2-Door'],
    [1986, 'Mitsubishi', 'Montero', 'SUV 2-Door'],
    [1986, 'Mitsubishi', 'Starion', 'Coupe 2-Door'],
    [1986, 'Mitsubishi', 'Tredia', 'Sedan 4-Door'],
    [1986, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1986, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1986, 'Nissan', '720', 'Extended Cab Pickup 2-Door'],
    [1986, 'Nissan', '720', 'Standard Cab Pickup 2-Door'],
    [1986, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1986, 'Nissan', '200SX', 'Hatchback 2-Door'],
    [1986, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1986, 'Nissan', 'D21', 'Extended Cab Pickup 2-Door'],
    [1986, 'Nissan', 'D21', 'Standard Cab Pickup 2-Door'],
    [1986, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1986, 'Nissan', 'Maxima', 'Wagon 4-Door'],
    [1986, 'Nissan', 'Micra', 'Hatchback 2-Door'],
    [1986, 'Nissan', 'Multi', 'Wagon 4-Door'],
    [1986, 'Nissan', 'Pulsar NX', 'Coupe 2-Door'],
    [1986, 'Nissan', 'Sentra', 'Hatchback 2-Door'],
    [1986, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1986, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1986, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1986, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1986, 'Nissan', 'Stanza', 'Wagon 4-Door'],
    [1986, 'Oldsmobile', '98', 'Sedan 2-Door'],
    [1986, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1986, 'Oldsmobile', 'Calais', 'Coupe 2-Door'],
    [1986, 'Oldsmobile', 'Calais', 'Sedan 4-Door'],
    [1986, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1986, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1986, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1986, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1986, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1986, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1986, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1986, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1986, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1986, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1986, 'Oldsmobile', 'Firenza', 'Coupe 2-Door'],
    [1986, 'Oldsmobile', 'Firenza', 'Hatchback 2-Door'],
    [1986, 'Oldsmobile', 'Firenza', 'Sedan 4-Door'],
    [1986, 'Oldsmobile', 'Firenza', 'Wagon 4-Door'],
    [1986, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1986, 'Peugeot', '505', 'Sedan 4-Door'],
    [1986, 'Peugeot', '505', 'Wagon 4-Door'],
    [1986, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1986, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1986, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1986, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1986, 'Plymouth', 'Conquest', 'Hatchback 2-Door'],
    [1986, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1986, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1986, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1986, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1986, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1986, 'Plymouth', 'Turismo', 'Hatchback 2-Door'],
    [1986, 'Plymouth', 'Turismo 2.2', 'Hatchback 2-Door'],
    [1986, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1986, 'Pontiac', '6000', 'Coupe 2-Door'],
    [1986, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1986, 'Pontiac', '6000', 'Wagon 4-Door'],
    [1986, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1986, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1986, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1986, 'Pontiac', 'Fiero', 'Coupe 2-Door'],
    [1986, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1986, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1986, 'Pontiac', 'Firefly', 'Hatchback 4-Door'],
    [1986, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1986, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1986, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1986, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1986, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1986, 'Pontiac', 'Parisienne', 'Wagon 4-Door'],
    [1986, 'Pontiac', 'Sunbird', 'Convertible 2-Door'],
    [1986, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1986, 'Pontiac', 'Sunbird', 'Hatchback 2-Door'],
    [1986, 'Pontiac', 'Sunbird', 'Sedan 4-Door'],
    [1986, 'Pontiac', 'Sunbird', 'Wagon 4-Door'],
    [1986, 'Pontiac', 'Sunburst', 'Sedan 4-Door'],
    [1986, 'Pontiac', 'T1000', 'Hatchback 2-Door'],
    [1986, 'Pontiac', 'T1000', 'Hatchback 4-Door'],
    [1986, 'Porsche', '911', 'Convertible 2-Door'],
    [1986, 'Porsche', '911', 'Coupe 2-Door'],
    [1986, 'Porsche', '911', 'Targa 2-Door'],
    [1986, 'Porsche', '928', 'Coupe 2-Door'],
    [1986, 'Porsche', '944', 'Coupe 2-Door'],
    [1986, 'Renault', 'Alliance', 'Convertible 2-Door'],
    [1986, 'Renault', 'Alliance', 'Sedan 2-Door'],
    [1986, 'Renault', 'Alliance', 'Sedan 4-Door'],
    [1986, 'Renault', 'Encore', 'Hatchback 2-Door'],
    [1986, 'Renault', 'Encore', 'Hatchback 4-Door'],
    [1986, 'Renault', 'R18i', 'Wagon 4-Door'],
    [1986, 'Renault', 'R5', 'Hatchback 2-Door'],
    [1986, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1986, 'Rolls-Royce', 'Corniche II', 'Convertible 2-Door'],
    [1986, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1986, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1986, 'Saab', '900', 'Convertible 2-Door'],
    [1986, 'Saab', '900', 'Hatchback 2-Door'],
    [1986, 'Saab', '900', 'Sedan 2-Door'],
    [1986, 'Saab', '900', 'Sedan 4-Door'],
    [1986, 'Saab', '9000', 'Hatchback 4-Door'],
    [1986, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1986, 'Subaru', 'DL', 'Coupe 3-Door'],
    [1986, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1986, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1986, 'Subaru', 'GL', 'Coupe 3-Door'],
    [1986, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1986, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1986, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1986, 'Subaru', 'GL-10', 'Sedan 4-Door'],
    [1986, 'Subaru', 'GL-10', 'Wagon 4-Door'],
    [1986, 'Subaru', 'RX', 'Sedan 4-Door'],
    [1986, 'Subaru', 'Standard', 'Hatchback 2-Door'],
    [1986, 'Subaru', 'XT', 'Coupe 2-Door'],
    [1986, 'Suzuki', 'Forsa', 'Hatchback 2-Door'],
    [1986, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1986, 'Toyota', '4Runner', 'SUV 2-Door'],
    [1986, 'Toyota', 'Camry', 'Hatchback 4-Door'],
    [1986, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1986, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1986, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1986, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1986, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1986, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [1986, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1986, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1986, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1986, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1986, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1986, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1986, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1986, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1986, 'Toyota', 'Supra', 'Hatchback 2-Door'],
    [1986, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1986, 'Toyota', 'Tercel', 'Hatchback 4-Door'],
    [1986, 'Toyota', 'Tercel', 'Wagon 4-Door'],
    [1986, 'Toyota', 'Van', 'Mini Cargo Van 3-Door'],
    [1986, 'Toyota', 'Van', 'Mini Passenger Van 3-Door'],
    [1986, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1986, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1986, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1986, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1986, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1986, 'Volkswagen', 'Quantum', 'Sedan 4-Door'],
    [1986, 'Volkswagen', 'Quantum', 'Wagon 5-Door'],
    [1986, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1986, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1986, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1986, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1986, 'Volvo', '244', 'Sedan 4-Door'],
    [1986, 'Volvo', '245', 'Wagon 4-Door'],
    [1986, 'Volvo', '740', 'Sedan 4-Door'],
    [1986, 'Volvo', '740', 'Wagon 4-Door'],
    [1986, 'Volvo', '760', 'Sedan 4-Door'],
    [1986, 'Volvo', '760', 'Wagon 4-Door'],
    [1986, 'Yugo', 'GV', 'Hatchback 2-Door'],
    [1985, 'Alfa Romeo', 'GTV-6', 'Coupe 2-Door'],
    [1985, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1985, 'AMC', 'Eagle', 'Sedan 4-Door'],
    [1985, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1985, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1985, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1985, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1985, 'Audi', '4000', 'Sedan 2-Door'],
    [1985, 'Audi', '4000', 'Sedan 4-Door'],
    [1985, 'Audi', '5000', 'Sedan 4-Door'],
    [1985, 'Audi', '5000', 'Wagon 4-Door'],
    [1985, 'Audi', '4000 Quattro', 'Sedan 4-Door'],
    [1985, 'Audi', 'Coupe', 'Coupe 2-Door'],
    [1985, 'Audi', 'Quattro', 'Hatchback 2-Door'],
    [1985, 'Avanti', 'II', 'Coupe 2-Door'],
    [1985, 'Bentley', 'Continental', 'Convertible 2-Door'],
    [1985, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1985, 'Bertone', 'X-1/9', 'Coupe 2-Door'],
    [1985, 'BMW', '318i', 'Coupe 2-Door'],
    [1985, 'BMW', '318i', 'Sedan 4-Door'],
    [1985, 'BMW', '325e', 'Coupe 2-Door'],
    [1985, 'BMW', '325e', 'Sedan 4-Door'],
    [1985, 'BMW', '524td', 'Sedan 4-Door'],
    [1985, 'BMW', '528e', 'Sedan 4-Door'],
    [1985, 'BMW', '535i', 'Sedan 4-Door'],
    [1985, 'BMW', '635CSi', 'Coupe 2-Door'],
    [1985, 'BMW', '735i', 'Sedan 4-Door'],
    [1985, 'Buick', 'Century', 'Coupe 2-Door'],
    [1985, 'Buick', 'Century', 'Sedan 4-Door'],
    [1985, 'Buick', 'Century', 'Wagon 4-Door'],
    [1985, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1985, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1985, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1985, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1985, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1985, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1985, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1985, 'Buick', 'Riviera', 'Convertible 2-Door'],
    [1985, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1985, 'Buick', 'Skyhawk', 'Coupe 2-Door'],
    [1985, 'Buick', 'Skyhawk', 'Sedan 4-Door'],
    [1985, 'Buick', 'Skyhawk', 'Wagon 4-Door'],
    [1985, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1985, 'Buick', 'Somerset Regal', 'Coupe 2-Door'],
    [1985, 'Cadillac', 'Cimarron', 'Sedan 4-Door'],
    [1985, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1985, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1985, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1985, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1985, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1985, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1985, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1985, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1985, 'Chevrolet', 'Astro', 'Standard Cargo Van 3-Door'],
    [1985, 'Chevrolet', 'Astro', 'Standard Passenger Van 3-Door'],
    [1985, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1985, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1985, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1985, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1985, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1985, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1985, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1985, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1985, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1985, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1985, 'Chevrolet', 'Cavalier', 'Hatchback 2-Door'],
    [1985, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1985, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1985, 'Chevrolet', 'Celebrity', 'Coupe 2-Door'],
    [1985, 'Chevrolet', 'Celebrity', 'Sedan 4-Door'],
    [1985, 'Chevrolet', 'Celebrity', 'Wagon 4-Door'],
    [1985, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1985, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1985, 'Chevrolet', 'Citation II', 'Hatchback 2-Door'],
    [1985, 'Chevrolet', 'Citation II', 'Hatchback 4-Door'],
    [1985, 'Chevrolet', 'Citation II', 'Sedan 2-Door'],
    [1985, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1985, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1985, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1985, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1985, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1985, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1985, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1985, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1985, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1985, 'Chevrolet', 'G30', 'Extended Passenger Van 3-Door'],
    [1985, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1985, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1985, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1985, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1985, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1985, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1985, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1985, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1985, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1985, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1985, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1985, 'Chevrolet', 'Spectrum', 'Hatchback 2-Door'],
    [1985, 'Chevrolet', 'Spectrum', 'Sedan 4-Door'],
    [1985, 'Chevrolet', 'Sprint', 'Hatchback 2-Door'],
    [1985, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1985, 'Chrysler', 'Executive Limousine', 'Limousine 4-Door'],
    [1985, 'Chrysler', 'Fifth Avenue', 'Sedan 4-Door'],
    [1985, 'Chrysler', 'Laser', 'Hatchback 2-Door'],
    [1985, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1985, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1985, 'Chrysler', 'LeBaron', 'Hatchback 4-Door'],
    [1985, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1985, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1985, 'Chrysler', 'Town & Country', 'Convertible 2-Door'],
    [1985, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1985, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1985, 'Dodge', '600', 'Convertible 2-Door'],
    [1985, 'Dodge', '600', 'Coupe 2-Door'],
    [1985, 'Dodge', '600', 'Sedan 4-Door'],
    [1985, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1985, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1985, 'Dodge', 'Aries', 'Wagon 4-Door'],
    [1985, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1985, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1985, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1985, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1985, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1985, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1985, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1985, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1985, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1985, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1985, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1985, 'Dodge', 'Charger', 'Hatchback 2-Door'],
    [1985, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1985, 'Dodge', 'Colt', 'Hatchback 4-Door'],
    [1985, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1985, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1985, 'Dodge', 'Conquest', 'Hatchback 2-Door'],
    [1985, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'D350', 'Crew Cab Pickup 4-Door'],
    [1985, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1985, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1985, 'Dodge', 'Lancer', 'Hatchback 4-Door'],
    [1985, 'Dodge', 'Mini Ram', 'Mini Cargo Van 3-Door'],
    [1985, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1985, 'Dodge', 'Power Ram 50', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1985, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1985, 'Dodge', 'W350', 'Crew Cab Pickup 4-Door'],
    [1985, 'Dodge', 'W350', 'Extended Cab Pickup 2-Door'],
    [1985, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1985, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1985, 'Ferrari', '412', 'Coupe 2-Door'],
    [1985, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1985, 'Ferrari', '308 GTS', 'Coupe 2-Door'],
    [1985, 'Ferrari', '328 GTB', 'Coupe 2-Door'],
    [1985, 'Ferrari', '328 GTS', 'Coupe 2-Door'],
    [1985, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1985, 'Ferrari', 'GTO', 'Coupe 2-Door'],
    [1985, 'Ferrari', 'Mondial', 'Convertible 2-Door'],
    [1985, 'Ferrari', 'Mondial', 'Coupe 2-Door'],
    [1985, 'Ferrari', 'Mondial 8', 'Convertible 2-Door'],
    [1985, 'Ferrari', 'Mondial 8', 'Coupe 2-Door'],
    [1985, 'Ferrari', 'Testarossa', 'Coupe 2-Door'],
    [1985, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1985, 'Ford', 'Bronco II', 'SUV 2-Door'],
    [1985, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1985, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1985, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1985, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1985, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1985, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1985, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1985, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1985, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1985, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1985, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1985, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1985, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1985, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1985, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1985, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1985, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1985, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1985, 'Ford', 'EXP', 'Hatchback 2-Door'],
    [1985, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1985, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1985, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1985, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1985, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1985, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1985, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1985, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1985, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1985, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1985, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1985, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1985, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1985, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1985, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1985, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1985, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1985, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1985, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1985, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1985, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1985, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1985, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1985, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1985, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1985, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1985, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1985, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1985, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1985, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1985, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1985, 'GMC', 'G3500', 'Extended Cargo Van 3-Door'],
    [1985, 'GMC', 'G3500', 'Extended Passenger Van 3-Door'],
    [1985, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1985, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1985, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1985, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1985, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1985, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1985, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1985, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1985, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1985, 'GMC', 'S15', 'Extended Cab Pickup 2-Door'],
    [1985, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1985, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1985, 'GMC', 'Safari', 'Standard Cargo Van 3-Door'],
    [1985, 'GMC', 'Safari', 'Standard Passenger Van 3-Door'],
    [1985, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1985, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1985, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1985, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1985, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1985, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1985, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1985, 'Honda', 'Prelude', 'Coupe 3-Door'],
    [1985, 'Hyundai', 'Pony', 'Hatchback 2-Door'],
    [1985, 'Hyundai', 'Stellar', 'Sedan 4-Door'],
    [1985, 'Isuzu', 'I-Mark', 'Coupe 2-Door'],
    [1985, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1985, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1985, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1985, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1985, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1985, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1985, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1985, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1985, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1985, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1985, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1985, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1985, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1985, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1985, 'Jeep', 'Scrambler', 'SUV 2-Door'],
    [1985, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1985, 'Lada', 'Niva', 'SUV 2-Door'],
    [1985, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1985, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1985, 'Lamborghini', 'Jalpa', 'Coupe 2-Door'],
    [1985, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1985, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1985, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1985, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1985, 'Maserati', 'Biturbo', 'Coupe 2-Door'],
    [1985, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [1985, 'Mazda', '626', 'Coupe 2-Door'],
    [1985, 'Mazda', '626', 'Hatchback 4-Door'],
    [1985, 'Mazda', '626', 'Sedan 4-Door'],
    [1985, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1985, 'Mazda', 'GLC', 'Sedan 4-Door'],
    [1985, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1985, 'Mercedes-Benz', '190D', 'Sedan 4-Door'],
    [1985, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1985, 'Mercedes-Benz', '300CD', 'Coupe 2-Door'],
    [1985, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1985, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1985, 'Mercedes-Benz', '300TD', 'Wagon 4-Door'],
    [1985, 'Mercedes-Benz', '380SE', 'Sedan 4-Door'],
    [1985, 'Mercedes-Benz', '380SL', 'Convertible 2-Door'],
    [1985, 'Mercedes-Benz', '500SEC', 'Coupe 2-Door'],
    [1985, 'Mercedes-Benz', '500SEL', 'Sedan 4-Door'],
    [1985, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1985, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1985, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1985, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1985, 'Mercury', 'Grand Marquis', 'Wagon 4-Door'],
    [1985, 'Mercury', 'Lynx', 'Hatchback 2-Door'],
    [1985, 'Mercury', 'Lynx', 'Hatchback 4-Door'],
    [1985, 'Mercury', 'Lynx', 'Wagon 4-Door'],
    [1985, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1985, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1985, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1985, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1985, 'Merkur', 'XR4Ti', 'Sedan 3-Door'],
    [1985, 'Mitsubishi', 'Cordia', 'Hatchback 2-Door'],
    [1985, 'Mitsubishi', 'Galant', 'Sedan 4-Door'],
    [1985, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1985, 'Mitsubishi', 'Mirage', 'Hatchback 2-Door'],
    [1985, 'Mitsubishi', 'Montero', 'SUV 2-Door'],
    [1985, 'Mitsubishi', 'Starion', 'Coupe 2-Door'],
    [1985, 'Mitsubishi', 'Tredia', 'Sedan 4-Door'],
    [1985, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1985, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1985, 'Nissan', '720', 'Extended Cab Pickup 2-Door'],
    [1985, 'Nissan', '720', 'Standard Cab Pickup 2-Door'],
    [1985, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1985, 'Nissan', '200SX', 'Hatchback 2-Door'],
    [1985, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1985, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1985, 'Nissan', 'Maxima', 'Wagon 4-Door'],
    [1985, 'Nissan', 'Micra', 'Hatchback 2-Door'],
    [1985, 'Nissan', 'Pulsar NX', 'Coupe 2-Door'],
    [1985, 'Nissan', 'Sentra', 'Hatchback 2-Door'],
    [1985, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1985, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1985, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1985, 'Nissan', 'Stanza', 'Hatchback 4-Door'],
    [1985, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1985, 'Oldsmobile', '98', 'Sedan 2-Door'],
    [1985, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1985, 'Oldsmobile', 'Calais', 'Convertible 2-Door'],
    [1985, 'Oldsmobile', 'Calais', 'Coupe 2-Door'],
    [1985, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1985, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1985, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1985, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1985, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1985, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1985, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1985, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1985, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1985, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1985, 'Oldsmobile', 'Firenza', 'Hatchback 2-Door'],
    [1985, 'Oldsmobile', 'Firenza', 'Sedan 4-Door'],
    [1985, 'Oldsmobile', 'Firenza', 'Wagon 4-Door'],
    [1985, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1985, 'Peugeot', '505', 'Sedan 4-Door'],
    [1985, 'Peugeot', '505', 'Wagon 4-Door'],
    [1985, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1985, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1985, 'Plymouth', 'Colt', 'Hatchback 4-Door'],
    [1985, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1985, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1985, 'Plymouth', 'Conquest', 'Hatchback 2-Door'],
    [1985, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1985, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1985, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1985, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1985, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1985, 'Plymouth', 'Turismo', 'Hatchback 2-Door'],
    [1985, 'Plymouth', 'Turismo 2.2', 'Hatchback 2-Door'],
    [1985, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1985, 'Pontiac', '6000', 'Coupe 2-Door'],
    [1985, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1985, 'Pontiac', '6000', 'Wagon 4-Door'],
    [1985, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1985, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1985, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1985, 'Pontiac', 'Fiero', 'Coupe 2-Door'],
    [1985, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1985, 'Pontiac', 'Firefly', 'Hatchback 2-Door'],
    [1985, 'Pontiac', 'Firefly', 'Sedan 4-Door'],
    [1985, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1985, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1985, 'Pontiac', 'J2000 Sunbird', 'Convertible 2-Door'],
    [1985, 'Pontiac', 'J2000 Sunbird', 'Coupe 2-Door'],
    [1985, 'Pontiac', 'J2000 Sunbird', 'Hatchback 2-Door'],
    [1985, 'Pontiac', 'J2000 Sunbird', 'Sedan 4-Door'],
    [1985, 'Pontiac', 'J2000 Sunbird', 'Wagon 4-Door'],
    [1985, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1985, 'Pontiac', 'Parisienne', 'Wagon 4-Door'],
    [1985, 'Pontiac', 'Sunburst', 'Sedan 4-Door'],
    [1985, 'Pontiac', 'T1000', 'Hatchback 2-Door'],
    [1985, 'Pontiac', 'T1000', 'Hatchback 4-Door'],
    [1985, 'Porsche', '911', 'Convertible 2-Door'],
    [1985, 'Porsche', '911', 'Coupe 2-Door'],
    [1985, 'Porsche', '911', 'Targa 2-Door'],
    [1985, 'Porsche', '928', 'Coupe 2-Door'],
    [1985, 'Porsche', '944', 'Coupe 2-Door'],
    [1985, 'Renault', 'Alliance', 'Convertible 2-Door'],
    [1985, 'Renault', 'Alliance', 'Sedan 2-Door'],
    [1985, 'Renault', 'Alliance', 'Sedan 4-Door'],
    [1985, 'Renault', 'Encore', 'Hatchback 2-Door'],
    [1985, 'Renault', 'Encore', 'Hatchback 4-Door'],
    [1985, 'Renault', 'Fuego', 'Coupe 2-Door'],
    [1985, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1985, 'Renault', 'R18i', 'Wagon 4-Door'],
    [1985, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1985, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1985, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1985, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1985, 'Saab', '900', 'Hatchback 2-Door'],
    [1985, 'Saab', '900', 'Sedan 4-Door'],
    [1985, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1985, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1985, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1985, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1985, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1985, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1985, 'Subaru', 'GL-10', 'Sedan 4-Door'],
    [1985, 'Subaru', 'GL-10', 'Wagon 4-Door'],
    [1985, 'Subaru', 'RX', 'Sedan 4-Door'],
    [1985, 'Subaru', 'Standard', 'Hatchback 2-Door'],
    [1985, 'Subaru', 'XT', 'Coupe 2-Door'],
    [1985, 'Subaru', 'XT', 'Coupe 3-Door'],
    [1985, 'Suzuki', 'Forsa', 'Hatchback 2-Door'],
    [1985, 'Suzuki', 'SA310', 'Hatchback 2-Door'],
    [1985, 'Suzuki', 'Samurai', 'SUV 2-Door'],
    [1985, 'Suzuki', 'SJ410', 'SUV 2-Door'],
    [1985, 'Suzuki', 'SJ413', 'SUV 2-Door'],
    [1985, 'Toyota', '4Runner', 'SUV 2-Door'],
    [1985, 'Toyota', 'Camry', 'Hatchback 4-Door'],
    [1985, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1985, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1985, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1985, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1985, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1985, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1985, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [1985, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1985, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1985, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1985, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1985, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1985, 'Toyota', 'MR2', 'Coupe 2-Door'],
    [1985, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1985, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1985, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1985, 'Toyota', 'Tercel', 'Hatchback 4-Door'],
    [1985, 'Toyota', 'Tercel', 'Wagon 4-Door'],
    [1985, 'Toyota', 'Van', 'Mini Cargo Van 3-Door'],
    [1985, 'Toyota', 'Van', 'Mini Passenger Van 3-Door'],
    [1985, 'Volkswagen', 'Cabriolet', 'Convertible 2-Door'],
    [1985, 'Volkswagen', 'Golf', 'Hatchback 2-Door'],
    [1985, 'Volkswagen', 'Golf', 'Hatchback 4-Door'],
    [1985, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1985, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1985, 'Volkswagen', 'Quantum', 'Sedan 4-Door'],
    [1985, 'Volkswagen', 'Quantum', 'Wagon 5-Door'],
    [1985, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1985, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1985, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1985, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1985, 'Volvo', '244', 'Sedan 4-Door'],
    [1985, 'Volvo', '245', 'Wagon 4-Door'],
    [1985, 'Volvo', '740', 'Sedan 4-Door'],
    [1985, 'Volvo', '745', 'Wagon 4-Door'],
    [1985, 'Volvo', '760', 'Sedan 4-Door'],
    [1985, 'Volvo', '760', 'Wagon 4-Door'],
    [1984, 'Alfa Romeo', 'GTV-6', 'Coupe 2-Door'],
    [1984, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1984, 'AMC', 'Eagle', 'Sedan 4-Door'],
    [1984, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1984, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1984, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1984, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1984, 'Audi', '4000', 'Sedan 2-Door'],
    [1984, 'Audi', '4000', 'Sedan 4-Door'],
    [1984, 'Audi', '5000', 'Sedan 4-Door'],
    [1984, 'Audi', '5000', 'Wagon 4-Door'],
    [1984, 'Audi', '4000 Quattro', 'Sedan 4-Door'],
    [1984, 'Audi', 'Coupe', 'Coupe 2-Door'],
    [1984, 'Audi', 'Quattro', 'Hatchback 2-Door'],
    [1984, 'Avanti', 'II', 'Coupe 2-Door'],
    [1984, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1984, 'Bentley', 'Eight', 'Sedan 4-Door'],
    [1984, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1984, 'Bertone', 'X-1/9', 'Coupe 2-Door'],
    [1984, 'BMW', '318i', 'Coupe 2-Door'],
    [1984, 'BMW', '325e', 'Coupe 2-Door'],
    [1984, 'BMW', '528e', 'Sedan 4-Door'],
    [1984, 'BMW', '533i', 'Sedan 4-Door'],
    [1984, 'BMW', '633CSi', 'Coupe 2-Door'],
    [1984, 'BMW', '733i', 'Sedan 4-Door'],
    [1984, 'Buick', 'Century', 'Coupe 2-Door'],
    [1984, 'Buick', 'Century', 'Sedan 4-Door'],
    [1984, 'Buick', 'Century', 'Wagon 4-Door'],
    [1984, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1984, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1984, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1984, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1984, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1984, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1984, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1984, 'Buick', 'Riviera', 'Convertible 2-Door'],
    [1984, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1984, 'Buick', 'Skyhawk', 'Coupe 2-Door'],
    [1984, 'Buick', 'Skyhawk', 'Sedan 4-Door'],
    [1984, 'Buick', 'Skyhawk', 'Wagon 4-Door'],
    [1984, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1984, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1984, 'Cadillac', 'Cimarron', 'Sedan 4-Door'],
    [1984, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1984, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1984, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1984, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1984, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1984, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1984, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1984, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1984, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1984, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1984, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1984, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1984, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1984, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1984, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1984, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1984, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1984, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1984, 'Chevrolet', 'Cavalier', 'Hatchback 2-Door'],
    [1984, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1984, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1984, 'Chevrolet', 'Celebrity', 'Coupe 2-Door'],
    [1984, 'Chevrolet', 'Celebrity', 'Sedan 4-Door'],
    [1984, 'Chevrolet', 'Celebrity', 'Wagon 4-Door'],
    [1984, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1984, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1984, 'Chevrolet', 'Citation II', 'Hatchback 2-Door'],
    [1984, 'Chevrolet', 'Citation II', 'Hatchback 4-Door'],
    [1984, 'Chevrolet', 'Citation II', 'Sedan 2-Door'],
    [1984, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1984, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1984, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1984, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1984, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1984, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1984, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1984, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1984, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1984, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1984, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1984, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1984, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1984, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1984, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1984, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1984, 'Chrysler', 'Daytona', 'Hatchback 2-Door'],
    [1984, 'Chrysler', 'E Class', 'Sedan 4-Door'],
    [1984, 'Chrysler', 'Executive Sedan', 'Sedan 4-Door'],
    [1984, 'Chrysler', 'Fifth Avenue', 'Sedan 4-Door'],
    [1984, 'Chrysler', 'Laser', 'Hatchback 2-Door'],
    [1984, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1984, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1984, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1984, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1984, 'Chrysler', 'Town & Country', 'Convertible 2-Door'],
    [1984, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1984, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1984, 'Dodge', '600', 'Convertible 2-Door'],
    [1984, 'Dodge', '600', 'Coupe 2-Door'],
    [1984, 'Dodge', '600', 'Sedan 4-Door'],
    [1984, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1984, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1984, 'Dodge', 'Aries', 'Wagon 4-Door'],
    [1984, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1984, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1984, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1984, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1984, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1984, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1984, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1984, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1984, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1984, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1984, 'Dodge', 'Caravan', 'Mini Passenger Van 3-Door'],
    [1984, 'Dodge', 'Charger', 'Hatchback 2-Door'],
    [1984, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1984, 'Dodge', 'Colt', 'Hatchback 4-Door'],
    [1984, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1984, 'Dodge', 'Conquest', 'Hatchback 2-Door'],
    [1984, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'D350', 'Crew Cab Pickup 4-Door'],
    [1984, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'Daytona', 'Hatchback 2-Door'],
    [1984, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1984, 'Dodge', 'Mini Ram', 'Mini Cargo Van 3-Door'],
    [1984, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1984, 'Dodge', 'Power Ram 50', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1984, 'Dodge', 'Rampage', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1984, 'Dodge', 'W350', 'Crew Cab Pickup 4-Door'],
    [1984, 'Dodge', 'W350', 'Extended Cab Pickup 2-Door'],
    [1984, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1984, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1984, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1984, 'Ferrari', '308 GTS', 'Coupe 2-Door'],
    [1984, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1984, 'Ferrari', 'GTO', 'Coupe 2-Door'],
    [1984, 'Ferrari', 'Mondial', 'Convertible 2-Door'],
    [1984, 'Ferrari', 'Mondial', 'Coupe 2-Door'],
    [1984, 'Ferrari', 'Mondial 8', 'Convertible 2-Door'],
    [1984, 'Ferrari', 'Mondial 8', 'Coupe 2-Door'],
    [1984, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1984, 'Ford', 'Bronco II', 'SUV 2-Door'],
    [1984, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1984, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1984, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1984, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1984, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1984, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1984, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1984, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1984, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1984, 'Ford', 'E-250 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1984, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1984, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1984, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1984, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1984, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1984, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1984, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1984, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1984, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1984, 'Ford', 'EXP', 'Hatchback 2-Door'],
    [1984, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1984, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1984, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1984, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1984, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1984, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1984, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1984, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1984, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1984, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1984, 'Ford', 'Mustang', 'Coupe 2-Door'],
    [1984, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1984, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1984, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1984, 'Ford', 'Tempo', 'Sedan 2-Door'],
    [1984, 'Ford', 'Tempo', 'Sedan 4-Door'],
    [1984, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1984, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1984, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1984, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1984, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1984, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1984, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1984, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1984, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1984, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1984, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1984, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1984, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1984, 'GMC', 'G2500', 'Standard Passenger Van 3-Door'],
    [1984, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1984, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1984, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1984, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1984, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1984, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1984, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1984, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1984, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1984, 'GMC', 'S15', 'Extended Cab Pickup 2-Door'],
    [1984, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1984, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1984, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1984, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1984, 'Honda', 'Civic', 'Coupe 2-Door'],
    [1984, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1984, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1984, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1984, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1984, 'Honda', 'Wagovan', 'Wagon 4-Door'],
    [1984, 'Hyundai', 'Pony', 'Hatchback 2-Door'],
    [1984, 'Isuzu', 'I-Mark', 'Coupe 2-Door'],
    [1984, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1984, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1984, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1984, 'Isuzu', 'Trooper', 'SUV 2-Door'],
    [1984, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1984, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1984, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1984, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1984, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1984, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1984, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1984, 'Jeep', 'Grand Wagoneer', 'SUV 4-Door'],
    [1984, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1984, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1984, 'Jeep', 'Scrambler', 'SUV 2-Door'],
    [1984, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1984, 'Lada', 'Niva', 'SUV 2-Door'],
    [1984, 'Lada', 'Signet', 'Sedan 4-Door'],
    [1984, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1984, 'Lamborghini', 'Jalpa', 'Coupe 2-Door'],
    [1984, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1984, 'Lincoln', 'Mark VII', 'Sedan 2-Door'],
    [1984, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1984, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1984, 'Maserati', 'Biturbo', 'Coupe 2-Door'],
    [1984, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [1984, 'Mazda', '626', 'Coupe 2-Door'],
    [1984, 'Mazda', '626', 'Hatchback 4-Door'],
    [1984, 'Mazda', '626', 'Sedan 4-Door'],
    [1984, 'Mazda', 'B2000', 'Standard Cab Pickup 2-Door'],
    [1984, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1984, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1984, 'Mazda', 'GLC', 'Sedan 4-Door'],
    [1984, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1984, 'Mercedes-Benz', '190D', 'Sedan 4-Door'],
    [1984, 'Mercedes-Benz', '190E', 'Sedan 4-Door'],
    [1984, 'Mercedes-Benz', '300CD', 'Coupe 2-Door'],
    [1984, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1984, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1984, 'Mercedes-Benz', '300TD', 'Wagon 4-Door'],
    [1984, 'Mercedes-Benz', '380SE', 'Sedan 4-Door'],
    [1984, 'Mercedes-Benz', '380SL', 'Convertible 2-Door'],
    [1984, 'Mercedes-Benz', '500SEC', 'Coupe 2-Door'],
    [1984, 'Mercedes-Benz', '500SEL', 'Sedan 4-Door'],
    [1984, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1984, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1984, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1984, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1984, 'Mercury', 'Grand Marquis', 'Wagon 4-Door'],
    [1984, 'Mercury', 'Lynx', 'Hatchback 2-Door'],
    [1984, 'Mercury', 'Lynx', 'Hatchback 4-Door'],
    [1984, 'Mercury', 'Lynx', 'Wagon 4-Door'],
    [1984, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1984, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1984, 'Mercury', 'Topaz', 'Sedan 2-Door'],
    [1984, 'Mercury', 'Topaz', 'Sedan 4-Door'],
    [1984, 'Mitsubishi', 'Cordia', 'Hatchback 2-Door'],
    [1984, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1984, 'Mitsubishi', 'Montero', 'SUV 2-Door'],
    [1984, 'Mitsubishi', 'Starion', 'Coupe 2-Door'],
    [1984, 'Mitsubishi', 'Tredia', 'Sedan 4-Door'],
    [1984, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1984, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1984, 'Nissan', '720', 'Extended Cab Pickup 2-Door'],
    [1984, 'Nissan', '720', 'Standard Cab Pickup 2-Door'],
    [1984, 'Nissan', '200SX', 'Coupe 2-Door'],
    [1984, 'Nissan', '200SX', 'Hatchback 2-Door'],
    [1984, 'Nissan', '300ZX', 'Coupe 2-Door'],
    [1984, 'Nissan', 'Maxima', 'Sedan 4-Door'],
    [1984, 'Nissan', 'Maxima', 'Wagon 4-Door'],
    [1984, 'Nissan', 'Micra', 'Hatchback 2-Door'],
    [1984, 'Nissan', 'Pulsar NX', 'Coupe 2-Door'],
    [1984, 'Nissan', 'Sentra', 'Hatchback 2-Door'],
    [1984, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1984, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1984, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1984, 'Nissan', 'Stanza', 'Hatchback 2-Door'],
    [1984, 'Nissan', 'Stanza', 'Hatchback 4-Door'],
    [1984, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1984, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1984, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1984, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1984, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1984, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1984, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1984, 'Oldsmobile', 'Cutlass Ciera', 'Wagon 4-Door'],
    [1984, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1984, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1984, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1984, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1984, 'Oldsmobile', 'Firenza', 'Hatchback 2-Door'],
    [1984, 'Oldsmobile', 'Firenza', 'Sedan 4-Door'],
    [1984, 'Oldsmobile', 'Firenza', 'Wagon 4-Door'],
    [1984, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1984, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1984, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1984, 'Peugeot', '505', 'Sedan 4-Door'],
    [1984, 'Peugeot', '505', 'Wagon 4-Door'],
    [1984, 'Peugeot', '604', 'Sedan 4-Door'],
    [1984, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1984, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1984, 'Plymouth', 'Colt', 'Hatchback 4-Door'],
    [1984, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1984, 'Plymouth', 'Conquest', 'Hatchback 2-Door'],
    [1984, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1984, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1984, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1984, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1984, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1984, 'Plymouth', 'Turismo', 'Hatchback 2-Door'],
    [1984, 'Plymouth', 'Turismo 2.2', 'Hatchback 2-Door'],
    [1984, 'Plymouth', 'Voyager', 'Mini Passenger Van 3-Door'],
    [1984, 'Pontiac', '6000', 'Coupe 2-Door'],
    [1984, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1984, 'Pontiac', '6000', 'Wagon 4-Door'],
    [1984, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1984, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1984, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1984, 'Pontiac', 'Fiero', 'Coupe 2-Door'],
    [1984, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1984, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1984, 'Pontiac', 'J2000 Sunbird', 'Convertible 2-Door'],
    [1984, 'Pontiac', 'J2000 Sunbird', 'Coupe 2-Door'],
    [1984, 'Pontiac', 'J2000 Sunbird', 'Hatchback 2-Door'],
    [1984, 'Pontiac', 'J2000 Sunbird', 'Sedan 4-Door'],
    [1984, 'Pontiac', 'J2000 Sunbird', 'Wagon 4-Door'],
    [1984, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1984, 'Pontiac', 'Parisienne', 'Wagon 4-Door'],
    [1984, 'Pontiac', 'Phoenix', 'Coupe 2-Door'],
    [1984, 'Pontiac', 'Phoenix', 'Hatchback 4-Door'],
    [1984, 'Pontiac', 'T1000', 'Hatchback 2-Door'],
    [1984, 'Pontiac', 'T1000', 'Hatchback 4-Door'],
    [1984, 'Porsche', '911', 'Convertible 2-Door'],
    [1984, 'Porsche', '911', 'Coupe 2-Door'],
    [1984, 'Porsche', '911', 'Targa 2-Door'],
    [1984, 'Porsche', '928', 'Coupe 2-Door'],
    [1984, 'Porsche', '944', 'Coupe 2-Door'],
    [1984, 'Renault', 'Alliance', 'Sedan 2-Door'],
    [1984, 'Renault', 'Alliance', 'Sedan 4-Door'],
    [1984, 'Renault', 'Encore', 'Hatchback 2-Door'],
    [1984, 'Renault', 'Encore', 'Hatchback 4-Door'],
    [1984, 'Renault', 'Fuego', 'Coupe 2-Door'],
    [1984, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1984, 'Renault', 'R18i', 'Wagon 4-Door'],
    [1984, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1984, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1984, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1984, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1984, 'Saab', '900', 'Hatchback 2-Door'],
    [1984, 'Saab', '900', 'Sedan 4-Door'],
    [1984, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1984, 'Subaru', 'DL', 'Hardtop 2-Door'],
    [1984, 'Subaru', 'DL', 'Hatchback 2-Door'],
    [1984, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1984, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1984, 'Subaru', 'GL', 'Hardtop 2-Door'],
    [1984, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1984, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1984, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1984, 'Subaru', 'Standard', 'Hatchback 2-Door'],
    [1984, 'Suzuki', 'SJ410', 'SUV 2-Door'],
    [1984, 'Toyota', '4Runner', 'SUV 2-Door'],
    [1984, 'Toyota', 'Camry', 'Hatchback 4-Door'],
    [1984, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1984, 'Toyota', 'Celica', 'Convertible 2-Door'],
    [1984, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1984, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1984, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1984, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1984, 'Toyota', 'Corolla', 'Hatchback 4-Door'],
    [1984, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1984, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1984, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1984, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1984, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1984, 'Toyota', 'Pickup', 'Extended Cab Pickup 2-Door'],
    [1984, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1984, 'Toyota', 'Starlet', 'Hatchback 2-Door'],
    [1984, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1984, 'Toyota', 'Tercel', 'Hatchback 4-Door'],
    [1984, 'Toyota', 'Tercel', 'Wagon 4-Door'],
    [1984, 'Toyota', 'Van', 'Mini Cargo Van 3-Door'],
    [1984, 'Toyota', 'Van', 'Mini Passenger Van 3-Door'],
    [1984, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1984, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1984, 'Volkswagen', 'Quantum', 'Sedan 4-Door'],
    [1984, 'Volkswagen', 'Quantum', 'Sedan 5-Door'],
    [1984, 'Volkswagen', 'Quantum', 'Wagon 5-Door'],
    [1984, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1984, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1984, 'Volkswagen', 'Rabbit Convertible', 'Convertible 2-Door'],
    [1984, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1984, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1984, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1984, 'Volvo', '242', 'Sedan 2-Door'],
    [1984, 'Volvo', '244', 'Sedan 4-Door'],
    [1984, 'Volvo', '245', 'Wagon 4-Door'],
    [1984, 'Volvo', '760', 'Sedan 4-Door'],
    [1984, 'Volvo', '760', 'Wagon 4-Door'],
    [1984, 'Volvo', 'DL', 'Sedan 4-Door'],
    [1984, 'Volvo', 'GLE', 'Sedan 4-Door'],
    [1983, 'Alfa Romeo', 'GTV-6', 'Coupe 2-Door'],
    [1983, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1983, 'AMC', 'Concord', 'Sedan 4-Door'],
    [1983, 'AMC', 'Concord', 'Wagon 4-Door'],
    [1983, 'AMC', 'Eagle', 'Hatchback 2-Door'],
    [1983, 'AMC', 'Eagle', 'Sedan 4-Door'],
    [1983, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1983, 'AMC', 'Spirit', 'Hatchback 2-Door'],
    [1983, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1983, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1983, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1983, 'Audi', '4000', 'Sedan 2-Door'],
    [1983, 'Audi', '4000', 'Sedan 4-Door'],
    [1983, 'Audi', '5000', 'Sedan 4-Door'],
    [1983, 'Audi', 'Coupe', 'Coupe 2-Door'],
    [1983, 'Audi', 'Quattro', 'Hatchback 2-Door'],
    [1983, 'Avanti', 'II', 'Coupe 2-Door'],
    [1983, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1983, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1983, 'BMW', '320i', 'Coupe 2-Door'],
    [1983, 'BMW', '528e', 'Sedan 4-Door'],
    [1983, 'BMW', '533i', 'Sedan 4-Door'],
    [1983, 'BMW', '633CSi', 'Coupe 2-Door'],
    [1983, 'BMW', '733i', 'Sedan 4-Door'],
    [1983, 'Buick', 'Century', 'Coupe 2-Door'],
    [1983, 'Buick', 'Century', 'Sedan 4-Door'],
    [1983, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1983, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1983, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1983, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1983, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1983, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1983, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1983, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1983, 'Buick', 'Regal', 'Wagon 4-Door'],
    [1983, 'Buick', 'Riviera', 'Convertible 2-Door'],
    [1983, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1983, 'Buick', 'Skyhawk', 'Coupe 2-Door'],
    [1983, 'Buick', 'Skyhawk', 'Sedan 4-Door'],
    [1983, 'Buick', 'Skyhawk', 'Wagon 4-Door'],
    [1983, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1983, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1983, 'Cadillac', 'Cimarron', 'Sedan 4-Door'],
    [1983, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1983, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1983, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1983, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1983, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1983, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1983, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1983, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1983, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1983, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1983, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1983, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1983, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1983, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1983, 'Chevrolet', 'Cavalier', 'Convertible 2-Door'],
    [1983, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1983, 'Chevrolet', 'Cavalier', 'Hatchback 2-Door'],
    [1983, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1983, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1983, 'Chevrolet', 'Celebrity', 'Coupe 2-Door'],
    [1983, 'Chevrolet', 'Celebrity', 'Sedan 4-Door'],
    [1983, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1983, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1983, 'Chevrolet', 'Citation', 'Coupe 2-Door'],
    [1983, 'Chevrolet', 'Citation', 'Hatchback 2-Door'],
    [1983, 'Chevrolet', 'Citation', 'Hatchback 4-Door'],
    [1983, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1983, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1983, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1983, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1983, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1983, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1983, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1983, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1983, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1983, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1983, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1983, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1983, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1983, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1983, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1983, 'Chevrolet', 'S10', 'Extended Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1983, 'Chevrolet', 'S10 Blazer', 'SUV 2-Door'],
    [1983, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1983, 'Chrysler', 'E Class', 'Sedan 4-Door'],
    [1983, 'Chrysler', 'Executive Sedan', 'Sedan 4-Door'],
    [1983, 'Chrysler', 'Fifth Avenue', 'Sedan 4-Door'],
    [1983, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1983, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1983, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1983, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1983, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1983, 'Chrysler', 'Town & Country', 'Convertible 2-Door'],
    [1983, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1983, 'Datsun', '200SX', 'Coupe 2-Door'],
    [1983, 'Datsun', '200SX', 'Hatchback 2-Door'],
    [1983, 'Datsun', '280ZX', 'Coupe 2-Door'],
    [1983, 'Datsun', 'Maxima', 'Sedan 4-Door'],
    [1983, 'Datsun', 'Maxima', 'Wagon 4-Door'],
    [1983, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1983, 'DeLorean', 'DMC 12', 'Coupe 2-Door'],
    [1983, 'Dodge', '400', 'Convertible 2-Door'],
    [1983, 'Dodge', '400', 'Coupe 2-Door'],
    [1983, 'Dodge', '400', 'Sedan 4-Door'],
    [1983, 'Dodge', '600', 'Sedan 4-Door'],
    [1983, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1983, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1983, 'Dodge', 'Aries', 'Wagon 4-Door'],
    [1983, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1983, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1983, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1983, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1983, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1983, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1983, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1983, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1983, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1983, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1983, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [1983, 'Dodge', 'Charger', 'Hatchback 2-Door'],
    [1983, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1983, 'Dodge', 'Colt', 'Hatchback 4-Door'],
    [1983, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1983, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1983, 'Dodge', 'D350', 'Crew Cab Pickup 4-Door'],
    [1983, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1983, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1983, 'Dodge', 'Mirada', 'Coupe 2-Door'],
    [1983, 'Dodge', 'Mirada', 'Hardtop 2-Door'],
    [1983, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1983, 'Dodge', 'Power Ram 50', 'Standard Cab Pickup 2-Door'],
    [1983, 'Dodge', 'Ram 50', 'Standard Cab Pickup 2-Door'],
    [1983, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1983, 'Dodge', 'Rampage', 'Standard Cab Pickup 2-Door'],
    [1983, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1983, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1983, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1983, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1983, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1983, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1983, 'Ferrari', '308 GTS', 'Coupe 2-Door'],
    [1983, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1983, 'Ferrari', 'Mondial', 'Coupe 2-Door'],
    [1983, 'Ferrari', 'Mondial 8', 'Convertible 2-Door'],
    [1983, 'Ferrari', 'Mondial 8', 'Coupe 2-Door'],
    [1983, 'Fiat', '124', 'Convertible 2-Door'],
    [1983, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1983, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1983, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1983, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1983, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1983, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1983, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1983, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1983, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1983, 'Ford', 'E-150 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1983, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1983, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1983, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1983, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1983, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1983, 'Ford', 'E-250 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1983, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1983, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1983, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1983, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1983, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1983, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1983, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1983, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1983, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1983, 'Ford', 'EXP', 'Hatchback 2-Door'],
    [1983, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1983, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1983, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1983, 'Ford', 'F-250', 'Crew Cab Pickup 4-Door'],
    [1983, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1983, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1983, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1983, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1983, 'Ford', 'Fairmont', 'Coupe 2-Door'],
    [1983, 'Ford', 'Fairmont', 'Sedan 2-Door'],
    [1983, 'Ford', 'Fairmont', 'Sedan 4-Door'],
    [1983, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1983, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1983, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1983, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1983, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1983, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1983, 'Ford', 'Ranger', 'Standard Cab Pickup 2-Door'],
    [1983, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1983, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1983, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1983, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1983, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1983, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1983, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1983, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1983, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1983, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1983, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1983, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1983, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1983, 'GMC', 'G2500', 'Standard Passenger Van 3-Door'],
    [1983, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1983, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1983, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1983, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1983, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1983, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1983, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1983, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1983, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1983, 'GMC', 'S15', 'Extended Cab Pickup 2-Door'],
    [1983, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1983, 'GMC', 'S15 Jimmy', 'SUV 2-Door'],
    [1983, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1983, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1983, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1983, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1983, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1983, 'Honda', 'Civic', 'Wagon 5-Door'],
    [1983, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1983, 'Hyundai', 'Pony', 'Hatchback 2-Door'],
    [1983, 'Isuzu', 'I-Mark', 'Coupe 2-Door'],
    [1983, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1983, 'Isuzu', 'Impulse', 'Hatchback 2-Door'],
    [1983, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1983, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1983, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1983, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1983, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1983, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1983, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1983, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1983, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1983, 'Jeep', 'DJ5', 'SUV 2-Door'],
    [1983, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1983, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1983, 'Jeep', 'Scrambler', 'SUV 2-Door'],
    [1983, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1983, 'Lada', '1300', 'Sedan 4-Door'],
    [1983, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1983, 'Lamborghini', 'Jalpa', 'Coupe 2-Door'],
    [1983, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1983, 'Lincoln', 'Mark VI', 'Sedan 2-Door'],
    [1983, 'Lincoln', 'Mark VI', 'Sedan 4-Door'],
    [1983, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1983, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1983, 'Maserati', 'Biturbo', 'Coupe 2-Door'],
    [1983, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1983, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [1983, 'Mazda', '626', 'Coupe 2-Door'],
    [1983, 'Mazda', '626', 'Hatchback 4-Door'],
    [1983, 'Mazda', '626', 'Sedan 4-Door'],
    [1983, 'Mazda', 'B2000', 'Standard Cab Pickup 2-Door'],
    [1983, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1983, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1983, 'Mazda', 'GLC', 'Sedan 4-Door'],
    [1983, 'Mazda', 'GLC', 'Wagon 4-Door'],
    [1983, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1983, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1983, 'Mercedes-Benz', '300CD', 'Coupe 2-Door'],
    [1983, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1983, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1983, 'Mercedes-Benz', '300TD', 'Wagon 4-Door'],
    [1983, 'Mercedes-Benz', '380SEC', 'Coupe 2-Door'],
    [1983, 'Mercedes-Benz', '380SEL', 'Sedan 4-Door'],
    [1983, 'Mercedes-Benz', '380SL', 'Convertible 2-Door'],
    [1983, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1983, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1983, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1983, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1983, 'Mercury', 'Grand Marquis', 'Wagon 4-Door'],
    [1983, 'Mercury', 'LN7', 'Hatchback 2-Door'],
    [1983, 'Mercury', 'Lynx', 'Hatchback 2-Door'],
    [1983, 'Mercury', 'Lynx', 'Hatchback 4-Door'],
    [1983, 'Mercury', 'Lynx', 'Wagon 4-Door'],
    [1983, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1983, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1983, 'Mercury', 'Zephyr', 'Coupe 2-Door'],
    [1983, 'Mercury', 'Zephyr', 'Sedan 2-Door'],
    [1983, 'Mercury', 'Zephyr', 'Sedan 4-Door'],
    [1983, 'Mitsubishi', 'Cordia', 'Hatchback 2-Door'],
    [1983, 'Mitsubishi', 'Mighty Max', 'Standard Cab Pickup 2-Door'],
    [1983, 'Mitsubishi', 'Montero', 'SUV 2-Door'],
    [1983, 'Mitsubishi', 'Starion', 'Coupe 2-Door'],
    [1983, 'Mitsubishi', 'Tredia', 'Sedan 4-Door'],
    [1983, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1983, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1983, 'Nissan', '720', 'Extended Cab Pickup 2-Door'],
    [1983, 'Nissan', '720', 'Standard Cab Pickup 2-Door'],
    [1983, 'Nissan', 'Pulsar', 'Hatchback 2-Door'],
    [1983, 'Nissan', 'Pulsar', 'Hatchback 4-Door'],
    [1983, 'Nissan', 'Pulsar NX', 'Coupe 2-Door'],
    [1983, 'Nissan', 'Sentra', 'Hatchback 2-Door'],
    [1983, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1983, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1983, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1983, 'Nissan', 'Stanza', 'Hatchback 2-Door'],
    [1983, 'Nissan', 'Stanza', 'Hatchback 4-Door'],
    [1983, 'Nissan', 'Stanza', 'Sedan 4-Door'],
    [1983, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1983, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1983, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1983, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1983, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1983, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1983, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1983, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1983, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1983, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1983, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1983, 'Oldsmobile', 'Firenza', 'Hatchback 2-Door'],
    [1983, 'Oldsmobile', 'Firenza', 'Sedan 4-Door'],
    [1983, 'Oldsmobile', 'Firenza', 'Wagon 4-Door'],
    [1983, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1983, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1983, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1983, 'Peugeot', '504', 'Wagon 4-Door'],
    [1983, 'Peugeot', '505', 'Sedan 4-Door'],
    [1983, 'Peugeot', '604', 'Sedan 4-Door'],
    [1983, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1983, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1983, 'Plymouth', 'Colt', 'Hatchback 4-Door'],
    [1983, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1983, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1983, 'Plymouth', 'PB150', 'Standard Passenger Van 3-Door'],
    [1983, 'Plymouth', 'PB250', 'Extended Passenger Van 3-Door'],
    [1983, 'Plymouth', 'PB250', 'Standard Passenger Van 3-Door'],
    [1983, 'Plymouth', 'PB350', 'Extended Passenger Van 3-Door'],
    [1983, 'Plymouth', 'PB350', 'Standard Passenger Van 3-Door'],
    [1983, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1983, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1983, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1983, 'Plymouth', 'Sapporo', 'Coupe 2-Door'],
    [1983, 'Plymouth', 'Scamp', 'Standard Cab Pickup 2-Door'],
    [1983, 'Plymouth', 'Turismo', 'Hatchback 2-Door'],
    [1983, 'Plymouth', 'Turismo 2.2', 'Hatchback 2-Door'],
    [1983, 'Pontiac', '6000', 'Coupe 2-Door'],
    [1983, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1983, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1983, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1983, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1983, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1983, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1983, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1983, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1983, 'Pontiac', 'J2000', 'Convertible 2-Door'],
    [1983, 'Pontiac', 'J2000', 'Coupe 2-Door'],
    [1983, 'Pontiac', 'J2000', 'Hatchback 2-Door'],
    [1983, 'Pontiac', 'J2000', 'Sedan 4-Door'],
    [1983, 'Pontiac', 'J2000', 'Wagon 4-Door'],
    [1983, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1983, 'Pontiac', 'Parisienne', 'Wagon 4-Door'],
    [1983, 'Pontiac', 'Phoenix', 'Coupe 2-Door'],
    [1983, 'Pontiac', 'Phoenix', 'Hatchback 4-Door'],
    [1983, 'Pontiac', 'T1000', 'Hatchback 2-Door'],
    [1983, 'Pontiac', 'T1000', 'Hatchback 4-Door'],
    [1983, 'Porsche', '911', 'Convertible 2-Door'],
    [1983, 'Porsche', '911', 'Coupe 2-Door'],
    [1983, 'Porsche', '911', 'Targa 2-Door'],
    [1983, 'Porsche', '928', 'Coupe 2-Door'],
    [1983, 'Porsche', '944', 'Coupe 2-Door'],
    [1983, 'Renault', 'Alliance', 'Sedan 2-Door'],
    [1983, 'Renault', 'Alliance', 'Sedan 4-Door'],
    [1983, 'Renault', 'Fuego', 'Coupe 2-Door'],
    [1983, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1983, 'Renault', 'LeCar', 'Hatchback 4-Door'],
    [1983, 'Renault', 'R18i', 'Sedan 4-Door'],
    [1983, 'Renault', 'R18i', 'Wagon 4-Door'],
    [1983, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1983, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1983, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1983, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1983, 'Saab', '900', 'Hatchback 2-Door'],
    [1983, 'Saab', '900', 'Sedan 4-Door'],
    [1983, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1983, 'Subaru', 'DL', 'Hardtop 2-Door'],
    [1983, 'Subaru', 'DL', 'Hatchback 2-Door'],
    [1983, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1983, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1983, 'Subaru', 'GL', 'Hardtop 2-Door'],
    [1983, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1983, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1983, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1983, 'Subaru', 'Standard', 'Hatchback 2-Door'],
    [1983, 'Suzuki', 'SJ410', 'SUV 2-Door'],
    [1983, 'Toyota', 'Camry', 'Hatchback 4-Door'],
    [1983, 'Toyota', 'Camry', 'Sedan 4-Door'],
    [1983, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1983, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1983, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1983, 'Toyota', 'Corolla', 'Hardtop 2-Door'],
    [1983, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1983, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1983, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1983, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1983, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1983, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1983, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1983, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1983, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1983, 'Toyota', 'Starlet', 'Hatchback 2-Door'],
    [1983, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1983, 'Toyota', 'Tercel', 'Hatchback 4-Door'],
    [1983, 'Toyota', 'Tercel', 'Wagon 4-Door'],
    [1983, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1983, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1983, 'Volkswagen', 'Quantum', 'Coupe 2-Door'],
    [1983, 'Volkswagen', 'Quantum', 'Sedan 4-Door'],
    [1983, 'Volkswagen', 'Quantum', 'Wagon 5-Door'],
    [1983, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1983, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1983, 'Volkswagen', 'Rabbit Convertible', 'Convertible 2-Door'],
    [1983, 'Volkswagen', 'Rabbit Pickup', 'Standard Cab Pickup 2-Door'],
    [1983, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1983, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1983, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1983, 'Volvo', '242', 'Sedan 2-Door'],
    [1983, 'Volvo', '244', 'Sedan 4-Door'],
    [1983, 'Volvo', '245', 'Wagon 4-Door'],
    [1983, 'Volvo', '760', 'Sedan 4-Door'],
    [1983, 'Volvo', '760', 'Wagon 4-Door'],
    [1982, 'Alfa Romeo', 'GTV-6', 'Coupe 2-Door'],
    [1982, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1982, 'AMC', 'Concord', 'Sedan 2-Door'],
    [1982, 'AMC', 'Concord', 'Sedan 4-Door'],
    [1982, 'AMC', 'Concord', 'Wagon 4-Door'],
    [1982, 'AMC', 'Eagle', 'Hatchback 2-Door'],
    [1982, 'AMC', 'Eagle', 'Sedan 2-Door'],
    [1982, 'AMC', 'Eagle', 'Sedan 4-Door'],
    [1982, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1982, 'AMC', 'Spirit', 'Coupe 2-Door'],
    [1982, 'AMC', 'Spirit', 'Hatchback 2-Door'],
    [1982, 'AMC', 'Spirit', 'Sedan 2-Door'],
    [1982, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1982, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1982, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1982, 'Audi', '4000', 'Sedan 2-Door'],
    [1982, 'Audi', '4000', 'Sedan 4-Door'],
    [1982, 'Audi', '5000', 'Sedan 4-Door'],
    [1982, 'Audi', 'Coupe', 'Coupe 2-Door'],
    [1982, 'Avanti', 'II', 'Coupe 2-Door'],
    [1982, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1982, 'Bentley', 'Corniche', 'Coupe 2-Door'],
    [1982, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1982, 'BMW', '320i', 'Coupe 2-Door'],
    [1982, 'BMW', '528e', 'Sedan 4-Door'],
    [1982, 'BMW', '633CSi', 'Coupe 2-Door'],
    [1982, 'BMW', '733i', 'Sedan 4-Door'],
    [1982, 'Buick', 'Century', 'Coupe 2-Door'],
    [1982, 'Buick', 'Century', 'Sedan 4-Door'],
    [1982, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1982, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1982, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1982, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1982, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1982, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1982, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1982, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1982, 'Buick', 'Regal', 'Wagon 4-Door'],
    [1982, 'Buick', 'Riviera', 'Convertible 2-Door'],
    [1982, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1982, 'Buick', 'Skyhawk', 'Coupe 2-Door'],
    [1982, 'Buick', 'Skyhawk', 'Sedan 4-Door'],
    [1982, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1982, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1982, 'Cadillac', 'Cimarron', 'Sedan 4-Door'],
    [1982, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1982, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1982, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1982, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1982, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1982, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1982, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1982, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1982, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1982, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1982, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1982, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1982, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1982, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1982, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1982, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1982, 'Chevrolet', 'Cavalier', 'Coupe 2-Door'],
    [1982, 'Chevrolet', 'Cavalier', 'Hatchback 2-Door'],
    [1982, 'Chevrolet', 'Cavalier', 'Sedan 4-Door'],
    [1982, 'Chevrolet', 'Cavalier', 'Wagon 4-Door'],
    [1982, 'Chevrolet', 'Celebrity', 'Coupe 2-Door'],
    [1982, 'Chevrolet', 'Celebrity', 'Sedan 4-Door'],
    [1982, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1982, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1982, 'Chevrolet', 'Citation', 'Coupe 2-Door'],
    [1982, 'Chevrolet', 'Citation', 'Hatchback 2-Door'],
    [1982, 'Chevrolet', 'Citation', 'Hatchback 4-Door'],
    [1982, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1982, 'Chevrolet', 'Corvette', 'Hatchback 2-Door'],
    [1982, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1982, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1982, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1982, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1982, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1982, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1982, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1982, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1982, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1982, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1982, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1982, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1982, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1982, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1982, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1982, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1982, 'Chevrolet', 'LUV', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1982, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1982, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1982, 'Chevrolet', 'S10', 'Standard Cab Pickup 2-Door'],
    [1982, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1982, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1982, 'Chrysler', 'LeBaron', 'Convertible 2-Door'],
    [1982, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1982, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1982, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1982, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1982, 'Datsun', '210', 'Hatchback 2-Door'],
    [1982, 'Datsun', '210', 'Sedan 2-Door'],
    [1982, 'Datsun', '210', 'Sedan 4-Door'],
    [1982, 'Datsun', '210', 'Wagon 4-Door'],
    [1982, 'Datsun', '310', 'Coupe 2-Door'],
    [1982, 'Datsun', '310', 'Hatchback 2-Door'],
    [1982, 'Datsun', '310', 'Hatchback 4-Door'],
    [1982, 'Datsun', '720', 'Extended Cab Pickup 2-Door'],
    [1982, 'Datsun', '720', 'Standard Cab Pickup 2-Door'],
    [1982, 'Datsun', '200SX', 'Coupe 2-Door'],
    [1982, 'Datsun', '200SX', 'Hatchback 2-Door'],
    [1982, 'Datsun', '280ZX', 'Coupe 2-Door'],
    [1982, 'Datsun', 'Maxima', 'Sedan 4-Door'],
    [1982, 'Datsun', 'Maxima', 'Wagon 4-Door'],
    [1982, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1982, 'DeLorean', 'DMC 12', 'Coupe 2-Door'],
    [1982, 'Dodge', '400', 'Convertible 2-Door'],
    [1982, 'Dodge', '400', 'Coupe 2-Door'],
    [1982, 'Dodge', '400', 'Sedan 4-Door'],
    [1982, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1982, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1982, 'Dodge', 'Aries', 'Wagon 4-Door'],
    [1982, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1982, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1982, 'Dodge', 'B250', 'Extended Cargo Van 3-Door'],
    [1982, 'Dodge', 'B250', 'Extended Passenger Van 3-Door'],
    [1982, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1982, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1982, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1982, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1982, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1982, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1982, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [1982, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1982, 'Dodge', 'Colt', 'Hatchback 4-Door'],
    [1982, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1982, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1982, 'Dodge', 'D250', 'Extended Cab Pickup 2-Door'],
    [1982, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1982, 'Dodge', 'D350', 'Crew Cab Pickup 4-Door'],
    [1982, 'Dodge', 'D350', 'Extended Cab Pickup 2-Door'],
    [1982, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1982, 'Dodge', 'D50', 'Standard Cab Pickup 2-Door'],
    [1982, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1982, 'Dodge', 'Mirada', 'Hardtop 2-Door'],
    [1982, 'Dodge', 'Omni', 'Hatchback 2-Door'],
    [1982, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1982, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1982, 'Dodge', 'Rampage', 'Standard Cab Pickup 2-Door'],
    [1982, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1982, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1982, 'Dodge', 'W250', 'Extended Cab Pickup 2-Door'],
    [1982, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1982, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1982, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1982, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1982, 'Ferrari', '308 GTBi', 'Coupe 2-Door'],
    [1982, 'Ferrari', '308 GTS', 'Coupe 2-Door'],
    [1982, 'Ferrari', '308 GTSi', 'Coupe 2-Door'],
    [1982, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1982, 'Ferrari', 'Mondial 8', 'Coupe 2-Door'],
    [1982, 'Fiat', '124', 'Convertible 2-Door'],
    [1982, 'Fiat', 'Strada', 'Hatchback 2-Door'],
    [1982, 'Fiat', 'Strada', 'Hatchback 4-Door'],
    [1982, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1982, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1982, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1982, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1982, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1982, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1982, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1982, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1982, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1982, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1982, 'Ford', 'E-150 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1982, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1982, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1982, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1982, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1982, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1982, 'Ford', 'E-250 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1982, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1982, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1982, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1982, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1982, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1982, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1982, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1982, 'Ford', 'Escort', 'Hatchback 4-Door'],
    [1982, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1982, 'Ford', 'EXP', 'Hatchback 2-Door'],
    [1982, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1982, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1982, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1982, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1982, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1982, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1982, 'Ford', 'Fairmont', 'Coupe 2-Door'],
    [1982, 'Ford', 'Fairmont', 'Sedan 2-Door'],
    [1982, 'Ford', 'Fairmont', 'Sedan 4-Door'],
    [1982, 'Ford', 'Granada', 'Sedan 2-Door'],
    [1982, 'Ford', 'Granada', 'Sedan 4-Door'],
    [1982, 'Ford', 'Granada', 'Wagon 4-Door'],
    [1982, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1982, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1982, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1982, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1982, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1982, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1982, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1982, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1982, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1982, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1982, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1982, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1982, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1982, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1982, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1982, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1982, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1982, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1982, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1982, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1982, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1982, 'GMC', 'G2500', 'Standard Passenger Van 3-Door'],
    [1982, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1982, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1982, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1982, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1982, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1982, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1982, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1982, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1982, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1982, 'GMC', 'S15', 'Standard Cab Pickup 2-Door'],
    [1982, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1982, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1982, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1982, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1982, 'Honda', 'Civic', 'Wagon 5-Door'],
    [1982, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1982, 'Isuzu', 'I-Mark', 'Coupe 2-Door'],
    [1982, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1982, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1982, 'Jaguar', 'Vanden Plas', 'Sedan 4-Door'],
    [1982, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1982, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1982, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1982, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1982, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1982, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1982, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1982, 'Jeep', 'DJ5', 'SUV 2-Door'],
    [1982, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1982, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1982, 'Jeep', 'Scrambler', 'SUV 2-Door'],
    [1982, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1982, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1982, 'Lamborghini', 'Jalpa', 'Coupe 2-Door'],
    [1982, 'Lancia', 'Zagato', 'Convertible 2-Door'],
    [1982, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1982, 'Lincoln', 'Mark VI', 'Sedan 2-Door'],
    [1982, 'Lincoln', 'Mark VI', 'Sedan 4-Door'],
    [1982, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1982, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1982, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1982, 'Maserati', 'Merak', 'Coupe 2-Door'],
    [1982, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [1982, 'Mazda', '626', 'Coupe 2-Door'],
    [1982, 'Mazda', '626', 'Sedan 4-Door'],
    [1982, 'Mazda', 'B2000', 'Standard Cab Pickup 2-Door'],
    [1982, 'Mazda', 'B2200', 'Standard Cab Pickup 2-Door'],
    [1982, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1982, 'Mazda', 'GLC', 'Sedan 4-Door'],
    [1982, 'Mazda', 'GLC', 'Wagon 4-Door'],
    [1982, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1982, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1982, 'Mercedes-Benz', '300CD', 'Coupe 2-Door'],
    [1982, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1982, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1982, 'Mercedes-Benz', '300TD', 'Wagon 4-Door'],
    [1982, 'Mercedes-Benz', '380SEC', 'Coupe 2-Door'],
    [1982, 'Mercedes-Benz', '380SEL', 'Sedan 4-Door'],
    [1982, 'Mercedes-Benz', '380SL', 'Convertible 2-Door'],
    [1982, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1982, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1982, 'Mercury', 'Cougar', 'Sedan 4-Door'],
    [1982, 'Mercury', 'Cougar', 'Wagon 4-Door'],
    [1982, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1982, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1982, 'Mercury', 'Grand Marquis', 'Wagon 4-Door'],
    [1982, 'Mercury', 'LN7', 'Hatchback 2-Door'],
    [1982, 'Mercury', 'Lynx', 'Hatchback 2-Door'],
    [1982, 'Mercury', 'Lynx', 'Hatchback 4-Door'],
    [1982, 'Mercury', 'Lynx', 'Wagon 4-Door'],
    [1982, 'Mercury', 'Marquis', 'Sedan 2-Door'],
    [1982, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1982, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1982, 'Mercury', 'Zephyr', 'Coupe 2-Door'],
    [1982, 'Mercury', 'Zephyr', 'Sedan 2-Door'],
    [1982, 'Mercury', 'Zephyr', 'Sedan 4-Door'],
    [1982, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1982, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1982, 'Nissan', 'Sentra', 'Hatchback 2-Door'],
    [1982, 'Nissan', 'Sentra', 'Sedan 2-Door'],
    [1982, 'Nissan', 'Sentra', 'Sedan 4-Door'],
    [1982, 'Nissan', 'Sentra', 'Wagon 4-Door'],
    [1982, 'Nissan', 'Stanza', 'Hatchback 2-Door'],
    [1982, 'Nissan', 'Stanza', 'Hatchback 4-Door'],
    [1982, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1982, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1982, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1982, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1982, 'Oldsmobile', 'Cutlass Ciera', 'Coupe 2-Door'],
    [1982, 'Oldsmobile', 'Cutlass Ciera', 'Sedan 4-Door'],
    [1982, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1982, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1982, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1982, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1982, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1982, 'Oldsmobile', 'Firenza', 'Hatchback 2-Door'],
    [1982, 'Oldsmobile', 'Firenza', 'Sedan 4-Door'],
    [1982, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1982, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1982, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1982, 'Peugeot', '504', 'Wagon 4-Door'],
    [1982, 'Peugeot', '505', 'Sedan 4-Door'],
    [1982, 'Peugeot', '604', 'Sedan 4-Door'],
    [1982, 'Plymouth', 'Arrow Pickup', 'Standard Cab Pickup 2-Door'],
    [1982, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1982, 'Plymouth', 'Champ', 'Hatchback 2-Door'],
    [1982, 'Plymouth', 'Champ', 'Hatchback 4-Door'],
    [1982, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1982, 'Plymouth', 'Gran Fury', 'Hardtop 4-Door'],
    [1982, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1982, 'Plymouth', 'PB150', 'Standard Passenger Van 3-Door'],
    [1982, 'Plymouth', 'PB250', 'Extended Passenger Van 3-Door'],
    [1982, 'Plymouth', 'PB250', 'Standard Passenger Van 3-Door'],
    [1982, 'Plymouth', 'PB350', 'Extended Passenger Van 3-Door'],
    [1982, 'Plymouth', 'PB350', 'Standard Passenger Van 3-Door'],
    [1982, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1982, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1982, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1982, 'Plymouth', 'Reliant', 'Wagon 5-Door'],
    [1982, 'Plymouth', 'Sapporo', 'Coupe 2-Door'],
    [1982, 'Plymouth', 'TC3', 'Hatchback 2-Door'],
    [1982, 'Pontiac', '6000', 'Coupe 2-Door'],
    [1982, 'Pontiac', '6000', 'Sedan 4-Door'],
    [1982, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1982, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1982, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1982, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1982, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1982, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1982, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1982, 'Pontiac', 'J2000', 'Coupe 2-Door'],
    [1982, 'Pontiac', 'J2000', 'Hatchback 2-Door'],
    [1982, 'Pontiac', 'J2000', 'Sedan 4-Door'],
    [1982, 'Pontiac', 'J2000', 'Wagon 4-Door'],
    [1982, 'Pontiac', 'Parisienne', 'Coupe 2-Door'],
    [1982, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1982, 'Pontiac', 'Parisienne', 'Wagon 4-Door'],
    [1982, 'Pontiac', 'Phoenix', 'Coupe 2-Door'],
    [1982, 'Pontiac', 'Phoenix', 'Hatchback 4-Door'],
    [1982, 'Pontiac', 'T1000', 'Hatchback 2-Door'],
    [1982, 'Pontiac', 'T1000', 'Hatchback 4-Door'],
    [1982, 'Porsche', '911', 'Coupe 2-Door'],
    [1982, 'Porsche', '911', 'Targa 2-Door'],
    [1982, 'Porsche', '924', 'Coupe 2-Door'],
    [1982, 'Porsche', '928', 'Coupe 2-Door'],
    [1982, 'Renault', 'Fuego', 'Coupe 2-Door'],
    [1982, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1982, 'Renault', 'LeCar', 'Hatchback 4-Door'],
    [1982, 'Renault', 'R18i', 'Sedan 4-Door'],
    [1982, 'Renault', 'R18i', 'Wagon 4-Door'],
    [1982, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1982, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1982, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1982, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1982, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1982, 'Saab', '900', 'Hatchback 2-Door'],
    [1982, 'Saab', '900', 'Sedan 4-Door'],
    [1982, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1982, 'Subaru', 'DL', 'Hardtop 2-Door'],
    [1982, 'Subaru', 'DL', 'Hatchback 2-Door'],
    [1982, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1982, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1982, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1982, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1982, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1982, 'Subaru', 'GLF', 'Hardtop 2-Door'],
    [1982, 'Subaru', 'Standard', 'Hatchback 2-Door'],
    [1982, 'Suzuki', 'SJ410', 'SUV 2-Door'],
    [1982, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1982, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1982, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1982, 'Toyota', 'Corolla', 'Hardtop 2-Door'],
    [1982, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1982, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1982, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1982, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1982, 'Toyota', 'Corona', 'Hatchback 4-Door'],
    [1982, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1982, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1982, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1982, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1982, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1982, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1982, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1982, 'Toyota', 'Starlet', 'Hatchback 2-Door'],
    [1982, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1982, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1982, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1982, 'Triumph', 'TR7', 'Convertible 2-Door'],
    [1982, 'Triumph', 'TR8', 'Convertible 2-Door'],
    [1982, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1982, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1982, 'Volkswagen', 'Quantum', 'Coupe 2-Door'],
    [1982, 'Volkswagen', 'Quantum', 'Sedan 4-Door'],
    [1982, 'Volkswagen', 'Quantum', 'Wagon 5-Door'],
    [1982, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1982, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1982, 'Volkswagen', 'Rabbit Convertible', 'Convertible 2-Door'],
    [1982, 'Volkswagen', 'Rabbit Pickup', 'Standard Cab Pickup 2-Door'],
    [1982, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1982, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1982, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1982, 'Volvo', '242', 'Sedan 2-Door'],
    [1982, 'Volvo', '244', 'Sedan 4-Door'],
    [1982, 'Volvo', '245', 'Wagon 4-Door'],
    [1982, 'Volvo', '264', 'Sedan 4-Door'],
    [1981, 'Alfa Romeo', 'GTV-6', 'Coupe 2-Door'],
    [1981, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1981, 'AMC', 'Concord', 'Sedan 2-Door'],
    [1981, 'AMC', 'Concord', 'Sedan 4-Door'],
    [1981, 'AMC', 'Concord', 'Wagon 4-Door'],
    [1981, 'AMC', 'Eagle', 'Hatchback 2-Door'],
    [1981, 'AMC', 'Eagle', 'Sedan 2-Door'],
    [1981, 'AMC', 'Eagle', 'Sedan 4-Door'],
    [1981, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1981, 'AMC', 'Spirit', 'Hatchback 2-Door'],
    [1981, 'AMC', 'Spirit', 'Sedan 2-Door'],
    [1981, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1981, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1981, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1981, 'Audi', '4000', 'Sedan 2-Door'],
    [1981, 'Audi', '4000', 'Sedan 4-Door'],
    [1981, 'Audi', '5000', 'Sedan 4-Door'],
    [1981, 'Audi', 'Coupe', 'Coupe 2-Door'],
    [1981, 'Avanti', 'II', 'Coupe 2-Door'],
    [1981, 'Bentley', 'Mulsanne', 'Sedan 4-Door'],
    [1981, 'BMW', '320i', 'Coupe 2-Door'],
    [1981, 'BMW', '528i', 'Sedan 4-Door'],
    [1981, 'BMW', '633CSi', 'Coupe 2-Door'],
    [1981, 'BMW', '733i', 'Sedan 4-Door'],
    [1981, 'Buick', 'Century', 'Coupe 2-Door'],
    [1981, 'Buick', 'Century', 'Sedan 4-Door'],
    [1981, 'Buick', 'Century', 'Wagon 4-Door'],
    [1981, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1981, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1981, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1981, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1981, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1981, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1981, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1981, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1981, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1981, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1981, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1981, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1981, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1981, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1981, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1981, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1981, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1981, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1981, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1981, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1981, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1981, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1981, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1981, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1981, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1981, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1981, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1981, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1981, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1981, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1981, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1981, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1981, 'Chevrolet', 'Citation', 'Hatchback 2-Door'],
    [1981, 'Chevrolet', 'Citation', 'Hatchback 4-Door'],
    [1981, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1981, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1981, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1981, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1981, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1981, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1981, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1981, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1981, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1981, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1981, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1981, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1981, 'Chevrolet', 'Impala', 'Coupe 2-Door'],
    [1981, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1981, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1981, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1981, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1981, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1981, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1981, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1981, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1981, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1981, 'Chevrolet', 'LUV', 'Standard Cab Pickup 2-Door'],
    [1981, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1981, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1981, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1981, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1981, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1981, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1981, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1981, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1981, 'Chrysler', 'LeBaron', 'Wagon 4-Door'],
    [1981, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1981, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1981, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1981, 'Datsun', '210', 'Hatchback 2-Door'],
    [1981, 'Datsun', '210', 'Sedan 2-Door'],
    [1981, 'Datsun', '210', 'Sedan 4-Door'],
    [1981, 'Datsun', '210', 'Wagon 4-Door'],
    [1981, 'Datsun', '310', 'Coupe 2-Door'],
    [1981, 'Datsun', '310', 'Hatchback 2-Door'],
    [1981, 'Datsun', '310', 'Hatchback 4-Door'],
    [1981, 'Datsun', '510', 'Hatchback 2-Door'],
    [1981, 'Datsun', '510', 'Hatchback 4-Door'],
    [1981, 'Datsun', '510', 'Sedan 2-Door'],
    [1981, 'Datsun', '510', 'Wagon 4-Door'],
    [1981, 'Datsun', '720', 'Extended Cab Pickup 2-Door'],
    [1981, 'Datsun', '720', 'Standard Cab Pickup 2-Door'],
    [1981, 'Datsun', '810', 'Sedan 4-Door'],
    [1981, 'Datsun', '810', 'Wagon 4-Door'],
    [1981, 'Datsun', '200SX', 'Coupe 2-Door'],
    [1981, 'Datsun', '200SX', 'Hatchback 2-Door'],
    [1981, 'Datsun', '280ZX', 'Coupe 2-Door'],
    [1981, 'Datsun', 'Maxima', 'Sedan 4-Door'],
    [1981, 'Datsun', 'Maxima', 'Wagon 4-Door'],
    [1981, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1981, 'DeLorean', 'DMC 12', 'Coupe 2-Door'],
    [1981, 'Dodge', 'Aries', 'Coupe 2-Door'],
    [1981, 'Dodge', 'Aries', 'Sedan 4-Door'],
    [1981, 'Dodge', 'Aries', 'Wagon 4-Door'],
    [1981, 'Dodge', 'B150', 'Standard Cargo Van 3-Door'],
    [1981, 'Dodge', 'B150', 'Standard Passenger Van 3-Door'],
    [1981, 'Dodge', 'B250', 'Standard Cargo Van 3-Door'],
    [1981, 'Dodge', 'B250', 'Standard Passenger Van 3-Door'],
    [1981, 'Dodge', 'B350', 'Extended Cargo Van 3-Door'],
    [1981, 'Dodge', 'B350', 'Extended Passenger Van 3-Door'],
    [1981, 'Dodge', 'B350', 'Standard Cargo Van 3-Door'],
    [1981, 'Dodge', 'B350', 'Standard Passenger Van 3-Door'],
    [1981, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [1981, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1981, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1981, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1981, 'Dodge', 'D250', 'Crew Cab Pickup 4-Door'],
    [1981, 'Dodge', 'D250', 'Extended Cab Pickup 2-Door'],
    [1981, 'Dodge', 'D250', 'Standard Cab Pickup 2-Door'],
    [1981, 'Dodge', 'D350', 'Crew Cab Pickup 4-Door'],
    [1981, 'Dodge', 'D350', 'Extended Cab Pickup 2-Door'],
    [1981, 'Dodge', 'D350', 'Standard Cab Pickup 2-Door'],
    [1981, 'Dodge', 'D50', 'Standard Cab Pickup 2-Door'],
    [1981, 'Dodge', 'Diplomat', 'Coupe 2-Door'],
    [1981, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1981, 'Dodge', 'Diplomat', 'Wagon 4-Door'],
    [1981, 'Dodge', 'Mirada', 'Coupe 2-Door'],
    [1981, 'Dodge', 'Mirada', 'Hardtop 2-Door'],
    [1981, 'Dodge', 'Omni', 'Hatchback 2-Door'],
    [1981, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1981, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1981, 'Dodge', 'St. Regis', 'Hardtop 4-Door'],
    [1981, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1981, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1981, 'Dodge', 'W250', 'Crew Cab Pickup 4-Door'],
    [1981, 'Dodge', 'W250', 'Extended Cab Pickup 2-Door'],
    [1981, 'Dodge', 'W250', 'Standard Cab Pickup 2-Door'],
    [1981, 'Dodge', 'W350', 'Standard Cab Pickup 2-Door'],
    [1981, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1981, 'Ferrari', '308 GTBi', 'Coupe 2-Door'],
    [1981, 'Ferrari', '308 GTSi', 'Coupe 2-Door'],
    [1981, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1981, 'Ferrari', 'Mondial 8', 'Coupe 2-Door'],
    [1981, 'Fiat', '124', 'Convertible 2-Door'],
    [1981, 'Fiat', 'Brava', 'Sedan 2-Door'],
    [1981, 'Fiat', 'Brava', 'Sedan 4-Door'],
    [1981, 'Fiat', 'Strada', 'Hatchback 2-Door'],
    [1981, 'Fiat', 'Strada', 'Hatchback 4-Door'],
    [1981, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1981, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1981, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1981, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1981, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1981, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1981, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1981, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1981, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1981, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1981, 'Ford', 'E-150 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1981, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1981, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1981, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1981, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1981, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1981, 'Ford', 'E-250 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1981, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1981, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1981, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1981, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1981, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1981, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1981, 'Ford', 'Escort', 'Hatchback 2-Door'],
    [1981, 'Ford', 'Escort', 'Wagon 4-Door'],
    [1981, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1981, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1981, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1981, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1981, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1981, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1981, 'Ford', 'Fairmont', 'Coupe 2-Door'],
    [1981, 'Ford', 'Fairmont', 'Sedan 2-Door'],
    [1981, 'Ford', 'Fairmont', 'Sedan 4-Door'],
    [1981, 'Ford', 'Fairmont', 'Wagon 4-Door'],
    [1981, 'Ford', 'Granada', 'Sedan 2-Door'],
    [1981, 'Ford', 'Granada', 'Sedan 4-Door'],
    [1981, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1981, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1981, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1981, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1981, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1981, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1981, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1981, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1981, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1981, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1981, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1981, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1981, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1981, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1981, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1981, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1981, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1981, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1981, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1981, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1981, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1981, 'GMC', 'G2500', 'Standard Passenger Van 3-Door'],
    [1981, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1981, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1981, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1981, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1981, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1981, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1981, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1981, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1981, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1981, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1981, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1981, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1981, 'Honda', 'Civic', 'Sedan 4-Door'],
    [1981, 'Honda', 'Civic', 'Wagon 5-Door'],
    [1981, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1981, 'Isuzu', 'I-Mark', 'Coupe 2-Door'],
    [1981, 'Isuzu', 'I-Mark', 'Sedan 4-Door'],
    [1981, 'Isuzu', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1981, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1981, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1981, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1981, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1981, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1981, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1981, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1981, 'Jeep', 'DJ5', 'SUV 2-Door'],
    [1981, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1981, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1981, 'Jeep', 'Scrambler', 'SUV 2-Door'],
    [1981, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1981, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1981, 'Lancia', 'Beta', 'Coupe 2-Door'],
    [1981, 'Lancia', 'Zagato', 'Convertible 2-Door'],
    [1981, 'Lincoln', 'Mark VI', 'Sedan 2-Door'],
    [1981, 'Lincoln', 'Mark VI', 'Sedan 4-Door'],
    [1981, 'Lincoln', 'Town Car', 'Sedan 2-Door'],
    [1981, 'Lincoln', 'Town Car', 'Sedan 4-Door'],
    [1981, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1981, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1981, 'Maserati', 'Merak', 'Coupe 2-Door'],
    [1981, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [1981, 'Mazda', '626', 'Coupe 2-Door'],
    [1981, 'Mazda', '626', 'Sedan 4-Door'],
    [1981, 'Mazda', 'B2000', 'Standard Cab Pickup 2-Door'],
    [1981, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1981, 'Mazda', 'GLC', 'Hatchback 4-Door'],
    [1981, 'Mazda', 'GLC', 'Sedan 4-Door'],
    [1981, 'Mazda', 'GLC', 'Wagon 4-Door'],
    [1981, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1981, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1981, 'Mercedes-Benz', '280CE', 'Coupe 2-Door'],
    [1981, 'Mercedes-Benz', '280E', 'Sedan 4-Door'],
    [1981, 'Mercedes-Benz', '300CD', 'Coupe 2-Door'],
    [1981, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1981, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1981, 'Mercedes-Benz', '300TD', 'Wagon 4-Door'],
    [1981, 'Mercedes-Benz', '380SEL', 'Sedan 4-Door'],
    [1981, 'Mercedes-Benz', '380SL', 'Convertible 2-Door'],
    [1981, 'Mercedes-Benz', '380SLC', 'Coupe 2-Door'],
    [1981, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1981, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1981, 'Mercury', 'Cougar', 'Sedan 4-Door'],
    [1981, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1981, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1981, 'Mercury', 'Grand Marquis', 'Wagon 4-Door'],
    [1981, 'Mercury', 'Lynx', 'Hatchback 2-Door'],
    [1981, 'Mercury', 'Lynx', 'Wagon 4-Door'],
    [1981, 'Mercury', 'Marquis', 'Sedan 2-Door'],
    [1981, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1981, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1981, 'Mercury', 'Zephyr', 'Coupe 2-Door'],
    [1981, 'Mercury', 'Zephyr', 'Sedan 2-Door'],
    [1981, 'Mercury', 'Zephyr', 'Sedan 4-Door'],
    [1981, 'Mercury', 'Zephyr', 'Wagon 4-Door'],
    [1981, 'MG', 'MGB', 'Convertible 2-Door'],
    [1981, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1981, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1981, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1981, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1981, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1981, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1981, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1981, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1981, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1981, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1981, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1981, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1981, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1981, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1981, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1981, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1981, 'Peugeot', '504', 'Wagon 4-Door'],
    [1981, 'Peugeot', '505', 'Sedan 4-Door'],
    [1981, 'Peugeot', '604', 'Sedan 4-Door'],
    [1981, 'Plymouth', 'Arrow Pickup', 'Standard Cab Pickup 2-Door'],
    [1981, 'Plymouth', 'Caravelle', 'Coupe 2-Door'],
    [1981, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1981, 'Plymouth', 'Champ', 'Hatchback 2-Door'],
    [1981, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1981, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1981, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1981, 'Plymouth', 'PB150', 'Standard Passenger Van 3-Door'],
    [1981, 'Plymouth', 'PB250', 'Extended Passenger Van 3-Door'],
    [1981, 'Plymouth', 'PB250', 'Standard Passenger Van 3-Door'],
    [1981, 'Plymouth', 'PB350', 'Extended Passenger Van 3-Door'],
    [1981, 'Plymouth', 'PB350', 'Standard Passenger Van 3-Door'],
    [1981, 'Plymouth', 'Reliant', 'Sedan 2-Door'],
    [1981, 'Plymouth', 'Reliant', 'Sedan 4-Door'],
    [1981, 'Plymouth', 'Reliant', 'Wagon 4-Door'],
    [1981, 'Plymouth', 'Reliant', 'Wagon 5-Door'],
    [1981, 'Plymouth', 'Sapporo', 'Coupe 2-Door'],
    [1981, 'Plymouth', 'TC3', 'Hatchback 2-Door'],
    [1981, 'Plymouth', 'Trailduster', 'SUV 2-Door'],
    [1981, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1981, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1981, 'Pontiac', 'Bonneville', 'Coupe 2-Door'],
    [1981, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1981, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1981, 'Pontiac', 'Catalina', 'Coupe 2-Door'],
    [1981, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1981, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1981, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1981, 'Pontiac', 'Grand LeMans', 'Coupe 2-Door'],
    [1981, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1981, 'Pontiac', 'Grand LeMans', 'Wagon 4-Door'],
    [1981, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1981, 'Pontiac', 'Laurentian', 'Sedan 4-Door'],
    [1981, 'Pontiac', 'Laurentian', 'Wagon 4-Door'],
    [1981, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1981, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1981, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1981, 'Pontiac', 'Parisienne', 'Coupe 2-Door'],
    [1981, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1981, 'Pontiac', 'Parisienne', 'Wagon 4-Door'],
    [1981, 'Pontiac', 'Phoenix', 'Coupe 2-Door'],
    [1981, 'Pontiac', 'Phoenix', 'Hatchback 4-Door'],
    [1981, 'Pontiac', 'T1000', 'Hatchback 2-Door'],
    [1981, 'Pontiac', 'T1000', 'Hatchback 4-Door'],
    [1981, 'Porsche', '911', 'Coupe 2-Door'],
    [1981, 'Porsche', '911', 'Targa 2-Door'],
    [1981, 'Porsche', '924', 'Coupe 2-Door'],
    [1981, 'Porsche', '928', 'Coupe 2-Door'],
    [1981, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1981, 'Renault', 'LeCar', 'Hatchback 4-Door'],
    [1981, 'Renault', 'R18', 'Sedan 4-Door'],
    [1981, 'Renault', 'R18i', 'Sedan 4-Door'],
    [1981, 'Renault', 'R18i', 'Wagon 4-Door'],
    [1981, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1981, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1981, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1981, 'Rolls-Royce', 'Silver Spirit', 'Sedan 4-Door'],
    [1981, 'Rolls-Royce', 'Silver Spur', 'Sedan 4-Door'],
    [1981, 'Saab', '900', 'Hatchback 2-Door'],
    [1981, 'Saab', '900', 'Sedan 4-Door'],
    [1981, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1981, 'Subaru', 'DL', 'Hardtop 2-Door'],
    [1981, 'Subaru', 'DL', 'Hatchback 2-Door'],
    [1981, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1981, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1981, 'Subaru', 'GL', 'Hatchback 2-Door'],
    [1981, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1981, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1981, 'Subaru', 'GLF', 'Hardtop 2-Door'],
    [1981, 'Subaru', 'Standard', 'Hatchback 2-Door'],
    [1981, 'Suzuki', 'LJ81', 'SUV 2-Door'],
    [1981, 'Suzuki', 'SJ410', 'SUV 2-Door'],
    [1981, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1981, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1981, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1981, 'Toyota', 'Corolla', 'Hardtop 2-Door'],
    [1981, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1981, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1981, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1981, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1981, 'Toyota', 'Corona', 'Hatchback 4-Door'],
    [1981, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1981, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1981, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1981, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1981, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1981, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1981, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1981, 'Toyota', 'Starlet', 'Hatchback 2-Door'],
    [1981, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1981, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1981, 'Toyota', 'Tercel', 'Sedan 4-Door'],
    [1981, 'Triumph', 'TR7', 'Convertible 2-Door'],
    [1981, 'Triumph', 'TR7', 'Coupe 2-Door'],
    [1981, 'Triumph', 'TR8', 'Convertible 2-Door'],
    [1981, 'Triumph', 'TR8', 'Coupe 2-Door'],
    [1981, 'Volkswagen', 'Dasher', 'Hatchback 4-Door'],
    [1981, 'Volkswagen', 'Dasher', 'Wagon 4-Door'],
    [1981, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1981, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1981, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1981, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1981, 'Volkswagen', 'Rabbit Convertible', 'Convertible 2-Door'],
    [1981, 'Volkswagen', 'Rabbit Pickup', 'Standard Cab Pickup 2-Door'],
    [1981, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1981, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1981, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1981, 'Volvo', '242', 'Sedan 2-Door'],
    [1981, 'Volvo', '244', 'Sedan 4-Door'],
    [1981, 'Volvo', '245', 'Wagon 4-Door'],
    [1981, 'Volvo', '262', 'Coupe 2-Door'],
    [1981, 'Volvo', '264', 'Sedan 4-Door'],
    [1981, 'Volvo', '265', 'Wagon 4-Door'],
    [1980, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1980, 'AMC', 'AMX', 'Hatchback 2-Door'],
    [1980, 'AMC', 'Concord', 'Sedan 2-Door'],
    [1980, 'AMC', 'Concord', 'Sedan 4-Door'],
    [1980, 'AMC', 'Concord', 'Wagon 4-Door'],
    [1980, 'AMC', 'Eagle', 'Sedan 2-Door'],
    [1980, 'AMC', 'Eagle', 'Sedan 4-Door'],
    [1980, 'AMC', 'Eagle', 'Wagon 4-Door'],
    [1980, 'AMC', 'Pacer', 'Hatchback 2-Door'],
    [1980, 'AMC', 'Pacer', 'Wagon 2-Door'],
    [1980, 'AMC', 'Spirit', 'Hatchback 2-Door'],
    [1980, 'AMC', 'Spirit', 'Sedan 2-Door'],
    [1980, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1980, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1980, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1980, 'Audi', '4000', 'Sedan 2-Door'],
    [1980, 'Audi', '4000', 'Sedan 4-Door'],
    [1980, 'Audi', '5000', 'Sedan 4-Door'],
    [1980, 'Avanti', 'II', 'Coupe 2-Door'],
    [1980, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1980, 'Bentley', 'Corniche', 'Coupe 2-Door'],
    [1980, 'Bentley', 'T2 Series', 'Sedan 4-Door'],
    [1980, 'BMW', '320i', 'Coupe 2-Door'],
    [1980, 'BMW', '528i', 'Sedan 4-Door'],
    [1980, 'BMW', '633CSi', 'Coupe 2-Door'],
    [1980, 'BMW', '733i', 'Sedan 4-Door'],
    [1980, 'Buick', 'Century', 'Coupe 2-Door'],
    [1980, 'Buick', 'Century', 'Sedan 4-Door'],
    [1980, 'Buick', 'Century', 'Wagon 4-Door'],
    [1980, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1980, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1980, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1980, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1980, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1980, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1980, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1980, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1980, 'Buick', 'Skyhawk', 'Hatchback 2-Door'],
    [1980, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1980, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1980, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1980, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1980, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1980, 'Cadillac', 'Fleetwood', 'Coupe 2-Door'],
    [1980, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1980, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1980, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1980, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1980, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1980, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1980, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1980, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1980, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1980, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1980, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1980, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1980, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1980, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1980, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1980, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1980, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1980, 'Chevrolet', 'Citation', 'Coupe 2-Door'],
    [1980, 'Chevrolet', 'Citation', 'Hatchback 2-Door'],
    [1980, 'Chevrolet', 'Citation', 'Hatchback 4-Door'],
    [1980, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1980, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1980, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1980, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1980, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1980, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1980, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1980, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1980, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1980, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1980, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1980, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1980, 'Chevrolet', 'Impala', 'Coupe 2-Door'],
    [1980, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1980, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1980, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1980, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1980, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1980, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1980, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1980, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1980, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1980, 'Chevrolet', 'LUV', 'Standard Cab Pickup 2-Door'],
    [1980, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1980, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1980, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1980, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1980, 'Chevrolet', 'Monza', 'Coupe 2-Door'],
    [1980, 'Chevrolet', 'Monza', 'Hatchback 2-Door'],
    [1980, 'Chevrolet', 'P10', 'Standard Cargo Van 2-Door'],
    [1980, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1980, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1980, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1980, 'Chrysler', 'LeBaron', 'Wagon 4-Door'],
    [1980, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1980, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1980, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1980, 'Datsun', '210', 'Hatchback 2-Door'],
    [1980, 'Datsun', '210', 'Sedan 2-Door'],
    [1980, 'Datsun', '210', 'Sedan 4-Door'],
    [1980, 'Datsun', '210', 'Wagon 4-Door'],
    [1980, 'Datsun', '310', 'Coupe 2-Door'],
    [1980, 'Datsun', '310', 'Hatchback 2-Door'],
    [1980, 'Datsun', '310', 'Hatchback 4-Door'],
    [1980, 'Datsun', '510', 'Hatchback 2-Door'],
    [1980, 'Datsun', '510', 'Hatchback 4-Door'],
    [1980, 'Datsun', '510', 'Sedan 2-Door'],
    [1980, 'Datsun', '510', 'Wagon 4-Door'],
    [1980, 'Datsun', '720', 'Extended Cab Pickup 2-Door'],
    [1980, 'Datsun', '720', 'Standard Cab Pickup 2-Door'],
    [1980, 'Datsun', '810', 'Hardtop 2-Door'],
    [1980, 'Datsun', '810', 'Sedan 4-Door'],
    [1980, 'Datsun', '810', 'Wagon 4-Door'],
    [1980, 'Datsun', '200SX', 'Coupe 2-Door'],
    [1980, 'Datsun', '200SX', 'Hatchback 2-Door'],
    [1980, 'Datsun', '280ZX', 'Coupe 2-Door'],
    [1980, 'Dodge', 'Aspen', 'Coupe 2-Door'],
    [1980, 'Dodge', 'Aspen', 'Sedan 4-Door'],
    [1980, 'Dodge', 'Aspen', 'Wagon 4-Door'],
    [1980, 'Dodge', 'B100', 'Standard Cargo Van 3-Door'],
    [1980, 'Dodge', 'B100', 'Standard Passenger Van 3-Door'],
    [1980, 'Dodge', 'B200', 'Extended Cargo Van 3-Door'],
    [1980, 'Dodge', 'B200', 'Extended Passenger Van 3-Door'],
    [1980, 'Dodge', 'B200', 'Standard Cargo Van 3-Door'],
    [1980, 'Dodge', 'B200', 'Standard Passenger Van 3-Door'],
    [1980, 'Dodge', 'B300', 'Extended Cargo Van 3-Door'],
    [1980, 'Dodge', 'B300', 'Extended Passenger Van 3-Door'],
    [1980, 'Dodge', 'B300', 'Standard Cargo Van 3-Door'],
    [1980, 'Dodge', 'B300', 'Standard Passenger Van 3-Door'],
    [1980, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [1980, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1980, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1980, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1980, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1980, 'Dodge', 'D200', 'Crew Cab Pickup 4-Door'],
    [1980, 'Dodge', 'D200', 'Extended Cab Pickup 2-Door'],
    [1980, 'Dodge', 'D200', 'Standard Cab Pickup 2-Door'],
    [1980, 'Dodge', 'D300', 'Crew Cab Pickup 4-Door'],
    [1980, 'Dodge', 'D300', 'Extended Cab Pickup 2-Door'],
    [1980, 'Dodge', 'D300', 'Standard Cab Pickup 2-Door'],
    [1980, 'Dodge', 'D50', 'Standard Cab Pickup 2-Door'],
    [1980, 'Dodge', 'Diplomat', 'Coupe 2-Door'],
    [1980, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1980, 'Dodge', 'Diplomat', 'Wagon 4-Door'],
    [1980, 'Dodge', 'Mirada', 'Hardtop 2-Door'],
    [1980, 'Dodge', 'Omni', 'Hatchback 2-Door'],
    [1980, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1980, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1980, 'Dodge', 'RD200', 'Crew Cab Pickup 4-Door'],
    [1980, 'Dodge', 'RD200', 'Extended Cab Pickup 2-Door'],
    [1980, 'Dodge', 'RD200', 'Standard Cab Pickup 2-Door'],
    [1980, 'Dodge', 'St. Regis', 'Hardtop 4-Door'],
    [1980, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1980, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1980, 'Dodge', 'W200', 'Crew Cab Pickup 4-Door'],
    [1980, 'Dodge', 'W200', 'Extended Cab Pickup 2-Door'],
    [1980, 'Dodge', 'W200', 'Standard Cab Pickup 2-Door'],
    [1980, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1980, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1980, 'Ferrari', '308 GTS', 'Coupe 2-Door'],
    [1980, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1980, 'Ferrari', 'Mondial 8', 'Coupe 2-Door'],
    [1980, 'Fiat', '124', 'Convertible 2-Door'],
    [1980, 'Fiat', 'Brava', 'Sedan 2-Door'],
    [1980, 'Fiat', 'Brava', 'Sedan 4-Door'],
    [1980, 'Fiat', 'Strada', 'Hatchback 2-Door'],
    [1980, 'Fiat', 'Strada', 'Hatchback 4-Door'],
    [1980, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1980, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1980, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1980, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1980, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1980, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1980, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1980, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1980, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1980, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1980, 'Ford', 'E-150 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1980, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1980, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1980, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1980, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1980, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1980, 'Ford', 'E-250 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1980, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1980, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1980, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1980, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1980, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1980, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1980, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1980, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1980, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1980, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1980, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1980, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1980, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1980, 'Ford', 'Fairmont', 'Coupe 2-Door'],
    [1980, 'Ford', 'Fairmont', 'Sedan 2-Door'],
    [1980, 'Ford', 'Fairmont', 'Sedan 4-Door'],
    [1980, 'Ford', 'Fairmont', 'Wagon 4-Door'],
    [1980, 'Ford', 'Fiesta', 'Hatchback 2-Door'],
    [1980, 'Ford', 'Granada', 'Sedan 2-Door'],
    [1980, 'Ford', 'Granada', 'Sedan 4-Door'],
    [1980, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1980, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1980, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1980, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1980, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1980, 'Ford', 'Pinto', 'Sedan 2-Door'],
    [1980, 'Ford', 'Pinto', 'Sedan 3-Door'],
    [1980, 'Ford', 'Pinto', 'Wagon 2-Door'],
    [1980, 'Ford', 'Thunderbird', 'Sedan 2-Door'],
    [1980, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1980, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1980, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1980, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1980, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1980, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1980, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1980, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1980, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1980, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1980, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1980, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1980, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1980, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1980, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1980, 'GMC', 'G2500', 'Standard Passenger Van 3-Door'],
    [1980, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1980, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1980, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1980, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1980, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1980, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1980, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1980, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1980, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1980, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1980, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1980, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1980, 'Honda', 'Civic', 'Wagon 5-Door'],
    [1980, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1980, 'International Harvester', 'Scout II', 'Standard Cab Pickup 2-Door'],
    [1980, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1980, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1980, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1980, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1980, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1980, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1980, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1980, 'Jeep', 'DJ5', 'SUV 2-Door'],
    [1980, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1980, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1980, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1980, 'Lincoln', 'Continental', 'Hardtop 2-Door'],
    [1980, 'Lincoln', 'Continental', 'Hardtop 4-Door'],
    [1980, 'Lincoln', 'Mark VI', 'Hardtop 2-Door'],
    [1980, 'Lincoln', 'Mark VI', 'Sedan 2-Door'],
    [1980, 'Lincoln', 'Mark VI', 'Sedan 4-Door'],
    [1980, 'Lincoln', 'Versailles', 'Sedan 4-Door'],
    [1980, 'Lotus', 'Elite', 'Hatchback 2-Door'],
    [1980, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1980, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1980, 'Maserati', 'Merak', 'Coupe 2-Door'],
    [1980, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [1980, 'Mazda', '626', 'Coupe 2-Door'],
    [1980, 'Mazda', '626', 'Sedan 4-Door'],
    [1980, 'Mazda', 'B2000', 'Standard Cab Pickup 2-Door'],
    [1980, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1980, 'Mazda', 'GLC', 'Hatchback 4-Door'],
    [1980, 'Mazda', 'GLC', 'Wagon 4-Door'],
    [1980, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1980, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1980, 'Mercedes-Benz', '280CE', 'Coupe 2-Door'],
    [1980, 'Mercedes-Benz', '280E', 'Sedan 4-Door'],
    [1980, 'Mercedes-Benz', '280SE', 'Sedan 4-Door'],
    [1980, 'Mercedes-Benz', '300CD', 'Coupe 2-Door'],
    [1980, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1980, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1980, 'Mercedes-Benz', '300TD', 'Wagon 4-Door'],
    [1980, 'Mercedes-Benz', '450SEL', 'Sedan 4-Door'],
    [1980, 'Mercedes-Benz', '450SL', 'Convertible 2-Door'],
    [1980, 'Mercedes-Benz', '450SLC', 'Coupe 2-Door'],
    [1980, 'Mercury', 'Bobcat', 'Sedan 3-Door'],
    [1980, 'Mercury', 'Bobcat', 'Wagon 2-Door'],
    [1980, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1980, 'Mercury', 'Cougar', 'Sedan 2-Door'],
    [1980, 'Mercury', 'Grand Marquis', 'Sedan 2-Door'],
    [1980, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1980, 'Mercury', 'Grand Marquis', 'Wagon 4-Door'],
    [1980, 'Mercury', 'Marquis', 'Sedan 2-Door'],
    [1980, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1980, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1980, 'Mercury', 'Monarch', 'Sedan 2-Door'],
    [1980, 'Mercury', 'Monarch', 'Sedan 4-Door'],
    [1980, 'Mercury', 'Zephyr', 'Coupe 2-Door'],
    [1980, 'Mercury', 'Zephyr', 'Sedan 2-Door'],
    [1980, 'Mercury', 'Zephyr', 'Sedan 4-Door'],
    [1980, 'Mercury', 'Zephyr', 'Wagon 4-Door'],
    [1980, 'MG', 'MGB', 'Convertible 2-Door'],
    [1980, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1980, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1980, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1980, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1980, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1980, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1980, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1980, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1980, 'Oldsmobile', 'Cutlass Cruiser', 'Wagon 4-Door'],
    [1980, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1980, 'Oldsmobile', 'Cutlass Salon', 'Sedan 4-Door'],
    [1980, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1980, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1980, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1980, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1980, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1980, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1980, 'Oldsmobile', 'Starfire', 'Hatchback 2-Door'],
    [1980, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1980, 'Peugeot', '504', 'Wagon 4-Door'],
    [1980, 'Peugeot', '505', 'Sedan 4-Door'],
    [1980, 'Peugeot', '604', 'Sedan 4-Door'],
    [1980, 'Plymouth', 'Arrow', 'Hatchback 2-Door'],
    [1980, 'Plymouth', 'Arrow Pickup', 'Standard Cab Pickup 2-Door'],
    [1980, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1980, 'Plymouth', 'Champ', 'Hatchback 2-Door'],
    [1980, 'Plymouth', 'Colt', 'Hatchback 2-Door'],
    [1980, 'Plymouth', 'Gran Fury', 'Hardtop 4-Door'],
    [1980, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1980, 'Plymouth', 'PB100', 'Standard Passenger Van 3-Door'],
    [1980, 'Plymouth', 'PB200', 'Extended Passenger Van 3-Door'],
    [1980, 'Plymouth', 'PB200', 'Standard Passenger Van 3-Door'],
    [1980, 'Plymouth', 'PB300', 'Extended Passenger Van 3-Door'],
    [1980, 'Plymouth', 'PB300', 'Standard Passenger Van 3-Door'],
    [1980, 'Plymouth', 'Sapporo', 'Coupe 2-Door'],
    [1980, 'Plymouth', 'TC3', 'Hatchback 2-Door'],
    [1980, 'Plymouth', 'Trailduster', 'SUV 2-Door'],
    [1980, 'Plymouth', 'Volare', 'Coupe 2-Door'],
    [1980, 'Plymouth', 'Volare', 'Sedan 4-Door'],
    [1980, 'Plymouth', 'Volare', 'Wagon 4-Door'],
    [1980, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1980, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1980, 'Pontiac', 'Bonneville', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1980, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1980, 'Pontiac', 'Catalina', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1980, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1980, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Grand LeMans', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1980, 'Pontiac', 'Grand LeMans', 'Wagon 4-Door'],
    [1980, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Laurentian', 'Sedan 4-Door'],
    [1980, 'Pontiac', 'Laurentian', 'Wagon 4-Door'],
    [1980, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1980, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1980, 'Pontiac', 'Parisienne', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1980, 'Pontiac', 'Parisienne', 'Wagon 4-Door'],
    [1980, 'Pontiac', 'Phoenix', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Phoenix', 'Hatchback 4-Door'],
    [1980, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1980, 'Pontiac', 'Sunbird', 'Hatchback 2-Door'],
    [1980, 'Porsche', '911', 'Coupe 2-Door'],
    [1980, 'Porsche', '911', 'Targa 2-Door'],
    [1980, 'Porsche', '924', 'Coupe 2-Door'],
    [1980, 'Porsche', '928', 'Coupe 2-Door'],
    [1980, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1980, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1980, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1980, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1980, 'Rolls-Royce', 'Silver Shadow II', 'Sedan 4-Door'],
    [1980, 'Rolls-Royce', 'Silver Wraith II', 'Sedan 4-Door'],
    [1980, 'Rover', '3500', 'Hatchback 4-Door'],
    [1980, 'Saab', '99', 'Sedan 2-Door'],
    [1980, 'Saab', '99', 'Sedan 4-Door'],
    [1980, 'Saab', '900', 'Hatchback 2-Door'],
    [1980, 'Saab', '900', 'Hatchback 4-Door'],
    [1980, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1980, 'Subaru', 'DL', 'Hardtop 2-Door'],
    [1980, 'Subaru', 'DL', 'Hatchback 2-Door'],
    [1980, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1980, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1980, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1980, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1980, 'Subaru', 'GLF', 'Hardtop 2-Door'],
    [1980, 'Subaru', 'Standard', 'Hatchback 2-Door'],
    [1980, 'Subaru', 'Standard', 'Sedan 4-Door'],
    [1980, 'Suzuki', 'SJ410', 'SUV 2-Door'],
    [1980, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1980, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1980, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1980, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1980, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1980, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1980, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1980, 'Toyota', 'Corona', 'Hatchback 4-Door'],
    [1980, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1980, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1980, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1980, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1980, 'Toyota', 'Land Cruiser', 'Standard Cab Pickup 2-Door'],
    [1980, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1980, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1980, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1980, 'Toyota', 'Tercel', 'Hatchback 2-Door'],
    [1980, 'Toyota', 'Tercel', 'Sedan 2-Door'],
    [1980, 'Triumph', 'Spitfire', 'Convertible 2-Door'],
    [1980, 'Triumph', 'TR7', 'Convertible 2-Door'],
    [1980, 'Triumph', 'TR7', 'Coupe 2-Door'],
    [1980, 'Triumph', 'TR8', 'Convertible 2-Door'],
    [1980, 'Triumph', 'TR8', 'Coupe 2-Door'],
    [1980, 'Volkswagen', 'Dasher', 'Hatchback 2-Door'],
    [1980, 'Volkswagen', 'Dasher', 'Hatchback 4-Door'],
    [1980, 'Volkswagen', 'Dasher', 'Wagon 4-Door'],
    [1980, 'Volkswagen', 'Jetta', 'Sedan 2-Door'],
    [1980, 'Volkswagen', 'Jetta', 'Sedan 4-Door'],
    [1980, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1980, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1980, 'Volkswagen', 'Rabbit Convertible', 'Convertible 2-Door'],
    [1980, 'Volkswagen', 'Rabbit Pickup', 'Standard Cab Pickup 2-Door'],
    [1980, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1980, 'Volkswagen', 'Super Beetle', 'Convertible 2-Door'],
    [1980, 'Volkswagen', 'Vanagon', 'Standard Passenger Van 3-Door'],
    [1980, 'Volkswagen', 'Vanagon', 'Van Camper 3-Door'],
    [1980, 'Volvo', '242', 'Sedan 2-Door'],
    [1980, 'Volvo', '244', 'Sedan 4-Door'],
    [1980, 'Volvo', '245', 'Wagon 4-Door'],
    [1980, 'Volvo', '262', 'Coupe 2-Door'],
    [1980, 'Volvo', '264', 'Sedan 4-Door'],
    [1980, 'Volvo', '265', 'Wagon 4-Door'],
    [1979, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1979, 'Alfa Romeo', 'Sport', 'Sedan 4-Door'],
    [1979, 'Alfa Romeo', 'Sprint', 'Coupe 2-Door'],
    [1979, 'AMC', 'AMX', 'Hatchback 2-Door'],
    [1979, 'AMC', 'Concord', 'Hatchback 2-Door'],
    [1979, 'AMC', 'Concord', 'Sedan 2-Door'],
    [1979, 'AMC', 'Concord', 'Sedan 4-Door'],
    [1979, 'AMC', 'Concord', 'Wagon 4-Door'],
    [1979, 'AMC', 'Pacer', 'Hatchback 2-Door'],
    [1979, 'AMC', 'Pacer', 'Wagon 2-Door'],
    [1979, 'AMC', 'Spirit', 'Hatchback 2-Door'],
    [1979, 'AMC', 'Spirit', 'Sedan 2-Door'],
    [1979, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1979, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1979, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1979, 'Audi', '5000', 'Sedan 4-Door'],
    [1979, 'Audi', 'Fox', 'Sedan 2-Door'],
    [1979, 'Audi', 'Fox', 'Sedan 4-Door'],
    [1979, 'Audi', 'Fox', 'Wagon 4-Door'],
    [1979, 'Avanti', 'II', 'Coupe 2-Door'],
    [1979, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1979, 'Bentley', 'Corniche', 'Coupe 2-Door'],
    [1979, 'Bentley', 'T2 Series', 'Sedan 4-Door'],
    [1979, 'BMW', '320i', 'Coupe 2-Door'],
    [1979, 'BMW', '528i', 'Sedan 4-Door'],
    [1979, 'BMW', '633CSi', 'Coupe 2-Door'],
    [1979, 'BMW', '733i', 'Sedan 4-Door'],
    [1979, 'Buick', 'Century', 'Coupe 2-Door'],
    [1979, 'Buick', 'Century', 'Sedan 4-Door'],
    [1979, 'Buick', 'Century', 'Wagon 4-Door'],
    [1979, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1979, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1979, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1979, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1979, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1979, 'Buick', 'Opel', 'Coupe 2-Door'],
    [1979, 'Buick', 'Opel', 'Sedan 4-Door'],
    [1979, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1979, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1979, 'Buick', 'Skyhawk', 'Hatchback 2-Door'],
    [1979, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1979, 'Buick', 'Skylark', 'Hatchback 2-Door'],
    [1979, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1979, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1979, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1979, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1979, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1979, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1979, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1979, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1979, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1979, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1979, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1979, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1979, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1979, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1979, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1979, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1979, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1979, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1979, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1979, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1979, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1979, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1979, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1979, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1979, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1979, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1979, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1979, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1979, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1979, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1979, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1979, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1979, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1979, 'Chevrolet', 'Impala', 'Coupe 2-Door'],
    [1979, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1979, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1979, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1979, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1979, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1979, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1979, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1979, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1979, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1979, 'Chevrolet', 'LUV', 'Standard Cab Pickup 2-Door'],
    [1979, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1979, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1979, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1979, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1979, 'Chevrolet', 'Monza', 'Coupe 2-Door'],
    [1979, 'Chevrolet', 'Monza', 'Hatchback 2-Door'],
    [1979, 'Chevrolet', 'Monza', 'Wagon 2-Door'],
    [1979, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1979, 'Chevrolet', 'Nova', 'Hatchback 2-Door'],
    [1979, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1979, 'Chevrolet', 'P10', 'Standard Cargo Van 2-Door'],
    [1979, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1979, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1979, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1979, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1979, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1979, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1979, 'Datsun', '210', 'Hatchback 2-Door'],
    [1979, 'Datsun', '210', 'Sedan 2-Door'],
    [1979, 'Datsun', '210', 'Sedan 4-Door'],
    [1979, 'Datsun', '210', 'Wagon 4-Door'],
    [1979, 'Datsun', '310', 'Coupe 2-Door'],
    [1979, 'Datsun', '310', 'Hatchback 2-Door'],
    [1979, 'Datsun', '310', 'Hatchback 4-Door'],
    [1979, 'Datsun', '510', 'Hatchback 2-Door'],
    [1979, 'Datsun', '510', 'Hatchback 4-Door'],
    [1979, 'Datsun', '510', 'Sedan 2-Door'],
    [1979, 'Datsun', '510', 'Sedan 4-Door'],
    [1979, 'Datsun', '510', 'Wagon 4-Door'],
    [1979, 'Datsun', '620', 'Extended Cab Pickup 2-Door'],
    [1979, 'Datsun', '620', 'Standard Cab Pickup 2-Door'],
    [1979, 'Datsun', '810', 'Hardtop 2-Door'],
    [1979, 'Datsun', '810', 'Sedan 4-Door'],
    [1979, 'Datsun', '810', 'Wagon 4-Door'],
    [1979, 'Datsun', '200SX', 'Coupe 2-Door'],
    [1979, 'Datsun', '280ZX', 'Coupe 2-Door'],
    [1979, 'Dodge', 'Aspen', 'Coupe 2-Door'],
    [1979, 'Dodge', 'Aspen', 'Sedan 4-Door'],
    [1979, 'Dodge', 'Aspen', 'Wagon 4-Door'],
    [1979, 'Dodge', 'B100', 'Standard Cargo Van 3-Door'],
    [1979, 'Dodge', 'B100', 'Standard Passenger Van 3-Door'],
    [1979, 'Dodge', 'B200', 'Extended Cargo Van 3-Door'],
    [1979, 'Dodge', 'B200', 'Standard Cargo Van 3-Door'],
    [1979, 'Dodge', 'B200', 'Standard Passenger Van 3-Door'],
    [1979, 'Dodge', 'B300', 'Extended Cargo Van 3-Door'],
    [1979, 'Dodge', 'B300', 'Standard Cargo Van 3-Door'],
    [1979, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [1979, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1979, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1979, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1979, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1979, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1979, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1979, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1979, 'Dodge', 'D200', 'Crew Cab Pickup 4-Door'],
    [1979, 'Dodge', 'D200', 'Extended Cab Pickup 2-Door'],
    [1979, 'Dodge', 'D200', 'Standard Cab Pickup 2-Door'],
    [1979, 'Dodge', 'D300', 'Crew Cab Pickup 4-Door'],
    [1979, 'Dodge', 'D300', 'Extended Cab Pickup 2-Door'],
    [1979, 'Dodge', 'D300', 'Standard Cab Pickup 2-Door'],
    [1979, 'Dodge', 'D50', 'Standard Cab Pickup 2-Door'],
    [1979, 'Dodge', 'Diplomat', 'Coupe 2-Door'],
    [1979, 'Dodge', 'Diplomat', 'Wagon 4-Door'],
    [1979, 'Dodge', 'Magnum', 'Coupe 2-Door'],
    [1979, 'Dodge', 'Omni', 'Hatchback 2-Door'],
    [1979, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1979, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1979, 'Dodge', 'RD200', 'Crew Cab Pickup 4-Door'],
    [1979, 'Dodge', 'RD200', 'Extended Cab Pickup 2-Door'],
    [1979, 'Dodge', 'RD200', 'Standard Cab Pickup 2-Door'],
    [1979, 'Dodge', 'St. Regis', 'Hardtop 4-Door'],
    [1979, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1979, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1979, 'Dodge', 'W200', 'Crew Cab Pickup 4-Door'],
    [1979, 'Dodge', 'W200', 'Extended Cab Pickup 2-Door'],
    [1979, 'Dodge', 'W200', 'Standard Cab Pickup 2-Door'],
    [1979, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1979, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1979, 'Ferrari', '308 GTS', 'Coupe 2-Door'],
    [1979, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1979, 'Ferrari', 'Dino 308 GT4', 'Coupe 2-Door'],
    [1979, 'Fiat', '124', 'Convertible 2-Door'],
    [1979, 'Fiat', '128', 'Coupe 2-Door'],
    [1979, 'Fiat', '128', 'Coupe 3-Door'],
    [1979, 'Fiat', '128', 'Sedan 2-Door'],
    [1979, 'Fiat', '128', 'Sedan 4-Door'],
    [1979, 'Fiat', 'Brava', 'Coupe 2-Door'],
    [1979, 'Fiat', 'Brava', 'Sedan 4-Door'],
    [1979, 'Fiat', 'Brava', 'Wagon 4-Door'],
    [1979, 'Fiat', 'Strada', 'Hatchback 2-Door'],
    [1979, 'Fiat', 'Strada', 'Hatchback 4-Door'],
    [1979, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1979, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1979, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1979, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1979, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1979, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1979, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1979, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1979, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1979, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1979, 'Ford', 'E-150 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1979, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1979, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1979, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1979, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1979, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1979, 'Ford', 'E-250 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1979, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1979, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1979, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1979, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1979, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1979, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1979, 'Ford', 'F-100', 'Extended Cab Pickup 2-Door'],
    [1979, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1979, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1979, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1979, 'Ford', 'F-250', 'Crew Cab Pickup 4-Door'],
    [1979, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1979, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1979, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1979, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1979, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1979, 'Ford', 'Fairmont', 'Coupe 2-Door'],
    [1979, 'Ford', 'Fairmont', 'Sedan 2-Door'],
    [1979, 'Ford', 'Fairmont', 'Sedan 4-Door'],
    [1979, 'Ford', 'Fairmont', 'Wagon 4-Door'],
    [1979, 'Ford', 'Fiesta', 'Hatchback 2-Door'],
    [1979, 'Ford', 'Granada', 'Sedan 2-Door'],
    [1979, 'Ford', 'Granada', 'Sedan 4-Door'],
    [1979, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1979, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1979, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1979, 'Ford', 'LTD II', 'Hardtop 2-Door'],
    [1979, 'Ford', 'LTD II', 'Hardtop 4-Door'],
    [1979, 'Ford', 'Mustang', 'Hatchback 2-Door'],
    [1979, 'Ford', 'Mustang', 'Sedan 2-Door'],
    [1979, 'Ford', 'Pinto', 'Sedan 2-Door'],
    [1979, 'Ford', 'Pinto', 'Sedan 3-Door'],
    [1979, 'Ford', 'Pinto', 'Wagon 2-Door'],
    [1979, 'Ford', 'Ranchero', 'Standard Cab Pickup 2-Door'],
    [1979, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1979, 'GMC', 'C1500', 'Standard Cab Pickup 2-Door'],
    [1979, 'GMC', 'C1500 Suburban', 'SUV 4-Door'],
    [1979, 'GMC', 'C2500', 'Crew Cab Pickup 4-Door'],
    [1979, 'GMC', 'C2500', 'Standard Cab Pickup 2-Door'],
    [1979, 'GMC', 'C2500 Suburban', 'SUV 4-Door'],
    [1979, 'GMC', 'C3500', 'Crew Cab Pickup 4-Door'],
    [1979, 'GMC', 'C3500', 'Standard Cab Pickup 2-Door'],
    [1979, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1979, 'GMC', 'G1500', 'Extended Cargo Van 3-Door'],
    [1979, 'GMC', 'G1500', 'Extended Passenger Van 3-Door'],
    [1979, 'GMC', 'G1500', 'Standard Cargo Van 3-Door'],
    [1979, 'GMC', 'G1500', 'Standard Passenger Van 3-Door'],
    [1979, 'GMC', 'G2500', 'Extended Cargo Van 3-Door'],
    [1979, 'GMC', 'G2500', 'Extended Passenger Van 3-Door'],
    [1979, 'GMC', 'G2500', 'Standard Cargo Van 3-Door'],
    [1979, 'GMC', 'G2500', 'Standard Passenger Van 3-Door'],
    [1979, 'GMC', 'G3500', 'Standard Cargo Van 3-Door'],
    [1979, 'GMC', 'G3500', 'Standard Passenger Van 3-Door'],
    [1979, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1979, 'GMC', 'K1500', 'Standard Cab Pickup 2-Door'],
    [1979, 'GMC', 'K1500 Suburban', 'SUV 4-Door'],
    [1979, 'GMC', 'K2500', 'Standard Cab Pickup 2-Door'],
    [1979, 'GMC', 'K2500 Suburban', 'SUV 4-Door'],
    [1979, 'GMC', 'K3500', 'Crew Cab Pickup 4-Door'],
    [1979, 'GMC', 'K3500', 'Standard Cab Pickup 2-Door'],
    [1979, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1979, 'Honda', 'Accord', 'Sedan 4-Door'],
    [1979, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1979, 'Honda', 'Civic', 'Sedan 2-Door'],
    [1979, 'Honda', 'Civic', 'Sedan 3-Door'],
    [1979, 'Honda', 'Civic', 'Wagon 2-Door'],
    [1979, 'Honda', 'Civic', 'Wagon 3-Door'],
    [1979, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1979, 'Honda', 'Prelude', 'Coupe 2-Door'],
    [1979, 'International Harvester', 'Scout II', 'Standard Cab Pickup 2-Door'],
    [1979, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1979, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1979, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1979, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1979, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1979, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1979, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1979, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1979, 'Jeep', 'DJ5', 'SUV 2-Door'],
    [1979, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1979, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1979, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1979, 'Lancia', 'Beta', 'Coupe 2-Door'],
    [1979, 'Lancia', 'Beta', 'Sedan 4-Door'],
    [1979, 'Lancia', 'Beta', 'Wagon 2-Door'],
    [1979, 'Lancia', 'Zagato', 'Convertible 2-Door'],
    [1979, 'Lincoln', 'Continental', 'Hardtop 2-Door'],
    [1979, 'Lincoln', 'Continental', 'Hardtop 4-Door'],
    [1979, 'Lincoln', 'Mark V', 'Coupe 2-Door'],
    [1979, 'Lincoln', 'Versailles', 'Sedan 4-Door'],
    [1979, 'Lotus', 'Eclat', 'Hatchback 2-Door'],
    [1979, 'Lotus', 'Elite', 'Hatchback 2-Door'],
    [1979, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1979, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1979, 'Maserati', 'Khamsin', 'Coupe 2-Door'],
    [1979, 'Maserati', 'Merak', 'Coupe 2-Door'],
    [1979, 'Maserati', 'Quattroporte', 'Sedan 4-Door'],
    [1979, 'Mazda', '626', 'Coupe 2-Door'],
    [1979, 'Mazda', '626', 'Sedan 4-Door'],
    [1979, 'Mazda', 'B2000', 'Standard Cab Pickup 2-Door'],
    [1979, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1979, 'Mazda', 'GLC', 'Hatchback 4-Door'],
    [1979, 'Mazda', 'GLC', 'Wagon 4-Door'],
    [1979, 'Mazda', 'RX-7', 'Coupe 2-Door'],
    [1979, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1979, 'Mercedes-Benz', '280CE', 'Coupe 2-Door'],
    [1979, 'Mercedes-Benz', '280E', 'Sedan 4-Door'],
    [1979, 'Mercedes-Benz', '280SE', 'Sedan 4-Door'],
    [1979, 'Mercedes-Benz', '300CD', 'Coupe 2-Door'],
    [1979, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1979, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1979, 'Mercedes-Benz', '300TD', 'Wagon 4-Door'],
    [1979, 'Mercedes-Benz', '450SEL', 'Sedan 4-Door'],
    [1979, 'Mercedes-Benz', '450SL', 'Convertible 2-Door'],
    [1979, 'Mercedes-Benz', '450SLC', 'Coupe 2-Door'],
    [1979, 'Mercury', 'Bobcat', 'Sedan 3-Door'],
    [1979, 'Mercury', 'Bobcat', 'Wagon 2-Door'],
    [1979, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1979, 'Mercury', 'Cougar', 'Hardtop 2-Door'],
    [1979, 'Mercury', 'Cougar', 'Hardtop 4-Door'],
    [1979, 'Mercury', 'Grand Marquis', 'Hardtop 2-Door'],
    [1979, 'Mercury', 'Grand Marquis', 'Sedan 4-Door'],
    [1979, 'Mercury', 'Grand Marquis', 'Wagon 4-Door'],
    [1979, 'Mercury', 'Marquis', 'Sedan 2-Door'],
    [1979, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1979, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1979, 'Mercury', 'Monarch', 'Sedan 2-Door'],
    [1979, 'Mercury', 'Monarch', 'Sedan 4-Door'],
    [1979, 'Mercury', 'Zephyr', 'Coupe 2-Door'],
    [1979, 'Mercury', 'Zephyr', 'Sedan 2-Door'],
    [1979, 'Mercury', 'Zephyr', 'Sedan 4-Door'],
    [1979, 'Mercury', 'Zephyr', 'Wagon 4-Door'],
    [1979, 'MG', 'MGB', 'Convertible 2-Door'],
    [1979, 'MG', 'Midget', 'Convertible 2-Door'],
    [1979, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1979, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1979, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1979, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1979, 'Oldsmobile', 'Cutlass', 'Wagon 4-Door'],
    [1979, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1979, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1979, 'Oldsmobile', 'Cutlass Salon', 'Sedan 4-Door'],
    [1979, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1979, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1979, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1979, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1979, 'Oldsmobile', 'Omega', 'Hatchback 2-Door'],
    [1979, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1979, 'Oldsmobile', 'Starfire', 'Coupe 2-Door'],
    [1979, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1979, 'Peugeot', '504', 'Sedan 4-Door'],
    [1979, 'Peugeot', '504', 'Wagon 4-Door'],
    [1979, 'Peugeot', '604', 'Sedan 4-Door'],
    [1979, 'Plymouth', 'Arrow', 'Hatchback 2-Door'],
    [1979, 'Plymouth', 'Arrow Pickup', 'Standard Cab Pickup 2-Door'],
    [1979, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1979, 'Plymouth', 'Champ', 'Hatchback 2-Door'],
    [1979, 'Plymouth', 'Colt', 'Coupe 2-Door'],
    [1979, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1979, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1979, 'Plymouth', 'Horizon', 'Hatchback 2-Door'],
    [1979, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1979, 'Plymouth', 'PB100', 'Standard Passenger Van 3-Door'],
    [1979, 'Plymouth', 'PB200', 'Extended Passenger Van 3-Door'],
    [1979, 'Plymouth', 'PB200', 'Standard Passenger Van 3-Door'],
    [1979, 'Plymouth', 'PB300', 'Extended Passenger Van 3-Door'],
    [1979, 'Plymouth', 'PB300', 'Standard Passenger Van 3-Door'],
    [1979, 'Plymouth', 'Sapporo', 'Coupe 2-Door'],
    [1979, 'Plymouth', 'Trailduster', 'SUV 2-Door'],
    [1979, 'Plymouth', 'Volare', 'Coupe 2-Door'],
    [1979, 'Plymouth', 'Volare', 'Sedan 4-Door'],
    [1979, 'Plymouth', 'Volare', 'Wagon 4-Door'],
    [1979, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1979, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1979, 'Pontiac', 'Bonneville', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1979, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1979, 'Pontiac', 'Catalina', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1979, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1979, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1979, 'Pontiac', 'Grand LeMans', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1979, 'Pontiac', 'Grand LeMans', 'Wagon 4-Door'],
    [1979, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Laurentian', 'Sedan 4-Door'],
    [1979, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1979, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1979, 'Pontiac', 'Parisienne', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1979, 'Pontiac', 'Phoenix', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Phoenix', 'Hatchback 2-Door'],
    [1979, 'Pontiac', 'Phoenix', 'Sedan 4-Door'],
    [1979, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1979, 'Pontiac', 'Sunbird', 'Hatchback 2-Door'],
    [1979, 'Pontiac', 'Sunbird', 'Wagon 2-Door'],
    [1979, 'Porsche', '911', 'Coupe 2-Door'],
    [1979, 'Porsche', '911', 'Targa 2-Door'],
    [1979, 'Porsche', '924', 'Coupe 2-Door'],
    [1979, 'Porsche', '928', 'Coupe 2-Door'],
    [1979, 'Porsche', '930', 'Coupe 2-Door'],
    [1979, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1979, 'Renault', 'R17', 'Coupe 2-Door'],
    [1979, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1979, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1979, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1979, 'Rolls-Royce', 'Silver Shadow II', 'Sedan 4-Door'],
    [1979, 'Rolls-Royce', 'Silver Wraith II', 'Sedan 4-Door'],
    [1979, 'Saab', '99', 'Hatchback 2-Door'],
    [1979, 'Saab', '99', 'Sedan 2-Door'],
    [1979, 'Saab', '900', 'Hatchback 2-Door'],
    [1979, 'Saab', '900', 'Hatchback 4-Door'],
    [1979, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1979, 'Subaru', 'DL', 'Coupe 2-Door'],
    [1979, 'Subaru', 'DL', 'Sedan 2-Door'],
    [1979, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1979, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1979, 'Subaru', 'FE', 'Coupe 2-Door'],
    [1979, 'Subaru', 'GF', 'Hardtop 2-Door'],
    [1979, 'Subaru', 'GL', 'Sedan 4-Door'],
    [1979, 'Subaru', 'GL', 'Wagon 4-Door'],
    [1979, 'Subaru', 'Standard', 'Sedan 2-Door'],
    [1979, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1979, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1979, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1979, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1979, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1979, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1979, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1979, 'Toyota', 'Corona', 'Hatchback 4-Door'],
    [1979, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1979, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1979, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1979, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1979, 'Toyota', 'Land Cruiser', 'Standard Cab Pickup 2-Door'],
    [1979, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1979, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1979, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1979, 'Triumph', 'Spitfire', 'Convertible 2-Door'],
    [1979, 'Triumph', 'TR7', 'Convertible 2-Door'],
    [1979, 'Triumph', 'TR7', 'Coupe 2-Door'],
    [1979, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1979, 'Volkswagen', 'Dasher', 'Hatchback 2-Door'],
    [1979, 'Volkswagen', 'Dasher', 'Hatchback 4-Door'],
    [1979, 'Volkswagen', 'Dasher', 'Wagon 4-Door'],
    [1979, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1979, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1979, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1979, 'Volkswagen', 'Super Beetle', 'Convertible 2-Door'],
    [1979, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1979, 'Volkswagen', 'Transporter', 'Van Camper 3-Door'],
    [1979, 'Volvo', '242', 'Sedan 2-Door'],
    [1979, 'Volvo', '244', 'Sedan 4-Door'],
    [1979, 'Volvo', '245', 'Wagon 4-Door'],
    [1979, 'Volvo', '262', 'Coupe 2-Door'],
    [1979, 'Volvo', '264', 'Sedan 4-Door'],
    [1979, 'Volvo', '265', 'Wagon 4-Door'],
    [1978, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1978, 'Alfa Romeo', 'Sport', 'Sedan 4-Door'],
    [1978, 'Alfa Romeo', 'Sprint', 'Coupe 2-Door'],
    [1978, 'AMC', 'AMX', 'Hatchback 2-Door'],
    [1978, 'AMC', 'Concord', 'Hatchback 2-Door'],
    [1978, 'AMC', 'Concord', 'Sedan 2-Door'],
    [1978, 'AMC', 'Concord', 'Sedan 4-Door'],
    [1978, 'AMC', 'Concord', 'Wagon 4-Door'],
    [1978, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1978, 'AMC', 'Matador', 'Coupe 2-Door'],
    [1978, 'AMC', 'Matador', 'Sedan 4-Door'],
    [1978, 'AMC', 'Matador', 'Wagon 4-Door'],
    [1978, 'AMC', 'Pacer', 'Hatchback 2-Door'],
    [1978, 'AMC', 'Pacer', 'Wagon 2-Door'],
    [1978, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1978, 'Aston Martin', 'V-8', 'Convertible 2-Door'],
    [1978, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1978, 'Audi', '5000', 'Sedan 4-Door'],
    [1978, 'Audi', 'Fox', 'Sedan 2-Door'],
    [1978, 'Audi', 'Fox', 'Sedan 4-Door'],
    [1978, 'Audi', 'Fox', 'Wagon 4-Door'],
    [1978, 'Avanti', 'II', 'Coupe 2-Door'],
    [1978, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1978, 'Bentley', 'Corniche', 'Coupe 2-Door'],
    [1978, 'Bentley', 'T2 Series', 'Sedan 4-Door'],
    [1978, 'BMW', '320i', 'Coupe 2-Door'],
    [1978, 'BMW', '530i', 'Sedan 4-Door'],
    [1978, 'BMW', '630CSi', 'Coupe 2-Door'],
    [1978, 'BMW', '633CSi', 'Coupe 2-Door'],
    [1978, 'BMW', '733i', 'Sedan 4-Door'],
    [1978, 'Buick', 'Century', 'Coupe 2-Door'],
    [1978, 'Buick', 'Century', 'Sedan 4-Door'],
    [1978, 'Buick', 'Century', 'Wagon 4-Door'],
    [1978, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1978, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1978, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1978, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1978, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1978, 'Buick', 'Opel', 'Coupe 2-Door'],
    [1978, 'Buick', 'Opel', 'Sedan 4-Door'],
    [1978, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1978, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1978, 'Buick', 'Skyhawk', 'Hatchback 2-Door'],
    [1978, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1978, 'Buick', 'Skylark', 'Hatchback 2-Door'],
    [1978, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1978, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1978, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1978, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1978, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1978, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1978, 'Cadillac', 'Seville', 'Coupe 2-Door'],
    [1978, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1978, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1978, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1978, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1978, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1978, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1978, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1978, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1978, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1978, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1978, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1978, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1978, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1978, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1978, 'Chevrolet', 'Chevette', 'Hatchback 4-Door'],
    [1978, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1978, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1978, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1978, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1978, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1978, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1978, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1978, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1978, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1978, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1978, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1978, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1978, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1978, 'Chevrolet', 'Impala', 'Coupe 2-Door'],
    [1978, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1978, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1978, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1978, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1978, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1978, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1978, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1978, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1978, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1978, 'Chevrolet', 'LUV', 'Standard Cab Pickup 2-Door'],
    [1978, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1978, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1978, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1978, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1978, 'Chevrolet', 'Monza', 'Coupe 2-Door'],
    [1978, 'Chevrolet', 'Monza', 'Hatchback 2-Door'],
    [1978, 'Chevrolet', 'Monza', 'Wagon 2-Door'],
    [1978, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1978, 'Chevrolet', 'Nova', 'Hatchback 2-Door'],
    [1978, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1978, 'Chevrolet', 'P10', 'Standard Cargo Van 2-Door'],
    [1978, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1978, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1978, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1978, 'Chrysler', 'New Yorker', 'Hardtop 2-Door'],
    [1978, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1978, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1978, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1978, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1978, 'Datsun', '510', 'Hatchback 2-Door'],
    [1978, 'Datsun', '510', 'Hatchback 4-Door'],
    [1978, 'Datsun', '510', 'Sedan 2-Door'],
    [1978, 'Datsun', '510', 'Sedan 4-Door'],
    [1978, 'Datsun', '510', 'Wagon 4-Door'],
    [1978, 'Datsun', '620', 'Extended Cab Pickup 2-Door'],
    [1978, 'Datsun', '620', 'Standard Cab Pickup 2-Door'],
    [1978, 'Datsun', '810', 'Sedan 4-Door'],
    [1978, 'Datsun', '810', 'Wagon 4-Door'],
    [1978, 'Datsun', '200SX', 'Coupe 2-Door'],
    [1978, 'Datsun', '280Z', 'Coupe 2-Door'],
    [1978, 'Datsun', 'B210', 'Coupe 2-Door'],
    [1978, 'Datsun', 'B210', 'Sedan 2-Door'],
    [1978, 'Datsun', 'B210', 'Sedan 4-Door'],
    [1978, 'Datsun', 'F10', 'Hatchback 2-Door'],
    [1978, 'Datsun', 'F10', 'Sedan 2-Door'],
    [1978, 'Datsun', 'F10', 'Wagon 2-Door'],
    [1978, 'Dodge', 'Aspen', 'Coupe 2-Door'],
    [1978, 'Dodge', 'Aspen', 'Sedan 4-Door'],
    [1978, 'Dodge', 'Aspen', 'Wagon 4-Door'],
    [1978, 'Dodge', 'B100', 'Standard Cargo Van 3-Door'],
    [1978, 'Dodge', 'B100', 'Standard Passenger Van 3-Door'],
    [1978, 'Dodge', 'B200', 'Extended Cargo Van 3-Door'],
    [1978, 'Dodge', 'B200', 'Standard Cargo Van 3-Door'],
    [1978, 'Dodge', 'B200', 'Standard Passenger Van 3-Door'],
    [1978, 'Dodge', 'B300', 'Extended Cargo Van 3-Door'],
    [1978, 'Dodge', 'B300', 'Standard Cargo Van 3-Door'],
    [1978, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [1978, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1978, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1978, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1978, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1978, 'Dodge', 'D100', 'Extended Cab Pickup 2-Door'],
    [1978, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1978, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1978, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1978, 'Dodge', 'D200', 'Crew Cab Pickup 4-Door'],
    [1978, 'Dodge', 'D200', 'Extended Cab Pickup 2-Door'],
    [1978, 'Dodge', 'D200', 'Standard Cab Pickup 2-Door'],
    [1978, 'Dodge', 'D300', 'Crew Cab Pickup 4-Door'],
    [1978, 'Dodge', 'D300', 'Extended Cab Pickup 2-Door'],
    [1978, 'Dodge', 'D300', 'Standard Cab Pickup 2-Door'],
    [1978, 'Dodge', 'Diplomat', 'Coupe 2-Door'],
    [1978, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1978, 'Dodge', 'Diplomat', 'Wagon 4-Door'],
    [1978, 'Dodge', 'Magnum', 'Coupe 2-Door'],
    [1978, 'Dodge', 'Monaco', 'Hardtop 2-Door'],
    [1978, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1978, 'Dodge', 'Monaco', 'Wagon 4-Door'],
    [1978, 'Dodge', 'Omni', 'Hatchback 4-Door'],
    [1978, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1978, 'Dodge', 'RD200', 'Extended Cab Pickup 2-Door'],
    [1978, 'Dodge', 'RD200', 'Standard Cab Pickup 2-Door'],
    [1978, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1978, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1978, 'Dodge', 'W200', 'Crew Cab Pickup 4-Door'],
    [1978, 'Dodge', 'W200', 'Extended Cab Pickup 2-Door'],
    [1978, 'Dodge', 'W200', 'Standard Cab Pickup 2-Door'],
    [1978, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1978, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1978, 'Ferrari', '308 GTS', 'Coupe 2-Door'],
    [1978, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1978, 'Ferrari', 'Dino 308 GT4', 'Coupe 2-Door'],
    [1978, 'Fiat', '124', 'Convertible 2-Door'],
    [1978, 'Fiat', '128', 'Coupe 2-Door'],
    [1978, 'Fiat', '128', 'Coupe 3-Door'],
    [1978, 'Fiat', '128', 'Sedan 2-Door'],
    [1978, 'Fiat', '128', 'Sedan 4-Door'],
    [1978, 'Fiat', '131', 'Coupe 2-Door'],
    [1978, 'Fiat', '131', 'Sedan 4-Door'],
    [1978, 'Fiat', '131', 'Wagon 4-Door'],
    [1978, 'Fiat', 'Brava', 'Coupe 2-Door'],
    [1978, 'Fiat', 'Brava', 'Sedan 4-Door'],
    [1978, 'Fiat', 'Brava', 'Wagon 4-Door'],
    [1978, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1978, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1978, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1978, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1978, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1978, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1978, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1978, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1978, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1978, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1978, 'Ford', 'E-150 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1978, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1978, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1978, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1978, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1978, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1978, 'Ford', 'E-250 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1978, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1978, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1978, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1978, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1978, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1978, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1978, 'Ford', 'F-100', 'Extended Cab Pickup 2-Door'],
    [1978, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1978, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1978, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1978, 'Ford', 'F-250', 'Crew Cab Pickup 4-Door'],
    [1978, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1978, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1978, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1978, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1978, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1978, 'Ford', 'Fairmont', 'Coupe 2-Door'],
    [1978, 'Ford', 'Fairmont', 'Sedan 2-Door'],
    [1978, 'Ford', 'Fairmont', 'Sedan 4-Door'],
    [1978, 'Ford', 'Fairmont', 'Wagon 4-Door'],
    [1978, 'Ford', 'Fiesta', 'Hatchback 2-Door'],
    [1978, 'Ford', 'Granada', 'Sedan 2-Door'],
    [1978, 'Ford', 'Granada', 'Sedan 4-Door'],
    [1978, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1978, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1978, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1978, 'Ford', 'LTD II', 'Hardtop 2-Door'],
    [1978, 'Ford', 'LTD II', 'Hardtop 4-Door'],
    [1978, 'Ford', 'Mustang II', 'Hardtop 2-Door'],
    [1978, 'Ford', 'Mustang II', 'Hardtop 3-Door'],
    [1978, 'Ford', 'Pinto', 'Sedan 2-Door'],
    [1978, 'Ford', 'Pinto', 'Sedan 3-Door'],
    [1978, 'Ford', 'Pinto', 'Wagon 2-Door'],
    [1978, 'Ford', 'Ranchero', 'Standard Cab Pickup 2-Door'],
    [1978, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1978, 'GMC', 'C15', 'Standard Cab Pickup 2-Door'],
    [1978, 'GMC', 'C15 Suburban', 'SUV 4-Door'],
    [1978, 'GMC', 'C25', 'Crew Cab Pickup 4-Door'],
    [1978, 'GMC', 'C25', 'Standard Cab Pickup 2-Door'],
    [1978, 'GMC', 'C25 Suburban', 'SUV 4-Door'],
    [1978, 'GMC', 'C35', 'Crew Cab Pickup 4-Door'],
    [1978, 'GMC', 'C35', 'Standard Cab Pickup 2-Door'],
    [1978, 'GMC', 'Caballero', 'Standard Cab Pickup 2-Door'],
    [1978, 'GMC', 'G15', 'Extended Cargo Van 3-Door'],
    [1978, 'GMC', 'G15', 'Extended Passenger Van 3-Door'],
    [1978, 'GMC', 'G15', 'Standard Cargo Van 3-Door'],
    [1978, 'GMC', 'G15', 'Standard Passenger Van 3-Door'],
    [1978, 'GMC', 'G25', 'Extended Cargo Van 3-Door'],
    [1978, 'GMC', 'G25', 'Extended Passenger Van 3-Door'],
    [1978, 'GMC', 'G25', 'Standard Cargo Van 3-Door'],
    [1978, 'GMC', 'G25', 'Standard Passenger Van 3-Door'],
    [1978, 'GMC', 'G35', 'Extended Cargo Van 3-Door'],
    [1978, 'GMC', 'G35', 'Standard Cargo Van 3-Door'],
    [1978, 'GMC', 'G35', 'Standard Passenger Van 3-Door'],
    [1978, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1978, 'GMC', 'K15', 'Standard Cab Pickup 2-Door'],
    [1978, 'GMC', 'K15 Suburban', 'SUV 4-Door'],
    [1978, 'GMC', 'K25', 'Standard Cab Pickup 2-Door'],
    [1978, 'GMC', 'K25 Suburban', 'SUV 4-Door'],
    [1978, 'GMC', 'K35', 'Crew Cab Pickup 4-Door'],
    [1978, 'GMC', 'K35', 'Standard Cab Pickup 2-Door'],
    [1978, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1978, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1978, 'Honda', 'Civic', 'Sedan 2-Door'],
    [1978, 'Honda', 'Civic', 'Sedan 3-Door'],
    [1978, 'Honda', 'Civic', 'Wagon 2-Door'],
    [1978, 'Honda', 'Civic', 'Wagon 3-Door'],
    [1978, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1978, 'International Harvester', 'Scout II', 'Standard Cab Pickup 2-Door'],
    [1978, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1978, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1978, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1978, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1978, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1978, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1978, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1978, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1978, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1978, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1978, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1978, 'Lamborghini', 'Espada', 'Coupe 2-Door'],
    [1978, 'Lancia', 'Beta', 'Coupe 2-Door'],
    [1978, 'Lancia', 'Beta', 'Sedan 4-Door'],
    [1978, 'Lancia', 'Beta', 'Wagon 2-Door'],
    [1978, 'Lincoln', 'Continental', 'Hardtop 2-Door'],
    [1978, 'Lincoln', 'Continental', 'Hardtop 4-Door'],
    [1978, 'Lincoln', 'Mark V', 'Coupe 2-Door'],
    [1978, 'Lincoln', 'Versailles', 'Sedan 4-Door'],
    [1978, 'Lotus', 'Eclat', 'Hatchback 2-Door'],
    [1978, 'Lotus', 'Elite', 'Hatchback 2-Door'],
    [1978, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1978, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1978, 'Maserati', 'Khamsin', 'Coupe 2-Door'],
    [1978, 'Maserati', 'Merak', 'Coupe 2-Door'],
    [1978, 'Mazda', 'B1800', 'Standard Cab Pickup 2-Door'],
    [1978, 'Mazda', 'Cosmo', 'Coupe 2-Door'],
    [1978, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1978, 'Mazda', 'GLC', 'Hatchback 4-Door'],
    [1978, 'Mazda', 'RX-3', 'Coupe 2-Door'],
    [1978, 'Mazda', 'RX-4', 'Sedan 4-Door'],
    [1978, 'Mazda', 'RX-4', 'Wagon 4-Door'],
    [1978, 'Mercedes-Benz', '230', 'Sedan 4-Door'],
    [1978, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1978, 'Mercedes-Benz', '280CE', 'Coupe 2-Door'],
    [1978, 'Mercedes-Benz', '280E', 'Sedan 4-Door'],
    [1978, 'Mercedes-Benz', '280SE', 'Sedan 4-Door'],
    [1978, 'Mercedes-Benz', '300CD', 'Coupe 2-Door'],
    [1978, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1978, 'Mercedes-Benz', '300SD', 'Sedan 4-Door'],
    [1978, 'Mercedes-Benz', '450SEL', 'Sedan 4-Door'],
    [1978, 'Mercedes-Benz', '450SL', 'Convertible 2-Door'],
    [1978, 'Mercedes-Benz', '450SLC', 'Coupe 2-Door'],
    [1978, 'Mercury', 'Bobcat', 'Sedan 3-Door'],
    [1978, 'Mercury', 'Bobcat', 'Wagon 2-Door'],
    [1978, 'Mercury', 'Cougar', 'Hardtop 2-Door'],
    [1978, 'Mercury', 'Cougar', 'Hardtop 4-Door'],
    [1978, 'Mercury', 'Grand Marquis', 'Hardtop 2-Door'],
    [1978, 'Mercury', 'Grand Marquis', 'Hardtop 4-Door'],
    [1978, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1978, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1978, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1978, 'Mercury', 'Monarch', 'Sedan 2-Door'],
    [1978, 'Mercury', 'Monarch', 'Sedan 4-Door'],
    [1978, 'Mercury', 'Zephyr', 'Coupe 2-Door'],
    [1978, 'Mercury', 'Zephyr', 'Sedan 2-Door'],
    [1978, 'Mercury', 'Zephyr', 'Sedan 4-Door'],
    [1978, 'Mercury', 'Zephyr', 'Wagon 4-Door'],
    [1978, 'MG', 'MGB', 'Convertible 2-Door'],
    [1978, 'MG', 'Midget', 'Convertible 2-Door'],
    [1978, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1978, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1978, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1978, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1978, 'Oldsmobile', 'Cutlass', 'Wagon 4-Door'],
    [1978, 'Oldsmobile', 'Cutlass Calais', 'Coupe 2-Door'],
    [1978, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1978, 'Oldsmobile', 'Cutlass Salon', 'Sedan 4-Door'],
    [1978, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1978, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1978, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1978, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1978, 'Oldsmobile', 'Omega', 'Hatchback 2-Door'],
    [1978, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1978, 'Oldsmobile', 'Starfire', 'Coupe 2-Door'],
    [1978, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1978, 'Peugeot', '504', 'Sedan 4-Door'],
    [1978, 'Peugeot', '504', 'Wagon 4-Door'],
    [1978, 'Peugeot', '604', 'Sedan 4-Door'],
    [1978, 'Plymouth', 'Arrow', 'Hatchback 2-Door'],
    [1978, 'Plymouth', 'Caravelle', 'Sedan 4-Door'],
    [1978, 'Plymouth', 'Colt', 'Coupe 2-Door'],
    [1978, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1978, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1978, 'Plymouth', 'Fury', 'Hardtop 2-Door'],
    [1978, 'Plymouth', 'Fury', 'Sedan 4-Door'],
    [1978, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1978, 'Plymouth', 'Horizon', 'Hatchback 4-Door'],
    [1978, 'Plymouth', 'PB100', 'Standard Passenger Van 3-Door'],
    [1978, 'Plymouth', 'PB200', 'Extended Passenger Van 3-Door'],
    [1978, 'Plymouth', 'PB200', 'Standard Passenger Van 3-Door'],
    [1978, 'Plymouth', 'PB300', 'Extended Passenger Van 3-Door'],
    [1978, 'Plymouth', 'PB300', 'Standard Passenger Van 3-Door'],
    [1978, 'Plymouth', 'Sapporo', 'Coupe 2-Door'],
    [1978, 'Plymouth', 'Trailduster', 'SUV 2-Door'],
    [1978, 'Plymouth', 'Volare', 'Coupe 2-Door'],
    [1978, 'Plymouth', 'Volare', 'Sedan 4-Door'],
    [1978, 'Plymouth', 'Volare', 'Wagon 4-Door'],
    [1978, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1978, 'Pontiac', 'Acadian', 'Hatchback 4-Door'],
    [1978, 'Pontiac', 'Bonneville', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1978, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1978, 'Pontiac', 'Catalina', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1978, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1978, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1978, 'Pontiac', 'Grand LeMans', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1978, 'Pontiac', 'Grand LeMans', 'Wagon 4-Door'],
    [1978, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Grand Safari', 'Wagon 4-Door'],
    [1978, 'Pontiac', 'Laurentian', 'Sedan 4-Door'],
    [1978, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1978, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1978, 'Pontiac', 'Parisienne', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1978, 'Pontiac', 'Phoenix', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Phoenix', 'Hatchback 2-Door'],
    [1978, 'Pontiac', 'Phoenix', 'Sedan 4-Door'],
    [1978, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1978, 'Pontiac', 'Sunbird', 'Hatchback 2-Door'],
    [1978, 'Pontiac', 'Sunbird', 'Wagon 2-Door'],
    [1978, 'Porsche', '911', 'Coupe 2-Door'],
    [1978, 'Porsche', '911', 'Targa 2-Door'],
    [1978, 'Porsche', '924', 'Coupe 2-Door'],
    [1978, 'Porsche', '928', 'Coupe 2-Door'],
    [1978, 'Porsche', '930', 'Coupe 2-Door'],
    [1978, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1978, 'Renault', 'R17', 'Coupe 2-Door'],
    [1978, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1978, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1978, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1978, 'Rolls-Royce', 'Silver Shadow II', 'Sedan 4-Door'],
    [1978, 'Rolls-Royce', 'Silver Wraith II', 'Sedan 4-Door'],
    [1978, 'Saab', '99', 'Coupe 2-Door'],
    [1978, 'Saab', '99', 'Hatchback 2-Door'],
    [1978, 'Saab', '99', 'Hatchback 4-Door'],
    [1978, 'Saab', '99', 'Sedan 2-Door'],
    [1978, 'Saab', '99', 'Wagon 4-Door'],
    [1978, 'Subaru', 'Brat', 'Standard Cab Pickup 2-Door'],
    [1978, 'Subaru', 'DL', 'Coupe 2-Door'],
    [1978, 'Subaru', 'DL', 'Sedan 2-Door'],
    [1978, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1978, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1978, 'Subaru', 'GF', 'Hardtop 2-Door'],
    [1978, 'Subaru', 'Standard', 'Sedan 2-Door'],
    [1978, 'Toyota', 'Celica', 'Coupe 2-Door'],
    [1978, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1978, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1978, 'Toyota', 'Corolla', 'Hardtop 2-Door'],
    [1978, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1978, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1978, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1978, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1978, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1978, 'Toyota', 'Corona', 'Sedan 2-Door'],
    [1978, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1978, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1978, 'Toyota', 'Cressida', 'Sedan 4-Door'],
    [1978, 'Toyota', 'Cressida', 'Wagon 4-Door'],
    [1978, 'Toyota', 'Land Cruiser', 'Standard Cab Pickup 2-Door'],
    [1978, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1978, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1978, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1978, 'Triumph', 'Spitfire', 'Convertible 2-Door'],
    [1978, 'Triumph', 'TR7', 'Coupe 2-Door'],
    [1978, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1978, 'Volkswagen', 'Dasher', 'Hatchback 2-Door'],
    [1978, 'Volkswagen', 'Dasher', 'Hatchback 4-Door'],
    [1978, 'Volkswagen', 'Dasher', 'Wagon 4-Door'],
    [1978, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1978, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1978, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1978, 'Volkswagen', 'Super Beetle', 'Convertible 2-Door'],
    [1978, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1978, 'Volkswagen', 'Transporter', 'Van Camper 3-Door'],
    [1978, 'Volvo', '242', 'Sedan 2-Door'],
    [1978, 'Volvo', '244', 'Sedan 4-Door'],
    [1978, 'Volvo', '245', 'Wagon 4-Door'],
    [1978, 'Volvo', '262', 'Coupe 2-Door'],
    [1978, 'Volvo', '264', 'Sedan 4-Door'],
    [1978, 'Volvo', '265', 'Wagon 4-Door'],
    [1977, 'Alfa Romeo', 'Alfetta', 'Coupe 2-Door'],
    [1977, 'Alfa Romeo', 'Alfetta', 'Sedan 4-Door'],
    [1977, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1977, 'Alfa Romeo', 'Sprint', 'Coupe 2-Door'],
    [1977, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1977, 'AMC', 'Hornet', 'Hatchback 2-Door'],
    [1977, 'AMC', 'Hornet', 'Sedan 2-Door'],
    [1977, 'AMC', 'Hornet', 'Sedan 4-Door'],
    [1977, 'AMC', 'Hornet', 'Wagon 4-Door'],
    [1977, 'AMC', 'Matador', 'Coupe 2-Door'],
    [1977, 'AMC', 'Matador', 'Sedan 4-Door'],
    [1977, 'AMC', 'Matador', 'Wagon 4-Door'],
    [1977, 'AMC', 'Pacer', 'Hatchback 2-Door'],
    [1977, 'AMC', 'Pacer', 'Wagon 2-Door'],
    [1977, 'Aston Martin', 'Lagonda', 'Sedan 4-Door'],
    [1977, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1977, 'Audi', '100 Series', 'Sedan 2-Door'],
    [1977, 'Audi', '100 Series', 'Sedan 4-Door'],
    [1977, 'Audi', 'Fox', 'Sedan 2-Door'],
    [1977, 'Audi', 'Fox', 'Sedan 4-Door'],
    [1977, 'Audi', 'Fox', 'Wagon 4-Door'],
    [1977, 'Avanti', 'II', 'Coupe 2-Door'],
    [1977, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1977, 'Bentley', 'Corniche', 'Coupe 2-Door'],
    [1977, 'Bentley', 'T2 Series', 'Sedan 4-Door'],
    [1977, 'BMW', '320i', 'Coupe 2-Door'],
    [1977, 'BMW', '530i', 'Sedan 4-Door'],
    [1977, 'BMW', '630CSi', 'Coupe 2-Door'],
    [1977, 'Buick', 'Century', 'Coupe 2-Door'],
    [1977, 'Buick', 'Century', 'Sedan 4-Door'],
    [1977, 'Buick', 'Century', 'Wagon 4-Door'],
    [1977, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1977, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1977, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1977, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1977, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1977, 'Buick', 'Opel', 'Coupe 2-Door'],
    [1977, 'Buick', 'Opel', 'Sedan 4-Door'],
    [1977, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1977, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1977, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1977, 'Buick', 'Skyhawk', 'Hatchback 2-Door'],
    [1977, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1977, 'Buick', 'Skylark', 'Hatchback 2-Door'],
    [1977, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1977, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1977, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1977, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1977, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1977, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1977, 'Cadillac', 'Seville', 'Coupe 2-Door'],
    [1977, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1977, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1977, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1977, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1977, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1977, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1977, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1977, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1977, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1977, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1977, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1977, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1977, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1977, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1977, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1977, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1977, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1977, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1977, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1977, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1977, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1977, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1977, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1977, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1977, 'Chevrolet', 'Impala', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1977, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1977, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1977, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1977, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1977, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1977, 'Chevrolet', 'K30', 'Crew Cab Pickup 4-Door'],
    [1977, 'Chevrolet', 'K30', 'Standard Cab Pickup 2-Door'],
    [1977, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1977, 'Chevrolet', 'LUV', 'Standard Cab Pickup 2-Door'],
    [1977, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1977, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1977, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'Monza', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'Monza', 'Hatchback 2-Door'],
    [1977, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'Nova', 'Hatchback 2-Door'],
    [1977, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1977, 'Chevrolet', 'P10', 'Standard Cargo Van 2-Door'],
    [1977, 'Chevrolet', 'Vega', 'Coupe 2-Door'],
    [1977, 'Chevrolet', 'Vega', 'Hatchback 2-Door'],
    [1977, 'Chevrolet', 'Vega', 'Wagon 2-Door'],
    [1977, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1977, 'Chrysler', 'LeBaron', 'Coupe 2-Door'],
    [1977, 'Chrysler', 'LeBaron', 'Sedan 4-Door'],
    [1977, 'Chrysler', 'New Yorker', 'Hardtop 2-Door'],
    [1977, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1977, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1977, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1977, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1977, 'Chrysler', 'Town & Country', 'Wagon 5-Door'],
    [1977, 'Datsun', '620', 'Extended Cab Pickup 2-Door'],
    [1977, 'Datsun', '620', 'Standard Cab Pickup 2-Door'],
    [1977, 'Datsun', '710', 'Hardtop 2-Door'],
    [1977, 'Datsun', '710', 'Sedan 2-Door'],
    [1977, 'Datsun', '710', 'Sedan 4-Door'],
    [1977, 'Datsun', '710', 'Wagon 4-Door'],
    [1977, 'Datsun', '810', 'Sedan 4-Door'],
    [1977, 'Datsun', '810', 'Wagon 4-Door'],
    [1977, 'Datsun', '200SX', 'Coupe 2-Door'],
    [1977, 'Datsun', '280Z', 'Coupe 2-Door'],
    [1977, 'Datsun', 'B210', 'Coupe 2-Door'],
    [1977, 'Datsun', 'B210', 'Sedan 2-Door'],
    [1977, 'Datsun', 'B210', 'Sedan 4-Door'],
    [1977, 'Datsun', 'F10', 'Hatchback 2-Door'],
    [1977, 'Datsun', 'F10', 'Sedan 2-Door'],
    [1977, 'Datsun', 'F10', 'Wagon 2-Door'],
    [1977, 'Dodge', 'Aspen', 'Coupe 2-Door'],
    [1977, 'Dodge', 'Aspen', 'Sedan 4-Door'],
    [1977, 'Dodge', 'Aspen', 'Wagon 4-Door'],
    [1977, 'Dodge', 'B100', 'Standard Cargo Van 3-Door'],
    [1977, 'Dodge', 'B100', 'Standard Passenger Van 3-Door'],
    [1977, 'Dodge', 'B200', 'Extended Cargo Van 3-Door'],
    [1977, 'Dodge', 'B200', 'Extended Passenger Van 3-Door'],
    [1977, 'Dodge', 'B200', 'Standard Cargo Van 3-Door'],
    [1977, 'Dodge', 'B200', 'Standard Passenger Van 3-Door'],
    [1977, 'Dodge', 'B300', 'Extended Cargo Van 3-Door'],
    [1977, 'Dodge', 'B300', 'Standard Cargo Van 3-Door'],
    [1977, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1977, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1977, 'Dodge', 'Colt', 'Hardtop 2-Door'],
    [1977, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1977, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1977, 'Dodge', 'D100', 'Extended Cab Pickup 2-Door'],
    [1977, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1977, 'Dodge', 'D150', 'Extended Cab Pickup 2-Door'],
    [1977, 'Dodge', 'D150', 'Standard Cab Pickup 2-Door'],
    [1977, 'Dodge', 'D200', 'Crew Cab Pickup 4-Door'],
    [1977, 'Dodge', 'D200', 'Extended Cab Pickup 2-Door'],
    [1977, 'Dodge', 'D200', 'Standard Cab Pickup 2-Door'],
    [1977, 'Dodge', 'D300', 'Crew Cab Pickup 4-Door'],
    [1977, 'Dodge', 'D300', 'Extended Cab Pickup 2-Door'],
    [1977, 'Dodge', 'D300', 'Standard Cab Pickup 2-Door'],
    [1977, 'Dodge', 'Diplomat', 'Coupe 2-Door'],
    [1977, 'Dodge', 'Diplomat', 'Sedan 4-Door'],
    [1977, 'Dodge', 'Monaco', 'Hardtop 2-Door'],
    [1977, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1977, 'Dodge', 'Monaco', 'Wagon 4-Door'],
    [1977, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1977, 'Dodge', 'Royal Monaco', 'Hardtop 2-Door'],
    [1977, 'Dodge', 'Royal Monaco', 'Sedan 4-Door'],
    [1977, 'Dodge', 'Royal Monaco', 'Wagon 4-Door'],
    [1977, 'Dodge', 'W100', 'Extended Cab Pickup 2-Door'],
    [1977, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1977, 'Dodge', 'W150', 'Extended Cab Pickup 2-Door'],
    [1977, 'Dodge', 'W150', 'Standard Cab Pickup 2-Door'],
    [1977, 'Dodge', 'W200', 'Crew Cab Pickup 4-Door'],
    [1977, 'Dodge', 'W200', 'Extended Cab Pickup 2-Door'],
    [1977, 'Dodge', 'W200', 'Standard Cab Pickup 2-Door'],
    [1977, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1977, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1977, 'Ferrari', '308 GTS', 'Coupe 2-Door'],
    [1977, 'Ferrari', '512 BB', 'Coupe 2-Door'],
    [1977, 'Ferrari', 'Dino 308 GT4', 'Coupe 2-Door'],
    [1977, 'Fiat', '124', 'Convertible 2-Door'],
    [1977, 'Fiat', '128', 'Coupe 2-Door'],
    [1977, 'Fiat', '128', 'Coupe 3-Door'],
    [1977, 'Fiat', '128', 'Sedan 2-Door'],
    [1977, 'Fiat', '128', 'Sedan 4-Door'],
    [1977, 'Fiat', '128', 'Wagon 2-Door'],
    [1977, 'Fiat', '131', 'Sedan 2-Door'],
    [1977, 'Fiat', '131', 'Sedan 4-Door'],
    [1977, 'Fiat', '131', 'Wagon 4-Door'],
    [1977, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1977, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1977, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1977, 'Ford', 'Custom 500', 'Hardtop 2-Door'],
    [1977, 'Ford', 'Custom 500', 'Hardtop 4-Door'],
    [1977, 'Ford', 'Custom 500', 'Wagon 4-Door'],
    [1977, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1977, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1977, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1977, 'Ford', 'E-150 Econoline', 'Extended Cargo Van 2-Door'],
    [1977, 'Ford', 'E-150 Econoline', 'Extended Passenger Van 2-Door'],
    [1977, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1977, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1977, 'Ford', 'E-150 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1977, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1977, 'Ford', 'E-250 Econoline', 'Extended Cargo Van 2-Door'],
    [1977, 'Ford', 'E-250 Econoline', 'Extended Passenger Van 2-Door'],
    [1977, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1977, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1977, 'Ford', 'E-250 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1977, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1977, 'Ford', 'E-350 Econoline', 'Extended Cargo Van 2-Door'],
    [1977, 'Ford', 'E-350 Econoline', 'Extended Passenger Van 2-Door'],
    [1977, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1977, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1977, 'Ford', 'E-350 Econoline Club Wagon', 'Extended Passenger Van 2-Door'],
    [1977, 'Ford', 'F-100', 'Extended Cab Pickup 2-Door'],
    [1977, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1977, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1977, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1977, 'Ford', 'F-250', 'Crew Cab Pickup 4-Door'],
    [1977, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1977, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1977, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1977, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1977, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1977, 'Ford', 'Granada', 'Sedan 2-Door'],
    [1977, 'Ford', 'Granada', 'Sedan 4-Door'],
    [1977, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1977, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1977, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1977, 'Ford', 'LTD II', 'Hardtop 2-Door'],
    [1977, 'Ford', 'LTD II', 'Hardtop 4-Door'],
    [1977, 'Ford', 'LTD II', 'Wagon 4-Door'],
    [1977, 'Ford', 'Maverick', 'Sedan 2-Door'],
    [1977, 'Ford', 'Maverick', 'Sedan 4-Door'],
    [1977, 'Ford', 'Mustang II', 'Hardtop 2-Door'],
    [1977, 'Ford', 'Mustang II', 'Hardtop 3-Door'],
    [1977, 'Ford', 'Pinto', 'Sedan 2-Door'],
    [1977, 'Ford', 'Pinto', 'Sedan 3-Door'],
    [1977, 'Ford', 'Pinto', 'Wagon 2-Door'],
    [1977, 'Ford', 'Ranchero', 'Standard Cab Pickup 2-Door'],
    [1977, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1977, 'GMC', 'C15', 'Standard Cab Pickup 2-Door'],
    [1977, 'GMC', 'C15 Suburban', 'SUV 4-Door'],
    [1977, 'GMC', 'C25', 'Crew Cab Pickup 4-Door'],
    [1977, 'GMC', 'C25', 'Standard Cab Pickup 2-Door'],
    [1977, 'GMC', 'C25 Suburban', 'SUV 4-Door'],
    [1977, 'GMC', 'C35', 'Crew Cab Pickup 4-Door'],
    [1977, 'GMC', 'C35', 'Standard Cab Pickup 2-Door'],
    [1977, 'GMC', 'G15', 'Extended Cargo Van 3-Door'],
    [1977, 'GMC', 'G15', 'Extended Passenger Van 3-Door'],
    [1977, 'GMC', 'G15', 'Standard Cargo Van 3-Door'],
    [1977, 'GMC', 'G15', 'Standard Passenger Van 3-Door'],
    [1977, 'GMC', 'G25', 'Extended Cargo Van 3-Door'],
    [1977, 'GMC', 'G25', 'Extended Passenger Van 3-Door'],
    [1977, 'GMC', 'G25', 'Standard Cargo Van 3-Door'],
    [1977, 'GMC', 'G25', 'Standard Passenger Van 3-Door'],
    [1977, 'GMC', 'G35', 'Extended Cargo Van 3-Door'],
    [1977, 'GMC', 'G35', 'Standard Cargo Van 3-Door'],
    [1977, 'GMC', 'G35', 'Standard Passenger Van 3-Door'],
    [1977, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1977, 'GMC', 'K15', 'Standard Cab Pickup 2-Door'],
    [1977, 'GMC', 'K15 Suburban', 'SUV 4-Door'],
    [1977, 'GMC', 'K25', 'Standard Cab Pickup 2-Door'],
    [1977, 'GMC', 'K25 Suburban', 'SUV 4-Door'],
    [1977, 'GMC', 'K35', 'Crew Cab Pickup 4-Door'],
    [1977, 'GMC', 'K35', 'Extended Cab Pickup 2-Door'],
    [1977, 'GMC', 'K35', 'Standard Cab Pickup 2-Door'],
    [1977, 'GMC', 'Sprint', 'Standard Cab Pickup 2-Door'],
    [1977, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1977, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1977, 'Honda', 'Civic', 'Sedan 2-Door'],
    [1977, 'Honda', 'Civic', 'Sedan 3-Door'],
    [1977, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1977, 'International Harvester', 'Scout II', 'Standard Cab Pickup 2-Door'],
    [1977, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1977, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1977, 'Jaguar', 'XJ6', 'Coupe 2-Door'],
    [1977, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1977, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1977, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1977, 'Jeep', 'Cherokee', 'SUV 4-Door'],
    [1977, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1977, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1977, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1977, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1977, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1977, 'Lamborghini', 'Espada', 'Coupe 2-Door'],
    [1977, 'Lamborghini', 'Silhouette', 'Coupe 2-Door'],
    [1977, 'Lancia', 'Beta', 'Coupe 2-Door'],
    [1977, 'Lancia', 'Beta', 'Sedan 4-Door'],
    [1977, 'Lancia', 'Beta', 'Wagon 2-Door'],
    [1977, 'Lincoln', 'Continental', 'Hardtop 2-Door'],
    [1977, 'Lincoln', 'Continental', 'Hardtop 4-Door'],
    [1977, 'Lincoln', 'Mark V', 'Coupe 2-Door'],
    [1977, 'Lincoln', 'Versailles', 'Sedan 4-Door'],
    [1977, 'Lotus', 'Eclat', 'Hatchback 2-Door'],
    [1977, 'Lotus', 'Elite', 'Hatchback 2-Door'],
    [1977, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1977, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1977, 'Maserati', 'Khamsin', 'Coupe 2-Door'],
    [1977, 'Maserati', 'Merak', 'Coupe 2-Door'],
    [1977, 'Mazda', '808', 'Coupe 2-Door'],
    [1977, 'Mazda', '808', 'Sedan 4-Door'],
    [1977, 'Mazda', '808', 'Wagon 4-Door'],
    [1977, 'Mazda', 'B1800', 'Standard Cab Pickup 2-Door'],
    [1977, 'Mazda', 'Cosmo', 'Coupe 2-Door'],
    [1977, 'Mazda', 'GLC', 'Hatchback 2-Door'],
    [1977, 'Mazda', 'Mizer', 'Coupe 2-Door'],
    [1977, 'Mazda', 'Mizer', 'Sedan 4-Door'],
    [1977, 'Mazda', 'Mizer', 'Wagon 4-Door'],
    [1977, 'Mazda', 'Rotary Pickup', 'Standard Cab Pickup 2-Door'],
    [1977, 'Mazda', 'RX-3', 'Coupe 2-Door'],
    [1977, 'Mazda', 'RX-4', 'Sedan 4-Door'],
    [1977, 'Mazda', 'RX-4', 'Wagon 4-Door'],
    [1977, 'Mercedes-Benz', '230', 'Sedan 4-Door'],
    [1977, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1977, 'Mercedes-Benz', '280E', 'Sedan 4-Door'],
    [1977, 'Mercedes-Benz', '280SE', 'Sedan 4-Door'],
    [1977, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1977, 'Mercedes-Benz', '450SEL', 'Sedan 4-Door'],
    [1977, 'Mercedes-Benz', '450SL', 'Convertible 2-Door'],
    [1977, 'Mercedes-Benz', '450SLC', 'Coupe 2-Door'],
    [1977, 'Mercury', 'Bobcat', 'Sedan 3-Door'],
    [1977, 'Mercury', 'Bobcat', 'Wagon 2-Door'],
    [1977, 'Mercury', 'Capri', 'Coupe 2-Door'],
    [1977, 'Mercury', 'Comet', 'Sedan 2-Door'],
    [1977, 'Mercury', 'Comet', 'Sedan 4-Door'],
    [1977, 'Mercury', 'Cougar', 'Hardtop 2-Door'],
    [1977, 'Mercury', 'Cougar', 'Hardtop 4-Door'],
    [1977, 'Mercury', 'Cougar', 'Wagon 4-Door'],
    [1977, 'Mercury', 'Grand Marquis', 'Hardtop 2-Door'],
    [1977, 'Mercury', 'Grand Marquis', 'Hardtop 4-Door'],
    [1977, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1977, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1977, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1977, 'Mercury', 'Monarch', 'Sedan 2-Door'],
    [1977, 'Mercury', 'Monarch', 'Sedan 4-Door'],
    [1977, 'MG', 'MGB', 'Convertible 2-Door'],
    [1977, 'MG', 'Midget', 'Convertible 2-Door'],
    [1977, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1977, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1977, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1977, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1977, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1977, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1977, 'Oldsmobile', 'Cutlass', 'Wagon 4-Door'],
    [1977, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1977, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1977, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1977, 'Oldsmobile', 'Cutlass Supreme', 'Wagon 4-Door'],
    [1977, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1977, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1977, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1977, 'Oldsmobile', 'Omega', 'Hatchback 2-Door'],
    [1977, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1977, 'Oldsmobile', 'Starfire', 'Hatchback 2-Door'],
    [1977, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1977, 'Peugeot', '504', 'Sedan 4-Door'],
    [1977, 'Peugeot', '504', 'Wagon 4-Door'],
    [1977, 'Peugeot', '604', 'Sedan 4-Door'],
    [1977, 'Plymouth', 'Arrow', 'Hatchback 2-Door'],
    [1977, 'Plymouth', 'Colt', 'Coupe 2-Door'],
    [1977, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1977, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1977, 'Plymouth', 'Fury', 'Hardtop 2-Door'],
    [1977, 'Plymouth', 'Fury', 'Sedan 4-Door'],
    [1977, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1977, 'Plymouth', 'Gran Fury', 'Hardtop 2-Door'],
    [1977, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1977, 'Plymouth', 'Gran Fury', 'Wagon 4-Door'],
    [1977, 'Plymouth', 'PB100', 'Standard Passenger Van 3-Door'],
    [1977, 'Plymouth', 'PB200', 'Extended Passenger Van 3-Door'],
    [1977, 'Plymouth', 'PB200', 'Standard Passenger Van 3-Door'],
    [1977, 'Plymouth', 'PB300', 'Extended Passenger Van 3-Door'],
    [1977, 'Plymouth', 'PB300', 'Standard Passenger Van 3-Door'],
    [1977, 'Plymouth', 'Trailduster', 'SUV 2-Door'],
    [1977, 'Plymouth', 'Volare', 'Coupe 2-Door'],
    [1977, 'Plymouth', 'Volare', 'Sedan 4-Door'],
    [1977, 'Plymouth', 'Volare', 'Wagon 4-Door'],
    [1977, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1977, 'Pontiac', 'Astre', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Astre', 'Hatchback 2-Door'],
    [1977, 'Pontiac', 'Astre', 'Wagon 2-Door'],
    [1977, 'Pontiac', 'Bonneville', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1977, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1977, 'Pontiac', 'Catalina', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1977, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1977, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Grand LeMans', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1977, 'Pontiac', 'Grand LeMans', 'Wagon 4-Door'],
    [1977, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Grand Safari', 'Wagon 4-Door'],
    [1977, 'Pontiac', 'Laurentian', 'Sedan 4-Door'],
    [1977, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1977, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1977, 'Pontiac', 'Parisienne', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1977, 'Pontiac', 'Phoenix', 'Sedan 2-Door'],
    [1977, 'Pontiac', 'Phoenix', 'Sedan 4-Door'],
    [1977, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Sunbird', 'Hatchback 2-Door'],
    [1977, 'Pontiac', 'Ventura', 'Coupe 2-Door'],
    [1977, 'Pontiac', 'Ventura', 'Hatchback 2-Door'],
    [1977, 'Pontiac', 'Ventura', 'Sedan 4-Door'],
    [1977, 'Porsche', '911', 'Coupe 2-Door'],
    [1977, 'Porsche', '911', 'Targa 2-Door'],
    [1977, 'Porsche', '924', 'Coupe 2-Door'],
    [1977, 'Renault', 'LeCar', 'Hatchback 2-Door'],
    [1977, 'Renault', 'R12', 'Sedan 4-Door'],
    [1977, 'Renault', 'R12', 'Wagon 4-Door'],
    [1977, 'Renault', 'R17', 'Coupe 2-Door'],
    [1977, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1977, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1977, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1977, 'Rolls-Royce', 'Silver Shadow II', 'Sedan 4-Door'],
    [1977, 'Rolls-Royce', 'Silver Wraith II', 'Sedan 4-Door'],
    [1977, 'Saab', '99', 'Coupe 2-Door'],
    [1977, 'Saab', '99', 'Hatchback 2-Door'],
    [1977, 'Saab', '99', 'Sedan 2-Door'],
    [1977, 'Saab', '99', 'Sedan 4-Door'],
    [1977, 'Saab', '99', 'Wagon 4-Door'],
    [1977, 'Subaru', 'DL', 'Coupe 2-Door'],
    [1977, 'Subaru', 'DL', 'Sedan 2-Door'],
    [1977, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1977, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1977, 'Subaru', 'GF', 'Hardtop 2-Door'],
    [1977, 'Subaru', 'Standard', 'Sedan 2-Door'],
    [1977, 'Toyota', 'Celica', 'Hardtop 2-Door'],
    [1977, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1977, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1977, 'Toyota', 'Corolla', 'Hardtop 2-Door'],
    [1977, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1977, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1977, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1977, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1977, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1977, 'Toyota', 'Corona', 'Sedan 2-Door'],
    [1977, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1977, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1977, 'Toyota', 'Land Cruiser', 'Standard Cab Pickup 2-Door'],
    [1977, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1977, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1977, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1977, 'Triumph', 'Spitfire', 'Convertible 2-Door'],
    [1977, 'Triumph', 'TR7', 'Coupe 2-Door'],
    [1977, 'TVR', '2500M', 'Coupe 2-Door'],
    [1977, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1977, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1977, 'Volkswagen', 'Dasher', 'Hatchback 2-Door'],
    [1977, 'Volkswagen', 'Dasher', 'Hatchback 4-Door'],
    [1977, 'Volkswagen', 'Dasher', 'Wagon 4-Door'],
    [1977, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1977, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1977, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1977, 'Volkswagen', 'Super Beetle', 'Convertible 2-Door'],
    [1977, 'Volkswagen', 'Super Beetle', 'Sedan 2-Door'],
    [1977, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1977, 'Volkswagen', 'Transporter', 'Van Camper 3-Door'],
    [1977, 'Volvo', '242', 'Sedan 2-Door'],
    [1977, 'Volvo', '244', 'Sedan 4-Door'],
    [1977, 'Volvo', '245', 'Wagon 4-Door'],
    [1977, 'Volvo', '264', 'Sedan 4-Door'],
    [1977, 'Volvo', '265', 'Wagon 4-Door'],
    [1976, 'Alfa Romeo', 'Alfetta', 'Coupe 2-Door'],
    [1976, 'Alfa Romeo', 'Alfetta', 'Sedan 4-Door'],
    [1976, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1976, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1976, 'AMC', 'Hornet', 'Hatchback 2-Door'],
    [1976, 'AMC', 'Hornet', 'Sedan 2-Door'],
    [1976, 'AMC', 'Hornet', 'Sedan 4-Door'],
    [1976, 'AMC', 'Hornet', 'Wagon 4-Door'],
    [1976, 'AMC', 'Matador', 'Coupe 2-Door'],
    [1976, 'AMC', 'Matador', 'Sedan 4-Door'],
    [1976, 'AMC', 'Matador', 'Wagon 4-Door'],
    [1976, 'AMC', 'Pacer', 'Hatchback 2-Door'],
    [1976, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1976, 'Audi', '100 Series', 'Sedan 2-Door'],
    [1976, 'Audi', '100 Series', 'Sedan 4-Door'],
    [1976, 'Audi', 'Fox', 'Sedan 2-Door'],
    [1976, 'Audi', 'Fox', 'Sedan 4-Door'],
    [1976, 'Audi', 'Fox', 'Wagon 4-Door'],
    [1976, 'Avanti', 'II', 'Coupe 2-Door'],
    [1976, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1976, 'Bentley', 'Corniche', 'Coupe 2-Door'],
    [1976, 'Bentley', 'T1 Series', 'Sedan 4-Door'],
    [1976, 'BMW', '2002', 'Coupe 2-Door'],
    [1976, 'BMW', '3.0Si', 'Sedan 4-Door'],
    [1976, 'BMW', '530i', 'Sedan 4-Door'],
    [1976, 'Bricklin', 'SV-1', 'Coupe 2-Door'],
    [1976, 'Buick', 'Century', 'Coupe 2-Door'],
    [1976, 'Buick', 'Century', 'Sedan 4-Door'],
    [1976, 'Buick', 'Century', 'Wagon 4-Door'],
    [1976, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1976, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1976, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1976, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1976, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1976, 'Buick', 'Opel', 'Coupe 2-Door'],
    [1976, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1976, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1976, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1976, 'Buick', 'Skyhawk', 'Hatchback 2-Door'],
    [1976, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1976, 'Buick', 'Skylark', 'Hatchback 2-Door'],
    [1976, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1976, 'Cadillac', 'Calais', 'Coupe 2-Door'],
    [1976, 'Cadillac', 'Calais', 'Sedan 4-Door'],
    [1976, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1976, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1976, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1976, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1976, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1976, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1976, 'Cadillac', 'Seville', 'Sedan 4-Door'],
    [1976, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1976, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1976, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1976, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1976, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1976, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1976, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1976, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1976, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1976, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1976, 'Chevrolet', 'Chevette', 'Hatchback 2-Door'],
    [1976, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1976, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1976, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1976, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1976, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1976, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1976, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1976, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1976, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1976, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1976, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1976, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1976, 'Chevrolet', 'Impala', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1976, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1976, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1976, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1976, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1976, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1976, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1976, 'Chevrolet', 'Laguna', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'LUV', 'Standard Cab Pickup 2-Door'],
    [1976, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1976, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1976, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'Monza', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'Monza', 'Hatchback 2-Door'],
    [1976, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'Nova', 'Hatchback 2-Door'],
    [1976, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1976, 'Chevrolet', 'P10', 'Standard Cargo Van 2-Door'],
    [1976, 'Chevrolet', 'Vega', 'Coupe 2-Door'],
    [1976, 'Chevrolet', 'Vega', 'Hatchback 2-Door'],
    [1976, 'Chevrolet', 'Vega', 'Wagon 2-Door'],
    [1976, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1976, 'Chrysler', 'New Yorker', 'Hardtop 2-Door'],
    [1976, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1976, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1976, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1976, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1976, 'Chrysler', 'Town & Country', 'Wagon 5-Door'],
    [1976, 'Datsun', '610', 'Coupe 2-Door'],
    [1976, 'Datsun', '610', 'Sedan 4-Door'],
    [1976, 'Datsun', '610', 'Wagon 4-Door'],
    [1976, 'Datsun', '620', 'Extended Cab Pickup 2-Door'],
    [1976, 'Datsun', '620', 'Standard Cab Pickup 2-Door'],
    [1976, 'Datsun', '710', 'Hardtop 2-Door'],
    [1976, 'Datsun', '710', 'Sedan 2-Door'],
    [1976, 'Datsun', '710', 'Sedan 4-Door'],
    [1976, 'Datsun', '710', 'Wagon 4-Door'],
    [1976, 'Datsun', '280Z', 'Coupe 2-Door'],
    [1976, 'Datsun', 'B210', 'Coupe 2-Door'],
    [1976, 'Datsun', 'B210', 'Sedan 2-Door'],
    [1976, 'Datsun', 'B210', 'Sedan 4-Door'],
    [1976, 'Datsun', 'F10', 'Hatchback 2-Door'],
    [1976, 'Datsun', 'F10', 'Sedan 2-Door'],
    [1976, 'Datsun', 'F10', 'Wagon 2-Door'],
    [1976, 'Dodge', 'Aspen', 'Coupe 2-Door'],
    [1976, 'Dodge', 'Aspen', 'Sedan 4-Door'],
    [1976, 'Dodge', 'Aspen', 'Wagon 4-Door'],
    [1976, 'Dodge', 'B100', 'Standard Cargo Van 3-Door'],
    [1976, 'Dodge', 'B100', 'Standard Passenger Van 3-Door'],
    [1976, 'Dodge', 'B200', 'Standard Cargo Van 3-Door'],
    [1976, 'Dodge', 'B200', 'Standard Passenger Van 3-Door'],
    [1976, 'Dodge', 'B300', 'Extended Cargo Van 3-Door'],
    [1976, 'Dodge', 'B300', 'Standard Cargo Van 3-Door'],
    [1976, 'Dodge', 'Charger', 'Coupe 2-Door'],
    [1976, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1976, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1976, 'Dodge', 'Colt', 'Hardtop 2-Door'],
    [1976, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1976, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1976, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1976, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1976, 'Dodge', 'D100', 'Extended Cab Pickup 2-Door'],
    [1976, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1976, 'Dodge', 'D200', 'Crew Cab Pickup 4-Door'],
    [1976, 'Dodge', 'D200', 'Extended Cab Pickup 2-Door'],
    [1976, 'Dodge', 'D200', 'Standard Cab Pickup 2-Door'],
    [1976, 'Dodge', 'D300', 'Crew Cab Pickup 4-Door'],
    [1976, 'Dodge', 'D300', 'Extended Cab Pickup 2-Door'],
    [1976, 'Dodge', 'D300', 'Standard Cab Pickup 2-Door'],
    [1976, 'Dodge', 'Dart', 'Coupe 2-Door'],
    [1976, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1976, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1976, 'Dodge', 'Monaco', 'Hardtop 2-Door'],
    [1976, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1976, 'Dodge', 'Monaco', 'Wagon 4-Door'],
    [1976, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1976, 'Dodge', 'Royal Monaco', 'Hardtop 2-Door'],
    [1976, 'Dodge', 'Royal Monaco', 'Sedan 4-Door'],
    [1976, 'Dodge', 'Royal Monaco', 'Wagon 4-Door'],
    [1976, 'Dodge', 'W100', 'Extended Cab Pickup 2-Door'],
    [1976, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1976, 'Dodge', 'W200', 'Crew Cab Pickup 4-Door'],
    [1976, 'Dodge', 'W200', 'Extended Cab Pickup 2-Door'],
    [1976, 'Dodge', 'W200', 'Standard Cab Pickup 2-Door'],
    [1976, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1976, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1976, 'Ferrari', '365 GT4', 'Coupe 2-Door'],
    [1976, 'Ferrari', 'Dino 308 GT4', 'Coupe 2-Door'],
    [1976, 'Fiat', '124', 'Convertible 2-Door'],
    [1976, 'Fiat', '128', 'Coupe 2-Door'],
    [1976, 'Fiat', '128', 'Coupe 3-Door'],
    [1976, 'Fiat', '128', 'Sedan 2-Door'],
    [1976, 'Fiat', '128', 'Sedan 4-Door'],
    [1976, 'Fiat', '128', 'Wagon 2-Door'],
    [1976, 'Fiat', '131', 'Coupe 2-Door'],
    [1976, 'Fiat', '131', 'Sedan 4-Door'],
    [1976, 'Fiat', '131', 'Wagon 4-Door'],
    [1976, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1976, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1976, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1976, 'Ford', 'Custom 500', 'Hardtop 2-Door'],
    [1976, 'Ford', 'Custom 500', 'Hardtop 4-Door'],
    [1976, 'Ford', 'Custom 500', 'Wagon 4-Door'],
    [1976, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1976, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1976, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1976, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1976, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1976, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1976, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1976, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1976, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1976, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1976, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1976, 'Ford', 'Elite', 'Hardtop 2-Door'],
    [1976, 'Ford', 'F-100', 'Extended Cab Pickup 2-Door'],
    [1976, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1976, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1976, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1976, 'Ford', 'F-250', 'Crew Cab Pickup 4-Door'],
    [1976, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1976, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1976, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1976, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1976, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1976, 'Ford', 'Gran Torino', 'Hardtop 2-Door'],
    [1976, 'Ford', 'Gran Torino', 'Hardtop 4-Door'],
    [1976, 'Ford', 'Gran Torino', 'Wagon 4-Door'],
    [1976, 'Ford', 'Granada', 'Sedan 2-Door'],
    [1976, 'Ford', 'Granada', 'Sedan 4-Door'],
    [1976, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1976, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1976, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1976, 'Ford', 'Maverick', 'Sedan 2-Door'],
    [1976, 'Ford', 'Maverick', 'Sedan 4-Door'],
    [1976, 'Ford', 'Mustang II', 'Hardtop 2-Door'],
    [1976, 'Ford', 'Mustang II', 'Hardtop 3-Door'],
    [1976, 'Ford', 'Pinto', 'Sedan 2-Door'],
    [1976, 'Ford', 'Pinto', 'Sedan 3-Door'],
    [1976, 'Ford', 'Pinto', 'Wagon 2-Door'],
    [1976, 'Ford', 'Ranchero', 'Standard Cab Pickup 2-Door'],
    [1976, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1976, 'Ford', 'Torino', 'Hardtop 2-Door'],
    [1976, 'Ford', 'Torino', 'Hardtop 4-Door'],
    [1976, 'Ford', 'Torino', 'Wagon 4-Door'],
    [1976, 'GMC', 'C15', 'Standard Cab Pickup 2-Door'],
    [1976, 'GMC', 'C15 Suburban', 'SUV 4-Door'],
    [1976, 'GMC', 'C25', 'Crew Cab Pickup 4-Door'],
    [1976, 'GMC', 'C25', 'Standard Cab Pickup 2-Door'],
    [1976, 'GMC', 'C25 Suburban', 'SUV 4-Door'],
    [1976, 'GMC', 'C35', 'Crew Cab Pickup 4-Door'],
    [1976, 'GMC', 'C35', 'Standard Cab Pickup 2-Door'],
    [1976, 'GMC', 'G15', 'Extended Cargo Van 3-Door'],
    [1976, 'GMC', 'G15', 'Extended Passenger Van 3-Door'],
    [1976, 'GMC', 'G15', 'Standard Cargo Van 3-Door'],
    [1976, 'GMC', 'G15', 'Standard Passenger Van 3-Door'],
    [1976, 'GMC', 'G25', 'Extended Cargo Van 3-Door'],
    [1976, 'GMC', 'G25', 'Extended Passenger Van 3-Door'],
    [1976, 'GMC', 'G25', 'Standard Cargo Van 3-Door'],
    [1976, 'GMC', 'G25', 'Standard Passenger Van 3-Door'],
    [1976, 'GMC', 'G35', 'Extended Cargo Van 3-Door'],
    [1976, 'GMC', 'G35', 'Standard Cargo Van 3-Door'],
    [1976, 'GMC', 'G35', 'Standard Passenger Van 3-Door'],
    [1976, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1976, 'GMC', 'K15', 'Standard Cab Pickup 2-Door'],
    [1976, 'GMC', 'K15 Suburban', 'SUV 4-Door'],
    [1976, 'GMC', 'K25', 'Standard Cab Pickup 2-Door'],
    [1976, 'GMC', 'K25 Suburban', 'SUV 4-Door'],
    [1976, 'GMC', 'Sprint', 'Standard Cab Pickup 2-Door'],
    [1976, 'Honda', 'Accord', 'Hatchback 2-Door'],
    [1976, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1976, 'Honda', 'Civic', 'Sedan 2-Door'],
    [1976, 'Honda', 'Civic', 'Sedan 3-Door'],
    [1976, 'Honda', 'Civic', 'Wagon 4-Door'],
    [1976, 'International Harvester', 'Scout II', 'Standard Cab Pickup 2-Door'],
    [1976, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1976, 'Jaguar', 'XJ12', 'Coupe 2-Door'],
    [1976, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1976, 'Jaguar', 'XJ6', 'Coupe 2-Door'],
    [1976, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1976, 'Jaguar', 'XJS', 'Coupe 2-Door'],
    [1976, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1976, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1976, 'Jeep', 'CJ7', 'SUV 2-Door'],
    [1976, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1976, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1976, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1976, 'Jensen', 'Healey', 'Coupe 2-Door'],
    [1976, 'Jensen', 'Interceptor', 'Convertible 2-Door'],
    [1976, 'Jensen', 'Interceptor', 'Coupe 2-Door'],
    [1976, 'Jensen', 'Interceptor', 'Sedan 2-Door'],
    [1976, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1976, 'Lamborghini', 'Espada', 'Coupe 2-Door'],
    [1976, 'Lamborghini', 'Jarama', 'Coupe 2-Door'],
    [1976, 'Lamborghini', 'Silhouette', 'Coupe 2-Door'],
    [1976, 'Lamborghini', 'Urraco', 'Coupe 2-Door'],
    [1976, 'Lancia', 'Beta', 'Coupe 2-Door'],
    [1976, 'Lancia', 'Beta', 'Sedan 4-Door'],
    [1976, 'Lancia', 'Beta', 'Wagon 2-Door'],
    [1976, 'Lancia', 'Scorpion', 'Coupe 2-Door'],
    [1976, 'Lincoln', 'Continental', 'Hardtop 2-Door'],
    [1976, 'Lincoln', 'Continental', 'Hardtop 4-Door'],
    [1976, 'Lincoln', 'Mark IV', 'Coupe 2-Door'],
    [1976, 'Lotus', 'Eclat', 'Hatchback 2-Door'],
    [1976, 'Lotus', 'Elite', 'Hatchback 2-Door'],
    [1976, 'Lotus', 'Esprit', 'Coupe 2-Door'],
    [1976, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1976, 'Maserati', 'Khamsin', 'Coupe 2-Door'],
    [1976, 'Maserati', 'Merak', 'Coupe 2-Door'],
    [1976, 'Mazda', '808', 'Coupe 2-Door'],
    [1976, 'Mazda', '808', 'Wagon 4-Door'],
    [1976, 'Mazda', 'B1600', 'Standard Cab Pickup 2-Door'],
    [1976, 'Mazda', 'Cosmo', 'Coupe 2-Door'],
    [1976, 'Mazda', 'Mizer', 'Coupe 2-Door'],
    [1976, 'Mazda', 'Mizer', 'Sedan 4-Door'],
    [1976, 'Mazda', 'Mizer', 'Wagon 4-Door'],
    [1976, 'Mazda', 'Rotary Pickup', 'Standard Cab Pickup 2-Door'],
    [1976, 'Mazda', 'RX-3', 'Coupe 2-Door'],
    [1976, 'Mazda', 'RX-3', 'Wagon 4-Door'],
    [1976, 'Mazda', 'RX-4', 'Hardtop 2-Door'],
    [1976, 'Mazda', 'RX-4', 'Sedan 4-Door'],
    [1976, 'Mazda', 'RX-4', 'Wagon 4-Door'],
    [1976, 'Mercedes-Benz', '230', 'Sedan 4-Door'],
    [1976, 'Mercedes-Benz', '280', 'Sedan 4-Door'],
    [1976, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1976, 'Mercedes-Benz', '280C', 'Coupe 2-Door'],
    [1976, 'Mercedes-Benz', '280S', 'Sedan 4-Door'],
    [1976, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1976, 'Mercedes-Benz', '450SE', 'Sedan 4-Door'],
    [1976, 'Mercedes-Benz', '450SEL', 'Sedan 4-Door'],
    [1976, 'Mercedes-Benz', '450SL', 'Convertible 2-Door'],
    [1976, 'Mercedes-Benz', '450SLC', 'Coupe 2-Door'],
    [1976, 'Mercury', 'Bobcat', 'Sedan 3-Door'],
    [1976, 'Mercury', 'Bobcat', 'Wagon 2-Door'],
    [1976, 'Mercury', 'Capri', 'Coupe 2-Door'],
    [1976, 'Mercury', 'Comet', 'Sedan 2-Door'],
    [1976, 'Mercury', 'Comet', 'Sedan 4-Door'],
    [1976, 'Mercury', 'Cougar', 'Hardtop 2-Door'],
    [1976, 'Mercury', 'Grand Marquis', 'Hardtop 2-Door'],
    [1976, 'Mercury', 'Grand Marquis', 'Hardtop 4-Door'],
    [1976, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1976, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1976, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1976, 'Mercury', 'Monarch', 'Sedan 2-Door'],
    [1976, 'Mercury', 'Monarch', 'Sedan 4-Door'],
    [1976, 'Mercury', 'Montego', 'Hardtop 2-Door'],
    [1976, 'Mercury', 'Montego', 'Hardtop 4-Door'],
    [1976, 'Mercury', 'Montego', 'Wagon 4-Door'],
    [1976, 'MG', 'MGB', 'Convertible 2-Door'],
    [1976, 'MG', 'MGB', 'Coupe 2-Door'],
    [1976, 'MG', 'Midget', 'Convertible 2-Door'],
    [1976, 'Morgan', 'Plus 8', 'Convertible 2-Door'],
    [1976, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1976, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1976, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1976, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1976, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1976, 'Oldsmobile', 'Cutlass', 'Wagon 4-Door'],
    [1976, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1976, 'Oldsmobile', 'Cutlass Salon', 'Sedan 4-Door'],
    [1976, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1976, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1976, 'Oldsmobile', 'Cutlass Supreme', 'Wagon 4-Door'],
    [1976, 'Oldsmobile', 'Cutlass Tiara', 'Coupe 2-Door'],
    [1976, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1976, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1976, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1976, 'Oldsmobile', 'Omega', 'Hatchback 2-Door'],
    [1976, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1976, 'Oldsmobile', 'Starfire', 'Hatchback 2-Door'],
    [1976, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1976, 'Peugeot', '504', 'Sedan 4-Door'],
    [1976, 'Peugeot', '504', 'Wagon 4-Door'],
    [1976, 'Plymouth', 'Arrow', 'Hatchback 2-Door'],
    [1976, 'Plymouth', 'Colt', 'Coupe 2-Door'],
    [1976, 'Plymouth', 'Colt', 'Sedan 4-Door'],
    [1976, 'Plymouth', 'Colt', 'Wagon 4-Door'],
    [1976, 'Plymouth', 'Duster', 'Coupe 2-Door'],
    [1976, 'Plymouth', 'Fury', 'Hardtop 2-Door'],
    [1976, 'Plymouth', 'Fury', 'Sedan 4-Door'],
    [1976, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1976, 'Plymouth', 'Gran Fury', 'Coupe 2-Door'],
    [1976, 'Plymouth', 'Gran Fury', 'Hardtop 2-Door'],
    [1976, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1976, 'Plymouth', 'Gran Fury', 'Wagon 4-Door'],
    [1976, 'Plymouth', 'PB100', 'Standard Passenger Van 3-Door'],
    [1976, 'Plymouth', 'PB200', 'Extended Passenger Van 3-Door'],
    [1976, 'Plymouth', 'PB200', 'Standard Passenger Van 3-Door'],
    [1976, 'Plymouth', 'PB300', 'Extended Passenger Van 3-Door'],
    [1976, 'Plymouth', 'PB300', 'Standard Passenger Van 3-Door'],
    [1976, 'Plymouth', 'Scamp', 'Hardtop 2-Door'],
    [1976, 'Plymouth', 'Trailduster', 'SUV 2-Door'],
    [1976, 'Plymouth', 'Valiant', 'Sedan 4-Door'],
    [1976, 'Plymouth', 'Volare', 'Coupe 2-Door'],
    [1976, 'Plymouth', 'Volare', 'Sedan 4-Door'],
    [1976, 'Plymouth', 'Volare', 'Wagon 4-Door'],
    [1976, 'Pontiac', 'Acadian', 'Hatchback 2-Door'],
    [1976, 'Pontiac', 'Astre', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Astre', 'Hatchback 2-Door'],
    [1976, 'Pontiac', 'Astre', 'Wagon 2-Door'],
    [1976, 'Pontiac', 'Bonneville', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1976, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1976, 'Pontiac', 'Catalina', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1976, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1976, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Grand LeMans', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1976, 'Pontiac', 'Grand LeMans', 'Wagon 4-Door'],
    [1976, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Grand Safari', 'Wagon 4-Door'],
    [1976, 'Pontiac', 'Laurentian', 'Sedan 4-Door'],
    [1976, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1976, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1976, 'Pontiac', 'Parisienne', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1976, 'Pontiac', 'Sunbird', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Ventura', 'Coupe 2-Door'],
    [1976, 'Pontiac', 'Ventura', 'Hatchback 2-Door'],
    [1976, 'Pontiac', 'Ventura', 'Sedan 4-Door'],
    [1976, 'Porsche', '911', 'Coupe 2-Door'],
    [1976, 'Porsche', '911', 'Targa 2-Door'],
    [1976, 'Porsche', '912', 'Coupe 2-Door'],
    [1976, 'Porsche', '914', 'Coupe 2-Door'],
    [1976, 'Renault', 'R12', 'Sedan 4-Door'],
    [1976, 'Renault', 'R12', 'Wagon 4-Door'],
    [1976, 'Renault', 'R15', 'Coupe 2-Door'],
    [1976, 'Renault', 'R17', 'Coupe 2-Door'],
    [1976, 'Renault', 'R5', 'Hatchback 2-Door'],
    [1976, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1976, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1976, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1976, 'Rolls-Royce', 'Silver Shadow', 'Sedan 4-Door'],
    [1976, 'Saab', '99', 'Coupe 2-Door'],
    [1976, 'Saab', '99', 'Hatchback 2-Door'],
    [1976, 'Saab', '99', 'Sedan 2-Door'],
    [1976, 'Saab', '99', 'Sedan 4-Door'],
    [1976, 'Subaru', 'DL', 'Sedan 2-Door'],
    [1976, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1976, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1976, 'Subaru', 'GF', 'Hardtop 2-Door'],
    [1976, 'Subaru', 'Standard', 'Sedan 2-Door'],
    [1976, 'Toyota', 'Celica', 'Hardtop 2-Door'],
    [1976, 'Toyota', 'Celica', 'Hatchback 2-Door'],
    [1976, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1976, 'Toyota', 'Corolla', 'Hardtop 2-Door'],
    [1976, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1976, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1976, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1976, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1976, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1976, 'Toyota', 'Corona', 'Sedan 2-Door'],
    [1976, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1976, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1976, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1976, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1976, 'Toyota', 'Mark II', 'Sedan 4-Door'],
    [1976, 'Toyota', 'Mark II', 'Wagon 4-Door'],
    [1976, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1976, 'Triumph', 'Spitfire', 'Convertible 2-Door'],
    [1976, 'Triumph', 'TR6', 'Convertible 2-Door'],
    [1976, 'Triumph', 'TR7', 'Coupe 2-Door'],
    [1976, 'TVR', '2500M', 'Coupe 2-Door'],
    [1976, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1976, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1976, 'Volkswagen', 'Dasher', 'Hatchback 2-Door'],
    [1976, 'Volkswagen', 'Dasher', 'Hatchback 4-Door'],
    [1976, 'Volkswagen', 'Dasher', 'Wagon 4-Door'],
    [1976, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1976, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1976, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1976, 'Volkswagen', 'Super Beetle', 'Convertible 2-Door'],
    [1976, 'Volkswagen', 'Super Beetle', 'Sedan 2-Door'],
    [1976, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1976, 'Volkswagen', 'Transporter', 'Van Camper 3-Door'],
    [1976, 'Volvo', '242', 'Sedan 2-Door'],
    [1976, 'Volvo', '244', 'Sedan 4-Door'],
    [1976, 'Volvo', '245', 'Wagon 4-Door'],
    [1976, 'Volvo', '262', 'Coupe 2-Door'],
    [1976, 'Volvo', '264', 'Sedan 4-Door'],
    [1976, 'Volvo', '265', 'Wagon 4-Door'],
    [1975, 'Alfa Romeo', 'Alfetta', 'Coupe 2-Door'],
    [1975, 'Alfa Romeo', 'Alfetta', 'Sedan 4-Door'],
    [1975, 'Alfa Romeo', 'Montreal', 'Coupe 2-Door'],
    [1975, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1975, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1975, 'AMC', 'Hornet', 'Hatchback 2-Door'],
    [1975, 'AMC', 'Hornet', 'Sedan 2-Door'],
    [1975, 'AMC', 'Hornet', 'Sedan 4-Door'],
    [1975, 'AMC', 'Hornet', 'Wagon 4-Door'],
    [1975, 'AMC', 'Matador', 'Coupe 2-Door'],
    [1975, 'AMC', 'Matador', 'Sedan 4-Door'],
    [1975, 'AMC', 'Matador', 'Wagon 4-Door'],
    [1975, 'AMC', 'Pacer', 'Hatchback 2-Door'],
    [1975, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1975, 'Audi', '100 Series', 'Sedan 2-Door'],
    [1975, 'Audi', '100 Series', 'Sedan 4-Door'],
    [1975, 'Audi', 'Fox', 'Sedan 2-Door'],
    [1975, 'Audi', 'Fox', 'Sedan 4-Door'],
    [1975, 'Audi', 'Fox', 'Wagon 4-Door'],
    [1975, 'Austin', 'Marina', 'Sedan 2-Door'],
    [1975, 'Austin', 'Marina', 'Sedan 4-Door'],
    [1975, 'Avanti', 'II', 'Coupe 2-Door'],
    [1975, 'Bentley', 'Corniche', 'Convertible 2-Door'],
    [1975, 'Bentley', 'Corniche', 'Coupe 2-Door'],
    [1975, 'Bentley', 'T1 Series', 'Sedan 4-Door'],
    [1975, 'BMW', '2002', 'Coupe 2-Door'],
    [1975, 'BMW', '3.0Si', 'Sedan 4-Door'],
    [1975, 'BMW', '530i', 'Sedan 4-Door'],
    [1975, 'Bricklin', 'SV-1', 'Coupe 2-Door'],
    [1975, 'Buick', 'Apollo', 'Sedan 4-Door'],
    [1975, 'Buick', 'Century', 'Coupe 2-Door'],
    [1975, 'Buick', 'Century', 'Sedan 4-Door'],
    [1975, 'Buick', 'Century', 'Wagon 4-Door'],
    [1975, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1975, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1975, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1975, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1975, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1975, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1975, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1975, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1975, 'Buick', 'Riviera', 'Coupe 2-Door'],
    [1975, 'Buick', 'Skyhawk', 'Hatchback 2-Door'],
    [1975, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1975, 'Buick', 'Skylark', 'Hatchback 2-Door'],
    [1975, 'Cadillac', 'Calais', 'Coupe 2-Door'],
    [1975, 'Cadillac', 'Calais', 'Sedan 4-Door'],
    [1975, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1975, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1975, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1975, 'Cadillac', 'Eldorado', 'Coupe 2-Door'],
    [1975, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1975, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1975, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1975, 'Checker', 'Marathon', 'Sedan 6-Door'],
    [1975, 'Checker', 'Marathon', 'Sedan 8-Door'],
    [1975, 'Checker', 'Marathon', 'Wagon 6-Door'],
    [1975, 'Checker', 'Marathon', 'Wagon 8-Door'],
    [1975, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1975, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1975, 'Chevrolet', 'C10', 'Standard Cab Pickup 2-Door'],
    [1975, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1975, 'Chevrolet', 'C20', 'Crew Cab Pickup 4-Door'],
    [1975, 'Chevrolet', 'C20', 'Standard Cab Pickup 2-Door'],
    [1975, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1975, 'Chevrolet', 'C30', 'Crew Cab Pickup 4-Door'],
    [1975, 'Chevrolet', 'C30', 'Standard Cab Pickup 2-Door'],
    [1975, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'Caprice', 'Convertible 2-Door'],
    [1975, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1975, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1975, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1975, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1975, 'Chevrolet', 'G10', 'Extended Cargo Van 3-Door'],
    [1975, 'Chevrolet', 'G10', 'Extended Passenger Van 3-Door'],
    [1975, 'Chevrolet', 'G10', 'Standard Cargo Van 3-Door'],
    [1975, 'Chevrolet', 'G10', 'Standard Passenger Van 3-Door'],
    [1975, 'Chevrolet', 'G20', 'Extended Cargo Van 3-Door'],
    [1975, 'Chevrolet', 'G20', 'Extended Passenger Van 3-Door'],
    [1975, 'Chevrolet', 'G20', 'Standard Cargo Van 3-Door'],
    [1975, 'Chevrolet', 'G20', 'Standard Passenger Van 3-Door'],
    [1975, 'Chevrolet', 'G30', 'Extended Cargo Van 3-Door'],
    [1975, 'Chevrolet', 'G30', 'Standard Cargo Van 3-Door'],
    [1975, 'Chevrolet', 'G30', 'Standard Passenger Van 3-Door'],
    [1975, 'Chevrolet', 'Impala', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1975, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1975, 'Chevrolet', 'K10', 'Standard Cab Pickup 2-Door'],
    [1975, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1975, 'Chevrolet', 'K20', 'Standard Cab Pickup 2-Door'],
    [1975, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1975, 'Chevrolet', 'K5 Blazer', 'SUV 2-Door'],
    [1975, 'Chevrolet', 'Laguna', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'LUV', 'Standard Cab Pickup 2-Door'],
    [1975, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1975, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1975, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'Monza', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'Monza', 'Hatchback 2-Door'],
    [1975, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1975, 'Chevrolet', 'Nova', 'Hatchback 2-Door'],
    [1975, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1975, 'Chevrolet', 'P10', 'Standard Cargo Van 2-Door'],
    [1975, 'Chevrolet', 'Vega', 'Hatchback 2-Door'],
    [1975, 'Chevrolet', 'Vega', 'Wagon 2-Door'],
    [1975, 'Chrysler', 'Cordoba', 'Hardtop 2-Door'],
    [1975, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1975, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1975, 'Chrysler', 'New Yorker', 'Hardtop 2-Door'],
    [1975, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1975, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1975, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1975, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1975, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1975, 'Chrysler', 'Town & Country', 'Wagon 5-Door'],
    [1975, 'Citro�n', 'SM', 'Coupe 2-Door'],
    [1975, 'Datsun', '610', 'Coupe 2-Door'],
    [1975, 'Datsun', '610', 'Sedan 4-Door'],
    [1975, 'Datsun', '610', 'Wagon 4-Door'],
    [1975, 'Datsun', '620', 'Standard Cab Pickup 2-Door'],
    [1975, 'Datsun', '710', 'Hardtop 2-Door'],
    [1975, 'Datsun', '710', 'Sedan 2-Door'],
    [1975, 'Datsun', '710', 'Sedan 4-Door'],
    [1975, 'Datsun', '710', 'Wagon 4-Door'],
    [1975, 'Datsun', '260Z', 'Coupe 2-Door'],
    [1975, 'Datsun', '280Z', 'Coupe 2-Door'],
    [1975, 'Datsun', 'B210', 'Coupe 2-Door'],
    [1975, 'Datsun', 'B210', 'Sedan 2-Door'],
    [1975, 'Datsun', 'B210', 'Sedan 4-Door'],
    [1975, 'Dodge', 'B100', 'Standard Cargo Van 3-Door'],
    [1975, 'Dodge', 'B100', 'Standard Passenger Van 3-Door'],
    [1975, 'Dodge', 'B200', 'Standard Cargo Van 3-Door'],
    [1975, 'Dodge', 'B200', 'Standard Passenger Van 3-Door'],
    [1975, 'Dodge', 'B300', 'Extended Cargo Van 3-Door'],
    [1975, 'Dodge', 'B300', 'Standard Cargo Van 3-Door'],
    [1975, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1975, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1975, 'Dodge', 'Colt', 'Hardtop 2-Door'],
    [1975, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1975, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1975, 'Dodge', 'Coronet', 'Hardtop 2-Door'],
    [1975, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1975, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1975, 'Dodge', 'D100', 'Extended Cab Pickup 2-Door'],
    [1975, 'Dodge', 'D100', 'Standard Cab Pickup 2-Door'],
    [1975, 'Dodge', 'D200', 'Crew Cab Pickup 4-Door'],
    [1975, 'Dodge', 'D200', 'Extended Cab Pickup 2-Door'],
    [1975, 'Dodge', 'D200', 'Standard Cab Pickup 2-Door'],
    [1975, 'Dodge', 'D300', 'Crew Cab Pickup 4-Door'],
    [1975, 'Dodge', 'D300', 'Extended Cab Pickup 2-Door'],
    [1975, 'Dodge', 'D300', 'Standard Cab Pickup 2-Door'],
    [1975, 'Dodge', 'Dart', 'Coupe 2-Door'],
    [1975, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1975, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1975, 'Dodge', 'Monaco', 'Hardtop 2-Door'],
    [1975, 'Dodge', 'Monaco', 'Hardtop 4-Door'],
    [1975, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1975, 'Dodge', 'Monaco', 'Wagon 4-Door'],
    [1975, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1975, 'Dodge', 'Royal Monaco', 'Hardtop 2-Door'],
    [1975, 'Dodge', 'Royal Monaco', 'Hardtop 4-Door'],
    [1975, 'Dodge', 'Royal Monaco', 'Sedan 4-Door'],
    [1975, 'Dodge', 'Royal Monaco', 'Wagon 4-Door'],
    [1975, 'Dodge', 'W100', 'Extended Cab Pickup 2-Door'],
    [1975, 'Dodge', 'W100', 'Standard Cab Pickup 2-Door'],
    [1975, 'Dodge', 'W200', 'Crew Cab Pickup 4-Door'],
    [1975, 'Dodge', 'W200', 'Extended Cab Pickup 2-Door'],
    [1975, 'Dodge', 'W200', 'Standard Cab Pickup 2-Door'],
    [1975, 'Dodge', 'W300', 'Standard Cab Pickup 2-Door'],
    [1975, 'Excalibur', 'Phaeton', 'Convertible 2-Door'],
    [1975, 'Ferrari', '308 GTB', 'Coupe 2-Door'],
    [1975, 'Ferrari', '365 GT4', 'Coupe 2-Door'],
    [1975, 'Ferrari', 'Dino 308 GT4', 'Coupe 2-Door'],
    [1975, 'Fiat', '124', 'Convertible 2-Door'],
    [1975, 'Fiat', '124', 'Coupe 2-Door'],
    [1975, 'Fiat', '128', 'Coupe 2-Door'],
    [1975, 'Fiat', '128', 'Sedan 2-Door'],
    [1975, 'Fiat', '128', 'Sedan 4-Door'],
    [1975, 'Fiat', '128', 'Wagon 2-Door'],
    [1975, 'Fiat', '131', 'Sedan 2-Door'],
    [1975, 'Fiat', '131', 'Sedan 4-Door'],
    [1975, 'Fiat', '131', 'Wagon 4-Door'],
    [1975, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1975, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1975, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1975, 'Ford', 'Custom 500', 'Hardtop 2-Door'],
    [1975, 'Ford', 'Custom 500', 'Hardtop 4-Door'],
    [1975, 'Ford', 'Custom 500', 'Wagon 4-Door'],
    [1975, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1975, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1975, 'Ford', 'E-100 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1975, 'Ford', 'E-150 Econoline', 'Standard Cargo Van 2-Door'],
    [1975, 'Ford', 'E-150 Econoline', 'Standard Passenger Van 2-Door'],
    [1975, 'Ford', 'E-150 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1975, 'Ford', 'E-250 Econoline', 'Standard Cargo Van 2-Door'],
    [1975, 'Ford', 'E-250 Econoline', 'Standard Passenger Van 2-Door'],
    [1975, 'Ford', 'E-250 Econoline Club Wagon', 'Standard Passenger Van 2-Door'],
    [1975, 'Ford', 'E-350 Econoline', 'Standard Cargo Van 2-Door'],
    [1975, 'Ford', 'E-350 Econoline', 'Standard Passenger Van 2-Door'],
    [1975, 'Ford', 'Elite', 'Hardtop 2-Door'],
    [1975, 'Ford', 'F-100', 'Extended Cab Pickup 2-Door'],
    [1975, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1975, 'Ford', 'F-150', 'Extended Cab Pickup 2-Door'],
    [1975, 'Ford', 'F-150', 'Standard Cab Pickup 2-Door'],
    [1975, 'Ford', 'F-250', 'Crew Cab Pickup 4-Door'],
    [1975, 'Ford', 'F-250', 'Extended Cab Pickup 2-Door'],
    [1975, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1975, 'Ford', 'F-350', 'Crew Cab Pickup 4-Door'],
    [1975, 'Ford', 'F-350', 'Extended Cab Pickup 2-Door'],
    [1975, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1975, 'Ford', 'Gran Torino', 'Hardtop 2-Door'],
    [1975, 'Ford', 'Gran Torino', 'Hardtop 4-Door'],
    [1975, 'Ford', 'Gran Torino', 'Wagon 4-Door'],
    [1975, 'Ford', 'Granada', 'Sedan 2-Door'],
    [1975, 'Ford', 'Granada', 'Sedan 4-Door'],
    [1975, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1975, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1975, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1975, 'Ford', 'Maverick', 'Sedan 2-Door'],
    [1975, 'Ford', 'Maverick', 'Sedan 4-Door'],
    [1975, 'Ford', 'Mustang II', 'Hardtop 2-Door'],
    [1975, 'Ford', 'Mustang II', 'Hardtop 3-Door'],
    [1975, 'Ford', 'Pinto', 'Sedan 2-Door'],
    [1975, 'Ford', 'Pinto', 'Sedan 3-Door'],
    [1975, 'Ford', 'Pinto', 'Wagon 2-Door'],
    [1975, 'Ford', 'Ranchero', 'Standard Cab Pickup 2-Door'],
    [1975, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1975, 'Ford', 'Torino', 'Hardtop 2-Door'],
    [1975, 'Ford', 'Torino', 'Hardtop 4-Door'],
    [1975, 'Ford', 'Torino', 'Wagon 4-Door'],
    [1975, 'GMC', 'C15', 'Standard Cab Pickup 2-Door'],
    [1975, 'GMC', 'C15 Suburban', 'SUV 4-Door'],
    [1975, 'GMC', 'C25', 'Crew Cab Pickup 4-Door'],
    [1975, 'GMC', 'C25', 'Standard Cab Pickup 2-Door'],
    [1975, 'GMC', 'C25 Suburban', 'SUV 4-Door'],
    [1975, 'GMC', 'C35', 'Crew Cab Pickup 4-Door'],
    [1975, 'GMC', 'C35', 'Standard Cab Pickup 2-Door'],
    [1975, 'GMC', 'G15', 'Extended Cargo Van 3-Door'],
    [1975, 'GMC', 'G15', 'Extended Passenger Van 3-Door'],
    [1975, 'GMC', 'G15', 'Standard Cargo Van 3-Door'],
    [1975, 'GMC', 'G15', 'Standard Passenger Van 3-Door'],
    [1975, 'GMC', 'G25', 'Extended Cargo Van 3-Door'],
    [1975, 'GMC', 'G25', 'Extended Passenger Van 3-Door'],
    [1975, 'GMC', 'G25', 'Standard Cargo Van 3-Door'],
    [1975, 'GMC', 'G25', 'Standard Passenger Van 3-Door'],
    [1975, 'GMC', 'G35', 'Extended Cargo Van 3-Door'],
    [1975, 'GMC', 'G35', 'Standard Cargo Van 3-Door'],
    [1975, 'GMC', 'G35', 'Standard Passenger Van 3-Door'],
    [1975, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1975, 'GMC', 'K15', 'Standard Cab Pickup 2-Door'],
    [1975, 'GMC', 'K15 Suburban', 'SUV 4-Door'],
    [1975, 'GMC', 'K25', 'Standard Cab Pickup 2-Door'],
    [1975, 'GMC', 'K25 Suburban', 'SUV 4-Door'],
    [1975, 'GMC', 'Sprint', 'Standard Cab Pickup 2-Door'],
    [1975, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1975, 'Honda', 'Civic', 'Sedan 2-Door'],
    [1975, 'Honda', 'Civic', 'Sedan 3-Door'],
    [1975, 'Honda', 'Civic', 'Wagon 2-Door'],
    [1975, 'International Harvester', '150', 'Standard Cab Pickup 2-Door'],
    [1975, 'International Harvester', '200', 'Crew Cab Pickup 4-Door'],
    [1975, 'International Harvester', '200', 'Standard Cab Pickup 2-Door'],
    [1975, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1975, 'International Harvester', 'Travelall', 'SUV 4-Door'],
    [1975, 'Jaguar', 'XJ12', 'Coupe 2-Door'],
    [1975, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1975, 'Jaguar', 'XJ6', 'Coupe 2-Door'],
    [1975, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1975, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1975, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1975, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1975, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1975, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1975, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1975, 'Jensen', 'Healey', 'Convertible 2-Door'],
    [1975, 'Jensen', 'Interceptor', 'Convertible 2-Door'],
    [1975, 'Jensen', 'Interceptor', 'Sedan 2-Door'],
    [1975, 'Lamborghini', 'Countach', 'Coupe 2-Door'],
    [1975, 'Lamborghini', 'Espada', 'Coupe 2-Door'],
    [1975, 'Lamborghini', 'Jarama', 'Coupe 2-Door'],
    [1975, 'Lamborghini', 'Urraco', 'Coupe 2-Door'],
    [1975, 'Lincoln', 'Continental', 'Hardtop 2-Door'],
    [1975, 'Lincoln', 'Continental', 'Hardtop 4-Door'],
    [1975, 'Lincoln', 'Mark IV', 'Coupe 2-Door'],
    [1975, 'Lotus', 'Elan', 'Convertible 2-Door'],
    [1975, 'Lotus', 'Elan', 'Coupe 2-Door'],
    [1975, 'Lotus', 'Elite', 'Hatchback 2-Door'],
    [1975, 'Lotus', 'Europa', 'Coupe 2-Door'],
    [1975, 'Lotus', 'Seven', 'Convertible 2-Door'],
    [1975, 'Maserati', 'Bora', 'Coupe 2-Door'],
    [1975, 'Maserati', 'Khamsin', 'Coupe 2-Door'],
    [1975, 'Maserati', 'Merak', 'Coupe 2-Door'],
    [1975, 'Mazda', '808', 'Coupe 2-Door'],
    [1975, 'Mazda', '808', 'Wagon 4-Door'],
    [1975, 'Mazda', 'B1600', 'Standard Cab Pickup 2-Door'],
    [1975, 'Mazda', 'Rotary Pickup', 'Standard Cab Pickup 2-Door'],
    [1975, 'Mazda', 'RX-3', 'Coupe 2-Door'],
    [1975, 'Mazda', 'RX-3', 'Wagon 4-Door'],
    [1975, 'Mazda', 'RX-4', 'Coupe 2-Door'],
    [1975, 'Mazda', 'RX-4', 'Sedan 4-Door'],
    [1975, 'Mazda', 'RX-4', 'Wagon 4-Door'],
    [1975, 'Mercedes-Benz', '230', 'Sedan 4-Door'],
    [1975, 'Mercedes-Benz', '280', 'Sedan 4-Door'],
    [1975, 'Mercedes-Benz', '240D', 'Sedan 4-Door'],
    [1975, 'Mercedes-Benz', '280C', 'Coupe 2-Door'],
    [1975, 'Mercedes-Benz', '280S', 'Sedan 4-Door'],
    [1975, 'Mercedes-Benz', '300D', 'Sedan 4-Door'],
    [1975, 'Mercedes-Benz', '450SE', 'Sedan 4-Door'],
    [1975, 'Mercedes-Benz', '450SEL', 'Sedan 4-Door'],
    [1975, 'Mercedes-Benz', '450SL', 'Convertible 2-Door'],
    [1975, 'Mercedes-Benz', '450SLC', 'Coupe 2-Door'],
    [1975, 'Mercury', 'Bobcat', 'Sedan 3-Door'],
    [1975, 'Mercury', 'Bobcat', 'Wagon 2-Door'],
    [1975, 'Mercury', 'Capri', 'Coupe 2-Door'],
    [1975, 'Mercury', 'Comet', 'Sedan 2-Door'],
    [1975, 'Mercury', 'Comet', 'Sedan 4-Door'],
    [1975, 'Mercury', 'Cougar', 'Hardtop 2-Door'],
    [1975, 'Mercury', 'Grand Marquis', 'Hardtop 2-Door'],
    [1975, 'Mercury', 'Grand Marquis', 'Hardtop 4-Door'],
    [1975, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1975, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1975, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1975, 'Mercury', 'Monarch', 'Sedan 2-Door'],
    [1975, 'Mercury', 'Monarch', 'Sedan 4-Door'],
    [1975, 'Mercury', 'Montego', 'Hardtop 2-Door'],
    [1975, 'Mercury', 'Montego', 'Hardtop 4-Door'],
    [1975, 'Mercury', 'Montego', 'Wagon 4-Door'],
    [1975, 'MG', 'MGB', 'Convertible 2-Door'],
    [1975, 'MG', 'MGB', 'Coupe 2-Door'],
    [1975, 'MG', 'Midget', 'Convertible 2-Door'],
    [1975, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1975, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1975, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1975, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1975, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1975, 'Oldsmobile', 'Cutlass Salon', 'Coupe 2-Door'],
    [1975, 'Oldsmobile', 'Cutlass Salon', 'Sedan 4-Door'],
    [1975, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1975, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1975, 'Oldsmobile', 'Cutlass Supreme', 'Wagon 4-Door'],
    [1975, 'Oldsmobile', 'Delta 88', 'Convertible 2-Door'],
    [1975, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1975, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1975, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1975, 'Oldsmobile', 'Omega', 'Hatchback 2-Door'],
    [1975, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1975, 'Oldsmobile', 'Starfire', 'Coupe 2-Door'],
    [1975, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1975, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1975, 'Opel', '1900', 'Sedan 2-Door'],
    [1975, 'Opel', '1900', 'Wagon 2-Door'],
    [1975, 'Opel', 'Manta', 'Coupe 2-Door'],
    [1975, 'Peugeot', '504', 'Sedan 4-Door'],
    [1975, 'Peugeot', '504', 'Wagon 4-Door'],
    [1975, 'Plymouth', 'Duster', 'Coupe 2-Door'],
    [1975, 'Plymouth', 'Fury', 'Coupe 2-Door'],
    [1975, 'Plymouth', 'Fury', 'Hardtop 2-Door'],
    [1975, 'Plymouth', 'Fury', 'Sedan 4-Door'],
    [1975, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1975, 'Plymouth', 'Gran Fury', 'Coupe 2-Door'],
    [1975, 'Plymouth', 'Gran Fury', 'Hardtop 2-Door'],
    [1975, 'Plymouth', 'Gran Fury', 'Hardtop 4-Door'],
    [1975, 'Plymouth', 'Gran Fury', 'Sedan 4-Door'],
    [1975, 'Plymouth', 'Gran Fury', 'Wagon 4-Door'],
    [1975, 'Plymouth', 'PB100', 'Standard Passenger Van 3-Door'],
    [1975, 'Plymouth', 'PB200', 'Extended Passenger Van 3-Door'],
    [1975, 'Plymouth', 'PB200', 'Standard Passenger Van 3-Door'],
    [1975, 'Plymouth', 'PB300', 'Extended Passenger Van 3-Door'],
    [1975, 'Plymouth', 'PB300', 'Standard Passenger Van 3-Door'],
    [1975, 'Plymouth', 'Road Runner', 'Hardtop 2-Door'],
    [1975, 'Plymouth', 'Scamp', 'Hardtop 2-Door'],
    [1975, 'Plymouth', 'Trailduster', 'SUV 2-Door'],
    [1975, 'Plymouth', 'Valiant', 'Coupe 2-Door'],
    [1975, 'Plymouth', 'Valiant', 'Hardtop 2-Door'],
    [1975, 'Plymouth', 'Valiant', 'Sedan 4-Door'],
    [1975, 'Pontiac', 'Astre', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'Astre', 'Hatchback 2-Door'],
    [1975, 'Pontiac', 'Astre', 'Wagon 2-Door'],
    [1975, 'Pontiac', 'Bonneville', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1975, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1975, 'Pontiac', 'Catalina', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1975, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1975, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'Grand Am', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'Grand Am', 'Sedan 4-Door'],
    [1975, 'Pontiac', 'Grand LeMans', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'Grand LeMans', 'Sedan 4-Door'],
    [1975, 'Pontiac', 'Grand LeMans', 'Wagon 4-Door'],
    [1975, 'Pontiac', 'Grand Prix', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'Grand Safari', 'Wagon 4-Door'],
    [1975, 'Pontiac', 'Grandville', 'Convertible 2-Door'],
    [1975, 'Pontiac', 'Grandville', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'Grandville', 'Sedan 4-Door'],
    [1975, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1975, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1975, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1975, 'Pontiac', 'Ventura', 'Hatchback 2-Door'],
    [1975, 'Pontiac', 'Ventura', 'Sedan 2-Door'],
    [1975, 'Pontiac', 'Ventura', 'Sedan 4-Door'],
    [1975, 'Porsche', '911', 'Coupe 2-Door'],
    [1975, 'Porsche', '911', 'Targa 2-Door'],
    [1975, 'Porsche', '914', 'Coupe 2-Door'],
    [1975, 'Renault', 'R12', 'Sedan 4-Door'],
    [1975, 'Renault', 'R12', 'Wagon 4-Door'],
    [1975, 'Renault', 'R15', 'Coupe 2-Door'],
    [1975, 'Renault', 'R17', 'Coupe 2-Door'],
    [1975, 'Rolls-Royce', 'Camargue', 'Coupe 2-Door'],
    [1975, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1975, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1975, 'Rolls-Royce', 'Silver Shadow', 'Sedan 4-Door'],
    [1975, 'Saab', '99', 'Hatchback 2-Door'],
    [1975, 'Saab', '99', 'Sedan 2-Door'],
    [1975, 'Saab', '99', 'Sedan 4-Door'],
    [1975, 'Subaru', 'DL', 'Sedan 2-Door'],
    [1975, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1975, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1975, 'Subaru', 'GF', 'Hardtop 2-Door'],
    [1975, 'Subaru', 'GL', 'Coupe 2-Door'],
    [1975, 'Toyota', 'Celica', 'Hardtop 2-Door'],
    [1975, 'Toyota', 'Corolla', 'Hardtop 2-Door'],
    [1975, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1975, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1975, 'Toyota', 'Corolla', 'Wagon 5-Door'],
    [1975, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1975, 'Toyota', 'Corona', 'Sedan 2-Door'],
    [1975, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1975, 'Toyota', 'Corona', 'Wagon 5-Door'],
    [1975, 'Toyota', 'Land Cruiser', 'SUV 2-Door'],
    [1975, 'Toyota', 'Land Cruiser', 'SUV 4-Door'],
    [1975, 'Toyota', 'Mark II', 'Hardtop 2-Door'],
    [1975, 'Toyota', 'Mark II', 'Sedan 4-Door'],
    [1975, 'Toyota', 'Mark II', 'Wagon 4-Door'],
    [1975, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1975, 'Triumph', 'Spitfire', 'Convertible 2-Door'],
    [1975, 'Triumph', 'TR6', 'Convertible 2-Door'],
    [1975, 'Triumph', 'TR7', 'Coupe 2-Door'],
    [1975, 'TVR', '2500M', 'Coupe 2-Door'],
    [1975, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1975, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1975, 'Volkswagen', 'Dasher', 'Hatchback 2-Door'],
    [1975, 'Volkswagen', 'Dasher', 'Hatchback 4-Door'],
    [1975, 'Volkswagen', 'Dasher', 'Wagon 4-Door'],
    [1975, 'Volkswagen', 'Rabbit', 'Hatchback 2-Door'],
    [1975, 'Volkswagen', 'Rabbit', 'Hatchback 4-Door'],
    [1975, 'Volkswagen', 'Scirocco', 'Coupe 2-Door'],
    [1975, 'Volkswagen', 'Super Beetle', 'Convertible 2-Door'],
    [1975, 'Volkswagen', 'Super Beetle', 'Sedan 2-Door'],
    [1975, 'Volkswagen', 'Transporter', 'Standard Passenger Van 3-Door'],
    [1975, 'Volkswagen', 'Transporter', 'Van Camper 3-Door'],
    [1975, 'Volvo', '164', 'Sedan 4-Door'],
    [1975, 'Volvo', '242', 'Sedan 2-Door'],
    [1975, 'Volvo', '244', 'Sedan 4-Door'],
    [1975, 'Volvo', '245', 'Wagon 4-Door'],
    [1974, 'Alfa Romeo', 'Berlina', 'Sedan 4-Door'],
    [1974, 'Alfa Romeo', 'GT Veloce', 'Coupe 2-Door'],
    [1974, 'Alfa Romeo', 'Montreal', 'Coupe 2-Door'],
    [1974, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1974, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1974, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1974, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1974, 'AMC', 'Hornet', 'Hatchback 2-Door'],
    [1974, 'AMC', 'Hornet', 'Sedan 2-Door'],
    [1974, 'AMC', 'Hornet', 'Sedan 4-Door'],
    [1974, 'AMC', 'Hornet', 'Wagon 4-Door'],
    [1974, 'AMC', 'Matador', 'Coupe 2-Door'],
    [1974, 'AMC', 'Matador', 'Sedan 4-Door'],
    [1974, 'AMC', 'Matador', 'Wagon 4-Door'],
    [1974, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1974, 'Audi', '100 Series', 'Sedan 2-Door'],
    [1974, 'Audi', '100 Series', 'Sedan 4-Door'],
    [1974, 'Audi', 'Fox', 'Sedan 2-Door'],
    [1974, 'Audi', 'Fox', 'Sedan 4-Door'],
    [1974, 'Austin', 'Marina', 'Sedan 2-Door'],
    [1974, 'Austin', 'Marina', 'Sedan 4-Door'],
    [1974, 'Avanti', 'II', 'Coupe 2-Door'],
    [1974, 'Bentley', 'T1 Series', 'Sedan 4-Door'],
    [1974, 'BMW', '2002', 'Convertible 2-Door'],
    [1974, 'BMW', '2002', 'Sedan 2-Door'],
    [1974, 'Buick', 'Apollo', 'Coupe 2-Door'],
    [1974, 'Buick', 'Apollo', 'Hatchback 2-Door'],
    [1974, 'Buick', 'Apollo', 'Sedan 4-Door'],
    [1974, 'Buick', 'Century', 'Coupe 2-Door'],
    [1974, 'Buick', 'Century', 'Sedan 4-Door'],
    [1974, 'Buick', 'Century', 'Wagon 4-Door'],
    [1974, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1974, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1974, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1974, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1974, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1974, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1974, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1974, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1974, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1974, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1974, 'Buick', 'Regal', 'Sedan 4-Door'],
    [1974, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1974, 'Cadillac', 'Calais', 'Coupe 2-Door'],
    [1974, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1974, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1974, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1974, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1974, 'Cadillac', 'DeVille', 'Coupe 2-Door'],
    [1974, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1974, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1974, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1974, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1974, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1974, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1974, 'Checker', 'Marathon', 'Sedan 6-Door'],
    [1974, 'Checker', 'Marathon', 'Sedan 8-Door'],
    [1974, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1974, 'Checker', 'Marathon', 'Wagon 6-Door'],
    [1974, 'Checker', 'Marathon', 'Wagon 8-Door'],
    [1974, 'Chevrolet', 'Bel Air', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1974, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1974, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1974, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1974, 'Chevrolet', 'C20 Suburban', 'SUV 4-Door'],
    [1974, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Caprice', 'Convertible 2-Door'],
    [1974, 'Chevrolet', 'Caprice', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1974, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1974, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1974, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1974, 'Chevrolet', 'G20 Van', 'Standard Cargo Van 2-Door'],
    [1974, 'Chevrolet', 'G20 Van', 'Standard Passenger Van 2-Door'],
    [1974, 'Chevrolet', 'Impala', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1974, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1974, 'Chevrolet', 'K10 Suburban', 'SUV 4-Door'],
    [1974, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1974, 'Chevrolet', 'Laguna', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1974, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1974, 'Chevrolet', 'Monte Carlo', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Nova', 'Hatchback 2-Door'],
    [1974, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1974, 'Chevrolet', 'P10 Van', 'Standard Cargo Van 2-Door'],
    [1974, 'Chevrolet', 'Vega', 'Coupe 2-Door'],
    [1974, 'Chevrolet', 'Vega', 'Hatchback 2-Door'],
    [1974, 'Chevrolet', 'Vega', 'Wagon 2-Door'],
    [1974, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1974, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1974, 'Chrysler', 'New Yorker', 'Hardtop 2-Door'],
    [1974, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1974, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1974, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1974, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1974, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1974, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1974, 'Chrysler', 'Town & Country', 'Wagon 4-Door'],
    [1974, 'Datsun', '610', 'Hardtop 2-Door'],
    [1974, 'Datsun', '610', 'Sedan 4-Door'],
    [1974, 'Datsun', '610', 'Wagon 4-Door'],
    [1974, 'Datsun', '710', 'Hardtop 2-Door'],
    [1974, 'Datsun', '710', 'Sedan 2-Door'],
    [1974, 'Datsun', '710', 'Sedan 4-Door'],
    [1974, 'Datsun', '710', 'Wagon 4-Door'],
    [1974, 'Datsun', '260Z', 'Coupe 2-Door'],
    [1974, 'Datsun', '620 Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Datsun', 'B210', 'Coupe 2-Door'],
    [1974, 'Datsun', 'B210', 'Sedan 2-Door'],
    [1974, 'Datsun', 'B210', 'Sedan 4-Door'],
    [1974, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1974, 'Dodge', 'B100 Van', 'Standard Cargo Van 2-Door'],
    [1974, 'Dodge', 'B100 Van', 'Standard Passenger Van 2-Door'],
    [1974, 'Dodge', 'B200 Van', 'Extended Cargo Van 3-Door'],
    [1974, 'Dodge', 'B200 Van', 'Extended Passenger Van 3-Door'],
    [1974, 'Dodge', 'B200 Van', 'Standard Cargo Van 2-Door'],
    [1974, 'Dodge', 'B200 Van', 'Standard Passenger Van 2-Door'],
    [1974, 'Dodge', 'B300 Van', 'Extended Cargo Van 3-Door'],
    [1974, 'Dodge', 'B300 Van', 'Extended Passenger Van 3-Door'],
    [1974, 'Dodge', 'B300 Van', 'Standard Cargo Van 2-Door'],
    [1974, 'Dodge', 'B300 Van', 'Standard Passenger Van 2-Door'],
    [1974, 'Dodge', 'CB300', 'Standard Cargo Van 2-Door'],
    [1974, 'Dodge', 'Challenger', 'Hardtop 2-Door'],
    [1974, 'Dodge', 'Charger', 'Coupe 2-Door'],
    [1974, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1974, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1974, 'Dodge', 'Colt', 'Hardtop 2-Door'],
    [1974, 'Dodge', 'Colt', 'Hatchback 2-Door'],
    [1974, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1974, 'Dodge', 'Colt', 'Wagon 4-Door'],
    [1974, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1974, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1974, 'Dodge', 'D100 Pickup', 'Extended Cab Pickup 2-Door'],
    [1974, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Dodge', 'D200 Pickup', 'Crew Cab Pickup 4-Door'],
    [1974, 'Dodge', 'D200 Pickup', 'Extended Cab Pickup 2-Door'],
    [1974, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Dodge', 'D300 Pickup', 'Extended Cab Pickup 2-Door'],
    [1974, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Dodge', 'Dart', 'Coupe 2-Door'],
    [1974, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1974, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1974, 'Dodge', 'Monaco', 'Hardtop 2-Door'],
    [1974, 'Dodge', 'Monaco', 'Hardtop 4-Door'],
    [1974, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1974, 'Dodge', 'Monaco', 'Wagon 4-Door'],
    [1974, 'Dodge', 'Ramcharger', 'SUV 2-Door'],
    [1974, 'Dodge', 'W100 Pickup', 'Extended Cab Pickup 2-Door'],
    [1974, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Dodge', 'W200 Pickup', 'Crew Cab Pickup 4-Door'],
    [1974, 'Dodge', 'W200 Pickup', 'Extended Cab Pickup 2-Door'],
    [1974, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Fiat', '124', 'Convertible 2-Door'],
    [1974, 'Fiat', '124', 'Coupe 2-Door'],
    [1974, 'Fiat', '124', 'Sedan 4-Door'],
    [1974, 'Fiat', '124', 'Wagon 4-Door'],
    [1974, 'Fiat', '128', 'Coupe 2-Door'],
    [1974, 'Fiat', '128', 'Sedan 2-Door'],
    [1974, 'Fiat', '128', 'Sedan 4-Door'],
    [1974, 'Fiat', '128', 'Wagon 2-Door'],
    [1974, 'Fiat', 'X-1/9', 'Coupe 2-Door'],
    [1974, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1974, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1974, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1974, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1974, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1974, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1974, 'Ford', 'E-200 Econoline', 'Standard Passenger Van 2-Door'],
    [1974, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1974, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1974, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1974, 'Ford', 'Gran Torino', 'Hardtop 2-Door'],
    [1974, 'Ford', 'Gran Torino', 'Hardtop 4-Door'],
    [1974, 'Ford', 'Gran Torino', 'Wagon 4-Door'],
    [1974, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1974, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1974, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1974, 'Ford', 'Maverick', 'Sedan 2-Door'],
    [1974, 'Ford', 'Maverick', 'Sedan 4-Door'],
    [1974, 'Ford', 'Mustang II', 'Hardtop 2-Door'],
    [1974, 'Ford', 'Mustang II', 'Hatchback 2-Door'],
    [1974, 'Ford', 'Pinto', 'Hatchback 2-Door'],
    [1974, 'Ford', 'Pinto', 'Sedan 2-Door'],
    [1974, 'Ford', 'Pinto', 'Wagon 2-Door'],
    [1974, 'Ford', 'Ranchero', 'Standard Cab Pickup 2-Door'],
    [1974, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1974, 'Ford', 'Torino', 'Hardtop 2-Door'],
    [1974, 'Ford', 'Torino', 'Hardtop 4-Door'],
    [1974, 'Ford', 'Torino', 'Wagon 4-Door'],
    [1974, 'GMC', 'G35/G3500 Van', 'Standard Cargo Van 2-Door'],
    [1974, 'GMC', 'G35/G3500 Van', 'Standard Passenger Van 2-Door'],
    [1974, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1974, 'GMC', 'Sprint', 'Standard Cab Pickup 2-Door'],
    [1974, 'Honda', 'Civic', 'Hatchback 2-Door'],
    [1974, 'Honda', 'Civic', 'Sedan 2-Door'],
    [1974, 'International Harvester', '100', 'Standard Cab Pickup 2-Door'],
    [1974, 'International Harvester', '200', 'Crew Cab Pickup 4-Door'],
    [1974, 'International Harvester', '200', 'Standard Cab Pickup 2-Door'],
    [1974, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1974, 'Jaguar', 'XJ12', 'Sedan 4-Door'],
    [1974, 'Jaguar', 'XJ6', 'Sedan 4-Door'],
    [1974, 'Jeep', 'Cherokee', 'SUV 2-Door'],
    [1974, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1974, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1974, 'Jeep', 'J10', 'Standard Cab Pickup 2-Door'],
    [1974, 'Jeep', 'J20', 'Standard Cab Pickup 2-Door'],
    [1974, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1974, 'Jensen', 'Healey', 'Convertible 2-Door'],
    [1974, 'Land Rover', 'Land Rover', 'SUV 2-Door'],
    [1974, 'Lincoln', 'Continental', 'Coupe 2-Door'],
    [1974, 'Lincoln', 'Continental', 'Sedan 4-Door'],
    [1974, 'Lincoln', 'Mark IV', 'Coupe 2-Door'],
    [1974, 'Lotus', 'Elite', 'Hatchback 2-Door'],
    [1974, 'Mazda', '808', 'Coupe 2-Door'],
    [1974, 'Mazda', '808', 'Sedan 4-Door'],
    [1974, 'Mazda', '808', 'Wagon 4-Door'],
    [1974, 'Mazda', 'B1600', 'Standard Cab Pickup 2-Door'],
    [1974, 'Mazda', 'Rotary Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Mazda', 'RX-3', 'Coupe 2-Door'],
    [1974, 'Mazda', 'RX-3', 'Sedan 4-Door'],
    [1974, 'Mazda', 'RX-3', 'Wagon 4-Door'],
    [1974, 'Mazda', 'RX-4', 'Coupe 2-Door'],
    [1974, 'Mazda', 'RX-4', 'Sedan 4-Door'],
    [1974, 'Mazda', 'RX-4', 'Wagon 4-Door'],
    [1974, 'Mercury', 'Capri', 'Hatchback 2-Door'],
    [1974, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1974, 'Mercury', 'Comet', 'Sedan 2-Door'],
    [1974, 'Mercury', 'Comet', 'Sedan 4-Door'],
    [1974, 'Mercury', 'Cougar', 'Hardtop 2-Door'],
    [1974, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1974, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1974, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1974, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1974, 'Mercury', 'Montego', 'Hardtop 2-Door'],
    [1974, 'Mercury', 'Montego', 'Hardtop 4-Door'],
    [1974, 'Mercury', 'Montego', 'Wagon 4-Door'],
    [1974, 'MG', 'MGB', 'Convertible 2-Door'],
    [1974, 'MG', 'MGB', 'Coupe 2-Door'],
    [1974, 'MG', 'Midget', 'Convertible 2-Door'],
    [1974, 'Oldsmobile', '98', 'Coupe 2-Door'],
    [1974, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1974, 'Oldsmobile', 'Custom Cruiser', 'Wagon 4-Door'],
    [1974, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1974, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1974, 'Oldsmobile', 'Cutlass', 'Wagon 4-Door'],
    [1974, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1974, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1974, 'Oldsmobile', 'Cutlass Supreme', 'Wagon 4-Door'],
    [1974, 'Oldsmobile', 'Delta 88', 'Convertible 2-Door'],
    [1974, 'Oldsmobile', 'Delta 88', 'Coupe 2-Door'],
    [1974, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1974, 'Oldsmobile', 'Delta 88', 'Wagon 4-Door'],
    [1974, 'Oldsmobile', 'Omega', 'Coupe 2-Door'],
    [1974, 'Oldsmobile', 'Omega', 'Hatchback 2-Door'],
    [1974, 'Oldsmobile', 'Omega', 'Sedan 4-Door'],
    [1974, 'Oldsmobile', 'Toronado', 'Coupe 2-Door'],
    [1974, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1974, 'Opel', '1900', 'Wagon 2-Door'],
    [1974, 'Opel', 'Manta', 'Coupe 2-Door'],
    [1974, 'Peugeot', '504', 'Sedan 4-Door'],
    [1974, 'Peugeot', '504', 'Wagon 4-Door'],
    [1974, 'Plymouth', 'Duster', 'Coupe 2-Door'],
    [1974, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1974, 'Plymouth', 'Fury I', 'Wagon 4-Door'],
    [1974, 'Plymouth', 'Fury II', 'Wagon 4-Door'],
    [1974, 'Plymouth', 'Fury III', 'Wagon 4-Door'],
    [1974, 'Plymouth', 'Gran Fury', 'Hardtop 2-Door'],
    [1974, 'Plymouth', 'Gran Fury', 'Hardtop 4-Door'],
    [1974, 'Plymouth', 'Gran Fury', 'Wagon 4-Door'],
    [1974, 'Plymouth', 'PB100 Van', 'Standard Passenger Van 2-Door'],
    [1974, 'Plymouth', 'PB200 Van', 'Extended Passenger Van 3-Door'],
    [1974, 'Plymouth', 'PB200 Van', 'Standard Passenger Van 2-Door'],
    [1974, 'Plymouth', 'PB300 Van', 'Extended Passenger Van 3-Door'],
    [1974, 'Plymouth', 'PB300 Van', 'Standard Passenger Van 2-Door'],
    [1974, 'Plymouth', 'Road Runner', 'Coupe 2-Door'],
    [1974, 'Plymouth', 'Scamp', 'Hardtop 2-Door'],
    [1974, 'Plymouth', 'Trailduster', 'SUV 2-Door'],
    [1974, 'Plymouth', 'Valiant', 'Hardtop 2-Door'],
    [1974, 'Plymouth', 'Valiant', 'Sedan 4-Door'],
    [1974, 'Pontiac', 'Bonneville', 'Hardtop 2-Door'],
    [1974, 'Pontiac', 'Bonneville', 'Hardtop 4-Door'],
    [1974, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1974, 'Pontiac', 'Catalina', 'Hardtop 2-Door'],
    [1974, 'Pontiac', 'Catalina', 'Hardtop 4-Door'],
    [1974, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1974, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1974, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1974, 'Pontiac', 'Grand Am', 'Hardtop 2-Door'],
    [1974, 'Pontiac', 'Grand Am', 'Hardtop 4-Door'],
    [1974, 'Pontiac', 'Grand Prix', 'Hardtop 2-Door'],
    [1974, 'Pontiac', 'Grand Safari', 'Wagon 4-Door'],
    [1974, 'Pontiac', 'Grandville', 'Convertible 2-Door'],
    [1974, 'Pontiac', 'Grandville', 'Coupe 2-Door'],
    [1974, 'Pontiac', 'Grandville', 'Hardtop 4-Door'],
    [1974, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1974, 'Pontiac', 'LeMans', 'Hardtop 2-Door'],
    [1974, 'Pontiac', 'LeMans', 'Hardtop 4-Door'],
    [1974, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1974, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1974, 'Pontiac', 'Parisienne', 'Coupe 2-Door'],
    [1974, 'Pontiac', 'Parisienne', 'Sedan 4-Door'],
    [1974, 'Pontiac', 'Parisienne', 'Wagon 4-Door'],
    [1974, 'Pontiac', 'Ventura', 'Coupe 2-Door'],
    [1974, 'Pontiac', 'Ventura', 'Hatchback 2-Door'],
    [1974, 'Pontiac', 'Ventura', 'Sedan 4-Door'],
    [1974, 'Porsche', '911', 'Coupe 2-Door'],
    [1974, 'Porsche', '911', 'Targa 2-Door'],
    [1974, 'Porsche', '914', 'Coupe 2-Door'],
    [1974, 'Renault', 'R12', 'Sedan 4-Door'],
    [1974, 'Renault', 'R12', 'Wagon 4-Door'],
    [1974, 'Renault', 'R15', 'Coupe 2-Door'],
    [1974, 'Renault', 'R17', 'Convertible 2-Door'],
    [1974, 'Renault', 'R17', 'Coupe 2-Door'],
    [1974, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1974, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1974, 'Saab', '99', 'Hatchback 2-Door'],
    [1974, 'Saab', '99', 'Sedan 2-Door'],
    [1974, 'Saab', '99', 'Sedan 4-Door'],
    [1974, 'Subaru', 'DL', 'Sedan 2-Door'],
    [1974, 'Subaru', 'DL', 'Sedan 4-Door'],
    [1974, 'Subaru', 'DL', 'Wagon 4-Door'],
    [1974, 'Subaru', 'GL', 'Coupe 2-Door'],
    [1974, 'Toyota', 'Celica', 'Hardtop 2-Door'],
    [1974, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1974, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1974, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1974, 'Toyota', 'Corolla', 'Wagon 2-Door'],
    [1974, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1974, 'Toyota', 'Corona', 'Sedan 2-Door'],
    [1974, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1974, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1974, 'Toyota', 'Mark II', 'Hardtop 2-Door'],
    [1974, 'Toyota', 'Mark II', 'Sedan 4-Door'],
    [1974, 'Toyota', 'Mark II', 'Wagon 4-Door'],
    [1974, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1974, 'Triumph', 'Spitfire', 'Convertible 2-Door'],
    [1974, 'Triumph', 'TR6', 'Convertible 2-Door'],
    [1974, 'TVR', '2500M', 'Coupe 2-Door'],
    [1974, 'Volkswagen', '412', 'Sedan 2-Door'],
    [1974, 'Volkswagen', '412', 'Sedan 4-Door'],
    [1974, 'Volkswagen', '412', 'Wagon 2-Door'],
    [1974, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1974, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1974, 'Volkswagen', 'Dasher', 'Sedan 2-Door'],
    [1974, 'Volkswagen', 'Dasher', 'Sedan 4-Door'],
    [1974, 'Volkswagen', 'Dasher', 'Wagon 4-Door'],
    [1974, 'Volkswagen', 'Super Beetle', 'Sedan 2-Door'],
    [1974, 'Volkswagen', 'Transporter', 'Standard Passenger Van 2-Door'],
    [1974, 'Volvo', '164', 'Sedan 4-Door'],
    [1973, 'Alfa Romeo', 'Berlina', 'Sedan 4-Door'],
    [1973, 'Alfa Romeo', 'GT Veloce', 'Coupe 2-Door'],
    [1973, 'Alfa Romeo', 'Montreal', 'Coupe 2-Door'],
    [1973, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1973, 'AMC', 'Ambassador', 'Coupe 2-Door'],
    [1973, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1973, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1973, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1973, 'AMC', 'Hornet', 'Hatchback 2-Door'],
    [1973, 'AMC', 'Hornet', 'Sedan 2-Door'],
    [1973, 'AMC', 'Hornet', 'Sedan 4-Door'],
    [1973, 'AMC', 'Hornet', 'Wagon 4-Door'],
    [1973, 'AMC', 'Matador', 'Hardtop 2-Door'],
    [1973, 'AMC', 'Matador', 'Sedan 4-Door'],
    [1973, 'AMC', 'Matador', 'Wagon 4-Door'],
    [1973, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1973, 'Audi', '100 Series', 'Sedan 2-Door'],
    [1973, 'Audi', '100 Series', 'Sedan 4-Door'],
    [1973, 'Audi', 'Fox', 'Sedan 2-Door'],
    [1973, 'Audi', 'Fox', 'Sedan 4-Door'],
    [1973, 'Austin', 'Marina', 'Sedan 2-Door'],
    [1973, 'Austin', 'Marina', 'Sedan 4-Door'],
    [1973, 'Avanti', 'II', 'Coupe 2-Door'],
    [1973, 'Bentley', 'T1 Series', 'Sedan 4-Door'],
    [1973, 'BMW', '2002', 'Convertible 2-Door'],
    [1973, 'BMW', '2002', 'Sedan 2-Door'],
    [1973, 'Buick', 'Apollo', 'Hatchback 2-Door'],
    [1973, 'Buick', 'Apollo', 'Sedan 2-Door'],
    [1973, 'Buick', 'Apollo', 'Sedan 4-Door'],
    [1973, 'Buick', 'Century', 'Coupe 2-Door'],
    [1973, 'Buick', 'Century', 'Hardtop 4-Door'],
    [1973, 'Buick', 'Century', 'Sedan 4-Door'],
    [1973, 'Buick', 'Century', 'Wagon 4-Door'],
    [1973, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1973, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1973, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1973, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1973, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1973, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1973, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1973, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1973, 'Buick', 'Regal', 'Coupe 2-Door'],
    [1973, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1973, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1973, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1973, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1973, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1973, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1973, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1973, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1973, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1973, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1973, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1973, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1973, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1973, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1973, 'Checker', 'Marathon', 'Wagon 6-Door'],
    [1973, 'Checker', 'Marathon', 'Wagon 8-Door'],
    [1973, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1973, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1973, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1973, 'Chevrolet', 'C10 Suburban', 'SUV 4-Door'],
    [1973, 'Chevrolet', 'C20 Suburban', 'SUV 3-Door'],
    [1973, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1973, 'Chevrolet', 'Caprice', 'Convertible 2-Door'],
    [1973, 'Chevrolet', 'Caprice', 'Hardtop 2-Door'],
    [1973, 'Chevrolet', 'Caprice', 'Sedan 4-Door'],
    [1973, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1973, 'Chevrolet', 'Chevelle', 'Coupe 2-Door'],
    [1973, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1973, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1973, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1973, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1973, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1973, 'Chevrolet', 'G20 Van', 'Standard Cargo Van 2-Door'],
    [1973, 'Chevrolet', 'G20 Van', 'Standard Passenger Van 2-Door'],
    [1973, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1973, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1973, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1973, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1973, 'Chevrolet', 'K10 Suburban', 'SUV 3-Door'],
    [1973, 'Chevrolet', 'K20 Suburban', 'SUV 4-Door'],
    [1973, 'Chevrolet', 'Laguna', 'Coupe 2-Door'],
    [1973, 'Chevrolet', 'Laguna', 'Sedan 4-Door'],
    [1973, 'Chevrolet', 'Laguna', 'Wagon 4-Door'],
    [1973, 'Chevrolet', 'Malibu', 'Coupe 2-Door'],
    [1973, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1973, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1973, 'Chevrolet', 'Monte Carlo', 'Hardtop 2-Door'],
    [1973, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1973, 'Chevrolet', 'Nova', 'Hatchback 2-Door'],
    [1973, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1973, 'Chevrolet', 'P10 Van', 'Standard Cargo Van 2-Door'],
    [1973, 'Chevrolet', 'Vega', 'Hatchback 2-Door'],
    [1973, 'Chevrolet', 'Vega', 'Sedan 2-Door'],
    [1973, 'Chevrolet', 'Vega', 'Wagon 2-Door'],
    [1973, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1973, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1973, 'Chrysler', 'New Yorker', 'Hardtop 2-Door'],
    [1973, 'Chrysler', 'New Yorker', 'Hardtop 4-Door'],
    [1973, 'Chrysler', 'New Yorker', 'Sedan 4-Door'],
    [1973, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1973, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1973, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1973, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1973, 'Datsun', '620 Pickup', 'Standard Cab Pickup 2-Door'],
    [1973, 'Datsun', 'B110', 'Coupe 2-Door'],
    [1973, 'Datsun', 'B110', 'Sedan 2-Door'],
    [1973, 'Datsun', 'B210', 'Coupe 2-Door'],
    [1973, 'Datsun', 'B210', 'Sedan 2-Door'],
    [1973, 'Datsun', 'B210', 'Sedan 4-Door'],
    [1973, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1973, 'Dodge', 'B100 Van', 'Standard Cargo Van 2-Door'],
    [1973, 'Dodge', 'B100 Van', 'Standard Passenger Van 2-Door'],
    [1973, 'Dodge', 'B200 Van', 'Standard Cargo Van 2-Door'],
    [1973, 'Dodge', 'B200 Van', 'Standard Passenger Van 2-Door'],
    [1973, 'Dodge', 'B300 Van', 'Extended Cargo Van 3-Door'],
    [1973, 'Dodge', 'B300 Van', 'Extended Passenger Van 3-Door'],
    [1973, 'Dodge', 'B300 Van', 'Standard Cargo Van 2-Door'],
    [1973, 'Dodge', 'B300 Van', 'Standard Passenger Van 2-Door'],
    [1973, 'Dodge', 'Challenger', 'Hardtop 2-Door'],
    [1973, 'Dodge', 'Charger', 'Coupe 2-Door'],
    [1973, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1973, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1973, 'Dodge', 'Colt', 'Hardtop 2-Door'],
    [1973, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1973, 'Dodge', 'Colt', 'Wagon 2-Door'],
    [1973, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1973, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1973, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1973, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1973, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1973, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1973, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1973, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1973, 'Fiat', '124', 'Convertible 2-Door'],
    [1973, 'Fiat', '124', 'Coupe 2-Door'],
    [1973, 'Fiat', '124', 'Sedan 4-Door'],
    [1973, 'Fiat', '124', 'Wagon 4-Door'],
    [1973, 'Fiat', '850', 'Convertible 2-Door'],
    [1973, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1973, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1973, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1973, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1973, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1973, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1973, 'Ford', 'E-200 Econoline', 'Standard Passenger Van 2-Door'],
    [1973, 'Ford', 'E-300 Econoline', 'Standard Passenger Van 2-Door'],
    [1973, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1973, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1973, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1973, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1973, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1973, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1973, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1973, 'Ford', 'Maverick', 'Sedan 2-Door'],
    [1973, 'Ford', 'Maverick', 'Sedan 4-Door'],
    [1973, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1973, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1973, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1973, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1973, 'GMC', 'G35/G3500 Van', 'Standard Cargo Van 2-Door'],
    [1973, 'GMC', 'G35/G3500 Van', 'Standard Passenger Van 2-Door'],
    [1973, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1973, 'GMC', 'Sprint', 'Standard Cab Pickup 2-Door'],
    [1973, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1973, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1973, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1973, 'Jensen', 'Healey', 'Convertible 2-Door'],
    [1973, 'Land Rover', 'Land Rover', 'SUV 2-Door'],
    [1973, 'Mazda', '808', 'Coupe 2-Door'],
    [1973, 'Mazda', '808', 'Sedan 4-Door'],
    [1973, 'Mazda', '808', 'Wagon 4-Door'],
    [1973, 'Mazda', 'B1600', 'Standard Cab Pickup 2-Door'],
    [1973, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1973, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1973, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1973, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1973, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1973, 'MG', 'MGB', 'Coupe 2-Door'],
    [1973, 'Oldsmobile', '98', 'Hardtop 2-Door'],
    [1973, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1973, 'Oldsmobile', 'Cutlass', 'Coupe 2-Door'],
    [1973, 'Oldsmobile', 'Cutlass', 'Sedan 4-Door'],
    [1973, 'Oldsmobile', 'Cutlass', 'Wagon 4-Door'],
    [1973, 'Oldsmobile', 'Cutlass Supreme', 'Coupe 2-Door'],
    [1973, 'Oldsmobile', 'Cutlass Supreme', 'Sedan 4-Door'],
    [1973, 'Oldsmobile', 'Cutlass Supreme', 'Wagon 4-Door'],
    [1973, 'Oldsmobile', 'Delta 88', 'Convertible 2-Door'],
    [1973, 'Oldsmobile', 'Delta 88', 'Hardtop 2-Door'],
    [1973, 'Oldsmobile', 'Delta 88', 'Hardtop 4-Door'],
    [1973, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1973, 'Oldsmobile', 'Delta 88', 'Wagon 4-Door'],
    [1973, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1973, 'Opel', 'Opel', 'Coupe 2-Door'],
    [1973, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1973, 'Plymouth', 'Fury I', 'Wagon 4-Door'],
    [1973, 'Plymouth', 'Fury II', 'Wagon 4-Door'],
    [1973, 'Plymouth', 'Fury III', 'Wagon 4-Door'],
    [1973, 'Plymouth', 'Gran Fury', 'Hardtop 2-Door'],
    [1973, 'Plymouth', 'Gran Fury', 'Hardtop 4-Door'],
    [1973, 'Plymouth', 'Gran Fury', 'Wagon 4-Door'],
    [1973, 'Pontiac', 'Bonneville', 'Hardtop 2-Door'],
    [1973, 'Pontiac', 'Bonneville', 'Hardtop 4-Door'],
    [1973, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1973, 'Pontiac', 'Catalina', 'Hardtop 2-Door'],
    [1973, 'Pontiac', 'Catalina', 'Hardtop 4-Door'],
    [1973, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1973, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1973, 'Pontiac', 'Grand Am', 'Hardtop 2-Door'],
    [1973, 'Pontiac', 'Grand Am', 'Hardtop 4-Door'],
    [1973, 'Pontiac', 'Grand Safari', 'Wagon 4-Door'],
    [1973, 'Pontiac', 'GTO', 'Hardtop 2-Door'],
    [1973, 'Pontiac', 'LeMans', 'Coupe 2-Door'],
    [1973, 'Pontiac', 'LeMans', 'Hardtop 2-Door'],
    [1973, 'Pontiac', 'LeMans', 'Hardtop 4-Door'],
    [1973, 'Pontiac', 'LeMans', 'Sedan 4-Door'],
    [1973, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1973, 'Porsche', '911', 'Coupe 2-Door'],
    [1973, 'Renault', 'R12', 'Sedan 4-Door'],
    [1973, 'Renault', 'R12', 'Wagon 4-Door'],
    [1973, 'Renault', 'R15', 'Coupe 2-Door'],
    [1973, 'Renault', 'R17', 'Convertible 2-Door'],
    [1973, 'Renault', 'R17', 'Coupe 2-Door'],
    [1973, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1973, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1973, 'Saab', '99', 'Sedan 2-Door'],
    [1973, 'Saab', '99', 'Sedan 4-Door'],
    [1973, 'Subaru', 'GL', 'Coupe 2-Door'],
    [1973, 'Toyota', 'Celica', 'Hardtop 2-Door'],
    [1973, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1973, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1973, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1973, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1973, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1973, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1973, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1973, 'TVR', '2500M', 'Coupe 2-Door'],
    [1973, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1973, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1973, 'Volkswagen', 'Super Beetle', 'Sedan 2-Door'],
    [1972, 'Alfa Romeo', 'Berlina', 'Sedan 4-Door'],
    [1972, 'Alfa Romeo', 'GT Veloce', 'Coupe 2-Door'],
    [1972, 'Alfa Romeo', 'Montreal', 'Coupe 2-Door'],
    [1972, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1972, 'AMC', 'Ambassador', 'Coupe 2-Door'],
    [1972, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1972, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1972, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1972, 'AMC', 'Hornet', 'Sedan 2-Door'],
    [1972, 'AMC', 'Hornet', 'Sedan 4-Door'],
    [1972, 'AMC', 'Hornet', 'Wagon 4-Door'],
    [1972, 'AMC', 'Matador', 'Hardtop 2-Door'],
    [1972, 'AMC', 'Matador', 'Sedan 4-Door'],
    [1972, 'AMC', 'Matador', 'Wagon 4-Door'],
    [1972, 'Aston Martin', 'V-8', 'Coupe 2-Door'],
    [1972, 'Audi', '100 Series', 'Sedan 2-Door'],
    [1972, 'Audi', '100 Series', 'Sedan 4-Door'],
    [1972, 'Avanti', 'II', 'Coupe 2-Door'],
    [1972, 'Bentley', 'T1 Series', 'Sedan 4-Door'],
    [1972, 'BMW', '2000', 'Hatchback 2-Door'],
    [1972, 'BMW', '2000', 'Sedan 4-Door'],
    [1972, 'BMW', '2002', 'Convertible 2-Door'],
    [1972, 'BMW', '2002', 'Sedan 2-Door'],
    [1972, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1972, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1972, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1972, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1972, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1972, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1972, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1972, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1972, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1972, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1972, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1972, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1972, 'Buick', 'Skylark', 'Hardtop 4-Door'],
    [1972, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1972, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1972, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1972, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1972, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1972, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1972, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1972, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1972, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1972, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1972, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1972, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1972, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1972, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1972, 'Checker', 'Marathon', 'Wagon 6-Door'],
    [1972, 'Checker', 'Marathon', 'Wagon 8-Door'],
    [1972, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1972, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1972, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1972, 'Chevrolet', 'C10 Suburban', 'SUV 3-Door'],
    [1972, 'Chevrolet', 'C20 Suburban', 'SUV 3-Door'],
    [1972, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1972, 'Chevrolet', 'Caprice', 'Hardtop 2-Door'],
    [1972, 'Chevrolet', 'Caprice', 'Hardtop 4-Door'],
    [1972, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1972, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1972, 'Chevrolet', 'Chevelle', 'Hardtop 2-Door'],
    [1972, 'Chevrolet', 'Chevelle', 'Hardtop 4-Door'],
    [1972, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1972, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1972, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1972, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1972, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1972, 'Chevrolet', 'G20 Van', 'Standard Cargo Van 2-Door'],
    [1972, 'Chevrolet', 'G20 Van', 'Standard Passenger Van 2-Door'],
    [1972, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1972, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1972, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1972, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1972, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1972, 'Chevrolet', 'K10 Suburban', 'SUV 3-Door'],
    [1972, 'Chevrolet', 'K20 Suburban', 'SUV 3-Door'],
    [1972, 'Chevrolet', 'Monte Carlo', 'Hardtop 2-Door'],
    [1972, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1972, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1972, 'Chevrolet', 'P10 Van', 'Standard Cargo Van 2-Door'],
    [1972, 'Chevrolet', 'Vega', 'Coupe 2-Door'],
    [1972, 'Chevrolet', 'Vega', 'Sedan 2-Door'],
    [1972, 'Chevrolet', 'Vega', 'Wagon 2-Door'],
    [1972, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1972, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1972, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1972, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1972, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1972, 'Datsun', '620 Pickup', 'Standard Cab Pickup 2-Door'],
    [1972, 'Datsun', 'B110', 'Coupe 2-Door'],
    [1972, 'Datsun', 'B110', 'Sedan 2-Door'],
    [1972, 'De Tomaso', 'Mangusta', 'Coupe 2-Door'],
    [1972, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1972, 'Dodge', 'B100 Van', 'Standard Cargo Van 2-Door'],
    [1972, 'Dodge', 'B100 Van', 'Standard Passenger Van 2-Door'],
    [1972, 'Dodge', 'B200 Van', 'Standard Cargo Van 2-Door'],
    [1972, 'Dodge', 'B200 Van', 'Standard Passenger Van 2-Door'],
    [1972, 'Dodge', 'B300 Van', 'Extended Cargo Van 3-Door'],
    [1972, 'Dodge', 'B300 Van', 'Extended Passenger Van 3-Door'],
    [1972, 'Dodge', 'B300 Van', 'Standard Cargo Van 2-Door'],
    [1972, 'Dodge', 'B300 Van', 'Standard Passenger Van 2-Door'],
    [1972, 'Dodge', 'Challenger', 'Hardtop 2-Door'],
    [1972, 'Dodge', 'Charger', 'Coupe 2-Door'],
    [1972, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1972, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1972, 'Dodge', 'Colt', 'Hardtop 2-Door'],
    [1972, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1972, 'Dodge', 'Colt', 'Wagon 2-Door'],
    [1972, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1972, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1972, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1972, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1972, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1972, 'Dodge', 'Dart', 'Coupe 2-Door'],
    [1972, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1972, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1972, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1972, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1972, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1972, 'Fiat', '124', 'Convertible 2-Door'],
    [1972, 'Fiat', '124', 'Coupe 2-Door'],
    [1972, 'Fiat', '124', 'Sedan 4-Door'],
    [1972, 'Fiat', '124', 'Wagon 4-Door'],
    [1972, 'Fiat', '850', 'Convertible 2-Door'],
    [1972, 'Ford', 'Bronco', 'Standard Cab Pickup 2-Door'],
    [1972, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1972, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1972, 'Ford', 'Courier', 'Standard Cab Pickup 2-Door'],
    [1972, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1972, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1972, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1972, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1972, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1972, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1972, 'Ford', 'LTD', 'Convertible 2-Door'],
    [1972, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1972, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1972, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1972, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1972, 'Ford', 'Maverick', 'Sedan 2-Door'],
    [1972, 'Ford', 'Maverick', 'Sedan 4-Door'],
    [1972, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1972, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1972, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1972, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1972, 'GMC', 'G35/G3500 Van', 'Standard Cargo Van 2-Door'],
    [1972, 'GMC', 'G35/G3500 Van', 'Standard Passenger Van 2-Door'],
    [1972, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1972, 'GMC', 'Sprint', 'Standard Cab Pickup 2-Door'],
    [1972, 'Honda', '600', 'Coupe 2-Door'],
    [1972, 'Honda', '600', 'Sedan 2-Door'],
    [1972, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1972, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1972, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1972, 'Jeep', 'M151', 'SUV 2-Door'],
    [1972, 'Jensen', 'Healey', 'Convertible 2-Door'],
    [1972, 'Land Rover', 'Land Rover', 'SUV 2-Door'],
    [1972, 'Mazda', '808', 'Coupe 2-Door'],
    [1972, 'Mazda', '808', 'Sedan 4-Door'],
    [1972, 'Mazda', '808', 'Wagon 4-Door'],
    [1972, 'Mazda', 'B1600', 'Standard Cab Pickup 2-Door'],
    [1972, 'Mercedes-Benz', '280SEL', 'Sedan 4-Door'],
    [1972, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1972, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1972, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1972, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1972, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1972, 'Oldsmobile', '98', 'Hardtop 2-Door'],
    [1972, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1972, 'Oldsmobile', 'Delta 88', 'Convertible 2-Door'],
    [1972, 'Oldsmobile', 'Delta 88', 'Hardtop 2-Door'],
    [1972, 'Oldsmobile', 'Delta 88', 'Hardtop 4-Door'],
    [1972, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1972, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1972, 'Opel', 'Opel', 'Coupe 2-Door'],
    [1972, 'Plymouth', 'Fury', 'Coupe 2-Door'],
    [1972, 'Plymouth', 'Fury', 'Hardtop 2-Door'],
    [1972, 'Plymouth', 'Fury', 'Hardtop 4-Door'],
    [1972, 'Plymouth', 'Fury', 'Sedan 4-Door'],
    [1972, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1972, 'Plymouth', 'Fury I', 'Wagon 4-Door'],
    [1972, 'Plymouth', 'Fury II', 'Wagon 4-Door'],
    [1972, 'Plymouth', 'Fury III', 'Wagon 4-Door'],
    [1972, 'Plymouth', 'Gran Fury', 'Hardtop 2-Door'],
    [1972, 'Plymouth', 'Gran Fury', 'Hardtop 4-Door'],
    [1972, 'Plymouth', 'Gran Fury', 'Wagon 4-Door'],
    [1972, 'Pontiac', 'Bonneville', 'Hardtop 2-Door'],
    [1972, 'Pontiac', 'Bonneville', 'Hardtop 4-Door'],
    [1972, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1972, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1972, 'Pontiac', 'Catalina', 'Convertible 2-Door'],
    [1972, 'Pontiac', 'Catalina', 'Hardtop 2-Door'],
    [1972, 'Pontiac', 'Catalina', 'Hardtop 4-Door'],
    [1972, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1972, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1972, 'Pontiac', 'Grand Safari', 'Wagon 4-Door'],
    [1972, 'Renault', 'R12', 'Sedan 4-Door'],
    [1972, 'Renault', 'R12', 'Wagon 4-Door'],
    [1972, 'Renault', 'R15', 'Coupe 2-Door'],
    [1972, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1972, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1972, 'Rover', '2000', 'Sedan 4-Door'],
    [1972, 'Saab', '99', 'Sedan 2-Door'],
    [1972, 'Saab', '99', 'Sedan 4-Door'],
    [1972, 'Subaru', 'GL', 'Coupe 2-Door'],
    [1972, 'Toyota', 'Celica', 'Hardtop 2-Door'],
    [1972, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1972, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1972, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1972, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1972, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1972, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1972, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1972, 'TVR', '2500M', 'Coupe 2-Door'],
    [1972, 'TVR', 'Vixen', 'Coupe 2-Door'],
    [1972, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1972, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1972, 'Volkswagen', 'Super Beetle', 'Sedan 2-Door'],
    [1972, 'Volvo', '1800', 'Coupe 2-Door'],
    [1972, 'Volvo', '1800', 'Wagon 2-Door'],
    [1971, 'Alfa Romeo', 'Berlina', 'Sedan 4-Door'],
    [1971, 'Alfa Romeo', 'GT Veloce', 'Coupe 2-Door'],
    [1971, 'Alfa Romeo', 'Montreal', 'Coupe 2-Door'],
    [1971, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1971, 'AMC', 'Ambassador', 'Coupe 2-Door'],
    [1971, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1971, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1971, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1971, 'AMC', 'Hornet', 'Sedan 2-Door'],
    [1971, 'AMC', 'Hornet', 'Sedan 4-Door'],
    [1971, 'AMC', 'Hornet', 'Wagon 4-Door'],
    [1971, 'AMC', 'Matador', 'Hardtop 2-Door'],
    [1971, 'AMC', 'Matador', 'Sedan 4-Door'],
    [1971, 'AMC', 'Matador', 'Wagon 4-Door'],
    [1971, 'Audi', '100 Series', 'Sedan 2-Door'],
    [1971, 'Audi', '100 Series', 'Sedan 4-Door'],
    [1971, 'Avanti', 'II', 'Coupe 2-Door'],
    [1971, 'Bentley', 'T1 Series', 'Sedan 4-Door'],
    [1971, 'BMW', '2000', 'Hatchback 2-Door'],
    [1971, 'BMW', '2000', 'Sedan 4-Door'],
    [1971, 'BMW', '2002', 'Convertible 2-Door'],
    [1971, 'BMW', '2002', 'Sedan 2-Door'],
    [1971, 'BMW', '2500', 'Sedan 4-Door'],
    [1971, 'BMW', '1600-2', 'Sedan 2-Door'],
    [1971, 'BMW', '3.0Si', 'Sedan 4-Door'],
    [1971, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1971, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1971, 'Buick', 'Electra', 'Wagon 4-Door'],
    [1971, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1971, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1971, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1971, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1971, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1971, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1971, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1971, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1971, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1971, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1971, 'Buick', 'Skylark', 'Hardtop 4-Door'],
    [1971, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1971, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1971, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1971, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1971, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1971, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1971, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1971, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1971, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1971, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1971, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1971, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1971, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1971, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1971, 'Checker', 'Marathon', 'Wagon 6-Door'],
    [1971, 'Checker', 'Marathon', 'Wagon 8-Door'],
    [1971, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1971, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1971, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1971, 'Chevrolet', 'C10 Suburban', 'SUV 3-Door'],
    [1971, 'Chevrolet', 'C20 Suburban', 'SUV 3-Door'],
    [1971, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1971, 'Chevrolet', 'Caprice', 'Hardtop 2-Door'],
    [1971, 'Chevrolet', 'Caprice', 'Hardtop 4-Door'],
    [1971, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1971, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1971, 'Chevrolet', 'Chevelle', 'Hardtop 2-Door'],
    [1971, 'Chevrolet', 'Chevelle', 'Hardtop 4-Door'],
    [1971, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1971, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1971, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1971, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1971, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1971, 'Chevrolet', 'G20 Van', 'Standard Cargo Van 2-Door'],
    [1971, 'Chevrolet', 'G20 Van', 'Standard Passenger Van 2-Door'],
    [1971, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1971, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1971, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1971, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1971, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1971, 'Chevrolet', 'K10 Suburban', 'SUV 3-Door'],
    [1971, 'Chevrolet', 'K20 Suburban', 'SUV 3-Door'],
    [1971, 'Chevrolet', 'Monte Carlo', 'Hardtop 2-Door'],
    [1971, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1971, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1971, 'Chevrolet', 'P10 Van', 'Standard Cargo Van 2-Door'],
    [1971, 'Chevrolet', 'Vega', 'Coupe 2-Door'],
    [1971, 'Chevrolet', 'Vega', 'Sedan 2-Door'],
    [1971, 'Chevrolet', 'Vega', 'Wagon 2-Door'],
    [1971, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1971, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1971, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1971, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1971, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1971, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1971, 'Datsun', 'B110', 'Coupe 2-Door'],
    [1971, 'Datsun', 'B110', 'Sedan 2-Door'],
    [1971, 'De Tomaso', 'Mangusta', 'Coupe 2-Door'],
    [1971, 'De Tomaso', 'Pantera', 'Coupe 2-Door'],
    [1971, 'Dodge', 'B100 Van', 'Standard Cargo Van 2-Door'],
    [1971, 'Dodge', 'B100 Van', 'Standard Passenger Van 2-Door'],
    [1971, 'Dodge', 'B200 Van', 'Standard Cargo Van 2-Door'],
    [1971, 'Dodge', 'B200 Van', 'Standard Passenger Van 2-Door'],
    [1971, 'Dodge', 'B300 Van', 'Standard Cargo Van 2-Door'],
    [1971, 'Dodge', 'B300 Van', 'Standard Passenger Van 2-Door'],
    [1971, 'Dodge', 'Challenger', 'Convertible 2-Door'],
    [1971, 'Dodge', 'Challenger', 'Coupe 2-Door'],
    [1971, 'Dodge', 'Challenger', 'Hardtop 2-Door'],
    [1971, 'Dodge', 'Charger', 'Coupe 2-Door'],
    [1971, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1971, 'Dodge', 'Colt', 'Coupe 2-Door'],
    [1971, 'Dodge', 'Colt', 'Hardtop 2-Door'],
    [1971, 'Dodge', 'Colt', 'Sedan 4-Door'],
    [1971, 'Dodge', 'Colt', 'Wagon 2-Door'],
    [1971, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1971, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1971, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1971, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1971, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1971, 'Dodge', 'Dart', 'Coupe 2-Door'],
    [1971, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1971, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1971, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1971, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1971, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1971, 'Fiat', '124', 'Convertible 2-Door'],
    [1971, 'Fiat', '124', 'Coupe 2-Door'],
    [1971, 'Fiat', '124', 'Sedan 4-Door'],
    [1971, 'Fiat', '124', 'Wagon 4-Door'],
    [1971, 'Fiat', '850', 'Convertible 2-Door'],
    [1971, 'Fiat', '850', 'Coupe 2-Door'],
    [1971, 'Fiat', '850', 'Sedan 2-Door'],
    [1971, 'Ford', 'Bronco', 'Standard Cab Pickup 2-Door'],
    [1971, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1971, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1971, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1971, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1971, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1971, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1971, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1971, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1971, 'Ford', 'LTD', 'Convertible 2-Door'],
    [1971, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1971, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1971, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1971, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1971, 'Ford', 'Maverick', 'Sedan 2-Door'],
    [1971, 'Ford', 'Maverick', 'Sedan 4-Door'],
    [1971, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1971, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1971, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1971, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1971, 'Ford', 'Thunderbird', 'Sedan 4-Door'],
    [1971, 'GMC', 'G35/G3500 Van', 'Standard Cargo Van 2-Door'],
    [1971, 'GMC', 'G35/G3500 Van', 'Standard Passenger Van 2-Door'],
    [1971, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1971, 'GMC', 'Sprint', 'Standard Cab Pickup 2-Door'],
    [1971, 'Honda', '600', 'Coupe 2-Door'],
    [1971, 'Honda', '600', 'Sedan 2-Door'],
    [1971, 'International Harvester', 'Scout II', 'SUV 2-Door'],
    [1971, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [1971, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1971, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1971, 'Jeep', 'M151', 'SUV 2-Door'],
    [1971, 'Land Rover', 'Land Rover', 'SUV 2-Door'],
    [1971, 'Mercedes-Benz', '280SE', 'Convertible 2-Door'],
    [1971, 'Mercedes-Benz', '280SE', 'Coupe 2-Door'],
    [1971, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1971, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1971, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1971, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1971, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1971, 'Oldsmobile', '98', 'Hardtop 2-Door'],
    [1971, 'Oldsmobile', '98', 'Hardtop 4-Door'],
    [1971, 'Oldsmobile', '98', 'Sedan 4-Door'],
    [1971, 'Oldsmobile', '442', 'Convertible 2-Door'],
    [1971, 'Oldsmobile', '442', 'Hardtop 2-Door'],
    [1971, 'Oldsmobile', 'Delta 88', 'Convertible 2-Door'],
    [1971, 'Oldsmobile', 'Delta 88', 'Hardtop 2-Door'],
    [1971, 'Oldsmobile', 'Delta 88', 'Hardtop 4-Door'],
    [1971, 'Oldsmobile', 'Delta 88', 'Sedan 4-Door'],
    [1971, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1971, 'Opel', 'Opel', 'Coupe 2-Door'],
    [1971, 'Plymouth', 'Fury', 'Hardtop 2-Door'],
    [1971, 'Plymouth', 'Fury', 'Hardtop 4-Door'],
    [1971, 'Plymouth', 'Fury', 'Sedan 2-Door'],
    [1971, 'Plymouth', 'Fury', 'Sedan 4-Door'],
    [1971, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1971, 'Plymouth', 'Fury I', 'Wagon 4-Door'],
    [1971, 'Plymouth', 'Fury II', 'Wagon 4-Door'],
    [1971, 'Plymouth', 'Fury III', 'Wagon 4-Door'],
    [1971, 'Pontiac', 'Bonneville', 'Hardtop 2-Door'],
    [1971, 'Pontiac', 'Bonneville', 'Hardtop 4-Door'],
    [1971, 'Pontiac', 'Bonneville', 'Sedan 4-Door'],
    [1971, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1971, 'Pontiac', 'Catalina', 'Convertible 2-Door'],
    [1971, 'Pontiac', 'Catalina', 'Hardtop 2-Door'],
    [1971, 'Pontiac', 'Catalina', 'Hardtop 4-Door'],
    [1971, 'Pontiac', 'Catalina', 'Sedan 4-Door'],
    [1971, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1971, 'Pontiac', 'Grand Safari', 'Wagon 4-Door'],
    [1971, 'Renault', 'R10', 'Sedan 4-Door'],
    [1971, 'Rolls-Royce', 'Corniche', 'Convertible 2-Door'],
    [1971, 'Rolls-Royce', 'Corniche', 'Coupe 2-Door'],
    [1971, 'Rover', '2000', 'Sedan 4-Door'],
    [1971, 'Saab', '99', 'Sedan 2-Door'],
    [1971, 'Saab', '99', 'Sedan 4-Door'],
    [1971, 'Toyota', 'Celica', 'Hardtop 2-Door'],
    [1971, 'Toyota', 'Corolla', 'Coupe 2-Door'],
    [1971, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1971, 'Toyota', 'Corolla', 'Sedan 4-Door'],
    [1971, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1971, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1971, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1971, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1971, 'TVR', 'Tuscan', 'Coupe 2-Door'],
    [1971, 'TVR', 'Vixen', 'Coupe 2-Door'],
    [1971, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1971, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1971, 'Volkswagen', 'Super Beetle', 'Sedan 2-Door'],
    [1970, 'Alfa Romeo', 'Berlina', 'Sedan 4-Door'],
    [1970, 'Alfa Romeo', 'GT Veloce', 'Coupe 2-Door'],
    [1970, 'Alfa Romeo', 'Spider', 'Convertible 2-Door'],
    [1970, 'AMC', 'Ambassador', 'Coupe 2-Door'],
    [1970, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1970, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1970, 'AMC', 'AMX', 'Hardtop 2-Door'],
    [1970, 'AMC', 'Gremlin', 'Sedan 2-Door'],
    [1970, 'AMC', 'Hornet', 'Sedan 2-Door'],
    [1970, 'AMC', 'Hornet', 'Sedan 4-Door'],
    [1970, 'Avanti', 'II', 'Coupe 2-Door'],
    [1970, 'Bentley', 'T1 Series', 'Convertible 2-Door'],
    [1970, 'Bentley', 'T1 Series', 'Coupe 2-Door'],
    [1970, 'Bentley', 'T1 Series', 'Sedan 2-Door'],
    [1970, 'Bentley', 'T1 Series', 'Sedan 4-Door'],
    [1970, 'BMW', '2000', 'Sedan 4-Door'],
    [1970, 'BMW', '2002', 'Sedan 2-Door'],
    [1970, 'BMW', '2500', 'Sedan 4-Door'],
    [1970, 'BMW', '1600-2', 'Sedan 2-Door'],
    [1970, 'Buick', 'Electra', 'Convertible 2-Door'],
    [1970, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1970, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1970, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1970, 'Buick', 'Estate Wagon', 'Wagon 4-Door'],
    [1970, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1970, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1970, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1970, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1970, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1970, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1970, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1970, 'Buick', 'Skylark', 'Hardtop 4-Door'],
    [1970, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1970, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1970, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1970, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1970, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1970, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1970, 'Cadillac', 'DeVille', 'Convertible 2-Door'],
    [1970, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1970, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1970, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1970, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1970, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1970, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1970, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1970, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1970, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1970, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1970, 'Chevrolet', 'C10 Suburban', 'SUV 3-Door'],
    [1970, 'Chevrolet', 'C20 Suburban', 'SUV 3-Door'],
    [1970, 'Chevrolet', 'Camaro', 'Coupe 2-Door'],
    [1970, 'Chevrolet', 'Caprice', 'Hardtop 2-Door'],
    [1970, 'Chevrolet', 'Caprice', 'Hardtop 4-Door'],
    [1970, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1970, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1970, 'Chevrolet', 'Chevelle', 'Hardtop 2-Door'],
    [1970, 'Chevrolet', 'Chevelle', 'Hardtop 4-Door'],
    [1970, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1970, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1970, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1970, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1970, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1970, 'Chevrolet', 'G20 Van', 'Standard Cargo Van 2-Door'],
    [1970, 'Chevrolet', 'G20 Van', 'Standard Passenger Van 2-Door'],
    [1970, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1970, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1970, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1970, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1970, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1970, 'Chevrolet', 'K10 Suburban', 'SUV 3-Door'],
    [1970, 'Chevrolet', 'K20 Suburban', 'SUV 3-Door'],
    [1970, 'Chevrolet', 'Monte Carlo', 'Hardtop 2-Door'],
    [1970, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1970, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1970, 'Chevrolet', 'P10 Van', 'Standard Cargo Van 2-Door'],
    [1970, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1970, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1970, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1970, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1970, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1970, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1970, 'Datsun', 'B110', 'Coupe 2-Door'],
    [1970, 'Datsun', 'B110', 'Sedan 2-Door'],
    [1970, 'De Tomaso', 'Mangusta', 'Coupe 2-Door'],
    [1970, 'Dodge', 'Challenger', 'Convertible 2-Door'],
    [1970, 'Dodge', 'Challenger', 'Hardtop 2-Door'],
    [1970, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1970, 'Dodge', 'Coronet', 'Convertible 2-Door'],
    [1970, 'Dodge', 'Coronet', 'Hardtop 2-Door'],
    [1970, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1970, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1970, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1970, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1970, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1970, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1970, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1970, 'Dodge', 'Monaco', 'Hardtop 2-Door'],
    [1970, 'Dodge', 'Monaco', 'Hardtop 4-Door'],
    [1970, 'Dodge', 'Monaco', 'Sedan 4-Door'],
    [1970, 'Dodge', 'Monaco', 'Wagon 4-Door'],
    [1970, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1970, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1970, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1970, 'Fiat', '124', 'Convertible 2-Door'],
    [1970, 'Fiat', '124', 'Coupe 2-Door'],
    [1970, 'Fiat', '124', 'Sedan 4-Door'],
    [1970, 'Fiat', '124', 'Wagon 4-Door'],
    [1970, 'Fiat', '850', 'Convertible 2-Door'],
    [1970, 'Fiat', '850', 'Coupe 2-Door'],
    [1970, 'Fiat', '850', 'Sedan 2-Door'],
    [1970, 'Ford', 'Bronco', 'Standard Cab Pickup 2-Door'],
    [1970, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1970, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1970, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1970, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1970, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1970, 'Ford', 'E-200 Econoline', 'Standard Passenger Van 2-Door'],
    [1970, 'Ford', 'E-300 Econoline', 'Standard Passenger Van 2-Door'],
    [1970, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1970, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1970, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1970, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1970, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1970, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1970, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1970, 'Ford', 'Maverick', 'Sedan 2-Door'],
    [1970, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1970, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1970, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1970, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1970, 'Ford', 'Thunderbird', 'Sedan 4-Door'],
    [1970, 'GMC', 'Jimmy', 'SUV 2-Door'],
    [1970, 'Honda', '600', 'Sedan 2-Door'],
    [1970, 'Jaguar', 'XJ', 'Sedan 4-Door'],
    [1970, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1970, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1970, 'Jeep', 'M151', 'SUV 2-Door'],
    [1970, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1970, 'Land Rover', 'Land Rover', 'SUV 2-Door'],
    [1970, 'Mercury', 'Capri', 'Coupe 2-Door'],
    [1970, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1970, 'Mercury', 'Marauder', 'Coupe 2-Door'],
    [1970, 'Mercury', 'Marquis', 'Convertible 2-Door'],
    [1970, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1970, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1970, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1970, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1970, 'Oldsmobile', '442', 'Convertible 2-Door'],
    [1970, 'Oldsmobile', '442', 'Hardtop 2-Door'],
    [1970, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1970, 'Opel', 'Opel', 'Coupe 2-Door'],
    [1970, 'Plymouth', 'Fury', 'Hardtop 2-Door'],
    [1970, 'Plymouth', 'Fury', 'Hardtop 4-Door'],
    [1970, 'Plymouth', 'Fury', 'Sedan 2-Door'],
    [1970, 'Plymouth', 'Fury', 'Sedan 4-Door'],
    [1970, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1970, 'Plymouth', 'Fury I', 'Wagon 4-Door'],
    [1970, 'Plymouth', 'Fury II', 'Wagon 4-Door'],
    [1970, 'Plymouth', 'Fury III', 'Wagon 4-Door'],
    [1970, 'Plymouth', 'Satellite', 'Convertible 2-Door'],
    [1970, 'Plymouth', 'Satellite', 'Hardtop 2-Door'],
    [1970, 'Plymouth', 'Satellite', 'Sedan 4-Door'],
    [1970, 'Plymouth', 'Satellite', 'Wagon 4-Door'],
    [1970, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1970, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1970, 'Pontiac', 'Executive', 'Wagon 4-Door'],
    [1970, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1970, 'Renault', 'R10', 'Sedan 4-Door'],
    [1970, 'Rover', '2000', 'Sedan 4-Door'],
    [1970, 'Saab', '99', 'Sedan 2-Door'],
    [1970, 'Saab', '99', 'Sedan 4-Door'],
    [1970, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1970, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1970, 'Toyota', 'Corolla', 'Wagon 2-Door'],
    [1970, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1970, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1970, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1970, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1970, 'TVR', 'Tuscan', 'Coupe 2-Door'],
    [1970, 'TVR', 'Vixen', 'Coupe 2-Door'],
    [1970, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1970, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1969, 'Alfa Romeo', 'Berlina', 'Sedan 4-Door'],
    [1969, 'Alfa Romeo', 'GT Veloce', 'Coupe 2-Door'],
    [1969, 'AMC', 'Ambassador', 'Coupe 2-Door'],
    [1969, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1969, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1969, 'AMC', 'AMX', 'Hardtop 2-Door'],
    [1969, 'Avanti', 'II', 'Coupe 2-Door'],
    [1969, 'Bentley', 'T1 Series', 'Convertible 2-Door'],
    [1969, 'Bentley', 'T1 Series', 'Coupe 2-Door'],
    [1969, 'Bentley', 'T1 Series', 'Sedan 2-Door'],
    [1969, 'Bentley', 'T1 Series', 'Sedan 4-Door'],
    [1969, 'BMW', '2000', 'Sedan 4-Door'],
    [1969, 'BMW', '2002', 'Sedan 2-Door'],
    [1969, 'BMW', '2500', 'Sedan 4-Door'],
    [1969, 'BMW', '1600-2', 'Sedan 2-Door'],
    [1969, 'Buick', 'Electra', 'Convertible 2-Door'],
    [1969, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1969, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1969, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1969, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1969, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1969, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1969, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1969, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1969, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1969, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1969, 'Buick', 'Skylark', 'Hardtop 4-Door'],
    [1969, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1969, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1969, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1969, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1969, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1969, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1969, 'Cadillac', 'DeVille', 'Convertible 2-Door'],
    [1969, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1969, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1969, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1969, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1969, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1969, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1969, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1969, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1969, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1969, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1969, 'Chevrolet', 'Blazer', 'SUV 2-Door'],
    [1969, 'Chevrolet', 'C10 Suburban', 'SUV 3-Door'],
    [1969, 'Chevrolet', 'C20 Suburban', 'SUV 3-Door'],
    [1969, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1969, 'Chevrolet', 'Camaro', 'Hardtop 2-Door'],
    [1969, 'Chevrolet', 'Caprice', 'Hardtop 2-Door'],
    [1969, 'Chevrolet', 'Caprice', 'Hardtop 4-Door'],
    [1969, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1969, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1969, 'Chevrolet', 'Chevelle', 'Hardtop 2-Door'],
    [1969, 'Chevrolet', 'Chevelle', 'Hardtop 4-Door'],
    [1969, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1969, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1969, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1969, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1969, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1969, 'Chevrolet', 'G20 Van', 'Standard Cargo Van 2-Door'],
    [1969, 'Chevrolet', 'G20 Van', 'Standard Passenger Van 2-Door'],
    [1969, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1969, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1969, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1969, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1969, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1969, 'Chevrolet', 'K10 Suburban', 'SUV 3-Door'],
    [1969, 'Chevrolet', 'K20 Suburban', 'SUV 3-Door'],
    [1969, 'Chevrolet', 'Nova', 'Coupe 2-Door'],
    [1969, 'Chevrolet', 'Nova', 'Sedan 4-Door'],
    [1969, 'Chevrolet', 'P10 Van', 'Standard Cargo Van 2-Door'],
    [1969, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1969, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1969, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1969, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1969, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1969, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1969, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1969, 'De Tomaso', 'Mangusta', 'Coupe 2-Door'],
    [1969, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1969, 'Dodge', 'Coronet', 'Convertible 2-Door'],
    [1969, 'Dodge', 'Coronet', 'Hardtop 2-Door'],
    [1969, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1969, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1969, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1969, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1969, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1969, 'Dodge', 'Dart', 'Convertible 2-Door'],
    [1969, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1969, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1969, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1969, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1969, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1969, 'Fiat', '124', 'Convertible 2-Door'],
    [1969, 'Fiat', '124', 'Coupe 2-Door'],
    [1969, 'Fiat', '124', 'Sedan 4-Door'],
    [1969, 'Fiat', '124', 'Wagon 4-Door'],
    [1969, 'Fiat', '850', 'Convertible 2-Door'],
    [1969, 'Fiat', '850', 'Coupe 2-Door'],
    [1969, 'Fiat', '850', 'Sedan 2-Door'],
    [1969, 'Ford', 'Bronco', 'Standard Cab Pickup 2-Door'],
    [1969, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1969, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1969, 'Ford', 'Custom 500', 'Sedan 2-Door'],
    [1969, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1969, 'Ford', 'E-100 Econoline', 'Standard Cargo Van 2-Door'],
    [1969, 'Ford', 'E-100 Econoline', 'Standard Passenger Van 2-Door'],
    [1969, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1969, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1969, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1969, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1969, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1969, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1969, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1969, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1969, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1969, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1969, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1969, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1969, 'Ford', 'Thunderbird', 'Sedan 4-Door'],
    [1969, 'Honda', '600', 'Sedan 2-Door'],
    [1969, 'Jaguar', 'XKE', 'Convertible 2-Door'],
    [1969, 'Jaguar', 'XKE', 'Coupe 2-Door'],
    [1969, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1969, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1969, 'Jeep', 'Gladiator', 'Standard Cab Pickup 2-Door'],
    [1969, 'Jeep', 'M151', 'SUV 2-Door'],
    [1969, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1969, 'Mercury', 'Capri', 'Coupe 2-Door'],
    [1969, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1969, 'Mercury', 'Comet', 'Convertible 2-Door'],
    [1969, 'Mercury', 'Comet', 'Hardtop 2-Door'],
    [1969, 'Mercury', 'Comet', 'Sedan 4-Door'],
    [1969, 'Mercury', 'Comet', 'Wagon 4-Door'],
    [1969, 'Mercury', 'Marquis', 'Convertible 2-Door'],
    [1969, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1969, 'Mercury', 'Marquis', 'Hardtop 4-Door'],
    [1969, 'Mercury', 'Marquis', 'Sedan 4-Door'],
    [1969, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1969, 'Oldsmobile', '442', 'Convertible 2-Door'],
    [1969, 'Oldsmobile', '442', 'Hardtop 2-Door'],
    [1969, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1969, 'Opel', 'Opel', 'Coupe 2-Door'],
    [1969, 'Plymouth', 'Fury', 'Coupe 2-Door'],
    [1969, 'Plymouth', 'Fury', 'Hardtop 4-Door'],
    [1969, 'Plymouth', 'Fury I', 'Wagon 4-Door'],
    [1969, 'Plymouth', 'Fury II', 'Wagon 4-Door'],
    [1969, 'Plymouth', 'Fury III', 'Wagon 4-Door'],
    [1969, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1969, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1969, 'Pontiac', 'Executive', 'Wagon 4-Door'],
    [1969, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1969, 'Pontiac', 'Firebird', 'Hardtop 2-Door'],
    [1969, 'Pontiac', 'LeMans', 'Wagon 4-Door'],
    [1969, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1969, 'Renault', 'R10', 'Sedan 4-Door'],
    [1969, 'Rover', '2000', 'Sedan 4-Door'],
    [1969, 'Saab', '99', 'Sedan 2-Door'],
    [1969, 'Toyota', 'Corolla', 'Hatchback 2-Door'],
    [1969, 'Toyota', 'Corolla', 'Sedan 2-Door'],
    [1969, 'Toyota', 'Corolla', 'Wagon 2-Door'],
    [1969, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1969, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1969, 'Toyota', 'Corona', 'Wagon 4-Door'],
    [1969, 'Toyota', 'Pickup', 'Standard Cab Pickup 2-Door'],
    [1969, 'TVR', 'Tuscan', 'Coupe 2-Door'],
    [1969, 'TVR', 'Vixen', 'Coupe 2-Door'],
    [1969, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1969, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1968, 'Alfa Romeo', '2600', 'Sedan 4-Door'],
    [1968, 'Alfa Romeo', 'Duetto 1600', 'Convertible 2-Door'],
    [1968, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [1968, 'Alfa Romeo', 'Giulia Sprint', 'Coupe 2-Door'],
    [1968, 'Alfa Romeo', 'GTA', 'Coupe 2-Door'],
    [1968, 'Alfa Romeo', 'GTV', 'Coupe 2-Door'],
    [1968, 'AMC', 'Ambassador', 'Coupe 2-Door'],
    [1968, 'AMC', 'Ambassador', 'Hardtop 2-Door'],
    [1968, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1968, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1968, 'AMC', 'AMX', 'Hardtop 2-Door'],
    [1968, 'Avanti', 'II', 'Coupe 2-Door'],
    [1968, 'Bentley', 'T1 Series', 'Convertible 2-Door'],
    [1968, 'Bentley', 'T1 Series', 'Coupe 2-Door'],
    [1968, 'Bentley', 'T1 Series', 'Sedan 2-Door'],
    [1968, 'BMW', '2000', 'Sedan 4-Door'],
    [1968, 'BMW', '2002', 'Sedan 2-Door'],
    [1968, 'BMW', '2500', 'Sedan 4-Door'],
    [1968, 'BMW', '1600-2', 'Sedan 2-Door'],
    [1968, 'Buick', 'Electra', 'Convertible 2-Door'],
    [1968, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1968, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1968, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1968, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1968, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1968, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1968, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1968, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1968, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1968, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1968, 'Buick', 'Skylark', 'Hardtop 4-Door'],
    [1968, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1968, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1968, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1968, 'Cadillac', 'Calais', 'Limousine 4-Door'],
    [1968, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1968, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1968, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1968, 'Cadillac', 'DeVille', 'Convertible 2-Door'],
    [1968, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1968, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1968, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1968, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1968, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1968, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1968, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1968, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1968, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1968, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1968, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1968, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1968, 'Chevrolet', 'C10 Suburban', 'SUV 3-Door'],
    [1968, 'Chevrolet', 'C20 Suburban', 'SUV 3-Door'],
    [1968, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1968, 'Chevrolet', 'Camaro', 'Hardtop 2-Door'],
    [1968, 'Chevrolet', 'Caprice', 'Hardtop 2-Door'],
    [1968, 'Chevrolet', 'Caprice', 'Hardtop 4-Door'],
    [1968, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1968, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1968, 'Chevrolet', 'Chevelle', 'Coupe 2-Door'],
    [1968, 'Chevrolet', 'Chevelle', 'Hardtop 2-Door'],
    [1968, 'Chevrolet', 'Chevelle', 'Hardtop 4-Door'],
    [1968, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1968, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1968, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1968, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1968, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1968, 'Chevrolet', 'G20 Van', 'Standard Cargo Van 2-Door'],
    [1968, 'Chevrolet', 'G20 Van', 'Standard Passenger Van 2-Door'],
    [1968, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1968, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1968, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1968, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1968, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1968, 'Chevrolet', 'K10 Suburban', 'SUV 3-Door'],
    [1968, 'Chevrolet', 'K20 Suburban', 'SUV 3-Door'],
    [1968, 'Chevrolet', 'P10 Van', 'Standard Cargo Van 2-Door'],
    [1968, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1968, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1968, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1968, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1968, 'Chrysler', 'Newport', 'Convertible 2-Door'],
    [1968, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1968, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1968, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1968, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1968, 'De Tomaso', 'Mangusta', 'Coupe 2-Door'],
    [1968, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1968, 'Dodge', 'Coronet', 'Convertible 2-Door'],
    [1968, 'Dodge', 'Coronet', 'Hardtop 2-Door'],
    [1968, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1968, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1968, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1968, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1968, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1968, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1968, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1968, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1968, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1968, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1968, 'Fiat', '124', 'Convertible 2-Door'],
    [1968, 'Fiat', '124', 'Coupe 2-Door'],
    [1968, 'Fiat', '124', 'Sedan 4-Door'],
    [1968, 'Fiat', '124', 'Wagon 4-Door'],
    [1968, 'Fiat', '850', 'Convertible 2-Door'],
    [1968, 'Fiat', '850', 'Coupe 2-Door'],
    [1968, 'Fiat', '850', 'Sedan 2-Door'],
    [1968, 'Ford', 'Bronco', 'Standard Cab Pickup 2-Door'],
    [1968, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1968, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1968, 'Ford', 'Custom 500', 'Sedan 2-Door'],
    [1968, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1968, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1968, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1968, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1968, 'Ford', 'LTD', 'Hardtop 2-Door'],
    [1968, 'Ford', 'LTD', 'Hardtop 4-Door'],
    [1968, 'Ford', 'LTD', 'Sedan 2-Door'],
    [1968, 'Ford', 'LTD', 'Sedan 4-Door'],
    [1968, 'Ford', 'LTD', 'Wagon 4-Door'],
    [1968, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1968, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1968, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1968, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1968, 'Ford', 'Thunderbird', 'Sedan 4-Door'],
    [1968, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1968, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1968, 'Jeep', 'Gladiator', 'Standard Cab Pickup 2-Door'],
    [1968, 'Jeep', 'M151', 'SUV 2-Door'],
    [1968, 'Jeep', 'Wagoneer', 'SUV 2-Door'],
    [1968, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1968, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1968, 'Mercury', 'Comet', 'Convertible 2-Door'],
    [1968, 'Mercury', 'Comet', 'Hardtop 2-Door'],
    [1968, 'Mercury', 'Comet', 'Sedan 4-Door'],
    [1968, 'Mercury', 'Comet', 'Wagon 4-Door'],
    [1968, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1968, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1968, 'Morgan', '4-Apr', 'Coupe 2-Door'],
    [1968, 'Morgan', '4/4 Series V', 'Convertible 2-Door'],
    [1968, 'Oldsmobile', '442', 'Convertible 2-Door'],
    [1968, 'Oldsmobile', '442', 'Hardtop 2-Door'],
    [1968, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1968, 'Plymouth', 'Fury', 'Coupe 2-Door'],
    [1968, 'Plymouth', 'Fury', 'Hardtop 4-Door'],
    [1968, 'Plymouth', 'Fury', 'Wagon 4-Door'],
    [1968, 'Plymouth', 'Fury I', 'Wagon 4-Door'],
    [1968, 'Plymouth', 'Fury II', 'Wagon 4-Door'],
    [1968, 'Plymouth', 'Fury III', 'Wagon 4-Door'],
    [1968, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1968, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1968, 'Pontiac', 'Executive', 'Wagon 4-Door'],
    [1968, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1968, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1968, 'Pontiac', 'Firebird', 'Hardtop 2-Door'],
    [1968, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1968, 'Renault', 'R10', 'Sedan 4-Door'],
    [1968, 'Rover', '2000', 'Sedan 4-Door'],
    [1968, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1968, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1968, 'TVR', 'Tuscan', 'Coupe 2-Door'],
    [1968, 'TVR', 'Vixen', 'Coupe 2-Door'],
    [1968, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1968, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1967, 'Alfa Romeo', '2600', 'Sedan 4-Door'],
    [1967, 'Alfa Romeo', 'Duetto 1600', 'Convertible 2-Door'],
    [1967, 'Alfa Romeo', 'Giulia', 'Convertible 2-Door'],
    [1967, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [1967, 'Alfa Romeo', 'Giulia Sprint', 'Coupe 2-Door'],
    [1967, 'Alfa Romeo', 'GTA', 'Coupe 2-Door'],
    [1967, 'Alfa Romeo', 'GTV', 'Coupe 2-Door'],
    [1967, 'AMC', 'Ambassador', 'Hardtop 2-Door'],
    [1967, 'AMC', 'Ambassador', 'Sedan 2-Door'],
    [1967, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1967, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1967, 'Avanti', 'II', 'Coupe 2-Door'],
    [1967, 'Bentley', 'T1 Series', 'Convertible 2-Door'],
    [1967, 'Bentley', 'T1 Series', 'Coupe 2-Door'],
    [1967, 'Bentley', 'T1 Series', 'Sedan 2-Door'],
    [1967, 'BMW', '2000', 'Sedan 4-Door'],
    [1967, 'BMW', '2002', 'Sedan 2-Door'],
    [1967, 'BMW', '1600-2', 'Sedan 2-Door'],
    [1967, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1967, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1967, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1967, 'Buick', 'Gran Sport', 'Convertible 2-Door'],
    [1967, 'Buick', 'Gran Sport', 'Coupe 2-Door'],
    [1967, 'Buick', 'Gran Sport', 'Hardtop 2-Door'],
    [1967, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1967, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1967, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1967, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1967, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1967, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1967, 'Buick', 'Skylark', 'Coupe 2-Door'],
    [1967, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1967, 'Buick', 'Skylark', 'Hardtop 4-Door'],
    [1967, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1967, 'Buick', 'Special', 'Coupe 2-Door'],
    [1967, 'Buick', 'Special', 'Hardtop 2-Door'],
    [1967, 'Buick', 'Special', 'Sedan 4-Door'],
    [1967, 'Buick', 'Special', 'Wagon 4-Door'],
    [1967, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1967, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1967, 'Cadillac', 'Calais', 'Limousine 4-Door'],
    [1967, 'Cadillac', 'Calais', 'Sedan 4-Door'],
    [1967, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1967, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1967, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1967, 'Cadillac', 'DeVille', 'Convertible 2-Door'],
    [1967, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1967, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1967, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1967, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1967, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1967, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1967, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1967, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1967, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1967, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1967, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1967, 'Chevrolet', 'Camaro', 'Convertible 2-Door'],
    [1967, 'Chevrolet', 'Camaro', 'Hardtop 2-Door'],
    [1967, 'Chevrolet', 'Caprice', 'Hardtop 2-Door'],
    [1967, 'Chevrolet', 'Caprice', 'Hardtop 4-Door'],
    [1967, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1967, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1967, 'Chevrolet', 'Chevelle', 'Hardtop 2-Door'],
    [1967, 'Chevrolet', 'Chevelle', 'Sedan 2-Door'],
    [1967, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1967, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1967, 'Chevrolet', 'Chevy II', 'Hardtop 2-Door'],
    [1967, 'Chevrolet', 'Chevy II', 'Sedan 2-Door'],
    [1967, 'Chevrolet', 'Chevy II', 'Sedan 4-Door'],
    [1967, 'Chevrolet', 'Chevy II', 'Wagon 4-Door'],
    [1967, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1967, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1967, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1967, 'Chevrolet', 'G20 Van', 'Standard Cargo Van 2-Door'],
    [1967, 'Chevrolet', 'G20 Van', 'Standard Passenger Van 2-Door'],
    [1967, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1967, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1967, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1967, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1967, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1967, 'Chevrolet', 'Malibu', 'Convertible 2-Door'],
    [1967, 'Chevrolet', 'Malibu', 'Hardtop 2-Door'],
    [1967, 'Chevrolet', 'Malibu', 'Hardtop 4-Door'],
    [1967, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1967, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1967, 'Chevrolet', 'P10 Van', 'Standard Cargo Van 2-Door'],
    [1967, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1967, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1967, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1967, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1967, 'Chrysler', 'Newport', 'Convertible 2-Door'],
    [1967, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1967, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1967, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1967, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1967, 'De Tomaso', 'Mangusta', 'Coupe 2-Door'],
    [1967, 'Dodge', 'Coronet', 'Convertible 2-Door'],
    [1967, 'Dodge', 'Coronet', 'Hardtop 2-Door'],
    [1967, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1967, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1967, 'Dodge', 'Dart', 'Convertible 2-Door'],
    [1967, 'Dodge', 'Dart', 'Coupe 2-Door'],
    [1967, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1967, 'Dodge', 'Dart', 'Sedan 2-Door'],
    [1967, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1967, 'Fiat', '124', 'Sedan 4-Door'],
    [1967, 'Fiat', '124', 'Wagon 4-Door'],
    [1967, 'Fiat', '850', 'Convertible 2-Door'],
    [1967, 'Fiat', '850', 'Coupe 2-Door'],
    [1967, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1967, 'Ford', 'Anglia', 'Wagon 2-Door'],
    [1967, 'Ford', 'Bronco', 'Standard Cab Pickup 2-Door'],
    [1967, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1967, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1967, 'Ford', 'Custom 500', 'Sedan 2-Door'],
    [1967, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1967, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1967, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1967, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1967, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1967, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1967, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1967, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1967, 'Ford', 'Thunderbird', 'Sedan 4-Door'],
    [1967, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1967, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1967, 'Jeep', 'DJ6', 'SUV 2-Door'],
    [1967, 'Jeep', 'Gladiator', 'Standard Cab Pickup 2-Door'],
    [1967, 'Jeep', 'J-100', 'SUV 2-Door'],
    [1967, 'Jeep', 'J-100', 'SUV 4-Door'],
    [1967, 'Jeep', 'M151', 'SUV 2-Door'],
    [1967, 'Jeep', 'Wagoneer', 'SUV 2-Door'],
    [1967, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1967, 'Mercury', 'Capri', 'Coupe 2-Door'],
    [1967, 'Mercury', 'Capri', 'Sedan 4-Door'],
    [1967, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1967, 'Mercury', 'Comet', 'Convertible 2-Door'],
    [1967, 'Mercury', 'Comet', 'Hardtop 2-Door'],
    [1967, 'Mercury', 'Comet', 'Sedan 4-Door'],
    [1967, 'Mercury', 'Comet', 'Wagon 4-Door'],
    [1967, 'Mercury', 'Marquis', 'Hardtop 2-Door'],
    [1967, 'Mercury', 'Marquis', 'Wagon 4-Door'],
    [1967, 'Mercury', 'Villager', 'Wagon 4-Door'],
    [1967, 'Morgan', '4-Apr', 'Convertible 2-Door'],
    [1967, 'Morgan', '4/4 Series V', 'Convertible 2-Door'],
    [1967, 'Oldsmobile', '442', 'Convertible 2-Door'],
    [1967, 'Oldsmobile', '442', 'Hardtop 2-Door'],
    [1967, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1967, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1967, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1967, 'Pontiac', 'Executive', 'Wagon 4-Door'],
    [1967, 'Pontiac', 'Firebird', 'Convertible 2-Door'],
    [1967, 'Pontiac', 'Firebird', 'Coupe 2-Door'],
    [1967, 'Pontiac', 'Firebird', 'Hardtop 2-Door'],
    [1967, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1967, 'Porsche', '911', 'Coupe 2-Door'],
    [1967, 'Renault', 'R10', 'Sedan 4-Door'],
    [1967, 'Rover', '2000', 'Sedan 4-Door'],
    [1967, 'Saab', 'Monte Carlo', 'Sedan 2-Door'],
    [1967, 'Toyota', 'Corona', 'Hardtop 2-Door'],
    [1967, 'Toyota', 'Corona', 'Sedan 4-Door'],
    [1967, 'TVR', 'Tuscan', 'Coupe 2-Door'],
    [1967, 'TVR', 'Vixen', 'Coupe 2-Door'],
    [1967, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1967, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1966, 'AC', 'Shelby Cobra', 'Convertible 2-Door'],
    [1966, 'Alfa Romeo', '2600', 'Convertible 2-Door'],
    [1966, 'Alfa Romeo', '2600', 'Coupe 2-Door'],
    [1966, 'Alfa Romeo', '2600', 'Sedan 4-Door'],
    [1966, 'Alfa Romeo', 'Giulia', 'Convertible 2-Door'],
    [1966, 'Alfa Romeo', 'Giulia', 'Coupe 2-Door'],
    [1966, 'Alfa Romeo', 'Giulia', 'Sedan 2-Door'],
    [1966, 'Alfa Romeo', 'Giulia Sprint', 'Coupe 2-Door'],
    [1966, 'Alfa Romeo', 'GTA', 'Coupe 2-Door'],
    [1966, 'Alfa Romeo', 'GTC', 'Convertible 2-Door'],
    [1966, 'AMC', 'Ambassador', 'Convertible 2-Door'],
    [1966, 'AMC', 'Ambassador', 'Sedan 2-Door'],
    [1966, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1966, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1966, 'Avanti', 'II', 'Coupe 2-Door'],
    [1966, 'Bentley', 'T1 Series', 'Convertible 2-Door'],
    [1966, 'Bentley', 'T1 Series', 'Coupe 2-Door'],
    [1966, 'Bentley', 'T1 Series', 'Sedan 2-Door'],
    [1966, 'BMW', '2000', 'Sedan 4-Door'],
    [1966, 'BMW', '2002', 'Sedan 2-Door'],
    [1966, 'BMW', '1600-2', 'Sedan 2-Door'],
    [1966, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1966, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1966, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1966, 'Buick', 'Gran Sport', 'Convertible 2-Door'],
    [1966, 'Buick', 'Gran Sport', 'Coupe 2-Door'],
    [1966, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1966, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1966, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1966, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1966, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1966, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1966, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1966, 'Buick', 'Skylark', 'Hardtop 4-Door'],
    [1966, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1966, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1966, 'Cadillac', 'Calais', 'Limousine 4-Door'],
    [1966, 'Cadillac', 'Calais', 'Sedan 4-Door'],
    [1966, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1966, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1966, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1966, 'Cadillac', 'DeVille', 'Convertible 2-Door'],
    [1966, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1966, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1966, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1966, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1966, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1966, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1966, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1966, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1966, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1966, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1966, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1966, 'Chevrolet', 'Caprice', 'Hardtop 2-Door'],
    [1966, 'Chevrolet', 'Caprice', 'Hardtop 4-Door'],
    [1966, 'Chevrolet', 'Caprice', 'Wagon 4-Door'],
    [1966, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1966, 'Chevrolet', 'Chevelle', 'Hardtop 2-Door'],
    [1966, 'Chevrolet', 'Chevelle', 'Sedan 2-Door'],
    [1966, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1966, 'Chevrolet', 'Chevelle', 'Wagon 2-Door'],
    [1966, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1966, 'Chevrolet', 'Chevy II', 'Hardtop 2-Door'],
    [1966, 'Chevrolet', 'Chevy II', 'Sedan 2-Door'],
    [1966, 'Chevrolet', 'Chevy II', 'Sedan 4-Door'],
    [1966, 'Chevrolet', 'Chevy II', 'Wagon 4-Door'],
    [1966, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1966, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1966, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1966, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1966, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1966, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1966, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1966, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1966, 'Chevrolet', 'Malibu', 'Convertible 2-Door'],
    [1966, 'Chevrolet', 'Malibu', 'Hardtop 2-Door'],
    [1966, 'Chevrolet', 'Malibu', 'Hardtop 4-Door'],
    [1966, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1966, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1966, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1966, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1966, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1966, 'Chrysler', 'Newport', 'Convertible 2-Door'],
    [1966, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1966, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1966, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1966, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1966, 'Dodge', 'Charger', 'Hardtop 2-Door'],
    [1966, 'Dodge', 'Coronet', 'Convertible 2-Door'],
    [1966, 'Dodge', 'Coronet', 'Hardtop 2-Door'],
    [1966, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1966, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1966, 'Dodge', 'Dart', 'Convertible 2-Door'],
    [1966, 'Dodge', 'Dart', 'Hardtop 2-Door'],
    [1966, 'Dodge', 'Dart', 'Sedan 2-Door'],
    [1966, 'Dodge', 'Dart', 'Sedan 4-Door'],
    [1966, 'Dodge', 'Dart', 'Wagon 4-Door'],
    [1966, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1966, 'Ford', 'Anglia', 'Wagon 2-Door'],
    [1966, 'Ford', 'Bronco', 'Standard Cab Pickup 2-Door'],
    [1966, 'Ford', 'Bronco', 'SUV 2-Door'],
    [1966, 'Ford', 'Cortina', 'Sedan 2-Door'],
    [1966, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1966, 'Ford', 'Custom 500', 'Sedan 2-Door'],
    [1966, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1966, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1966, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1966, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1966, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1966, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1966, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1966, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1966, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1966, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1966, 'Jeep', 'CJ5', 'SUV 2-Door'],
    [1966, 'Jeep', 'CJ6', 'SUV 2-Door'],
    [1966, 'Jeep', 'Gladiator', 'Standard Cab Pickup 2-Door'],
    [1966, 'Jeep', 'J-100', 'SUV 2-Door'],
    [1966, 'Jeep', 'J-100', 'SUV 4-Door'],
    [1966, 'Jeep', 'M151', 'SUV 2-Door'],
    [1966, 'Jeep', 'Wagoneer', 'SUV 2-Door'],
    [1966, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1966, 'Mercury', 'Capri', 'Coupe 2-Door'],
    [1966, 'Mercury', 'Capri', 'Sedan 4-Door'],
    [1966, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1966, 'Mercury', 'Comet', 'Convertible 2-Door'],
    [1966, 'Mercury', 'Comet', 'Hardtop 2-Door'],
    [1966, 'Mercury', 'Comet', 'Sedan 4-Door'],
    [1966, 'Mercury', 'Comet', 'Wagon 4-Door'],
    [1966, 'Mercury', 'Villager', 'Wagon 4-Door'],
    [1966, 'Morgan', '4/4 Series V', 'Convertible 2-Door'],
    [1966, 'Oldsmobile', '442', 'Convertible 2-Door'],
    [1966, 'Oldsmobile', '442', 'Hardtop 2-Door'],
    [1966, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1966, 'Peugeot', '403', 'Sedan 4-Door'],
    [1966, 'Peugeot', '403', 'Wagon 4-Door'],
    [1966, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1966, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1966, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1966, 'Renault', 'R8', 'Sedan 4-Door'],
    [1966, 'Rover', '2000', 'Sedan 4-Door'],
    [1966, 'Saab', 'Monte Carlo', 'Sedan 2-Door'],
    [1966, 'Toyota', 'Crown', 'Sedan 4-Door'],
    [1966, 'Toyota', 'Crown', 'Wagon 4-Door'],
    [1966, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1966, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1965, 'AC', 'Shelby Cobra', 'Convertible 2-Door'],
    [1965, 'AC', 'Shelby Cobra', 'Coupe 2-Door'],
    [1965, 'Alfa Romeo', '2600', 'Convertible 2-Door'],
    [1965, 'Alfa Romeo', '2600', 'Coupe 2-Door'],
    [1965, 'Alfa Romeo', '2600', 'Sedan 4-Door'],
    [1965, 'Alfa Romeo', 'Giulia', 'Convertible 2-Door'],
    [1965, 'Alfa Romeo', 'Giulia', 'Coupe 2-Door'],
    [1965, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [1965, 'Alfa Romeo', 'Giulia Sprint', 'Coupe 2-Door'],
    [1965, 'Alfa Romeo', 'GTA', 'Coupe 2-Door'],
    [1965, 'Alfa Romeo', 'GTC', 'Convertible 2-Door'],
    [1965, 'AMC', 'Ambassador', 'Sedan 2-Door'],
    [1965, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1965, 'AMC', 'Ambassador', 'Wagon 2-Door'],
    [1965, 'Avanti', 'II', 'Coupe 2-Door'],
    [1965, 'Bentley', 'S3 Series', 'Coupe 2-Door'],
    [1965, 'Bentley', 'S3 Series', 'Limousine 4-Door'],
    [1965, 'Bentley', 'S3 Series', 'Sedan 2-Door'],
    [1965, 'Bentley', 'S3 Series', 'Sedan 4-Door'],
    [1965, 'Buick', 'Electra', 'Convertible 2-Door'],
    [1965, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1965, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1965, 'Buick', 'Gran Sport', 'Convertible 2-Door'],
    [1965, 'Buick', 'Gran Sport', 'Coupe 2-Door'],
    [1965, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1965, 'Buick', 'LeSabre', 'Coupe 2-Door'],
    [1965, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1965, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1965, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1965, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1965, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1965, 'Buick', 'Skylark', 'Sedan 2-Door'],
    [1965, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1965, 'Cadillac', 'Calais', 'Hardtop 2-Door'],
    [1965, 'Cadillac', 'Calais', 'Hardtop 4-Door'],
    [1965, 'Cadillac', 'Calais', 'Limousine 4-Door'],
    [1965, 'Cadillac', 'Calais', 'Sedan 4-Door'],
    [1965, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1965, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1965, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1965, 'Cadillac', 'DeVille', 'Convertible 2-Door'],
    [1965, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1965, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1965, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1965, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1965, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1965, 'Cadillac', 'Fleetwood', 'Hardtop 4-Door'],
    [1965, 'Cadillac', 'Fleetwood', 'Limousine 4-Door'],
    [1965, 'Cadillac', 'Fleetwood', 'Sedan 4-Door'],
    [1965, 'Checker', 'Marathon', 'Sedan 4-Door'],
    [1965, 'Checker', 'Marathon', 'Wagon 4-Door'],
    [1965, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1965, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1965, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1965, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1965, 'Chevrolet', 'Chevelle', 'Hardtop 2-Door'],
    [1965, 'Chevrolet', 'Chevelle', 'Sedan 2-Door'],
    [1965, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1965, 'Chevrolet', 'Chevelle', 'Wagon 2-Door'],
    [1965, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1965, 'Chevrolet', 'Chevy II', 'Hardtop 2-Door'],
    [1965, 'Chevrolet', 'Chevy II', 'Sedan 2-Door'],
    [1965, 'Chevrolet', 'Chevy II', 'Sedan 4-Door'],
    [1965, 'Chevrolet', 'Chevy II', 'Wagon 4-Door'],
    [1965, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1965, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1965, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1965, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1965, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1965, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1965, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1965, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1965, 'Chevrolet', 'Malibu', 'Convertible 2-Door'],
    [1965, 'Chevrolet', 'Malibu', 'Hardtop 2-Door'],
    [1965, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1965, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1965, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1965, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1965, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1965, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1965, 'Chrysler', 'Newport', 'Convertible 2-Door'],
    [1965, 'Chrysler', 'Newport', 'Hardtop 2-Door'],
    [1965, 'Chrysler', 'Newport', 'Hardtop 4-Door'],
    [1965, 'Chrysler', 'Newport', 'Sedan 4-Door'],
    [1965, 'Chrysler', 'Newport', 'Wagon 4-Door'],
    [1965, 'Dodge', 'Coronet', 'Convertible 2-Door'],
    [1965, 'Dodge', 'Coronet', 'Hardtop 2-Door'],
    [1965, 'Dodge', 'Coronet', 'Sedan 4-Door'],
    [1965, 'Dodge', 'Coronet', 'Wagon 4-Door'],
    [1965, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1965, 'Ford', 'Anglia', 'Wagon 2-Door'],
    [1965, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1965, 'Ford', 'Custom 500', 'Sedan 2-Door'],
    [1965, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1965, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1965, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1965, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1965, 'Ford', 'Falcon Sedan Delivery', 'Sedan Delivery 2-Door'],
    [1965, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1965, 'Ford', 'Mustang', 'Fastback 2-Door'],
    [1965, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1965, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1965, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1965, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1965, 'Jeep', 'Gladiator', 'Standard Cab Pickup 2-Door'],
    [1965, 'Jeep', 'J-100', 'SUV 2-Door'],
    [1965, 'Jeep', 'J-100', 'SUV 4-Door'],
    [1965, 'Jeep', 'M151', 'SUV 2-Door'],
    [1965, 'Jeep', 'Wagoneer', 'SUV 2-Door'],
    [1965, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1965, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1965, 'Mercury', 'Villager', 'Wagon 4-Door'],
    [1965, 'Morgan', '4/4 Series V', 'Convertible 2-Door'],
    [1965, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1965, 'Peugeot', '403', 'Sedan 4-Door'],
    [1965, 'Peugeot', '403', 'Wagon 4-Door'],
    [1965, 'Pontiac', 'Bonneville', 'Hardtop 2-Door'],
    [1965, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1965, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1965, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1965, 'Renault', 'R8', 'Sedan 4-Door'],
    [1965, 'Rover', '2000', 'Sedan 4-Door'],
    [1965, 'Toyota', 'Crown', 'Sedan 4-Door'],
    [1965, 'Toyota', 'Crown', 'Wagon 4-Door'],
    [1965, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1965, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1964, 'AC', 'Shelby Cobra', 'Convertible 2-Door'],
    [1964, 'AC', 'Shelby Cobra', 'Coupe 2-Door'],
    [1964, 'Alfa Romeo', '2600', 'Convertible 2-Door'],
    [1964, 'Alfa Romeo', '2600', 'Coupe 2-Door'],
    [1964, 'Alfa Romeo', '2600', 'Sedan 4-Door'],
    [1964, 'Alfa Romeo', 'Giulia', 'Convertible 2-Door'],
    [1964, 'Alfa Romeo', 'Giulia', 'Coupe 2-Door'],
    [1964, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [1964, 'Alfa Romeo', 'Giulia Sprint', 'Coupe 2-Door'],
    [1964, 'Alfa Romeo', 'GTC', 'Convertible 2-Door'],
    [1964, 'AMC', 'Ambassador', 'Sedan 2-Door'],
    [1964, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1964, 'AMC', 'Ambassador', 'Wagon 2-Door'],
    [1964, 'Bentley', 'S3 Series', 'Coupe 2-Door'],
    [1964, 'Bentley', 'S3 Series', 'Limousine 4-Door'],
    [1964, 'Bentley', 'S3 Series', 'Sedan 2-Door'],
    [1964, 'Bentley', 'S3 Series', 'Sedan 4-Door'],
    [1964, 'Buick', 'Electra', 'Convertible 2-Door'],
    [1964, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1964, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1964, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1964, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1964, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1964, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1964, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1964, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1964, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1964, 'Buick', 'Skylark', 'Sedan 4-Door'],
    [1964, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1964, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1964, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1964, 'Cadillac', 'DeVille', 'Convertible 2-Door'],
    [1964, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1964, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1964, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1964, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1964, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1964, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1964, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1964, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1964, 'Chevrolet', 'Chevelle', 'Convertible 2-Door'],
    [1964, 'Chevrolet', 'Chevelle', 'Sedan 2-Door'],
    [1964, 'Chevrolet', 'Chevelle', 'Sedan 4-Door'],
    [1964, 'Chevrolet', 'Chevelle', 'Wagon 2-Door'],
    [1964, 'Chevrolet', 'Chevelle', 'Wagon 4-Door'],
    [1964, 'Chevrolet', 'Chevy II', 'Hardtop 2-Door'],
    [1964, 'Chevrolet', 'Chevy II', 'Sedan 2-Door'],
    [1964, 'Chevrolet', 'Chevy II', 'Sedan 4-Door'],
    [1964, 'Chevrolet', 'Chevy II', 'Wagon 4-Door'],
    [1964, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1964, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1964, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1964, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1964, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1964, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1964, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1964, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1964, 'Chevrolet', 'Malibu', 'Convertible 2-Door'],
    [1964, 'Chevrolet', 'Malibu', 'Hardtop 2-Door'],
    [1964, 'Chevrolet', 'Malibu', 'Sedan 4-Door'],
    [1964, 'Chevrolet', 'Malibu', 'Wagon 2-Door'],
    [1964, 'Chevrolet', 'Malibu', 'Wagon 4-Door'],
    [1964, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1964, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1964, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1964, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1964, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1964, 'Ford', 'Anglia', 'Sedan 4-Door'],
    [1964, 'Ford', 'Anglia', 'Wagon 2-Door'],
    [1964, 'Ford', 'Cortina', 'Coupe 2-Door'],
    [1964, 'Ford', 'Cortina', 'Sedan 4-Door'],
    [1964, 'Ford', 'Cortina', 'Wagon 2-Door'],
    [1964, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1964, 'Ford', 'Custom 500', 'Sedan 2-Door'],
    [1964, 'Ford', 'Custom 500', 'Sedan 4-Door'],
    [1964, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1964, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1964, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1964, 'Ford', 'Falcon Sedan Delivery', 'Sedan Delivery 2-Door'],
    [1964, 'Ford', 'Mustang', 'Convertible 2-Door'],
    [1964, 'Ford', 'Mustang', 'Hardtop 2-Door'],
    [1964, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1964, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1964, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1964, 'Jeep', 'F-134', 'Standard Cab Pickup 2-Door'],
    [1964, 'Jeep', 'F-134', 'SUV 2-Door'],
    [1964, 'Jeep', 'F-134', 'Wagon 2-Door'],
    [1964, 'Jeep', 'Gladiator', 'Standard Cab Pickup 2-Door'],
    [1964, 'Jeep', 'J-100', 'SUV 2-Door'],
    [1964, 'Jeep', 'J-100', 'SUV 4-Door'],
    [1964, 'Jeep', 'M151', 'SUV 2-Door'],
    [1964, 'Jeep', 'Wagoneer', 'SUV 2-Door'],
    [1964, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1964, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1964, 'Mercury', 'Villager', 'Wagon 4-Door'],
    [1964, 'Morgan', '4/4 Series V', 'Convertible 2-Door'],
    [1964, 'Morris', 'Oxford', 'Sedan 4-Door'],
    [1964, 'Oldsmobile', 'Vista Cruiser', 'Wagon 4-Door'],
    [1964, 'Peugeot', '403', 'Sedan 4-Door'],
    [1964, 'Peugeot', '403', 'Wagon 4-Door'],
    [1964, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1964, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1964, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1964, 'Renault', 'R8', 'Sedan 4-Door'],
    [1964, 'Rover', '2000', 'Sedan 4-Door'],
    [1964, 'Studebaker', 'Challenger', 'Sedan 2-Door'],
    [1964, 'Studebaker', 'Challenger', 'Sedan 4-Door'],
    [1964, 'Studebaker', 'Challenger', 'Wagon 4-Door'],
    [1964, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1964, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1963, 'AC', 'Shelby Cobra', 'Convertible 2-Door'],
    [1963, 'Alfa Romeo', '2600', 'Convertible 2-Door'],
    [1963, 'Alfa Romeo', '2600', 'Coupe 2-Door'],
    [1963, 'Alfa Romeo', '2600', 'Sedan 4-Door'],
    [1963, 'Alfa Romeo', 'Giulia', 'Convertible 2-Door'],
    [1963, 'Alfa Romeo', 'Giulia', 'Coupe 2-Door'],
    [1963, 'Alfa Romeo', 'Giulia', 'Sedan 4-Door'],
    [1963, 'Alfa Romeo', 'Giulia Sprint', 'Coupe 2-Door'],
    [1963, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1963, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1963, 'AMC', 'Ambassador', 'Sedan 2-Door'],
    [1963, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1963, 'AMC', 'Ambassador', 'Wagon 2-Door'],
    [1963, 'AMC', 'Classic', 'Sedan 2-Door'],
    [1963, 'AMC', 'Classic', 'Sedan 4-Door'],
    [1963, 'AMC', 'Classic', 'Wagon 4-Door'],
    [1963, 'Bentley', 'S3 Series', 'Coupe 2-Door'],
    [1963, 'Bentley', 'S3 Series', 'Limousine 4-Door'],
    [1963, 'Bentley', 'S3 Series', 'Sedan 2-Door'],
    [1963, 'Bentley', 'S3 Series', 'Sedan 4-Door'],
    [1963, 'Buick', 'Electra', 'Convertible 2-Door'],
    [1963, 'Buick', 'Electra', 'Coupe 2-Door'],
    [1963, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1963, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1963, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1963, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1963, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1963, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1963, 'Buick', 'Riviera', 'Hardtop 2-Door'],
    [1963, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1963, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1963, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1963, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1963, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1963, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1963, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1963, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1963, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1963, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1963, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1963, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1963, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1963, 'Chevrolet', 'Chevy II', 'Convertible 2-Door'],
    [1963, 'Chevrolet', 'Chevy II', 'Hardtop 2-Door'],
    [1963, 'Chevrolet', 'Chevy II', 'Sedan 4-Door'],
    [1963, 'Chevrolet', 'Chevy II', 'Wagon 4-Door'],
    [1963, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1963, 'Chevrolet', 'Corvette', 'Coupe 2-Door'],
    [1963, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1963, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1963, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1963, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1963, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1963, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1963, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1963, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1963, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1963, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1963, 'Ford', 'Anglia', 'Wagon 2-Door'],
    [1963, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1963, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1963, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1963, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1963, 'Ford', 'Falcon Sedan Delivery', 'Sedan Delivery 2-Door'],
    [1963, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1963, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1963, 'Ford', 'Zephyr', 'Sedan 4-Door'],
    [1963, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1963, 'Jeep', 'F-134', 'Standard Cab Pickup 2-Door'],
    [1963, 'Jeep', 'F-134', 'SUV 2-Door'],
    [1963, 'Jeep', 'F-134', 'Wagon 2-Door'],
    [1963, 'Jeep', 'Gladiator', 'Standard Cab Pickup 2-Door'],
    [1963, 'Jeep', 'J-100', 'SUV 2-Door'],
    [1963, 'Jeep', 'J-100', 'SUV 4-Door'],
    [1963, 'Jeep', 'M151', 'SUV 2-Door'],
    [1963, 'Jeep', 'Wagoneer', 'SUV 2-Door'],
    [1963, 'Jeep', 'Wagoneer', 'SUV 4-Door'],
    [1963, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1963, 'Mercury', 'Villager', 'Wagon 4-Door'],
    [1963, 'Morgan', '4/4 Series IV', 'Convertible 2-Door'],
    [1963, 'Morgan', '4/4 Series V', 'Convertible 2-Door'],
    [1963, 'Morris', 'Oxford', 'Sedan 4-Door'],
    [1963, 'Peugeot', '403', 'Sedan 4-Door'],
    [1963, 'Peugeot', '403', 'Wagon 4-Door'],
    [1963, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1963, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1963, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1963, 'Porsche', 'Carrera', 'Coupe 2-Door'],
    [1963, 'Renault', 'R8', 'Sedan 4-Door'],
    [1963, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1963, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1962, 'Alfa Romeo', '2000', 'Convertible 2-Door'],
    [1962, 'Alfa Romeo', '2600', 'Convertible 2-Door'],
    [1962, 'Alfa Romeo', '2600', 'Coupe 2-Door'],
    [1962, 'Alfa Romeo', '2600', 'Sedan 4-Door'],
    [1962, 'Alfa Romeo', 'Giulia', 'Convertible 2-Door'],
    [1962, 'Alfa Romeo', 'Giulia Sprint', 'Coupe 2-Door'],
    [1962, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1962, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1962, 'AMC', 'Ambassador', 'Sedan 2-Door'],
    [1962, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1962, 'AMC', 'Ambassador', 'Wagon 2-Door'],
    [1962, 'Bentley', 'S3 Series', 'Coupe 2-Door'],
    [1962, 'Bentley', 'S3 Series', 'Limousine 4-Door'],
    [1962, 'Bentley', 'S3 Series', 'Sedan 2-Door'],
    [1962, 'Bentley', 'S3 Series', 'Sedan 4-Door'],
    [1962, 'Buick', 'Electra', 'Convertible 2-Door'],
    [1962, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1962, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1962, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1962, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1962, 'Buick', 'LeSabre', 'Sedan 2-Door'],
    [1962, 'Buick', 'LeSabre', 'Sedan 4-Door'],
    [1962, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1962, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1962, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1962, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1962, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1962, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1962, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1962, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1962, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1962, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1962, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1962, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1962, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1962, 'Chevrolet', 'Chevy II', 'Convertible 2-Door'],
    [1962, 'Chevrolet', 'Chevy II', 'Hardtop 2-Door'],
    [1962, 'Chevrolet', 'Chevy II', 'Sedan 2-Door'],
    [1962, 'Chevrolet', 'Chevy II', 'Sedan 4-Door'],
    [1962, 'Chevrolet', 'Chevy II', 'Wagon 4-Door'],
    [1962, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1962, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1962, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1962, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1962, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1962, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1962, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1962, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1962, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1962, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1962, 'Ford', 'Anglia', 'Wagon 2-Door'],
    [1962, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1962, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1962, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1962, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1962, 'Ford', 'Falcon Sedan Delivery', 'Sedan Delivery 2-Door'],
    [1962, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1962, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1962, 'Ford', 'Zephyr', 'Sedan 4-Door'],
    [1962, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1962, 'Jeep', 'F-134', 'Standard Cab Pickup 2-Door'],
    [1962, 'Jeep', 'F-134', 'SUV 2-Door'],
    [1962, 'Jeep', 'F-134', 'Wagon 2-Door'],
    [1962, 'Jeep', 'Gladiator', 'Standard Cab Pickup 2-Door'],
    [1962, 'Jeep', 'M151', 'SUV 2-Door'],
    [1962, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1962, 'Mercury', 'Villager', 'Wagon 4-Door'],
    [1962, 'Morgan', '4/4 Series IV', 'Convertible 2-Door'],
    [1962, 'Morris', 'Oxford', 'Sedan 4-Door'],
    [1962, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1962, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1962, 'Pontiac', 'Tempest', 'Convertible 2-Door'],
    [1962, 'Pontiac', 'Tempest', 'Coupe 2-Door'],
    [1962, 'Pontiac', 'Tempest', 'Sedan 2-Door'],
    [1962, 'Pontiac', 'Tempest', 'Sedan 4-Door'],
    [1962, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1962, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1962, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1961, 'Alfa Romeo', '2000', 'Convertible 2-Door'],
    [1961, 'Alfa Romeo', '2000', 'Coupe 2-Door'],
    [1961, 'Alfa Romeo', '2000', 'Sedan 4-Door'],
    [1961, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1961, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1961, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1961, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1961, 'Bentley', 'S2 Series', 'Coupe 2-Door'],
    [1961, 'Bentley', 'S2 Series', 'Limousine 4-Door'],
    [1961, 'Bentley', 'S2 Series', 'Sedan 2-Door'],
    [1961, 'Bentley', 'S2 Series', 'Sedan 4-Door'],
    [1961, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1961, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1961, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1961, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1961, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1961, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1961, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1961, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1961, 'Buick', 'Skylark', 'Hardtop 2-Door'],
    [1961, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1961, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1961, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1961, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1961, 'Cadillac', 'DeVille', 'Limousine 4-Door'],
    [1961, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1961, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1961, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1961, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1961, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1961, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1961, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1961, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1961, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1961, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1961, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1961, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1961, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1961, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1961, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1961, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1961, 'DeSoto', 'Adventurer', 'Hardtop 2-Door'],
    [1961, 'DeSoto', 'Adventurer', 'Hardtop 4-Door'],
    [1961, 'DeSoto', 'Adventurer', 'Sedan 4-Door'],
    [1961, 'DeSoto', 'DeSoto', 'Hardtop 2-Door'],
    [1961, 'DeSoto', 'DeSoto', 'Hardtop 4-Door'],
    [1961, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1961, 'Ford', 'Anglia', 'Wagon 2-Door'],
    [1961, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1961, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1961, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1961, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1961, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1961, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1961, 'Ford', 'Falcon Sedan Delivery', 'Sedan Delivery 2-Door'],
    [1961, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1961, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1961, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1961, 'Ford', 'Zephyr', 'Convertible 2-Door'],
    [1961, 'Ford', 'Zephyr', 'Sedan 4-Door'],
    [1961, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1961, 'Jeep', 'F-134', 'Standard Cab Pickup 2-Door'],
    [1961, 'Jeep', 'F-134', 'SUV 2-Door'],
    [1961, 'Jeep', 'F-134', 'Wagon 2-Door'],
    [1961, 'Jeep', 'M151', 'SUV 2-Door'],
    [1961, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1961, 'Morgan', '4/4 Series III', 'Convertible 2-Door'],
    [1961, 'Morgan', '4/4 Series IV', 'Convertible 2-Door'],
    [1961, 'Morris', 'Oxford', 'Sedan 4-Door'],
    [1961, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1961, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1961, 'Pontiac', 'Tempest', 'Sedan 2-Door'],
    [1961, 'Pontiac', 'Tempest', 'Sedan 4-Door'],
    [1961, 'Pontiac', 'Tempest', 'Wagon 4-Door'],
    [1961, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1961, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1960, 'Alfa Romeo', '2000', 'Convertible 2-Door'],
    [1960, 'Alfa Romeo', '2000', 'Coupe 2-Door'],
    [1960, 'Alfa Romeo', '2000', 'Sedan 4-Door'],
    [1960, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1960, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1960, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1960, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1960, 'Bentley', 'S2 Series', 'Coupe 2-Door'],
    [1960, 'Bentley', 'S2 Series', 'Limousine 4-Door'],
    [1960, 'Bentley', 'S2 Series', 'Sedan 2-Door'],
    [1960, 'Bentley', 'S2 Series', 'Sedan 4-Door'],
    [1960, 'Buick', 'Electra', 'Hardtop 2-Door'],
    [1960, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1960, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1960, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1960, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1960, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1960, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1960, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1960, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1960, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1960, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1960, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1960, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1960, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1960, 'Cadillac', 'Eldorado', 'Hardtop 4-Door'],
    [1960, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1960, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1960, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1960, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1960, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1960, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1960, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1960, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1960, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1960, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1960, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1960, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1960, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1960, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1960, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1960, 'DeSoto', 'Adventurer', 'Hardtop 2-Door'],
    [1960, 'DeSoto', 'Adventurer', 'Hardtop 4-Door'],
    [1960, 'DeSoto', 'Adventurer', 'Sedan 4-Door'],
    [1960, 'DeSoto', 'Fireflite', 'Hardtop 2-Door'],
    [1960, 'DeSoto', 'Fireflite', 'Hardtop 4-Door'],
    [1960, 'DeSoto', 'Fireflite', 'Sedan 4-Door'],
    [1960, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1960, 'Ford', 'Anglia', 'Wagon 2-Door'],
    [1960, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1960, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1960, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1960, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1960, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1960, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1960, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1960, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1960, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1960, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1960, 'Jeep', 'F-134', 'Standard Cab Pickup 2-Door'],
    [1960, 'Jeep', 'F-134', 'SUV 2-Door'],
    [1960, 'Jeep', 'F-134', 'Wagon 2-Door'],
    [1960, 'Jeep', 'M151', 'SUV 2-Door'],
    [1960, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1960, 'Morgan', '4/4 Series III', 'Convertible 2-Door'],
    [1960, 'Morris', 'Oxford', 'Sedan 4-Door'],
    [1960, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1960, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1960, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1960, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1959, 'Alfa Romeo', '2000', 'Convertible 2-Door'],
    [1959, 'Alfa Romeo', '2000', 'Sedan 4-Door'],
    [1959, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1959, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1959, 'Alfa Romeo', 'Giulietta', 'Sedan 4-Door'],
    [1959, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1959, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1959, 'Bentley', 'S2 Series', 'Coupe 2-Door'],
    [1959, 'Bentley', 'S2 Series', 'Limousine 4-Door'],
    [1959, 'Bentley', 'S2 Series', 'Sedan 2-Door'],
    [1959, 'Bentley', 'S2 Series', 'Sedan 4-Door'],
    [1959, 'Buick', 'Electra', 'Convertible 2-Door'],
    [1959, 'Buick', 'Electra', 'Hardtop 4-Door'],
    [1959, 'Buick', 'Electra', 'Sedan 4-Door'],
    [1959, 'Buick', 'LeSabre', 'Convertible 2-Door'],
    [1959, 'Buick', 'LeSabre', 'Hardtop 2-Door'],
    [1959, 'Buick', 'LeSabre', 'Hardtop 4-Door'],
    [1959, 'Buick', 'LeSabre', 'Wagon 4-Door'],
    [1959, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1959, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1959, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1959, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1959, 'Cadillac', 'DeVille', 'Sedan 4-Door'],
    [1959, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1959, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1959, 'Cadillac', 'Eldorado', 'Hardtop 4-Door'],
    [1959, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1959, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1959, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1959, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1959, 'Chevrolet', 'El Camino', 'Standard Cab Pickup 2-Door'],
    [1959, 'Chevrolet', 'Impala', 'Convertible 2-Door'],
    [1959, 'Chevrolet', 'Impala', 'Hardtop 2-Door'],
    [1959, 'Chevrolet', 'Impala', 'Hardtop 4-Door'],
    [1959, 'Chevrolet', 'Impala', 'Sedan 4-Door'],
    [1959, 'Chevrolet', 'Impala', 'Wagon 4-Door'],
    [1959, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1959, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1959, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1959, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1959, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1959, 'DeSoto', 'Adventurer', 'Convertible 2-Door'],
    [1959, 'DeSoto', 'Adventurer', 'Hardtop 2-Door'],
    [1959, 'DeSoto', 'Firedome', 'Convertible 2-Door'],
    [1959, 'DeSoto', 'Firedome', 'Hardtop 2-Door'],
    [1959, 'DeSoto', 'Firedome', 'Hardtop 4-Door'],
    [1959, 'DeSoto', 'Firedome', 'Sedan 4-Door'],
    [1959, 'DeSoto', 'Fireflite', 'Convertible 2-Door'],
    [1959, 'DeSoto', 'Fireflite', 'Hardtop 2-Door'],
    [1959, 'DeSoto', 'Fireflite', 'Hardtop 4-Door'],
    [1959, 'DeSoto', 'Fireflite', 'Sedan 4-Door'],
    [1959, 'DeSoto', 'Fireflite', 'Wagon 4-Door'],
    [1959, 'DeSoto', 'Firesweep', 'Convertible 2-Door'],
    [1959, 'DeSoto', 'Firesweep', 'Hardtop 2-Door'],
    [1959, 'DeSoto', 'Firesweep', 'Hardtop 4-Door'],
    [1959, 'DeSoto', 'Firesweep', 'Sedan 4-Door'],
    [1959, 'DeSoto', 'Firesweep', 'Wagon 4-Door'],
    [1959, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1959, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1959, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1959, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1959, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1959, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1959, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1959, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1959, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1959, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1959, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1959, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1959, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1959, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1959, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1959, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1959, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1959, 'Jeep', 'F-134', 'Standard Cab Pickup 2-Door'],
    [1959, 'Jeep', 'F-134', 'SUV 2-Door'],
    [1959, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1959, 'Morgan', '4/4 Series II', 'Convertible 2-Door'],
    [1959, 'Morris', 'Oxford', 'Sedan 4-Door'],
    [1959, 'Pontiac', 'Bonneville', 'Wagon 4-Door'],
    [1959, 'Pontiac', 'Catalina', 'Wagon 4-Door'],
    [1959, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1959, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1958, 'Alfa Romeo', '2000', 'Convertible 2-Door'],
    [1958, 'Alfa Romeo', '2000', 'Sedan 4-Door'],
    [1958, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1958, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1958, 'Alfa Romeo', 'Giulietta', 'Sedan 4-Door'],
    [1958, 'AMC', 'Ambassador', 'Sedan 4-Door'],
    [1958, 'AMC', 'Ambassador', 'Wagon 4-Door'],
    [1958, 'Bentley', 'S1 Series', 'Coupe 2-Door'],
    [1958, 'Bentley', 'S1 Series', 'Sedan 2-Door'],
    [1958, 'Bentley', 'S1 Series', 'Sedan 4-Door'],
    [1958, 'Buick', 'Century', 'Convertible 2-Door'],
    [1958, 'Buick', 'Century', 'Hardtop 2-Door'],
    [1958, 'Buick', 'Century', 'Sedan 4-Door'],
    [1958, 'Buick', 'Century', 'Wagon 4-Door'],
    [1958, 'Buick', 'Limited', 'Convertible 2-Door'],
    [1958, 'Buick', 'Limited', 'Hardtop 2-Door'],
    [1958, 'Buick', 'Limited', 'Hardtop 4-Door'],
    [1958, 'Buick', 'Roadmaster', 'Convertible 2-Door'],
    [1958, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1958, 'Buick', 'Roadmaster', 'Hardtop 4-Door'],
    [1958, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1958, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1958, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1958, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1958, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1958, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1958, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1958, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1958, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1958, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1958, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1958, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1958, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1958, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1958, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1958, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1958, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1958, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1958, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1958, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1958, 'Dodge', 'D300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1958, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1958, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1958, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1958, 'Edsel', 'Bermuda', 'Wagon 4-Door'],
    [1958, 'Edsel', 'Roundup', 'Wagon 2-Door'],
    [1958, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1958, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1958, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1958, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1958, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1958, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1958, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1958, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1958, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1958, 'Ford', 'Thunderbird', 'Hardtop 2-Door'],
    [1958, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1958, 'Jeep', 'F-134', 'Standard Cab Pickup 2-Door'],
    [1958, 'Jeep', 'F-134', 'SUV 2-Door'],
    [1958, 'Jeep', 'Willys', 'SUV 2-Door'],
    [1958, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1958, 'Morgan', '4/4 Series II', 'Convertible 2-Door'],
    [1958, 'Packard', 'Packard', 'Coupe 2-Door'],
    [1958, 'Packard', 'Packard', 'Sedan 4-Door'],
    [1958, 'Packard', 'Packard', 'Wagon 4-Door'],
    [1958, 'Pontiac', 'Chieftain', 'Wagon 4-Door'],
    [1958, 'Pontiac', 'Star Chief', 'Wagon 4-Door'],
    [1958, 'Studebaker', 'Scotsman', 'Standard Cab Pickup 2-Door'],
    [1958, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1958, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1957, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1957, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1957, 'Alfa Romeo', 'Giulietta', 'Sedan 4-Door'],
    [1957, 'Aston Martin', 'DB2-4', 'Coupe 2-Door'],
    [1957, 'Bentley', 'S1 Series', 'Coupe 2-Door'],
    [1957, 'Bentley', 'S1 Series', 'Sedan 2-Door'],
    [1957, 'Bentley', 'S1 Series', 'Sedan 4-Door'],
    [1957, 'Buick', 'Century', 'Convertible 2-Door'],
    [1957, 'Buick', 'Century', 'Hardtop 2-Door'],
    [1957, 'Buick', 'Century', 'Sedan 4-Door'],
    [1957, 'Buick', 'Century', 'Wagon 4-Door'],
    [1957, 'Buick', 'Roadmaster', 'Convertible 2-Door'],
    [1957, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1957, 'Buick', 'Roadmaster', 'Hardtop 4-Door'],
    [1957, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1957, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1957, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1957, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1957, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1957, 'Cadillac', 'Eldorado', 'Limousine 4-Door'],
    [1957, 'Cadillac', 'Eldorado', 'Sedan 4-Door'],
    [1957, 'Chevrolet', 'Bel Air', 'Convertible 2-Door'],
    [1957, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1957, 'Chevrolet', 'Bel Air', 'Hardtop 4-Door'],
    [1957, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1957, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1957, 'Chevrolet', 'Bel Air', 'Wagon 2-Door'],
    [1957, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1957, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1957, 'Chevrolet', 'Nomad', 'Wagon 2-Door'],
    [1957, 'Chevrolet', 'One-Fifty Series', 'Sedan 2-Door'],
    [1957, 'Chevrolet', 'One-Fifty Series', 'Sedan 4-Door'],
    [1957, 'Chevrolet', 'One-Fifty Series', 'Sedan Delivery 2-Door'],
    [1957, 'Chevrolet', 'One-Fifty Series', 'Wagon 2-Door'],
    [1957, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1957, 'Chevrolet', 'Two-Ten Series', 'Coupe 2-Door'],
    [1957, 'Chevrolet', 'Two-Ten Series', 'Sedan 2-Door'],
    [1957, 'Chevrolet', 'Two-Ten Series', 'Sedan 4-Door'],
    [1957, 'Chevrolet', 'Two-Ten Series', 'Wagon 4-Door'],
    [1957, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1957, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1957, 'Chrysler', 'Imperial', 'Hardtop 4-Door'],
    [1957, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1957, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1957, 'Dodge', 'D100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1957, 'Dodge', 'D200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1957, 'Dodge', 'W100 Pickup', 'Standard Cab Pickup 2-Door'],
    [1957, 'Dodge', 'W200 Pickup', 'Standard Cab Pickup 2-Door'],
    [1957, 'Dodge', 'W300 Pickup', 'Standard Cab Pickup 2-Door'],
    [1957, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1957, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1957, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1957, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1957, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1957, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1957, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1957, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1957, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1957, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1957, 'Jeep', 'F-134', 'Standard Cab Pickup 2-Door'],
    [1957, 'Jeep', 'F-134', 'SUV 2-Door'],
    [1957, 'Jeep', 'Willys', 'SUV 2-Door'],
    [1957, 'Mercury', 'Colony Park', 'Wagon 4-Door'],
    [1957, 'Morgan', '4/4 Series II', 'Convertible 2-Door'],
    [1957, 'Nash', 'Ambassador Custom', 'Coupe 2-Door'],
    [1957, 'Nash', 'Ambassador Custom', 'Sedan 4-Door'],
    [1957, 'Nash', 'Ambassador Custom', 'Wagon 4-Door'],
    [1957, 'Oldsmobile', '88', 'Hardtop 2-Door'],
    [1957, 'Oldsmobile', '88', 'Sedan 2-Door'],
    [1957, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1957, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1957, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1956, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1956, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1956, 'Alfa Romeo', 'Giulietta', 'Sedan 4-Door'],
    [1956, 'Aston Martin', 'DB2-4', 'Coupe 2-Door'],
    [1956, 'Bentley', 'S1 Series', 'Coupe 2-Door'],
    [1956, 'Bentley', 'S1 Series', 'Sedan 2-Door'],
    [1956, 'Bentley', 'S1 Series', 'Sedan 4-Door'],
    [1956, 'Buick', 'Century', 'Convertible 2-Door'],
    [1956, 'Buick', 'Century', 'Hardtop 2-Door'],
    [1956, 'Buick', 'Century', 'Sedan 4-Door'],
    [1956, 'Buick', 'Century', 'Wagon 4-Door'],
    [1956, 'Buick', 'Roadmaster', 'Convertible 2-Door'],
    [1956, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1956, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1956, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1956, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1956, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1956, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1956, 'Cadillac', 'DeVille', 'Hardtop 4-Door'],
    [1956, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1956, 'Cadillac', 'Eldorado', 'Hardtop 2-Door'],
    [1956, 'Chevrolet', 'Bel Air', 'Convertible 2-Door'],
    [1956, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1956, 'Chevrolet', 'Bel Air', 'Hardtop 4-Door'],
    [1956, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1956, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1956, 'Chevrolet', 'Bel Air', 'Wagon 2-Door'],
    [1956, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1956, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1956, 'Chevrolet', 'Nomad', 'Wagon 2-Door'],
    [1956, 'Chevrolet', 'One-Fifty Series', 'Sedan 2-Door'],
    [1956, 'Chevrolet', 'One-Fifty Series', 'Sedan 4-Door'],
    [1956, 'Chevrolet', 'One-Fifty Series', 'Sedan Delivery 2-Door'],
    [1956, 'Chevrolet', 'One-Fifty Series', 'Wagon 2-Door'],
    [1956, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1956, 'Chevrolet', 'Two-Ten Series', 'Coupe 2-Door'],
    [1956, 'Chevrolet', 'Two-Ten Series', 'Sedan 2-Door'],
    [1956, 'Chevrolet', 'Two-Ten Series', 'Sedan 4-Door'],
    [1956, 'Chevrolet', 'Two-Ten Series', 'Wagon 4-Door'],
    [1956, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1956, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1956, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1956, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1956, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1956, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1956, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1956, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1956, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1956, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1956, 'Jeep', 'Willys', 'SUV 2-Door'],
    [1956, 'Morgan', '4/4 Series II', 'Convertible 2-Door'],
    [1956, 'Nash', 'Ambassador Custom', 'Coupe 2-Door'],
    [1956, 'Nash', 'Ambassador Custom', 'Sedan 4-Door'],
    [1956, 'Oldsmobile', '88', 'Hardtop 2-Door'],
    [1956, 'Oldsmobile', '88', 'Sedan 2-Door'],
    [1956, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1956, 'Packard', 'Caribbean', 'Convertible 2-Door'],
    [1956, 'Packard', 'Four-Hundred', 'Coupe 2-Door'],
    [1956, 'Packard', 'Patrician', 'Sedan 4-Door'],
    [1956, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1956, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1955, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1955, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1955, 'Alfa Romeo', 'Giulietta', 'Sedan 4-Door'],
    [1955, 'Aston Martin', 'DB2-4', 'Coupe 2-Door'],
    [1955, 'Bentley', 'S1 Series', 'Coupe 2-Door'],
    [1955, 'Bentley', 'S1 Series', 'Sedan 2-Door'],
    [1955, 'Bentley', 'S1 Series', 'Sedan 4-Door'],
    [1955, 'Buick', 'Century', 'Convertible 2-Door'],
    [1955, 'Buick', 'Century', 'Hardtop 2-Door'],
    [1955, 'Buick', 'Century', 'Sedan 4-Door'],
    [1955, 'Buick', 'Century', 'Wagon 4-Door'],
    [1955, 'Buick', 'Roadmaster', 'Convertible 2-Door'],
    [1955, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1955, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1955, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1955, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1955, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1955, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1955, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1955, 'Chevrolet', 'Bel Air', 'Convertible 2-Door'],
    [1955, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1955, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1955, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1955, 'Chevrolet', 'Bel Air', 'Wagon 2-Door'],
    [1955, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1955, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1955, 'Chevrolet', 'Nomad', 'Wagon 2-Door'],
    [1955, 'Chevrolet', 'One-Fifty Series', 'Sedan 2-Door'],
    [1955, 'Chevrolet', 'One-Fifty Series', 'Sedan 4-Door'],
    [1955, 'Chevrolet', 'One-Fifty Series', 'Sedan Delivery 2-Door'],
    [1955, 'Chevrolet', 'One-Fifty Series', 'Wagon 2-Door'],
    [1955, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1955, 'Chevrolet', 'Two-Ten Series', 'Coupe 2-Door'],
    [1955, 'Chevrolet', 'Two-Ten Series', 'Sedan 2-Door'],
    [1955, 'Chevrolet', 'Two-Ten Series', 'Sedan 4-Door'],
    [1955, 'Chevrolet', 'Two-Ten Series', 'Wagon 2-Door'],
    [1955, 'Chevrolet', 'Two-Ten Series', 'Wagon 4-Door'],
    [1955, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1955, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1955, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1955, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1955, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1955, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1955, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1955, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1955, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1955, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1955, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1955, 'Ford', 'Thunderbird', 'Convertible 2-Door'],
    [1955, 'Hillman', 'Husky', 'Wagon 2-Door'],
    [1955, 'Hudson', 'Wasp', 'Coupe 2-Door'],
    [1955, 'Hudson', 'Wasp', 'Sedan 4-Door'],
    [1955, 'Morgan', '4/4 Series II', 'Convertible 2-Door'],
    [1955, 'Nash', 'Ambassador Custom', 'Coupe 2-Door'],
    [1955, 'Nash', 'Ambassador Custom', 'Sedan 4-Door'],
    [1955, 'Oldsmobile', '88', 'Hardtop 2-Door'],
    [1955, 'Oldsmobile', '88', 'Sedan 2-Door'],
    [1955, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1955, 'Packard', 'Caribbean', 'Convertible 2-Door'],
    [1955, 'Packard', 'Four-Hundred', 'Coupe 2-Door'],
    [1955, 'Packard', 'Patrician', 'Sedan 4-Door'],
    [1955, 'Pontiac', 'Chieftain', 'Wagon 4-Door'],
    [1955, 'Studebaker', 'E10', 'Standard Cab Pickup 2-Door'],
    [1955, 'Studebaker', 'E12', 'Standard Cab Pickup 2-Door'],
    [1955, 'Studebaker', 'E5', 'Standard Cab Pickup 2-Door'],
    [1955, 'Studebaker', 'E7', 'Standard Cab Pickup 2-Door'],
    [1955, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1955, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1954, 'Alfa Romeo', 'Giulietta', 'Convertible 2-Door'],
    [1954, 'Alfa Romeo', 'Giulietta', 'Coupe 2-Door'],
    [1954, 'Alfa Romeo', 'Giulietta', 'Sedan 4-Door'],
    [1954, 'Aston Martin', 'DB2-4', 'Coupe 2-Door'],
    [1954, 'Buick', 'Century', 'Convertible 2-Door'],
    [1954, 'Buick', 'Century', 'Hardtop 2-Door'],
    [1954, 'Buick', 'Century', 'Sedan 4-Door'],
    [1954, 'Buick', 'Century', 'Wagon 4-Door'],
    [1954, 'Buick', 'Roadmaster', 'Convertible 2-Door'],
    [1954, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1954, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1954, 'Buick', 'Skylark', 'Convertible 2-Door'],
    [1954, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1954, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1954, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1954, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1954, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1954, 'Chevrolet', 'Bel Air', 'Convertible 2-Door'],
    [1954, 'Chevrolet', 'Bel Air', 'Coupe 2-Door'],
    [1954, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1954, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1954, 'Chevrolet', 'Bel Air', 'Wagon 4-Door'],
    [1954, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1954, 'Chevrolet', 'One-Fifty Series', 'Sedan 2-Door'],
    [1954, 'Chevrolet', 'One-Fifty Series', 'Sedan 4-Door'],
    [1954, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1954, 'Chevrolet', 'Two-Ten Series', 'Coupe 2-Door'],
    [1954, 'Chevrolet', 'Two-Ten Series', 'Sedan 2-Door'],
    [1954, 'Chevrolet', 'Two-Ten Series', 'Sedan 4-Door'],
    [1954, 'Chevrolet', 'Two-Ten Series', 'Wagon 4-Door'],
    [1954, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1954, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1954, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1954, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1954, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1954, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1954, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1954, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1954, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1954, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1954, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1954, 'Hudson', 'Hornet', 'Convertible 2-Door'],
    [1954, 'Hudson', 'Hornet', 'Coupe 2-Door'],
    [1954, 'Hudson', 'Hornet', 'Sedan 4-Door'],
    [1954, 'Hudson', 'Italia', 'Coupe 2-Door'],
    [1954, 'Hudson', 'Jet', 'Coupe 2-Door'],
    [1954, 'Hudson', 'Jet', 'Sedan 4-Door'],
    [1954, 'Hudson', 'Jetliner', 'Coupe 2-Door'],
    [1954, 'Hudson', 'Jetliner', 'Sedan 4-Door'],
    [1954, 'Hudson', 'Super Jet', 'Coupe 2-Door'],
    [1954, 'Hudson', 'Super Jet', 'Sedan 4-Door'],
    [1954, 'Hudson', 'Super Wasp', 'Convertible 2-Door'],
    [1954, 'Hudson', 'Super Wasp', 'Coupe 2-Door'],
    [1954, 'Hudson', 'Super Wasp', 'Sedan 4-Door'],
    [1954, 'Hudson', 'Wasp', 'Convertible 2-Door'],
    [1954, 'Hudson', 'Wasp', 'Coupe 2-Door'],
    [1954, 'Hudson', 'Wasp', 'Sedan 4-Door'],
    [1954, 'Morgan', 'Plus Four', 'Convertible 2-Door'],
    [1954, 'Nash', 'Ambassador Custom', 'Coupe 2-Door'],
    [1954, 'Nash', 'Ambassador Custom', 'Sedan 2-Door'],
    [1954, 'Nash', 'Ambassador Custom', 'Sedan 4-Door'],
    [1954, 'Nash', 'Rambler', 'Convertible 2-Door'],
    [1954, 'Nash', 'Rambler', 'Coupe 2-Door'],
    [1954, 'Nash', 'Rambler', 'Sedan 4-Door'],
    [1954, 'Nash', 'Rambler', 'Wagon 2-Door'],
    [1954, 'Nash', 'Rambler', 'Wagon 4-Door'],
    [1954, 'Oldsmobile', '88', 'Sedan 2-Door'],
    [1954, 'Oldsmobile', '88', 'Sedan 4-Door'],
    [1954, 'Packard', 'Cavalier', 'Convertible 2-Door'],
    [1954, 'Packard', 'Cavalier', 'Coupe 2-Door'],
    [1954, 'Packard', 'Cavalier', 'Sedan 4-Door'],
    [1954, 'Packard', 'Packard', 'Convertible 2-Door'],
    [1954, 'Packard', 'Packard', 'Coupe 2-Door'],
    [1954, 'Packard', 'Packard', 'Sedan 4-Door'],
    [1954, 'Studebaker', '3R10', 'Standard Cab Pickup 2-Door'],
    [1954, 'Studebaker', '3R11', 'Standard Cab Pickup 2-Door'],
    [1954, 'Studebaker', '3R14', 'Standard Cab Pickup 2-Door'],
    [1954, 'Studebaker', '3R15', 'Standard Cab Pickup 2-Door'],
    [1954, 'Studebaker', '3R5', 'Standard Cab Pickup 2-Door'],
    [1954, 'Studebaker', '3R6', 'Standard Cab Pickup 2-Door'],
    [1954, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1954, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1953, 'Aston Martin', 'DB2', 'Coupe 2-Door'],
    [1953, 'Aston Martin', 'DB2-4', 'Coupe 2-Door'],
    [1953, 'Buick', 'Roadmaster', 'Convertible 2-Door'],
    [1953, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1953, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1953, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1953, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1953, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1953, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1953, 'Cadillac', 'DeVille', 'Hardtop 2-Door'],
    [1953, 'Cadillac', 'Eldorado', 'Convertible 2-Door'],
    [1953, 'Chevrolet', 'Bel Air', 'Convertible 2-Door'],
    [1953, 'Chevrolet', 'Bel Air', 'Coupe 2-Door'],
    [1953, 'Chevrolet', 'Bel Air', 'Sedan 2-Door'],
    [1953, 'Chevrolet', 'Bel Air', 'Sedan 4-Door'],
    [1953, 'Chevrolet', 'Corvette', 'Convertible 2-Door'],
    [1953, 'Chevrolet', 'One-Fifty Series', 'Sedan 2-Door'],
    [1953, 'Chevrolet', 'One-Fifty Series', 'Sedan 4-Door'],
    [1953, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1953, 'Chevrolet', 'Two-Ten Series', 'Coupe 2-Door'],
    [1953, 'Chevrolet', 'Two-Ten Series', 'Sedan 2-Door'],
    [1953, 'Chevrolet', 'Two-Ten Series', 'Sedan 4-Door'],
    [1953, 'Chevrolet', 'Two-Ten Series', 'Wagon 4-Door'],
    [1953, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1953, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1953, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1953, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1953, 'Ford', 'Consul', 'Convertible 2-Door'],
    [1953, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1953, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1953, 'Ford', 'F-100', 'Standard Cab Pickup 2-Door'],
    [1953, 'Ford', 'F-250', 'Standard Cab Pickup 2-Door'],
    [1953, 'Ford', 'F-350', 'Standard Cab Pickup 2-Door'],
    [1953, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1953, 'Hudson', 'Hornet', 'Convertible 2-Door'],
    [1953, 'Hudson', 'Hornet', 'Coupe 2-Door'],
    [1953, 'Hudson', 'Hornet', 'Sedan 4-Door'],
    [1953, 'Hudson', 'Jet', 'Coupe 2-Door'],
    [1953, 'Hudson', 'Jet', 'Sedan 4-Door'],
    [1953, 'Hudson', 'Super Jet', 'Coupe 2-Door'],
    [1953, 'Hudson', 'Super Jet', 'Sedan 4-Door'],
    [1953, 'Hudson', 'Super Wasp', 'Convertible 2-Door'],
    [1953, 'Hudson', 'Super Wasp', 'Coupe 2-Door'],
    [1953, 'Hudson', 'Super Wasp', 'Sedan 4-Door'],
    [1953, 'Hudson', 'Wasp', 'Convertible 2-Door'],
    [1953, 'Hudson', 'Wasp', 'Coupe 2-Door'],
    [1953, 'Hudson', 'Wasp', 'Sedan 4-Door'],
    [1953, 'Nash', 'Ambassador Custom', 'Coupe 2-Door'],
    [1953, 'Nash', 'Ambassador Custom', 'Sedan 2-Door'],
    [1953, 'Nash', 'Ambassador Custom', 'Sedan 4-Door'],
    [1953, 'Nash', 'Rambler', 'Convertible 2-Door'],
    [1953, 'Nash', 'Rambler', 'Coupe 2-Door'],
    [1953, 'Nash', 'Rambler', 'Wagon 2-Door'],
    [1953, 'Packard', 'Cavalier', 'Convertible 2-Door'],
    [1953, 'Packard', 'Cavalier', 'Coupe 2-Door'],
    [1953, 'Packard', 'Cavalier', 'Sedan 4-Door'],
    [1953, 'Packard', 'Patrician', 'Sedan 4-Door'],
    [1953, 'Studebaker', '2R10', 'Standard Cab Pickup 2-Door'],
    [1953, 'Studebaker', '2R11', 'Standard Cab Pickup 2-Door'],
    [1953, 'Studebaker', '2R14', 'Standard Cab Pickup 2-Door'],
    [1953, 'Studebaker', '2R15', 'Standard Cab Pickup 2-Door'],
    [1953, 'Studebaker', '2R5', 'Standard Cab Pickup 2-Door'],
    [1953, 'Studebaker', '2R6', 'Standard Cab Pickup 2-Door'],
    [1953, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1953, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1952, 'Aston Martin', 'DB2', 'Coupe 2-Door'],
    [1952, 'Buick', 'Roadmaster', 'Convertible 2-Door'],
    [1952, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1952, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1952, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1952, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1952, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1952, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1952, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1952, 'Chevrolet', 'Fleetline', 'Sedan 2-Door'],
    [1952, 'Chevrolet', 'Styleline Deluxe', 'Convertible 2-Door'],
    [1952, 'Chevrolet', 'Styleline Deluxe', 'Coupe 2-Door'],
    [1952, 'Chevrolet', 'Styleline Deluxe', 'Sedan 2-Door'],
    [1952, 'Chevrolet', 'Styleline Deluxe', 'Sedan 4-Door'],
    [1952, 'Chevrolet', 'Styleline Deluxe', 'Wagon 4-Door'],
    [1952, 'Chevrolet', 'Styleline Special', 'Coupe 2-Door'],
    [1952, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1952, 'Chrysler', 'Imperial', 'Coupe 2-Door'],
    [1952, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1952, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1952, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1952, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1952, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1952, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1952, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1952, 'Hudson', 'Commodore Series', 'Convertible 2-Door'],
    [1952, 'Hudson', 'Commodore Series', 'Coupe 2-Door'],
    [1952, 'Hudson', 'Commodore Series', 'Sedan 4-Door'],
    [1952, 'Hudson', 'Hornet', 'Convertible 2-Door'],
    [1952, 'Hudson', 'Hornet', 'Coupe 2-Door'],
    [1952, 'Hudson', 'Hornet', 'Sedan 4-Door'],
    [1952, 'Hudson', 'Pacemaker', 'Convertible 2-Door'],
    [1952, 'Hudson', 'Pacemaker', 'Coupe 2-Door'],
    [1952, 'Hudson', 'Pacemaker', 'Sedan 4-Door'],
    [1952, 'Hudson', 'Wasp', 'Convertible 2-Door'],
    [1952, 'Hudson', 'Wasp', 'Coupe 2-Door'],
    [1952, 'Hudson', 'Wasp', 'Sedan 4-Door'],
    [1952, 'Nash', 'Ambassador Custom', 'Coupe 2-Door'],
    [1952, 'Nash', 'Ambassador Custom', 'Sedan 2-Door'],
    [1952, 'Nash', 'Ambassador Custom', 'Sedan 4-Door'],
    [1952, 'Nash', 'Rambler', 'Convertible 2-Door'],
    [1952, 'Nash', 'Rambler', 'Coupe 2-Door'],
    [1952, 'Nash', 'Rambler', 'Wagon 2-Door'],
    [1952, 'Packard', '200', 'Coupe 2-Door'],
    [1952, 'Packard', '200', 'Sedan 4-Door'],
    [1952, 'Packard', 'Patrician', 'Sedan 4-Door'],
    [1952, 'Studebaker', '2R10', 'Standard Cab Pickup 2-Door'],
    [1952, 'Studebaker', '2R11', 'Standard Cab Pickup 2-Door'],
    [1952, 'Studebaker', '2R14', 'Standard Cab Pickup 2-Door'],
    [1952, 'Studebaker', '2R15', 'Standard Cab Pickup 2-Door'],
    [1952, 'Studebaker', '2R5', 'Standard Cab Pickup 2-Door'],
    [1952, 'Studebaker', '2R6', 'Standard Cab Pickup 2-Door'],
    [1952, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1952, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1951, 'Aston Martin', 'DB2', 'Coupe 2-Door'],
    [1951, 'Buick', 'Roadmaster', 'Convertible 2-Door'],
    [1951, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1951, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1951, 'Buick', 'Roadmaster', 'Wagon 4-Door'],
    [1951, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1951, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1951, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1951, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1951, 'Chevrolet', 'Fleetline', 'Sedan 2-Door'],
    [1951, 'Chevrolet', 'Fleetline', 'Sedan 4-Door'],
    [1951, 'Chevrolet', 'Styleline Deluxe', 'Convertible 2-Door'],
    [1951, 'Chevrolet', 'Styleline Deluxe', 'Coupe 2-Door'],
    [1951, 'Chevrolet', 'Styleline Deluxe', 'Sedan 2-Door'],
    [1951, 'Chevrolet', 'Styleline Deluxe', 'Sedan 4-Door'],
    [1951, 'Chevrolet', 'Styleline Deluxe', 'Wagon 4-Door'],
    [1951, 'Chevrolet', 'Styleline Special', 'Sedan 2-Door'],
    [1951, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1951, 'Chrysler', 'Imperial', 'Convertible 2-Door'],
    [1951, 'Chrysler', 'Imperial', 'Coupe 2-Door'],
    [1951, 'Chrysler', 'Imperial', 'Hardtop 2-Door'],
    [1951, 'Chrysler', 'Imperial', 'Limousine 4-Door'],
    [1951, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1951, 'Ford', 'Anglia', 'Sedan 2-Door'],
    [1951, 'Ford', 'Consul', 'Sedan 4-Door'],
    [1951, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1951, 'Ford', 'Prefect', 'Sedan 4-Door'],
    [1951, 'Hudson', 'Commodore Series', 'Convertible 2-Door'],
    [1951, 'Hudson', 'Commodore Series', 'Coupe 2-Door'],
    [1951, 'Hudson', 'Commodore Series', 'Sedan 4-Door'],
    [1951, 'Hudson', 'Hornet', 'Convertible 2-Door'],
    [1951, 'Hudson', 'Hornet', 'Coupe 2-Door'],
    [1951, 'Hudson', 'Hornet', 'Sedan 4-Door'],
    [1951, 'Hudson', 'Super Series', 'Convertible 2-Door'],
    [1951, 'Hudson', 'Super Series', 'Coupe 2-Door'],
    [1951, 'Hudson', 'Super Series', 'Sedan 4-Door'],
    [1951, 'Nash', 'Ambassador Custom', 'Sedan 2-Door'],
    [1951, 'Nash', 'Ambassador Custom', 'Sedan 4-Door'],
    [1951, 'Nash', 'Rambler', 'Convertible 2-Door'],
    [1951, 'Nash', 'Rambler', 'Coupe 2-Door'],
    [1951, 'Nash', 'Rambler', 'Wagon 2-Door'],
    [1951, 'Packard', '200', 'Coupe 2-Door'],
    [1951, 'Packard', '200', 'Sedan 4-Door'],
    [1951, 'Packard', 'Patrician', 'Sedan 4-Door'],
    [1951, 'Studebaker', '2R10', 'Standard Cab Pickup 2-Door'],
    [1951, 'Studebaker', '2R11', 'Standard Cab Pickup 2-Door'],
    [1951, 'Studebaker', '2R14', 'Standard Cab Pickup 2-Door'],
    [1951, 'Studebaker', '2R15', 'Standard Cab Pickup 2-Door'],
    [1951, 'Studebaker', '2R5', 'Standard Cab Pickup 2-Door'],
    [1951, 'Studebaker', '2R6', 'Standard Cab Pickup 2-Door'],
    [1951, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1951, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1950, 'Aston Martin', 'DB2', 'Coupe 2-Door'],
    [1950, 'Buick', 'Roadmaster', 'Coupe 2-Door'],
    [1950, 'Buick', 'Roadmaster', 'Hardtop 2-Door'],
    [1950, 'Buick', 'Roadmaster', 'Sedan 4-Door'],
    [1950, 'Cadillac', 'Commercial Chassis', 'Hearse 2-Door'],
    [1950, 'Cadillac', 'Commercial Chassis', 'Limousine 4-Door'],
    [1950, 'Cadillac', 'Commercial Chassis', 'Sedan 4-Door'],
    [1950, 'Chevrolet', 'Bel Air', 'Hardtop 2-Door'],
    [1950, 'Chevrolet', 'Fleetline', 'Sedan 2-Door'],
    [1950, 'Chevrolet', 'Fleetline', 'Sedan 4-Door'],
    [1950, 'Chevrolet', 'Styleline Deluxe', 'Convertible 2-Door'],
    [1950, 'Chevrolet', 'Styleline Deluxe', 'Coupe 2-Door'],
    [1950, 'Chevrolet', 'Styleline Deluxe', 'Sedan 2-Door'],
    [1950, 'Chevrolet', 'Styleline Deluxe', 'Sedan 4-Door'],
    [1950, 'Chevrolet', 'Styleline Deluxe', 'Wagon 4-Door'],
    [1950, 'Chevrolet', 'Styleline Special', 'Coupe 2-Door'],
    [1950, 'Chevrolet', 'Styleline Special', 'Sedan 2-Door'],
    [1950, 'Chevrolet', 'Styleline Special', 'Sedan 4-Door'],
    [1950, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1950, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1950, 'Ford', 'Country Squire', 'Wagon 4-Door'],
    [1950, 'Hudson', 'Commodore Series', 'Convertible 2-Door'],
    [1950, 'Hudson', 'Commodore Series', 'Coupe 2-Door'],
    [1950, 'Hudson', 'Commodore Series', 'Sedan 4-Door'],
    [1950, 'Hudson', 'Pacemaker', 'Convertible 2-Door'],
    [1950, 'Hudson', 'Pacemaker', 'Coupe 2-Door'],
    [1950, 'Hudson', 'Pacemaker', 'Sedan 4-Door'],
    [1950, 'Hudson', 'Super Series', 'Convertible 2-Door'],
    [1950, 'Hudson', 'Super Series', 'Coupe 2-Door'],
    [1950, 'Hudson', 'Super Series', 'Sedan 4-Door'],
    [1950, 'Nash', 'Ambassador Custom', 'Sedan 2-Door'],
    [1950, 'Nash', 'Ambassador Custom', 'Sedan 4-Door'],
    [1950, 'Nash', 'Rambler', 'Convertible 2-Door'],
    [1950, 'Nash', 'Rambler', 'Wagon 2-Door'],
    [1950, 'Studebaker', '2R10', 'Standard Cab Pickup 2-Door'],
    [1950, 'Studebaker', '2R11', 'Standard Cab Pickup 2-Door'],
    [1950, 'Studebaker', '2R14', 'Standard Cab Pickup 2-Door'],
    [1950, 'Studebaker', '2R15', 'Standard Cab Pickup 2-Door'],
    [1950, 'Studebaker', '2R5', 'Standard Cab Pickup 2-Door'],
    [1950, 'Studebaker', '2R6', 'Standard Cab Pickup 2-Door'],
    [1950, 'Volkswagen', 'Beetle', 'Convertible 2-Door'],
    [1950, 'Volkswagen', 'Beetle', 'Sedan 2-Door'],
    [1949, 'Buick', 'Roadmaster Series 70', 'Convertible 2-Door'],
    [1949, 'Buick', 'Roadmaster Series 70', 'Coupe 2-Door'],
    [1949, 'Buick', 'Roadmaster Series 70', 'Sedan 4-Door'],
    [1949, 'Buick', 'Roadmaster Series 70', 'Wagon 4-Door'],
    [1949, 'Buick', 'Special Series 40', 'Sedan 2-Door'],
    [1949, 'Buick', 'Special Series 40', 'Sedan 4-Door'],
    [1949, 'Buick', 'Super Series 50', 'Convertible 2-Door'],
    [1949, 'Buick', 'Super Series 50', 'Sedan 2-Door'],
    [1949, 'Buick', 'Super Series 50', 'Sedan 4-Door'],
    [1949, 'Buick', 'Super Series 50', 'Wagon 4-Door'],
    [1949, 'Chevrolet', 'Fleetline', 'Sedan 2-Door'],
    [1949, 'Chevrolet', 'Fleetline', 'Sedan 4-Door'],
    [1949, 'Chevrolet', 'Styleline Deluxe', 'Convertible 2-Door'],
    [1949, 'Chevrolet', 'Styleline Deluxe', 'Coupe 2-Door'],
    [1949, 'Chevrolet', 'Styleline Deluxe', 'Sedan 2-Door'],
    [1949, 'Chevrolet', 'Styleline Deluxe', 'Sedan 4-Door'],
    [1949, 'Chevrolet', 'Styleline Deluxe', 'Wagon 4-Door'],
    [1949, 'Chevrolet', 'Styleline Special', 'Coupe 2-Door'],
    [1949, 'Chevrolet', 'Styleline Special', 'Sedan 2-Door'],
    [1949, 'Chevrolet', 'Styleline Special', 'Sedan 4-Door'],
    [1949, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1949, 'Chrysler', 'Imperial', 'Sedan 4-Door'],
    [1949, 'Hudson', 'Commodore Series', 'Convertible 2-Door'],
    [1949, 'Hudson', 'Commodore Series', 'Coupe 2-Door'],
    [1949, 'Hudson', 'Commodore Series', 'Sedan 4-Door'],
    [1949, 'Hudson', 'Super Series', 'Convertible 2-Door'],
    [1949, 'Hudson', 'Super Series', 'Coupe 2-Door'],
    [1949, 'Hudson', 'Super Series', 'Sedan 4-Door'],
    [1949, 'Studebaker', '2R10', 'Standard Cab Pickup 2-Door'],
    [1949, 'Studebaker', '2R15', 'Standard Cab Pickup 2-Door'],
    [1949, 'Studebaker', '2R5', 'Standard Cab Pickup 2-Door'],
    [1948, 'Buick', 'Roadmaster Series 70', 'Convertible 2-Door'],
    [1948, 'Buick', 'Roadmaster Series 70', 'Coupe 2-Door'],
    [1948, 'Buick', 'Roadmaster Series 70', 'Wagon 4-Door'],
    [1948, 'Buick', 'Special Series 40', 'Sedan 2-Door'],
    [1948, 'Buick', 'Special Series 40', 'Sedan 4-Door'],
    [1948, 'Buick', 'Super Series 50', 'Convertible 2-Door'],
    [1948, 'Buick', 'Super Series 50', 'Sedan 2-Door'],
    [1948, 'Buick', 'Super Series 50', 'Sedan 4-Door'],
    [1948, 'Buick', 'Super Series 50', 'Wagon 4-Door'],
    [1948, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1948, 'Ford', 'F-1', 'Standard Cab Pickup 2-Door'],
    [1948, 'Ford', 'F-2', 'Standard Cab Pickup 2-Door'],
    [1948, 'Ford', 'F-3', 'Standard Cab Pickup 2-Door'],
    [1948, 'Hudson', 'Commodore Series', 'Convertible 2-Door'],
    [1948, 'Hudson', 'Commodore Series', 'Coupe 2-Door'],
    [1948, 'Hudson', 'Commodore Series', 'Sedan 4-Door'],
    [1948, 'Hudson', 'Super Series', 'Convertible 2-Door'],
    [1948, 'Hudson', 'Super Series', 'Coupe 2-Door'],
    [1948, 'Hudson', 'Super Series', 'Sedan 4-Door'],
    [1948, 'Lincoln', '876H Series', 'Convertible 2-Door'],
    [1948, 'Lincoln', '876H Series', 'Coupe 2-Door'],
    [1948, 'Studebaker', 'M5', 'Standard Cab Pickup 2-Door'],
    [1947, 'Buick', 'Roadmaster Series 70', 'Convertible 2-Door'],
    [1947, 'Buick', 'Roadmaster Series 70', 'Coupe 2-Door'],
    [1947, 'Buick', 'Roadmaster Series 70', 'Wagon 4-Door'],
    [1947, 'Buick', 'Special Series 40', 'Sedan 2-Door'],
    [1947, 'Buick', 'Special Series 40', 'Sedan 4-Door'],
    [1947, 'Buick', 'Super Series 50', 'Convertible 2-Door'],
    [1947, 'Buick', 'Super Series 50', 'Sedan 2-Door'],
    [1947, 'Buick', 'Super Series 50', 'Sedan 4-Door'],
    [1947, 'Buick', 'Super Series 50', 'Wagon 4-Door'],
    [1947, 'Chevrolet', 'Truck', 'Standard Cab Pickup 2-Door'],
    [1947, 'Hudson', 'Commodore Series', 'Convertible 2-Door'],
    [1947, 'Hudson', 'Commodore Series', 'Coupe 2-Door'],
    [1947, 'Hudson', 'Commodore Series', 'Sedan 4-Door'],
    [1947, 'Hudson', 'Super Series', 'Convertible 2-Door'],
    [1947, 'Hudson', 'Super Series', 'Coupe 2-Door'],
    [1947, 'Hudson', 'Super Series', 'Sedan 4-Door'],
    [1947, 'Lincoln', '76H Series', 'Convertible 2-Door'],
    [1947, 'Lincoln', '76H Series', 'Coupe 2-Door'],
    [1947, 'Studebaker', 'M5', 'Standard Cab Pickup 2-Door'],
    [1946, 'Buick', 'Roadmaster Series 70', 'Convertible 2-Door'],
    [1946, 'Buick', 'Roadmaster Series 70', 'Coupe 2-Door'],
    [1946, 'Buick', 'Roadmaster Series 70', 'Sedan 4-Door'],
    [1946, 'Buick', 'Special Series 40', 'Sedan 2-Door'],
    [1946, 'Buick', 'Special Series 40', 'Sedan 4-Door'],
    [1946, 'Buick', 'Super Series 50', 'Convertible 2-Door'],
    [1946, 'Buick', 'Super Series 50', 'Sedan 2-Door'],
    [1946, 'Buick', 'Super Series 50', 'Sedan 4-Door'],
    [1946, 'Buick', 'Super Series 50', 'Wagon 4-Door'],
    [1946, 'Hudson', 'Commodore Series', 'Convertible 2-Door'],
    [1946, 'Hudson', 'Commodore Series', 'Coupe 2-Door'],
    [1946, 'Hudson', 'Commodore Series', 'Sedan 4-Door'],
    [1946, 'Hudson', 'Super Series', 'Convertible 2-Door'],
    [1946, 'Hudson', 'Super Series', 'Coupe 2-Door'],
    [1946, 'Hudson', 'Super Series', 'Sedan 4-Door'],
    [1946, 'Lincoln', '66H Series', 'Convertible 2-Door'],
    [1946, 'Lincoln', '66H Series', 'Coupe 2-Door'],
    [1946, 'Studebaker', 'M5', 'Standard Cab Pickup 2-Door'],
    [1945, 'Ford', 'GPW', 'SUV U/K-Door'],
    [1945, 'Lincoln', 'Continental', 'Convertible 2-Door'],
    [1945, 'Lincoln', 'Continental', 'Coupe 2-Door'],
    [1944, 'Ford', 'GPW', 'SUV U/K-Door'],
    [1943, 'Ford', 'GPW', 'SUV U/K-Door'],
    [1942, 'Ford', 'GPW', 'SUV U/K-Door'],
    [1941, 'Ford', 'GPW', 'SUV U/K-Door'],
    [1941, 'Plymouth', 'PT-125', 'Standard Cab Pickup 2-Door'],
    [1940, 'GMC', 'AC252', 'Standard Cab Pickup 2-Door'],
    [1940, 'Plymouth', 'PT-105', 'Standard Cab Pickup 2-Door'],
    [1939, 'Bentley', '4 1/4-Litre', 'Convertible 2-Door'],
    [1939, 'Bentley', '4 1/4-Litre', 'Sedan 2-Door'],
    [1939, 'Bentley', '4 1/4-Litre', 'Sedan 4-Door'],
    [1939, 'Plymouth', 'PT-81', 'Standard Cab Pickup 2-Door'],
    [1938, 'Bentley', '4 1/4-Litre', 'Convertible 2-Door'],
    [1938, 'Bentley', '4 1/4-Litre', 'Sedan 2-Door'],
    [1938, 'Bentley', '4 1/4-Litre', 'Sedan 4-Door'],
    [1937, 'Bentley', '4 1/4-Litre', 'Convertible 2-Door'],
    [1937, 'Bentley', '4 1/4-Litre', 'Sedan 2-Door'],
    [1937, 'Bentley', '4 1/4-Litre', 'Sedan 4-Door'],
    [1936, 'Bentley', '3 1/2-Litre', 'Convertible 2-Door'],
    [1936, 'Bentley', '3 1/2-Litre', 'Coupe 2-Door'],
    [1936, 'Bentley', '3 1/2-Litre', 'Sedan 2-Door'],
    [1936, 'Bentley', '3 1/2-Litre', 'Sedan 4-Door'],
    [1936, 'Bentley', '4 1/4-Litre', 'Convertible 2-Door'],
    [1936, 'Bentley', '4 1/4-Litre', 'Sedan 2-Door'],
    [1936, 'Bentley', '4 1/4-Litre', 'Sedan 4-Door'],
    [1931, 'Bentley', '4 1/2-Litre', 'Convertible 2-Door'],
    [1931, 'Bentley', '4-Litre', 'Sedan 4-Door'],
    [1930, 'Bentley', '4 1/2-Litre', 'Convertible 2-Door'],
    [1929, 'Bentley', '4 1/2-Litre', 'Convertible 2-Door'],
    [1928, 'Bentley', '4 1/2-Litre', 'Convertible 2-Door'],
    [1927, 'Bentley', '4 1/2-Litre', 'Convertible 2-Door'],
    [1921, 'Bentley', '3-Litre', 'Convertible 2-Door']
];